"use strict";

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}
'use strict';

angular.module('mtic', [
// Dependencies
'ngCookies', 'firebase', 'ng-fastclick', 'ngSanitize', 'ngAnimate', '720kb.tooltips',
// Main module
'mtic.components.main']);

/**
 * Configure Timezone
 * @type {[type]}
 */
var currentTimesZone = moment.tz.guess(); //Set this to `Europe/Luxembourg` for lux time
moment.tz.setDefault(currentTimesZone);

// if (window.location.origin === 'https://mathematic.org'){
//   window.location.href = 'https://mathematic.lu/app2'
// }
'use strict';

angular.module('mtic').service('volumeCaptionStatus', function ($log) {

    //var eventManager = new EventManager('volumeCaptionStatus');
    var volumeOn = true;
    var captionsOn = false;

    // Public Methods
    var volumeCaptionStatus = {
        set: function set(vol, capt) {
            volumeOn = vol;
            captionsOn = capt;
        },

        getVolume: function getVolume() {
            return volumeOn;
        },
        getCaptions: function getCaptions() {
            return captionsOn;
        }
    };

    return volumeCaptionStatus;
});
'use strict';

angular.module('mtic').service('userAccount', function ($log, EventManager, $location, LoginCookie, $cookies, IAMManager, LOGIN_CONSTANTS, DEV_VARIABLES, $timeout, $window, language, PlatformService) {
  var eventManager = new EventManager('userAccount');
  /**
  * Private loginInfo
  * @type {Object}
  */
  var loginInfo = {
    userData: {},
    isLoggedin: false
  };
  var languageSetThroughProfile = false;
  /**
  * Resets login (in cases where the session expires)
  * @return {}
  */
  var resetLogin = function resetLogin() {
    var uuid = loginInfo && loginInfo.userData ? loginInfo.userData.uuid || '' : '';
    loginInfo.userData = {
      uuid: uuid,
      user_id: null,
      firstName: null,
      lastName: null,
      fullName: null,
      role: {},
      roles: [],
      sessionKey: null,
      firebase_token: null
    };
    loginInfo.isLoggedin = false;
  };
  resetLogin();

  /**
  * Capitalize the first letter in a string
  * @param  {String} string
  * @return {String}
  */
  var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  /**
  * @param  {Determine if admin}
  * @return {Boolean}
  */
  var isAdmin = function isAdmin(roles) {
    var isAdmin = false;
    var roleIndex = 0;
    var role;
    while (!isAdmin) {
      role = roles[roleIndex];
      isAdmin = role.role_type === 'admin' && role.group_id === 1;
      roleIndex++;
      if (roleIndex > roles.length - 1) {
        break;
      }
    }
    return isAdmin;
  };

  /**
  * Determine the user role
  * @param  {Array<Role>} roles
  * @return {Promise}
  */
  var determineRole = function determineRole(roles) {
    if (roles.length === 0) {
      throw new Error('User has no role assigned to them');
    } else if (roles.length > 1) {
      // Teacher
      var isTeacher = false;
      var roleIndex = 0;
      var role;
      while (!isTeacher) {
        role = roles[roleIndex];
        isTeacher = role.role_type === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER && role.group.group_type === LOGIN_CONSTANTS.GROUP_TYPES.SCHOOL;
        roleIndex++;
        if (roleIndex > roles.length - 1) {
          break;
        }
      }
      if (isTeacher) {
        // throw new Error('Student has more than one role assigned to them, or this is a teacher without a school assigned to them, this is not supported in this release')
        return angular.extend(role, {
          isGeneralAccess: false,
          isTeacher: true
        });
      } else {
        return angular.extend(roles[0], {
          isGeneralAccess: false,
          isTeacher: false
        });
      }
    } else {
      return angular.extend(roles[0], {
        isGeneralAccess: false,
        isTeacher: roles[0].role_type === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER
      });
    }
  };
  /**
  * Public Methods
  * @type {Object}
  */
  return {
    determineRole: determineRole,
    isLoggedIn: function isLoggedIn() {
      return loginInfo.isLoggedin;
    },
    expireSession: function expireSession() {
      resetLogin();
      LoginCookie.clearSessions();
      eventManager.broadcast('login:session:expired');
      eventManager.clearLoginSession();
    },
    logout: function logout() {

      if (window.isWebEmbedConnect) {
        $cookies.putObject('webembedcookie', ['true'], {
          'expires': moment().add(1, 'hours').toDate()
        });
      }

      eventManager.broadcast('logging-out');

      if (loginInfo.loggedInFromSaml || window.location.href.indexOf('force-saml') > -1) {
        resetLogin();
        LoginCookie.clearSessions();
        eventManager.clearLoginSession();
        EventManager.disableBeforeUnloadMsg = true;
        eventManager.broadcast('logout', {});
      } else {
        IAMManager.logout().then(function (atLeastOneLoggedOut) {
          resetLogin();
          LoginCookie.clearSessions();
          eventManager.clearLoginSession();
          EventManager.disableBeforeUnloadMsg = true;
          IAMManager.clearSavedUrlParamsForToken();
          if (!atLeastOneLoggedOut || PlatformService.isApp) {
            eventManager.broadcast('logout', {});
          }
        });
      }
    },
    clearSession: function clearSession() {
      resetLogin();
      LoginCookie.clearSessions();
      eventManager.broadcast('login:session:clear');
      eventManager.clearLoginSession();
    },
    getActiveClassroom: function getActiveClassroom(class_id) {
      return loginInfo.activeClassroom;
    },
    setActiveClassroom: function setActiveClassroom(class_id) {
      loginInfo.activeClassroom = class_id;
    },
    setActiveClassFull: function setActiveClassFull(class_data) {
      loginInfo.fullClass = class_data;
    },
    setData: function setData(uuid, userData) {
      loginInfo.userData = {
        uuid: uuid,
        user_id: userData.user_id,
        firstName: capitalizeFirstLetter(userData.info.first_name),
        lastName: capitalizeFirstLetter(userData.info.last_name),
        fullName: capitalizeFirstLetter(userData.info.first_name) + ' ' + capitalizeFirstLetter(userData.info.last_name),
        role: determineRole(userData.roles),
        isAdmin: isAdmin(userData.roles),
        roles: userData.roles,
        sessionKey: userData.session_key,
        firebase_token: userData.firebaseToken
      };
      var role = loginInfo.userData.role.role_type;
      LoginCookie.registerLogin(uuid, loginInfo.userData.fullName, userData.user_id, userData.session_key, userData.firebaseToken, role);
      loginInfo.isLoggedin = true;
      loginInfo.loggedInFromSaml = !!userData.loggedInFromSaml;
      eventManager.broadcast('userAccount:setData', loginInfo.userData.role);
      eventManager.setUserInfo(loginInfo.userData.user_id);
      if (userData.info.language) {
        languageSetThroughProfile = true;
        language.set(userData.info.language, true);
      }
      return loginInfo.userData.role;
    },
    getData: function getData(data) {
      return loginInfo.userData;
    },
    getActiveClassData: function getActiveClassData() {
      return loginInfo.fullClass;
    },
    isSamlUser: function isSamlUser() {
      return loginInfo.loggedInFromSaml;
    },
    setIsSamlUser: function setIsSamlUser(isSamlUser) {
      loginInfo.loggedInFromSaml = isSamlUser;
    },
    isLanguageSetThroughProfile: function isLanguageSetThroughProfile() {
      return languageSetThroughProfile;
    }
  };
});
'use strict';

angular.module('mtic').service('preliveCheck', function () {
  // Init Event Manager
  var isQC = window.location.href.indexOf('edge') > -1 || window.location.href.indexOf('preview') > -1 || window.location.href.indexOf('localhost') > -1;
  var isPrelive = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('prelive2') > -1;
  return {
    isPreliveCheck: function isPreliveCheck() {
      return isPrelive;
    },
    isQCCheck: function isQCCheck() {
      return isQC;
    }
  };
});
'use strict';

angular.module('pixi', []);

angular.module('pixi').constant('PIXI', PIXI);
'use strict';

angular.module('mtic').service('moduleMappingService', function ($log) {
    var c3v2_map = {
        "mtic_c3_m1_diagnostic": "mtic_c3_m1_diagnostic",
        "mtic_c3_m1v2_4stages": null,
        "mtic_c3_m1v2_aquarium": "mtic_c3_m1_fish",
        "mtic_c3_m1v2_lemurs": "mtic_c3_m1_lemur",
        "mtic_c3_m1v2_stickers": "mtic_c3_m1_sticker",
        "mtic_c3_m1v2_bike": "mtic_c3_m1_bike_tachometer",
        "mtic_c3_m1v2_granny": "mtic_c3_m1_car_tachometer",
        "mtic_c3_m1v2_jump": "mtic_c3_m1_jump",
        "mtic_c3_m1v2_zooshop": "mtic_c3_m1_souvenir_b",
        "mtic_c3_m1v2_skate": "mtic_c3_m1_skateshop",
        "mtic_c3_m1v2_camp": "mtic_c3_m1_camping",
        "mtic_c3_m1v2_elephants": "mtic_c3_m1_elephants",
        "mtic_c3_m1v2_train": "mtic_c3_m1_train_paris",
        "mtic_c3_m1v2_plane": "mtic_c3_m1_airplane_porto",
        "mtic_c3_m1v2_tower": "mtic_c3_m1_block_tower",
        "mtic_c3_m1v2_stuffedanimal": "mtic_c3_m1_souvenir_c",
        "mtic_c3_m1v2_tram": "mtic_c3_m1_tram"
    };
    return {
        getC3Mapping: function getC3Mapping(orig_map) {
            var c3v1, c3v2;
            _.each(orig_map.resources, function (mod) {
                if (mod.slug === 'mtic_c3_m1') {
                    c3v1 = mod;
                } else if (mod.slug === 'mtic_c3_m1v2') {
                    c3v2 = mod;
                }
            });
            if (c3v2 && c3v2.children && c3v1 && c3v1.children) {
                _.each(c3v2.children, function (resource) {
                    if (c3v2_map[resource.slug]) {
                        _.each(c3v1.children, function (v1_resource) {
                            if (c3v2_map[resource.slug] === v1_resource.slug) {
                                resource.complete = resource.complete || v1_resource.complete;
                                if (resource.resourceState && v1_resource.resourceState) {
                                    resource.resourceState.completions = resource.resourceState.completions + v1_resource.resourceState.completions;
                                    resource.resourceState.complete = resource.resourceState.complete || v1_resource.resourceState.complete;
                                    resource.resourceState.score_max = Math.max(resource.resourceState.score_max, v1_resource.resourceState.score_max);
                                } else if (v1_resource.resourceState) {
                                    resource.resourceState = v1_resource.resourceState;
                                }
                            }
                        });
                    }
                });
            }
            return orig_map;
        }
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('mtic').service('language', function ($http, $cookies, $log, EventManager, API_CONFIG, LANGUAGE_TEXT, LANGUAGE_TEXT_SLUGS, LANGUAGE_SLUG_LINK, BRANDING, $rootScope) {
  // Init Event Manager
  var eventManager = new EventManager('language');

  // Private variables
  var languageOptionMap = {
    'fr': 'FRANÇAIS',
    'en': 'ENGLISH',
    'de': 'DEUTSCH',
    'pt': 'PORTUGUÊS'
  };
  var forceNew = [];
  var activeLanguageOptions = [];
  // var currentSelectedLanguage = $cookies.get('bar_language') || 'fr';
  var currentSelectedLanguage = 'fr';
  var languageText = LANGUAGE_TEXT || {};
  var failedGets = [];
  var transpacks = {};
  var TRANPACK_PREFIX = 'TRANPACK://';

  /**
   * Builds a url to get a language id
   * @param  {String}
   * @return {String}
   */
  var urlBuilder = function urlBuilder(url) {
    return 'https://mathematic-language.vretta.com/' + url;
  };
  /**
   * Gets a language text by a slug name
   * used mostly for lessons in the modules
   * will be deprected
   * @param  {String}
   * @return {String}
   */
  var _getBySpecialSlugName = function _getBySpecialSlugName(slugName, allowNull) {
    // $log.warn('[[language]] @@Temporary using a temporay method `language.get.getBySpecialSlugName`, please make sure that', slugName, 'has a languageId!')
    if (LANGUAGE_TEXT_SLUGS[slugName]) {
      return LANGUAGE_TEXT_SLUGS[slugName];
    } else {
      if (!allowNull) {
        failedGets.push(slugName);
        // $log.error('[[language]] could not find SpecialSlugName translation for ' + slugName)
      }
      return {};
    }
  };
  /**
   * Get Language Id from slug
   * @param  {String} slugName
   * @return {Null<Object>}
   */
  var getLangIdFromSlug = function getLangIdFromSlug(slugName) {
    if (LANGUAGE_SLUG_LINK[slugName]) {
      return LANGUAGE_SLUG_LINK[slugName];
    } else {
      return null;
    }
  };
  /**
   * Checks if the JSON is empty
   * @param  {Object} obj
   * @return {Boolean}
   */
  var objectIsEmpty = function objectIsEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  };
  /**
   * Gets a language id
   * @param  {Integer}
   * @return {String}
   */
  var getLanguage = function getLanguage(id, allowNull, makeHttpCall) {
    if (!id) {
      return {};
    }

    if (id && ('' + id).substr(0, TRANPACK_PREFIX.length) === TRANPACK_PREFIX) {
      // TODO 
      var translation_slug = id.substr(TRANPACK_PREFIX.length, id.length);
      var pack_id = translation_slug.split('/')[0];
      var translation_id = translation_slug.split('/')[1];

      if (transpacks[pack_id] && transpacks[pack_id][translation_id]) {
        return transpacks[pack_id][translation_id];
      }
      return {};
    }

    if (getLangIdFromSlug(id)) {
      id = getLangIdFromSlug(id);
    }

    if (isNaN(id)) {
      var text = _getBySpecialSlugName(id, allowNull);
      if (objectIsEmpty(text)) {
        return Object.keys(languageOptionMap).reduce(function (obj, langId) {
          obj[langId] = id;
          return obj;
        }, {});
      }
      return text;
    }

    if (!languageText[Number(id)] || forceNew.indexOf(id) > -1) {
      languageText[id] = Object.keys(languageOptionMap).reduce(function (obj, langId) {
        obj[langId] = '...';
        return obj;
      }, {});
      failedGets.push(id);
      if (makeHttpCall) {
        $http({ method: 'GET', url: urlBuilder('get_text'), params: { ids: id } }).then(function (data) {
          var textObj = data.data[0];
          newIds[id] = languageText[id] = textObj;
          window._redefined_clean_lang_text = _.keys(languageText).reduce(function (obj, k) {
            if (!isNaN(k)) {
              obj[k] = languageText[k];
            }return obj;
          }, {});
        }).catch(function (err) {
          $log.error('[[language]] Failed to get language id ' + id);
        });
      }
    }
    return languageText[Number(id)];
  };

  // Public Methods
  var language = {
    /**
     * Reset the language options to default
     */
    resetAvilableOptions: function resetAvilableOptions() {
      this.setAvailableOptions(['fr', 'en', 'de', 'pt']);
    },

    getMomentLocale: function getMomentLocale() {
      switch (eventManager.getLanguage()) {
        case 'en':
          return 'en';
        case 'fr':
          return 'fr';
        case 'pt':
          return 'pt';
        case 'de':
          return 'de';
      }
      return 'en';
    },

    /**
     * Sets the language options
     * @param {Array<String>}
     */
    setAvailableOptions: function setAvailableOptions(languageSlugs) {
      if (!languageSlugs) {
        return;
      }
      $log.debug("[[language]] languageSlugs: ", languageSlugs);
      activeLanguageOptions = languageSlugs.map(function (languageOption) {
        return {
          slug: languageOption,
          text: languageOptionMap[languageOption]
        };
      });
      if (languageSlugs.indexOf(currentSelectedLanguage) === -1) {
        this.set(languageSlugs[0], true);
      }
      eventManager.broadcast("language:options:change");
    },
    /**
     * Sets the current language
     * @param {String}
     */
    set: function set(slug, is_forced) {
      if (slug) {
        currentSelectedLanguage = slug;
        // $cookies.put('bar_language', slug, {
        //       expires: moment()
        //             .add(2, 'hours')
        //             .toDate()
        // });
      }
      eventManager.setLanguage(slug, is_forced);
      moment.locale(slug);
    },
    /**
     * Grabs a language text by its id
     * @param  {String}
     * @param  {Object}
     * @return {String}
     */
    get: function get(id, params, allowNull) {
      if ($rootScope.branding === BRANDING.OCMT) {
        currentSelectedLanguage = 'en';
      }
      var text = getLanguage(id, allowNull)[currentSelectedLanguage];

      if ((typeof text === 'undefined' ? 'undefined' : _typeof(text)) === 'object' && text.val) {
        text = text.val;
      }

      if (text === null) {
        return '';
      } else {
        if (text === 'NA' && getLanguage(id, allowNull).en !== null && getLanguage(id, allowNull).en !== 'NA') {
          text = getLanguage(id, allowNull).en;
        }
        if (params && params.length > 0) {
          params.forEach(function (param) {
            text = text.replace('{{' + param.name + '}}', param.value);
          });
        }
        return text;
      }
    },
    /**
     * gets the current language slug (or name)
     * @param  {Boolean}
     * @return {String}
     */
    getCurrentSelectedLanguage: function getCurrentSelectedLanguage(pretty) {
      if (pretty) {
        return languageOptionMap[currentSelectedLanguage];
      } else {
        return currentSelectedLanguage;
      }
    },
    /**
     * gets a list of the current language options
     * @return {Array<Object>}
     */
    getActiveLanguageOptions: function getActiveLanguageOptions() {
      return activeLanguageOptions;
    },

    getBySpecialSlugName: function getBySpecialSlugName(id, allowNull) {
      $log.warn('[[language]] @@Deprecated using a Deprecated method `language.getBySpecialSlugName`, please use `language.get` instead!');
      return _getBySpecialSlugName(id, allowNull)[currentSelectedLanguage];
    }

  };

  language.loadTranspacks = function (tran_packs) {
    var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
    $http.get(API_CONFIG.PDF_API + '/translation-packs?packIds=' + tran_packs_safe + '&apiUrl=' + encodeURIComponent(API_CONFIG.REMOTE_API)).then(function (data) {
      var translations = data.data;
      _.each(translations, function (pack, pack_id) {
        if (!transpacks[pack_id]) {
          transpacks[pack_id] = {};
        }
        if (pack.elements) {
          _.each(pack.elements, function (el) {
            if (el) {
              if (typeof el === 'string') {
                el = JSON.parse(el);
              }
              if (el.id && el.id.pack_element_id) {
                transpacks[pack_id][el.id.pack_element_id] = el.text;
              }
            }
          });
        }
      });

      $log.log('transpack loaded : ', transpacks);
    });
  };

  // Use default language
  language.resetAvilableOptions();

  if (forceNew && forceNew.length > 0) {
    var newIds = window.newIds = {};
    forceNew.map(function (tId) {
      $log.debug('Getting', tId);
      getLanguage(tId, true, true);
    });
    $log.debug("new translations!", newIds);
  }
  window._lang_failed_gets = failedGets;
  return language;
});
'use strict';

/* jshint ignore:start */
angular.module('mtic').service('encryptionService', function ($log, EventManager) {
  var eventManager = new EventManager('encryptionService');
  var cipher_salt = 'mticSalt';
  var decipher_salt = 'verttaDecipherSecret';
  var globalCipher = cipher(cipher_salt);
  var globalDecipher = decipher(decipher_salt);
  function cipher(salt) {
    var textToChars = function textToChars(text) {
      return text.split('').map(function (c) {
        return c.charCodeAt(0);
      });
    };
    var byteHex = function byteHex(n) {
      return ("0" + Number(n).toString(16)).substr(-2);
    };
    var applySaltToChar = function applySaltToChar(code) {
      return textToChars(salt).reduce(function (a, b) {
        return a ^ b;
      }, code);
    };

    return function (text) {
      return text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('');
    };
  }

  function decipher(salt) {
    var textToChars = function textToChars(text) {
      return text.split('').map(function (c) {
        return c.charCodeAt(0);
      });
    };
    var saltChars = textToChars(salt);
    var applySaltToChar = function applySaltToChar(code) {
      return textToChars(salt).reduce(function (a, b) {
        return a ^ b;
      }, code);
    };
    return function (encoded) {
      return encoded.match(/.{1,2}/g).map(function (hex) {
        return parseInt(hex, 16);
      }).map(applySaltToChar).map(function (charCode) {
        return String.fromCharCode(charCode);
      }).join('');
    };
  }
  window.testPdf = function (name, count, date) {
    var uri_params = encryptionService.encryptMathleticParams(name, count, date);
    window.open('http://localhost:8080/mathleticCertificate?' + uri_params, '_blank');
  };
  return {
    cipher: function cipher(string) {
      return globalCipher(string);
    },
    decipher: function decipher(string) {
      return globalDecipher(string);
    },
    encryptMathleticParams: function encryptMathleticParams(name, count, date) {
      return this.cipher('user_name') + '=' + this.cipher(name) + '&' + this.cipher('stars') + '=' + this.cipher(count + '') + '&' + this.cipher('date') + '=' + this.cipher(date + '');
    }

  };
});

/* jshint ignore:end */
'use strict';

angular.module('mtic').service('cordovaMessenger', function ($log, $q, $timeout, EventManager, LocaleService, PlatformService) {

  function getNextMessageId() {
    return ++lastMessageId;
  }

  function handleResponse(data) {
    var responseDeferred = pendingResponses[data.messageId];
    var responseTypeName = responseTypeNameExtractor.exec(data.messageType)[1];
    var responseType = responseTypes[responseTypeName];
    if (!responseDeferred) {
      throw new Error('could not find a deferred object for response!');
    }
    if (responseDeferred === "TIMED_OUT") {
      $log.warn('received app response, but it has already timed out!', data);
      return;
    }
    if (!responseType) {
      throw new Error('could not find a response type for response!');
    }
    try {
      responseDeferred.resolve(responseType.handleResponse(data));
    } catch (err) {
      responseDeferred.reject({
        err: err, data: data
      });
    }
  }

  function onMessage(event) {
    if (!event.origin || !event.data) {
      return;
    }

    if (responseTypeNameExtractor.test(event.data.messageType)) {
      // this message is a response to a request sent by requestResponse
      try {
        handleResponse(event.data);
        return;
      } catch (err) {
        $log.error(err, event);
        throw err;
      }
    }

    var handler = messageHandlers[event.data.messageType];
    if (typeof handler === "function") {
      handler(event.data);
    } else {
      $log.warn('no handler for post message messageType, event will be ignored', event);
    }
  }
  window.addEventListener('message', onMessage, {
    capture: false,
    passive: true
  });

  var cordovaOrigin = 'file://';
  var eventManager = new EventManager('cordovaMessenger');
  var lastMessageId = 0; // do not access this directly: use getNextMessageId() instead
  var responseTypeNameExtractor = /^response:(.*)$/;
  var pendingResponses = {};

  /*
   * Put handlers here for events that are sent from cordova in response to a
   * request from this.requestResponse. The handleResponse function will be
   * passed the message object sent from cordova as its first argument, and its
   * return value will be used to resolve the promise that was returned from
   * this.requestResponse
   */
  var responseTypes = {
    requestNativeAdalLogin: {
      handleResponse: function handleResponse(eventData) {
        eventManager.broadcast('start-login-attempt');
        var srcProfile = _.assignIn({}, eventData.payload);
        return {
          profile: {
            _srcProfile: srcProfile,
            exp: moment(srcProfile.expiresOn).unix(),
            name: srcProfile.userInfo.displayableId,
            oid: srcProfile.userInfo.userId,
            unique_name: srcProfile.userInfo.uniqueId,
            ver: '1.0'
          }
        };
      }
    },
    requestNativeAdalLogout: {
      handleResponse: function handleResponse(eventData) {
        $log.debug('response:requestNativeAdalLogout', eventData);
        return eventData;
      },
      timeout: {
        after: 500,
        timeoutResult: 1
      }
    },
    requestSamlLogin: {
      handleResponse: function handleResponse(eventData) {
        $log.debug('response:requestSamlLogin', eventData);
        return eventData;
      }
    }

    /*
     * Put handlers here for events that originate from cordova. The handler
     * will be passed the message object sent from cordova as its first argument
     */
  };var messageHandlers = {
    nativePause: function nativePause() {
      eventManager.broadcast('focusout:end');
      LocaleService.idleFocus = false;
      eventManager.broadcast('mouse:keyboard:active', { idleInput: LocaleService.idleInput, away: LocaleService.isAway });
    },
    nativeResign: function nativeResign() {
      eventManager.broadcast('focusout:end');
      LocaleService.idleFocus = false;
      eventManager.broadcast('mouse:keyboard:active', { idleInput: LocaleService.idleInput, away: LocaleService.isAway });
    },
    nativeResume: function nativeResume() {
      eventManager.broadcast('focusout:start');
      LocaleService.idleFocus = true;
    },
    appautologin: function appautologin() {
      eventManager.broadcast('app:auto:login');
    }
  };

  this.getAvailableResponseTypes = function () {
    return Object.keys(responseTypes);
  };

  /*
   * Send a one-way message to cordova
   */
  this.postToCordova = function postToCordova(type, payload) {
    $log.log('post to cordova : ', type, payload);
    if (!window.webkit || !window.webkit.messageHandlers.cordova_iab) {
      window.parent.postMessage({
        messageId: null,
        messageType: type,
        payload: payload
      }, "*");
    } else {
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        messageId: null,
        messageType: type,
        payload: payload
      }));
    }
  };

  /*
   * Send a message to cordova requesting a response. Returns a promise that
   * will resolve with the value return by a handleResponse function from
   * responseTypes
   */
  this.requestResponse = function requestResponse(responseType, payload) {
    var deferred, messageId;
    if (!responseTypes[responseType]) {
      $q.reject('unknown responseType: "' + responseType + '"');
    }
    deferred = $q.defer();
    messageId = getNextMessageId();
    pendingResponses[messageId] = deferred;
    if (!window.webkit || !window.webkit.messageHandlers.cordova_iab) {
      window.parent.postMessage({
        messageId: messageId,
        messageType: responseType,
        payload: payload
      }, "*");
    } else {
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        messageId: messageId,
        messageType: responseType,
        payload: payload
      }));
    }
    var timeoutSpec = responseTypes[responseType].timeout;
    if (timeoutSpec) {
      $timeout(function () {
        $log.warn('request timed out!', {
          responseType: responseType,
          payload: payload,
          messageId: messageId
        });
        pendingResponses[messageId] = "TIMED_OUT";
        deferred.resolve(timeoutSpec.timeoutResult);
      }, timeoutSpec.after);
    }
    return deferred.promise;
  };

  if (!PlatformService.isApp) {
    this.postToCordova = this.requestResponse = function cordovaRejection() {
      var msg = 'this function cannot be used without Cordova!';
      return $q.reject(new Error(msg));
    };
  }
});
'use strict';

angular.module('mtic').service('apiTranslationService', function ($log, $http, API_CONFIG, language, $timeout, $q) {

  var apiTranslationService = {};
  var translations_map = {};
  var retrieved_packs = [];

  apiTranslationService.getTranslationPack = function (pack_id) {
    return $q(function (resolve, reject) {
      if (retrieved_packs.indexOf(pack_id) > -1) {
        resolve(translations_map);
      }
      var tran_packs = [pack_id];
      var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
      $http.get('https://stats.vretta.com/pdf-maker/translation-packs?packIds=' + tran_packs_safe + '&apiUrl=' + encodeURIComponent(API_CONFIG.REMOTE_API)).then(function (data) {
        var translations = data.data;
        retrieved_packs.push(pack_id);
        _.map(translations, function (pack_id, id_key) {
          if (pack_id.elements) {
            _.map(pack_id.elements, function (val, element_key) {
              var content = typeof val === 'string' ? JSON.parse(val) : val;
              translations_map[element_key] = content.text; //TRANPACK_PREFIX+id_key+'/'+
            });
          }
        });
        $log.log('retrieved translations : ', translations_map);
        resolve(translations_map);
      }).catch(function (err) {
        reject('error');
      });
    });
  };

  apiTranslationService.getTranslation = function (trans_id) {
    if (translations_map[trans_id]) {
      return translations_map[trans_id][language.getCurrentSelectedLanguage()].val;
    }
    return trans_id;
  };

  return apiTranslationService;
});
'use strict';

/**
* A generalization of api Methods
* @return {Obiect}
*/
angular.module('mtic').service('apiMethods', function ($http, $q, $location, $log, EventManager, API_CONFIG, userAccount, API_ROUTES, Firebase, LoginCookie, $timeout, language, $interval) {

  var eventManager = new EventManager('apiMethods');
  /**
  * API Path
  * @type {String}
  */
  //TODO  get rid of this
  var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1 ? API_CONFIG.API_VERSION : API_CONFIG.API_QC_VERSION;
  var API_PATH = API_CONFIG.REMOTE_API + api_version;
  var FEDERATION_API_PATH = API_CONFIG.REMOTE_API_FEDERATION;

  window.__clearSession = function () {
    apiMethods.setHeaders('U2FsdGVkX19RxUGEMDe/pznrh1hXJ7H5ER9SVEzQMMepbG3LlBaqUinXXNUDopKx', authHeaders['X-Auth-Id']);
  };

  var cached_promise;
  var resubmission_call_urls = [API_PATH + '/student/resource/state'];
  /**
  * Default Authorization headers
  * @type {Object}
  */
  var authHeaders;
  var federationHeaders = {};
  var resetHeaders = function resetHeaders() {
    authHeaders = {};
    federationHeaders = {};
  };
  resetHeaders();
  var callThrottle = {};

  /**
  * On Sucess of an api call
  * @param  {Object} response
  * @param  {String} pathName
  * @param  {$q.resolve} resolve
  * @param  {$q.resolve} reject
  * @return {Null}
  */
  var successResults = function successResults(response, pathName, resolve, reject) {
    if (response.data.success) {
      LoginCookie.refreshCookieStore();
      resolve(response.data.data);
      callThrottle[pathName] = false;
    } else {
      $log.error({
        call: pathName,
        error: response.data.data
      });
      reject(response.data);
      callThrottle[pathName] = false;
    }
  };
  /**
  * In the case of a failed results run this
  * This will attempt to re-submit the api call in a failed instance
  * @param  {$http.Request} apiCall
  * @param  {String} pathName
  * @param  {Object} response
  * @param  {$q.resolve} resolve
  * @param  {$q.reject} reject
  * @return {null}
  */
  var failedResults = function failedResults(apiCall, pathName, response, resolve, reject) {
    try {
      if (!response.data) {
        reject('FAILED_TO_CONNECT');

        callThrottle[pathName] = false;
        $log.error(response);
      } else if (response.data.message === 'SESSION_EXPIRED') {
        userAccount.expireSession();
        var listenerExpiry = eventManager.listen('session-expiry:close', function () {
          apiCall.headers = authHeaders;
          apiCall.headers["Content-Type"] = "application/json;charset=utf-8";
          listenerExpiry();
          listenerLogout();
          $http(apiCall).then(function (response) {
            callThrottle[pathName] = false;
            successResults(response, pathName, resolve, reject);
          }).catch(function (response) {
            failedResults(apiCall, pathName, response, resolve, reject);
          });
        });
        var listenerLogout = eventManager.listen('logout', function () {
          listenerExpiry();
          listenerLogout();
        });
      } else if (response.data.message === 'ERROR_TOKENEXPIREDERROR' || response.data === 'EXPIRED_TOKEN') {
        apiMethods.FEDERATION_GET("REFRESH_TOKEN", {}, federationHeaders).then(function (new_token) {
          if (!new_token) {
            eventManager.broadcast('refresh-token-expired');
            reject(response.data);
          } else {
            authHeaders['X-ACCESS-TOKEN'] = new_token;
            apiCall.headers['X-ACCESS-TOKEN'] = new_token;
            $http(apiCall).then(function (response) {
              callThrottle[pathName] = false;
              successResults(response, pathName, resolve, reject);
            }).catch(function (response) {
              failedResults(apiCall, pathName, response, resolve, reject);
            });
          }
        }).catch(function (err) {
          $log.error(err);
          reject(response.data);
          eventManager.broadcast('refresh-token-expired');
        });
      } else {
        $log.error(response);
        callThrottle[pathName] = false;
        reject(response.data);
      }
    } catch (err) {
      $log.error("An issue occured for", pathName);
      $log.error(apiCall);
      $log.error(response);
      $log.error(err.message);
      $log.error(err.stack);
      callThrottle[pathName] = false;
      reject(err.message);
    }
  };
  /**
  * Every call is wrapped with this method
  * @param  {$http.Request} apiCall
  * @param  {String} pathName
  * @return {Promise}
  */
  var cached_promises = [];
  window.setInterval(function () {
    if (!navigator.onLine) {
      eventManager.broadcast('offline-post-call');
    }
  }, 1000);
  var checkStatus = function checkStatus(resolve) {
    if (navigator.onLine) {
      //resolve()
      cached_promises.forEach(function (pr) {
        pr();
      });
      cached_promises = [];
      eventManager.broadcast('offline-post-call-resolved');
    } else {
      eventManager.broadcast('offline-post-call');
    }
  };
  var waitForNetworkConnection = function waitForNetworkConnection() {
    //  $log.log('CHECKING LIST : ', cached_promises)
    return $q(function (resolve, reject) {
      //cached_promise = resolve;
      cached_promises.push(resolve);
    });
  };
  var afterCallWrapper = function afterCallWrapper(apiCall, pathName) {
    // $log.log("AFTER CALL WRAPPER : ", apiCall, pathName)
    $log.debug('[[API CALL]]', pathName);
    // if (callThrottle[pathName]) {
    //       throw pathName + ' is being sent too rapidly!'
    // } else {
    //       callThrottle[pathName] = true;
    apiCall.headers = angular.extend(angular.copy(authHeaders), apiCall.headers);
    apiCall.headers["Content-Type"] = "application/json;charset=utf-8";
    //added this part to deal with offline submissions

    function tryAgain() {
      return $q(function (resolve, reject) {
        $http(apiCall).then(function (response) {
          callThrottle[pathName] = false;
          successResults(response, pathName, resolve, reject);
        }).catch(function (response) {
          if (!navigator.onLine || !response.data) {
            eventManager.broadcast('offline-post-call');
            return waitForNetworkConnection().then(function () {
              return tryAgain().then(function (response) {
                resolve(response);
              });
            });
          } else {
            failedResults(apiCall, pathName, response, resolve, reject);
          }
        });
      });
    }
    return tryAgain();
  };

  /**
  * Public Methods
  * @type {Object}
  */
  var apiMethods = {
    /**
    * Generalized PUT call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    * @param {String} string_query
    */
    POST: function POST(pathName, body, query, headers) {
      return afterCallWrapper({
        method: 'POST',
        url: API_PATH + API_ROUTES.POST[pathName],
        data: body,
        params: query,
        headers: angular.extend(authHeaders, headers || {})
      }, 'POST ' + pathName);
    },
    /**
    * Generalized PUT call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    */
    PUT: function PUT(pathName, body, options) {
      options = options || {};
      return afterCallWrapper({
        method: 'PUT',
        url: API_PATH + API_ROUTES.PUT[pathName],
        data: body,
        params: options.query,
        headers: angular.extend(authHeaders, options.headers || {})
      }, 'PUT ' + pathName);
    },
    /**
    * Generalized DELETE call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    */
    DELETE: function DELETE(pathName, body, query) {
      return afterCallWrapper({
        method: 'DELETE',
        url: API_PATH + API_ROUTES.DELETE[pathName],
        data: body,
        params: query,
        headers: authHeaders
      }, 'DELETE ' + pathName);
    },
    /**
    * Generalized GET call
    * @param {String} pathName
    * @param {Object} query
    */
    GET: function GET(pathName, query, headers) {
      return afterCallWrapper({
        method: 'GET',
        url: API_PATH + API_ROUTES.GET[pathName],
        params: query,
        headers: angular.extend(authHeaders, headers || {})
      }, 'GET ' + pathName);
    },
    FEDERATION_GET: function FEDERATION_GET(pathName, query, headers) {
      return afterCallWrapper({
        method: 'GET',
        url: FEDERATION_API_PATH + API_ROUTES.GET[pathName],
        params: query,
        headers: angular.extend(_.clone(authHeaders), headers || {})
      }, 'GET ' + pathName);
    },
    setHeaders: function setHeaders(sessionKey, authId, access_token, refresh_token) {
      authHeaders['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      authHeaders['Cache-Control'] = 'no-cache';
      authHeaders.Pragma = 'no-cache';

      authHeaders['X-Auth-Session-Key'] = String(sessionKey);
      authHeaders['X-Auth-Id'] = String(authId);
      if (access_token && refresh_token) {
        authHeaders['X-ACCESS-TOKEN'] = access_token;
        federationHeaders['X-REFRESH-TOKEN'] = refresh_token;
      }
      eventManager.setHeaders(authHeaders);
    },
    setGroupId: function setGroupId(groupId) {
      authHeaders['X-Group-Id'] = String(groupId);
      eventManager.setHeaders(authHeaders);
    },
    getAuthHeaders: function getAuthHeaders() {
      return authHeaders;
    },

    loginAs: function loginAs(_ref) {
      var user_id = _ref.user_id,
          uuid = _ref.uuid;

      return apiMethods.POST("USER_LOGIN_AS", {
        "user_id": parseInt(user_id),
        "uuid": uuid
      }).then(function (response) {
        if (response.user_id) {
          // console.log('LOGIN AS success: ', response)
          apiMethods.setHeaders(response.session_key, response.user_id, response.access_token, response.refresh_token);

          var userRole = userAccount.setData(uuid, response);
          apiMethods.setGroupId(userRole.group_id);
          return Firebase.auth().signInWithCustomToken(response.firebaseToken).then(function () {
            eventManager.broadcast('login:first');
            eventManager.broadcast('login:login_as');
          });
        }
      });
    },
    /**
    * The user login function
    * @param  {String} uuid
    * @param  {String} password
    * @return {Promise}
    */
    login: function login(_ref2) {
      var uuid = _ref2.uuid,
          password = _ref2.password,
          _ref2$auth_type = _ref2.auth_type,
          auth_type = _ref2$auth_type === undefined ? 'localStrategy' : _ref2$auth_type,
          dueToExpiry = _ref2.dueToExpiry,
          keepMoving = _ref2.keepMoving,
          dontCatch = _ref2.dontCatch;


      var loginPromise = apiMethods.POST("USER_LOGIN", {
        uuid: uuid,
        "secret_key": password,
        auth_type: auth_type
      }).then(function (response) {
        var userData = response;
        if (userData.user_id) {
          apiMethods.setHeaders(userData.session_key, userData.user_id, userData.access_token, userData.refresh_token);
          var userRole = userAccount.setData(uuid, userData);
          // $log.log('window.isWebEmbedConnect', window.isWebEmbedConnect)
          // if (window.isWebEmbedConnect){
          //   window.location.href = window.location.href+'&web-embed-response&user_id='+userData.user_id+'&session_key='+userData.session_key+'&group_id='+userRole.group_id;
          // }
          apiMethods.setGroupId(userRole.group_id);
          return Firebase.auth().signInWithCustomToken(userData.firebaseToken);
        } else {
          eventManager.broadcast('login:fail', 'MISSING_USER_ID');
        }
      }).then(function () {
        if (dueToExpiry) {
          eventManager.broadcast('login:session-refresh');
          if (keepMoving) {
            eventManager.broadcast('login:first');
          }
        } else {
          eventManager.broadcast('login:first');
        }
      });
      if (dontCatch) {
        return loginPromise;
      } else {
        return loginPromise.catch(function (error) {
          $log.debug('[[apiMethods]] login:fail', error);
          eventManager.broadcast('login:fail', error.message);
        });
      }
    },
    /**
    * Restores login-session
    * @param  {Intger} userId
    * @param  {String} sessionKey
    * @param  {Integer} groupId
    * @return {Promise}
    */
    loginRestore: function loginRestore(uuid, userId, sessionKey, firebaseToken, fromAutoLogin) {
      return apiMethods.GET("USER_LOGIN", {}, {
        "X-Auth-Id": userId,
        "X-Auth-Session-Key": sessionKey
      }).then(function (response) {
        var userData = {
          user_id: userId,
          session_key: sessionKey,
          roles: response[0].roles,
          info: response[0].info,
          firebaseToken: firebaseToken
        };
        apiMethods.setHeaders(sessionKey, userId, response[0].access_token, response[0].refresh_token);
        var userRole = userAccount.setData(uuid, userData);
        apiMethods.setGroupId(userRole.group_id);
        return Firebase.auth().signInWithCustomToken(firebaseToken);
      }).then(function () {
        eventManager.broadcast('login:first');
      }).catch(function (error) {
        $log.debug('[[apiMethods]] login:fail', error);
        if (error.message === "TOKEN_EXPIRED" && fromAutoLogin) {
          eventManager.broadcast('login:first');
        } else if (error.code === "auth/invalid-custom-token") {
          eventManager.broadcast('token-expired-logout');
        }
      });
    },
    /**
    * Resets all credentials
    * @return {String}
    */
    logout: function logout() {
      resetHeaders();
      userAccount.logout();
    },
    resubmitOfflinePost: function resubmitOfflinePost() {
      $timeout(function () {
        checkStatus(cached_promise);
      }, 200);
    }
  };
  return apiMethods;
});
'use strict';

angular.module('mtic').service('apiErrorInterpeter', function (ERROR_CODES, $log, language) {
      return {
            get: function get(group, message, type) {
                  if (message === 'FAILED_TO_CONNECT') {
                        return language.get('11324');
                  } else if (ERROR_CODES[group][message]) {
                        return language.get(ERROR_CODES[group][message]);
                  } else {
                        return language.get(ERROR_CODES.UNKNOWN);
                        $log.error('An UNKNOWN error was returned from the api', group, message);
                  }
            }
      };
});
'use strict';

angular.module('mtic').service('api', function ($log, apiMethods) {
  var GET = apiMethods.GET,
      PUT = apiMethods.PUT,
      POST = apiMethods.POST,
      DELETE = apiMethods.DELETE;

  return {
    findStudentNoSchool: function findStudentNoSchool(_ref) {
      var uuid = _ref.uuid,
          auth_type = _ref.auth_type;

      return GET('STUDENT_BY_USERNAME_NOSCHOOL', {
        uuid: uuid,
        auth_type: auth_type
      });
    },
    signUpStudentThroughNoSchoolAll: function signUpStudentThroughNoSchoolAll(_ref2) {
      var group_ids = _ref2.group_ids,
          user_name = _ref2.user_name,
          password = _ref2.password,
          first_name = _ref2.first_name,
          last_name = _ref2.last_name,
          email = _ref2.email,
          auth_type = _ref2.auth_type,
          class_data = _ref2.class_data;

      return POST('STUDENT_NO_SCHOOL_ALL', {
        group_ids: group_ids,
        user_info: {
          uuid: user_name,
          secret_key: password,
          auth_type: auth_type,
          first_name: first_name,
          last_name: last_name,
          email: email,
          class_data: class_data
        }
      });
    },
    signUpStudentThroughNoSchool: function signUpStudentThroughNoSchool(_ref3) {
      var group_id = _ref3.group_id,
          user_name = _ref3.user_name,
          password = _ref3.password,
          first_name = _ref3.first_name,
          last_name = _ref3.last_name,
          email = _ref3.email,
          auth_type = _ref3.auth_type;

      return POST('STUDENT_NO_SCHOOL', {
        group_id: group_id,
        user_info: {
          uuid: user_name,
          secret_key: password,
          auth_type: auth_type,
          first_name: first_name,
          last_name: last_name,
          email: email
        }
      });
    },
    getClassesForStudent: function getClassesForStudent() {
      return GET('STUDENT_CLASSES', {});
    },
    getClassesForSchool: function getClassesForSchool(school_id) {
      return GET('CLASSES_WITH_MODULES_BY_SCHOOL', {
        school_id: school_id
      });
    },
    getSchoolModules: function getSchoolModules(school_id) {
      return GET('TEACHER_SCHOOL_MODULES', {
        school_id: school_id
      });
    },
    getNoSchoolClasses: function getNoSchoolClasses(noschool_id) {
      return GET('NOSCHOOL_CLASSES', {
        noschool_id: noschool_id
      });
    },
    getCountries: function getCountries(noschool) {
      return GET('COUNTRIES', {
        noschool: noschool ? 1 : 0
      });
    },
    linkIam: function linkIam(msfUser, _ref4) {
      var session_key = _ref4.session_key,
          user_id = _ref4.user_id;

      return PUT('LINK_IAM', msfUser, {
        headers: {
          'X-Auth-Session-Key': session_key,
          'X-Auth-Id': user_id
        }
      });
    },
    nonSystematicLogin: function nonSystematicLogin(uuid, secret_key, auth_type) {
      return POST('USER_LOGIN', {
        uuid: uuid,
        secret_key: secret_key,
        auth_type: auth_type
      });
    },
    validateIAM: function validateIAM(iAMProfile) {
      return apiMethods.POST('VALID_IAM', iAMProfile);
    },
    getCustomResource: function getCustomResource(class_id, resource_id) {
      return apiMethods.GET('CLASS_CUSTOM_RESOURCES', {
        class_id: class_id,
        resource_id: resource_id
      });
    },
    updateClass: function updateClass(class_id, class_data) {
      return apiMethods.PUT('GROUP', {
        class_id: class_id,
        class_data: class_data
      });
    },
    getStudentCustomResource: function getStudentCustomResource(resource_id) {
      return apiMethods.GET('STUDENT_CUSTOM_RESOURCES', {
        resource_id: resource_id
      });
    },
    updateClassComponentStat: function updateClassComponentStat(resource_id, component_id, state_update, timestamp) {
      return apiMethods.PUT('CLASS_STATE', {
        resource_id: resource_id,
        component_id: component_id,
        state_update: state_update,
        timestamp: timestamp
      });
    },
    getUserGroups: function getUserGroups() {
      return apiMethods.GET('USER_GROUPS');
    },
    deleteAgendaProperty: function deleteAgendaProperty(class_id, agenda_ids) {
      return apiMethods.DELETE('CLASS_AGENDA', {
        "class_id": class_id,
        "agenda_ids": agenda_ids
      });
    },
    updateAgendaProperty: function updateAgendaProperty(class_id, agenda_id, updates) {
      return apiMethods.PUT('CLASS_AGENDA', {
        "class_id": class_id,
        "agenda_id": agenda_id,
        "updates": updates
      });
    },
    createAgenda: function createAgenda(class_id, sub_module_resource_id, resources, students, agenda_definition) {
      var intStudentList = [];
      students.forEach(function (student) {
        intStudentList.push(parseInt(student));
      });
      agenda_definition.students = intStudentList; //students;
      agenda_definition.resources = resources;
      return apiMethods.POST('CLASS_AGENDA', {
        "class_id": class_id,
        "sub_module_resource_id": sub_module_resource_id,
        "agenda_definition": agenda_definition
      });
    },
    getStudentAgenda: function getStudentAgenda() {
      return apiMethods.GET('STUDENT_AGENDA');
    },
    getClassAgenda: function getClassAgenda(classId) {
      return apiMethods.GET('CLASS_AGENDA', { class_id: classId });
    },
    getStudentsAppEvents: function getStudentsAppEvents(class_id, module_id, from, to, limit) {
      return apiMethods.GET('STUDENT_APP_EVENTS', {
        class_id: class_id,
        module_id: module_id,
        from: from || moment().subtract(7, 'days').format('YYYY-MM-DD'),
        to: to || moment().format('YYYY-MM-DD'),
        limit: limit || 200
      });
    },
    logout: function logout() {
      return apiMethods.DELETE("LOGOUT");
    },
    getUserInfoById: function getUserInfoById(uuid) {
      return apiMethods.GET("USER_INFO", { uuid: uuid });
    },
    redeemAccessCode: function redeemAccessCode(access_code) {
      return apiMethods.POST("REDEEM_ACCESS_CODE", {
        code: access_code
      }, {});
    },
    setGroupId: function setGroupId(group_id) {
      apiMethods.setGroupId(group_id);
    },
    createClass: function createClass(schoold, className, classDescription) {
      throw new Error('api.createClass is no longer supported!');
      // apiMethods.setGroupId( schoold )
      // return apiMethods.POST("GROUP", {
      //   "class_name": className,
      //   "class_description": classDescription,
      //   "school_id": schoold
      // }, { })
    },
    createSchoolClass: function createSchoolClass(_ref5) {
      var module_id = _ref5.module_id,
          school_id = _ref5.school_id,
          name = _ref5.name,
          description = _ref5.description;

      return POST('SCHOOL_MODULE_CLASS', {
        module_id: module_id,
        school_id: school_id,
        name: name,
        description: description
      });
    },
    addStudentToClass: function addStudentToClass(code) {
      return apiMethods.POST("STUDENT_GROUP", {
        "class_id": 16,
        "teacher_id": 11
      }, {});
    },
    signUpTeacherThroughGroup: function signUpTeacherThroughGroup(_ref6) {
      var group_id = _ref6.group_id,
          user_name = _ref6.user_name,
          password = _ref6.password,
          first_name = _ref6.first_name,
          last_name = _ref6.last_name,
          email = _ref6.email,
          auth_type = _ref6.auth_type,
          user_type = _ref6.user_type,
          class_data = _ref6.class_data;

      //console.log('attempting : ', group_id, user_name, password, first_name, last_name, email, auth_type)
      return apiMethods.POST("TEACHER_THROUGH_GROUP", {
        "group_id": Number(group_id),
        "user_info": {
          "uuid": String(user_name),
          "secret_key": String(password),
          "first_name": String(first_name),
          "last_name": String(last_name),
          "email": String(email),
          "auth_type": auth_type ? String(auth_type) : "localStrategy",
          "class_data": String(class_data)
          //"user_type": String( user_type )
        }
      }, {});
    },
    signUpTeacher: function signUpTeacher(code, user_name, password, first_name, last_name, email, user_type) {
      return apiMethods.POST("TEACHER", {
        "code": String(code),
        "user_info": {
          "uuid": String(user_name),
          "secret_key": String(password),
          "first_name": String(first_name),
          "last_name": String(last_name),
          "email": String(email),
          "user_type": String(user_type)
        }
      }, {});
    },

    login: apiMethods.login,
    loginRestore: apiMethods.loginRestore,
    signUpStudent: function signUpStudent(teacher_id, class_id, user_name, password, first_name, last_name, user_type) {
      return apiMethods.POST("STUDENT", {
        "teacher_id": Number(teacher_id),
        "class_id": Number(class_id),
        "user_info": {
          "uuid": String(user_name),
          "secret_key": String(password),
          "first_name": String(first_name),
          "last_name": String(last_name),
          "user_type": String(user_type)
        }
      }, {});
    },
    transferStudent: function transferStudent(_ref7) {
      var teacher_id = _ref7.teacher_id,
          from_class_id = _ref7.from_class_id,
          to_class_id = _ref7.to_class_id;

      return apiMethods.PUT("STUDENT_CLASSES_TRANSFER", {
        from_class_id: from_class_id,
        to_class_id: to_class_id,
        teacher_id: teacher_id
      }, {});
    },
    getClassInfo: function getClassInfo(_ref8) {
      var class_id = _ref8.class_id;

      return apiMethods.GET('CLASS_INFO', { class_id: class_id });
    },
    getClassMembers: function getClassMembers(classId, role_type, isArchived) {
      // console.log('NOW')
      return apiMethods.GET('CLASS_MEMBERS', {
        class_id: classId,
        role_type: role_type,
        archived: isArchived
      });
    },
    getArchivedStudents: function getArchivedStudents(classId, role_type) {
      return apiMethods.GET('ARCHIVED_STUDENTS', {
        class_id: classId,
        role_type: role_type,
        archived: true
      });
    },
    getStudentClassMembers: function getStudentClassMembers(classId, role_type) {
      return apiMethods.GET('STUDENT_CLASS_MEMBERS');
    },
    getClassStats: function getClassStats(classId) {
      return apiMethods.GET('CLASS_SUMMARY_STATS', { class_id: classId });
    },
    getStudentModuleResourceState: function getStudentModuleResourceState(module_id) {
      return apiMethods.GET('STUDENT_MODULE_RESOURCE_STATE', { module_id: module_id });
    },
    getStudentModuleResourceStateByTeacher: function getStudentModuleResourceStateByTeacher(module_id, user_id, class_id) {
      return apiMethods.GET('TEACHER_STUDENT_MODULE_RESOURCE_STATE', {
        module_id: module_id,
        user_id: user_id,
        class_id: class_id
      });
    },
    getClassResourceStates: function getClassResourceStates(class_id, isArchived, omitStateLogs, workspace_logs, user_id, resource_id) {
      return apiMethods.GET('CLASS_RESOURCE_STATES', { class_id: class_id, archived: isArchived, omit_logs: omitStateLogs, workspace_logs: workspace_logs, user_id: user_id, resource_id: resource_id });
    },
    getClassModuleMaps: function getClassModuleMaps(groupId) {
      return apiMethods.GET('CLASS_MODULES', { class_id: groupId });
    },
    submitStudentResourceState: function submitStudentResourceState(resourceState) {
      return apiMethods.POST('STUDENT_RERSOURCE_STATE', resourceState);
    },
    submitCopiedStudentResourceState: function submitCopiedStudentResourceState(resourceState) {
      return apiMethods.POST('STUDENT_RERSOURCE_STATE_COPIED', resourceState);
    },
    submitItemEndQuestionaire: function submitItemEndQuestionaire(resourceId, data) {
      return apiMethods.POST('GENERAL_LOG', {
        resource_id: resourceId,
        tag: 'end-questionaire',
        data: data
      });
    },
    sendEvent: function sendEvent(eventData) {
      return apiMethods.POST('EVENT', eventData);
    },
    getUserResourceAppState: function getUserResourceAppState(user_id, resource_id) {
      return apiMethods.GET('GET_USER_RESOURCE_APP_STATE', {
        user_id: user_id,
        resource_id: resource_id
      });
    },
    getUserResourceLatestAppState: function getUserResourceLatestAppState(user_id, resource_id, since_date, up_to_date) {
      return apiMethods.GET('GET_USER_RESOURCE_LATEST_APP_STATE', {
        user_id: user_id,
        resource_id: resource_id,
        since_date: since_date,
        up_to_date: up_to_date
      });
    },

    //THE LAST APP STATE ONE SHOULD BE DEPRECATED!
    getUserResourceLastAppState: function getUserResourceLastAppState(user_id, resource_id) {
      return apiMethods.GET('GET_USER_RESOURCE_LAST_APP_STATE', {
        user_id: user_id,
        resource_id: resource_id
      });
    },
    archiveStudent: function archiveStudent(class_id, user_id, isArchived) {
      return apiMethods.POST('ARCHIVE_STUDENT', {
        class_id: class_id,
        user_id: user_id,
        archive: isArchived || false
      });
    },
    updateClassArchiveStatus: function updateClassArchiveStatus(class_id, isArchived) {
      return apiMethods.PUT('UPDATE_CLASS_ARCHIVE_STATUS', {
        class_id: class_id,
        archive: isArchived || false
      });
    },
    getCompetitionLeaderBoard: function getCompetitionLeaderBoard(comp_id) {
      return apiMethods.GET('GET_LEADERBOARD', {
        competition_id: comp_id
      });
    },
    getLeaderBoardTopPerformer: function getLeaderBoardTopPerformer(agenda_id) {
      return apiMethods.GET('GET_LEADERBOARD_TOP_PERFORMER', {
        agenda_id: agenda_id
      });
    },
    syncLeaderboard: function syncLeaderboard(competition_id) {
      return apiMethods.GET('GET_SYNC_LEADERBOARD', {
        competition_id: competition_id
      });
    },
    getStudentAssessmentPdf: function getStudentAssessmentPdf(student_id, diagnostic_assessment_resource_id, group_id) {
      return apiMethods.GET('GET_STUDENT_ASSESSMENT_PDF', {
        student_id: student_id,
        diagnostic_assessment_resource_id: diagnostic_assessment_resource_id,
        group_id: group_id
      });
    },
    getClassAssessmentData: function getClassAssessmentData(diagnostic_assessment_resource_id, group_id, date_open, date_close) {
      return apiMethods.GET('GET_CLASS_ASSESSMENT_DATA', {
        diagnostic_assessment_resource_id: diagnostic_assessment_resource_id,
        group_id: group_id,
        date_from: date_open,
        date_to: date_close
      });
    },
    getPdfAvailability: function getPdfAvailability(user_id, group_id) {
      return apiMethods.GET('GET_PDF_AVAILABILITY', {
        user_id: user_id,
        group_id: group_id
      });
    },
    initStateLogSession: function initStateLogSession(user_id, resource_id, module_id, class_id, working_session_hash, assessment_session_hash) {
      return apiMethods.POST('STATE_LOG_SESSION', {
        user_id: user_id,
        resource_id: resource_id,
        module_id: module_id,
        class_id: class_id,
        working_session_hash: working_session_hash,
        assessment_session_hash: assessment_session_hash
      });
    },
    importAgenda: function importAgenda(class_id, agenda_code) {
      return apiMethods.POST('IMPORT_AGENDA', {
        class_id: class_id,
        agenda_code: agenda_code
      });
    },
    getUserNotifications: function getUserNotifications(user_id) {
      return apiMethods.GET('GET_USER_NOTIFICATIONS', {
        user_id: user_id
      });
    },
    logNotificationState: function logNotificationState(user_id, notification_id, log_state, update_logs) {
      // TO DO: create new route which allows to update log_state with time stamp without marking as dismissed
      return apiMethods.POST('NOTIFICATION_SEEN', {
        user_id: user_id,
        notification_id: notification_id,
        log_state: log_state,
        instance_id: null,
        update_logs: update_logs
      });
    },
    dismissNotification: function dismissNotification(user_id, notification_id, log_state, instance_id) {
      return apiMethods.POST('NOTIFICATION_DISMISSED', {
        user_id: user_id,
        notification_id: notification_id,
        log_state: log_state,
        instance_id: instance_id
      });
    },
    archiveNotification: function archiveNotification(user_id, notification_id, instance_id) {
      return apiMethods.POST('NOTIFICATION_ARCHIVE', {
        user_id: user_id,
        notification_id: notification_id,
        instance_id: instance_id
      });
    },
    postUserNotification: function postUserNotification(message_type, user_id, from_user_id, log_state) {
      return apiMethods.POST('POST_NOTIFICATION', {
        message_type: message_type,
        user_id: user_id,
        from_user_id: from_user_id,
        log_state: log_state
      });
    },
    postResourceTimeUpdate: function postResourceTimeUpdate(working_session_hash, ping_update) {
      return apiMethods.POST('POST_RESOURCE_TIME', {
        working_session_hash: working_session_hash,
        ping_update: ping_update
      });
    },
    postUserPasswordUpdate: function postUserPasswordUpdate(user_id, secret_key, group_id) {
      return apiMethods.POST('UPDATE_PASSWORD', {
        user_id: user_id,
        secret_key: secret_key,
        group_id: group_id
      });
    },
    postTeacherPasswordUpdate: function postTeacherPasswordUpdate(secret_key) {
      return apiMethods.POST('UPDATE_TEACHER_PASSWORD', {
        secret_key: secret_key
      });
    },
    setUserLanguage: function setUserLanguage(language) {
      return apiMethods.POST('UPDATE_USER_LANGUAGE', {
        language: language
      });
    },
    getCountryOfClass: function getCountryOfClass(class_id) {
      return apiMethods.GET('CLASS_COUNTRY', {
        class_id: class_id
      });
    }
  };
});
'use strict';

angular.module('mtic').service('WindowOpener', function () {
  var windowsArray = [];
  var windowsMap = {};
  var closeListeners = {};
  var closeCallbacks = {};

  var clearListener = function clearListener(timerId) {
    if (timerId) {
      window.clearInterval(timerId);
    }
  };

  var setOnClose = function setOnClose(id) {
    var windowObj = windowsMap[id];
    if (windowObj) {
      var timer = window.setInterval(function checkChild() {
        if (windowObj && windowObj.closed) {
          if (closeCallbacks[id]) {
            closeCallbacks[id](true);
          }
          clearListener(timer);
        } else if (!windowObj) {
          if (closeCallbacks[id]) {
            closeCallbacks[id](false);
          }
          clearListener(timer);
        }
      }, 500);
      closeListeners[id] = timer;
      return timer;
    } else {
      return null;
    }
  };

  this.open = function (url, id, options) {
    options = options || {};
    options.width = options.width || '500';
    id = id || Math.random().toString(36).substr(2, 5);
    var newWindow = window.open(url, '', ['width=' + options.width].join('&'));
    windowsArray.push({
      id: id,
      window: newWindow
    });
    windowsMap[id] = newWindow;
    setOnClose(id);
    return windowsMap;
  };

  this.close = function (id) {
    var windowObj = windowsMap[id];
    if (windowObj) {
      windowObj.close();
    }
  };

  this.getWindow = function (id) {
    return windowsMap[id];
  };

  this.getAll = function () {
    return windowsArray;
  };

  this.listenToWindowCloseOf = function (id, cb) {
    closeCallbacks[id] = cb;
    return closeListeners[id];
  };
});
'use strict';

angular.module('mtic').service('TeacherDataService', function ($log, $http, $q, api, userAccount, Firebase, EventManager, DataCacheService, DataPathService, language, LogReducer, TeacherClassStatsService, DATA_HOST, StudentDataService) {

  // vars
  var eventManager = new EventManager('TeacherDataService');

  // private methods
  /**
   * Capitalize the first letter in a string
   * @param  {String} string
   * @return {String}
   */
  var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  var _getModuleMap = function _getModuleMap(class_id, next) {
    return DataCacheService.fetch({
      action: next,
      key: DataPathService['class/modulesMapContainer'](class_id),
      fetcher: function fetcher(cb) {
        return api.getClassModuleMaps(class_id).then(function (moduleMapsContainer) {
          cb(moduleMapsContainer);
        });
      }
    });
  };
  var getModuleContainerMap = function getModuleContainerMap(class_id, next) {
    return DataCacheService.fetch({
      action: next,
      key: DataPathService.dynamic('class/moduleContainer/:classId', { classId: class_id }),
      fetcher: function fetcher(cb) {
        return _getModuleMap(class_id).then(function (moduleMapsContainers) {
          cb(moduleMapsContainers.Modules[0]);
        });
      }
    });
  };
  var _getModuleListFlat = function _getModuleListFlat(class_id, next) {
    return DataCacheService.fetch({
      action: next,
      key: DataPathService['class/modulesListFlat'](class_id),
      fetcher: function fetcher(cb) {
        return getModulesAndSubModules(class_id, function (allModules) {
          var modulesListFlat = _.map(allModules, function (moduleResource) {
            return {
              name: moduleResource.name,
              slug: moduleResource.slug,
              content: moduleResource.content,
              resource_id: moduleResource.id,
              hasSubModules: moduleResource.hasSubModules,
              display: moduleResource.display,
              config: moduleResource.config
            };
          });
          cb(modulesListFlat);
        });
      }
    });
  };

  var getModuleResourceListFlatMap = function getModuleResourceListFlatMap(class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/modulesListFlatMap'](class_id),
      fetcher: function fetcher(next) {
        return _getModuleMap(class_id).then(function (modules) {
          var modulesListFlatMap = {};
          var addNewResource = function addNewResource(resource, module) {
            if (resource.resource_type !== 'symlink') {
              modulesListFlatMap[resource.id] = _.extend({
                module_id: module.module_id
              }, resource);
            }
            if (resource.children && resource.children.length > 0) {
              resource.children.map(function (child) {
                addNewResource(child, module);
              });
            }
          };
          _.each(modules.Modules, function (module) {
            _.each(module.Resource.children, function (resource) {
              addNewResource(resource, module);
            });
          });
          next(modulesListFlatMap);
        });
      }
    });
  };

  var getStudentWorkForModuleByTeacher = function getStudentWorkForModuleByTeacher(moduleResource, user_id, class_id, cb, flush) {
    if (flush) {
      DataCacheService.flush(DataPathService['class/module/student/work'](class_id, moduleResource.module_id, user_id));
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/student/work'](class_id, moduleResource.module_id, user_id),
      fetcher: function fetcher(cb) {
        return api.getStudentModuleResourceStateByTeacher(moduleResource.module_id, user_id, class_id).then(function (studentWorks) {
          cb(StudentDataService.genModuleWIthWork(studentWorks, moduleResource, user_id));
        });
      }
    });
  };

  var getStudentWorkSummaryForModuleByTeacher = function getStudentWorkSummaryForModuleByTeacher(moduleResource, user_id, class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/student/workSummary'](class_id, moduleResource.module_id, user_id),
      fetcher: function fetcher(cb) {
        getStudentWorkForModuleByTeacher(moduleResource, user_id, class_id, function (detail) {
          var summary = {};
          _.each(detail.resources, function (resource) {
            var resourceTypeSummary = summary[resource.resource_type];
            if (!resourceTypeSummary) {
              resourceTypeSummary = summary[resource.resource_type] = { atLeastOne: false, allLocked: true, noIncomplete: true, total: 0, num: 0 };
            }
            if (!resource.locked) {
              resourceTypeSummary.allLocked = false;
            }
            if (!resource.complete) {
              resourceTypeSummary.noIncomplete = false;
            }
          });
          cb({
            module_id: moduleResource.module_id,
            summary: summary
          });
        });
      }
    });
  };

  var getStudentsAppEvents = function getStudentsAppEvents(class_id, module_id, options, cb) {
    var from = options.from || moment().subtract(7, 'days').format('YYYY-MM-DD');
    var to = options.to || moment().format('YYYY-MM-DD');
    var limit = options.limit || 200;
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/module/work'](class_id, module_id, from, to, limit),
      fetcher: function fetcher(cb) {
        return api.getStudentsAppEvents(class_id, module_id, from, to, limit).then(function (modulesContainer) {
          cb(modulesContainer);
        });
      }
    });
  };

  var getStudentAppEventsSummarized = function getStudentAppEventsSummarized(class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/workSummarized'](class_id),
      fetcher: function fetcher(cb) {
        cb([]);
      }
    });
  };

  var getUserIDSync = function getUserIDSync() {
    return userAccount.getData().user_id;
  };

  var _getStudentWorkForClass = function _getStudentWorkForClass(student_user_id, class_id, cb, flush) {
    if (flush) {
      DataCacheService.flush(DataPathService['class/student/work'](class_id, student_user_id));
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/student/work'](class_id, student_user_id),
      fetcher: function fetcher(cb) {
        _getModuleMap(class_id, function (moduleMapsContainer) {
          var classStudentWork = {
            modules: {}
          };
          _.each(moduleMapsContainer.Modules, function (moduleContainer) {
            getStudentWorkSummaryForModuleByTeacher(moduleContainer, student_user_id, class_id, function (data) {
              classStudentWork.modules[moduleContainer.module_id] = data;
              cb(classStudentWork); // sending same object multiple times on purpose (to force scope refresh)
            });
          });
        });
      }
    });
  };

  /**
  * Get the work that a teacher did (as a student) in a module
  * @param  {Integer}   class_id
  * @param  {Bool}   flush
  * @param  {Function} cb
  * @return {Function}
  */
  var _getStudentWorkForModuleOfTeacher = function _getStudentWorkForModuleOfTeacher(class_id, flush, cb) {
    var teacher_user_id = getUserIDSync();
    if (flush) {
      DataCacheService.flush(DataPathService['class/teacher/work'](class_id, teacher_user_id));
    }
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService['class/teacher/work'](class_id, teacher_user_id),
      fetcher: function fetcher(cb) {
        return _getModuleMap(class_id, function (moduleDatas) {
          var moduleData = moduleDatas.Modules[0];
          cb(StudentDataService.genModuleWIthWork([], moduleData, teacher_user_id));
          //getStudentWorkForModuleByTeacher(moduleData, teacher_user_id, class_id, cb, flush)
        });
      }
    });
  };

  var getArchivedStudents = function getArchivedStudents(class_id) {
    return api.getArchivedStudents(class_id, 'mtic_teacher');
  };

  var getClassStats = function getClassStats(class_id, reset, cb, isArchived) {
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService.dynamic('/class/:classId/work', { classId: class_id }),
      fetcher: function fetcher(next) {
        return $q.all([getModulesAndSubModules(class_id), api.getClassResourceStates(class_id, isArchived, true), getClassStudentMap(class_id, null, reset || false, isArchived)]).then(function (datas) {
          var moduleData = angular.copy(datas[0]);
          var userRoles = datas[1];
          //this part is added because some g78 m1/m3 lessons were marked as incomplete
          userRoles.forEach(function (user) {
            user.User.ClassWorks.forEach(function (work) {
              if ((work.WorkBatch.Resource.parent_resource_id === 69 || work.WorkBatch.Resource.parent_resource_id === 373) && work.WorkBatch.Resource.resource_type !== "assessment" && work.WorkBatch.StudentResourceState) {
                work.WorkBatch.StudentResourceState.completions = 1;
                work.WorkBatch.StudentResourceState.complete = true;
                work.WorkBatch.StudentResourceState.score_max = 1;
              }
            });
          });
          var studentMap = datas[2];
          TeacherClassStatsService.computeStats(moduleData, userRoles, studentMap).then(function (stats) {
            $log.debug('[[TeacherDataService]]', moduleData, userRoles, stats);
            next(stats);
          });
        });
      }
    });
  };

  var getArchivedClassStats = function getArchivedClassStats(class_id, reset, cb, isArchived) {
    var defer = $q.defer();
    $q.all([getModulesAndSubModules(class_id), api.getClassResourceStates(class_id, isArchived, true), getClassStudentMap(class_id, null, reset, isArchived)]).then(function (datas) {
      var moduleData = angular.copy(datas[0]);
      var userRoles = datas[1];
      var studentMap = datas[2];
      TeacherClassStatsService.computeStats(moduleData, userRoles, studentMap).then(function (stats) {
        // $log.debug('[[TeacherDataService]]',moduleData, userRoles, stats)
        defer.resolve(stats);
      });
    });

    return defer.promise;
  };

  var getModulesAndSubModules = function getModulesAndSubModules(class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService.dynamic('/class/:classId/allModules', { classId: class_id }),
      fetcher: function fetcher(next) {
        return _getModuleMap(class_id).then(function (classMetaModules) {
          var allModules = {};
          var seekAndRetrieveSubModules = function seekAndRetrieveSubModules(someModule) {
            var copy = angular.copy(someModule).children || [];
            var foundSubs = copy.filter(function (resource) {
              if (['sub_module', 'resource_module'].indexOf(resource.resource_type) > -1) {
                allModules[resource.id] = resource;
                resource.hasSubModules = seekAndRetrieveSubModules(resource);
                return true;
              } else {
                return false;
              }
            });
            return foundSubs.length > 0;
          };
          classMetaModules.Modules.forEach(function (moduleData) {
            var moduleResource = moduleData.Resource;
            moduleResource.hasSubModules = seekAndRetrieveSubModules(moduleResource);
            allModules[moduleResource.id] = moduleResource;
          });
          next(allModules);
        });
      }
    });
  };

  var getClassPanelConfig = function getClassPanelConfig(class_id, cb) {
    return DataCacheService.fetch({
      action: cb,
      key: DataPathService.dynamic('/class/:classId/modules/config', { classId: class_id }),
      fetcher: function fetcher(next) {
        return getModulesAndSubModules(class_id).then(function (allModules) {
          var panels = {};
          _.map(allModules, function (module) {
            if (module.config.teacher_panel) {
              panels = angular.extend(panels, module.config.teacher_panel);
              panels = angular.extend(panels, module.config.teacher_panel_archive);
            }
          });
          next(_.map(panels, function (panel, panelId) {
            return {
              id: panelId,
              name: capitalizeFirstLetter(panelId)
            };
          }));
        });
      }
    });
  };

  var _getClassStudents = function _getClassStudents(class_id, cb, reset, isArchived) {
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService['class/students'](class_id),
      fetcher: function fetcher(cb) {
        api.getClassMembers(class_id, 'mtic_teacher', isArchived).then(function (students) {
          students = _.sortBy(students, function (student) {
            student.display_name = [student.info.first_name, student.info.last_name].join(' ');
            //if they have more than 1 it will show the first
            if (student.auths[0]) {
              student.user_name = student.auths[0].uuid;
            } else {
              student.user_name = '---';
            }
            return String(student.info.last_name + student.info.first_name).toUpperCase();
          });
          cb(students);
        });
      }
    });
  };

  var getClassStudentMap = function getClassStudentMap(class_id, cb, reset, isArchived) {
    //var isArchivedVal = isArchived || false;
    return DataCacheService.fetch({
      action: cb,
      reset: reset,
      key: DataPathService['class/studentsMap'](class_id),
      fetcher: function fetcher(cb) {
        return _getClassStudents(class_id, function (students) {
          var studentMap = {};
          _.each(students, function (student) {
            studentMap[student.user_id] = student;
          });
          cb(studentMap);
        }, reset, isArchived);
      }
    });
  };
  var getUserGroups = function getUserGroups(reset, action) {
    var key = DataPathService.dynamic('user/:userId/groups', { userId: getUserIDSync() });
    if (reset) {
      DataCacheService.flush(key);
    }
    return DataCacheService.fetch({
      action: action,
      key: key,
      fetcher: function fetcher(next) {
        return api.getUserGroups().then(next);
      }
    });
  };

  var getCustomResource = function getCustomResource(classId, resourceId, reset) {
    return DataCacheService.fetch({
      reset: reset,
      key: DataPathService.dynamic('class/:classId/custom_module/resource/:resourceId', { classId: classId, resourceId: resourceId }),
      fetcher: function fetcher(next) {
        return api.getCustomResource(classId, resourceId).then(function (groupData) {
          next(groupData[0]); //.CustomModule.Resource.children[0])
        });
      }
    });
  };
  var getCustomResources = function getCustomResources(classId, resourceIds, reset) {
    return $q.all(resourceIds.map(function (resourceId) {
      return getCustomResource(classId, resourceId, reset);
    }));
  };

  var getSchoolModules = function getSchoolModules(_ref) {
    var school_id = _ref.school_id,
        reset = _ref.reset;

    return DataCacheService.fetch({
      reset: reset,
      key: DataPathService.dynamic('school/:school_id/modules', { school_id: school_id }),
      fetcher: function fetcher(next) {
        return api.getSchoolModules(school_id).then(function (groupModules) {
          next(groupModules.map(function (groupModule) {
            // console.log('groupModule.Module.Resource.slug', groupModule.Module.Resource.slug)
            return {
              getName: function getName() {
                return language.get(groupModule.Module.Resource.slug);
              },

              module_id: groupModule.Module.id,
              module_resource_id: groupModule.Module.Resource.id
            };
          }));
        });
      }
    });
  };
  // init

  // public methods
  return {
    getSchoolModules: getSchoolModules,
    getModuleContainerMap: getModuleContainerMap,
    getCustomResources: getCustomResources,
    getClassStudentMap: getClassStudentMap,
    getModuleResourceListFlatMap: getModuleResourceListFlatMap,
    getClassPanelConfig: getClassPanelConfig,
    currentActiveMeta: null,
    searchStudent: function searchStudent(_ref2) {
      var uuid = _ref2.uuid,
          _ref2$noschool = _ref2.noschool,
          noschool = _ref2$noschool === undefined ? false : _ref2$noschool,
          _ref2$auth_type = _ref2.auth_type,
          auth_type = _ref2$auth_type === undefined ? 'microsoftStrategy' : _ref2$auth_type;

      return DataCacheService.fetch({
        key: DataPathService.dynamic('searchStudent/:noschool/:auth_type/:uuid', { noschool: noschool, uuid: uuid, auth_type: auth_type }),
        fetcher: function fetcher(next) {
          return api.findStudentNoSchool({ uuid: uuid, auth_type: auth_type }).then(function (students) {
            return next(students.map(function (_ref3) {
              var user_id = _ref3.user_id,
                  info = _ref3.info,
                  auths = _ref3.auths,
                  moduleResource = _ref3.moduleResource,
                  classroom = _ref3.classroom;
              return {
                user_id: user_id,
                first_name: info.first_name,
                last_name: info.last_name,
                full_name: [info.first_name, info.last_name].join(' '),
                email: info.email,
                classroom: classroom,
                user_name: auths.filter(function (auth) {
                  return auth.auth_type === auth_type;
                })[0].uuid,
                moduleResource: moduleResource,
                getModuleName: function getModuleName() {
                  return language.get(moduleResource.slug);
                }
              };
            }));
          });
        }
      });
    },
    transferStudent: function transferStudent(_ref4) {
      var user_id = _ref4.user_id,
          to_class_id = _ref4.to_class_id,
          from_class_id = _ref4.from_class_id,
          transferProgress = _ref4.transferProgress;

      return api.transferStudent(user_id, to_class_id, transferProgress ? from_class_id : undefined);
    },

    getAppLogs: function getAppLogs(class_id, options, next) {
      var from = options.from || moment().subtract(7, 'days').format('YYYY-MM-DD');
      var to = options.to || moment().format('YYYY-MM-DD');
      var limit = options.limit || 200;
      return DataCacheService.fetch({
        action: next,
        key: DataPathService['class/users/app/events'](class_id, from, to, limit),
        fetcher: function fetcher(cb) {
          return _getModuleMap(class_id, function (modules) {
            _.each(modules.Modules, function (module) {
              return $q.all([getStudentsAppEvents(class_id, module.module_id, { from: from, to: to, limit: limit }), getClassStudentMap(class_id), getModuleResourceListFlatMap(class_id)]).then(function (datas) {
                var group = datas[0][0]; //always returns an array of 1
                var userMapping = datas[1];
                var moduleResourceMapping = datas[2];
                return cb(new LogReducer(group.Group.UserRoles, userMapping, moduleResourceMapping));
              });
            });
          });
        }
      });
    },
    getStudentWorkForModuleOfTeacher: function getStudentWorkForModuleOfTeacher(class_id, flush, cb) {
      return _getStudentWorkForModuleOfTeacher(class_id, flush, cb);
    },
    createClass: function createClass(schoolId, className, classDescription, cb) {
      throw new Error("TeacherDataService.createClass is no longer supported!");
      // return api.createClass(schoolId, className, classDescription).
      // then(function(newClass) {
      //   cb(newClass);
      // });
    },
    createSchoolClass: function createSchoolClass(_ref5) {
      var module_id = _ref5.module_id,
          school_id = _ref5.school_id,
          name = _ref5.name,
          description = _ref5.description;

      return api.createSchoolClass({ module_id: module_id, school_id: school_id, name: name, description: description });
    },

    getModuleMap: function getModuleMap(class_id, cb) {
      return _getModuleMap(class_id, cb);
    },

    getModuleListFlat: function getModuleListFlat(class_id, cb) {
      return _getModuleListFlat(class_id, cb);
    },

    getUserId: function getUserId(cb) {
      return cb(getUserIDSync());
    },

    getUserClasses: function getUserClasses(reset, cb) {
      var TeacherDataService = this;
      var key = DataPathService['user/classes'](getUserIDSync());
      if (reset) {
        DataCacheService.flush(key);
      }
      return DataCacheService.fetch({
        action: cb,
        key: key,
        fetcher: function fetcher(cb) {
          return getUserGroups(reset).then(function (groupRoles) {
            var classes = groupRoles.filter(function (groupRole) {
              return groupRole.role_type === 'mtic_teacher' && groupRole.Group.group_type === 'mtic_class';
            }).map(function (groupRole) {
              return groupRole.Group;
            });
            _.each(classes, function (classroom) {
              classroom.code = TeacherDataService.renderClassCodeStr(classroom);
            });
            return classes;
          }).then(function (classes) {
            var allPromise = [];
            _.each(classes, function (classroom) {
              allPromise.push(TeacherDataService.getCountry(classroom.id).then(function (country) {
                classroom.country = country;
              }));
            });
            Promise.all(allPromise).then(function () {
              cb(classes);
            });
          });
        }
      });
    },

    renderClassCodeStr: function renderClassCodeStr(classroom) {
      return getUserIDSync() + 'c' + classroom.id;
    },

    getSchoolClasses: function getSchoolClasses(reset, school_id, get_archived) {
      var TeacherDataService = this;
      var key = DataPathService.dynamic('school/:school_id/classes', { school_id: school_id });
      if (reset) {
        DataCacheService.flush(key);
      }
      return DataCacheService.fetch({
        key: key,
        reset: reset,
        fetcher: function fetcher(next) {
          return api.getClassesForSchool(school_id).then(function (classes) {
            if (get_archived) {
              classes = classes.filter(function (cur_class) {
                return cur_class.GroupModules[0].archived;
              });
            } else {
              classes = classes.filter(function (cur_class) {
                return !cur_class.GroupModules[0].archived;
              });
            }

            next(classes.map(function (classroom) {
              if (classroom.GroupModules.length !== 1) {
                throw new Error('Too many groupModules for ' + classroom.id);
              }
              var groupModule = classroom.GroupModules[0];
              if (!groupModule.Module) {
                throw new Error('No Module for ' + classroom.id);
              }
              var module = groupModule.Module;
              if (!module.Resource) {
                throw new Error('No Resource for ' + module.id);
              }
              var moduleResource = module.Resource;
              return {
                id: classroom.id,
                name: classroom.name,
                description: classroom.description,
                module_id: module.id,
                module_resource_id: moduleResource.id,
                shared_users: classroom.UserRoles && classroom.UserRoles.length > 0 && classroom.UserRoles[0].Group ? classroom.UserRoles[0].Group.UserRoles : [],
                getType: function getType() {
                  return language.get(moduleResource.slug);
                },

                code: TeacherDataService.renderClassCodeStr(classroom)
              };
            }));
          });
        }
      });
    },
    getSchoolArchivedClasses: function getSchoolArchivedClasses(reset, school_id) {
      var TeacherDataService = this;
      var defer = $q.defer();
      api.getClassesForSchool(school_id).then(function (classes) {
        classes = classes.filter(function (cur_class) {
          return cur_class.GroupModules[0].archived;
        });
        var archivedClasses = [];
        classes.forEach(function (classroom) {
          if (classroom.GroupModules.length !== 1) {
            throw new Error('Too many groupModules for ' + classroom.id);
          }
          var groupModule = classroom.GroupModules[0];
          if (!groupModule.Module) {
            throw new Error('No Module for ' + classroom.id);
          }
          var module = groupModule.Module;
          if (!module.Resource) {
            throw new Error('No Resource for ' + module.id);
          }
          var moduleResource = module.Resource;
          var modifiedClass = {
            id: classroom.id,
            name: classroom.name,
            description: classroom.description,
            module_id: module.id,
            module_resource_id: moduleResource.id,
            getType: function getType() {
              return language.get(moduleResource.slug);
            },

            code: TeacherDataService.renderClassCodeStr(classroom)
            // $log.log(modifiedClass);
          };archivedClasses.push(modifiedClass);
        });

        defer.resolve(archivedClasses);
      });

      return defer.promise;
    },
    getUserSchools: function getUserSchools(cb, reset) {
      return DataCacheService.fetch({
        action: cb,
        reset: reset,
        key: DataPathService['user/schools'](getUserIDSync()),
        fetcher: function fetcher(cb) {
          var schools = userAccount.getData().roles.filter(function (role) {
            return role.group.group_type === 'school' || role.group.group_type === 'no_school';
          }).map(function (role) {
            return role.group;
          });
          cb(schools);
        }
      });
    },

    getClassStudents: function getClassStudents(class_id, cb, reset) {
      return _getClassStudents(class_id, cb, reset);
    },

    getClassAgendas: function getClassAgendas(classId, flush, cb) {
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/agendas', { classId: classId }),
        reset: flush,
        fetcher: function fetcher(next) {
          return $q.all([getClassStudentMap(classId), getModuleResourceListFlatMap(classId), api.getClassAgenda(classId)]).then(function (datas) {
            var studentMap = datas[0];
            var resourceMap = datas[1];
            return $q.all(datas[2].Agendas.map(function (agenda) {
              if (!agenda.is_for_all_class) {
                agenda.studentRefs = agenda.students.map(function (user_id) {
                  return studentMap[user_id];
                });
              }
              var custom_resources = {};
              return $q.all(agenda.resources.map(function (resource_id) {
                if (resourceMap[resource_id]) {
                  return $q.resolve(resourceMap[resource_id]);
                } else {
                  return getCustomResource(classId, resource_id, true).then(function (cResource) {
                    if (cResource) {
                      custom_resources[cResource.id] = cResource;
                    }
                    return cResource;
                  });
                }
              })).then(function (resourceRefs) {
                agenda.resourceRefs = resourceRefs;
                agenda.custom_resources = custom_resources;
                agenda.StudentAgendaItems = agenda.StudentAgendaItems.filter(function (studentAgendaItem) {
                  studentAgendaItem.user = studentMap[studentAgendaItem.user_id];
                  studentAgendaItem.resource = resourceMap[studentAgendaItem.resource_id];
                  if (!studentAgendaItem.resource) {
                    if (custom_resources[studentAgendaItem.resource_id]) {
                      studentAgendaItem.resource = custom_resources[studentAgendaItem.resource_id];
                    }
                  }
                  return !!studentAgendaItem.resource;
                });
                return agenda;
              });
            })).then(function (agendas) {
              next(agendas.sort(function (agendaA, agendaB) {
                return moment(agendaB.open_date).diff(agendaA.open_date);
              }));
            });
          });
        }
      });
    },

    createAgenda: function createAgenda(class_id, resource_ids, description, date_close, date_open, custom_resources, user_ids, sub_module_resource_id, lockOptions, hideFromStudents, competition_ids) {
      if (!lockOptions) {
        lockOptions = {};
      }
      // $log.log('from create agenda : ' , hideFromStudents)
      var agenda_definition = {
        "description": description,
        "date_close": moment(date_close).hour(23).minute(59).second(59).toDate(),
        "date_open": moment(date_open).toDate(),
        "force_unlock": lockOptions.force_unlock || null,
        "force_redo": lockOptions.force_redo || false,
        "custom_resources": custom_resources,
        "published": !hideFromStudents,
        "competition_ids": competition_ids || null
      };
      if (lockOptions.attempt_limit) {
        agenda_definition.attempt_limit = lockOptions.attempt_limit;
      }
      return api.createAgenda(class_id, sub_module_resource_id, resource_ids, user_ids, agenda_definition);
    },

    updateClassName: function updateClassName(classId, name) {
      return api.updateClass(classId, {
        name: name
      });
    },

    updateClassInfo: function updateClassInfo(classId, name, description) {
      return api.updateClass(classId, {
        name: name,
        description: description
      });
    },

    togglePublishAgenda: function togglePublishAgenda(classId, agenda_id, publishStatus) {
      return api.updateAgendaProperty(classId, agenda_id, [{
        property_name: 'published',
        property_value: publishStatus
      }]);
    },

    updateAgenda: function updateAgenda(classId, agenda_id, updates) {
      var apiUpdate = [];
      if ('description' in updates) {
        apiUpdate.push({
          property_name: 'description',
          property_value: updates.description
        });
      }
      if ('date_close' in updates) {
        apiUpdate.push({
          property_name: 'date_close',
          property_value: updates.date_close
        });
      }
      if ('date_open' in updates) {
        apiUpdate.push({
          property_name: 'date_open',
          property_value: updates.date_open
        });
      }
      if ('resources' in updates) {
        apiUpdate.push({
          property_name: 'resources',
          property_value: updates.resources
        });
      }
      if ('students' in updates) {
        apiUpdate.push({
          property_name: 'students',
          property_value: updates.students
        });
      }
      if ('custom_resources' in updates) {
        apiUpdate.push({
          property_name: 'custom_resources',
          property_value: updates.custom_resources
        });
      }
      if ('force_unlock' in updates) {
        apiUpdate.push({
          property_name: 'force_unlock',
          property_value: updates.force_unlock
        });
      }
      if ('force_redo' in updates) {
        apiUpdate.push({
          property_name: 'force_redo',
          property_value: updates.force_redo
        });
      }
      if ('published' in updates) {
        apiUpdate.push({
          property_name: 'published',
          property_value: updates.published
        });
      }
      if ('archived' in updates) {
        apiUpdate.push({
          property_name: 'archived',
          property_value: updates.archived
        });
      }
      return api.updateAgendaProperty(classId, agenda_id, apiUpdate);
    },

    deleteAgenda: function deleteAgenda(classId, agenda_id) {
      return api.deleteAgendaProperty(classId, [agenda_id]);
    },

    getStudentWorkForClass: function getStudentWorkForClass(student_user_id, class_id, cb, flush) {
      return _getStudentWorkForClass(student_user_id, class_id, cb, flush);
    },

    getClassStats: getClassStats,

    getArchivedClassStats: getArchivedClassStats,

    getArchivedStudents: getArchivedStudents,

    getStudentsAppEvents: getStudentsAppEvents,

    /**
     * Returns a list of modules that have only leafs
     * @param  {Integer}   classId
     * @param  {Function} cb
     * @return {Promise}
     */
    getClassFullModules: function getClassFullModules(classId, cb) {
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/fullmodules', { classId: classId }),
        fetcher: function fetcher(next) {
          return getModulesAndSubModules(classId).then(function (moduleAndSubs) {
            next(_.toArray(moduleAndSubs).filter(function (module) {
              return !module.hasSubModules;
            }));
          });
        }
      });
    },
    getClassFullModulesStructured: function getClassFullModulesStructured(classId, cb) {
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService.dynamic('class/:classId/fullmodulesstruct', { classId: classId }),
        fetcher: function fetcher(next) {
          return getModulesAndSubModules(classId).then(function (moduleAndSubs) {
            var struct_arr = _.toArray(moduleAndSubs).filter(function (module) {
              return !module.hasSubModules || module.id === 192;
            });
            var cycle_data = _.toArray(moduleAndSubs).filter(function (module) {
              return module.hasSubModules && module.id !== 192;
            })[0];
            var struct = { resources: struct_arr, meta_config: cycle_data.config, resource_slug: cycle_data.slug };
            next(struct);
          });
        }
      });
    },
    getC3ClassStudents_customForUser: function getC3ClassStudents_customForUser(cb) {
      return DataCacheService.fetch({
        action: cb,
        key: DataPathService['user/students_c3custom'](getUserIDSync()),
        fetcher: function fetcher(cb) {
          var user_id = userAccount.getData().user_id;
          var url = DATA_HOST.C3_TEACHER_CONFIGS.path + user_id + DATA_HOST.C3_TEACHER_CONFIGS.ext;
          return $http.get(url).then(function success(res) {
            // $log.debug('DATA_HOST.C3_TEACHER_CONFIGS', url, res.data);
            var classListWithPasswords = res.data;
            _.sortBy(classListWithPasswords, 'student_username');
            cb(classListWithPasswords);
          });
        }
      });
    },
    getClassStudentPasswords: function getClassStudentPasswords(classId) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/:classId/students/passwords', { classId: classId }),
        fetcher: function fetcher(next) {
          return Firebase.database().ref('/classAccounts/' + classId).once('value').then(function (snap) {
            next(snap.val());
          });
        }
      });
    },
    getCompetitionLeaderBoard: function getCompetitionLeaderBoard(comp_id) {
      return api.getCompetitionLeaderBoard(comp_id);
    },
    getLeaderBoardTopPerformer: function getLeaderBoardTopPerformer(agenda_id) {
      return api.getLeaderBoardTopPerformer(agenda_id);
    },
    getStudentAssessmentPdf: function getStudentAssessmentPdf(student_id, resource_id, group_id) {
      return api.getStudentAssessmentPdf(student_id, resource_id, group_id);
    },
    getClassAssessmentData: function getClassAssessmentData(resource_id, group_id, date_open, date_close) {
      return api.getClassAssessmentData(resource_id, group_id, date_open, date_close);
    },
    getPdfAvailability: function getPdfAvailability(user_id, group_id) {
      return api.getPdfAvailability(user_id, group_id);
    },
    importAgenda: function importAgenda(class_id, import_code) {
      return api.importAgenda(class_id, import_code);
    },
    /**
     * Gets the country of the class.
     * Please refer to groups.groupType == 'country' in the db for what country names its expecting
     * If updating this, please update the `getCountry` in mtic2\src\main\services\StudentDataService.js as well :/
     * @param {number} class_id
     * @returns {(string|null)}
     */
    getCountry: function getCountry(class_id) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/country/:classId', { classId: class_id }),
        fetcher: function fetcher(next) {
          return api.getCountryOfClass(class_id).then(function (data) {
            if (data) {
              next(data.name);
            } else {
              next(null);
            }
          });
        }
      });
    }
    //
  };
});
'use strict';

angular.module('mtic').service('TeacherClassStatsService', function ($log, $q) {
  /**
   * initializes all stats
   * @param  {ModuleResource} moduleResource
   * @param  {Objcet} statDef
   * @param  {String} statName
   * @return {Null}
   */
  var initializeStats = function initializeStats(moduleResource, statDef, statName) {
    if (!moduleResource.stats) {
      moduleResource.stats = {};
    }
    var stats = moduleResource.stats;
    var meta_locks = moduleResource.config.meta_locks;
    if (!stats[statName]) {
      stats[statName] = {
        total: 0,
        attempts: 0,
        completed: 0,
        timespent: 0,
        score_max_mean: 0,
        locked: true
      };
      if (meta_locks && meta_locks[statName]) {
        stats[statName].locked = meta_locks[statName].length > 0;
      }
      var stat = stats[statName];
      switch (statDef.by) {
        case 'resource_type':
          stat.total = _.filter(moduleResource.children, function (childResource) {
            return childResource.resource_type === statDef.value;
          }).length;
          break;
        case 'slug':
          stat.total = _.filter(moduleResource.children, function (childResource) {
            return childResource.slug === statDef.value;
          }).length;
          break;
        case 'cluster_or_slug':
          stat.total = _.filter(moduleResource.children, function (childResource) {
            return statDef.value.cluster.indexOf(childResource.slug) > -1;
          }).length;
          break;
        default:
          throw new Error('Not Supported Stat Type ' + statDef.by);
      }
    }
  };
  /**
   * Init to all stats for moduleResource
   * @param  {ModuleResource} moduleResource
   * @return {}
   */
  var initStatsForModule = function initStatsForModule(moduleResource) {
    if (!moduleResource.stats) {

      _.map(moduleResource.config.stats, function (statDef, statName) {
        initializeStats(moduleResource, statDef, statName);
      });
    }
    return;
    // if ( moduleResource.config.stats ) {
    //   if ( ! moduleResource.stats ) {
    //     _.map( moduleResource.config.stats, function ( statDef, statName ) {
    //       initializeStats( moduleResource, statDef, statName )
    //     })
    //   }
    //   return;
    // } else {
    //   throw new Error( 'No Stats defined for ' + moduleResource.name );
    // }
  };
  /**
   * Updates the state of the stats
   * @param  {Object} stat
   * @param  {StudentResourceState} studentResourceState
   * @return {}
   */
  var workbatch_list = [];
  var updateStatState = function updateStatState(stat, studentResourceState, workbatch_id, resource) {
    if (workbatch_list.indexOf(workbatch_id) > -1 || !studentResourceState) {
      return;
    }
    workbatch_list.push(workbatch_id);
    stat.attempts++;
    stat.timespent += studentResourceState.time_spent_total;
    if (studentResourceState.complete) {
      stat.completed++;
      stat.locked = false;
    }
    var use_score = resource.display && resource.display.color === 'blue' && studentResourceState.complete ? 1 : studentResourceState.score_max;
    stat.score_max_mean += use_score / stat.total;
  };
  /**
   * Computes stats
   * @param  {Array<StudentResourceState>} work
   * @param  {ModuleResourceWithStats} workSummary
   * @return {Promise}
   */
  var statCompute = function statCompute(work, workSummary) {
    workbatch_list = [];
    return $q.all(work.map(function (classWork) {
      return $q(function (resolve, reject) {
        var resource = classWork.WorkBatch.Resource;
        var studentResourceState = classWork.WorkBatch.StudentResourceState;
        var parentModuleResource = workSummary[resource.parent_resource_id];
        if (parentModuleResource) {
          var cur_resource = _.find(parentModuleResource.children, { id: resource.id });
          _.map(parentModuleResource.config.stats, function (statDef, statName) {
            var stat;
            switch (statDef.by) {
              case 'slug':
                if (resource.slug === statDef.value) {
                  stat = parentModuleResource.stats[statName];
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource);
                }
                break;
              case 'resource_type':
                if (resource.resource_type === statDef.value) {
                  stat = parentModuleResource.stats[statName];
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource);
                }
                break;
              case 'cluster_or_slug':
                //the cluster_or_slug setting is used to grade using an array of assessments(cluster) which can also be overwritten by one final assessment(slug)
                //this is currently used for formatives with final summative format. The value should be {"cluster":[array of slugs], "slug"://final slug}
                //additionally the second part(slug) is optional and can be used purely for the cluster
                stat = parentModuleResource.stats[statName];
                if (resource.slug === statDef.value.slug && studentResourceState.complete) {
                  stat.timespent = studentResourceState.time_spent_total;
                  stat.locked = false;
                  stat.score_max_mean = studentResourceState.score_max;
                  stat.dont_change_by_cluster = true;
                } else if (!stat.dont_change_by_cluster && statDef.value.cluster.indexOf(resource.slug) > -1) {
                  updateStatState(stat, studentResourceState, classWork.WorkBatch.id, cur_resource);
                }
                break;
              default:
                $log.warn("Could not match a stat type for", statDef);
            }
          });
        } else {
          // $log.warn( '[[TeacherDataService]] PARENT RESOURCE IS NOT LOADED FOR', resource )
        }
        resolve();
      });
    }));
  };
  var computeMetaLock = function computeMetaLock(stats, statName, metaLocksDef, locksComputed) {
    if (!locksComputed[statName]) {
      var unlockedBys = metaLocksDef[statName];
      if (stats[statName].locked && unlockedBys.length > 0) {
        var unlockedBysCompleted = unlockedBys.filter(function (lockName) {
          computeMetaLock(stats, lockName, metaLocksDef, locksComputed);
          return stats[lockName].completed > 0;
        });
        stats[statName].locked = unlockedBysCompleted.length !== unlockedBys.length;
      } else if (unlockedBys.length > 0) {
        stats[statName].locked = false;
      }
      locksComputed[statName] = true;
    }
  };
  var computeMetaLocks = function computeMetaLocks(stats, metaLocksDefs) {
    var locksComputed = {};
    if (metaLocksDefs) {
      _.map(metaLocksDefs, function (unlockedBys, statName) {
        computeMetaLock(stats, statName, metaLocksDefs, locksComputed);
      });
    }
  };
  return {
    computeStats: function computeStats(moduleData, userRoles, studentMap) {
      return $q.all(userRoles.map(function (userRole) {
        return $q(function (resolve, reject) {
          var work = userRole.User.ClassWorks;
          var moduleWorkSummary = angular.copy(moduleData);
          _.map(moduleWorkSummary, initStatsForModule);
          if (work.length > 0) {
            statCompute(work, moduleWorkSummary).then(function () {
              _.map(moduleWorkSummary, function (module) {
                computeMetaLocks(module.stats, module.config.meta_locks);
              });
              resolve({
                user: studentMap[userRole.user_id],
                moduleWorkSummary: moduleWorkSummary
              });
            });
          } else {
            _.map(moduleWorkSummary, function (module) {
              computeMetaLocks(module.stats, module.config.meta_locks);
            });
            resolve({
              user: studentMap[userRole.user_id],
              moduleWorkSummary: moduleWorkSummary
            });
          }
        });
      }));
    }
  };
});
'use strict';

angular.module('mtic').service('StudentDataService', function (DEV_VARIABLES, GLOBAL_API_CONFIG, ASSET_HOST, ITEM_VERSION_MAP, EventManager, Firebase, api, userAccount, $q, $log, DataCacheService, DataPathService, FirebaseItematic, apiMethods, moduleMappingService) {
  var eventManager = new EventManager('StudentDataService');
  /**
  * Private vars
  */
  var studentModuleMaps = {};
  var classModuleMaps = {};
  var classSummaryStats = {};

  var resetMaps = function resetMaps() {
    studentModuleMaps = {};
    classModuleMaps = {};
    classSummaryStats = {};
  };

  var getUserIDSync = function getUserIDSync() {
    return userAccount.getData().user_id;
  };

  /**
  * Public Methods
  * @type {Object}
  */
  var StudentDataService = {
    genUrlfromContent: function genUrlfromContent(slug, content) {
      return determineHostUrl({
        slug: slug,
        content: content
      });
    },
    /**
    * Get Module Data
    * @param  {Boolean} refresh get new module data if set to true
    * @return {Promise}
    */
    getModuleData: function getModuleData(refresh) {
      switch (userAccount.getData().role.role_type) {
        case 'mtic_student':
          return getStudentMaps(refresh);
        case 'mtic_teacher':
          throw "Invalid Account Type";
        default:
          throw 'Invalid role!';
      }
    },

    getCustomResource: function getCustomResource(resourceId) {
      return api.getStudentCustomResource(resourceId).then(function (groupData) {
        // $log.log('got group data : ', groupData)
        var customResource = groupData[0]; //groupData.CustomModule.Resource.children[0];
        customResource.locked = false;
        customResource.hostUrl = determineHostUrl(customResource);
        return customResource;
      });
    },

    getClassInfo: function getClassInfo(_ref) {
      var class_id = _ref.class_id;

      return api.getClassInfo({ class_id: class_id });
    },


    getUserSchools: function getUserSchools(cb, reset) {
      return DataCacheService.fetch({
        action: cb,
        reset: reset,
        key: DataPathService['user/schools'](getUserIDSync()),
        fetcher: function fetcher(cb) {
          // console.log(userAccount.getData())
          var schools = userAccount.getData().roles.filter(function (role) {
            return role.group.group_type === 'school' || role.group.group_type === 'no_school';
          }).map(function (role) {
            return role.group;
          });
          cb(schools);
        }
      });
    },

    getAgendas: function getAgendas() {
      if (userAccount.getData().role.isTeacher) {
        return [];
      }
      return api.getStudentAgenda().then(function (data) {
        return data.Agendas ? data.Agendas : [];
      });
    },

    getClassMembers: function getClassMembers() {
      return api.getStudentClassMembers();
    },
    getClassMembersMap: function getClassMembersMap() {
      return this.getClassMembers().then(function (students) {
        var studentMap = {};
        _.each(students, function (student) {
          studentMap[student.user_id] = angular.copy(student);
          studentMap[student.user_id].display_name = [studentMap[student.user_id].info.first_name, studentMap[student.user_id].info.last_name].join(' ');
        });
        return studentMap;
      });
    },

    transferStudent: function transferStudent(_ref2) {
      var teacher_id = _ref2.teacher_id,
          from_class_id = _ref2.from_class_id,
          to_class_id = _ref2.to_class_id;

      return api.transferStudent({
        teacher_id: teacher_id,
        from_class_id: from_class_id,
        to_class_id: to_class_id
      });
    },
    parseClassCode: function parseClassCode(classCode) {
      var classCodeSplit = classCode.toLowerCase().split('c');
      return {
        teacherId: classCodeSplit[0],
        classId: classCodeSplit[1]
      };
    },
    setActiveClassroom: function setActiveClassroom(class_group_id) {
      userAccount.setActiveClassroom(class_group_id);
      api.setGroupId(class_group_id);
    },
    getClasses: function getClasses() {
      //return language.get(moduleResource.slug);
      return api.getClassesForStudent().then(function (allClasses) {
        return new Promise(function (resolve) {
          var allPromises = [];
          _.each(allClasses, function (singularClass) {
            allPromises.push(StudentDataService.getCountry(singularClass.id).then(function (country) {
              singularClass.country = country;
            }));
          });
          Promise.all(allPromises).then(function () {
            return resolve(allClasses);
          });
        });
      });
    },


    getCurrentUserData: function getCurrentUserData() {
      var userData = userAccount.getData();
      // userAccount.setActiveClassroom(userData.role.group_id)
      return {
        user_id: userData.user_id,
        firstName: userData.firstName,
        lastName: userData.lastName,
        fullName: userData.fullName
        // class_id: userData.role.group_id
        // class_id: userAccount.getActiveClassroom()
      };
    },
    getClassCommentState: function getClassCommentState(resourceId) {
      // var componentStates = {};
      // return componentStates;
      // return $q.all([
      //   Firebase.database().ref([
      //     'classCommentHistory',
      //     this.getCurrentClassId(),
      //     resourceId
      //   ].join('/')).once('value'),
      //   this.getClassMembersMap()
      // ]).then(function(datas){
      //   var states = datas[0].val();
      //   var classMembers = datas[1];
      //   var componentStates = {};
      //   _.forEach(states, function(obj, key){
      //     if(!componentStates[obj.component_id]) {
      //       componentStates[obj.component_id] = {comments:[]};
      //     }
      //     var componentState = componentStates[obj.component_id];
      //     var comment = angular.copy(obj.state || {});
      //     comment['.key'] = key;
      //     comment.time = obj.time_stamp;
      //     comment.author = classMembers[obj.user_id].display_name;
      //     componentState.comments.push(comment)
      //   })
      //   _.forEach(componentStates,function(state){
      //     state.comments = state.comments.sort(function(a,b){
      //       return b.time - a.time;
      //     })
      //   })
      //   return componentStates;
      // })
    },
    /**
     * Gets the country of the class.
     * Please refer to groups.groupType == 'country' in the db for what country names its expecting
     * If updating this, please update the `getCountry` in mtic2\src\main\services\TeacherDataService.js as well :/
     * @param {number} class_id
     * @returns {(string|null)}
     */
    getCountry: function getCountry(class_id) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/country/:classId', { classId: class_id }),
        fetcher: function fetcher(next) {
          return api.getCountryOfClass(class_id).then(function (data) {
            if (data) {
              next(data.name);
            } else {
              next(null);
            }
          });
        }
      });
    }
  };

  /**
  * Listens to session expired event
  */
  eventManager.listen('login:session:expired', function () {
    resetMaps();
  });
  /**
  * Listens to logout event
  */
  eventManager.listen('logout', function () {
    resetMaps();
  });

  eventManager.listen('navbar:my-classes:click', function () {
    resetMaps();
  });

  /**
  * Determine the url for openfl items
  * @param  {String} slug
  * @param  {String} itemVersion
  * @return {String}
  */
  var determineURLForOpenFl = function determineURLForOpenFl(slug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[slug]) {
      var item_version = ITEM_VERSION_MAP[slug];
      if (slug === 'run_like_math' && userAccount.getData().role.isTeacher) {
        item_version = ITEM_VERSION_MAP.run_like_math_teacher;
      }
      // $log.log('[[determineURLForOpenFl]]','Using ITEM_VERSION_MAP item version for', slug, ', i.e. using local file');
      return ASSET_HOST.CONTAINER.openfl.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl.VERSION + '&mticItemId=' + slug + '&mticItemVersion=' + item_version;
    } else if (itemVersion) {
      // $log.log('[[determineURLForOpenFl]]','Using fed-in itemVersion', slug, ', ', itemVersion);
      return ASSET_HOST.CONTAINER.openfl.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl.VERSION + '&mticItemId=' + slug + '&mticItemVersion=' + itemVersion;
    } else {
      $log.warn('Missing item version for', slug, 'reverting to latest');
      return ASSET_HOST.CONTAINER.openfl.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl.VERSION + '&mticItemId=' + slug;
    }
  };

  var determineURLForCycle4Html = function determineURLForCycle4Html(slug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[slug]) {
      var item_version = ITEM_VERSION_MAP[slug];
      return ASSET_HOST.CONTAINER.openfl_c4.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl_c4.VERSION + '&mticItemId=' + slug + '&mticItemVersion=' + item_version;
    } else if (itemVersion) {
      // $log.log('[[determineURLForopenfl_c4]]','Using fed-in itemVersion', slug, ', ', itemVersion);
      return ASSET_HOST.CONTAINER.openfl_c4.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl_c4.VERSION + '&mticItemId=' + slug + '&mticItemVersion=' + itemVersion;
    } else {
      $log.warn('Missing item version for', slug, 'reverting to latest');
      return ASSET_HOST.CONTAINER.openfl_c4.URL + "?versionId=" + ASSET_HOST.CONTAINER.openfl_c4.VERSION + '&mticItemId=' + slug;
    }
  };

  /**
  * Determine the url for cycle4 items
  * @param  {String} slug
  * @return {String}
  */
  var determineURLForCycle4 = function determineURLForCycle4(slug, content) {
    var item_type = content.openfl ? 'mathematic_maker' : 'activity';
    return ASSET_HOST.CONTAINER.c4swf.URL + '?versionId=' + ASSET_HOST.CONTAINER.c4swf.VERSION;
  };

  /**
  * Determine the url for an inbook package
  * @param  {String} repo
  * @param  {String} cloudfrontVersion
  * @return {String}
  */
  var determineURLForInbook = function determineURLForInbook(repo, cloudfrontVersion) {
    var URL = ASSET_HOST.CONTAINER.inbook_package.URL + '?versionId=' + ASSET_HOST.CONTAINER.inbook_package.VERSION + '&host=cloudfront' + '&repo=' + repo + '&repoVersion=';
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[repo]) {
      return URL + ITEM_VERSION_MAP[repo];
    } else {
      return URL + cloudfrontVersion;
    }
  };

  /**
  * Determine the url for an itematic package
  * @param  {String} slug
  * @param  {String} version
  * @param  {String} type
  * @param  {String} key
  * @return {String}
  */
  var determineURLForItematic = function determineURLForItematic(slug, groupId, groupItemId, itemVersionId) {
    return 'itematic://' + ['slug', slug, 'groupId', groupId, 'groupItemId', groupItemId, 'itemVersionId', itemVersionId].join('/');
  };

  /**
  * Determine the url for a custom link
  * @return {String}
  */
  var determineURLForLink = function determineURLForLink(content) {
    var URL = '';
    var currentProtocol = window.location.protocol;
    $log.debug('[[StudentDataService]] determineURLForLink', content);
    if ('value' in content) {
      URL = content.value.replace(/^(http|https):/i, currentProtocol);
    } else {
      URL = currentProtocol + '//aotw-pd.s3.amazonaws.com/media-vimeo/70533052.jpg';
    }
    $log.debug('[[StudentDataService]] determineURLForLink', content, URL);
    return URL;
  };

  /**
  * Determine URL path for HTML package
  * @param  {String} itemSlug
  * @param  {String} itemVersion
  * @return {String}
  */
  var determineURLForHTMLPackage = function determineURLForHTMLPackage(itemSlug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[itemSlug]) {
      return ASSET_HOST.CONTAINER.html_package.URL + '/' + itemSlug + '/' + ITEM_VERSION_MAP[itemSlug] + '/index.html';
    } else {
      return ASSET_HOST.CONTAINER.html_package.URL + '/' + itemSlug + '/' + itemVersion + '/index.html';
    }
  };
  /**
  * Determine host url for the resource
  * @param  {Object} resourceInfo
  * @return {String}
  */
  var items_use_openflc4 = []; //[515, 517, 518]
  var determineHostUrl = function determineHostUrl(resourceInfo) {
    var resourceHostUrl;
    var remoteName = resourceInfo.content.name || resourceInfo.slug;
    if (items_use_openflc4.indexOf(resourceInfo.id) > -1) {
      resourceInfo.content.container = 'openfl_c4';
    }
    var triggerDebug = DEV_VARIABLES.LOGGING_OVERRIDE.RESOURCE;
    // $log.debug(determineURLForOpenFl(remoteName, resourceInfo.content.version) + ( triggerDebug ?  '&debug=true' : ''));
    switch (resourceInfo.content.container) {
      case 'openfl':
        return determineURLForOpenFl(remoteName, resourceInfo.content.version) + (triggerDebug ? '&debug=true' : '');
      case 'c4swf':
        return determineURLForCycle4(remoteName, resourceInfo.content);
      case 'html_package':
        return determineURLForHTMLPackage(remoteName, resourceInfo.content.version);
      case 'inbook_package':
        return determineURLForInbook(remoteName, resourceInfo.content.version);
      case 'itematic_package':
        return determineURLForItematic(remoteName, resourceInfo.content.itematicGroupId, resourceInfo.content.itematicGroupItemId, resourceInfo.content.itemVersionId);
      case 'openfl_c4':
        return determineURLForCycle4Html(remoteName, resourceInfo.content);
      case 'module':
        return null;
      case 'link':
        return determineURLForLink(resourceInfo.content);
      default:
        return determineURLForOpenFl(remoteName, resourceInfo.content.version || null) + (triggerDebug ? '&debug=true' : '');
      // $log.warn('No container type for', resourceInfo.slug, 'using openfl as default.')
    }
  };

  /**
  * Compute locks and completions from module map and work.
  * This will also set the hostUrl variable
  * @param  {Array<StudentWork>} studentWorks
  * @param  {Array<Resource>} moduleResources
  * @return {Array<ResourceWithWork>}
  */
  var computeResourceStatusForStudentWork = function computeResourceStatusForStudentWork(studentWorks, moduleResources, skip_determination_step) {
    $log.debug('[[StudentDataService]] computeResourceStatusForStudentWork', studentWorks, moduleResources, skip_determination_step);
    /**
    * Determines if a resource is complete.
    * This will set the `complete` flag on a resource
    * @param  {ModuleResource} resource
    * @return {Null}
    */
    var determineIfComplete = function determineIfComplete(resource) {
      if (!skip_determination_step) {
        var workBatch = studentWorks.filter(function (studentWork) {
          return studentWork.WorkBatch.resource_id === resource.id;
        });
        resource.hostUrl = determineHostUrl(resource);
        resource.content.hostUrl = resource.hostUrl;
        if (workBatch.length > 0) {
          resource.resourceState = {};
          resource.resourceState.completions = 0;
          resource.resourceState.complete = false;
          resource.resourceState.score_max = 0;
          workBatch.forEach(function (batch) {
            if (!batch.WorkBatch.StudentResourceState) {
              batch.WorkBatch.StudentResourceState = { completions: 0, complete: false, score_max: 0 };
            }
            resource.complete = resource.complete || batch.WorkBatch.StudentResourceState.completions > 0;
            resource.resourceState.completions += batch.WorkBatch.StudentResourceState.completions;
            resource.resourceState.complete = resource.resourceState.complete || batch.WorkBatch.StudentResourceState.complete;
            resource.resourceState.score_max = Math.max(resource.resourceState.score_max, batch.WorkBatch.StudentResourceState.score_max);
          });
        } else {
          resource.complete = false;
        }
      }
    };

    if (moduleResources.length > 0 && moduleResources[0].slug.indexOf('ocmt_hse') > -1) {
      //This orders resources based on their unlock_by ordering, which is needed for cutoff scoring implementation in ocmt
      //techincally running for everything should make no difference, but just to be safe filtered for ocmt_hse items
      moduleResources = moduleResources.sort(function (b, a) {
        if (a.unlocked_by && a.unlocked_by.length > 0 && a.unlocked_by.indexOf(b.slug) > -1) {
          return -1;
        } else {
          return 0;
        }
      });
    }

    /**
    * Array<ResourceWithWork>
    */
    return moduleResources.map(function (resource) {
      switch (resource.resource_type) {
        case 'sub_module':
          //Depreacted, Use 'module' instead. Only here for backwards compatibilty (once we get to LIVE, it will be removed)
          resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
          break;
        case 'module':
          resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
          break;
        case 'resource_module':
          resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
          break;
        case 'lesson_module':
          //Depreacted, Use 'resource_module' instead. Only here for backwards compatibilty (once we get to LIVE, it will be removed)
          resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
          break;
        case 'symlink':
          break;
        // case 'assessment': //do same as lesson
        //       $log.debug('Processing', resource.slug, 'as assessment')
        // case 'lesson': //do same as default
        //       $log.debug('Processing', resource.slug, 'as lesson')
        default:
          // Do this for assessments and lessons, i.e. "leafs"
          if (!resource.workBatch) {
            determineIfComplete(resource);
          }

          resource.locked = resource.unlocked_by.filter(function (requiredResourceSlug) {
            var requiredResource = moduleResources.filter(function (someResourceFromMap) {
              return someResourceFromMap.slug === requiredResourceSlug;
            });
            // $log.log('moduleResources: ' , resource.slug, resource.unlocked_by, requiredResource)
            if (requiredResource.length === 0) {
              $log.warn('resource.unlocked_by', resource.unlocked_by);
              //throw 'Could not find required, ' + requiredResourceSlug + ', resource for ' + resource.slug;
            } else if (requiredResource.length > 1) {
              $log.warn('Found too many required, ' + requiredResourceSlug + ', resource for ' + resource.slug);
              throw 'Found too many required, ' + requiredResourceSlug + ', resource for ' + resource.slug;
            } else {
              requiredResource = requiredResource[0];

              if (!requiredResource.resourceState) {
                determineIfComplete(requiredResource);
              }

              // if(requiredResource.config.unlock_score){
              //   var unlockResource = requiredResource;
              //   if(resource.config.unlock_by_score_slug){
              //     unlockResource = moduleResources.filter(function (someResourceFromMap) {
              //       return someResourceFromMap.slug === resource.config.unlock_by_score_slug
              //     })
              //     unlockResource = unlockResource.length > 0 ? unlockResource[0] : requiredResource;
              //     if (!unlockResource.resourceState) {              
              //       determineIfComplete(unlockResource)
              //     }
              //   }

              //   if(unlockResource.resourceState){
              //     if(unlockResource.resourceState.score_max < unlockResource.config.unlock_score){
              //       return !requiredResource.complete;
              //     }else if(resource.config.assessment_type === 'summative'){
              //       return resource.complete;
              //     }
              //     resource.resourceState = {};
              //     resource.resourceState.completions = Math.max(1, resource.resourceState.completions || 0);
              //     resource.resourceState.complete = true;
              //     resource.resourceState.score_max = 1;
              //     resource.complete = true;
              //     return false;
              //   }
              // }

              if (requiredResource.resource_type && requiredResource.resource_type === "assessment") {
                return !requiredResource.complete;
              }

              if (requiredResource.display && requiredResource.display.color === 'blue') {
                return !requiredResource.complete;
              }
              if (requiredResource.slug.indexOf('run_like_math') > -1) {
                return requiredResource.resourceState ? requiredResource.resourceState.score_max === 0 || !requiredResource.complete : true;
              }
              return requiredResource.resourceState ? requiredResource.resourceState.score_max < 0.8 : true; //!requiredResource.complete
            }
          });
          resource.locked = resource.locked.length > 0;
          break;
      }

      if (resource.resource_type === 'assessment') {
        if (resource.config.assessment_type === 'summative' || resource.config.assessment_type === 'formative') {
          resource.locked = resource.complete || resource.locked;
        } else {
          resource.locked = resource.complete;
        }
      } else if (resource.complete) {
        resource.locked = false;
      }

      /**
      * ResourceWithWork
      */
      return resource;
    });
  };

  /**
  * Gets the work in a module a student
  * @param  {Module} moduleResource
  * @return {Promise<ModuleWithWork>}
  */
  var getStudentWorkForModule = function getStudentWorkForModule(moduleResource) {
    if (!moduleResource) {
      $log.debug("trying to getStudentWorkForModule, but no module resource found");
      return $q.when(null);
    }
    return api.getStudentModuleResourceState(moduleResource.module_id).then(function (studentWorks) {
      /**
      * ModuleWithWork
      * @param {String} module_id
      * @param {Array<ResourceWithWork>} resources
      */
      return {
        hostUrl: moduleResource.Resource.content ? determineHostUrl(moduleResource.Resource) : null,
        resource_slug: moduleResource.Resource.slug,
        module_id: moduleResource.module_id,
        resources: computeResourceStatusForStudentWork(studentWorks, moduleResource.Resource.children)
      };
    });
  };

  /**
  * Get the student map and pull the work
  * @param {Boolean}  refresh fresh pull
  * @return {Promise<Map<String,ModuleWithWork>>}
  */
  var getStudentMaps = function getStudentMaps(refresh) {
    if (Object.keys(studentModuleMaps).length === 0 || refresh) {
      return api.getClassModuleMaps().then(function (moduleMaps) {
        //   overrideC3itemMaps(moduleMaps); // this function was commented out, please see `determineURLForOpenFl` for the way we should overrides!
        return $q.all([// I made it so it always grabs the first module, sub_modules should assigned to the parent!
        getStudentWorkForModule(moduleMaps.Modules[0]).then(function (moduleWithWork) {
          studentModuleMaps = moduleWithWork;
          studentModuleMaps.meta_config = moduleMaps.Modules && moduleMaps.Modules.length > 0 ? moduleMaps.Modules[0].Resource.config : null;
          studentModuleMaps.content = moduleMaps.Modules && moduleMaps.Modules.length > 0 ? moduleMaps.Modules[0].Resource.content : null;
          return;
        })]);
      }).then(function (modules) {
        if (studentModuleMaps.module_id === 11) {
          studentModuleMaps = moduleMappingService.getC3Mapping(studentModuleMaps);
          _.each(studentModuleMaps.resources, function (submod) {
            submod.children = computeResourceStatusForStudentWork({}, submod.children, true);
          });
        }
        return studentModuleMaps;
      });
    } else {
      return $q(function (resolve) {
        resolve(studentModuleMaps);
      });
    }
  };

  // This is not how we do this, please see the `determineURLForOpenFl` function
  // It has a very clear way on how to override the versions!!!
  // var overrideC3itemMaps = function(pack){
  //     // var overrides = {
  //     //   "mtic_c3_m1_plane": "MRek3KGkF.Ue16dat72ivBhNL.pOSJZh",
  //     //   "mtic_c3_m1_airport": ".hkmR5hEXgfnDZckAYO3jby9Y127SYyO",
  //     //   "mtic_c3_m1_bus": "mD01c4prTZP2QBZJs3nBfqTKjX9eypgt",
  //     //   "mtic_c3_m1_monkey": "j84tgQOxBOBNN_7ceb3SR1u1vLM4CkzE",
  //     //   "mtic_c3_m1_flamingo": "U18F5ClpTJHrrtLJQ.5XxmmiuG_cDt9M"
  //     // }
  //     _.each(pack.Modules, function(module){
  //       $log.debug('overrideC3itemMaps', module, module.Resource.slug);
  //       if (module.Resource.slug == "mtic_c3_m1"){
  //         _.each(module.Resource.children, function(resource){
  //           if (resource.name){
  //             resource.name = resource.name.split(' ')[0];
  //           }
  //           if (resource.slug == 'mtic_c3_m1_plane'){
  //             $log.debug(resource.slug, resource.content.version)
  //           }
  //         })
  //       }
  //     })
  //   }
  /**
  * Generates a module with work
  * @param  {StudentWork} studentWorks
  * @param  {ModuleResource} moduleResource
  * @return {ModuleWithWork}
  */
  var genModuleWIthWork = function genModuleWIthWork(studentWorks, moduleResource, user_id) {
    /**
    * ModuleWithWork
    * @param {String} module_id
    * @param {String} hostUrl
    * @param {String} resource_slug
    * @param {Array<ResourceWithWork>} resources
    */
    return {
      class_id: moduleResource.GroupModule.group_id,
      hostUrl: moduleResource.Resource.content ? determineHostUrl(moduleResource.Resource) : null,
      resource_slug: moduleResource.Resource.slug,
      module_id: moduleResource.module_id,
      resources: computeResourceStatusForStudentWork(studentWorks, moduleResource.Resource.children),
      meta_config: moduleResource.Resource.config,
      content: moduleResource.Resource.content
    };
  };
  StudentDataService.genModuleWIthWork = genModuleWIthWork;
  return StudentDataService;
});
'use strict';

angular.module('mtic').service('SessionDataService', function (EventManager) {
  var eventManager = new EventManager('SessionDataService');
  var c4DiagPrompted = false;

  // Public Methods
  var SessionDataService = {
    resetSessionVars: function resetSessionVars() {
      c4DiagPrompted = false;
    },
    hasShownC4DiagPrompt: function hasShownC4DiagPrompt() {
      return c4DiagPrompted;
    },
    disableC4DiagPrompt: function disableC4DiagPrompt() {
      c4DiagPrompted = true;
    }

    /**
    * Listens to logout event
    */
  };eventManager.listen('logout', function () {
    SessionDataService.resetSessionVars();
  });

  return SessionDataService;
});
'use strict';

angular.module('mtic').service('PlatformService', function ($cookies, $location, $log) {

  function generateQueryVarCache() {
    var splitQueryStr;
    var specialValues = {
      "f": false,
      "false": false,
      "null": null,
      "t": true,
      "true": true
    };
    splitQueryStr = window.location.search.substring(1).split('&');
    queryVarCache = splitQueryStr.reduce(function (cache, pairStr) {
      var pair = pairStr.split('=').map(decodeURIComponent);
      var name = pair[0];
      var value = pair[1];
      var numericValue;
      if (value === undefined) {
        // value is undefined, but the name was still included in the query
        // string, so assume truthy. (This behaviour accommodates some legacy
        // URLs that contain 'web-embed-connect' and should not be relied
        // upon in the future)
        value = true;
      } else if (specialValues[value.toLowerCase()] !== undefined) {
        value = specialValues[value.toLowerCase()];
      } else if (value.split('.').length < 3 && !isNaN(numericValue = parseFloat(value))) {
        value = numericValue;
      }
      if (cache[name] !== undefined) {
        $log.warn('query string variable "' + name + '" declared more than once!');
      }
      cache[name] = value;
      return cache;
    }, { __srcString: window.location.search });
  }

  function getQueryVariable(variableName) {
    if (queryVarCache.__srcString !== window.location.search) {
      generateQueryVarCache();
    }
    return queryVarCache[variableName];
  }

  function isAndroid() {
    return !!navigator.userAgent.match(/Android/i);
  }

  function isAndroidEnabled() {
    if ($cookies.getObject('enableAndroid')) {
      return true;
    }

    if (getQueryVariable('enable-android')) {
      $cookies.putObject('enableAndroid', true);
      return true;
    }

    return false;
  }

  function isApp() {
    return (isAppAndroid() || isAppIos()) && !!window.parent.postMessage || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab;
  }

  function isAppAndroid() {
    return isAndroid() && (getQueryVariable('native-app') || /; wv\)/.test(navigator.userAgent));
  }

  function isAppIos() {
    return !isAppAndroid() && getQueryVariable('native-app');
  }

  function isIpad() {
    return (/iPad/.test(navigator.userAgent)
    );
  }

  function isIos() {
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 0
    );
  }

  var isMobile = function isMobile() {
    return isAndroid() || isIos() || isApp() || 320 <= window.outerWidth && window.outerWidth <= 736; /** NOTE: window.outerWidth part is dev-only, remove for production **/
  };

  function supportsBeforeUnloadMsg() {
    return !isApp();
  }

  var supportsFlash = function supportsFlash() {
    return true; //!isAndroid() && !isIos(); // this is false
  };

  function isPhonePortrait() {
    var el;
    return function () {
      el = el || document.querySelector('.phone-portrait'); // only accesses DOM once
      return window.getComputedStyle(el).display === 'block';
    };
  }

  var queryVarCache = {};
  var PlatformService = {
    getQueryVariable: getQueryVariable, // n.b. this one is a fn, not a fn call. This is not a mistake!
    isAndroid: isAndroid(),
    isAndroidEnabled: isAndroidEnabled(),
    isApp: isApp(),
    isIpad: isIpad(),
    isIos: isIos(),
    isMobile: isMobile(),
    isPhonePortrait: isPhonePortrait(), // unlike other fields, this is a function!
    supportsBeforeUnloadMsg: supportsBeforeUnloadMsg(),
    supportsFlash: supportsFlash()
  };

  return PlatformService;
});
// http://192.168.2.11:3000/index.html?enable-android=true&app-version=6.0.1&web-embed-connect=true&native-adal=true&duped=one&duped=two&native-app=true
'use strict';

angular.module('mtic').service('PanelFactory', function ($log, TeacherDataService, userAccount, language, EventManager, C4_ASSET_URL, GR78_ASSET_URL, $timeout, MapStateService, PlatformService, $rootScope) {
  var eventManager = new EventManager('panelFactory');
  var tab_options = null;
  var getTagsForClass = function getTagsForClass(classId) {
    var tags = TeacherDataService.getClassPanelConfig(classId);
    //  $log.log('[[tags]]', tags)
    return tags;
  };

  var prefixMatch = function prefixMatch(str, match) {
    return str.substr(0, match.length) === match;
  };

  var defaultPriorityOfViews = {
    'dashboard': 1,
    'studentsAddRemove': 2,
    'agenda': 3,
    'reports': 4,
    'workspace': 5,
    'modules': 6,
    'items': 7,
    'class-leaderboard': 8
  };

  var timed_out = false;
  function reset_timer() {
    timed_out = true;
    $timeout(function () {
      timed_out = false;
    }, 500);
  }

  eventManager.listen('request:tab:options', function () {
    eventManager.broadcast('response:tab:options', tab_options);
  });

  return {

    getItemImage: function getItemImage(item) {
      var itemsListed = {};
      if (item.display && item.display.images) {
        var arr = [];
        item.display.images.forEach(function (imgNum) {
          var imgStr = '' + imgNum;
          if (imgStr.length === 1) {
            imgStr = '000' + imgStr;
          }
          if (imgStr.length === 2) {
            imgStr = '00' + imgStr;
          }
          if (imgStr.length === 3) {
            imgStr = '0' + imgStr;
          }
          imgStr = 's' + imgStr;
          if (!itemsListed[imgStr]) {
            itemsListed[imgStr] = true;
            arr.push(imgStr);
          }
        });
        // $log.log('RETURNING : ', item.display.images)
        return arr;
      }
    },

    getModuleIconAssetUrl: function getModuleIconAssetUrl(filename, metaMod, parentId) {
      if (!filename) {
        return '';
      }
      var ext = '.png';
      var C3_ASSET_URL = 'assets/images/c3-meta/';
      var OCMT_ASSET_URL = 'assets/images/gr78/';

      // OCMT
      if (prefixMatch(filename, 'ocmt_hse')) {
        return OCMT_ASSET_URL + filename + ext;
      } else {
        if (prefixMatch(filename, 'mtic_c3') || metaMod && metaMod[0].slug === "mtic_c3_m_meta") {
          return C3_ASSET_URL + filename + ext;
        }
        if (prefixMatch(filename, 'mtic_gr78') || prefixMatch(filename, 'mtic_gr910')) {
          return GR78_ASSET_URL + filename + ext;
        }
        if (prefixMatch(filename, 'c4') || prefixMatch(filename, 'run_like_math')) {
          return C4_ASSET_URL + filename + ext;
        }
      }
    },

    setupScopedMenuForStudentPanel: function setupScopedMenuForStudentPanel(scope, classId) {
      //       var spliceModules = false;
      //       // var is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      //       // var is_android = navigator.userAgent.match(/Android/i);
      //       // var tabletCheck = is_ios || is_android;
      //       TeacherDataService.getModuleMap(classId).then( (data)=>{
      //         if(data.Modules[0].module_id === 28){
      // //          console.log('cycle 4 module panel, remove!')
      //           spliceModules = true;
      //         }

      var PanelFactory = this;
      getTagsForClass(classId).then(function (panelData) {
        // Temporary function to add Share-my-class tab to teacher dashboard, until it exists on firebase or somewhere
        var shareClassExists = false;
        var agendaPanelExists = false;
        var userData = userAccount.getData();
        var i = 0;

        var found = false;
        panelData.forEach(function (tag) {
          if (tag.id === 'agenda') {
            found = true;
          }
        });
        if (!found) {
          panelData.push({ id: 'agenda', name: 'Agenda' });
        }
        //panelData.push({id: 'class-leaderboard', name: 'Leaderboard'})


        panelData.forEach(function (panel) {
          i++;
        });

        var panelDataPrioritized = [];
        var panelDataNonPrioritized = [];
        panelData.forEach(function (panelTab) {
          if (defaultPriorityOfViews[panelTab.id]) {
            panelDataPrioritized[defaultPriorityOfViews[panelTab.id]] = panelTab;
          } else {
            panelDataNonPrioritized.push(panelTab);
          }
        });
        $log.debug('[[PanelFactory]] Reading > /class/`' + classId + '`/panelData/`', panelData, '`');

        PanelFactory.setupOrUpdateScopedMenu(scope, panelDataPrioritized.concat(panelDataNonPrioritized));
      });
      // })
    },
    setupOrUpdateScopedMenu: function setupOrUpdateScopedMenu(scope, options) {
      //      console.log('panel setupOrUpdateScopedMenu', options)
      if (scope.nav) {
        var selection = scope.nav.selection;
        this.setupScopedMenu(scope, options);
        if (scope.nav.isValid(selection)) {
          scope.nav.selection = selection;
        }
      } else {
        this.setupScopedMenu(scope, options);
      }
    },
    setupScopedMenu: function setupScopedMenu(scope, options) {
      // $log.log('panel setupScopedMenu', options)
      options = options.filter(function (opt) {
        return optionsBrandingFilter(opt) && !opt.disable;
      });
      if (!$rootScope.isOCMT) {
        var leaderBoard_i = -1;
        var documents_i = -1;
        options.forEach(function (opt, i) {
          if (opt.id === 'docs') {
            documents_i = i;
          }
          if (opt.id === 'class-leaderboard') {
            leaderBoard_i = i;
          }
        });
        if (leaderBoard_i === -1) {
          var injection_i = documents_i === -1 ? options.length - 1 : documents_i;
          options.splice(injection_i, 0, { id: 'class-leaderboard' });
        }
      }
      function optionsBrandingFilter(option) {
        var mticOnlyOptions = ['docs', 'share-class', 'class-leaderboard'];
        var include = true;
        if ($rootScope.isOCMT && mticOnlyOptions.indexOf(option.id) !== -1) {
          include = false;
        }
        return include;
      }
      // options.splice(1,0, {"id":"studentsAddRemove","name":"Add/Remove"}) // testing
      var optionsWhitelist = options.map(function (opt) {
        return opt.id;
      });
      // $log.debug('[[PanelFactory]] making scopedMenu from ', options)
      var nav = scope.nav = {

        selection: '',
        isValid: function isValid(id) {
          return options.filter(function (opt) {
            return opt.id === id;
          }).length > 0;
        },

        setSelection: function setSelection(optionSlug, agenda_resolve, options) {
          tab_options = options;
          // On phones, change selection only after sidebar width transition is over
          if (PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1) {
            // Register transitionend listener
            scope.els = scope.els || {};
            scope.els.sidebar = scope.els.sidebar || document.querySelector('.menu.side-menu');
            scope.els.sidebar.removeEventListener('transitionend', mOnSidebarTransitionEnd);
            scope.els.sidebar.addEventListener('transitionend', mOnSidebarTransitionEnd);
            $rootScope.sidebarExpanded = false;
            handleSelection();
          } else {
            // otherwise change selection immediately
            handleSelection();
          }

          // ontransitionend handler
          function mOnSidebarTransitionEnd(e) {
            if (e.srcElement === scope.els.sidebar && e.propertyName === 'width') {
              scope.els.sidebar.removeEventListener('transitionend', mOnSidebarTransitionEnd);
              handleSelection();
            }
          }

          function handleSelection() {
            if (optionSlug === nav.selection) {
              return;
            }

            if (optionsWhitelist && _.indexOf(optionsWhitelist, optionSlug) === -1) {
              $log.error('Nav option selected is not on whitelist'); // dont break
            }

            if (nav.selection === 'agenda' && !agenda_resolve) {
              eventManager.broadcast('request_agenda_change', optionSlug);
              return;
            }
            if (timed_out) {
              return;
            }
            if (nav.selection === 'modules') {
              eventManager.broadcast('module:close:resource');
            }
            reset_timer();
            language.resetAvilableOptions();
            if (optionSlug === nav.selection) {
              scope.nav.resetSelection();
            } else {
              nav.selection = optionSlug;
            }

            var slugText = optionSlug;
            if (optionSlug === "workspace") {
              slugText = "activity_log";
            }

            MapStateService.reset();
            eventManager.broadcast('teacher:change:tab', slugText);
          }
        },

        getSelection: function getSelection() {
          return nav.selection;
        },

        isSelection: function isSelection(optionSlug) {
          return nav.selection === optionSlug;
        },
        getAllSelections: function getAllSelections() {
          return options;
        },
        resetSelection: function resetSelection() {
          var temp = nav.selection;
          nav.selection = '';
          $timeout(function () {
            nav.selection = temp;
          }, 200);
        }
      };

      if (optionsWhitelist) {
        nav.selection = optionsWhitelist[0];
      }
    }
  };
});
'use strict';

angular.module('mtic').service('ModuleFilter', function (LocaleService, PlatformService) {

  var modules = {};
  var ModuleFilter = {};

  var availableOnBranch = function availableOnBranch(module) {
    // window.console.log('-----')
    if (module.content && module.content.lock_on) {
      for (var i = 0; i < module.content.lock_on.length; i++) {
        var currentLock = module.content.lock_on[i];
        if (LocaleService.checkUrlVersion(currentLock)) {
          modules[module.slug].availableOnBranch = false;
          return false;
        }
      }
    }
    modules[module.slug].availableOnBranch = true;

    return modules[module.slug].availableOnBranch;
  };

  var isNeedsFlashReported = false; // only do this once
  var reportNeedsFlash = function reportNeedsFlash() {
    if (!isNeedsFlashReported) {
      isNeedsFlashReported = true;
      window.alert('The Cycle 4 modules are not currently available on iPad/Android. They are under maintenance which will be completed in mid-September. In the interim, please use the lessons on a laptop or desktop computer.');
    }
  };

  var availableOnDevice = function availableOnDevice(module) {
    var isAvailable = PlatformService.supportsFlash || !(module.content && module.content.needs_flash);
    modules[module.slug].availableOnDevice = isAvailable;
    if (!isAvailable) {
      reportNeedsFlash();
    }
    return isAvailable;
  };

  ModuleFilter.checkAvailable = function (module) {
    if (!modules[module.slug]) {
      modules[module.slug] = {};
      availableOnBranch(module);
      availableOnDevice(module);
    }

    return modules[module.slug].availableOnBranch && modules[module.slug].availableOnDevice;
  };

  ModuleFilter.checkNotificationAvailable = function (notification_state) {
    if (notification_state && notification_state.hide_on) {
      for (var i = 0; i < notification_state.hide_on.length; i++) {
        var currentLock = notification_state.hide_on[i];
        if (LocaleService.checkUrlVersion(currentLock)) {
          return false;
        }
      }
    }
    return true;
  };

  return ModuleFilter;
});
'use strict';

/**
 * A store for login-sessions
 * Not using cookies anymore but local storage
 * @return {Obiect}
 */
angular.module('mtic').service('LoginCookie', function (EventManager) {
    var LOGIN_TOKEN_KEY = 'loginToken';
    var LOCAL_STORAGE = window.localStorage;
    var eventManager = new EventManager('LoginCookie');
    var loginSession = LOCAL_STORAGE.getItem(LOGIN_TOKEN_KEY);
    var sessionLoginTokens = loginSession ? JSON.parse(loginSession) : [];
    var currentSession = void 0;

    var updateLastItemLogin = function updateLastItemLogin(e, resource) {
        var slug = resource.slug || resource;
        var targetCookie = sessionLoginTokens.find(function (value) {
            return value === currentSession;
        });
        if (targetCookie) {
            targetCookie.lastItem = slug;
            saveLoginTokens();
        }
    };

    var registerLogin = function registerLogin(username, displayname, userid, sessionkey, firebaseToken, role) {
        var sessionObject = {
            username: username,
            displayname: displayname,
            userid: userid,
            sessionkey: sessionkey,
            firebaseToken: firebaseToken,
            role: role
        };
        currentSession = sessionObject;
        sessionLoginTokens.push(sessionObject);
        saveLoginTokens();
    };

    var saveLoginTokens = function saveLoginTokens() {
        LOCAL_STORAGE.setItem(LOGIN_TOKEN_KEY, JSON.stringify(sessionLoginTokens));
    };

    eventManager.listen('module:select:resource', updateLastItemLogin.bind(this));
    eventManager.listen('request-next-item', updateLastItemLogin.bind(this));
    var LoginCookie = {
        registerLogin: registerLogin,
        hasSessions: function hasSessions() {
            // // comment this back to enable
            return sessionLoginTokens.length > 0;
            // // disabling this at the moment
            // return false;
        },
        getSessionLoginTokens: function getSessionLoginTokens() {
            return angular.copy(sessionLoginTokens);
        },
        clearSessions: function clearSessions() {
            LOCAL_STORAGE.setItem(LOGIN_TOKEN_KEY, JSON.stringify([]));
            sessionLoginTokens.length = 0;
        },
        refreshCookieStore: function refreshCookieStore() {
            saveLoginTokens();
        }

        //To avoid issues while we are not using this!
        //LoginCookie.clearSessions()

    };return LoginCookie;
});
'use strict';

angular.module('mtic').service('LogReducer', function ($log, $q) {
      /**
       * LogReducer Class
       * @param {Array<UserRole>} userRoles
       * @param {Promise} getClassStudentsPromised
       */
      return function LogReducer(userRoles, userMapping, moduleResourceMapping) {
            /**
             * A generalized getter function
             * this is where we specify our filtering syntax
             * @param  {Object} obj
             * @return {Array}
             */
            var generalizedGetter = function generalizedGetter(obj) {
                  return function (params) {
                        if (params === '*' || !params) {
                              return _.map(obj);
                        } else if (params.by && params.by === 'children') {
                              return filterByChilds(obj, params.list);
                        } else {
                              $log.warn('Todo, allow custom filters');
                              throw "Not Possible";
                        }
                  };
            };
            var filterByChilds = function filterByChilds(obj, list) {
                  return _.filter(obj, function (row, id) {
                        var matchedAnds = _.filter(list, function (cond, key) {
                              return _.filter(cond, function (condOr) {
                                    return row[unpluralize(key)].id === condOr.id;
                              }).length > 0;
                        });
                        return matchedAnds.length >= _.map(list).length;
                  });
            };
            var unpluralize = function unpluralize(text) {
                  switch (text) {
                        case 'users':
                              return 'user';
                              break;
                        case 'resources':
                              return 'resource';
                              break;
                        default:
                              $log.warn('unpluralize function is really incomplete, returning ' + text);
                              return text;
                  }
            };
            /**
             * Classrooms Model
             */
            var classes = function Classes() {
                  var classes = {};
                  var upsertClass = function upsertClass(class_id) {
                        if (!classes[class_id]) {
                              classes[class_id] = {
                                    id: class_id,
                                    users: {}
                              };
                        }
                        return classes[class_id];
                  };
                  return {
                        insertUserToClass: function insertUserToClass(user, class_id) {
                              var _class = upsertClass(class_id);
                              _class.users[user.user_id] = user;
                              return _class;
                        },
                        get: generalizedGetter(classes)
                  };
            }();
            /**
             * Users Model
             */
            var users = function Users() {
                  var users = {};
                  var upsertUser = function upsertUser(user_id) {
                        if (!users[user_id]) {
                              users[user_id] = _.extend(userMapping[user_id], {
                                    id: user_id,
                                    resource_sessions: {},
                                    classes: {}
                              });
                        }
                        return users[user_id];
                  };
                  return {
                        insertSessionToUser: function insertSessionToUser(user_id, resourceSession) {
                              var _user = upsertUser(user_id);
                              resourceSession.user = _user;
                              _user.resource_sessions[resourceSession.id] = resourceSession;
                              return _user;
                        },
                        get: generalizedGetter(users)
                  };
            }();
            /**
             * Resources Model
             */
            var resources = function Resources() {
                  var resources = {};
                  var upsertResource = function upsertResource(resource_id) {
                        if (!resources[resource_id]) {
                              resources[resource_id] = _.extend(moduleResourceMapping[resource_id], {
                                    id: resource_id,
                                    resource_sessions: {},
                                    resources: resources
                              });
                        }
                        return resources[resource_id];
                  };
                  return {
                        insertSessionToResource: function insertSessionToResource(resource_id, resourceSession) {
                              var _resource = upsertResource(resource_id);
                              resourceSession.resource = _resource;
                              _resource.resource_sessions[resourceSession.id] = resourceSession;
                              return _resource;
                        },
                        get: generalizedGetter(resources)
                  };
            }();
            /**
             * Resource Sessions Model
             */
            var resourceSessions = function ResourceSessions() {
                  var resourceSessions = {};
                  var stagedResources = [];
                  var processSession = function processSession(superUniqueId) {
                        $q(function (resolve) {
                              if (resourceSessions[superUniqueId]) {
                                    var submitEvent;
                                    var completeEvent;
                                    var startEvent = resourceSessions[superUniqueId].eventLogs.filter(function (eventLog) {
                                          if (eventLog.event_name.split(':')[1] === 'score') {
                                                completeEvent = eventLog;
                                          } else if (eventLog.event_name.split(':')[1] === 'complete') {
                                                submitEvent = eventLog;
                                          }
                                          return eventLog.event_name.split(':')[1] === "RESOURCE_LOAD_COMPLETE";
                                    });
                                    if (startEvent.length === 0) {
                                          // delete invalid sessions
                                          delete resourceSessions[superUniqueId].resource.resource_sessions[superUniqueId];
                                          delete resourceSessions[superUniqueId].user.resource_sessions[superUniqueId];
                                          delete resourceSessions[superUniqueId];
                                          return resolve();
                                    }
                                    resourceSessions[superUniqueId].status.invalid = false;
                                    startEvent = startEvent[0];
                                    var endEvent = resourceSessions[superUniqueId].eventLogs.reduce(function (eventLogA, eventLogB) {
                                          return moment(eventLogA.time_stamp_local).isBefore(eventLogB.time_stamp_local) ? eventLogB : eventLogA;
                                    });
                                    resourceSessions[superUniqueId].time = {
                                          start: startEvent.time_stamp_local,
                                          end: endEvent.time_stamp_local,
                                          spent: moment(endEvent.time_stamp_local).diff(startEvent.time_stamp_local, 'm') // in minutes
                                    };
                                    if (submitEvent) {
                                          resourceSessions[superUniqueId].status.complete = true;
                                    }
                                    if (completeEvent) {
                                          resourceSessions[superUniqueId].status.hasScore = true;
                                          resourceSessions[superUniqueId].status.complete = true;
                                          var eventData = JSON.parse(completeEvent.event_data);
                                          resourceSessions[superUniqueId].score = eventData.score || 1; //since this variable was not here prior to 2017-05-25
                                    }
                              }
                              return resolve(resourceSessions[superUniqueId]);
                        });
                  };
                  var upsertSession = function upsertSession(user_id, class_id, session_id, resource_session_id, resource_id, eventLog) {
                        var superUniqueId = [class_id, user_id, session_id, resource_id, resource_session_id].join('/');
                        if (!resourceSessions[superUniqueId]) {
                              resourceSessions[superUniqueId] = {
                                    id: superUniqueId,
                                    class_id: class_id,
                                    session_id: session_id,
                                    resource_session_id: resource_session_id,
                                    user_id: user_id,
                                    eventLogs: [],
                                    status: {
                                          complete: false, //if it was complete
                                          invalid: true, // this would mean we could not process this event (maybe missing a start)
                                          hasScore: false // has a score
                                    },
                                    score: null,
                                    time: {}
                              };
                        }
                        resourceSessions[superUniqueId].eventLogs.push(eventLog);
                        stagedResources.push(superUniqueId);
                        return resourceSessions[superUniqueId];
                  };
                  return {
                        upsert: function upsert(user_id, class_id, session_id, resource_session_id, resource_id, row) {
                              var _resourceSession = upsertSession(user_id, class_id, session_id, resource_session_id, resource_id, row);
                              var _user = users.insertSessionToUser(user_id, _resourceSession);
                              var _resource = resources.insertSessionToResource(resource_id, _resourceSession);
                              _resourceSession.resource = _resource;
                              _resourceSession.class = _user.classes[class_id] = classes.insertUserToClass(_user, class_id);
                              _resourceSession.user = _user;
                              return _resourceSession;
                        },
                        bulkInsert: function bulkInsert(user_id, class_id, appEvents) {
                              var self = this;
                              return $q.all(appEvents.map(function (appEvent) {
                                    return $q(function (resolve) {
                                          resolve(self.upsert(user_id, class_id, appEvent.session_id, appEvent.resource_session_id, appEvent.resource_id, appEvent));
                                    });
                              })).then(function () {
                                    return $q.all(stagedResources.map(processSession));
                              }).then(function () {
                                    return resourceSessions;
                              });
                        },
                        get: generalizedGetter(resourceSessions)
                  };
            }();

            /**
             * Main Looper
             * @param  {UserRole} userRole
             * @return {Array<resourceSessions>}
             */
            var groupAppEventsFromUserRole = function groupAppEventsFromUserRole(userRole) {
                  var user_id = userRole.user_id;
                  var class_id = userRole.group_id;
                  return resourceSessions.bulkInsert(user_id, class_id, userRole.User.AppEvents);
            };
            /**
             * Flags
             */
            var done = false;
            var processing = false;
            var awaitingProcesses = [];
            /**
             * Init function
             * @return {Promise}
             */
            var init = function init() {
                  processing = true;
                  return $q.all(userRoles.map(groupAppEventsFromUserRole)).then(function () {
                        done = true;
                        awaitingProcesses.map(function (next) {
                              next();
                        });
                  });
            };
            init();
            /**
             * Main Output of this class
             * @param  {String} model      classes|users|resourceSessions
             * @param  {String|Object} conditions
             * @return {Promise<Array>}
             */
            var getData = function getData(model, conditions) {
                  $log.debug('[[LogReducer]] -START GET', model, conditions);
                  if (!done) {
                        if (processing) {
                              return $q(function (resolve) {
                                    awaitingProcesses.push(resolve);
                              }).then(function () {
                                    return getData(model, conditions);
                              });
                        } else {
                              return init().then(function () {
                                    return getData(model, conditions);
                              });
                        }
                  } else {
                        $log.debug('[[LogReducer]] -PROCESSING GET', model, conditions);
                        return $q(function (resolve, reject) {
                              switch (model) {
                                    case 'users':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions);
                                          return resolve(users.get(conditions));
                                    case 'classes':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions);
                                          return resolve(classes.get(conditions));
                                    case 'resourceSessions':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions);
                                          return resolve(resourceSessions.get(conditions));
                                    case 'resources':
                                          $log.debug('[[LogReducer]] -DONE GET', model, conditions);
                                          return resolve(resources.get(conditions));
                                    default:
                                          $log.debug('[[LogReducer]] -FAILED GET', model, conditions);
                                          reject(new Error("Invalid model passed to `getAppLogs` " + model));
                              }
                        });
                  }
            };
            return getData;
      };
});
'use strict';

angular.module('mtic').service('LocaleService', function ($log, $location, $http, language, URL_VERSIONS, $timeout, PlatformService) {

  var LocaleService = {};

  // constants
  var availableLocales = ['LUXEMBOURG', 'PORTUGAL', 'CANADA/ONTARIO', 'CANADA/ONTARIO/TCDSB', 'CANADA/ONTARIO/BROCKU', 'INTERNATIONAL'];
  var domainMappingInverse = {
    LUXEMBOURG: ['www.mathematic.lu', 'mathematic.lu', 'mthmtclu.vretta.com', 'mthmtc.vretta.com', 'mthmtc-preview2.vretta.com', 'localhost'],
    INTERNATIONAL: ['DEFAULT']
  };
  var QcDomains = [
  // 'mthmtclu.vretta.com',
  // 'mthmtc.vretta.com',
  'preview', 'localhost', 'edge'];

  // state
  var currentLocale = null;
  var DEFAULT_DOMAIN = 'DEFAULT';
  var ipBasedCountry = null;
  var registered_observers = [];
  var setLuxThroughLocation = false;
  var currentUrlVersion = 'Live';
  var isIamUser = false;
  var loading;

  // globally accessible service props (avoid using this format)
  LocaleService.hasCompletedStudentQuest = false;
  LocaleService.hasCompletedStudentBase = false;
  LocaleService.hasTakenStudentCyclePrompt = false;
  LocaleService.is_c4_student = false;
  LocaleService.done_student_post_test = false;
  LocaleService.done_student_offboarding = false;
  LocaleService.idleInput = false;
  LocaleService.idleFocus = false;
  LocaleService.isAway = false;
  LocaleService.item_link_opened = false;

  // private service methods
  var initService = function initService() {
    checkIpStack();
  };
  var notifyObservers = function notifyObservers() {
    registered_observers.forEach(function (observer) {
      observer();
    });
  };
  var findLocaleSlugByDomain = function findLocaleSlugByDomain(matchToDomain) {
    var matchingLocaleSlug = null;
    _.each(domainMappingInverse, function (domainList, localeSlug) {
      _.each(domainList, function (domainName) {
        if (domainName === matchToDomain) {
          matchingLocaleSlug = localeSlug;
        }
      });
    });
    return matchingLocaleSlug;
  };
  var computeCurrentUrlVersion = function computeCurrentUrlVersion() {
    var currentDomainName = $location.host();
    var hrefName = window.location.href;
    if (_.find(QcDomains, function (el) {
      return hrefName.indexOf(el) > -1;
    })) {
      currentUrlVersion = URL_VERSIONS.Preview;
    }
    if (hrefName.indexOf('preview') !== -1) {
      currentUrlVersion = URL_VERSIONS.Preview;
    }
    if (hrefName.indexOf('pre-live') !== -1 || hrefName.indexOf('prelive2') !== -1) {
      currentUrlVersion = URL_VERSIONS.Prelive;
    }
    if (currentDomainName.indexOf('mathematic.lu') > -1 || currentDomainName.indexOf('mathematic.org') > -1) {
      currentUrlVersion = URL_VERSIONS.Live;
    }
  };
  var updateCurrentLocale = function updateCurrentLocale() {
    computeCurrentUrlVersion();

    var currentDomainName = $location.host();
    var hrefName = window.location.href;
    var matchingLocaleSlug = findLocaleSlugByDomain(currentDomainName);
    if (!matchingLocaleSlug) {
      matchingLocaleSlug = findLocaleSlugByDomain(DEFAULT_DOMAIN);
    }

    if (window.isWebEmbedConnect && !setLuxThroughLocation) {
      currentLocale = 'INTERNATIONAL';
    } else if (PlatformService.getQueryVariable('force-ocmt')) {
      currentLocale = 'INTERNATIONAL';
    } else if (PlatformService.getQueryVariable('force-international')) {
      currentLocale = 'INTERNATIONAL';
    } else if (!setLuxThroughLocation) {
      currentLocale = matchingLocaleSlug;
    } else {
      currentLocale = 'LUXEMBOURG';
    }
  };
  var checkIpStack = function checkIpStack() {
    loading = true;
    $http.get("https://api.ipstack.com/check?access_key=0019e468e33db16ccac92651d7887192").then(function (response) {
      $log.log('Location info: ', response.data);
      ipBasedCountry = response.data.country_code;
      if (response.data.country_code === 'LU') {
        currentLocale = 'LUXEMBOURG';
        setLuxThroughLocation = true;
      } else if (response.data.country_code === 'PT') {
        language.set('pt', true);
      }
      notifyObservers();
      loading = false;
    }).catch(function (err) {
      loading = false;
    });
  };

  // public service methods
  LocaleService.registerObserver = function (observer) {
    registered_observers.push(observer);
  };
  LocaleService.checkUrlVersion = function (urlVersion) {
    return currentUrlVersion === urlVersion;
  };
  LocaleService.getIpBasedCountry = function () {
    return ipBasedCountry;
  };
  LocaleService.getAvailableLocales = function () {
    return availableLocales;
  };
  LocaleService.setCurrentLocale = function (val) {
    currentLocale = val;
  };
  LocaleService.computeCurrentUrlVersion = function () {
    computeCurrentUrlVersion();
  };
  LocaleService.getCurrentLocale = function () {
    if (loading) {
      return null;
    }
    if (currentLocale === null) {
      updateCurrentLocale();
    }
    return currentLocale;
  };
  LocaleService.getUrlVersion = function () {
    return currentUrlVersion;
  };
  LocaleService.isCurrentLocale = function (localeSlug) {
    return localeSlug === LocaleService.getCurrentLocale();
  };
  LocaleService.setAsIamUser = function () {
    isIamUser = true;
  };
  LocaleService.getIfIamUser = function () {
    return isIamUser;
  };

  // init
  initService();

  return LocaleService;
});
'use strict';

angular.module('mtic').service('LearningEnvironmentService', function () {
    return {
        givePostItemQuestionnaire: function givePostItemQuestionnaire(moduleId, slug) {
            if ((moduleId === 1 || moduleId === 11) && slug.indexOf('run_like_math') === -1) {
                return true;
            } else {
                return false;
            }
        }
    };
});
'use strict';

/* globals AuthenticationContext */

angular.module('mtic').service('IAMManager', function (IAM_CONFIGURATION, $log, $q, cordovaMessenger, PlatformService, EventManager) {

  var eventManager = new EventManager('IAMManager');
  this.getSavedUrlParamsForToken = function () {
    return adalAuthContext._getItem('url_params') || '';
  };

  this.clearSavedUrlParamsForToken = function () {
    adalAuthContext._saveItem('url_params', '');
  };

  /**
   * Attempt to login through ADAL / IAM
   * @return {Promise<{profile}>}
   */
  this.login = function () {
    return $q(function (resolve, reject) {
      var user = adalAuthContext.getCachedUser();
      if (user) {
        resolve(user);
        return;
      }
      if (PlatformService.isApp && PlatformService.isIos) {
        adalAuthContext.popUp = false;
      } else {
        adalAuthContext.popUp = true;
      }
      adalAuthContext.callback = function (err) {
        if (err) {
          $log.error(err);
          reject(err);
        } else {
          resolve(adalAuthContext.getCachedUser());
        }
      };
      adalAuthContext._saveItem('url_params', window.location);
      adalAuthContext.login();
    });
  };

  /**
   * Logout from all techniques
   * @return {Promise<Boolean>}
   */
  this.logout = function () {
    var logOutSuccess = false;
    if (adalAuthContext.getCachedUser()) {
      adalAuthContext.logOut();
      logOutSuccess = true;
    }
    adalAuthContext.clearCache();
    adalAuthContext.clearCacheForResource();
    return $q.resolve(logOutSuccess);
  };

  var adalAuthContext = new AuthenticationContext(IAM_CONFIGURATION.microsoft);
  var nativeAppFunctions = {
    clearSavedUrlParamsForToken: function clearSavedUrlParamsForToken() {},
    getSavedUrlParamsForToken: function getSavedUrlParamsForToken() {
      return '';
    },
    login: function login() {
      // eventManager.broadcast('start-login-attempt');
      return cordovaMessenger.requestResponse('requestNativeAdalLogin');
    },
    logout: function logout() {
      return cordovaMessenger.requestResponse('requestNativeAdalLogout');
    }
  };

  _.forOwn(this, function (value, key) {
    if (!nativeAppFunctions.hasOwnProperty(key)) {
      $log.error('property "' + key + '" exists on the default IAMManager object, but not on the nativeAppFunctions');
    }
  });
  var thiz = this;
  _.forOwn(nativeAppFunctions, function (value, key) {
    if (!thiz.hasOwnProperty(key)) {
      $log.error('property "' + key + '" exists on the nativeAppFunctions, but not on default IAMManager object');
    }
  });
  if (PlatformService.isApp) {
    _.assignIn(this, nativeAppFunctions);
  }
});
'use strict';

angular.module('mtic').service('GenericPopup', function ($log, $compile, $rootScope, $timeout) {
  var instance = null;
  var template = '<div class="generic-popup-container">\n      <div class="mticCard">\n        <div class="mticCard__header">\n          <span class="mticCard__headerText" ng-cloak>{{headerText}}</span>\n          <span class="mticCard__close" ng-click="close()">\n          <span class="char-icon">&#10006;</span>\n          <i class="fa fa-times-circle" aria-hidden="true"></i>\n        </span>\n        </div>\n        <div class="mticCard__body">\n          <span class="mticCard__genericMessage" ng-cloak>{{messageText}}</span>\n          <a class="button mticCard__button" ng-click="close()">Close</a>\n        </div>\n      </div>\n    </div>';

  function open(header, message) {
    instance = angular.element(template)[0];
    $compile(instance)(Object.assign($rootScope.$new(true), {
      headerText: header,
      messageText: message,
      close: close
    }));
    $timeout(function () {
      document.body.append(instance);
    });
  }
  function close() {
    if (instance) {
      instance.remove();
    }
  }

  return {
    open: open,
    close: close
  };
});
'use strict';

angular.module('mtic').service('flashPermission', function ($log) {

    // Public Methods
    var flashPermission = {

        getPermission: function getPermission() {
            return;
            function requestFlashPermission() {
                //window.onbeforeunload = null;
                // console.log('asking');
                var iframe = document.createElement('iframe');
                iframe.src = 'https://get.adobe.com/flashplayer';
                iframe.sandbox = '';
                document.body.appendChild(iframe);
                document.body.removeChild(iframe);
                window.removeEventListener('click', requestFlashPermission);
            }

            var isNewEdge = (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
            var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
            var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 && !/Mobile/i.test(navigator.userAgent);
            var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;

            if (canRequestPermission) {
                requestFlashPermission();
                window.addEventListener('click', requestFlashPermission);
            }
        }
    };

    return flashPermission;
});
'use strict';

angular.module('mtic').service('FirebaseItematic', function (GLOBAL_API_CONFIG, $firebaseArray, $firebaseObject, $log) {
  var fbItematicApp;
  var getItemUrl;
  var syncCache = {};
  var storeItemUrlCache = function storeItemUrlCache(groupId, groupItemId, releaseTag, url) {
    syncCache[[groupId, groupItemId, releaseTag].join('/')] = url;
  };
  var getItemUrlCache = function getItemUrlCache(groupId, groupItemId, releaseTag) {
    return syncCache[[groupId, groupItemId, releaseTag].join('/')];
  };

  //Init Firebase
  if (!GLOBAL_API_CONFIG.ITEMATIC.FIREBASE) {
    $log.warn("<<<<<<<<< Missing Firebase Configuration Data >>>>>>>>>");
  } else {
    fbItematicApp = firebase.initializeApp(GLOBAL_API_CONFIG.ITEMATIC.FIREBASE, String(Math.random().toString(36).substr(2, 10) + Date.now()));
    var pathjoin = function pathjoin(arr) {
      return '/' + arr.join('/') + '/';
    };
    var getOnce = function getOnce(pathArr) {
      var path = pathjoin(pathArr);
      return fbItematicApp.database().ref(path).once('value');
    };
    getItemUrl = function getItemUrl(groupId, groupItemId, releaseTag, cb) {
      var errorUrl = GLOBAL_API_CONFIG.ITEMATIC.itemLoadErrorUrl;
      return getOnce(['groups', groupId, 'itemReleases', groupItemId, 'taggedReleases', releaseTag]).catch(function (e) {
        $log.warn('could not load item release data');
        cb(errorUrl);
      }).then(function (data) {
        try {
          var itemReleaseId = data.val();
          getOnce(['groups', groupId, 'itemReleases', groupItemId, 'releases', itemReleaseId]).then(function (data) {
            var itemReleaseData = data.val();
            var release = itemReleaseData;
            if (!release) {
              throw new Error();
            }
            var engineBaseURL = GLOBAL_API_CONFIG.ITEMATIC.engineBaseURL;
            var engineVersion = release.engineVersion;
            var rootComponent = release.rootComponent;
            var itemVersionId = release.itemVersionId;
            var url = engineBaseURL + '/v' + engineVersion + '/' + rootComponent + '/index.html#!/' + rootComponent + '/' + itemVersionId;
            storeItemUrlCache(groupId, groupItemId, releaseTag, url);
            cb(url);
          }).catch(function (e) {
            $log.warn('could not find matching item release');
            cb(errorUrl);
          });
        } catch (e) {
          $log.warn('no item release data is defined in Itematic', groupId, groupItemId, releaseTag);
          cb(errorUrl);
        }
        // return data;
      });
    };
    // setTimeout(function(){
    //   getItemUrl('LUX_GR78', '-KwaizxHR_Jw56Cnm7Nn', GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.QC, function(url){
    //     console.log('ITEM URL:', url);
    //   });
    // }, 1000)
  }
  return {
    getItemUrl: getItemUrl,
    getReleaseTagByQcStatus: function getReleaseTagByQcStatus(options) {
      if (options) {
        if (options.isQC) {
          return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.QC;
        }
        if (options.isPrelive) {
          return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.PRELIVE;
        }
      }
      return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.LIVE;
    }
  };
});
'use strict';

angular.module('mtic').service('Firebase', function (GLOBAL_API_CONFIG, $firebaseArray, $firebaseObject, $log) {
  var fbApp;
  //Init Firebase
  if (!GLOBAL_API_CONFIG.FIREBASE) {
    $log.warn("<<<<<<<<< Missing Firebase Configuration Data >>>>>>>>>");
  } else {
    fbApp = firebase.initializeApp(GLOBAL_API_CONFIG.FIREBASE, String(Math.random().toString(36).substr(2, 10) + Date.now()));
  }
  return {
    database: function database() {
      return firebase.database(fbApp);
    },
    auth: function auth() {
      return firebase.auth(fbApp);
    },
    /**
      * Generate a 3-way bound array from firebase
      * @param  {Array<String>}
      * @param  {Object}
      * @return {$firebaseArray}
      */
    to3wBoundArray: function to3wBoundArray(refPath, options) {
      if (!options) {
        options = {};
      }
      var ref = this.database().ref(refPath.join('/'));
      _.forEach(options, function (val, name) {
        ref = ref[name](val);
      });
      return $firebaseArray(ref);
    },
    /**
     * Generate a 3-way bound object from firebase
     * @param  {Array<String>}
     * @param  {Object}
     * @return {$firebaseArray}
     */
    to3wBoundObject: function to3wBoundObject(refPath, options) {
      if (!options) {
        options = {};
      }
      var ref = this.database().ref(refPath.join('/'));
      _.forEach(options, function (val, name) {
        ref = ref[name](val);
      });
      return $firebaseObject(ref);
    }
  };
});
'use strict';

/*global XMLHttpRequest*/
angular.module('mtic').service('EventManager', function ($rootScope, $log, $http, $window, API_CONFIG, API_ROUTES, $cookies, $timeout) {

      if (window.location.href.indexOf('DEBUG_TOUCH') > -1) {
            window.DEBUG_TOUCH = true;
      }

      $rootScope.eventManagerName = $window.location.hostname;
      /**
       * Broadcast a message from rootScope
       * @param  {String} eventName
       * @param  {Object} eventData
       * @return {angular.$broadcast}
       */
      var broadCast = function broadCast(eventName, eventData) {
            return $rootScope.$broadcast(eventName, eventData);
      };
      /**
       * Generates a random string
       * @return {String}
       */
      var genRandomHash = function genRandomHash() {
            return Math.random().toString(36).substr(3, 10) + Date.now();
      };
      /**
       * Gets the closets parent instanceName and appends to it the componentType
       * @param  {angular.scope} scope
       * @param  {String} componentType
       * @return {String}
       */
      var computeInstanceName = function computeInstanceName(scope, componentType) {
            var instanceName;
            if (scope.$parent) {
                  if (scope.$parent.eventManagerName) {
                        instanceName = scope.$parent.eventManagerName;
                  } else {
                        instanceName = computeInstanceName(scope.$parent);
                  }
                  instanceName = instanceName + (componentType ? '/' + componentType : '');
                  return instanceName;
            } else {
                  return componentType;
            }
      };

      /**
       * Checks that the object has a key and its not null
       * @param  {Object}
       * @param  {String}
       * @return {Boolean}
       */
      var hasValue = function hasValue(obj, value) {
            return Object.keys(obj).indexOf(value) > -1 && obj[value] !== null;
      };
      /**
       * UserInfo
       * this information is generated by the user interacting with our system
       * @type {Object}
       */
      var userInfo = {
            userId: null, //the userId, set at a login event
            sessionId: genRandomHash(), //generated by the user opening the browser
            resource: {
                  id: null, //set when an activity is started
                  slug: null, //set when an activity is started
                  sessionId: null //generated locally when an activity is started
            },
            headers: {} //is set on login

            /**
             * Device Info
             * this information is extracted straight from the user's device
             * @type {Object}
             */
      };var deviceInfo = {
            browser: navigator.userAgent, //the browser's userAgent
            platform: navigator.platform, //the operating system
            language: { //the device's language features
                  selected: navigator.language, //their selected language (on their device)
                  options: navigator.languages //the languages that they are able to use
            }
            /**
             * Application Information
             * this information is use to describe the application
             * @type {Object}
             */
      };var appInfo = {
            version: 'v7.43.29-rc.110', //the version of the app, this is set from the package.json file (and is extracted a few lines below)
            location: location.href, //the url from which they are using the applicaiton
            host: location.hostname, //the hostname that this app is at
            // language: $cookies.get('bar_language') || 'fr'//the language that they selected IN the application
            language: 'fr' //the language that they selected IN the application

            // ga('set', 'appName', appInfo.location);
            // ga('set', 'appVersion', appInfo.version);
      };var allowedEvents = ['login:fail', 'login:first', "login:login_as", 'login:session:clear', 'browser:tab:beforeunload:warning', 'browser:tab:beforeunload:cancelled', 'app:open', 'language:change',
      //'student:module:open',
      //'teacher:module:open',
      'module:open:resource', 'mticResource:RESOURCE_LOAD_COMPLETE',
      //'mticResource:RESOURCE_LOAD_FAILED',
      'resource:score:submitted', 'module:close:resource',
      // 'COMPONENT_LOG',
      'C4_BASELINE_LOG', 'log:language:options', 'user:InactiveForThirtyMinutes',
      // 'user:inactiveForOneMinutePing',
      // 'user:idleStart60s',
      // 'user:idleStart300s',
      // 'user:idle_end',
      'language:init', 'mouse:keyboard:active:first', 'mouse:keyboard:active', 'idle:inputs:start', 'focusout:start', 'idle:inputs:end', 'focusout:end', 'language:change:automatic', 'language:change:manual', 'module:change:submodule', 'module:change:meta', 'teacher:change:tab', 'user:view:notification', 'user:dismiss:notification', 'user:chat', 'teacher:download:pdf', 'teacher:download:instructions', 'teacher:select', 'teacher:select:dropdown', 'set:lesson:options', 'logout:manual'];
      var reportToOurApi = function reportToOurApi(eventName, eventData, instanceName, is_forced) {
            var temp_before_clear = angular.copy(userInfo);
            var timer = 0;
            if (eventName === 'module:open:resource') {
                  timer = 200;
                  temp_before_clear = userInfo;
            } else if ((eventName === 'mouse:keyboard:active' || eventName === 'idle:inputs:start' || eventName === 'focusout:start' || eventName === 'idle:inputs:end' || eventName === 'focusout:end') && !userInfo.userId) {
                  return;
            }
            $timeout(function () {
                  if ((eventName === 'module:open:resource' || eventName === 'module:close:resource') && (!temp_before_clear.resource.slug || !temp_before_clear.resource.id) && eventData && eventData.slug && eventData.id) {
                        userInfo.resource.slug = eventData.slug;
                        userInfo.resource.id = eventData.id;
                        if (eventName === 'module:open:resource') {
                              userInfo.resource.sessionId = genRandomHash();
                        }
                        temp_before_clear = userInfo;
                  }
                  var CONFIG = API_CONFIG;
                  if (API_CONFIG.MTIC_REPORTING) {
                        CONFIG = API_CONFIG.MTIC_REPORTING;
                  }
                  var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1 ? CONFIG.API_VERSION : CONFIG.API_QC_VERSION;
                  var url = CONFIG.REMOTE_API + api_version;
                  var headers = {};

                  if (eventName === 'language:change') {
                        eventName = is_forced ? 'language:change:automatic' : 'language:change:manual';
                  } else if (eventName === 'open:cycle:prompt') {
                        eventName = 'module:open:resource';
                  } else if (eventName === 'submit:cycle:prompt') {
                        eventName = 'resource:score:submitted';
                  } else if (eventName === 'cycle:prompt:close') {
                        eventName = 'module:close:resource';
                  }

                  var resource_data = {
                        sessionId: temp_before_clear.resource.sessionId,
                        slug: temp_before_clear.resource.slug,
                        id: temp_before_clear.resource.id
                  };
                  if (eventData && eventData.resource) {
                        if (eventData.resource.sessionId) {
                              resource_data.sessionId = eventData.resource.sessionId;
                        }
                        if (eventData.resource.slug) {
                              resource_data.slug = eventData.resource.slug;
                        }
                        if (eventData.resource.id) {
                              resource_data.id = eventData.resource.id;
                        }
                  }

                  var payload = {
                        'user_id': temp_before_clear.userId,
                        'session_id': temp_before_clear.sessionId,
                        'instance_name': instanceName,
                        'resource_session_id': resource_data.sessionId,
                        'resource_slug': resource_data.slug,
                        'resource_id': resource_data.id ? Number(resource_data.id) : null,
                        'time_stamp_local': moment.utc().format(),
                        'event_name': eventName,
                        'event_data': JSON.stringify(eventData || ''),
                        'app_info': appInfo,
                        'device_info': deviceInfo
                  };
                  var allowed = true;
                  if (allowedEvents.indexOf(eventName) > -1) {
                        if (hasValue(userInfo.headers, 'X-Auth-Session-Key') && hasValue(userInfo.headers, 'X-Auth-Id')) {
                              url += API_ROUTES.POST.AUTH_EVENT;
                              headers = userInfo.headers;
                        } else {
                              url += API_ROUTES.POST.EVENT;
                        }
                  } else {
                        allowed = false;
                  }

                  if ((eventName === 'browser:tab:beforeunload:warning' || eventName === 'browser:tab:beforeunload:cancelled') && !userInfo.userId) {
                        allowed = false;
                  }
                  if (allowed) {
                        var headers_modified = angular.copy(headers);
                        delete headers_modified.Pragma;
                        delete headers_modified['If-Modified-Since'];
                        delete headers_modified['Cache-Control'];
                        delete headers_modified['X-ACCESS-TOKEN'];
                        $http({
                              method: 'POST',
                              url: url,
                              data: payload,
                              headers: headers_modified
                        }).then(function () {
                              $log.debug('[[EventManager]]', 'Sent to API', eventName, eventData, instanceName);
                        }).catch(function (e) {
                              $log.debug('[[EventManager]]', 'Failed to sent event to vretta db', e, eventName, eventData, instanceName);
                        });
                  }
            }, timer);
      };
      /**
      * EventManager Class
      * This is the main component logger class, all events are routed by this
      * @param {String} componentType best practise is to use the directives name
      * @param {String} instanceName should be computed by the function returned by this service
      * @param {angular.scope} scope  the scope object provided by the link function or $scope
      */
      function EventManager(componentType, instanceName, scope) {
            var listenerDeregisters = [];
            scope.$on('$destroy', function () {
                  $log.debug('[[EventManager]] DESTROYING', instanceName, listenerDeregisters.length, 'listeners');
                  listenerDeregisters.forEach(function (listenerDeregister) {
                        listenerDeregister();
                  });
                  listenerDeregisters = [];
                  $rootScope.eventManagers['/' + componentType] = null;
            });
            /**
             * Define getters
             */
            Object.defineProperty(this, 'instanceName', {
                  get: function get() {
                        return instanceName;
                  }
            });
            Object.defineProperty(this, 'componentType', {
                  get: function get() {
                        return componentType;
                  }
            });
            /**
            * A special syncronous call for when a user is about to refresh or exist the page
            * @return {}
            */
            this.beforeunloadWarning = function () {
                  var eventName = 'browser:tab:beforeunload:warning';
                  if (!userInfo.userId) {
                        return;
                  }
                  var request = new XMLHttpRequest();
                  var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1 ? API_CONFIG.API_VERSION : API_CONFIG.API_QC_VERSION;
                  var url = API_CONFIG.REMOTE_API + api_version + API_ROUTES.POST.AUTH_EVENT;
                  var payload = {
                        'user_id': userInfo.userId,
                        'session_id': userInfo.sessionId,
                        'instance_name': instanceName,
                        'resource_session_id': userInfo.resource.sessionId,
                        'resource_slug': userInfo.resource.slug,
                        'resource_id': userInfo.resource.id ? Number(userInfo.resource.id) : null,
                        'time_stamp_local': moment.utc().format(),
                        'event_name': eventName,
                        'event_data': '',
                        'app_info': appInfo,
                        'device_info': deviceInfo
                  };
                  var headers = userInfo.headers;
                  request.open("POST", url, false);
                  request.setRequestHeader("content-type", "application/json");
                  request.setRequestHeader("X-Auth-Id", headers['X-Auth-Id']);
                  request.setRequestHeader("X-Auth-Session-Key", headers['X-Auth-Session-Key']);
                  request.setRequestHeader("X-Group-Id", headers['X-Group-Id']);
                  request.send(JSON.stringify(payload));
            };
            /**
            * Broadcast an event from rootScope
            * @param  {String} eventName
            * @param  {Object} eventData
            * @return {angular.broadcast}
            */
            this.broadcast = function (eventName, eventData, is_forced) {
                  var eventLabel = 'General Activity';
                  $log.debug('[[broadcasting]]', {
                        instanceName: instanceName,
                        eventName: eventName,
                        eventData: eventData,
                        userInfo: userInfo,
                        deviceInfo: deviceInfo,
                        appInfo: appInfo
                  });
                  $log.debug('[[broadcasting]]', eventName);
                  // ga('send', 'event', instanceName, eventName, eventLabel, {
                  //       userInfo: userInfo,
                  //       deviceInfo: deviceInfo,
                  //       appInfo: appInfo,
                  //       // eventData: eventData
                  // });
                  reportToOurApi(eventName, eventData, instanceName, is_forced);
                  broadCast(eventName, eventData);
            };
            /**
            * A special broadcast for items (this will be wrapped around the iframe lesson)
            * @param  {String} itemComponentId
            * @param  {String} eventName
            * @param  {Object} eventData
            * @return {null}
            */
            this.itemBroadcast = function (itemComponentId, eventName, eventData) {
                  var eventLabel = 'General Activity';
                  $log.debug('[[item -> broadcasting]]', {
                        componentId: itemComponentId,
                        instanceName: instanceName,
                        eventName: eventName,
                        eventData: eventData,
                        userInfo: userInfo,
                        deviceInfo: deviceInfo,
                        appInfo: appInfo
                  });
                  // ga('send', 'event', instanceName, eventName, eventLabel, {
                  //       userInfo: userInfo,
                  //       deviceInfo: deviceInfo,
                  //       appInfo: appInfo,
                  //       // eventData: eventData
                  // });
                  reportToOurApi(eventName, eventData, instanceName + '/' + itemComponentId);
            };
            /**
            * Listen to events on LOCAL scope
            * @param  {String}   eventName
            * @param  {Function<Event,Object>} cb
            * @return {angular.$on}
            */
            this.listen = function (eventName, cb) {
                  $log.debug('[[EventManager]]', instanceName, 'is listening to', eventName);
                  var listenerDeregister = scope.$on(eventName, cb);
                  listenerDeregisters.push(listenerDeregister);
                  return listenerDeregister;
            };
            this.getlistenerDeregisters = function () {
                  return listenerDeregisters;
            };
            this.flush = function () {
                  $log.debug('[[EventManager]] Flushing', listenerDeregisters);
                  listenerDeregisters.forEach(function (listenerDeregister) {
                        listenerDeregister();
                  });
                  listenerDeregisters = [];
            };
            /**
            * Sets the current userId
            * @param  {String} userId
            * @return {}
            */
            this.setUserInfo = function (userId) {
                  userInfo.userId = Number(userId);
                  // ga('set', 'userId', String(userId));
            };
            /**
            * Sets the activity
            * @param  {String} activitySlug
            * @return {}
            */
            this.setResourceSession = function (resourceSlug, resourceId) {
                  userInfo.resource.slug = resourceSlug;
                  userInfo.resource.id = resourceId;
                  userInfo.resource.sessionId = genRandomHash();
            };
            /**
            * Gets the sessionId
            */
            this.getResourceSession = function () {
                  return userInfo.resource.sessionId;
            };
            /**
            * Resets the resource session
            * @return {}
            */
            this.resetResourceSession = function () {
                  userInfo.resource.sessionId = genRandomHash();
            };

            /**
            * Gets the session/resource info
            */
            this.getResourceInfo = function () {
                  return {
                        slug: userInfo.resource.slug,
                        id: userInfo.resource.id,
                        sessionId: userInfo.resource.sessionId
                  };
            };
            /**
            * Clears the activity session
            * @return {}
            */
            this.clearResourceSession = function () {
                  userInfo.resource.slug = null;
                  userInfo.resource.id = null;
                  userInfo.resource.sessionId = null;
            };
            /**
            * Clears the loginSession
            * @return {null}
            */
            this.clearLoginSession = function () {
                  this.clearResourceSession();
                  userInfo.userId = null;
                  userInfo.groupId = null;
                  userInfo.headers = {};
            };
            /**
            * Sets the login headers
            * @param {String}
            */
            this.setHeaders = function (headers) {
                  userInfo.headers = headers;
            };
            /**
            * Sets the current language and emit a language change event
            * @param  {String} slug
            * @return {}
            */
            this.setLanguage = function (slug, is_forced) {
                  appInfo.language = slug;
                  //var event_name = is_forced ? 'language:change:automatic' : 'language:change:manual'
                  this.broadcast('language:change', slug, is_forced);
                  if (!is_forced) {
                        this.broadcast('set:user:language', slug);
                  }
            };
            this.getLanguage = function () {
                  return appInfo.language;
            };
      }
      /**
       * Event Manager make function
       * This is done in order to get the current instanceName
       * and assign the class to the base scope
       * @param {String} componentType best practise is to use the directives name
       * @param {angular.scope} scope  the scope object provided by the link function or $scope
       */
      var service = function service(componentType, scope) {
            var instanceName = '/' + componentType;
            var eventManager;
            if (!scope) {
                  //this should ONLY happen in the case of SERVICES or FACTORIES
                  if (!$rootScope.eventManagers) {
                        $rootScope.eventManagers = {};
                  }
                  eventManager = new EventManager(componentType, instanceName, $rootScope);
                  $rootScope.eventManagers[instanceName] = eventManager;
            } else {
                  // this happens for directives and controllers
                  instanceName = computeInstanceName(scope, componentType);
                  eventManager = new EventManager(componentType, instanceName, scope);
                  scope.eventManagerName = instanceName;
                  $log.debug('[[EventManager]] Initilized', instanceName);
                  //TODO remove circular reference between scope & event
                  // scope.eventManager = eventManager
            }
            return eventManager;
      };
      service.disableBeforeUnloadMsg = false;
      return service;
});
'use strict';

angular.module('mtic').service('DataPathService', function ($log) {
  return {
    'class/module/student/work': function classModuleStudentWork(class_id, module_id, student_id) {
      return '/class/' + class_id + '/module_id/' + module_id + '/student/' + student_id + '/work';
    },
    'class/module/student/workSummary': function classModuleStudentWorkSummary(class_id, module_id, student_id) {
      return '/class/' + class_id + '/module_id/' + module_id + '/student/' + student_id + '/workSummary';
    },
    'class/module/work': function classModuleWork(class_id, module_id, from, to, limit) {
      return '/class/' + class_id + '/module/' + module_id + '/work/from/' + from + '/to/' + to + '/limit/' + limit;
    },
    'class/work': function classWork(class_id) {
      return '/class/' + class_id + '/work';
    },
    'class/modulesMapContainer': function classModulesMapContainer(class_id) {
      return '/class/' + class_id + '/moduleMapContainer';
    },
    'class/modulesListFlat': function classModulesListFlat(class_id) {
      return '/class/' + class_id + '/modulesListFlat';
    },
    'class/modulesListFlatMap': function classModulesListFlatMap(class_id) {
      return '/class/' + class_id + '/modulesListFlatMap';
    },
    'class/student/work': function classStudentWork(class_id, student_id) {
      return '/class/' + class_id + '/student/' + student_id + '/work';
    },
    'class/teacher/work': function classTeacherWork(class_id, teacher_id) {
      return '/class/' + class_id + '/teacher/' + teacher_id + '/work';
    },
    'class/users/app/events': function classUsersAppEvents(class_id, from, to, limit) {
      return '/class/' + class_id + '/users/app/events/from/' + from + '/to/' + to + '/limit/' + limit;
    },
    'user/students_c3custom': function userStudents_c3custom(class_id) {
      return '/user/' + class_id + '/students_c3custom';
    },
    'class/students': function classStudents(class_id) {
      return '/class/' + class_id + '/students';
    },
    'class/studentsMap': function classStudentsMap(class_id) {
      return '/class/' + class_id + '/studentsMap';
    },
    'class/workSummarized': function classWorkSummarized(class_id) {
      return '/class/' + class_id + '/workSummarized';
    },
    'user/classes': function userClasses(user_id) {
      return '/user/' + user_id + '/classes';
    },
    'user/schools': function userSchools(user_id) {
      return '/user/' + user_id + '/schools';
    },

    dynamic: function dynamic(key, params) {
      var parsedKey = key;
      _.map(params, function (param, paramName) {
        parsedKey = parsedKey.replace(new RegExp(':' + paramName, 'g'), param);
      });
      $log.debug('[[DataPathService]]', key, params, parsedKey);
      return parsedKey;
    }
  };
});
'use strict';

angular.module('mtic').service('DataCacheService', function (EventManager, $q, $log) {

  // vars
  var eventManager;
  var flag;
  var buffer;
  var store;
  var resolutions;

  // private methods
  var resetCache = function resetCache() {
    flag = {};
    buffer = {};
    store = {};
    resolutions = {};
  };
  var resolveVal = function resolveVal(key, val) {
    flag[key] = true;
    store[key] = val;
    if (resolutions[key]) {
      _.each(resolutions[key], function (resolution) {
        resolution(val);
      });
      resolutions[key] = [];
    }
  };
  var registerResolution = function registerResolution(key, cb) {
    if (!resolutions[key]) {
      resolutions[key] = [];
    }
    resolutions[key].push(cb);
  };
  var fetchVal = function fetchVal(key, fetcher, cb) {
    //console.log('DataCacheService.fetchVal', key, 'flag:', flag[key], 'buffer:', buffer[key]);
    return $q(function (resolve, reject) {
      $log.debug('[[CACHE SERVICE]] STARTED:', key);
      var done = function done(data, error) {
        if (!error) {
          $log.debug('[[CACHE SERVICE]] DONE (SUCCESS):', key, data);
          if (cb) {
            cb(data);
          }
          resolve(data);
        } else {
          $log.warn('[[CACHE SERVICE]] DONE (FAIL):', key, error);
          if (cb) {
            cb(null, error);
          }
          reject(error);
        }
      };
      if (flag[key]) {
        done(store[key], null);
      } else if (buffer[key]) {
        registerResolution(key, done);
      } else {
        registerResolution(key, done);
        buffer[key] = true;
        try {
          var fetcherRes = fetcher(function (val) {
            buffer[key] = false;
            resolveVal(key, val);
          });
          if (fetcherRes && fetcherRes.catch) {
            //suport for error catching in promises
            fetcherRes.catch(function (error) {
              done(null, error);
            });
          }
        } catch (error) {
          done(null, error);
        }
      }
    });
  };

  // init
  eventManager = new EventManager('DataCacheService');
  resetCache();
  eventManager.listen('logout', function () {
    resetCache();
  });

  // public methods
  return {
    fetch: function fetch(params) {
      if (params.reset) {
        this.flush(params.key, params.reset === 'hard');
      }
      return fetchVal(params.key, params.fetcher, params.action);
    },
    flush: function flush(key, hard) {
      flag[key] = false;
      if (hard) {
        store[key] = null;
      }
    }
  };
});
'use strict';

angular.module('mtic').service('ComponentIframeCom', function ($timeout, $rootScope, TIMING_CONSTANTS, EventManager, $log, $sce, language, volumeCaptionStatus, api, StudentDataService, LocaleService, FirebaseItematic, WindowOpener, apiMethods, userAccount, TeacherDataService, preliveCheck, PlatformService, cordovaMessenger, MapStateService, $location) {
  return function ComponentIframeCom(iframeId, scope, options) {
    options = options || {};
    var containerId = options.containerId || 'component-iframe-container';
    var windowId = options.windowId || null;
    var eventManager = new EventManager(iframeId, scope);
    var resourceState = {};
    var currentContent = {};
    var customVals = {};
    var currentIframe;
    var iframeLoaded = false;
    var curHostUrl = '';
    var lessonStarted = false;
    scope.volumeOn = true;
    scope.captionsOn = true;
    var noclass_items = [1236, 1240, 1244, 1248];
    /**
    * Broadcast to child iframe
    * @param  {String} type
    * @param {Object} payload
    * @return {null}
    */
    var broadcastToIframe = this.broadcastToIframe = function (type, payload) {
      if (!isExternalLink()) {
        $log.debug('[[ComponentIframeCom]]', type, payload);
        // $log.log('posting message : ', type, payload, document.getElementById(iframeId).src)
        currentIframe = document.getElementById(iframeId);
        document.getElementById(iframeId).contentWindow.postMessage(JSON.stringify({
          type: type,
          payload: payload
        }), document.getElementById(iframeId).src);
      } else {
        $log.debug('[[ComponentIframeCom]] aborted sending `', type, payload, '` to frame, due to `custom_resource`');
      }
    };
    /**
     * @param  {String}
     */
    var startLoadingResource = this.startLoadingResource = function (slug, hostUrl, content) {
      scope.notLoaded = true;
      //this flag is not used for anything
      if (content && content.container) {
        scope.notLoaded = false;
      }
      resourceState = {};
      customVals = {};
      currentContent = content;
      //StudentDataService.getClassCommentState(scope.resource.id).then(function(states)
      reloadUrl(slug, hostUrl, content, false, function () {
        // if(currentContent.container === 'link' || currentContent.container === 'itematic_package') {
        if (currentContent && currentContent.container === 'link') {
          customVals.timeStart = Date.now();
          lesson_ended = false;
          customVals.working_session_hash = Math.random().toString(26).substr(3, 8) + userAccount.getData().sessionKey + Date.now();
          eventManager.broadcast(iframeId + ':RESOURCE_LOAD_COMPLETE', {
            forced_by: currentContent.container
          });
          scope.notLoaded = false;
        }
      });
    };
    var reloadUrl = this.reloadUrl = function (slug, hostUrl, content, isGenNewWSHash, cb) {
      if (isGenNewWSHash) {
        customVals.working_session_hash = Math.random().toString(26).substr(3, 8) + userAccount.getData().sessionKey + Date.now();
      }
      withUrl(slug, hostUrl, content, function (url) {
        if (isExternalLink()) {
          listenToExternalWindow(url);
          cb();
        } else {
          startIframe(url, cb, slug || "");
        }
      });
    };
    var withUrl = function withUrl(slug, hostUrl, content, cb) {
      var url;
      // console.log('[[ASYNC ITEMATIC LOAD]] withUrl content', content);

      if (content && content.container === 'itematic_package') {
        // console.log('[[ASYNC ITEMATIC LOAD]]');
        var releaseTag = FirebaseItematic.getReleaseTagByQcStatus({
          isPrelive: preliveCheck.isPreliveCheck(),
          isQC: preliveCheck.isQCCheck()
        });
        FirebaseItematic.getItemUrl(content.itematicGroupId, content.itematicGroupItemId, releaseTag, function (url) {
          cb(url);
        });
      } else if (!hostUrl) {
        cb(StudentDataService.genUrlfromContent(slug, content));
      } else if (hostUrl) {
        cb(hostUrl);
      } else {
        throw new Error('No `hostUrl` passed into resource!');
      }
    };
    var currently_reporting = false;
    var lesson_ended = false;
    var last_working_session_hash;
    var reportProgress = function reportProgress(stateUpdate) {
      if (currently_reporting || stateUpdate.complete && stateUpdate.working_session_hash && last_working_session_hash === stateUpdate.working_session_hash) {
        return;
      }
      if (!stateUpdate.complete && stateUpdate.score === 0) {
        stateUpdate.score = null;
      }

      if (stateUpdate.app_state) {
        stateUpdate.app_state.assessment_session_hash = eventManager.getResourceSession();
        // $log.log('got resource session : ' ,  stateUpdate.app_state.assessment_session_hash)
      }
      currently_reporting = stateUpdate.complete;
      return api.submitStudentResourceState(stateUpdate).then(function (response) {
        if (stateUpdate.complete && stateUpdate.working_session_hash) {
          last_working_session_hash = stateUpdate.working_session_hash;
        }
        currently_reporting = false;
        // $log.log('report progress sucess : ', stateUpdate, response)
        if (scope.resource.slug === 'mtic_teacher_offboarding') {
          //eventManager.broadcast('navbar:completed_test')
          eventManager.broadcast('notification-completed', 'teacher_questionnaire');
        } else if (scope.resource.slug === 'mtic_post_test') {
          LocaleService.done_student_post_test = true;
          eventManager.broadcast('C4_BASELINE_LOG', {
            done_student_post_test: true
          });
        } else if (scope.resource.slug === 'mtic_student_offboarding') {
          LocaleService.done_student_offboarding = true;
          eventManager.broadcast('C4_BASELINE_LOG', {
            done_student_offboarding: true
          });
        }
        if (stateUpdate.complete) {
          lesson_ended = true;
          eventManager.broadcast('resource:score:submitted', {
            "attemptNumber": response.attempts,
            "work_batch_id": response.work_batch_id,
            "score": stateUpdate.score,
            "complete": stateUpdate.complete,
            "slug": scope.resource.slug,
            "component_instances": stateUpdate.component_instances || {},
            "app_state": stateUpdate.app_state || {},
            "log_data": stateUpdate.log_data || []
          });
          // eventManager.broadcast('module:close:resource', {isPassive:true});
          // eventManager.broadcast('app:module:refresh');
        }
      }, function (error) {
        $log.error('Failed to update the state', error);
        currently_reporting = false;
      });
    };

    var startIframe = function startIframe(hostUrl, cb, slug) {
      curHostUrl = hostUrl;
      var timer = TIMING_CONSTANTS.INSTANT;
      if (!currentIframe) {
        currentIframe = document.createElement('iframe');
        currentIframe.style.position = 'absolute';
        currentIframe.style.height = '100%'; //slug.indexOf("mtic_g78_m0")>-1?"600px":'100%';
        currentIframe.style.width = '100%';
        currentIframe.style.position = 'absolute';
        currentIframe.style['padding-bottom'] = '0px'; //(slug.indexOf("mtic_g78_m0")>-1 || slug.indexOf("mtic_g78_m4")>-1 )?'0px':'50px';
        //if(slug.indexOf("mtic_g78_m0")>-1 && (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent))){
        // $timeout(function(){
        //   currentIframe.style.transform = navigator.userAgent.match(/Android/i)? "scale(0.8)":"scale(0.9)";
        //   currentIframe.style.top = navigator.userAgent.match(/Android/i)? "-45px":"-30px";
        //   var parentElement = document.getElementById(iframeId).parentElement;
        //   parentElement.style.height = "600px";
        //   parentElement.style.width = "100%";
        //   parentElement.style.backgroundColor = "#fff";
        // },100);
        //}
        // currentIframe.style.transform = 'scale(1) !important';
        // currentIframe.style['-ms-transform'] = 'scale(1) !important';
        // currentIframe.style['-webkit-transform'] = 'scale(1) !important';
        // currentIframe.scrolling = options.scrolling || 'no';
        currentIframe.setAttribute('scrolling', options.scrolling || 'no');
        currentIframe.setAttribute('allow', 'autoplay');
        currentIframe.id = iframeId;
        var iframe_container = document.getElementById(containerId);
        iframe_container.appendChild(currentIframe);

        if (scope.resource.resource_type === 'embedded_notification') {
          currentIframe.style.position = 'relative';
          iframe_container.style.height = '100%';
          iframe_container.parentElement.style.height = '100%';
        }
        // if(noclass_items.indexOf(scope.resource.id) > -1){
        //   iframe_container.style['-webkit-overflow-scrolling'] = 'touch';
        //   iframe_container.style.position = 'fixed';
        //   iframe_container.style.width = '100%';
        //   iframe_container.style.height = '100%';
        // }
      }
      // else{
      //   timer = 200;
      // }
      // if(PlatformService.isAndroid || PlatformService.isIos){
      //   timer = 300;
      // }
      currentIframe.src = '';
      $timeout(function () {
        currentIframe.src = $sce.trustAsResourceUrl(hostUrl);

        $timeout(function () {
          if (cb) {
            cb();
          }
        }, TIMING_CONSTANTS.INSTANT);
      }, 300);

      return currentIframe;
    };

    var listenToExternalWindow = function listenToExternalWindow(hostUrl) {
      var timer = WindowOpener.listenToWindowCloseOf(windowId, function () {
        eventManager.broadcast('module:close:resource');
      });
      scope.$on('$destroy', function () {
        if (timer) {
          window.clearInterval(timer);
        }
      });
    };
    var isCustomResource = function isCustomResource() {
      return scope.resource.resource_type === 'custom_resource';
    };
    var isExternalLink = function isExternalLink() {
      return scope.resource && scope.resource.content ? scope.resource.content.container === 'link' : false;
    };
    scope.isCustomResource = isCustomResource;
    scope.isExternalLink = isExternalLink;
    /**
     * Convert all incoming messages from iframe to eventManager events
     */
    eventManager.listen('$messageIncoming', function (event, msgPayload) {
      // $log.log('$messageIncoming', {
      //     msgPayload: msgPayload,
      //     currentResource: scope.currentResource
      // })
      if (msgPayload.type) {
        var logEvent = msgPayload.payload;
        if (msgPayload.type === 'COMPONENT_LOG' && logEvent.eventName !== 'INIT') {
          eventManager.itemBroadcast(logEvent.componentId, 'COMPONENT_LOG', logEvent);
        } else if (msgPayload.type === 'GROUP_STATE_UPDATE') {
          /*console.log('UPDATING RESOURCE STATE : ', scope.resource.id,
              logEvent.componentId,
              logEvent.eventData,
              logEvent.timestamp)*/
          api.updateClassComponentState(scope.resource.id, logEvent.componentId, logEvent.eventData, logEvent.timestamp);
        } else {
          eventManager.broadcast(iframeId + ':' + msgPayload.type, logEvent);
        }
      } else {
        $log.error('No Event Type coming from resource!');
      }
    });
    /**
     * General Event Listeners
     */
    eventManager.listen('language:change', function (e, languageSlug) {
      broadcastToIframe('LANGUAGE_CHANGE', languageSlug);
    });
    eventManager.listen('navigation:volume:change', function (e, option) {
      broadcastToIframe('NAVIGATION_VOLUME_CHANGE', option);
    });
    eventManager.listen('navigation:captions:change', function (e, option) {
      broadcastToIframe('NAVIGATION_CAPTIONS_CHANGE', option);
    });
    var updateAndCloseDefer;
    eventManager.listen('module:updateAndClose:resource', function (e, defer) {
      if (updateAndCloseDefer) {
        defer.reject();
      }
      if (!iframeLoaded) {
        $timeout(function () {
          defer.resolve();
        }, 10);
      } else {
        updateAndCloseDefer = defer;
        broadcastToIframe('REQUEST_ITEM_APP_STATE_SAVE');
      }
    });

    eventManager.listen('module:close:resource', function (e, args) {
      api.postResourceTimeUpdate(customVals.working_session_hash);
      if (isExternalLink()) {
        var mod_id = scope.moduleId;
        reportProgress({
          "slug": scope.resource.slug,
          "score": 1,
          "complete": true,
          "time_spent": Date.now() - customVals.timeStart,
          "time_stamp": customVals.timeStart,
          "resource_id": scope.resource.id,
          "module_id": mod_id,
          "component_instances": {},
          "app_state": {},
          "log_data": {},
          "working_session_hash": customVals.working_session_hash
        });
      }
      if (args && args.isPassive) {
        return;
      }
      // Need to change iFrame src before removing it, to make voices stop playing in ie11
      document.getElementById(iframeId).src = '';
      currentIframe = null;
      $rootScope.sender = null;
      if (isExternalLink()) {
        WindowOpener.close(windowId);
      }
    });
    eventManager.listen(iframeId + ':RESOURCE_LOAD_COMPLETE', function (e, eventData) {
      lessonStarted = true;

      // $log.log('hostUrl: ', hostUrl)
      if (curHostUrl.indexOf('inbook') > -1 && window.location.href.indexOf('web-open-browser') === -1) {
        // For inbook, there are 2 issues: 1) It creates a new history instance, which causes the back navigation to go back through that history instead of the browser
        // 2) the history entry is identical, which doesnt trigger onpopstate, thus the solution is to force
        // a new history entry htat is not identical(so we can trigger popstate) and then pop 3 history entries based on the 2 additional ones and the one we pushed
        window.onpopstate = function (event) {
          window.history.go(-2);
        };

        $timeout(function () {
          window.history.pushState('', '', '?');
        }, 1000);
      } else if (location.href.indexOf('open_item_link') > -1) {
        $location.url('');
        LocaleService.item_link_opened = true;
      }

      scope.notLoaded = false;
      lesson_ended = false;
      customVals.timeStart = Date.now();
      customVals.working_session_hash = customVals.working_session_hash || Math.random().toString(26).substr(3, 8) + userAccount.getData().sessionKey + Date.now();
      broadcastToIframe('LANGUAGE_CHANGE', language.getCurrentSelectedLanguage());
      broadcastToIframe('NAVIGATION_VOLUME_CHANGE', volumeCaptionStatus.getVolume());
      broadcastToIframe('NAVIGATION_CAPTIONS_CHANGE', volumeCaptionStatus.getCaptions());
      broadcastToIframe('RESOURCE_DATA', {
        state: { frameCounter: 0 },
        states: resourceState,
        info: scope.resource,
        user: StudentDataService.getCurrentUserData()
      });

      resourceUnlocksAnother();

      var class_id;
      if (noclass_items.indexOf(scope.resource.id) > -1 || !userAccount.getActiveClassData() && (!userAccount.getActiveClassroom() || userAccount.getActiveClassroom() === '')) {
        class_id = 99999;
        scope.moduleId = 57;
      } else {
        class_id = userAccount.getData().role.isTeacher ? userAccount.getActiveClassData().id : userAccount.getActiveClassroom();
      }
      api.initStateLogSession(StudentDataService.getCurrentUserData().user_id, scope.resource.id, scope.moduleId || 57, class_id, customVals.working_session_hash, eventManager.getResourceSession()).then(function (state_log_data) {
        // $log.log('got state log init data : ' , state_log_data)
      });

      var item_options = MapStateService.getItemOptions();
      if (item_options) {
        $log.log('RESPONSE ITEM : ', item_options);
        broadcastToIframe('SET_ITEM_OPTIONS', item_options);
        //MapStateService.setItemOptions(null);
      }

      api.getUserResourceLatestAppState(StudentDataService.getCurrentUserData().user_id, scope.resource.id).then(function (data) {
        window.console.log('GOT LATEST : ', data, scope.resource);
        var latest_state_log = data.app_state || {};
        if (data.dependant_assessment_mapping) {
          latest_state_log.dependant_assessment_mapping = data.dependant_assessment_mapping;
        }
        var maxScore = 0;
        if (scope.resource && scope.resource.resourceState) {
          maxScore = scope.resource.resourceState.score_max;
        }
        // window.console.log('scope.resource', maxScore);
        if (maxScore) {
          var scoring = { score: maxScore };
          if (latest_state_log && latest_state_log.state_data && latest_state_log.state_data.highscores) {
            scoring.highscores = latest_state_log.state_data.highscores;
          }
          broadcastToIframe('LESSON_SCORE_RESTORE', scoring);
        }
        if (latest_state_log && (latest_state_log.state_data || latest_state_log.dependant_assessment_mapping)) {
          broadcastToIframe('LESSON_STATE_RESTORE', latest_state_log);
        }
      });

      //focus on iframe so we don't need to click to get focus
      var cur_resource_frame = document.getElementById('mticResource');
      if (cur_resource_frame) {
        cur_resource_frame.focus();
      }

      eventManager.broadcast('resource:load:complete');
    });

    function resourceUnlocksAnother() {
      if (userAccount.getData().role.role_type === 'mtic_student') {
        StudentDataService.getModuleData(false).then(function (data) {
          // $log.log('module map data: ', data)
          var found = false;
          data.resources.forEach(function (cur_module) {
            if (cur_module.id === scope.resource.parent_resource_id) {
              cur_module.children.forEach(function (resource) {
                if (resource.unlocked_by.indexOf(scope.resource.slug) > -1) {
                  found = true;
                }
              });
            }
          });

          if (!found) {
            broadcastToIframe('END_OF_MAP_ITEM', { unlocksNoItem: true });
          }
        });
      } else if (userAccount.getActiveClassroom()) {
        TeacherDataService.getModuleMap(userAccount.getActiveClassroom()).then(function (data) {
          // $log.log('module map data: ', data)
          var found = false;
          data.Modules.forEach(function (sub_mod) {
            if (sub_mod.module_id === 2) {
              sub_mod.Resource.children.forEach(function (cur_module) {
                if (cur_module.id === scope.resource.parent_resource_id) {
                  cur_module.children.forEach(function (resource) {
                    if (resource.unlocked_by.indexOf(scope.resource.slug) > -1) {
                      found = true;
                    }
                  });
                }
              });
            }
          });

          if (!found) {
            broadcastToIframe('END_OF_MAP_ITEM', { unlocksNoItem: true });
          }
        });
      }
    }

    //object to report progress to serve
    var getStateUpdate = function getStateUpdate(payload) {
      if (payload.payload) {
        payload = payload.payload;
      }
      //hard coding the assessment module ids, since these can be opened under different module tabs
      var mod_id = scope.moduleId;
      // if(payload.slug === 'mtic_teacher_offboarding' || payload.slug === 'mtic_student_onboarding' || payload.slug === 'mtic_post_test' || payload.slug === 'mtic_baseline_assessment'){
      //   mod_id = 57;
      //   if(payload.slug === 'mtic_teacher_offboarding'){
      //     scope.classId = 99999;
      //   }
      // }

      var time_spent = Date.now() - customVals.timeStart;

      var score = payload.score;
      if (!score && score !== 0) {
        score = payload.completed || payload.complete ? 1 : 0;
      }

      var complete_val = payload.completed;
      if (complete_val === null) {
        complete_val = payload.complete;
      }

      //            console.log('reporting from item progress: ', payload, time_spent, customVals.timeStart)
      var stateUpdate = {
        "slug": scope.resource.slug,
        "score": score, //Math.max(0,Math.min(1,score)),
        "complete": complete_val,
        "time_spent": time_spent,
        "time_stamp": customVals.timeStart,
        "resource_id": scope.resource.id,
        "module_id": mod_id || 57,
        "component_instances": payload.component_instances || {},
        "app_state": payload.app_state || {},
        "log_data": payload.log_data || [],
        "working_session_hash": customVals.working_session_hash
        // if(scope.classId) {
        //     stateUpdate.class_id = scope.classId;
        // }
        // if(mod_id === 28 || scope.resource.slug.indexOf('g78_m2') > -1){
        //   stateUpdate.complete = true;
        // }
      };if (noclass_items.indexOf(scope.resource.id) > -1 || !userAccount.getActiveClassData() && (!userAccount.getActiveClassroom() || userAccount.getActiveClassroom() === '')) {
        stateUpdate.class_id = 99999;
        scope.classId = 99999;
        scope.moduleId = 57;
      } else {
        stateUpdate.class_id = userAccount.getData().role.isTeacher ? userAccount.getActiveClassData().id : userAccount.getActiveClassroom();
      }

      return stateUpdate;
    };

    eventManager.listen(iframeId + ':ITEM_PROGRESS', function (e, payload) {
      var stateUpdate = getStateUpdate(payload);
      // $log.log('stateUpdate: ', stateUpdate)
      reportProgress(stateUpdate);
    });

    eventManager.listen(iframeId + ':LAB_AUTOSAVE', function (e, payload) {
      var stateUpdate = getStateUpdate(payload);
      api.submitStudentResourceState(stateUpdate).then(function (response) {
        // $log.log('autosave sucess : ', stateUpdate, response)
      }, function (error) {});
    });

    eventManager.listen(iframeId + ':item-work-submission', function (e, payload) {
      // $log.log('mid-lesson item-work-submission : ', payload)
      payload.assessment_session_hash = eventManager.getResourceSession();
      var stateUpdate = {
        "slug": scope.resource.slug,
        "score": null,
        "complete": false,
        "time_spent": Date.now() - customVals.timeStart,
        "time_stamp": customVals.timeStart,
        "resource_id": scope.resource.id,
        "module_id": scope.moduleId,
        "app_state": payload,
        "log_data": [],
        "working_session_hash": customVals.working_session_hash
      };
      return api.submitStudentResourceState(stateUpdate).then(function (response) {
        // $log.log('report progress sucess : ', stateUpdate, response)
        broadcastToIframe('SUBMISSION_RESOLVED_' + payload.comm_id, { success: true, msg: 'submitted work successfully' });
      }, function (error) {
        $log.error('Failed to update the state', error);
        broadcastToIframe('SUBMISSION_RESOLVED_' + payload.comm_id, { success: false, msg: 'sumbmission failed' });
      });
    });

    eventManager.listen(iframeId + ":RESPONSE_ITEM_APP_STATE_SAVE", function (e, payload) {
      var stateUpdate = getStateUpdate(payload);
      reportProgress(stateUpdate).then(function () {
        if (updateAndCloseDefer) {
          iframeLoaded = false;
          updateAndCloseDefer.resolve();
          $timeout(function () {
            updateAndCloseDefer = null;
          }, 2000);
        }
      });
    });

    eventManager.listen(iframeId + ":REQUEST_CLOSE", function (e, payload) {
      // $log.log("close resource");
    });

    eventManager.listen(iframeId + ":OPEN_EXTERNAL_LINK", function (e, payload) {
      // $log.log("close resource");
      if (PlatformService.isApp) {
        cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: payload.link_url });
      } else {
        window.open(payload.link_url, '_blank');
      }
    });

    eventManager.listen(iframeId + ":IDLE_TIME_RESET", function (e, payload) {
      eventManager.broadcast('iframe-idle-reset');
    });

    eventManager.listen(iframeId + ":REQUEST_ITEM_APP_STATE", function (e, payload) {
      var user = StudentDataService.getCurrentUserData();
      iframeLoaded = true;
      broadcastToIframe("RESPONSE_GETTING_APP_STATE", null);
      //api.getUserResourceLastAppState(user.user_id,scope.resource.id).then(function(data){
      api.getUserResourceLatestAppState(user.user_id, scope.resource.id).then(function (data) {

        //this is to mitigate the change from lastappstate to latestappstate routes, as the first of those should be deprecated
        var constructed_response = [{
          WorkBatch: {
            StudentResourceStateLogs: data
          }
        }];

        // $log.log('RESPONSE_ITEM_APP_STATE', constructed_response)
        broadcastToIframe("RESPONSE_ITEM_APP_STATE", constructed_response);
      });
    });

    eventManager.listen('mouse:keyboard:active', function (e, args) {
      if (lessonStarted && args && !args.idleInput && !lesson_ended && !args.returned_from_away) {
        api.postResourceTimeUpdate(customVals.working_session_hash, true);
      }
    });

    eventManager.listen('browser:tab:beforeunload:shown', function (e) {
      if (lessonStarted && !lesson_ended) {
        api.postResourceTimeUpdate(customVals.working_session_hash, true);
        $rootScope.$digest();
      }
    });

    eventManager.listen('offline-post-call-resolved', function () {
      if (!lessonStarted) {
        var temp = currentIframe.src;
        $log.log('GOT OFFLINE CALL RESOLVE FROM IFRAME', temp);
        currentIframe.src = '';
        $timeout(function () {
          currentIframe.src = $sce.trustAsResourceUrl(temp);
        }, 300);
      }
    });
  };
});
'use strict';

angular.module('mtic').filter('wsTime', function ($filter) {
  return function (list, filter) {
    return $filter("filter")(list, function (item) {
      var start = moment(item.timeStarted);
      var end = moment(item.timeEnded);
      var now = moment();

      if (filter.id === 'all') {
        return true;
      }
      if (filter.id === 'today') {
        return now.diff(end, 'days') === 0;
      }
      if (filter.id === '1week') {
        return now.diff(end, 'weeks') === 0;
      }
      if (filter.id === '2weeks') {
        return now.diff(end, 'weeks') <= 1;
      }
      if (filter.id === '1month') {
        return now.diff(end, 'months') === 0;
      }
    });
  };
});
'use strict';

angular.module('mtic').filter('inArray', function ($filter) {
    return function (list, arrayFilter, listElement, arrayFilterElement) {
        if (!arrayFilterElement) {
            arrayFilterElement = listElement;
        }
        if (arrayFilter && arrayFilter.length > 0) {
            return $filter("filter")(list, function (listItem) {
                return arrayFilter.map(function (filterItem) {
                    return filterItem[arrayFilterElement];
                }).indexOf(listItem[listElement]) !== -1;
            });
        } else {
            // return list;
            return $filter("filter")(list, function (listItem) {
                return !!listItem[listElement];
            });
        }
    };
});
'use strict';

angular.module('mtic').constant('IAM_TRANSLATIONS', {
  "14455": {
    "id": 14455,
    "item_id": "mtic2_IAM_translations",
    "en": "MathemaTIC - for cycles 3 and 4 and for secondary education. The environment is currently under maintainance and will be available from Friday 29th of September. In the meantime we advise you to update SCOLARIA and activate the IAM accounts of your students. Thank you for your patience.",
    "fr": "MathemaTIC - pour les cycles 3 et 4 et pour le cycle inférieur.\nL’environnement est en cours de maintenance et sera disponible à partir du vendredi 29 septembre. En attendant nous vous conseillons de mettre à jour SCOLARIA et d’activer les comptes IAM de vos élèves.\nMerci de votre patience.",
    "de": "MathemaTIC - für die Zyklen 3 und 4 und für den Untergrad der Sekundarstufe. Die Plattform wird gerade überarbeitet und wird vom 29. September an wieder zugänglich sein. In der Zwischenzeit empfehlen wir Ihnen, SCOLARIA zu aktualisieren und die IAM-Konten Ihrer Schüler zu aktivieren. Vielen Dank für Ihr Verständnis.",
    "pt": "Matemática - para os ciclos 3 e 4 e para o ensino secundário. O ambiente de aprendizagem encontra-se em manutenção e estará disponível a partir de sexta-feira, 29 de setembro. Entretanto, aconselhamos atualizar o SCOLARIA e ativar as contas IAM dos seus alunos. Obrigado pela sua paciência."
  },
  "14456": {
    "id": 14456,
    "item_id": "mtic2_IAM_translations",
    "en": "Minimum System Requirements",
    "fr": "Configuration système minimale requise",
    "de": "Minimale Systemvoraussetzungen",
    "pt": "Requisitos de sistema mínimos"
  },
  "14457": {
    "id": 14457,
    "item_id": "mtic2_IAM_translations",
    "en": "RECOMMENDED",
    "fr": "Recommandé",
    "de": "EMPFOHLEN",
    "pt": "RECOMANDADO"
  },
  "14458": {
    "id": 14458,
    "item_id": "mtic2_IAM_translations",
    "en": "ALSO TESTING ON",
    "fr": "Bientôt compatible avec",
    "de": "AUCH GETESTET FÜR",
    "pt": "TAMBÉM TESTADO COM"
  },
  "14459": {
    "id": 14459,
    "item_id": "mtic2_IAM_translations",
    "en": "COMING SOON",
    "fr": "PROCHAINEMENT",
    "de": "IN KÜRZE",
    "pt": "EM BREVE"
  },
  "14460": {
    "id": 14460,
    "item_id": "mtic2_IAM_translations",
    "en": "with up to date Flash Player\n",
    "fr": "avec Flash Player mis à jour",
    "de": "mit aktualisiertem Flash Player",
    "pt": "com o Flash Player atualizado"
  },
  "14461": {
    "id": 14461,
    "item_id": "mtic2_IAM_translations",
    "en": "GET THE APP\n",
    "fr": "Obtenez l'application",
    "de": "APP HERUNTERLADEN",
    "pt": "OBTENHA A APLICAÇÃO"
  },
  "14462": {
    "id": 14462,
    "item_id": "mtic2_IAM_translations",
    "en": "Setting up IAM for Kids",
    "fr": "Configuration d'IAM pour les enfants",
    "de": "IAM for Kids einrichten",
    "pt": "Configurar IAM for Kids"
  },
  "14463": {
    "id": 14463,
    "item_id": "mtic2_IAM_translations",
    "en": "Admin/Demo Login",
    "fr": "Connexion Admin / Demo",
    "de": "Einloggen Admin/Demo",
    "pt": "Login Admin/Demo"
  },
  "14464": {
    "id": 14464,
    "item_id": "mtic2_IAM_translations",
    "en": "Download",
    "fr": "Télécharger",
    "de": "Download",
    "pt": "Download"
  },
  "14465": {
    "id": 14465,
    "item_id": "mtic2_IAM_translations",
    "en": "Rights of use",
    "fr": "Droits d'utilisation",
    "de": "Nutzungsrechte",
    "pt": "Direitos de uso"
  },
  "14466": {
    "id": 14466,
    "item_id": "mtic2_IAM_translations",
    "en": "Embed",
    "fr": "Intégrer",
    "de": "Einbetten",
    "pt": "Incorporar"
  },
  "14501": {
    "id": 14501,
    "item_id": "mtic2_IAM_translations",
    "en": "dedicated video\n",
    "fr": "vidéo dédiée",
    "de": "Grafikspeicher",
    "pt": "vídeo dedicado"
  },
  "14502": {
    "id": 14502,
    "item_id": "mtic2_IAM_translations",
    "en": "Fall 2017 Release\n",
    "fr": "Sortie prévue à l'automne 2017",
    "de": "Start Herbst 2017",
    "pt": "Lançamento outono 2017"
  },
  "14503": {
    "id": 14503,
    "item_id": "mtic2_IAM_translations",
    "en": " or higher",
    "fr": "ou supérieur",
    "de": "oder höher",
    "pt": "ou superior"
  },
  "14524": {
    "id": 14524,
    "item_id": "mtic2_IAM_translations",
    "en": "This website is optimized for modern browsers\nsuch as Google Chrome.\nPlease click on the link above and follow the installation instructions to upgrade to a compatible browser.",
    "fr": "Ce site est optimisé pour les navigateurs modernes tels que Google Chrome. Cliquez sur le lien ci-dessus et suivez les instructions d'installation pour passer à un navigateur compatible.",
    "de": "Diese Webseite ist optimiert für moderne Browser wie Google Chrome. Klicken Sie auf den Link unten, folgen Sie den Anweisungen zur Installation und aktualisieren Sie ihren Browser.",
    "pt": "Este site está otimizado para navegadores modernos como o Google Chrome.\nClique no link acima e siga as instruções de instalação para atualizar para um navegador compatível."
  }
});
'use strict';

angular.module('mtic').constant('URL_VERSIONS', {
    Live: 'Live', // for all users
    Prelive: 'Prelive', // for testing by SMEs
    Preview: 'Preview' // for most testing by the QC team. Connected to live database
});
'use strict';

angular.module('mtic').constant('TIMING_CONSTANTS', {
    INSTANT: 0,
    SCOPE_REFRESH_DELAY_MS: 20,
    MESSAGE_HIDE_DELAY_MS: 2000,
    PRE_DEBUG_AUTOACTION_MS: 200,
    STUDENT_DATA_REFRESH_DELAY_MS: 100,
    BEFORE_UNLOAD_DELAY_MS: 1000,
    ALERT_BOX_DEFAULT_DISPLAY_MS: 5000
});
'use strict';

angular.module('mtic').constant('MODULE_THREE', {
  "id": 373,
  "slug": "mtic_gr78_m3",
  "name": "Grade 7&8 Module 3",
  "resource_type": "sub_module",
  "content": {},
  "unlocked_by": [],
  "display": {
    "panel": [{
      "sub": [{
        "slug": "mtic_g78_m3_game_sub_pt1"
      }, {
        "slug": "mtic_g78_m3_game_sub_pt2"
      }, {
        "slug": "mtic_g78_m3_alg_balance"
      }, {
        "slug": "mtic_g78_m3_class_eq"
      }, {
        "slug": "mtic_g78_m3_represent_eq"
      }],
      "slug": "Thinking about equality"
    }, {
      "sub": [{
        "slug": "mtic_g78_m3_sub_method"
      }, {
        "slug": "mtic_g78_m3_bracket_wo"
      }, {
        "slug": "mtic_g78_m3_bracket_wo_pt2"
      }, {
        "slug": "mtic_g78_m3_bracket_incl"
      }],
      "slug": "Solving Strategies"
    }, {
      "sub": [{
        "slug": "mtic_g78_m3_geo_perim"
      }, {
        "slug": "mtic_g78_m3_geo_area"
      }, {
        "slug": "mtic_g78_m3_word_prob"
      }, {
        "slug": "mtic_g78_m3_word_prob_pt2"
      }],
      "slug": "Building Equations"
    }, {
      "sub": [{
        "slug": "mtic_g78_m3_impos_eq"
      }, {
        "slug": "mtic_g78_m3_impos_eq_pt2"
      }],
      "slug": "Special Equations"
    }, {
      "sub": [{
        "slug": "mtic_g78_m3_alice_bob"
      }, {
        "slug": "mtic_g78_m3_equal_area"
      }, {
        "slug": "mtic_g78_m3_receipt"
      }, {
        "slug": "mtic_g78_m3_open"
      }, {
        "sub": [{
          "slug": "mtic_g78_m3_graph_area"
        }, {
          "slug": "mtic_g78_m3_graph_perim"
        }],
        "slug": "Equations and Graphs"
      }],
      "slug": "Problems"
    }],
    "position": {
      "x": 525,
      "y": -278
    }
  },
  "config": {
    "stats": {
      "lessons": {
        "by": "resource_type",
        "value": "lesson"
      },
      "summative": {
        "by": "slug",
        "value": "mtic_g78_m3_sum"
      },
      "diagnostic": {
        "by": "slug",
        "value": "mtic_g78_m3_diag"
      }
    },
    "meta_locks": {
      "lessons": ["diagnostic"],
      "summative": ["lessons"],
      "diagnostic": []
    },
    "teacher_panel": {
      "agenda": {},
      "dashboard": {},
      "workspace": {}
    }
  },
  "parent_resource_id": 316,
  "hierarchy_level": 2,
  "children": [{
    "id": 374,
    "slug": "mtic_g78_m3_game_sub_pt1",
    "name": "Substitution Game (Part 1)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.15",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_diag"],
    "display": {
      "color": "blue",
      "position": {
        "x": 708.4500612147657,
        "y": 375.41040433369943
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 375,
    "slug": "mtic_g78_m3_diag",
    "name": "Diagnostic",
    "resource_type": "assessment",
    "content": {
      "version": "v1.1.6",
      "container": "inbook_package"
    },
    "unlocked_by": [],
    "display": {
      "color": "red",
      "position": {
        "x": 920.0198592255623,
        "y": 233.58129138068642
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 376,
    "slug": "mtic_g78_m3_game_sub_pt2",
    "name": "Substitution Game (Part 2)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.12",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_game_sub_pt1"],
    "display": {
      "color": "blue",
      "position": {
        "x": 533.7787245395305,
        "y": 356.55768611411366
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 377,
    "slug": "mtic_g78_m3_graph_perim",
    "name": "variation-périmètre",
    "resource_type": "lesson",
    "content": {
      "version": "v1.1.6",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_diag"],
    "display": {
      "color": "black",
      "position": {
        "x": 1066.3005586929062,
        "y": 420.2221407390573
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  },
  // {
  //   "id": 378,
  //   "slug": "mtic_g78_m3_inver_oper",
  //   "name": "Opérations inverses (Part 1)",
  //   "resource_type": "lesson",
  //   "content": {
  //     "version": "v0.0.15",
  //     "container": "inbook_package"
  //   },
  //   "unlocked_by": [
  //     "mtic_g78_m3_diag"
  //   ],
  //   "display": {
  //     "color": "blue",
  //     "position": {
  //       "x": 785.058362778898,
  //       "y": 3.5658388771014904
  //     }
  //   },
  //   "config": {},
  //   "parent_resource_id": 373,
  //   "hierarchy_level": 3
  // },
  // {
  //   "id": 379,
  //   "slug": "mtic_g78_m3_inver_oper_pt2",
  //   "name": "Opérations inverses (Part 2)",
  //   "resource_type": "lesson",
  //   "content": {
  //     "version": "v1.0.0",
  //     "container": "inbook_package"
  //   },
  //   "unlocked_by": [
  //     "mtic_g78_m3_inver_oper"
  //   ],
  //   "display": {
  //     "color": "blue",
  //     "position": {
  //       "x": 621.6610373864353,
  //       "y": -121.1562963525572
  //     }
  //   },
  //   "config": {},
  //   "parent_resource_id": 373,
  //   "hierarchy_level": 3
  // },
  {
    "id": 380,
    "slug": "mtic_g78_m3_alg_balance",
    "name": "Connection between balances and equations",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.7",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_game_sub_pt2"],
    "display": {
      "color": "blue",
      "position": {
        "x": 435.7608878102408,
        "y": 205.74339338871835
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 381,
    "slug": "mtic_g78_m3_graph_area",
    "name": "Potager",
    "resource_type": "lesson",
    "content": {
      "version": "v3.3.3",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_diag"],
    "display": {
      "color": "black",
      "position": {
        "x": 1147.587078906502,
        "y": 168.64800294270066
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 382,
    "slug": "mtic_g78_m3_class_eq",
    "name": "Classification of equations",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.8",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_alg_balance"],
    "display": {
      "color": "blue",
      "position": {
        "x": 426.604799569811,
        "y": 6.274119971343426
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 383,
    "slug": "mtic_g78_m3_sub_method",
    "name": "Méthodes de substitution",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.8",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_class_eq"],
    "display": {
      "color": "blue",
      "position": {
        "x": 222.3669813624307,
        "y": -11.564624262966074
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 384,
    "slug": "mtic_g78_m3_bracket_wo",
    "name": "Résolution formelle d’équations – parenthèses (Part 1)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.10",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_sub_method"],
    "display": {
      "color": "blue",
      "position": {
        "x": 37.58881379376169,
        "y": -23.093673050968814
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 623,
    "slug": "mtic_g78_m3_bracket_wo_pt2",
    "name": "Résolution formelle d’équations – parenthèses (Part 2)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.11",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_bracket_wo"],
    "display": {
      "color": "blue",
      "position": {
        "x": -148.23941097527614,
        "y": -40.35043079439743
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 624,
    "slug": "mtic_g78_m3_bracket_incl",
    "name": "Résolution formelle d’équations + parenthèses ",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.17",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_bracket_wo_pt2"],
    "display": {
      "color": "blue",
      "position": {
        "x": -358.2801149111417,
        "y": -34.24239008546451
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 625,
    "slug": "mtic_g78_m3_impos_eq",
    "name": "Equations impossibles ou indéterminées (Part 1)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.12",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_bracket_incl"],
    "display": {
      "color": "blue",
      "position": {
        "x": -381.4818075323402,
        "y": -241.43029393661118
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 626,
    "slug": "mtic_g78_m3_impos_eq_pt2",
    "name": "Equations impossibles ou indéterminées (Part 2)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.5",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_impos_eq"],
    "display": {
      "color": "blue",
      "position": {
        "x": -421.0057440890587,
        "y": -409.903101424669
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 627,
    "slug": "mtic_g78_m3_represent_eq",
    "name": "Representations of Equations",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.5",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_word_prob_pt2"],
    "display": {
      "color": "blue",
      "position": {
        "x": -898.8514738067945,
        "y": 87.27697021659742
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 628,
    "slug": "mtic_g78_m3_geo_perim",
    "name": "Mise en équation -graphique(s), dessins (Part 1)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.9",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_bracket_incl"],
    "display": {
      "color": "blue",
      "position": {
        "x": -369.74745691313996,
        "y": 176.78347276767371
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 629,
    "slug": "mtic_g78_m3_geo_area",
    "name": "Mise en équation -graphique(s), dessins (Part 2)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.9",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_geo_perim"],
    "display": {
      "color": "blue",
      "position": {
        "x": -459.6260854253665,
        "y": 353.3330475087569
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 630,
    "slug": "mtic_g78_m3_word_prob",
    "name": "Mise en équation-textuelle (Part 1)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.14",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_bracket_incl"],
    "display": {
      "color": "blue",
      "position": {
        "x": -562.0419445117852,
        "y": 9.357571109647012
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 631,
    "slug": "mtic_g78_m3_word_prob_pt2",
    "name": "Mise en équation-textuelle (Part 2)",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.7",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_word_prob"],
    "display": {
      "color": "blue",
      "position": {
        "x": -725.2756409741629,
        "y": 123.01299448538013
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 632,
    "slug": "mtic_g78_m3_equal_area",
    "name": "égalité-aire",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.10",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_geo_area"],
    "display": {
      "color": "red",
      "position": {
        "x": -399.77585181276936,
        "y": 520.107814442736
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 633,
    "slug": "mtic_g78_m3_alice_bob",
    "name": "Alice & Bob",
    "resource_type": "lesson",
    "content": {
      "version": "v2.2.7",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_diag"],
    "display": {
      "color": "red",
      "position": {
        "x": 737.9664796007713,
        "y": -261.08689471961003
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 634,
    "slug": "mtic_g78_m3_open",
    "name": "Open Item",
    "resource_type": "lesson",
    "content": {
      "version": "v1.0.10",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_geo_area", "mtic_g78_m3_word_prob_pt2"],
    "display": {
      "color": "black",
      "position": {
        "x": -639.7385952385252,
        "y": 292.6916003265879
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }, {
    "id": 635,
    "slug": "mtic_g78_m3_receipt",
    "name": "Facture",
    "resource_type": "lesson",
    "content": {
      "version": "v2.0.12",
      "container": "inbook_package"
    },
    "unlocked_by": ["mtic_g78_m3_diag"],
    "display": {
      "color": "red",
      "position": {
        "x": 574.2743069853798,
        "y": -290.4157497265492
      }
    },
    "config": {},
    "parent_resource_id": 373,
    "hierarchy_level": 3
  }]
});
'use strict';

angular.module('mtic').constant('MODULE_AVAILABLE_LANGUAGE', {
    //"mtic_gr78_m_meta": ["fr", "en"],
    //"mtic_gr78_m0":["fr", "en"],
    // "mtic_gr78_m1":["fr", "de"],
    // "mtic_gr78_m3":["fr", "de"],
    //"mtic_gr78_m4":["fr", "en"],

    // "mtic_gr78_m2":["fr", "en", "de", "pt"],
    "run_like_math": ["fr", "en", "de", "pt"],
    "mtic_c3_m_meta": ["fr", "en", "de", "pt"],
    "mtic_c3_m1": ["fr", "en", "de", "pt"],
    "mtic_c3_m0": ["en"],
    "mtic_c3_m3": ["en", "de", "fr", "pt"]
});
'use strict';

angular.module('mtic').constant('LOGIN_CONSTANTS', {
  "ACCOUNT_TYPES": {
    "TEACHER": "mtic_teacher",
    "STUDENT": "mtic_student",
    "VRETTA": "mtic_user"
  },
  "GROUP_TYPES": {
    "SCHOOL": "school",
    "CLASS": "mtic_class"
  }
});
'use strict';

angular.module('mtic').constant('LANGUAGE_TEXT', {
  "8147": {
    "id": 8147,
    "item_id": "mtic-login-page",
    "en": "Connecting...",
    "fr": "Se connecte...",
    "de": "Verbindet...",
    "pt": "Conectando..."
  },
  "8152": {
    "id": 8152,
    "item_id": "mtic-login-page",
    "en": "An error occurred while linking the accounts.",
    "fr": "Un problème est survenu les comptes ne sont pas reliés.",
    "de": "Während der Verbindung ist ein Fehler aufgetreten.",
    "pt": "Ocorreu um erro ao vincular as contas."
  },
  "8154": {
    "id": 8154,
    "item_id": "mtic-login-page",
    "en": "Invalid account type.",
    "fr": "Type de compte invalide.",
    "de": "Ungültiges Konto",
    "pt": "Tipo de conta inválido."
  },
  "8155": {
    "id": 8155,
    "item_id": "mtic-login-page",
    "en": "An error has occurred.",
    "fr": "Un problème est survenu.",
    "de": "Ein Fehler ist aufgetreten.",
    "pt": "Ocorreu um erro."
  },
  "8157": {
    "id": 8157,
    "item_id": "mtic-login-page",
    "en": "Invalid username or password.",
    "fr": "Nom d'utilisateur ou mot de passe invalide.",
    "de": "Ungültiger Benutzername oder Passwort",
    "pt": "Nome de utilizador ou password inválida."
  },
  "8158": {
    "id": 8158,
    "item_id": "mtic-login-page",
    "en": "Username",
    "fr": "Nom d'utilisateur",
    "de": "Benutzername",
    "pt": "Nome de utilizador"
  },
  "8159": {
    "id": 8159,
    "item_id": "mtic-login-page",
    "en": "Password",
    "fr": "Mot de passe",
    "de": "Passwort",
    "pt": "Senha"
  },
  "8160": {
    "fr": "Connexion avec IAM (Office 365)",
    "de": "Anmelden mit IAM (Office 365)",
    "pt": "Conectar-se usando IAM (Office 365)",
    "en": "Login using IAM (Office 365)"
  },
  "8165": {
    "id": 8165,
    "item_id": "mtic-login-page",
    "en": "Teacher",
    "fr": "enseignant/-e",
    "de": "Lehrer/in",
    "pt": "Titular"
  },
  "8166": {
    "id": 8166,
    "item_id": "mtic-login-page",
    "en": "Student",
    "fr": "élève",
    "de": "Schüler/-in",
    "pt": "Aluno"
  },
  "8168": {
    "id": 8168,
    "item_id": "mtic-login-page",
    "en": "IAM Account Setup",
    "fr": "Configuration du compte IAM",
    "de": "IAM Konto einrichten",
    "pt": "Configuração da conta IAM"
  },
  "8169": {
    "id": 8169,
    "item_id": "mtic-login-page",
    "en": "Welcome to MathemaTIC! Your Office 365 account is not yet connected to MathemaTIC. To link your account, please let us know what type of user you are.",
    "fr": "Bonjour chez MathemaTIC! Votre compte Office 365 n'est pas encore relié à MathemaTIC. Veuillez préciser le type de votre compte pour le relier.",
    "de": "Willkommen bei MathemaTIC! Ihr Konto Office 365 ist noch nicht mit MathemaTIC verbunden. Um Ihr Konto zu verbinden, sagen Sie uns bitte, welche Art Benutzer Sie sind.",
    "pt": "Bem-vindo a MathemaTIC! A sua conta Office 365 ainda não está ligada a MathemaTIC. Para vincular a sua conta, por favor deixe-nos saber que tipo de usuário você é."
  },
  "8170": {
    "id": 8170,
    "item_id": "mtic-login-page",
    "en": "Please indicate if you already have an account, or if you are using MathemaTIC for the first time.",
    "fr": "Indiquer s.v.p. si vous avez déjà un compte ou si vous utilisez MathemaTIC pour la première fois.",
    "de": "Bitte geben Sie an, ob Sie schon ein Konto haben, oder ob Sie MathemaTIC zum ersten Mal benutzen.",
    "pt": "Indique se você já tem uma conta, ou se é a primeira vez que está usando MathemaTIC."
  },
  "8171": {
    "id": 8171,
    "item_id": "mtic-login-page",
    "en": "Continuing",
    "fr": "Continuer",
    "de": "Weiter",
    "pt": "Continuar"
  },
  "8172": {
    "id": 8172,
    "item_id": "mtic-login-page",
    "en": "New Account",
    "fr": "Nouveau compte",
    "de": "Neues Konto",
    "pt": "Nova conta"
  },
  "8173": {
    "id": 8173,
    "item_id": "mtic-login-page",
    "en": "Logout of Office 365 IAM",
    "fr": "Se déconnecter d'Office 365",
    "de": "Verbindung zu Office 365 IAM trennen",
    "pt": "Sair do Office 365 IAM"
  },
  "8174": {
    "id": 8174,
    "item_id": "mtic-login-page",
    "en": "Connect your existing account by logging in with your old username and password.",
    "fr": "Relier votre compte existant en vous connectant à l'aide du vieux nom d'utilisateur et vieux mot de passe.",
    "de": "Verbinden Sie das bestehende Konto, indem Sie sich mit ihrem alten Benutzernamen und Passowort anmelden.",
    "pt": "Conecte-se com a sua conta existente, utilizando o seu antigo nome de utilizador e password."
  },
  "8175": {
    "id": 8175,
    "item_id": "mtic-login-page",
    "en": "Please enter the unique class code provided to you by your instructor.",
    "fr": "Indiquer s.v.p. le code classe obtenu par votre enseignant.",
    "de": "Bitte gib den Code für die Klasse ein, den du von deinem Lehrer erhalten hast.",
    "pt": "Digite o código de classe único fornecido pelo seu instrutor."
  },
  "8176": {
    "id": 8176,
    "item_id": "mtic-login-page",
    "en": "Please enter the teacher access code provided to you by SCRIPT.",
    "fr": "Indiquer s.v.p. le code d'accès enseignant obtenu par SCRIPT.",
    "de": "Bitte geben Sie den Code für den Zugang als Lehrer ein, den Sie vom SCRIPT erhalten haben.",
    "pt": "Por favor insira o código de acesso professor fornecido pelo SCRIPT."
  },
  "8178": {
    "id": 8178,
    "item_id": "mtic-login-page",
    "en": "Login and link IAM - Office 365",
    "fr": "Connexion et lien IAM - Office 365",
    "de": "Anmelden und Verbinden mit IAM - Office 365",
    "pt": "Conectar-se e vincular IAM - Office 365"
  },
  "8179": {
    "id": 8179,
    "item_id": "mtic-login-page",
    "en": "Validate and Login",
    "fr": "Valider et se connecter",
    "de": "Bestätigen und Anmelden",
    "pt": "Validação e conectar-se"
  },
  "8188": {
    "id": 8188,
    "item_id": "mtic-teacher-admin",
    "en": "Login",
    "fr": "Connexion",
    "de": "Anmelden",
    "pt": "Conectar-se"
  },
  "8189": {
    "id": 10763,
    "en": "READ MORE",
    "fr": "LIRE LA SUITE",
    "de": "WEITERLESEN",
    "pt": "CONSULTE MAIS INFORMAÇÃO"
  },
  "8190": {
    "id": 8190,
    "en": "Register",
    "fr": "Enregistrer",
    "de": "Registrieren",
    "pt": "Registrar"
  },
  "8191": {
    "id": 8191,
    "en": "Forgot Password",
    "fr": "Mot de passe oublié",
    "de": "Passwort vergessen",
    "pt": "Esqueceu a senha"
  },
  "8192": {
    "id": 8192,
    "en": "Enter Credentials",
    "fr": "Entrer les informations d'identification",
    "de": "Anmeldedaten eingeben",
    "pt": "Insira credenciais"
  },
  "8193": {
    "id": 8193,
    "en": "Password Recovery",
    "fr": "Récupération de mot de passe",
    "de": "Passwort-Wiederherstellung",
    "pt": "Recuperação de senha"
  },
  "8194": {
    "id": 8194,
    "en": "Send Link",
    "fr": "Envoyer un lien",
    "de": "Link senden",
    "pt": "Enviar Link"
  },
  "8195": {
    "id": 8195,
    "en": "Email Address",
    "fr": "Adresse e-mail",
    "de": "E-Mail-Addresse",
    "pt": "Endereço de e-mail"
  },
  "8253": {
    "id": 8253,
    "item_id": "mtic-login-page",
    "en": "Invalid access code",
    "fr": "Code d'accès invalide",
    "de": "Zugangscode ist ungültig",
    "pt": "Código de acesso incorreto"
  },
  "8254": {
    "id": 8254,
    "item_id": "mtic-login-page",
    "en": "Information valid, please wait as we log you in ...",
    "fr": "Information valide, attendez pendant qu'on vous connecte....",
    "de": "Gültige Zugangsdaten, warten Sie, dass die Verbindung hergestellt wird.",
    "pt": "Dados válidos, espere pela conexão..."
  },
  "8795": {
    "id": 8795,
    "item_id": "mtic-login-page",
    "en": "class code",
    "fr": "code classe",
    "de": "Klassencode",
    "pt": "código de classe"
  },
  "9015": {
    "id": 9015,
    "item_id": "mtic-app2",
    "en": "Don't have an account yet?",
    "fr": "N'as-tu pas encore de compte?",
    "de": "Du hast noch kein Konto?",
    "pt": "Não tens uma conta?"
  },
  "10734": {
    "id": 10734,
    "en": "Understand (Island of the Sun)",
    "fr": "comprendre (Île du Soleil)",
    "de": "Verstehen (Sonneninsel)",
    "pt": "Compreender (Ilha do sol)"
  },
  "10735": {
    "id": 10735,
    "en": "Understand (Lunch at the Airport)",
    "fr": "comprendre (Déjeuner à l'aéroport)",
    "de": "Verstehen (Mittagessen am Flughafen)",
    "pt": "Compreender (Almoço no aeroporto)"
  },
  "10736": {
    "id": 10736,
    "en": "Understand (Shuttle Bus Tickets)",
    "fr": "comprendre (Tiquets de bus)",
    "de": "Verstehen (Fahrscheine für den Bus)",
    "pt": "Compreender (Bilhetes Autocarro)"
  },
  "10737": {
    "id": 10737,
    "en": "Understand (Monkeys)",
    "fr": "comprendre (Singes)",
    "de": "Verstehen (Affen)",
    "pt": "Compreender (Macacos)"
  },
  "10738": {
    "id": 10738,
    "en": "Understand (Flamingos)",
    "fr": "comprendre (Flamants)",
    "de": "Verstehen (Flamingos)",
    "pt": "Compreender (Flamingos)"
  },
  "10739": {
    "id": 10739,
    "en": "Plan (Bakery)",
    "fr": "planifier (Boulangerie)",
    "de": "Planen (Bäckerei)",
    "pt": "Planificar (Padaria)"
  },
  "10740": {
    "id": 10740,
    "en": "Plan (Schueberfouer Tickets)",
    "fr": "planifier (Billets pour la Schueberfouer)",
    "de": "Planen (Tickets auf der Schueberfouer)",
    "pt": "Planificar (Senhas na Schueberfouer)"
  },
  "10741": {
    "id": 10741,
    "en": "Plan (Roller Coaster)",
    "fr": "planifier (Montagne russe)",
    "de": "Planen (Achterbahn)",
    "pt": "Planificar (Montanha-russa)"
  },
  "10742": {
    "id": 10742,
    "en": "Plan (Chocolate stand)",
    "fr": "planifier (Chocolats)",
    "de": "Planen (Schokoladenstand)",
    "pt": "Planificar (Stand de chocolates)"
  },
  "10743": {
    "id": 10743,
    "en": "Solve (Bakery)",
    "fr": "calculer (Boulangerie)",
    "de": "Rechnen (Bäckerei)",
    "pt": "Calcular (Padaria)"
  },
  "10744": {
    "id": 10744,
    "en": "Solve (Schueberfouer Tickets)",
    "fr": "calculer (Billets pour  la Schueberfouer)",
    "de": "Rechnen (Tickets auf der Schueberfouer)",
    "pt": "Calcular (Senhas na Schueberfouer)"
  },
  "10745": {
    "id": 10745,
    "en": "Solve (Roller Coaster)",
    "fr": "calculer (Montagne russe)",
    "de": "Rechnen (Achterbahn)",
    "pt": "Calcular (Montanha-russa)"
  },
  "10746": {
    "id": 10746,
    "en": "Solve (Chocolate Stand)",
    "fr": "calculer (Chocolats)",
    "de": "Rechnen (Schokoladenstand)",
    "pt": "Calcular (Stand de chocolates)"
  },
  "10747": {
    "id": 10747,
    "en": "Check (Logbook)",
    "fr": "verifier (Carnet de bord)",
    "de": "Prüfen (Logbuch)",
    "pt": "Verificar (Diário de bordo)"
  },
  "10748": {
    "id": 10748,
    "en": "Elephants",
    "fr": "Eléphants",
    "de": "Elefanten",
    "pt": "Elefantes"
  },
  "10749": {
    "id": 10749,
    "en": "Aquarium",
    "fr": "Aquarium",
    "de": "Aquarium",
    "pt": "Aquário"
  },
  "10750": {
    "id": 10750,
    "en": "Train (Luxembourg-Paris)",
    "fr": "Train (Luxembourg-Paris)",
    "de": "Zug (Luxembourg-Paris)",
    "pt": "Comboio (Luxemburgo-Paris)"
  },
  "10751": {
    "id": 10751,
    "en": "Bike tour",
    "fr": "Randonnée à vélo",
    "de": "Fahrradtour",
    "pt": "Volta de bicicleta"
  },
  "10752": {
    "id": 10752,
    "en": "Stickers",
    "fr": "Autocollants",
    "de": "Sticker",
    "pt": "Autocolantes"
  },
  "10753": {
    "id": 10753,
    "en": "The Skateshop",
    "fr": "Le skateshop",
    "de": "Der Skateshop",
    "pt": "O Skateshop"
  },
  "10754": {
    "id": 10754,
    "en": "Souvenirs",
    "fr": "Souvenirs",
    "de": "Andenken",
    "pt": "Loja do jardim zoológico"
  },
  "10755": {
    "id": 10755,
    "en": "Lemurs at the Park",
    "fr": "Lémures au zoo",
    "de": "Lemuren im Zoo",
    "pt": "Lémures no jardim zoológico"
  },
  "10756": {
    "id": 10756,
    "en": "Plane (Findel-Porto)",
    "fr": "Avion (Findel-Porto)",
    "de": "Flugzeug (Findel-Porto)",
    "pt": "Avião (Findel-Porto)"
  },
  "10757": {
    "id": 10757,
    "en": "Visiting Granny",
    "fr": "Visite chez grand-mère",
    "de": "Besuch bei Oma",
    "pt": "Visitar a avó"
  },
  "10758": {
    "id": 10758,
    "en": "Jump",
    "fr": "Saut en longueur",
    "de": "Weitsprung",
    "pt": "Salto"
  },
  "10759": {
    "id": 10759,
    "en": "Camping",
    "fr": "Camping",
    "de": "Zelten",
    "pt": "Acampar"
  },
  "10760": {
    "id": 10760,
    "en": "The Souvenir Shop",
    "fr": "Magasin de souvenirs",
    "de": "Der Andenkenladen",
    "pt": "Loja de lembranças"
  },
  "10761": {
    "id": 10761,
    "en": "The Tram",
    "fr": "Le tramway",
    "de": "Die Straßenbahn",
    "pt": "O carro elétrico"
  },
  "10762": {
    "id": 10762,
    "en": "Tower of Cubes",
    "fr": "Tour avec des cubes",
    "de": "Turm aus Bauklötzen",
    "pt": "Torre de blocos"
  },

  /// Likely No Longer needed/ replaced by the mtic_app_2 batch below.
  // "11281": {
  //   "fr": "pas bien",
  //   "en": "not well",
  //   "pt": "mal",
  //   "de": "gar nicht"
  // },
  // "11282": {
  //   "fr": "un peut",
  //   "en": "barely",
  //   "pt": "quase",
  //   "de": "nicht so gut"
  // },
  // "11283": {
  //   "fr": "bien",
  //   "en": "well",
  //   "pt": "bem",
  //   "de": "gut"
  // },
  // "11284": {
  //   "fr": "très bien",
  //   "en": "very well",
  //   "pt": "muito bem",
  //   "de": "sehr gut"
  // },
  // "11285": {
  //   "fr": "Comment as-tu appris?",
  //   "en": "How did you learn?",
  //   "pt": "Como é que aprendeste?",
  //   "de": "Wie hast du gelernt?"
  // },
  // "11286": {
  //   "fr": "La résolution de problème",
  //   "en": "Problem Solving",
  //   "pt": "Resolução de problemas",
  //   "de": "Sachrechnen"
  // },
  // "11287": {
  //   "fr": "Rejouer",
  //   "en": "Replay",
  //   "pt": "Repetir",
  //   "de": "Wiederholen"
  // },
  // "11288": {
  //   "id": 11288,
  //   "en": "Continue",
  //   "fr": "Continuer",
  //   "de": "Weiter",
  //   "pt": "Continuar"
  // },
  // "11289": {
  //   "id": 11289,
  //   "en": "Submit",
  //   "fr": "Valider",
  //   "de": "Senden",
  //   "pt": "Submeter"
  // },
  // "11290": {
  //   "id": 11290,
  //   "en": "Item Complete!",
  //   "fr": "Item complété!",
  //   "de": "Du hast die Aufgabe beendet!",
  //   "pt": "Item Concluído!"
  // },
  // "11291": {
  //   "fr": "Nom d'utilisateur",
  //   "en": "Username",
  //   "pt": "Nome de utilizador",
  //   "de": "Benutzername"
  // },
  // "11292": {
  //   "id": 11292,
  //   "item_id": "mtic_app_2",
  //   "en": "Password",
  //   "fr": "Mot de passe",
  //   "de": "Passwort",
  //   "pt": "Palavra-passe"
  // },
  // "11293": {
  //   "fr": "Tu n'as pas de compte?",
  //   "en": "Don't have an account?",
  //   "pt": "Não tem conta?",
  //   "de": "Haben Sie noch kein Benutzerkonto?"
  // },
  // "11294": {
  //   "id": 11294,
  //   "item_id": "mtic_app_2",
  //   "en": "Sign Up",
  //   "fr": "Connexion",
  //   "de": "Neu anmelden",
  //   "pt": "Criar conta"
  // },
  // "11295": {
  //   "id": 11295,
  //   "item_id": "mtic_app_2",
  //   "en": "student",
  //   "fr": "Élève",
  //   "de": "Schüler/-in",
  //   "pt": "Aluno"
  // },
  // "11296": {
  //   "id": 11296,
  //   "item_id": "mtic_app_2",
  //   "en": "teacher",
  //   "fr": "Enseignant",
  //   "de": "Lehrer/in",
  //   "pt": "Professor"
  // },
  // "11297": {
  //   "id": 11297,
  //   "item_id": "mtic_app_2",
  //   "en": "Teacher ID",
  //   "fr": "Code Enseignant",
  //   "de": "Lehrer ID",
  //   "pt": "ID do Professor"
  // },
  // "11298": {
  //   "id": 11298,
  //   "item_id": "mtic_app_2",
  //   "en": "Class ID",
  //   "fr": "Code de classe",
  //   "de": "Klassencode",
  //   "pt": "ID da Classe"
  // },
  // "11299": {
  //   "id": 11299,
  //   "item_id": "mtic_app_2",
  //   "en": "First Name",
  //   "fr": "Prénom",
  //   "de": "Vorname",
  //   "pt": "Nome"
  // },
  // "11300": {
  //   "id": 11300,
  //   "item_id": "mtic_app_2",
  //   "en": "Last Name",
  //   "fr": "Nom de famille",
  //   "de": "Nachname",
  //   "pt": "Apelido"
  // },
  // "11301": {
  //   "id": 11301,
  //   "item_id": "mtic_app_2",
  //   "en": "Confirm Password",
  //   "fr": "Confirmer le mot de passe",
  //   "de": "Passwort bestätigen",
  //   "pt": "Confirmar palavra-passe"
  // },
  // "11302": {
  //   "fr": "Tu as déjà un compte?",
  //   "en": "Already have an account?",
  //   "pt": "Já tem conta?",
  //   "de": "Hast du schon ein account?"
  // },
  // "11303": {
  //   "fr": "Code d'accès",
  //   "en": "Access Code",
  //   "pt": "Código de Acesso",
  //   "de": "Zugangscode"
  // },
  // "11304": {
  //   "fr": "Adresse mail",
  //   "en": "Email",
  //   "pt": "Email",
  //   "de": "Email-Adresse"
  // },
  // "11305": {
  //   "id": 11305,
  //   "item_id": "mtic_app_2",
  //   "en": "Logout",
  //   "fr": "Déconnexion",
  //   "de": "Verbindung trennen",
  //   "pt": "Terminar Sessão"
  // },
  // "11306": {
  //   "fr": "Veuillez remplir le nom d'utilisateur et le mot de passe",
  //   "en": "Please fill in both username and password",
  //   "pt": "Por favor, introduza o nome do utilizador e a palavra-passe",
  //   "de": "Bitte geben Sie Ihre Nutzername und Passwort ein."
  // },
  // "11307": {
  //   "fr": "Nom d'utilisateur introuvable",
  //   "en": "Username is not found",
  //   "pt": "Utilizador não encontrado",
  //   "de": "Der angegebene Nutzername konnte nicht gefunden werden!"
  // },
  // "11308": {
  //   "fr": "Mot de passe invalide",
  //   "en": "Invalid Password",
  //   "pt": "Palavra-passe inválida",
  //   "de": "Das Passwort ist ungültig."
  // },
  // "11309": {
  //   "fr": "Veuillez remplir tous les champs",
  //   "en": "Please complete all fields to sign up",
  //   "pt": "Por favor, complete todos os campos para se registar",
  //   "de": "Füllen Sie bitte alle Felder aus um sich anzumelden."
  // },
  // "11310": {
  //   "fr": "Le code d'accès entré n'est pas valide",
  //   "en": "The access code you entered is not valid",
  //   "pt": "O código de acesso que introduziu não é válido",
  //   "de": "Der eingegebene Zugangscode ist ungültig."
  // },
  // "11311": {
  //   "fr": "Ce nom d'utilisateur existe déjà",
  //   "en": "This username already exists",
  //   "pt": "O código de acesso que introduziu não é válido",
  //   "de": "Der Benutzername ist schon belegt."
  // },
  // "11312": {
  //   "fr": "Code de classe ou code enseignant invalide",
  //   "en": "Invalid Class ID or Teacher ID",
  //   "pt": "ID de Lição ou ID de Professor inválido",
  //   "de": "Klassencode oder Lehrer ID ungültig."
  // },
  // "11313": {
  //   "fr": "Un problème est survenu. Veuillez vérifier votre connexion Internet",
  //   "en": "Something went wrong, please check your internet connection",
  //   "pt": "Algo correu mal, por favor verifique a sua conexão.",
  //   "de": "Verbindungsfehler,\nbitte überprüfen Sie die Internetverbindung."
  // },
  // "11319": {
  //   "fr": "connexion...",
  //   "en": "connecting...",
  //   "pt": "a ligar...",
  //   "de": "Verbinden..."
  // },
  // "11320": {
  //   "fr": "Connexion échouée",
  //   "en": "Login failed",
  //   "pt": "O login falhou",
  //   "de": "Die Anmeldung ist fehlgeschlagen."
  // },
  // "11322": {
  //   "fr": "Il semblerait que votre session ait expiré",
  //   "en": "It appears that your session has expired.",
  //   "pt": "Parece que a sua sessão expirou.",
  //   "de": "Ihre Anmeldung ist abgelaufen."
  // },
  // "11323": {
  //   "fr": "Veuillez entrer votre mot de passe pour continuer",
  //   "en": "Please log back in with your password to continue.",
  //   "pt": "Por favor, faça novamente o login com a sua palavra-passe para continuar.",
  //   "de": "Bitte melden Sie sich mit Ihren Passwort wieder ein, um weiterzumachen."
  // },
  // "11324": {
  //   "fr": "Échec de connexion au serveur MathemaTIC, veuillez vérifier votre connexion internet.",
  //   "en": "Failed to to connect to the MathemaTIC servers, please see that you have an internet connection.",
  //   "pt": "A ligação aos servidores da MathemaTIC falhou, por favor, veifique a sua ligação à internet.",
  //   "de": "Die Verbindung mit dem MathemaTIC Server konnte nicht hergestellt werden. Bitte überprüfen Sie die Internetverbindung."
  // },
  // "11325": {
  //   "fr": "Le code enseignant doit être un numéro",
  //   "en": "The Teacher ID must be a number",
  //   "pt": "A ID do Professor tem de ser um número",
  //   "de": "Lehrer ID muss eine Zahl sein."
  // },
  // "11326": {
  //   "fr": "Le code de classe doit être un numéro",
  //   "en": "The Class ID must be a number",
  //   "pt": "A ID da Aula tem de ser um número",
  //   "de": "Klassencode muss eine Zahl sein."
  // },
  // "11327": {
  //   "fr": "Les mots de passe ne concordent pas",
  //   "en": "Make sure your password matches",
  //   "pt": "Certifique-se que a palavra-passe é a mesma",
  //   "de": "Bitte bestimmen sie Ihr Passwort."
  // },
  // "11328": {
  //   "fr": "Veuillez remplir tous les champs",
  //   "en": "Please fill in all fields",
  //   "pt": "Por favor, preencha todos os campos",
  //   "de": "Füllen Sie bitte alle Felder aus."
  // },
  // "11329": {
  //   "fr": "Les mots de passe ne concordent pas",
  //   "en": "Make sure your password matches",
  //   "pt": "Certifique-se que a palavra-passe é a mesma",
  //   "de": "Bitte bestimmen sie Ihr Passwort."
  // },
  // "11330": {
  //   "fr": "Veuillez entrer une adresse mail valide",
  //   "en": "Please enter a valid email address",
  //   "pt": "Por favor, introduza um endereço de email válido",
  //   "de": "Bitte geben Sie eine gültige E-Mail-Adresse  ein."
  // },
  // "11784": {
  //   "fr": "Votre navigateur n'est actuellement pas supporté par cette page.",
  //   "en": "Your browser is currently not supported by this page.",
  //   "pt": "O seu navegador atual não é suportado por esta página",
  //   "de": "Ihr Browser wird derzeit von dieser Seite nicht unterstützt."
  // },
  // "11785": {
  //   "fr": "Veuillez revisiter cette page en utilisant Google Chrome.",
  //   "en": "Please revisit this page using Google Chrome.",
  //   "pt": "Por favor, visite novamente esta página usando o Google Chrome.",
  //   "de": "Bitte besuchen Sie diese Seite erneut mit Google Chrome."
  // },


  "12661": {
    "id": 12661,
    "en": "Set a limit for how many times the student can redo the task",
    "fr": "Définissez une limite pour combien de fois l'élève peut refaire la tâche",
    "de": "Obergrenze setzen für die Anzahl der Versuche, wie oft die Schüler eine Aufgabe erneut bearbeiten können.",
    "pt": "Set a limit for how many times the student can redo the task"
  },
  "12662": {
    "id": 12662,
    "en": "Force reattempt",
    "fr": "Forcer une nouvelle tentative.",
    "de": "Neustart erzwingen",
    "pt": "Force nova tentativa"
  },
  "12663": {
    "id": 12663,
    "en": "Set the lock behaviour of the task.",
    "fr": "Définir le mode de verrouillage pour la tâche.",
    "de": "Sperrmodus für die Aufgabe festlegen.",
    "pt": "Set the lock behaviour of the task"
  },
  "12664": {
    "id": 12664,
    "en": "Default",
    "fr": "Défaut",
    "de": "Standard",
    "pt": "Pré-definido"
  },
  "12665": {
    "id": 12665,
    "en": "Unlock path",
    "fr": "Chemin débloqué",
    "de": "Freischalten",
    "pt": "Desbloquear caminho"
  },
  "12666": {
    "id": 12666,
    "en": "Redo completed items",
    "fr": "Items réinitialisés",
    "de": "Abgeschloßene Übung wiederholen",
    "pt": "Refazer os itens concluidos"
  },
  "12667": {
    "id": 12667,
    "en": "Default Behaviour",
    "fr": "Comportement par défaut",
    "de": "Standard Verhalten",
    "pt": "Comportamento pré-definido"
  },
  "12668": {
    "id": 12668,
    "en": "Unlock",
    "fr": "Débloquer",
    "de": "Entsperren",
    "pt": "Desbloquear"
  },
  "12669": {
    "id": 12669,
    "en": "Lock",
    "fr": "Bloquer",
    "de": "Sperren",
    "pt": "Bloqueio"
  },
  "12670": {
    "id": 12670,
    "en": "Options",
    "fr": "Options",
    "de": "Optionen",
    "pt": "Opções"
  },
  "12671": {
    "id": 12671,
    "en": "PUBLISH",
    "fr": "PUBLIER",
    "de": "Veröffentlichen",
    "pt": "PUBLICAR"
  },
  "12672": {
    "id": 12672,
    "en": "UNPUBLISH",
    "fr": "NON PUBLIER",
    "de": "Nicht veröffentlichen",
    "pt": "NÃO PUBLICAR"
  },
  "12673": {
    "id": 12673,
    "en": "INFO",
    "fr": "INFO",
    "de": "Info",
    "pt": "INFO"
  },
  "12674": {
    "id": 12674,
    "en": "EDIT",
    "fr": "MODIFIER",
    "de": "Bearbeiten",
    "pt": "EDITAR"
  },
  "12675": {
    "id": 12675,
    "en": "AGENDA",
    "fr": "AGENDA",
    "de": "AGENDA",
    "pt": "AGENDA"
  },
  "12676": {
    "id": 12676,
    "en": "Create",
    "fr": "Créer",
    "de": "Erstellen",
    "pt": "Criar"
  },
  "12677": {
    "id": 12677,
    "en": "Delete",
    "fr": "Supprimer",
    "de": "Löschen",
    "pt": "Apagar"
  },
  "12678": {
    "id": 12678,
    "en": "Update",
    "fr": "Mettre à jour",
    "de": "Aktualisieren",
    "pt": "Atualizar"
  },
  "12679": {
    "id": 12679,
    "en": "Cancel",
    "fr": "Annuler",
    "de": "Abbrechen",
    "pt": "Cancelar"
  },
  "12680": {
    "id": 12680,
    "en": "Task",
    "fr": "Tâche",
    "de": "Aufgabe",
    "pt": "Tarefa"
  },
  "12681": {
    "id": 12681,
    "en": "Update Task",
    "fr": "Mettre à jour les tâches",
    "de": "Aufgaben aktualisieren",
    "pt": "Atualizar tarefa"
  },
  "12682": {
    "id": 12682,
    "en": "Add Resource",
    "fr": "Ajouter une tâche",
    "de": "Aufgabe hinzufügen",
    "pt": "Adicionar Recursoe"
  },
  "12683": {
    "id": 12683,
    "en": "Custom Tasks",
    "fr": "Tâches Personnalisées",
    "de": "personalisierte Aufgaben",
    "pt": "Tarefas personalizadas"
  },
  "12684": {
    "id": 12684,
    "en": "Add Student",
    "fr": "Ajouter un étudiant",
    "de": "Schüler hinzufügen",
    "pt": "Adicionar Estudante"
  },
  "12685": {
    "id": 12685,
    "en": "Students",
    "fr": "Étudiants",
    "de": "Schüler",
    "pt": "Estudantes"
  },
  "12686": {
    "id": 12686,
    "en": "Assignee:",
    "fr": "Destinataire:",
    "de": "Bevollmächtigter:",
    "pt": "Avaliador:"
  },
  "12687": {
    "id": 12687,
    "en": "Date:",
    "fr": "Date:",
    "de": "Datum:",
    "pt": "Data:"
  },
  "12688": {
    "id": 12688,
    "en": "Title:",
    "fr": "Titre:",
    "de": "Titel:",
    "pt": "Título:"
  },
  "12689": {
    "id": 12689,
    "en": "An error has occurred!",
    "fr": "Une erreur est survenue!",
    "de": "Ein Fehler ist aufgetreten!",
    "pt": "Ocorreu um erro!"
  },
  "12690": {
    "id": 12690,
    "en": "Create New Agenda",
    "fr": "Créer un nouvel agenda",
    "de": "Neue Agenda erstellen",
    "pt": "Criar Nova Agenda"
  },
  "12691": {
    "id": 12691,
    "en": "NEW AGENDA",
    "fr": "NOUVEL AGENDA",
    "de": "NEUE AGENDA",
    "pt": "NOVA AGENDA"
  },
  "12692": {
    "id": 12692,
    "en": "EDIT AGENDA",
    "fr": "MODIFIER L'AGENDA",
    "de": "AGENDA BEARBEITEN",
    "pt": "EDITAR AGENDA"
  },
  "12693": {
    "id": 12693,
    "en": "If you do not see the window, please check that your pop-up blocker is not blocking it.",
    "fr": "Si vous ne voyez pas la fenêtre, vérifiez que votre bloqueur de pop-up ne le bloque pas.",
    "de": "Wenn sich kein Fenster öffnet, stellen Sie sicher, dass Ihr Pop-up-Blocker dies nicht verhindert.",
    "pt": "Se não conseguir visualizar a janela, por favor verifique se o seu bloqueador de pop-ups não a estará a bloquear."
  },
  "12694": {
    "id": 12694,
    "en": "Your Lesson is opened in another window, waiting for you to finish!",
    "fr": "Votre leçon est ouverte dans une autre fenêtre, en attendant que vous finissiez!",
    "de": "Ihre Lektion ist in einem einem anderen Fenster geöffnet und wartet darauf, von Ihnen beendet zu werden.",
    "pt": "A Sua Aula encontra-se aberta numa outra janela, à espera que a conclua!"
  },
  "16290": {
    "id": 16290,
    "en": "Open",
    "fr": "Ouvrir",
    "de": "Öffnen",
    "pt": "Abrir"
  },

  "22598": {
    "id": 22598,
    "en": "(none)",
    "fr": "(aucun)",
    "de": "(Keine Auswahl)",
    "pt": "(nenhum)"
  },
  "22599": {
    "id": 22599,
    "en": "Click to Add Items",
    "fr": "Cliquez pour ajouter des articles",
    "de": "Klicken Sie um Übungen hinzuzufügen",
    "pt": "Clique para adicionar itens"
  },
  "22600": {
    "id": 22600,
    "en": "Send to students",
    "fr": "Envoyer aux étudiants",
    "de": "Zum Schüler senden",
    "pt": "Enviar aos estudantes"
  },
  "22601": {
    "id": 22601,
    "en": "Do you want to make this assignment available to your students now?",
    "fr": "Voulez-vous rendre cette tâche disponible à vos élèves maintenant?",
    "de": "Möchten Sie diese Übung jetzt Ihren Schülern zugänglich machen?",
    "pt": "Quer disponibilizar agora este exercício para todos os seus estudantes?"
  },
  "22602": {
    "id": 22602,
    "en": "Done",
    "fr": "Terminé",
    "de": "Fertig",
    "pt": "Feito"
  },
  "22603": {
    "id": 22603,
    "en": "Save Draft",
    "fr": "Sauvegarder le brouillon",
    "de": "Entwurf speichern",
    "pt": "Guardar Rascunho"
  },
  "22604": {
    "id": 22604,
    "en": "Date",
    "fr": "date",
    "de": "Datum",
    "pt": "Data"
  },
  "22605": {
    "id": 22605,
    "en": "Custom Task",
    "fr": "Tâche personnalisée",
    "de": "Benutzerdefinierte Aufgabe",
    "pt": "Tarefa Personalizada"
  },
  "22606": {
    "id": 22606,
    "en": "Options",
    "fr": "Options",
    "de": "Optionen",
    "pt": "Opções"
  },
  "22607": {
    "id": 22607,
    "en": "Please select items from right",
    "fr": "Veuillez sélectionner les éléments de droite",
    "de": "Bitte Übungen von rechts auswählen",
    "pt": "Por favor, selecione itens da direita"
  },
  "22608": {
    "id": 22608,
    "en": "Search for items...",
    "fr": "rechercher des items ...",
    "de": "Nach Übungen suchen...",
    "pt": "Pesquisar itens..."
  },
  "22609": {
    "id": 22609,
    "en": "Name",
    "fr": "Titre",
    "de": "Name",
    "pt": "Nome"
  },
  "22610": {
    "id": 22610,
    "en": "URL",
    "fr": "URL",
    "de": "URL",
    "pt": "URL"
  },
  "22946": {
    "id": 22946,
    "en": "Please enter a valid agenda description.",
    "fr": "Veuillez entrer une description de l'agenda valide.",
    "de": "Bitte geben Sie eine gültige Agenda Beschreibung ein.",
    "pt": "Por favor, introduza uma descrição de agenda válida."
  },
  "22947": {
    "id": 22947,
    "en": "Please assign items.",
    "fr": "Veuillez assigner des items.",
    "de": "Bitte wählen Sie eine Übung.",
    "pt": "Por favor, atribua itens."
  },
  "22948": {
    "id": 22948,
    "en": "Click to edit",
    "fr": "Cliquez pour modifier",
    "de": "Zum Bearbeiten anklicken ",
    "pt": "Clique para editar"
  },
  "22949": {
    "id": 22949,
    "en": "Click for info",
    "fr": "Cliquez pour des informations",
    "de": "Klicken Sie für Information",
    "pt": "Clique para info"
  },
  "22950": {
    "id": 22950,
    "en": "The date that you selected has passed. Please select a future date.",
    "fr": "La date que vous avez sélectionnée est passée. Veuillez sélectionner une date future.",
    "de": "Das ausgewählte Datum ist vorbei. Bitte wählen Sie ein zukünftiges Datum aus.",
    "pt": "A data que selecionou já passou. Por favor, selecione uma data futura."
  },
  "22951": {
    "id": 22951,
    "en": "Items assigned:",
    "fr": "Items assignés:",
    "de": "Zugewiesene Übung:",
    "pt": "Itens atribuídos:"
  },
  "22952": {
    "id": 22952,
    "en": "Closing Date:",
    "fr": "Date de clôture:",
    "de": "Meldeschluss:",
    "pt": "Data do fim:"
  },

  "login": {
    "en": "Login",
    "fr": "Connexion",
    "de": "Anmelden",
    "pt": "Login"
  },

  // mtic2_IAM_translations
  "14455": {
    "id": 14455,
    "item_id": "mtic2_IAM_translations",
    "en": "MathemaTIC - for cycles 3 and 4 and for secondary education. The environment is currently under maintainance and will be available from Friday 29th of September. In the meantime we advise you to update SCOLARIA and activate the IAM accounts of your students. Thank you for your patience.",
    "fr": "MathemaTIC - pour les cycles 3 et 4 et pour le cycle inférieur.\nL’environnement est en cours de maintenance et sera disponible à partir du vendredi 29 septembre. En attendant nous vous conseillons de mettre à jour SCOLARIA et d’activer les comptes IAM de vos élèves.\nMerci de votre patience.",
    "de": "MathemaTIC - für die Zyklen 3 und 4 und für den Untergrad der Sekundarstufe. Die Plattform wird gerade überarbeitet und wird vom 29. September an wieder zugänglich sein. In der Zwischenzeit empfehlen wir Ihnen, SCOLARIA zu aktualisieren und die IAM-Konten Ihrer Schüler zu aktivieren. Vielen Dank für Ihr Verständnis.",
    "pt": "Matemática - para os ciclos 3 e 4 e para o ensino secundário. O ambiente de aprendizagem encontra-se em manutenção e estará disponível a partir de sexta-feira, 29 de setembro. Entretanto, aconselhamos atualizar o SCOLARIA e ativar as contas IAM dos seus alunos. Obrigado pela sua paciência."
  },
  "14456": {
    "id": 14456,
    "item_id": "mtic2_IAM_translations",
    "en": "Recommended System Requirements",
    "fr": "Configuration système recommandée",
    "de": "Empfohlene Systemvoraussetzungen",
    "pt": "Requisitos de sistema recomendados"
  },
  "14457": {
    "id": 14457,
    "item_id": "mtic2_IAM_translations",
    "en": "RECOMMENDED",
    "fr": "RECOMMANDÉ",
    "de": "EMPFOHLEN",
    "pt": "RECOMENDADO"
  },
  "14458": {
    "id": 14458,
    "item_id": "mtic2_IAM_translations",
    "en": "ALSO TESTING ON",
    "fr": "ÉGALEMENT TESTÉ SUR",
    "de": "AUCH GETESTET FÜR",
    "pt": "TAMBÉM TESTADO COM"
  },
  "14459": {
    "id": 14459,
    "item_id": "mtic2_IAM_translations",
    "en": "COMING SOON",
    "fr": "PROCHAINEMENT",
    "de": "IN KÜRZE",
    "pt": "EM BREVE"
  },
  "14460": {
    "id": 14460,
    "item_id": "mtic2_IAM_translations",
    "en": "with up to date Flash Player\n",
    "fr": "avec Flash Player mis à jour",
    "de": "mit aktualisiertem Flash Player",
    "pt": "com o Flash Player atualizado"
  },
  "14461": {
    "id": 14461,
    "item_id": "mtic2_IAM_translations",
    "en": "GET THE APP",
    "fr": "OBTENEZ L'APPLICATION",
    "de": "APP HERUNTERLADEN",
    "pt": "BAIXE O APLICATIVO"
  },
  "14462": {
    "id": 14462,
    "item_id": "mtic2_IAM_translations",
    "en": "Setting up IAM for Kids",
    "fr": "Configuration d'IAM pour les enfants",
    "de": "IAM for Kids einrichten",
    "pt": "Configurar IAM for Kids"
  },
  "14463": {
    "id": 14463,
    "item_id": "mtic2_IAM_translations",
    "en": "Other Login",
    "fr": "Autre connexion",
    "de": "Andere Anmeldung",
    "pt": "Outra conexão"
  },
  "14464": {
    "id": 14464,
    "item_id": "mtic2_IAM_translations",
    "en": "Download",
    "fr": "Télécharger",
    "de": "Download",
    "pt": "Download"
  },
  "14465": {
    "id": 14465,
    "item_id": "mtic2_IAM_translations",
    "en": "Rights of use",
    "fr": "Droits d'utilisation",
    "de": "Nutzungsrechte",
    "pt": "Direitos de uso"
  },
  "14466": {
    "id": 14466,
    "item_id": "mtic2_IAM_translations",
    "en": "Embed",
    "fr": "Intégrer",
    "de": "Einbetten",
    "pt": "Incorporar"
  },
  "14501": {
    "id": 14501,
    "item_id": "mtic2_IAM_translations",
    "en": "dedicated video\n",
    "fr": "vidéo dédiée",
    "de": "Grafikspeicher",
    "pt": "vídeo dedicado"
  },
  "14502": {
    "id": 14502,
    "item_id": "mtic2_IAM_translations",
    "en": "Fall 2017 Release\n",
    "fr": "Sortie prévue à l'automne 2017",
    "de": "Start Herbst 2017",
    "pt": "Lançamento outono 2017"
  },
  "14503": {
    "id": 14503,
    "item_id": "mtic2_IAM_translations",
    "en": " or higher",
    "fr": "ou supérieur",
    "de": "oder höher",
    "pt": "ou superior"
  },
  "14504": {
    "id": 14504,
    "item_id": "mtic2_platform_translations",
    "en": "My Classes",
    "fr": "Mes classes",
    "de": "Meine Klassen",
    "pt": "Minhas classes"
  },
  "14505": {
    "id": 14505,
    "item_id": "mtic2_interface_translations",
    "en": "Closed Captions",
    "fr": "Sous-titres",
    "de": "Untertitel ",
    "pt": "Legendas Ocultas"
  },
  "14506": {
    "id": 14506,
    "item_id": "mtic2_interface_translations",
    "en": "Sounds",
    "fr": "Son",
    "de": "Ton",
    "pt": "Sons"
  },
  "14507": {
    "id": 14507,
    "item_id": "mtic2_interface_translations",
    "en": "Username\n",
    "fr": "Nom d'utilisateur",
    "de": "Nutzername",
    "pt": "Nome de utilizador"
  },
  "14508": {
    "id": 14508,
    "item_id": "mtic2_interface_translations",
    "en": "My Classes",
    "fr": "Mes classes",
    "de": "Meine Klassen",
    "pt": "Minhas classes"
  },
  "14509": {
    "id": 14509,
    "item_id": "c3_module_names",
    "en": "Problem Solving\n",
    "fr": "Résolution de problèmes",
    "de": "Sachaufgaben",
    "pt": "Resolução de problemas"
  },
  "14510": {
    "id": 14510,
    "item_id": "c3_module_names",
    "en": "MathleTIC - Mental Math",
    "fr": "MathleTIC - Calcul mental",
    "de": "MathleTIC - Kopfrechnen",
    "pt": "MathleTIC - Cálculo mental"
  },
  "14511": {
    "id": 14511,
    "item_id": "c3_module_names",
    "en": "Numbers and Operations",
    "fr": "Nombres et opérations",
    "de": "Zahlen und Operationen",
    "pt": "Números e Operações"
  },
  "14512": {
    "id": 14512,
    "item_id": "c3_module_names",
    "en": "Space, Shape and Measurement",
    "fr": "Espace, formes et mesures",
    "de": "Raum, Form und Maße",
    "pt": "Espaço, formas e medidas"
  },
  "14513": {
    "id": 14513,
    "item_id": "mtic2_interface_translations",
    "en": "Username is not found",
    "fr": "Nom d'utilisateur introuvable",
    "de": "Nutzername nicht gefunden",
    "pt": "O nome do utilizador não foi encontrado"
  },
  "14514": {
    "id": 14514,
    "item_id": "mtic2_interface_translations",
    "en": "Connecting..",
    "fr": "Connexion...",
    "de": "Verbinden...",
    "pt": "Conexão..."
  },
  "14515": {
    "id": 14515,
    "item_id": "mtic_g78_m3_graph_area",
    "en": "Here we have a shape made of 3 triangles.",
    "fr": "Voici une figure composée de 3 triangles.",
    "de": "Hier ist eine Figur die aus 3 Dreiecken besteht.",
    "pt": "Aqui temos uma forma feita de 3 triângulos"
  },
  "14516": {
    "id": 14516,
    "item_id": "mtic_g78_m3_graph_area",
    "en": "Where do the graphs have a point of intersection?",
    "fr": "Quel est le point d'intersection des graphiques?",
    "de": "In welchem Punkt schneiden sich die Grafiken?",
    "pt": "Quando é que os gráficos se intersectam?"
  },
  "14517": {
    "id": 14517,
    "item_id": "mtic_g78_m3_graph_area",
    "en": "Drag the white dot until you reach the common point.",
    "fr": "Bouge x pour obtenir ce point d'intersection.",
    "de": "Schiebe x bis zu diesem Punkt.",
    "pt": "Arraste o ponto branco até chegar ao ponto comum"
  },
  "14518": {
    "id": 14518,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "The digit in the thousands place is double the number 1.",
    "fr": "Le chiffre représentant les milliers est le double du numéro 1.",
    "de": "Der Tausender ist das Doppelte von 1.",
    "pt": "O algarismo na posição dos milhares é o dobro de 1."
  },
  "14519": {
    "id": 14519,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "The digit in the ones place is half of the number 2.",
    "fr": "Le chiffre représentant les unités est la moitié du numéro 2.",
    "de": "Der Einer ist die Hälfte von 2.",
    "pt": "O algarismo na posição das unidades é a metade do número 2."
  },
  "14520": {
    "id": 14520,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "The digit in the ones place is double the digit in the tens place.",
    "fr": "Le chiffre des unités est le double du chiffre représentant les dizaines.",
    "de": "Der Einer ist  doppelt so groß wie der Zehner.",
    "pt": "O algarismo na posição das unidades é o dobro do algarismo das dezenas."
  },
  "14521": {
    "id": 14521,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "The digit in the tens place is the sum of the digit in the ones place and the number 2.",
    "fr": "Le chiffre représentant les dizaines est la somme du chiffre représentant les unités et le nombre 2.",
    "de": "Der Zehner ist die Summe von dem Einer und 2.",
    "pt": "O algarismo na posição das dezenas é a soma do algarismo das unidades e o número 2."
  },
  "14522": {
    "id": 14522,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "The digit in the thousands place is the sum of the digit in the tens place and 3.",
    "fr": "Le chiffre représentant les milliers est la somme du chiffre représentant les dizaines et le nombre 3.",
    "de": "Der Tausender ist die Summe von dem Zehner und 3.",
    "pt": "O algarismo na posição dos milhares é a soma do algarismo das dezenas e o número 3."
  },
  "14523": {
    "id": 14523,
    "item_id": "mtic_c3_m34_briefcase",
    "en": "Use the Place Value Tool to help get the answer.",
    "fr": "Utilise l'outil Placer la valeur pour obtenir la réponse.",
    "de": "Benutzen Sie das Werkzeug 'Stellentafel' für die richtige Antwort.",
    "pt": "Use a Ferramenta de Valor para o ajudar a obter a resposta."
  },
  "14524": {
    "id": 14524,
    "item_id": "mtic2_IAM_translations",
    "en": "This website is optimized for modern browsers such as",
    "fr": "Ce site est optimisé pour les navigateurs modernes tels que",
    "de": "Diese Webseite ist optimiert für moderne Browser wie",
    "pt": "Este site está otimizado para navegadores modernos como o"
  },
  "14525": {
    "id": 14525,
    "item_id": "mtic2_IAM_translations",
    "en": "for desktops/laptops",
    "fr": "pour ordinateurs de bureau/ordinateurs portables",
    "de": "für Computer/Laptops",
    "pt": "para computadores/portáteis"
  },
  "14526": {
    "id": 14526,
    "item_id": "mtic2_IAM_translations",
    "en": "Please click on the link above and follow the installation instructions to upgrade to a compatible browser.",
    "fr": " Cliquez sur le lien ci-dessus et suivez les instructions d'installation pour passer à un navigateur compatible.",
    "de": "Klicken Sie auf den Link unten, folgen Sie den Anweisungen zur Installation und aktualisieren Sie ihren Browser.",
    "pt": "Clique no link acima e siga as instruções de instalação para atualizar para um navegador compatível."
  },
  "14527": {
    "id": 14527,
    "item_id": "mtic2_IAM_translations",
    "en": "Closed Captions",
    "fr": "Sous-titres",
    "de": "Untertitel ",
    "pt": "Legendas Ocultas"
  },
  "14528": {
    "id": 14528,
    "item_id": "mtic2_IAM_translations",
    "en": "Sound",
    "fr": "Son",
    "de": "Ton",
    "pt": "Sons"
  },
  "14529": {
    "id": 14529,
    "item_id": "mtic2_IAM_translations",
    "en": "PRIMARY SCHOOL",
    "fr": "ÉCOLE FONDAMENTALE",
    "de": "GRUNDSCHULE",
    "pt": "ENSINO BÁSICO"
  },
  "14530": {
    "id": 14530,
    "item_id": "mtic2_IAM_translations",
    "en": "SECONDARY SCHOOL",
    "fr": "ENSEIGNEMENT SECONDAIRE",
    "de": "SEKUNDARSTUFE",
    "pt": "ENSINO SECUNDÁRIO"
  },
  "14531": {
    "id": 14531,
    "item_id": "mtic2_IAM_translations",
    "en": null,
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "14532": {
    "id": 14532,
    "item_id": "mtic-student-onboarding",
    "en": "NA",
    "fr": "NA",
    "de": "Ich mache gerne Mathe.",
    "pt": "NA"
  },
  "14533": {
    "id": 14533,
    "item_id": "mtic-student-onboarding",
    "en": "NA",
    "fr": "NA",
    "de": "Am Computer, mache ich gerne Mathe.",
    "pt": "NA"
  },
  "14534": {
    "id": 14534,
    "item_id": "mtic2_IAM_translations",
    "en": "Click here to create a class",
    "fr": "Cliquez ici pour créer une classe",
    "de": "Klicken Sie hier, um eine Klasse zu erstellen",
    "pt": "Clique aqui para criar uma classe"
  },
  "14535": {
    "id": 14535,
    "item_id": "mtic2_IAM_translations",
    "en": "View Class",
    "fr": "Vue classe",
    "de": "Klassenansicht",
    "pt": "Ver Classe"
  },
  "14536": {
    "id": 14536,
    "item_id": "mtic2_IAM_translations",
    "en": "Enter details for your new class:",
    "fr": "Entrez les détails de votre nouvelle classe:",
    "de": "Details zu Ihrer neuen Klasse eingeben:",
    "pt": "Inserir detalhes para a nova classe:"
  },
  "14537": {
    "id": 14537,
    "item_id": "mtic2_IAM_translations",
    "en": "Name your class:",
    "fr": "Nommez votre classe:",
    "de": "Benennen Sie Ihre Klasse:",
    "pt": "Nomear sua classe:"
  },
  "14547": {
    "id": 14547,
    "item_id": "mtic2_IAM_translations",
    "en": "Recommended System Requirements",
    "fr": "Configuration système recommandée",
    "de": "Empfohlene Systemvoraussetzungen",
    "pt": "Requisitos de sistema recomendados"
  },
  "26207": {
    "id": 26207,
    "en": "The MathemaTIC personalized learning program is accessible to all students attending school in Luxembourg via their IAM account. For the moment, any pupil in Cycle 3 or 4 in primary school can obtain their personal identifier (IAM) directly from their teacher, while secondary school students receive it automatically by mail as they enter Grade 7.\n\nNotice to parents:\nMathemaTIC is a program specifically designed to follow the individual path of students who progress at their own pace with the help of exercises. Parents are welcome to monitor their child's progress without having their own IAM ID.",
    "fr": "Le programme didactique MathemaTIC est accessible à tous les élèves effectuant leur scolarité au Luxembourg, via leur compte IAM. Pour l'instant, tout élève du cycle 3 ou 4 de l'enseignement fondamental peut s'adresser directement à son enseignant qui lui transmettra son identifiant personnel (IAM), tandis que les élèves de l'enseignement secondaire le reçoivent automatiquement par courrier dès la rentrée en septième.\n\nAvis aux parents :\nMathemaTIC est un programme spécialement conçu pour suivre le parcours individuel des élèves qui progressent selon leur propre rythme à l'aide d'exercices. Les parents sont évidemment invités à suivre les progrès de leur enfant sans toutefois disposer de leur propre identifiant IAM.",
    "de": "Jedes Kind, das in einer luxemburgischen Schule nach dem luxemburgischen Curriculum unterrichtet wird, hat mit seinem IAM-Konto einen Zugang zu MathemaTIC. Momentan erhalten die Schüler des Cycle 3 und Cycle 4 diesen IAM-Code von ihrem Lehrer. Die Schüler der weiterführenden Schulen erhalten den IAM-Code automatisch. Es gibt keine speziellen Konten für Eltern. Eltern können zusammen mit ihren Kindern die Plattform MathemaTIC entdecken.",
    "pt": "Qualquer criança em uma escola luxemburguesa seguindo o currículo nacional tem acesso ao MathemaTIC com sua conta IAM. No momento, as crianças no Ciclo 3 e 4 recebem esta IAM de seu professor. Os alunos no Ensino médio recebem a IAM automaticamente. Não há uma conta especial para os pais. Os pais podem explorar o ambiente junto com seus filhos."
  },
  "26208": {
    "id": 26208,
    "en": "Login Details",
    "fr": "Détails du login",
    "de": "Informationen zur Anmeldung",
    "pt": "Informações do login"
  },
  "26209": {
    "id": 26209,
    "en": "for example",
    "fr": "par example",
    "de": "zum Beispiel",
    "pt": "for example"
  },
  "26210": {
    "id": 26210,
    "en": "Detailed IAM Instructions for Ecole Fondamentale Teachers",
    "fr": "IAM instructions détaillées pour les instituteurs de l’école fondamentale",
    "de": "Weitere Informationen zum IAM für das Lehrpersonal der Grundschulen",
    "pt": "Instruções detalhadas da IAM para professores da Ecole Fondamentale"
  },
  "26211": {
    "id": 26211,
    "en": "Are you sure you want to log out?",
    "fr": "Es-tu sûr de fermer la session?",
    "de": "Bist du sicher, dass du dich abmelden willst?",
    "pt": "Tem certeza de que deseja encerrar a sessão?"
  },
  "26212": {
    "id": 26212,
    "en": "No",
    "fr": "Non",
    "de": "Nein",
    "pt": "Não"
  },
  "26213": {
    "id": 26213,
    "en": "Yes",
    "fr": "Oui",
    "de": "Ja",
    "pt": "Sim "
  },
  "26214": {
    "id": 26214,
    "en": "CLICK HERE",
    "fr": "CLIQUEZ ICI",
    "de": "KLICK HIER",
    "pt": "CLIQUE AQUI"
  },
  "26215": {
    "id": 26215,
    "en": "for detailed IAM Instructions for Ecole Fondamentale Teachers",
    "fr": "pour IAM instructions détaillées pour les instituteurs de l’école fondamentale",
    "de": "zum Weitere Informationen zum IAM für das Lehrpersonal der Grundschulen",
    "pt": "para detailed IAM Instructions for Ecole Fondamentale Teachers"
  },

  // General translations from lux_nat_pretest
  "14367": {
    "id": 14367,
    "item_id": "lux_nat_pretest",
    "en": "Thank you! We saved your answers.",
    "fr": "Merci beaucoup! Nous avons sauvegardé vos réponses.",
    "de": "Vielen Dank! Wir haben Ihre Antworten gespeichert.",
    "pt": "Muito obrigado! Guardamos as suas respostas."
  },
  "14780": {
    "id": 14780,
    "item_id": "lux_nat_pretest",
    "en": "Attempt only if you are in Cycle 4.",
    "fr": "Seulement pour les étudiants du Cycle 4.",
    "de": "Nur für Schüler vom Zyklus 4.",
    "pt": "Somente para alunos do Ciclo 4."
  },
  "14782": {
    "id": 14782,
    "item_id": "lux_nat_pretest",
    "en": "Start the test",
    "fr": "Démarrer le test",
    "de": "Test beginnen",
    "pt": "Iniciar teste"
  },
  "14783": {
    "id": 14783,
    "item_id": "lux_nat_pretest",
    "en": "Return to MathemaTIC",
    "fr": "Retourner à MathemaTIC",
    "de": "Zurück zu MathemaTIC",
    "pt": "Voltar para MathemaTIC"
  },
  "14784": {
    "id": 14784,
    "item_id": "lux_nat_pretest",
    "en": "Select the level (s) that you teach:",
    "fr": "Sélectionnez le (s) cycle (s) dans lequel vous enseignez:",
    "de": "Wählen Sie den Zyklus / die Zyklen, die Sie unterrichten:",
    "pt": "Selecione o (s) ciclo (s) no qual você ensina:"
  },
  "14785": {
    "id": 14785,
    "item_id": "lux_nat_pretest",
    "en": "Cycle",
    "fr": "Cycle",
    "de": "Zyklus",
    "pt": "Ciclo"
  },
  "14786": {
    "id": 14786,
    "item_id": "lux_nat_pretest",
    "en": "Secondary School",
    "fr": "Classe Inférieur",
    "de": "Unter-/Mittelstufe",
    "pt": "Ensino secundário"
  },

  //mtic_app_2
  "11280": {
    "id": 11280,
    "item_id": "mtic_app_2",
    "en": "Login",
    "fr": "Connexion",
    "de": "Einloggen",
    "pt": "Login"
  },
  "11281": {
    "id": 11281,
    "item_id": "mtic_app_2",
    "en": "not well",
    "fr": "pas bien",
    "de": "gar nicht",
    "pt": "mal"
  },
  "11282": {
    "id": 11282,
    "item_id": "mtic_app_2",
    "en": "barely",
    "fr": "un peut",
    "de": "nicht so gut",
    "pt": "quase"
  },
  "11283": {
    "id": 11283,
    "item_id": "mtic_app_2",
    "en": "well",
    "fr": "bien",
    "de": "gut",
    "pt": "bem"
  },
  "11284": {
    "id": 11284,
    "item_id": "mtic_app_2",
    "en": "very well",
    "fr": "très bien",
    "de": "sehr gut",
    "pt": "muito bem"
  },
  "11285": {
    "id": 11285,
    "item_id": "mtic_app_2",
    "en": "How did you learn?",
    "fr": "Comment as-tu appris?",
    "de": "Wie hast du gelernt?",
    "pt": "Como é que aprendeste?"
  },
  "11286": {
    "id": 11286,
    "item_id": "mtic_app_2",
    "en": "Problem Solving",
    "fr": "La résolution de problème",
    "de": "Probleme lösen",
    "pt": "Resolução de problemas"
  },
  "11287": {
    "id": 11287,
    "item_id": "mtic_app_2",
    "en": "Replay",
    "fr": "Recommencer",
    "de": "Wiederholen",
    "pt": "Repetir"
  },
  "11288": {
    "id": 11288,
    "item_id": "mtic_app_2",
    "en": "Continue",
    "fr": "Continuer",
    "de": "Weiter",
    "pt": "Continuar"
  },
  "11289": {
    "id": 11289,
    "item_id": "mtic_app_2",
    "en": "Submit",
    "fr": "Valider",
    "de": "Senden",
    "pt": "Submeter"
  },
  "11290": {
    "id": 11290,
    "item_id": "mtic_app_2",
    "en": "Item Complete!",
    "fr": "Item complété!",
    "de": "Du hast die Aufgabe beendet!",
    "pt": "Item Concluído!"
  },
  "11291": {
    "id": 11291,
    "item_id": "mtic_app_2",
    "en": "Username",
    "fr": "Nom d'utilisateur",
    "de": "Benutzername",
    "pt": "Nome de utilizador"
  },
  "11292": {
    "id": 11292,
    "item_id": "mtic_app_2",
    "en": "Password",
    "fr": "Mot de passe",
    "de": "Passwort",
    "pt": "Palavra-passe"
  },
  "11293": {
    "id": 11293,
    "item_id": "mtic_app_2",
    "en": "Don't have an account?",
    "fr": "Tu n'as pas de compte?",
    "de": "Haben Sie keinen account?",
    "pt": "Não tem uma conta?"
  },
  "11294": {
    "id": 11294,
    "item_id": "mtic_app_2",
    "en": "Sign Up",
    "fr": "Connexion",
    "de": "Neu anmelden",
    "pt": "Criar conta"
  },
  "11295": {
    "id": 11295,
    "item_id": "mtic_app_2",
    "en": "student",
    "fr": "Élève",
    "de": "Schüler/-in",
    "pt": "Aluno"
  },
  "11296": {
    "id": 11296,
    "item_id": "mtic_app_2",
    "en": "teacher",
    "fr": "Enseignant",
    "de": "Lehrer/in",
    "pt": "Professor"
  },
  "11297": {
    "id": 11297,
    "item_id": "mtic_app_2",
    "en": "Teacher ID",
    "fr": "Code Enseignant",
    "de": "Lehrer ID",
    "pt": "ID do Professor"
  },
  "11298": {
    "id": 11298,
    "item_id": "mtic_app_2",
    "en": "Class Code",
    "fr": "Code de classe",
    "de": "Klassencode",
    "pt": "ID da Classe"
  },
  "11299": {
    "id": 11299,
    "item_id": "mtic_app_2",
    "en": "First Name",
    "fr": "Prénom",
    "de": "Vorname",
    "pt": "Nome"
  },
  "11300": {
    "id": 11300,
    "item_id": "mtic_app_2",
    "en": "Last Name",
    "fr": "Nom de famille",
    "de": "Nachname",
    "pt": "Apelido"
  },
  "11301": {
    "id": 11301,
    "item_id": "mtic_app_2",
    "en": "Confirm Password",
    "fr": "Confirmer le mot de passe",
    "de": "Passwort bestätigen",
    "pt": "Confirmar palavra-passe"
  },
  "11302": {
    "id": 11302,
    "item_id": "mtic_app_2",
    "en": "Already have an account?",
    "fr": "Tu as déjà un compte?",
    "de": "Hast du schon ein account?",
    "pt": "Já tem conta?"
  },
  "11303": {
    "id": 11303,
    "item_id": "mtic_app_2",
    "en": "Access Code",
    "fr": "Code d'accès",
    "de": "Zugangscode",
    "pt": "Código de Acesso"
  },
  "11304": {
    "id": 11304,
    "item_id": "mtic_app_2",
    "en": "Email",
    "fr": "Adresse mail",
    "de": "Email-Adresse",
    "pt": "Email"
  },
  "11305": {
    "id": 11305,
    "item_id": "mtic_app_2",
    "en": "Logout",
    "fr": "Déconnexion",
    "de": "Verbindung trennen",
    "pt": "Terminar Sessão"
  },
  "11306": {
    "id": 11306,
    "item_id": "mtic_app_2",
    "en": "Please fill in both username and password",
    "fr": "Veuillez remplir le nom d'utilisateur et le mot de passe",
    "de": "Bitte geben Sie Ihre Benutzername und Passwort ein.",
    "pt": "Por favor, introduza o nome do utilizador e a palavra-passe"
  },
  "11307": {
    "id": 11307,
    "item_id": "mtic_app_2",
    "en": "Username is not found",
    "fr": "Nom d'utilisateur introuvable",
    "de": "Der angegebene Benutzername konnte nicht gefunden werden!",
    "pt": "Utilizador não encontrado"
  },
  "11308": {
    "id": 11308,
    "item_id": "mtic_app_2",
    "en": "Invalid Password",
    "fr": "Mot de passe invalide",
    "de": "Das Passwort ist ungültig.",
    "pt": "Palavra-passe inválida"
  },
  "11309": {
    "id": 11309,
    "item_id": "mtic_app_2",
    "en": "Please complete all fields to sign up",
    "fr": "Veuillez remplir tous les champs",
    "de": "Füllen Sie bitte alle Felder aus um sich anzumelden.",
    "pt": "Por favor, complete todos os campos para se registar"
  },
  "11310": {
    "id": 11310,
    "item_id": "mtic_app_2",
    "en": "The access code you entered is not valid",
    "fr": "Le code d'accès entré n'est pas valide",
    "de": "Der eingegebene Zugangscode ist ungültig.",
    "pt": "O código de acesso que introduziu não é válido"
  },
  "11311": {
    "id": 11311,
    "item_id": "mtic_app_2",
    "en": "This username already exists",
    "fr": "Ce nom d'utilisateur existe déjà",
    "de": "Der Benutzername ist schon belegt.",
    "pt": "Este utilizador já existe"
  },
  "11312": {
    "id": 11312,
    "item_id": "mtic_app_2",
    "en": "Invalid Class ID or Teacher ID",
    "fr": "Code de classe ou code enseignant invalide",
    "de": "Klassencode oder Lehrer ID ungültig.",
    "pt": "ID de Lição ou ID de Professor inválido"
  },
  "11313": {
    "id": 11313,
    "item_id": "mtic_app_2",
    "en": "Something went wrong, please check your internet connection",
    "fr": "Un problème est survenu. Veuillez vérifier votre connexion Internet",
    "de": "Verbindungsfehler,\nbitte überprüfen Sie die Internetverbindung.",
    "pt": "Algo correu mal, por favor verifique a sua conexão."
  },
  "11314": {
    "id": 11314,
    "item_id": "mtic-c3-m1-likert-scale",
    "en": "How well did you learn in this activity?",
    "fr": "Comment as-tu trouvé cet exercice?",
    "de": "Wie hast du in dieser Aufgabe gelernt?",
    "pt": "Como é que se saiu nesta atividade?"
  },
  "11315": {
    "id": 11315,
    "item_id": "mtic-c3-m1-likert-scale",
    "en": "very well ",
    "fr": "très facile",
    "de": "sehr gut",
    "pt": "muito bem"
  },
  "11316": {
    "id": 11316,
    "item_id": "mtic-c3-m1-likert-scale",
    "en": "well",
    "fr": "facile",
    "de": "gut",
    "pt": "bem"
  },
  "11317": {
    "id": 11317,
    "item_id": "mtic-c3-m1-likert-scale",
    "en": "barely",
    "fr": "difficile",
    "de": "nicht so gut",
    "pt": "quase"
  },
  "11318": {
    "id": 11318,
    "item_id": "mtic-c3-m1-likert-scale",
    "en": "not well",
    "fr": "très difficile",
    "de": "gar nicht ",
    "pt": "mal"
  },
  "11319": {
    "id": 11319,
    "item_id": "mtic_app_2",
    "en": "connecting...",
    "fr": "connexion...",
    "de": "Verbinden...",
    "pt": "Conexão..."
  },
  "11320": {
    "id": 11320,
    "item_id": "mtic_app_2",
    "en": "Login failed",
    "fr": "Connexion échouée",
    "de": "Die Anmeldung ist fehlgeschlagen.",
    "pt": "O login falhou"
  },
  "11321": {
    "id": 11321,
    "item_id": "mtic_app_2",
    "en": "Login failed",
    "fr": "Connexion échouée",
    "de": "Die Anmeldung ist fehlgeschlagen.",
    "pt": "O login falhou"
  },
  "11322": {
    "id": 11322,
    "item_id": "mtic_app_2",
    "en": "It appears that your session has expired.",
    "fr": "Il semblerait que votre session ait expiré",
    "de": "Ihre Anmeldung ist abgelaufen.",
    "pt": "Parece que a sua sessão expirou."
  },
  "11323": {
    "id": 11323,
    "item_id": "mtic_app_2",
    "en": "Please log back in with your password to continue.",
    "fr": "Veuillez entrer votre mot de passe pour continuer",
    "de": "Bitte melden Sie sich mit Ihren Passwort wieder ein, um weiterzumachen.",
    "pt": "Por favor, faça novamente o login com a sua palavra-passe para continuar."
  },
  "11324": {
    "id": 11324,
    "item_id": "mtic_app_2",
    "en": "Failed to to connect to the MathemaTIC servers, please see that you have an internet connection.",
    "fr": "Échec de connexion au serveur MathemaTIC, veuillez vérifier votre connexion internet.",
    "de": "Die Verbindung mit dem MathemaTIC Server konnte nicht hergestellt werden. Bitte überprüfen Sie die Internetverbindung.",
    "pt": "A ligação aos servidores da MathemaTIC falhou, por favor, veifique a sua ligação à internet."
  },
  "11325": {
    "id": 11325,
    "item_id": "mtic_app_2",
    "en": "The Teacher ID must be a number",
    "fr": "Le code enseignant doit être un numéro",
    "de": "Lehrer ID muss eine Zahl sein.",
    "pt": "A ID do Professor tem de ser um número"
  },
  "11326": {
    "id": 11326,
    "item_id": "mtic_app_2",
    "en": "The Class ID must be a number",
    "fr": "Le code de classe doit être un numéro",
    "de": "Klassencode muss eine Zahl sein.",
    "pt": "A ID da Aula tem de ser um número"
  },
  "11327": {
    "id": 11327,
    "item_id": "mtic_app_2",
    "en": "Make sure your password matches",
    "fr": "Les mots de passe ne concordent pas",
    "de": "Bitte bestimmen sie Ihr Passwort.",
    "pt": "Certifique-se que a palavra-passe é a mesma"
  },
  "11328": {
    "id": 11328,
    "item_id": "mtic_app_2",
    "en": "Please fill in all fields",
    "fr": "Veuillez remplir tous les champs",
    "de": "Füllen Sie bitte alle Felder aus.",
    "pt": "Por favor, preencha todos os campos"
  },
  "11329": {
    "id": 11329,
    "item_id": "mtic_app_2",
    "en": "Make sure your password matches",
    "fr": "Les mots de passe ne concordent pas",
    "de": "Bitte bestimmen sie Ihr Passwort.",
    "pt": "Certifique-se que a palavra-passe é a mesma"
  },
  "11330": {
    "id": 11330,
    "item_id": "mtic_app_2",
    "en": "Please enter a valid email address",
    "fr": "Veuillez entrer une adresse mail valide",
    "de": "Bitte geben Sie eine gültige E-Mail-Adresse  ein.",
    "pt": "Por favor, introduza um endereço de email válido"
  },
  "11331": {
    "id": 11331,
    "item_id": "mtic_app_2",
    "en": "Student ID",
    "fr": "Code Étudiant",
    "de": "Schüler ID",
    "pt": "ID do Aluno"
  },
  "11784": {
    "id": 11784,
    "item_id": "mtic_app_2",
    "en": "Your browser is currently not supported by this page.",
    "fr": "Votre navigateur n'est actuellement pas supporté par cette page.",
    "de": "Ihr Browser wird derzeit von dieser Seite nicht unterstützt.",
    "pt": "O seu navegador atual não é suportado por esta página"
  },
  "11785": {
    "id": 11785,
    "item_id": "mtic_app_2",
    "en": "Please revisit this page using Google Chrome.",
    "fr": "Veuillez revisiter cette page en utilisant Google Chrome.",
    "de": "Bitte besuchen Sie diese Seite erneut mit Google Chrome.",
    "pt": "Por favor, visite novamente esta página usando o Google Chrome."
  },
  "15053": {
    "id": 15053,
    "item_id": "mtic_app_2",
    "en": "There appears to be a problem with your Internet connection.",
    "fr": "Il semble y avoir un problème avec ta connexion Internet.",
    "de": "Es gibt ein Problem mit der Internetverbindung.",
    "pt": "Parece haver um problema em sua conexão com a Internet."
  },
  "15054": {
    "id": 15054,
    "item_id": "mtic_app_2",
    "en": "Try Again",
    "fr": "Réessaie",
    "de": "Versuche es noch einmal",
    "pt": "Tenta novamente"
  },
  "15055": {
    "id": 15055,
    "item_id": "mtic_app_2",
    "en": "Check your network connection and try again.",
    "fr": "Vérifie ta connexion Internet et recommence.",
    "de": "Überprüfe deine Internetverbindung und versuche es noch einmal.",
    "pt": "Verifique sua conexão de rede e tente novamente."
  },
  "30823": {
    "id": 30823,
    "item_id": "mtic_app_2",
    "en": "Student Report",
    "fr": "Bilan de l'étudiant",
    "de": "Auswertung",
    "pt": "Revisão do aluno"
  },
  "31674": {
    "id": 31674,
    "item_id": "mtic_app_2",
    "en": "Student Reports",
    "fr": "Bilans de l'étudiant",
    "de": "Studentenberichte",
    "pt": "Revisões dos alunos"
  },

  //mtic2_agenda_v2
  "27447": {
    "id": 27447,
    "item_id": "mtic2_agenda_v2",
    "en": "Do you really want to close? All of your changes will be lost.",
    "fr": "Voulez-vous vraiment quitter la page? Toutes vos modifications seront perdues.",
    "de": "Möchten Sie wirklich aufhören? Alle Änderungen werden gelöscht.",
    "pt": "Tem a certeza que deseja fechar? Todas as alterações serão perdidas."
  },
  "27448": {
    "id": 27448,
    "item_id": "mtic2_agenda_v2",
    "en": "Cancel",
    "fr": "Annuler",
    "de": "Abbrechen",
    "pt": "Cancelar"
  },
  "27449": {
    "id": 27449,
    "item_id": "mtic2_agenda_v2",
    "en": "Confirm",
    "fr": "Confirmer",
    "de": "Bestätigen",
    "pt": "Confirmar"
  },
  "27450": {
    "id": 27450,
    "item_id": "mtic2_agenda_v2",
    "en": "Click to adjust the start and end dates",
    "fr": "Cliquer pour fixer les dates de début et de clôture.",
    "de": "Klicken Sie hier, um das Start- und Enddatum anzupassen",
    "pt": "Clique para alterar as datas de início e encerramento"
  },
  "27451": {
    "id": 27451,
    "item_id": "mtic2_agenda_v2",
    "en": "Start",
    "fr": "Début",
    "de": "Start",
    "pt": "Inicio"
  },
  "27452": {
    "id": 27452,
    "item_id": "mtic2_agenda_v2",
    "en": "End",
    "fr": "Fin",
    "de": "Ende",
    "pt": "Encerramento"
  },
  "27453": {
    "id": 27453,
    "item_id": "mtic2_agenda_v2",
    "en": "NEW UNIT",
    "fr": "Nouvel agenda",
    "de": "Neuen Eintrag erstellen",
    "pt": "NOVA AGENDA"
  },
  "27454": {
    "id": 27454,
    "item_id": "mtic2_agenda_v2",
    "en": "ASSIGN TO",
    "fr": "ATTRIBUER À",
    "de": "ZUWEISEN",
    "pt": "ATRIBUIR A"
  },
  "27455": {
    "id": 27455,
    "item_id": "mtic2_agenda_v2",
    "en": "My Class",
    "fr": "Ma classe",
    "de": "Meine Klassen",
    "pt": "A minha classe"
  },
  "27456": {
    "id": 27456,
    "item_id": "mtic2_agenda_v2",
    "en": "Students",
    "fr": "Étudiants",
    "de": "Schüler",
    "pt": "Alunos"
  },
  "27457": {
    "id": 27457,
    "item_id": "mtic2_agenda_v2",
    "en": "Are you sure you want to archive this Agenda Unit",
    "fr": "Voulez-vous vraiment de vouloir archiver cet agenda?",
    "de": "Möchten Sie diesen Eintrag wirklich archivieren?",
    "pt": "Tem a certeza que deseja arquivar esta unidade da Agenda?"
  },
  "27458": {
    "id": 27458,
    "item_id": "mtic2_agenda_v2",
    "en": "There is no data to display for the selected class, module or student",
    "fr": "Il n'y a pas de données disponibles pour la classe, le module ou l'étudiant sélectionné",
    "de": "Für die ausgewählte Klasse werden keine Daten angezeigt",
    "pt": "Não existem dados para a classe, módulo ou aluno selecionado"
  },
  "27490": {
    "id": 27490,
    "item_id": "mtic2_agenda_v2",
    "en": "EDIT UNIT",
    "fr": "MODIFIER AGENDA",
    "de": "Eintrag bearbeiten",
    "pt": "MODIFICAR UNIDADE"
  },
  "27491": {
    "id": 27491,
    "item_id": "mtic2_agenda_v2",
    "en": "When?",
    "fr": "Quand?",
    "de": "Wann?",
    "pt": "Quando?"
  },
  "27492": {
    "id": 27492,
    "item_id": "mtic2_agenda_v2",
    "en": "Custom Resources",
    "fr": "Agenda personnalisé",
    "de": "Benutzerdefinierte Ressourcen",
    "pt": "Recursos personalizados"
  },
  "27493": {
    "id": 27493,
    "item_id": "mtic2_agenda_v2",
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Diagnóstico"
  },
  "27494": {
    "id": 27494,
    "item_id": "mtic2_agenda_v2",
    "en": "Formative",
    "fr": "Items d'apprentissage",
    "de": "Lernaufgaben",
    "pt": "Formativo"
  },
  "27495": {
    "id": 27495,
    "item_id": "mtic2_agenda_v2",
    "en": "Summative Test",
    "fr": "Test sommatif",
    "de": "Abschlusstest",
    "pt": "Sumativo"
  },
  "27496": {
    "id": 27496,
    "item_id": "mtic2_agenda_v2",
    "en": "Force re-attempt",
    "fr": "Forcer une nouvelle tentative",
    "de": "Erneut versuchen",
    "pt": "Forçar nova tentativa"
  },
  "27497": {
    "id": 27497,
    "item_id": "mtic2_agenda_v2",
    "en": "Select Students",
    "fr": "Sélectionner des étudiants",
    "de": "Schüler auswählen",
    "pt": "Selecionar alunos"
  },
  "27498": {
    "id": 27498,
    "item_id": "mtic2_agenda_v2",
    "en": "Continue",
    "fr": "Suivant",
    "de": "Weiter",
    "pt": "Continuar"
  },
  "27499": {
    "id": 27499,
    "item_id": "mtic2_agenda_v2",
    "en": "Back",
    "fr": "Précédent",
    "de": "Zurück",
    "pt": "Voltar"
  },
  "27500": {
    "id": 27500,
    "item_id": "mtic2_agenda_v2",
    "en": "Update",
    "fr": "Mettre à jour",
    "de": "Aktualisieren",
    "pt": "Atualizar"
  },
  "27501": {
    "id": 27501,
    "item_id": "mtic2_agenda_v2",
    "en": "Archived Agenda Units",
    "fr": "Agendas archivés",
    "de": "Archivierte Einträge",
    "pt": "Unidades arquivadas da Agenda"
  },
  "27502": {
    "id": 27502,
    "item_id": "mtic2_agenda_v2",
    "en": "select your topic",
    "fr": "Sélectionner un sujet",
    "de": "Wählen Sie Ihr Thema aus",
    "pt": "Selecione o tema"
  },
  "27640": {
    "id": 27640,
    "item_id": "mtic2_agenda_v2",
    "en": "Manage Classes",
    "fr": "Gérer les classes",
    "de": "Klassen verwalten",
    "pt": "Gerir classes"
  },
  "27641": {
    "id": 27641,
    "item_id": "mtic2_agenda_v2",
    "en": "Show Archived Classes",
    "fr": "Afficher les classes archivées",
    "de": "Achivierte Klassen anzeigen",
    "pt": "Apresentar classes arquivadas"
  },
  "27642": {
    "id": 27642,
    "item_id": "mtic2_agenda_v2",
    "en": "My Classes",
    "fr": "Mes classes",
    "de": "Meine Klassen",
    "pt": "Minhas classes"
  },
  "27643": {
    "id": 27643,
    "item_id": "mtic2_agenda_v2",
    "en": "Logout",
    "fr": "Déconnecter",
    "de": "Verbindung trennen",
    "pt": "Terminar sessão"
  },
  "27644": {
    "id": 27644,
    "item_id": "mtic2_agenda_v2",
    "en": "Click again to disable",
    "fr": "Cliquer à nouveau pour désactiver",
    "de": "Klicken Sie erneut um zu deaktivieren",
    "pt": "Clique novamente para desativar"
  },
  "27645": {
    "id": 27645,
    "item_id": "mtic2_agenda_v2",
    "en": "Done",
    "fr": "Terminé",
    "de": "Fertig",
    "pt": "Terminado"
  },
  "27646": {
    "id": 27646,
    "item_id": "mtic2_agenda_v2",
    "en": "Remove Class",
    "fr": "Archiver la classe",
    "de": "Klasse entfernen",
    "pt": "Remover Classe"
  },
  "27647": {
    "id": 27647,
    "item_id": "mtic2_agenda_v2",
    "en": "No classes have been archived.",
    "fr": "Aucune classe n'a été archivée.",
    "de": "Keine archivierten Klassen",
    "pt": "Nenhuma classe foi arquivada"
  },
  "27648": {
    "id": 27648,
    "item_id": "mtic2_agenda_v2",
    "en": "Your Archived Classes",
    "fr": "Vos classes archivées",
    "de": "Ihre archivierten Klassen",
    "pt": "As suas classes arquivadas"
  },
  "27649": {
    "id": 27649,
    "item_id": "mtic2_agenda_v2",
    "en": "Un-archive Class",
    "fr": "Désarchiver la classe",
    "de": "Klasse unarchivieren",
    "pt": "Desarquivar classe"
  },
  "27650": {
    "id": 27650,
    "item_id": "mtic2_agenda_v2",
    "en": "Current Class",
    "fr": "Classe actuelle",
    "de": "Derzeitige Klassen",
    "pt": "Classe atual"
  },
  "27651": {
    "id": 27651,
    "item_id": "mtic2_agenda_v2",
    "en": "Dashboard",
    "fr": "Tableau de bord",
    "de": "Benutzeroberfläche",
    "pt": "Painel de controlo"
  },
  "27652": {
    "id": 27652,
    "item_id": "mtic2_agenda_v2",
    "en": "You don't have any students in your class yet!",
    "fr": "Il n'y a aucun étudiant dans votre classe!",
    "de": "Sie haben jetzt noch keine Schüler in Ihrer Klasse!",
    "pt": "Ainda não há alunos na sua classe!"
  },
  "27653": {
    "id": 27653,
    "item_id": "mtic2_agenda_v2",
    "en": "Add Students",
    "fr": "Ajouter un étudiant",
    "de": "Student hinzufügen",
    "pt": "Adicionar alunos"
  },
  "27654": {
    "id": 27654,
    "item_id": "mtic2_agenda_v2",
    "en": "Adding Students to your class",
    "fr": "Ajouter des étudiants à votre classe",
    "de": "Student zur Klasse hinzufügen",
    "pt": "Adicionar alunos à sua classe"
  },
  "27655": {
    "id": 27655,
    "item_id": "mtic2_agenda_v2",
    "en": "Download",
    "fr": "Télécharger",
    "de": "Download",
    "pt": "Baixar"
  },
  "27656": {
    "id": 27656,
    "item_id": "mtic2_agenda_v2",
    "en": "Rights of use",
    "fr": "Droits d'utilisation",
    "de": "Nutzungsrechte",
    "pt": "Direitos de uso"
  },
  "27657": {
    "id": 27657,
    "item_id": "mtic2_agenda_v2",
    "en": "Embed",
    "fr": "Intégrer",
    "de": "Einbinden",
    "pt": "Integrar"
  },
  "27658": {
    "id": 27658,
    "item_id": "mtic2_agenda_v2",
    "en": "Removed Students",
    "fr": "Élèves archivés",
    "de": "Entfernte Schüler",
    "pt": "Alunos arquivados"
  },
  "27659": {
    "id": 27659,
    "item_id": "mtic2_agenda_v2",
    "en": "Restore Students Accounts",
    "fr": "Restaurer les comptes étudiants",
    "de": "Studentenkonto wiederherstellen",
    "pt": "Restaurar Contas de alunos"
  },
  "27660": {
    "id": 27660,
    "item_id": "mtic2_agenda_v2",
    "en": "Edit Student Account",
    "fr": "Modifier les comptes étudiants",
    "de": "Studentenkonto bearbeiten",
    "pt": "Editar Conta do aluno"
  },
  "27661": {
    "id": 27661,
    "item_id": "mtic2_agenda_v2",
    "en": "Remove from Class",
    "fr": "Enlever de la classe",
    "de": "Von der Klasse entfernen",
    "pt": "Remover da classe"
  },
  "27662": {
    "id": 27662,
    "item_id": "mtic2_agenda_v2",
    "en": "Are you sure you want to remove this account from your class?",
    "fr": "Voulez-vous vraiment supprimer ce compte de votre classe?",
    "de": "Sind Sie sicher Sie möchten das Konto von Ihrer Klasse entfernen",
    "pt": "Tem a certeza que deseja remover esta conta da sua Classe?"
  },
  "27663": {
    "id": 27663,
    "item_id": "mtic2_agenda_v2",
    "en": "Yes",
    "fr": "Oui",
    "de": "Ja",
    "pt": "Sim"
  },
  "27664": {
    "id": 27664,
    "item_id": "mtic2_agenda_v2",
    "en": "No",
    "fr": "Non",
    "de": "Nein",
    "pt": "Não"
  },
  "27665": {
    "id": 27665,
    "item_id": "mtic2_agenda_v2",
    "en": "Restore ",
    "fr": "Restaurer",
    "de": "Wiederherstellen",
    "pt": "Restaurar"
  },
  "27666": {
    "id": 27666,
    "item_id": "mtic2_agenda_v2",
    "en": "Calendar",
    "fr": "Calendrier",
    "de": "Kalender",
    "pt": "Calendário"
  },
  "27667": {
    "id": 27667,
    "item_id": "mtic2_agenda_v2",
    "en": "List",
    "fr": "Liste",
    "de": "Liste",
    "pt": "Lista"
  },
  "27668": {
    "id": 27668,
    "item_id": "mtic2_agenda_v2",
    "en": "Create New Assignment",
    "fr": "Créer une nouvelle tâche",
    "de": "Neue Aufgabe erstellen",
    "pt": "Criar Nova tarefa"
  },
  "27669": {
    "id": 27669,
    "item_id": "mtic2_agenda_v2",
    "en": "Welcome to the agenda. Click the button above to create your first assignment.",
    "fr": "Bienvenue dans l'Agenda. Cliquez sur le bouton ci-dessus pour créer votre première tâche.",
    "de": "Willkommen zur Tagesordnung. Klicken Sie auf die Schaltfläche oben, um Ihre erste Aufgabe zu erstellen.",
    "pt": "Bem-vindo à agenda. Clique no botão em cima para criar a sua primeira tarefa."
  },
  "27670": {
    "id": 27670,
    "item_id": "mtic2_agenda_v2",
    "en": "Create New Custom Unit",
    "fr": "Créer un nouvel agenda personnalisé",
    "de": "Erstellen Sie einen neuen benutzerdefinierten Eintrag",
    "pt": "Criar uma Nova Unidade personalizada"
  },
  "27671": {
    "id": 27671,
    "item_id": "mtic2_agenda_v2",
    "en": "Create",
    "fr": "Créer",
    "de": "Erstellen",
    "pt": "Criar"
  },
  "27672": {
    "id": 27672,
    "item_id": "mtic2_agenda_v2",
    "en": "Who?",
    "fr": "Qui?",
    "de": "Wo?",
    "pt": "Quem?"
  },
  "27673": {
    "id": 27673,
    "item_id": "mtic2_agenda_v2",
    "en": "No filter applied",
    "fr": "Aucun filtre appliqué",
    "de": "Keinen Filter verwendet",
    "pt": "Nenhum filtro aplicado"
  },
  "27674": {
    "id": 27674,
    "item_id": "mtic2_agenda_v2",
    "en": "Edit ",
    "fr": "Modifier",
    "de": "Verändern",
    "pt": "Editar"
  },
  "27675": {
    "id": 27675,
    "item_id": "mtic2_agenda_v2",
    "en": "View report",
    "fr": "Afficher le rapport",
    "de": "Report anzeigen",
    "pt": "Ver relatório"
  },
  "27676": {
    "id": 27676,
    "item_id": "mtic2_agenda_v2",
    "en": "Archive",
    "fr": "Archiver",
    "de": "Archivieren",
    "pt": "Arquivo"
  },
  "27677": {
    "id": 27677,
    "item_id": "mtic2_agenda_v2",
    "en": "Title ",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27678": {
    "id": 27678,
    "item_id": "mtic2_agenda_v2",
    "en": "Date opened",
    "fr": "Date de début",
    "de": "Öffnungsdatum",
    "pt": "Data de início"
  },
  "27679": {
    "id": 27679,
    "item_id": "mtic2_agenda_v2",
    "en": "Date Closed",
    "fr": "Date de clôture",
    "de": "Enddatum",
    "pt": "Data de encerramento"
  },
  "27680": {
    "id": 27680,
    "item_id": "mtic2_agenda_v2",
    "en": "Restore",
    "fr": "Restaurer",
    "de": "Wiederherstellen",
    "pt": "Restaurar"
  },
  "27681": {
    "id": 27681,
    "item_id": "mtic2_agenda_v2",
    "en": "Included in Unit",
    "fr": "Inclure dans l'agenda",
    "de": "Im Eintrag enthalten",
    "pt": "Incluído na unidade"
  },
  "27682": {
    "id": 27682,
    "item_id": "mtic2_agenda_v2",
    "en": "Title:",
    "fr": "Titre:",
    "de": "Titel:",
    "pt": "Título:"
  },
  "28844": {
    "id": 28844,
    "item_id": "mtic2_agenda_v2",
    "en": "Custom Unit",
    "fr": "Agenda",
    "de": "Eintrag",
    "pt": "Unidade"
  },
  "27683": {
    "id": 27683,
    "item_id": "mtic2_agenda_v2",
    "en": "Insert Custom Activity",
    "fr": "Insérer Activité Personnalisée",
    "de": "Fügen Sie eine benutzerdefinierte Aktivität ein",
    "pt": "Inserir tarefa personalizada"
  },
  "27684": {
    "id": 27684,
    "item_id": "mtic2_agenda_v2",
    "en": "New",
    "fr": "Nouveau",
    "de": "Neu",
    "pt": "Novo"
  },
  "27685": {
    "id": 27685,
    "item_id": "mtic2_agenda_v2",
    "en": "Previously used",
    "fr": "Utilisé auparavant",
    "de": "Zuvor verwendet",
    "pt": "Usado anteriormente"
  },
  "27686": {
    "id": 27686,
    "item_id": "mtic2_agenda_v2",
    "en": "Custom Item Title",
    "fr": "Titre de l'item personnalisé",
    "de": "Titel der benutzerdefinierten Aufgabe",
    "pt": "Título do item personalizado"
  },
  "27687": {
    "id": 27687,
    "item_id": "mtic2_agenda_v2",
    "en": "Enter the url here.",
    "fr": "Entrer un lien externe (URL)  ici.",
    "de": "Geben Sie die URL hier ein.",
    "pt": "Adicionar o URL."
  },
  "27688": {
    "id": 27688,
    "item_id": "mtic2_agenda_v2",
    "en": "I acknowledge that the material I've entered above respects all copyrights in my jurisdiction",
    "fr": "Je confirme que les documents enregistrés ci-dessus respectent tous les droits d'auteur de ma juridiction",
    "de": "Ich bestätige, dass das Material, das ich oben eingegeben habe, allen Urheberrechtlichen Ansrpüche in meinem Land entgegenkommt.",
    "pt": "Reconheço que os recursos adicionados respeitam todos os direitos de autor"
  },
  "27689": {
    "id": 27689,
    "item_id": "mtic2_agenda_v2",
    "en": "Please enter a valid URL",
    "fr": "Veuillez entrer une URL valide",
    "de": "Bitte geben Sie eine gültige URL ein",
    "pt": "É favor adicionar um URL válido"
  },
  "27690": {
    "id": 27690,
    "item_id": "mtic2_agenda_v2",
    "en": "Drag the custom activity into the agenda list.",
    "fr": "Ajouter un lien externe à l'agenda.",
    "de": "Ziehen Sie die benutzerdefinierte Lernaufgabe in die Modulkarte.",
    "pt": "Arraste a tarefa personalizada para o mapa do módulo."
  },
  "27691": {
    "id": 27691,
    "item_id": "mtic2_agenda_v2",
    "en": "Custom Module Title",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27692": {
    "id": 27692,
    "item_id": "mtic2_agenda_v2",
    "en": "Unlock path",
    "fr": "Débloquer items precedents.",
    "de": "Pfad entsperren",
    "pt": "Desbloquear caminho"
  },
  "27693": {
    "id": 27693,
    "item_id": "mtic2_agenda_v2",
    "en": "Save ",
    "fr": "Enregistrer",
    "de": "Speichern",
    "pt": "Salvar"
  },
  "27694": {
    "id": 27694,
    "item_id": "mtic2_agenda_v2",
    "en": "Select the students you want to include in the filter",
    "fr": "Sélectionner les étudiants à ajouter au filtre",
    "de": "Wählen Sie die Studenten die Sie in diesen Filter einschließen möchten",
    "pt": "Selecione os alunos que deseja incluir no filtro"
  },
  "27695": {
    "id": 27695,
    "item_id": "mtic2_agenda_v2",
    "en": "Filter by Student",
    "fr": "Filtrer par étudiant",
    "de": "Studenten filtern",
    "pt": "Filtrar por aluno"
  },
  "27696": {
    "id": 27696,
    "item_id": "mtic2_agenda_v2",
    "en": "Are you sure you want to navigate away from this page? All changes will be lost if you leave this page.",
    "fr": "Êtes-vous sûr de vouloir quitter cette page? Toutes les modifications seront perdues si vous quittez cette page.",
    "de": "Möchten Sie diese Seite wirklich verlassen? Alle Änderungen werden verloren gehen.",
    "pt": "Tem a certeza que deseja sair desta página? Todas as alterações serão perdidas se deixar esta página."
  },
  "27697": {
    "id": 27697,
    "item_id": "mtic2_agenda_v2",
    "en": "Loading...",
    "fr": "Chargement...",
    "de": "Laden...",
    "pt": "Carregando..."
  },
  "27698": {
    "id": 27698,
    "item_id": "mtic2_agenda_v2",
    "en": "There is no data to display for the selected class,module or student",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27699": {
    "id": 27699,
    "item_id": "mtic2_agenda_v2",
    "en": "Activity Log",
    "fr": "Historique des travaux",
    "de": "Arbeitsverlauf",
    "pt": "Histórico de trabalho"
  },
  "27700": {
    "id": 27700,
    "item_id": "mtic2_agenda_v2",
    "en": "Instruction Manuals",
    "fr": "Manuels d'utilisation",
    "de": "Bedienungsanleitungen",
    "pt": "Manuais de instruções"
  },
  "27701": {
    "id": 27701,
    "item_id": "mtic2_agenda_v2",
    "en": "Instruction Manual",
    "fr": "Manuel d'utilisation",
    "de": "Bedienungsanleitung",
    "pt": "Manuais de instruções"
  },
  "27702": {
    "id": 27702,
    "item_id": "mtic2_agenda_v2",
    "en": "Letter to Teachers",
    "fr": "Lettre aux enseignants",
    "de": "Brief an die Lehrer",
    "pt": "Carta aos professores"
  },
  "27703": {
    "id": 27703,
    "item_id": "mtic2_agenda_v2",
    "en": "Letter to Parents",
    "fr": "Lettre aux parents",
    "de": "Elternbrief",
    "pt": "Carta aos pais"
  },
  "27704": {
    "id": 27704,
    "item_id": "mtic2_agenda_v2",
    "en": "Create new",
    "fr": "Créer un nouvel agenda",
    "de": "Neu erstellen",
    "pt": "Criar novo"
  },
  "27705": {
    "id": 27705,
    "item_id": "mtic2_agenda_v2",
    "en": "Communications",
    "fr": "Communications",
    "de": "Kommunikation",
    "pt": "Comunicações"
  },
  "27705999": {
    "id": 27705999,
    "item_id": "mtic2_data",
    "en": "Data Protection And Privacy Policy",
    "fr": "Protection Des Données Et Politique De Confidentialité",
    "de": "Datenschutz Und Private Datenschutzbestimmungen",
    "pt": "Proteção Dos Dados E Política De Privacidade"
  },
  "27706": {
    "id": 27706,
    "item_id": "mtic2_agenda_v2",
    "en": "Teacher guides",
    "fr": "Fiches didactiques",
    "de": "Didaktische Materialien",
    "pt": "Fichas didáticas"
  },
  "27707": {
    "id": 27707,
    "item_id": "mtic2_agenda_v2",
    "en": "Welcome to MathemaTIC's Newest Update!",
    "fr": "Bienvenue à la présentation de la dernière mise à jour de MathemaTIC!",
    "de": "Wilkommen zu MathemaTIC's neustem Update!",
    "pt": "Bem-vindo à atualização  mais recente de MathemaTIC!"
  },
  "27708": {
    "id": 27708,
    "item_id": "mtic2_agenda_v2",
    "en": "There have been a few exciting changes to your Teacher View in order to better personalize your student's learning experience.",
    "fr": "Il y a eu quelques changements dans la vue enseignant qui permettent de mieux personnaliser l'apprentissage de vos élèves.",
    "de": "Es gab einige aufregende Änderungen in Ihrer Lehreransicht, um die Lernerfahrung Ihres Schülers besser zu personalisieren.",
    "pt": "Houve algumas mudanças no painel de controlo do professor, de modo a personalizar a experiência de aprendizagem dos alunos."
  },
  "27709": {
    "id": 27709,
    "item_id": "mtic2_agenda_v2",
    "en": "The two main features that have been affected are the Design of the overall Teacher View and the updated version of the Agenda.Continue reading below to get caught up on all of the changes and how they will help improve your experience with MathemaTIC.",
    "fr": "Les deux principaux changements concernent la mise en page de la vue enseignant ainsi que la structure et la présentation de l'agenda actualisé. Voyons comment ces modifications contribueront à améliorer l'utilisation de MathemaTIC.",
    "de": "Die zwei Hauptfunktionen, die davon betroffen sind, sind das Design der gesamten Lehrer-Ansicht und die aktualisierte Version von Agenda. Weiter. Lesen Sie weiter unten, um sich über alle Änderungen zu informieren und wie sie Ihre Erfahrung mit MathemaTIC verbessern können.",
    "pt": "As duas principais alterações são o design do painel de controlo do professor e uma versão atualizada da Agenda. Continue lendo abaixo, para obter mais informações sobre todas as alterações e como elas o vão ajudar a melhorar a sua experiência com MathemaTIC."
  },
  "27710": {
    "id": 27710,
    "item_id": "mtic2_agenda_v2",
    "en": "The design for MathemaTIC's teacher view has been updated to create a simpler, more streamlined experience as well as adding a few new features to help you get the most out of your resource.",
    "fr": "La conception de la vue enseignant de MathemaTIC a été modifié afin de rendre l'utilisation plus simple et intuitive. De plus, de nouvelles fonctions ont été ajoutées, ce qui engendre une utilisation optimale des ressources.",
    "de": "Das Design für die MathemaTIC-Lehreransicht wurde aktualisiert, um ein einfacheres, optimierteres Erlebnis zu schaffen und um einige neue Funktionen hinzuzufügen, die Ihnen helfen, Ihre Ressource optimal zu nutzen.",
    "pt": "A atualização do design do painel de controlo do professor, tem como objetivo facilitar a sua utilização e adicionar novas funcionalidades para ajudar a tirar o melhor partido dos recursos."
  },
  "27711": {
    "id": 27711,
    "item_id": "mtic2_agenda_v2",
    "en": "Navigation Bar",
    "fr": "Barre de navigation",
    "de": "Navigationsleiste",
    "pt": "Barra de navegação"
  },
  "27712": {
    "id": 27712,
    "item_id": "mtic2_agenda_v2",
    "en": "Once you have entered your class view, you will notice that the Navigation Bar has relocated from the top of your screen to the left hand side. This new design gives you more space on screen and makes navigating through MathemaTIC more efficient.",
    "fr": "Dès que vous avez sélectionné votre classe, vous remarquerez que la barre de navigation a été déplacée du haut de votre écran vers le côté gauche. Ce nouvelle structure vous donne plus d'espace sur l'écran, ce qui simplifie l'utilisation de MathemaTIC.",
    "de": "Sobald Sie Ihre Klassenansicht betreten haben, werden Sie feststellen, dass die Navigationsleiste vom oberen Bildschirmrand auf die linke Seite verschoben wurde. Dieses neue Design bietet mehr Platz auf dem Bildschirm und macht das Navigieren durch MathemaTIC effizienter.",
    "pt": "Após escolher uma classe, vai notar que a barra de navegação foi deslocada do topo do seu ecrã para o lado esquerdo. Este novo design dá-lhe mais espaço no ecrã e torna a navigação em MathemaTIC mais eficiente."
  },
  "27713": {
    "id": 27713,
    "item_id": "mtic2_agenda_v2",
    "en": "Design",
    "fr": "Design",
    "de": "Design",
    "pt": "Design"
  },
  "27714": {
    "id": 27714,
    "item_id": "mtic2_agenda_v2",
    "en": "Agenda",
    "fr": "Agenda",
    "de": "Agenda",
    "pt": "Agenda"
  },
  "27715": {
    "id": 27715,
    "item_id": "mtic2_agenda_v2",
    "en": "We are ecited to present our new and improved Agenda! Along with an updated design, the Agenda now contains several additional features that allow you to organize your classes,schedule items and review your students performances all in one convenient view. This feature works well for assigning time sensitive material such as assessments,homework, or test-preparation.",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27716": {
    "id": 27716,
    "item_id": "mtic2_agenda_v2",
    "en": "We are excited to present our new and improved Agenda! Along with an updated design, the Agenda now contains several additional features that allow you to organize your classes, schedule items and review your students performances all in one convenient view. This feature works well for assigning time-sensitive material such as assessments, homework, or test-preparation.",
    "fr": "Nous sommes ravis de vous  présenter notre nouvel Agenda qui contient de nouvelles fonctions qui vous permettent de mieux organiser vos classes, de personnaliser les horaires des travaux à effectuer  et d'examiner les performances de vos élèves en un coup d’œil. Ces fonctions sont surtout pratiques pour planifier des devoirs à domicile, organiser des révisions ou établir une liste de travaux de récupération ou d'approfondissement personnalisés.",
    "de": "Wir freuen uns, Ihnen unsere neue und verbesserte Agenda zu präsentieren! Zusammen mit einem aktualisierten Design enthält die Agenda nun einige zusätzliche Funktionen, mit denen Sie Ihre Klassen organisieren können",
    "pt": "Estamos orgulhosos apresentar a nova Agenda! Além da atualização do design, a Agenda contém agora funcionalidades adicionais que lhe permitem organizar as suas classes, criar novas unidades e avaliar o progresso dos seus estudantes. Esta funcionalidade permite criar tarefas personalizadas, trabalhos de casa ou revisões para testes."
  },
  "27717": {
    "id": 27717,
    "item_id": "mtic2_agenda_v2",
    "en": "Create Units",
    "fr": "Créer des unités d'agenda",
    "de": "Eintrag erstellen",
    "pt": "Criar unidades"
  },
  "27718": {
    "id": 27718,
    "item_id": "mtic2_agenda_v2",
    "en": "The updated design on the Agenda now allows you to start creating units directly from the calendar view.",
    "fr": "Désormais, il est possible de créer un nouvel agenda en cliquant directement sur une case du calendrier.",
    "de": "Mit dem aktualisierten Design auf der Agenda können Sie jetzt Units direkt aus der Kalenderansicht erstellen.",
    "pt": "O design atualizado da Agenda agora permite-lhe começar a criar unidades a partir do calendário."
  },
  "27719": {
    "id": 27719,
    "item_id": "mtic2_agenda_v2",
    "en": "You are able to assign eather whole modules or specific items and topics.",
    "fr": "Une fois les dates fixées, vous pouvez introduire dans votre agenda un module entier, des items spécifiques ainsi que les liens externes.",
    "de": "Sie können ganze Module oder bestimmte Elemente und Themen zuweisen.",
    "pt": "Pode atribuir módulos inteiros ou itens e temas específicos."
  },
  "27720": {
    "id": 27720,
    "item_id": "mtic2_agenda_v2",
    "en": "Within the unit creation window, you can choose to make units accessible only during a certain time frame by selecting a start and end date from the calendar. Your units can be assigned to individual students or an entire class.",
    "fr": "En sélectionnant, à partir du calandrier, une date de début et une date de clôture à partir du calendrier, vous pouvez choisir de rendre la liste des tâches accessibles uniquement pendant un certain temps \nDe plus vous avez la possibilité d'attribuer l'agenda à toute une classe ou à un ou plusieurs élèves.",
    "de": "Im Fenster zur Erstellung von Units können Sie festlegen, welche Units nur während eines bestimmten Zeitraums zugänglich gemacht werden, indem Sie ein Start- und Enddatum aus dem Kalender auswählen. Ihre Units können einzelnen Schülern oder einer ganzen Klasse zugewiesen werden.",
    "pt": "Ao criar uma nova unidade, pode escolher torná-la acessível sómente durante um certo período de tempo, selecionando uma data de início e de encerramento a partir do calendário. As suas unidades podem ser atribuídas a estudantes individuais ou a uma classe inteira."
  },
  "27721": {
    "id": 27721,
    "item_id": "mtic2_agenda_v2",
    "en": "Edit Units",
    "fr": "Modifier les agendas",
    "de": "Eintrag bearbeiten",
    "pt": "Editar unidades"
  },
  "27722": {
    "id": 27722,
    "item_id": "mtic2_agenda_v2",
    "en": "If you want to make any changes to your scheduled units, you can edit them directly from your calendar at any time.",
    "fr": "Toute modification d'un agenda existant peut être effectuée directement à partir du calendrier.",
    "de": "Wenn Sie Änderungen an Ihren geplanten Einträgen vornehmen möchten, können Sie diese jederzeit direkt in Ihrem Kalender bearbeiten.",
    "pt": "Se quiser alterar as suas unidades agendadas, pode editá-las diretamente  a qualquer altura a partir do calendário."
  },
  "27723": {
    "id": 27723,
    "item_id": "mtic2_agenda_v2",
    "en": "Assign Summative Assessments",
    "fr": "Attribuer l'évaluation sommative",
    "de": "Abschlusstest zuweisen",
    "pt": "Atribuir avaliação sumativa"
  },
  "27724": {
    "id": 27724,
    "item_id": "mtic2_agenda_v2",
    "en": "Whenever your students are ready to attempt a summative test, you can assign it directly from the Agenda.",
    "fr": "Dès que vos élèves sont prêts à effectuer un test sommatif, vous pouvez leur attribuer celui-ci grâce à la fonction de l'Agenda.",
    "de": "Wenn Ihre Schüler bereit sind einen Abschlusstest zu machen, können Sie diesen direkt aus der Agenda zuweisen.",
    "pt": "Sempre que os seus estudantes estão prontos para uma avaliação sumativa, pode atribuir-la diretamente através da Agenda."
  },
  "27725": {
    "id": 27725,
    "item_id": "mtic2_agenda_v2",
    "en": "To assign a module's summative test simply select the 'summative' check box at the top of the page inside of the unit creation window.",
    "fr": "Pour assigner l'évaluation sommative, simplement cochez la case test sommatif en haut de la page à l'intérieur de la fenêtre \"nouvel agenda\".",
    "de": "Um ein Objekt als Abschlusstest zuzuordnen, aktivieren Sie einfach das Kontrollkästchen \"Abschlusstest\" oben auf der Seite im Fenster für die Uniterstellungen.",
    "pt": "Para atribuir um item, tal como uma avaliação sumativa simplesmente selecione a caixa 'sumativo' no topo da página dentro da janela de criação da unidade."
  },
  "27726": {
    "id": 27726,
    "item_id": "mtic2_agenda_v2",
    "en": "Access Student Data",
    "fr": "Accéder aux données des étudiants",
    "de": "Auf Studentendaten zugreifen",
    "pt": "Aceder aos dados do aluno"
  },
  "27727": {
    "id": 27727,
    "item_id": "mtic2_agenda_v2",
    "en": "You can track how your student’s performed within an assigned unit directly from the Agenda or from your Dashboard.",
    "fr": "Vous pouvez suivre la progression de vos élèves  à partir de la fonction de l'agenda ou à partir de votre tableau de bord.",
    "de": "Sie können direkt in der Agenda oder vom Dashboard aus verfolgen, wie Ihr Schüler die zugewiesenen Einträge bearbeitet hat.",
    "pt": "Pode verificar a progressão de cada aluno ou da classe inteira perante as tarefas e avaliar o tempo necessitado para realizar itens específicos."
  },
  "27728": {
    "id": 27728,
    "item_id": "mtic2_agenda_v2",
    "en": "You can see how far a single student, or an entire class, has progressed through an assigned unit as well as the time spent on each item.",
    "fr": "Vous y trouverez des renseignements sur la progression de l' élève et sur le temps de travail utilisé pour chaque item.",
    "de": "Sie können sehen, wie weit ein einzelner Schüler oder eine ganze Klasse durch eine zugewiesene Unit fortgeschritten ist, sowie die verbrachte Zeit für jede Unit",
    "pt": "Pode verificar a progressão de cada aluno ou da classe inteira perante as tarefas e avaliar o tempo necessitado para realizar itens específicos."
  },
  "27729": {
    "id": 27729,
    "item_id": "mtic2_agenda_v2",
    "en": "Completed",
    "fr": "Terminé",
    "de": "Vollständig",
    "pt": "Completado"
  },
  "27730": {
    "id": 27730,
    "item_id": "mtic2_agenda_v2",
    "en": "not completed",
    "fr": "Non terminé",
    "de": "Unvollständig",
    "pt": "Incompleto"
  },
  "27731": {
    "id": 27731,
    "item_id": "mtic2_agenda_v2",
    "en": "Morning",
    "fr": "Matin",
    "de": "Morgens",
    "pt": "Manhã"
  },
  "27732": {
    "id": 27732,
    "item_id": "mtic2_agenda_v2",
    "en": "Afternoon",
    "fr": "Après midi",
    "de": "Nachmittags",
    "pt": "Tarde"
  },
  "27733": {
    "id": 27733,
    "item_id": "mtic2_agenda_v2",
    "en": "Evening & Weekend",
    "fr": "Soirée et fin de semaine",
    "de": "Am Abend & am Wochenende",
    "pt": "Noite e fim de semana"
  },
  "27734": {
    "id": 27734,
    "item_id": "mtic2_agenda_v2",
    "en": "An embedded page on this page says",
    "fr": "Une page intégrée à cette page dit",
    "de": "Eine eingebettete Seite auf dieser Seite sagt",
    "pt": "Uma página integrada nesta página diz"
  },
  "27735": {
    "id": 27735,
    "item_id": "mtic2_agenda_v2",
    "en": "You must click the check box to proceed.",
    "fr": "Cochez la case pour continuer.",
    "de": "Sie müssen auf das Kontrollkästchen klicken, um fortzufahren.",
    "pt": "Tem de clicar na caixa de seleção para prosseguir."
  },
  "27736": {
    "id": 27736,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was left incomplete x days ago",
    "fr": "Cette leçon a été quittée inachevée il y a x jours",
    "de": "Die unvolständige Lektion wurde vor x tagen abgebrochen",
    "pt": "Esta aula ficou sem completar há x dias"
  },
  "27737": {
    "id": 27737,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was left incomplete x months ago",
    "fr": "Cette leçon a été quittée inachevée il y a x mois",
    "de": "Die unvolständige Lektion wurde vor x monaten abgebrochen",
    "pt": "Esta aula ficou sem completar há x meses"
  },
  "27738": {
    "id": 27738,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was completed x days ago ",
    "fr": "Cette leçon a été achevée il y a x jours",
    "de": "Diese Lektion wurde vor x Tag abgeschlossen",
    "pt": "Esta aula foi completada há x dias"
  },
  "27739": {
    "id": 27739,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was completed x months ago",
    "fr": "Cette leçon a été achevée il y a x mois",
    "de": "Diese Lektion wurde vor x monaten abgeschlossen",
    "pt": "Esta aula foi completada há x  meses"
  },
  "27740": {
    "id": 27740,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was completed x days ago",
    "fr": "Cette évaluation a été achevée il y a x jours",
    "de": "Diese Bewertung wurde vor x tagen vollendet",
    "pt": "Esta avaliação foi completada há x dias"
  },
  "27741": {
    "id": 27741,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was completed x months ago",
    "fr": "Cette évaluation a été achevée il y a x mois",
    "de": "Diese Bewertung wurde vor x Jahr vollendet ( Jahren if its more then one)",
    "pt": "Esta avaliação foi completada há x meses"
  },
  "27742": {
    "id": 27742,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was left incomplete x days ago",
    "fr": "Cette évaluation a été quittée inachevée il y a x jours",
    "de": "Diese Bewertung wurde vor x tagen unvollständig hinterlassen",
    "pt": "Esta avaliação ficou sem completar há x dias"
  },
  "27743": {
    "id": 27743,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was left incomplete x months ago",
    "fr": "Cette évaluation a été quittée inachevée il y a x mois",
    "de": "Diese Einschätzung wurde vor x monaten unvollständig hinterlassen",
    "pt": "Esta avaliação ficou sem completar há x meses"
  },
  "27744": {
    "id": 27744,
    "item_id": "mtic2_agenda_v2",
    "en": "Time spent: x seconds",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27745": {
    "id": 27745,
    "item_id": "mtic2_agenda_v2",
    "en": "Score:",
    "fr": "Résultat:",
    "de": "Ergebniss",
    "pt": "Resultado:"
  },
  "27746": {
    "id": 27746,
    "item_id": "mtic2_agenda_v2",
    "en": "Time spent:",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "27747": {
    "id": 27747,
    "item_id": "mtic2_agenda_v2",
    "en": "minute(s)",
    "fr": "minute(s)",
    "de": "Minute(n)",
    "pt": "minuto(s)"
  },
  "27748": {
    "id": 27748,
    "item_id": "mtic2_agenda_v2",
    "en": "seconds",
    "fr": "secondes",
    "de": "Sekunde(n)",
    "pt": "segundos"
  },
  "27895": {
    "id": 27895,
    "item_id": "mtic2_agenda_v2",
    "en": "Adding Students to Your Class",
    "fr": "Ajouter des étudiants à votre classe",
    "de": "Schüler zur Klasse hinzufügen",
    "pt": "Adicionar alunos à sua classe"
  },
  "27896": {
    "id": 27896,
    "item_id": "mtic2_agenda_v2",
    "en": "Got it!",
    "fr": "Compris!",
    "de": "Verstanden!",
    "pt": "Percebido!"
  },
  "27897": {
    "id": 27897,
    "item_id": "mtic2_agenda_v2",
    "en": "There are no students assigned to this class",
    "fr": "Aucun étudiant n'a été attribué à cette classe",
    "de": "Es sind keine Schüler für diese Klasse angemeldet",
    "pt": "Ainda não há alunos atribuídos a esta classe."
  },
  "27898": {
    "id": 27898,
    "item_id": "mtic2_agenda_v2",
    "en": "Title",
    "fr": "Titre",
    "de": "Überschrift",
    "pt": "Título"
  },
  "28223": {
    "id": 28223,
    "item_id": "mtic2_agenda_v2",
    "en": "hour(s)",
    "fr": "heure(s)",
    "de": "Stunde(n)",
    "pt": "hora (s)"
  },
  "28224": {
    "id": 28224,
    "item_id": "mtic2_agenda_v2",
    "en": "Time spent",
    "fr": "temps consacré",
    "de": "benötigte Zeit",
    "pt": "Tempo necessário"
  },
  "28225": {
    "id": 28225,
    "item_id": "mtic2_agenda_v2",
    "en": "Overview",
    "fr": "aperçu général",
    "de": "Übersicht",
    "pt": "Visão geral"
  },
  "28226": {
    "id": 28226,
    "item_id": "mtic2_agenda_v2",
    "en": "There is no Agenda Unit ending this month",
    "fr": "Aucun Agenda ne prend fin ce mois-ci.",
    "de": "In diesem Monat endet kein Agenda.",
    "pt": "Não há nenhuma unidade da Agenda que termine neste mês"
  },
  "28251": {
    "id": 28251,
    "item_id": "mtic2_agenda_v2",
    "en": "Failed to load data",
    "fr": "Problèmes de téléchargment",
    "de": "Ein Fehler ist beim Laden aufgetreten",
    "pt": "Erro ao carregar dados"
  },
  "28280": {
    "id": 28280,
    "item_id": "mtic2_agenda_v2",
    "en": "Today",
    "fr": "Aujourd'hui",
    "de": "Heute",
    "pt": "Hoje"
  },
  "28468": {
    "id": 28468,
    "item_id": "mtic2_agenda_v2",
    "en": "SUN",
    "fr": "DIM",
    "de": "SON",
    "pt": "DOM"
  },
  "28469": {
    "id": 28469,
    "item_id": "mtic2_agenda_v2",
    "en": "MON",
    "fr": "LUN",
    "de": "MON",
    "pt": "SEG"
  },
  "28470": {
    "id": 28470,
    "item_id": "mtic2_agenda_v2",
    "en": "TUE",
    "fr": "MAR",
    "de": "DIE",
    "pt": "TER"
  },
  "28471": {
    "id": 28471,
    "item_id": "mtic2_agenda_v2",
    "en": "WED",
    "fr": "MER",
    "de": "MITT",
    "pt": "QUA"
  },
  "28472": {
    "id": 28472,
    "item_id": "mtic2_agenda_v2",
    "en": "THU",
    "fr": "JEU",
    "de": "DON",
    "pt": "QUI"
  },
  "28473": {
    "id": 28473,
    "item_id": "mtic2_agenda_v2",
    "en": "FRI",
    "fr": "VEN",
    "de": "FRE",
    "pt": "SEX"
  },
  "28474": {
    "id": 28474,
    "item_id": "mtic2_agenda_v2",
    "en": "SAT",
    "fr": "SAM",
    "de": "SAM",
    "pt": "SÁB"
  },
  "28477": {
    "id": 28477,
    "item_id": "mtic2_agenda_v2",
    "en": "January",
    "fr": "Janvier",
    "de": "Januar",
    "pt": "Janeiro"
  },
  "28478": {
    "id": 28478,
    "item_id": "mtic2_agenda_v2",
    "en": "February",
    "fr": "Février",
    "de": "Februar",
    "pt": "Fevereiro"
  },
  "28479": {
    "id": 28479,
    "item_id": "mtic2_agenda_v2",
    "en": "March",
    "fr": "Mars",
    "de": "März",
    "pt": "Março"
  },
  "28480": {
    "id": 28480,
    "item_id": "mtic2_agenda_v2",
    "en": "April",
    "fr": "Avril",
    "de": "April",
    "pt": "Abril"
  },
  "28481": {
    "id": 28481,
    "item_id": "mtic2_agenda_v2",
    "en": "May",
    "fr": "Mai",
    "de": "Mai",
    "pt": "Maio"
  },
  "28482": {
    "id": 28482,
    "item_id": "mtic2_agenda_v2",
    "en": "June",
    "fr": "Juin",
    "de": "Juni",
    "pt": "Junho"
  },
  "28483": {
    "id": 28483,
    "item_id": "mtic2_agenda_v2",
    "en": "July",
    "fr": "Juillet",
    "de": "Juli",
    "pt": "Julho"
  },
  "28484": {
    "id": 28484,
    "item_id": "mtic2_agenda_v2",
    "en": "August",
    "fr": "Août",
    "de": "August",
    "pt": "Agosto"
  },
  "28485": {
    "id": 28485,
    "item_id": "mtic2_agenda_v2",
    "en": "September",
    "fr": "Septembre",
    "de": "September",
    "pt": "Setembro"
  },
  "28486": {
    "id": 28486,
    "item_id": "mtic2_agenda_v2",
    "en": "October",
    "fr": "Octobre",
    "de": "Oktober",
    "pt": "Outubro"
  },
  "28487": {
    "id": 28487,
    "item_id": "mtic2_agenda_v2",
    "en": "November",
    "fr": "Novembre",
    "de": "November",
    "pt": "Novembro"
  },
  "28488": {
    "id": 28488,
    "item_id": "mtic2_agenda_v2",
    "en": "December",
    "fr": "Décembre",
    "de": "Dezember",
    "pt": "Dezembro"
  },
  "28490": {
    "id": 28490,
    "item_id": "mtic2_agenda_v2",
    "en": "END DATE",
    "fr": "date de clôture",
    "de": "Endtermin",
    "pt": "Data Final"
  },
  "28492": {
    "id": 28492,
    "item_id": "mtic2_agenda_v2",
    "en": "Not started",
    "fr": "Not started",
    "de": "Not started",
    "pt": "Not started"
  },
  "28496": {
    "id": 28496,
    "item_id": "mtic2_agenda_v2",
    "en": "Hide Archived Classes",
    "fr": "Cacher les classes archivées",
    "de": "Verbergen Klassen anzeigen",
    "pt": "Ocultar classes arquivadas"
  },
  "28497": {
    "id": 28497,
    "item_id": "mtic2_agenda_v2",
    "en": "Problem joining class. Please contact support.",
    "fr": "Problème d'adhésion à la classe. Veuillez contacter le support.",
    "de": "Problem beim Beitritt zur Klasse. Bitte kontaktieren Sie den Support.",
    "pt": "Problema ao se inscrever nesta turma. Por favor, entre em contato com o suporte."
  },
  "28498": {
    "id": 28498,
    "item_id": "mtic2_agenda_v2",
    "en": "You are already enrolled in this class.",
    "fr": "Tu es déjà inscrit dans cette classe.",
    "de": "Sie sind bereits in dieser Klasse angemeldet.",
    "pt": "Você já está inscrito nesta turma."
  },
  "28499": {
    "id": 28499,
    "item_id": "mtic2_agenda_v2",
    "en": "No such class found.",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28502": {
    "id": 28502,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was left incomplete x hours ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28503": {
    "id": 28503,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was left incomplete x seconds ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28504": {
    "id": 28504,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was completed x hours ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28505": {
    "id": 28505,
    "item_id": "mtic2_agenda_v2",
    "en": "This lesson was completed x seconds ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28506": {
    "id": 28506,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was completed x hours ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28507": {
    "id": 28507,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was completed x seconds ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28508": {
    "id": 28508,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was left incomplete x hours ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28509": {
    "id": 28509,
    "item_id": "mtic2_agenda_v2",
    "en": "This assessment was left incomplete x seconds ago",
    "fr": "NA",
    "de": "NA",
    "pt": "NA"
  },
  "28510": {
    "id": 28510,
    "item_id": "mtic_c3_m2_run",
    "en": "MathleTIC/Mental Math",
    "fr": "MathleTIC/Calcul mental",
    "de": "MathleTIC/Kopfrechnen",
    "pt": "MathleTIC/Cálculo mental"
  },
  "28648": {
    "id": 28648,
    "item_id": "mtic2_agenda_v2",
    "en": "Custom Activity ",
    "fr": "Activité Personnalisée",
    "de": "benutzerdefinierte Aktivität ein",
    "pt": "Tarefa Personalizada"
  },
  "31668": {
    "id": 31668,
    "item_id": "mtic2_agenda_v2",
    "en": "Download",
    "fr": "Télécharger",
    "de": "Herunterladen",
    "pt": "Descarregar"
  },
  "31669": {
    "id": 31669,
    "item_id": "mtic2_agenda_v2",
    "en": "Unavailable",
    "fr": "Non-disponible",
    "de": "Nicht verfügbar",
    "pt": "Não disponível"
  },
  "31670": {
    "id": 31670,
    "item_id": "mtic2_agenda_v2",
    "en": "Download Student Learning Report",
    "fr": "Télécharger le rapport d’apprentissage élève",
    "de": "Laden Sie den Lernbericht herunter",
    "pt": "Descarregar o Relatório de Aprendizado do Aluno"
  },
  "31671": {
    "id": 31671,
    "item_id": "mtic2_agenda_v2",
    "en": "Select a student..",
    "fr": "Choisir un élève",
    "de": "Wählen Sie einen Schüler aus",
    "pt": "Selecionar um aluno"
  },

  //mtic2_teacher_view
  "14556": {
    "id": 14556,
    "item_id": "mtic2_teacher_view",
    "en": "Connect to your school",
    "fr": "Connectez-vous à votre école",
    "de": "Verknüpfen Sie sich mit Ihrer Schule.",
    "pt": "Conectar-se à sua escola."
  },
  "14557": {
    "id": 14557,
    "item_id": "mtic2_teacher_view",
    "en": "Select school type...",
    "fr": "Sélectionner le type d’école...",
    "de": "Schultyp wählen",
    "pt": "Selecionar o tipo de escola ..."
  },
  "14558": {
    "id": 14558,
    "item_id": "mtic2_teacher_view",
    "en": "Search school by name",
    "fr": "Rechercher l'école par son nom",
    "de": "Schule nach Namen suchen",
    "pt": "Pesquisar escola por nome"
  },
  "14559": {
    "id": 14559,
    "item_id": "mtic2_teacher_view",
    "en": "Your Active Classes",
    "fr": "Vos classes actives",
    "de": "Ihre aktuellen Klassen",
    "pt": "Suas classes ativas"
  },
  "14560": {
    "id": 14560,
    "item_id": "mtic2_teacher_view",
    "en": "Click here to create a class",
    "fr": "Cliquez ici pour créer une classe",
    "de": "Klicken Sie hier, um eine Klasse zu erstellen.",
    "pt": "Clicar aqui para criar uma classe"
  },
  "14561": {
    "id": 14561,
    "item_id": "mtic2_teacher_view",
    "en": "New Class ",
    "fr": "Nouvelle classe",
    "de": "Neue Klasse",
    "pt": "Nova Classe"
  },
  "14562": {
    "id": 14562,
    "item_id": "mtic2_teacher_view",
    "en": "Select the class grade level...",
    "fr": "Sélectionner le cycle de la classe...",
    "de": "Wählen Sie den Zyklus Ihrer Klasse...",
    "pt": "Selecionar o ciclo da classe ..."
  },
  "14563": {
    "id": 14563,
    "item_id": "mtic2_teacher_view",
    "en": "Name your class",
    "fr": "Nommez votre classe",
    "de": "Benennen Sie Ihre Klasse",
    "pt": "Nomear sua classe"
  },
  "14564": {
    "id": 14564,
    "item_id": "mtic2_teacher_view",
    "en": "Add Class",
    "fr": "Ajouter une classe",
    "de": "Klasse hinzufügen",
    "pt": "Adicionar uma classe"
  },
  "14565": {
    "id": 14565,
    "item_id": "mtic2_teacher_view",
    "en": "View class",
    "fr": "Afficher la classe",
    "de": "Klassenansicht",
    "pt": "Visualizar a classe"
  },
  "studentsAddRemove": {
    "id": 0,
    "item_id": "mtic2_teacher_view",
    "en": "Add/Remove Students",
    "fr": "Add/Remove Students",
    "de": "Add/Remove Students",
    "pt": "Add/Remove Students"
  },
  "14566": {
    "id": 14566,
    "item_id": "mtic2_teacher_view",
    "en": "Dashboard",
    "fr": "Tableau de bord",
    "de": "Benutzeroberfläche",
    "pt": "Painel de controlo"
  },
  "14567": {
    "id": 14567,
    "item_id": "mtic2_teacher_view",
    "en": "Agenda",
    "fr": "Agenda",
    "de": "Agenda",
    "pt": "Agenda"
  },
  "14568": {
    "id": 14568,
    "item_id": "mtic2_teacher_view",
    "en": "Activity Log",
    "fr": "Historique des travaux",
    "de": "Arbeitsverlauf",
    "pt": "Histórico de trabalho"
  },
  "14569": {
    "id": 14569,
    "item_id": "mtic2_teacher_view",
    "en": "Modules",
    "fr": "Modules",
    "de": "Module",
    "pt": "Módulos"
  },
  "14570": {
    "id": 14570,
    "item_id": "mtic2_teacher_view",
    "en": "FAQ & Documents",
    "fr": "FAQ & Documents",
    "de": "FAQ & Dokumente",
    "pt": "FAQ & Documentos"
  },
  "14571": {
    "id": 14571,
    "item_id": "mtic2_teacher_view",
    "en": "Be sure to activate the IAM accounts to add your students to this class. For more information, watch this video.",
    "fr": "Veillez activer les comptes IAM pour ajouter vos étudiants à cette classe. Pour plus d'informations, regardez cette vidéo.",
    "de": "Um Schüler zu dieser Klasse hinzuzufügen, müssen sie ein IAM-Konto haben. Sehen Sie sich für weitere Informationen dieses Video an.",
    "pt": "Certifique-se de ativar as contas IAM para adicionar os seus alunos a esta classe. Obtenha mais informações no seguinte vídeo."
  },
  "14572": {
    "id": 14572,
    "item_id": "mtic2_teacher_view",
    "en": "The following class code allows your students to connect to your class after logging in to MathemaTIC with their IAM:",
    "fr": "Le code classe suivant permet à vos élèves de se connecter à votre classe, après avoir démarré la session MathemaTIC avec l'IAM:",
    "de": "Nachdem sich Ihre Schüler mit ihrem IAM-Code bei MathemaTIC eingeloggt haben, geben Sie Ihnen den folgenden Klassencode, um sie zu Ihrer Klasse hinzuzufügen.",
    "pt": "O código de classe seguinte permite aos seus alunos de se conectarem à sua classe, após iniciaram a sessão de MathemaTIC com o IAM:"
  },
  "14573": {
    "id": 14573,
    "item_id": "mtic2_teacher_view",
    "en": "No data for your class",
    "fr": "Pas de données pour votre classe",
    "de": "Keine Daten für Ihre Klasse",
    "pt": "Não há dados para sua classe"
  },
  "14574": {
    "id": 14574,
    "item_id": "mtic2_teacher_view",
    "en": "All modules",
    "fr": "Tous les modules",
    "de": "Alle Module",
    "pt": "Todos os módulos"
  },
  "14575": {
    "id": 14575,
    "item_id": "mtic2_teacher_view",
    "en": "All students",
    "fr": "Tous les étudiants",
    "de": "Alle Schüler",
    "pt": "Todos os alunos"
  },
  "14576": {
    "id": 14576,
    "item_id": "mtic2_teacher_view",
    "en": "No item selected",
    "fr": "Pas d'item sélectionné",
    "de": "Keine Aufgabe ausgewählt",
    "pt": "Nenhum item selecionado"
  },
  "14577": {
    "id": 14577,
    "item_id": "mtic2_teacher_view",
    "en": "Coming soon",
    "fr": "Bientôt disponible",
    "de": "In Kürze",
    "pt": "Em breve"
  },
  "14578": {
    "id": 14578,
    "item_id": "mtic2_teacher_view",
    "en": "Enter details for your new class: ",
    "fr": "Entrez les informations de votre nouvelle classe:",
    "de": "Geben Sie Informationen zu Ihrer neuen Klasse ein:",
    "pt": "Inserir detalhes para a nova classe:"
  },
  "14579": {
    "id": 14579,
    "item_id": "mtic2_teacher_view",
    "en": "Hide",
    "fr": "Masquer",
    "de": "Ausblenden",
    "pt": "Ocultar"
  },
  "14580": {
    "id": 14580,
    "item_id": "mtic2_teacher_view",
    "en": "Our support team is not available at the moment. Please use the contact form and we will get back to you as soon as possible.",
    "fr": "Notre équipe de support n'est actuellement pas disponible. Veuillez utiliser le formulaire de contact et nous vous recontacterons dans les plus brefs délais.",
    "de": "Unser Support-Team ist im Moment nicht erreichbar. Benutzen Sie bitte das Kontaktformular und wir werden uns schnellstmöglich bei Ihnen melden.",
    "pt": "Nossa equipe de suporte não está disponível neste momento. Use o formulário de contacto e tentaremos contactá-lo o mais rápido possível."
  },
  "14581": {
    "id": 14581,
    "item_id": "mtic2_teacher_view",
    "en": "Your class(es)",
    "fr": "Ta/Tes classe(s)",
    "de": "Deine Klasse(n)",
    "pt": "Aceder à sua classe"
  },
  "14582": {
    "id": 14582,
    "item_id": "mtic2_teacher_view",
    "en": "Class Code:",
    "fr": "Code de la classe:",
    "de": "Klassencode:",
    "pt": "Código de Classe:"
  },
  "14583": {
    "id": 14583,
    "item_id": "mtic2_teacher_view",
    "en": "Ask your teacher for the class code.",
    "fr": "Demande à ton enseignant(e) pour le code de classe.",
    "de": "Frage deinen Lehrer nach dem Klassencode.",
    "pt": "Pergunta ao teu professor o código da classe."
  },
  "14584": {
    "id": 14584,
    "item_id": "mtic2_teacher_view",
    "en": "To other grades",
    "fr": "Vers d’autres cycles",
    "de": "Zu anderen Schuljahren",
    "pt": "Aceder os módulos"
  },
  "14585": {
    "id": 14585,
    "item_id": "mtic2_teacher_view",
    "en": "View modules",
    "fr": "Voir les modules",
    "de": "Module ansehen",
    "pt": "Visualizar módulos"
  },
  "14586": {
    "id": 14586,
    "item_id": "mtic2_teacher_view",
    "en": "Share my class",
    "fr": "Partager ma classe",
    "de": "Meine Klasse teilen",
    "pt": "Compartilhar minha classe"
  },
  "29373": {
    "id": 29373,
    "item_id": "mtic2_teacher_view",
    "en": "Leaderboard",
    "fr": "Classement",
    "de": "Bestenliste",
    "pt": "Classificação"
  },
  "29374": {
    "id": 29374,
    "item_id": "mtic2_teacher_view",
    "en": "Rank",
    "fr": "Rang",
    "de": "Platz",
    "pt": "Classificação"
  },
  "29375": {
    "id": 29375,
    "item_id": "mtic2_teacher_view",
    "en": "Stars",
    "fr": "Étoiles",
    "de": "Sterne",
    "pt": "Estrelas"
  },
  "29376": {
    "id": 29376,
    "item_id": "mtic2_teacher_view",
    "en": "Badges",
    "fr": "Badges",
    "de": "Medaillen",
    "pt": "Distintivos"
  },
  "29377": {
    "id": 29377,
    "item_id": "mtic2_teacher_view",
    "en": "Top Total",
    "fr": "Meilleurs résultats",
    "de": "Beste Ergebnisse",
    "pt": "Melhores resultados"
  },
  "29493": {
    "id": 29493,
    "item_id": "mtic2_teacher_view",
    "en": "(You must have 10 or more students to qualify for an average scores)",
    "fr": "(Vous devez avoir 10 étudiants ou plus pour avoir accès à la moyenne des résultats)",
    "de": "(Es müssen 10 oder mehr Schüler sein, um einen Durchschnitt berechnen zu können)",
    "pt": "(Ao menos 10 alunos têm de estar inscritos na classe para obter uma pontuação média)"
  },
  "29378": {
    "id": 29378,
    "item_id": "mtic2_teacher_view",
    "en": "Top Average",
    "fr": "Meilleures moyennes",
    "de": "Bester Durchschnitt",
    "pt": "Melhores pontuações médias"
  },
  "29379": {
    "id": 29379,
    "item_id": "mtic2_teacher_view",
    "en": "My Class",
    "fr": "Ma Classe",
    "de": "Ma Classe",
    "pt": "Ma Classe"
  },
  "14587": {
    "id": 14587,
    "item_id": "mtic2_teacher_view",
    "en": "To share this class with another teacher, send an email to: mathematic@vretta.com",
    "fr": "Pour partager cette classe avec un(e) autre enseignant(e), envoyez un courrier électronique à: mathematic@vretta.com",
    "de": "Um diese Klasse mit einem anderen Lehrer zu teilen, schicken Sie eine Email an: mathematic@vretta.com",
    "pt": "Para compartilhar esta classe com outro professor, envie um email para: mathematic@vretta.com"
  },
  "14588": {
    "id": 14588,
    "item_id": "mtic2_teacher_view",
    "en": "Put \"Share my MathemaTIC Class\" in the subject line.",
    "fr": "Mettez \"Partager ma classe MathemaTIC\" en objet.",
    "de": "Schreiben Sie \"Meine MathemaTIC-Klasse teilen\" in die Betreffzeile.",
    "pt": "Coloque \"Compartilhar minha classe MathemaTIC\" na linha de assunto."
  },
  "14589": {
    "id": 14589,
    "item_id": "mtic2_teacher_view",
    "en": "Include your class code, and the IAM email address of the teacher you wish to share the class with.",
    "fr": "Incluez votre code de classe et l'adresse électronique IAM de l'enseignant(e) avec laquelle ou lequel vous souhaitez partager la classe.",
    "de": "Ergänzen Sie Ihren Klassencode und die IAM-Email-Adresse des Lehrers, mit dem Sie Ihre Klasse teilen wollen.",
    "pt": "Inclua seu código de classe e o endereço de e-mail IAM do professor com quem deseja compartilhar a classe."
  },
  "14778": {
    "id": 14778,
    "item_id": "mtic2_teacher_view",
    "en": "Add student",
    "fr": "Ajouter un étudiant ",
    "de": "Schüler hinzufügen",
    "pt": "Adicionar aluno"
  },
  "14779": {
    "id": 14779,
    "item_id": "mtic2_teacher_view",
    "en": "My classes",
    "fr": "Mes classes",
    "de": "Meine Klassen",
    "pt": "Minhas classes"
  },
  "14781": {
    "id": 14781,
    "item_id": "mtic2_teacher_view",
    "en": "Join another class",
    "fr": "Joindre une autre classe",
    "de": "Einer anderen Klasse beitreten",
    "pt": "Juntar-se a outra classe"
  },

  "16278": {
    "id": 16278,
    "item_id": "mtic2_archivestudent",
    "en": "Active Students",
    "fr": "Étudiants actifs",
    "de": "Aktive Schüler",
    "pt": "Alunos Ativos"
  },
  "16279": {
    "id": 16279,
    "item_id": "mtic2_archivestudent",
    "en": "Archived Students",
    "fr": "Étudiants archivés",
    "de": "Archivierte Schüler",
    "pt": "Alunos Arquivados"
  },
  "16280": {
    "id": 16280,
    "item_id": "mtic2_archivestudent",
    "en": "Remove student",
    "fr": "Supprimer l'étudiant",
    "de": "Schüler entfernen",
    "pt": "Eliminar aluno"
  },
  "16281": {
    "id": 16281,
    "item_id": "mtic2_archivestudent",
    "en": "The following students will be moved to the Archived Students list.",
    "fr": "Les étudiants suivants seront déplacés vers la liste des Étudiants Archivés.",
    "de": "Die folgenden Schüler werden archiviert.",
    "pt": "Os seguintes alunos vão ser movidos para a lista de Alunos Arquivados."
  },
  "16282": {
    "id": 16282,
    "item_id": "mtic2_archivestudent",
    "en": "Are you sure you want to remove these students from the Active Students list?",
    "fr": "Êtes-vous sûr de vouloir supprimer ces étudiants de la liste des Étudiants Actifs?",
    "de": "Sind Sie sicher Sie möchten die folgenden Schüler von der aktiven Schülerliste entfernen?",
    "pt": "Tem a certeza que pretende eliminar estes alunos da lista de Alunos Ativos?"
  },
  "16283": {
    "id": 16283,
    "item_id": "mtic2_archivestudent",
    "en": "Yes",
    "fr": "Oui",
    "de": "Ja",
    "pt": "Sim"
  },
  "16284": {
    "id": 16284,
    "item_id": "mtic2_archivestudent",
    "en": "No",
    "fr": "Non",
    "de": "Nein",
    "pt": "Não"
  },
  "16285": {
    "id": 16285,
    "item_id": "mtic2_archivestudent",
    "en": "Un-archive Student",
    "fr": "Désarchiver l'étudiant",
    "de": "Schüler wiederherstellen",
    "pt": "Desarquive o Aluno"
  },
  "16286": {
    "id": 16286,
    "item_id": "mtic2_archivestudent",
    "en": "The following students will be moved to the Active Students list.",
    "fr": "Les étudiants suivants seront déplacés vers la liste des Étudiants Actifs.",
    "de": "Die folgenden Schüler werden zur aktiven Schülerliste verschoben.",
    "pt": "Os seguintes alunos vão ser movidos para a lista de Alunos Ativos."
  },
  "16287": {
    "id": 16287,
    "item_id": "mtic2_archivestudent",
    "en": "Are you sure you want to un-archive these students and move them back to the Active Students list?",
    "fr": "Êtes-vous sûr de vouloir désarchiver ces étudiants et les réinscrire dans la liste des Étudiants Actifs?",
    "de": "Sind Sie sicher Sie möchten die Schüler wiederherstellen und sie zur aktiven Schülerliste verschieben?",
    "pt": "Tem a certeza que pretende desarquivar estes alunos e movê-los para a lista de Alunos Ativos?"
  },
  "16288": {
    "id": 16288,
    "item_id": "mtic2_archivestudent",
    "en": "Archive Student",
    "fr": "Archiver l'étudiant",
    "de": "Schüler archivieren",
    "pt": "Arquivar Alunos"
  },
  "16289": {
    "id": 16288,
    "item_id": "mtic2_archivestudent",
    "en": "Done",
    "fr": "Terminer",
    "de": "Fertig",
    "pt": "Terminado"
  },
  "16814": {
    "id": 16814,
    "item_id": "mtic_platform_general",
    "en": "Please note that your class can be shared only if your colleague has already created a MathemaTIC account.",
    "fr": "Veuillez noter que votre classe peut être partagée seulement si votre collègue a déjà créé son compte MathemaTIC.",
    "de": "Bitte beachten Sie das Ihre Klasse nur geteilt werden kann wenn Ihr Kollege bereits ein MathemaTIC account erstellt hat.",
    "pt": "Por favor, note que a aula só pode ser partilhada se o seu colega já tiver uma conta MathemaTIC."
  },
  "16815": {
    "id": 16815,
    "fr": "Connexion avec IAM",
    "de": "Anmelden mit IAM",
    "pt": "Conectar-se usando IAM",
    "en": "Login using IAM"
  }
});

angular.module('mtic').constant('LANGUAGE_TEXT_SLUGS', {
  "docs_chapters_title": {
    "en": "Chapters \"ready to go\"",
    "fr": "Chapitres \"ready to go\"",
    "de": "Kapitel \"ready to go\"",
    "pt": "Capítulos \"pronto para utilizar\""
  },
  "show_map": {
    "en": "Show Map",
    "fr": "Vue d'ensemble",
    "de": "Übersicht",
    "pt": "Mostrar mapa"
  },
  "mtic_post_test": {
    "en": "MathemaTIC évaluation de fin d'année",
    "fr": "MathemaTIC évaluation de fin d'année",
    "de": "MathemaTIC Abschlusstest",
    "pt": "MathemaTIC évaluation de fin d'année"
  },
  "mtic_student_offboarding": {
    "en": "Satisfaction Questionnaire",
    "fr": "Questionnaire de satisfaction",
    "de": "Questionnaire de satisfaction",
    "pt": "Questionnaire de satisfaction"
  },
  "mtic_teacher_offboarding": {
    "en": "Satisfaction Questionnaire",
    "fr": "Questionnaire de satisfaction",
    "de": "Questionnaire de satisfaction",
    "pt": "Questionnaire de satisfaction"
  },
  "sent_to_student": {
    "en": "Sent to Students",
    "fr": "Envoyé aux étudiants",
    "de": "Zu Schüler verschickt",
    "pt": "Enviado aos Alunos"
  },

  "cambridge_meta_module": {
    "en": "Cambridge Assessment",
    "fr": "Cambridge Assessment",
    "de": "Cambridge Assessment",
    "pt": "Cambridge Assessment"
  },
  "c4_m1_1_key_questions": {
    "en": "Key Questions",
    "fr": "Key Questions",
    "de": "Key Questions",
    "pt": "Key Questions"
  },
  "c4_m1_2_key_questions": {
    "en": "Key Questions",
    "fr": "Key Questions",
    "de": "Key Questions",
    "pt": "Key Questions"
  },
  "c4_m1_3_key_questions": {
    "en": "Key Questions",
    "fr": "Key Questions",
    "de": "Key Questions",
    "pt": "Key Questions"
  },
  "c4_m1_4_key_questions": {
    "en": "Key Questions",
    "fr": "Key Questions",
    "de": "Key Questions",
    "pt": "Key Questions"
  },
  "c4_m1_5_key_questions": {
    "en": "Key Questions",
    "fr": "Key Questions",
    "de": "Key Questions",
    "pt": "Key Questions"
  },

  "c4_meta_module": {
    "en": "EF: Cycle 4",
    "fr": "EF: Cycle 4",
    "de": "EF: Cycle 4",
    "pt": "EF: Cycle 4"
  },
  "c4_m1": {
    "en": "Area and Perimeter",
    "fr": "L'aire et le périmètre",
    "de": "Flächeninhalt und Umfang",
    "pt": "Área e perímetro"
  },
  "c4_m2": {
    "en": "Natural Numbers",
    "fr": "Nombres Naturels",
    "de": "Natürliche Zahlen",
    "pt": "Números Naturais"
  },
  "c4_m3": {
    "en": "Fractions",
    "fr": "Fractions",
    "de": "Brüche",
    "pt": "Frações"
  },
  "c4_m4": {
    "en": "Decimals",
    "fr": "Décimaux",
    "de": "Dezimalzahlen",
    "pt": "Números Decimais"
  },
  "c4_m5": {
    "en": "Data Management",
    "fr": "Gestion de données",
    "de": "Datenmanagement",
    "pt": "Gestão de dados"
  },
  "c4_m6": {
    "en": "Geometry",
    "fr": "Géométrie",
    "de": "Geometrie",
    "pt": "Geometria"
  },
  "click_a_face": {
    "en": "(Click on one of the faces)",
    "fr": "(Clique sur l'un des visages)",
    "de": "(Klicke auf ein Gesicht)",
    "pt": "(Clica em um dos rostos)"
  },
  "qc_module": {
    "en": "QC Module",
    "fr": "QC Module",
    "de": "QC Module",
    "pt": "QC Module"
  },
  "mtic-finalization": {
    "en": "Registration",
    "fr": "Registration",
    "de": "Registrieren",
    "pt": "Registo"
  },
  "mtic_g78_m0_getting_started_group": {
    "en": "Getting Started",
    "fr": "Pré-requis",
    "de": "Anfangen",
    "pt": "Vamos começar"
  },
  "mtic_g78_m0_algebra_start_group": {
    "en": "Beginnings of Algebra",
    "fr": "Vocabulaire",
    "de": "Starten mit Algebra",
    "pt": "Iniciação à álgebra"
  },
  "mtic_g78_m0_algebra_expr_group": {
    "en": "Simplifying Algebraic Expressions",
    "fr": "Simplifier",
    "de": "Terme vereinfachen",
    "pt": "Simplificar"
  },
  "mtic_g78_m0_algebra_expr2_group": {
    "en": "Creating Algebraic Expressions",
    "fr": "Création d'expressions littéral",
    "de": "Terme aufstellen",
    "pt": "Criação de expressões algébricas"
  },
  "mtic_g78_m0_unknown_group": {
    "en": "Substituting for Unknowns",
    "fr": "Substitution",
    "de": "Ersetzen",
    "pt": "Substituição"
  },
  "mtic_c3_m2": {
    "en": "MathleTIC - Mental Math",
    "fr": "MathleTIC - Calcul mental",
    "de": "MathleTIC - Kopfrechnen",
    "pt": "MathleTIC - Cálculo mental"
  },
  "mtic_c3_m3": {
    "en": "Numbers and Operations",
    "fr": "Nombres et opérations",
    "de": "Zahlen und Operationen",
    "pt": "Números e Operações"
  },
  "mtic_c3_m4": {
    "en": "Space, Shape and Measures",
    "fr": "Espace, formes et mesures",
    "de": "Raum, Form und Maße",
    "pt": "Espaço, formas e medidas"
  },
  "dataprotectionen": {
    "en": "Data Protection And Privacy Policy - en",
    "fr": "Protection Des Données Et Politique De Confidentialité - en",
    "de": "Datenschutz Und Private Datenschutzbestimmungen - en",
    "pt": "Proteção Dos Dados E Política De Privacidade - en"
  },
  "dataprotectionfr": {
    "en": "Data Protection And Privacy Policy - fr",
    "fr": "Protection Des Données Et Politique De Confidentialité - fr",
    "de": "Datenschutz Und Private Datenschutzbestimmungen - fr",
    "pt": "Proteção Dos Dados E Política De Privacidade - fr"
  },
  "dataprotectionde": {
    "en": "Data Protection And Privacy Policy - de",
    "fr": "Protection Des Données Et Politique De Confidentialité - de",
    "de": "Datenschutz Und Private Datenschutzbestimmungen - de",
    "pt": "Proteção Dos Dados E Política De Privacidade - de"
  },
  "dataprotectionpt": {
    "en": "Data Protection And Privacy Policy - pt",
    "fr": "Protection Des Données Et Politique De Confidentialité - pt",
    "de": "Datenschutz Und Private Datenschutzbestimmungen - pt",
    "pt": "Proteção Dos Dados E Política De Privacidade - pt"
  },
  "mtic_gr78_m0": {
    "en": "Introduction to Algebra",
    "fr": "Introduction : Calcul Littéral",
    "de": "Einführung in die Algebra",
    "pt": "Introdução à Álgebra"
  },
  "mtic_gr78_m3": {
    "en": "Equations",
    "fr": "Équations",
    "de": "Gleichungen",
    "pt": "Equações"
  },
  "mtic_gr78_m4": {
    "en": "Fractions",
    "fr": "Nombres en écriture fractionnaire",
    "de": "Brüche",
    "pt": "Frações"
  },
  "mtic_gr78_m5": {
    "en": "Integers",
    "fr": "Nombres relatifs",
    "de": "Ganze Zahlen",
    "pt": "Números inteiros"
  },
  "mtic_gr78_m6": {
    "en": "Statistics",
    "fr": "Statistiques",
    "de": "Statistiken",
    "pt": "Estatisticas"
  },
  "mtic_gr78_m7": {
    "en": "Transformations",
    "fr": "Transformations",
    "de": "Abbildungen",
    "pt": "Transformações"
  },
  "mtic_gr78_m8": {
    "en": "Perimeter, Area and Volume",
    "fr": "Périmètre, Aire et Volume",
    "de": "Umfang, Fläche und Volumen",
    "pt": "Perímetro, área e volume"
  },
  "mtic_gr78_m9": {
    "en": "Angles and Geometric Constructions",
    "fr": "Angles et constructions géométriques",
    "de": "Winkel und geometrische Konstruktionen",
    "pt": "Ângulos e construções geométricas"
  },
  "start_item": {
    "en": "START",
    "fr": "COMMENCER",
    "de": "START",
    "pt": "INICIAR"
  },
  "inactivity_1": {
    "en": "You have been inactive for a while.",
    "fr": "Vous êtes inactif depuis un moment.",
    "de": "Vous êtes inactif depuis un moment.",
    "pt": "Vous êtes inactif depuis un moment."
  },
  "inactivity_2": {
    "en": "Please interact with the page, otherwise you will be logged out in 1 minute.",
    "fr": "Veuillez s'il vous plait interagir avec la page sinon vous serez déconnecté dans 1 minute.",
    "de": "Veuillez s'il vous plait interagir avec la page sinon vous serez déconnecté dans 1 minute.",
    "pt": "Veuillez s'il vous plait interagir avec la page sinon vous serez déconnecté dans 1 minute."
  },
  "mtic_c3_m_meta": {
    "en": "EF: Cycle 3",
    "fr": "EF: Cycle 3",
    "de": "EF: Cycle 3",
    "pt": "EF: Cycle 3"
  },
  "run_like_math": {
    "en": "MathleTIC Mental Math",
    "fr": "MathleTIC Calcul mental",
    "de": "MathleTIC Kopfrechnen",
    "pt": "MathleTIC Cálculo mental"
  },
  "run_like_math_addition": {
    "en": "Addition",
    "fr": "Addition",
    "de": "Addition",
    "pt": "Adição"
  },
  "run_like_math_subtraction": {
    "en": "Subtraction",
    "fr": "Soustraction",
    "de": "Subtraktion",
    "pt": "Subtração"
  },
  "run_like_math_multiplication": {
    "en": "Multiplication",
    "fr": "Multiplication",
    "de": "Multiplikation",
    "pt": "Multiplicação"
  },
  "run_like_math_division": {
    "en": "Division",
    "fr": "Division",
    "de": "Division",
    "pt": "Divisão"
  },
  "run_like_math_select_mode": {
    "en": "Select Mode",
    "fr": "Choisir mode",
    "de": "wählen",
    "pt": "Selecionar modo"
  },
  "run_like_math_training": {
    "en": "Training",
    "fr": "Entrainement",
    "de": "Training",
    "pt": "Treino"
  },
  "run_like_math_challenge": {
    "en": "Challenge",
    "fr": "Course",
    "de": "Wettbewerb",
    "pt": "Desafio"
  },
  "Agendas": {
    "en": "Agendas",
    "fr": "Agendas",
    "de": "Agendas",
    "pt": "Agendas"
  },
  "mtic_g78_m3_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "mtic_g78_m3_sum": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },

  "mtic_c3_m1_diagnostic": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "mtic_c3_m1": {
    "en": "Problem Solving",
    "fr": "Résolution de problèmes",
    "de": "Sachaufgaben",
    "pt": "Resolução de problemas"
  },
  "mtic_c3_m1v2": {
    "en": "Problem Solving",
    "fr": "Résolution de problèmes",
    "de": "Sachaufgaben",
    "pt": "Resolução de problemas"
  },
  "mtic_c3_m56": {
    "en": "Space, Shape and Measures",
    "fr": "Espace, formes et mesures",
    "de": "Raum, Form und Maße",
    "pt": "Espaço, Formas e Medidas"
  },
  "moduleMaps": {
    "en": "Modules",
    "fr": "Modules",
    "de": "Modules",
    "pt": "Modules"
  },
  "reload": {
    "en": "Refresh",
    "fr": "Recharger",
    "de": "Daten aktualisieren",
    "pt": "Recarregar"
  },
  "login": {
    "en": "Login",
    "fr": "Connexion",
    "de": "Anmelden",
    "pt": "Login"
  },
  "inbook_framePlayer": {
    "en": "Current Position",
    "fr": "Current Position",
    "de": "Aktuelle Position",
    "pt": "Posição Atual"
  },
  "mtic_gr78_m_meta": {
    "en": "ES: Cycle inférieur",
    "fr": "ES: Cycle inférieur",
    "de": "ES: Cycle inférieur",
    "pt": "ES: Cycle inférieur"
  },
  "mtic_gr78_m1": {
    "en": "Proportionality",
    "fr": "Proportionnalité",
    "de": "Proportionalität",
    "pt": "Proporcionalidade"
  },

  "mtic_g78_m0_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste sumativo"
  },
  "mtic_g78_m2_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m3_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m4_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m0_order_op": {
    "en": "Order of Operations",
    "fr": "Ordre des opérations",
    "de": "Reihenfolge beim Rechnen",
    "pt": "Prioridade das operações"
  },
  "mtic_g78_m0_sum_prod": {
    "en": "Expressions - Sums and Products",
    "fr": "Sommes et produits",
    "de": "Vereinf. - Sum/Prod",
    "pt": "Somas e produtos"
  },
  "mtic_g78_m0_alg_prog": {
    "en": "Calculation Programs",
    "fr": "Programme de calcul",
    "de": "Rechenprogramme",
    "pt": "Programa de cálculo"
  },
  "mtic_g78_m0_simp": {
    "en": "S.E. - Written Conventions",
    "fr": "Simp. conventions écrites",
    "de": "Vereinf. - Schreibweise",
    "pt": "Simplificar expressões - Convenções de escrita"
  },
  "mtic_g78_m0_simp_ops": {
    "en": "S.E. - Performing Ops (Part 1)",
    "fr": "Simp. calcul d'opérations (1)",
    "de": "Vereinf. - Rechenregeln (T1)",
    "pt": "Simplificar expressões - Efetuar operações (parte 1)"
  },
  "mtic_g78_m0_simp_exp1": {
    "en": "S.E. - Exponents",
    "fr": "Simp. exposants",
    "de": "Vereinf. - Exponenten",
    "pt": "Simplificar expoentes"
  },
  "mtic_g78_m0_simp_ex0": {
    "en": "Written Conventions - Exercises",
    "fr": "Simp. conventions -  exercices",
    "de": "Terme vereinfachen - Vereinbarungen zur Schreibweise",
    "pt": "Convenções para a simplificação - Exercícios"
  },
  "mtic_g78_m0_simp_ex": {
    "en": "S.E. - Exercises",
    "fr": "Simp. exercices",
    "de": "Vereinf. - Übungen",
    "pt": "Simplificação - Exercícios"
  },
  "mtic_g78_m0_sdpq": {
    "en": "Sum, Difference, Product, Quotient",
    "fr": "Somme, différence, produit, quot.",
    "de": "Summe, Diff, Prod, Quot",
    "pt": "Soma, diferença, produto, quociente"
  },
  "mtic_g78_m0_intro_var": {
    "en": "Intro to Algebraic Expressions",
    "fr": "Intro. calcul littéral",
    "de": "Einf.: algebraische Terme",
    "pt": "Introdução ao cálculo literal"
  },
  "mtic_g78_m0_vocab": {
    "en": "Vocabulary",
    "fr": "Vocabulaire",
    "de": "Vokabular",
    "pt": "Vocabulário"
  },
  "mtic_g78_m0_alg_word_1": {
    "en": "Match Expressions with Words",
    "fr": "Correspondance calculs et mots",
    "de": "Zus.hang: Text - Term",
    "pt": "Correspondência entre cálculos e palavras"
  },
  "mtic_g78_m0_alg_word_2": {
    "en": "Create Expression from Words",
    "fr": "Expression à partir des mots",
    "de": "Term zu Text",
    "pt": "Expressões a partir de palavras"
  },
  "mtic_g78_m0_alg_word_3": {
    "en": "Expression from a Situation",
    "fr": "Expression à partir d'une situation",
    "de": "Term zu Situation",
    "pt": "Expressões a partir de uma situação"
  },
  "mtic_g78_m0_poker_a": {
    "en": "S.E. - Intro to Like Terms",
    "fr": "Intro. termes semblables",
    "de": "Einf.: gleichartige Termgl.",
    "pt": "Termos semelhantes - Introdução"
  },
  "mtic_g78_m0_simp_brac": {
    "en": "S.E. - Removing Brackets",
    "fr": "Simp. élimin. parenthèses",
    "de": "Vereinf. - Klammern",
    "pt": "Simplificar expressões por supressão de parênteses"
  },
  "mtic_g78_m0_simp_order": {
    "en": "Reordering Variables, Coefficients and Terms",
    "fr": "Réorganisation des variables, des coefficients et des termes",
    "de": "Réorganisation des variables, des coefficients et des termes",
    "pt": "Réorganisation des variables, des coefficients et des termes"
  },
  "mtic_g78_m0_simp_add": {
    "en": "S.E. - Like Terms",
    "fr": "Simp. termes semblables",
    "de": "Vereinf. - gleichartige Termgl.",
    "pt": "Simplificar termos semelhantes"
  },
  "mtic_g78_m0_simp_ops2": {
    "en": "S.E. - Performing Ops (Part 2)",
    "fr": "Simp. calcul d'opérations (2)",
    "de": "Vereinf. - Rechenregeln (T2)",
    "pt": "Simplificar expressões - Efetuar operações (parte 2)"
  },
  "mtic_g78_m0_simp_exp2": {
    "en": "S.E. - Like Terms w. Mult Variables",
    "fr": "Simp. termes semblables, var. mult.",
    "de": "Vereinf. - mehrere Variablen",
    "pt": "Simplificar termos semelhantes - Várias variáveis"
  },
  "mtic_g78_m0_substitution": {
    "en": "Substitution",
    "fr": "Substitution",
    "de": "Ersetzen",
    "pt": "Substituição"
  },
  "mtic_g78_m0_poker_b": {
    "en": "Collect Like Terms w. Poker Chips",
    "fr": "Termes semblables - jetons Poker",
    "de": "Terme zus.fassen - Poker",
    "pt": "Termos semelhantes - Fichas de Poker"
  },
  "mtic_g78_m0_poker_adv2": {
    "en": "Expression from Poker Chips",
    "fr": "Expression - jetons Poker",
    "de": "Terme aufstellen - Poker",
    "pt": "Expressões - Fichas de Poker"
  },
  "mtic_g78_m0_geo_b": {
    "en": "Expression from Shapes (Part 1)",
    "fr": "Expression avec des formes (partie 1)",
    "de": "Terme aufstellen - Formen (T1)",
    "pt": "Expressões a partir de formas (parte 1)"
  },
  "mtic_g78_m0_geo_c": {
    "en": "Expression from Shapes (Part 2)",
    "fr": "Expression avec des formes (partie 2)",
    "de": "Terme aufstellen - Formen (T2)",
    "pt": "Expressões a partir de formas (parte 2)"
  },
  "mtic_g78_m0_shoes": {
    "en": "Buying Shoes",
    "fr": "Achat de chaussures",
    "de": "Schuhe kaufen",
    "pt": "Comprando sapatos"
  },
  "mtic_g78_m0_shoes_open": {
    "en": "Make a Video - Buying Shoes",
    "fr": "Vidéo (chaussures)",
    "de": "Video (Schuhe)",
    "pt": "Video (sapatos)"
  },
  "mtic_g78_m0_jewel": {
    "en": "The Necklace Pattern (Part 1)",
    "fr": "Bijoux (partie 1)",
    "de": "Schmuck (T1)",
    "pt": "Bijuteria (parte 1)"
  },
  "mtic_g78_m0_jewel_pt2": {
    "en": "The Necklace Pattern (Part 2)",
    "fr": "Bijoux (partie 2)",
    "de": "Schmuck (T2)",
    "pt": "Bijuteria (parte 2)"
  },
  "mtic_g78_m0_diag": {
    "en": "Diagnostic: Introduction to Algebra",
    "fr": "Test diagnostic: Introduction, Calcul Littéral",
    "de": "Diagnosetest: Einführung in die Algebra",
    "pt": "Álgebra: introdução"
  },

  "mtic_g78_m4_diagnostic": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m4_multiple": {
    "en": "Multiples",
    "fr": "Multiples",
    "de": "Vielfache",
    "pt": "Múltiplos"
  },
  "mtic_g78_m4_divisibility_a_pt1": {
    "en": "Divisibility (2, 5, 10 and 4)",
    "fr": "Divisibilité (2, 5, 10 et 4)",
    "de": "Teilbarkeit (2, 5, 10, 4)",
    "pt": "Divisibilidade por 2, 5, 10 e 4"
  },
  "mtic_g78_m4_divisibility_a_pt2": {
    "en": "Divisibility (3, 6 and 9)",
    "fr": "Divisibilité (3, 6 et 9)",
    "de": "Teilbarkeit (3, 6, 9)",
    "pt": "Divisibilidade por 3, 6 e 9"
  },
  "mtic_g78_m4_divisors": {
    "en": "Divisors",
    "fr": "Diviseurs",
    "de": "Teiler",
    "pt": "Divisores"
  },
  "mtic_g78_m4_intro_frac": {
    "en": "Intro to Fractions",
    "fr": "Introduction aux fractions",
    "de": "Einführung in Brüche",
    "pt": "Introdução às frações"
  },
  "mtic_g78_m4_num_line_a": {
    "en": "Fractions on the Number Line",
    "fr": "Fractions et demi-droite graduée",
    "de": "Brüche am Zahlenstrahl",
    "pt": "Frações na reta numérica"
  },
  "mtic_g78_m4_equiv_a": {
    "en": "Equivalent Fractions",
    "fr": "Fractions équivalentes",
    "de": "Äquivalente Brüche",
    "pt": "Frações equivalentes"
  },
  "mtic_g78_m4_simp": {
    "en": "Simplification",
    "fr": "Simplifier des fractions",
    "de": "Brüche kürzen",
    "pt": "Simplificação de frações"
  },
  "mtic_g78_m4_comp_a": {
    "en": "Comparing Fractions",
    "fr": "Comparer des fractions",
    "de": "Brüche vergleichen",
    "pt": "Comparação de frações"
  },
  "mtic_g78_m4_add_same": {
    "en": "Adding Fractions (Same Denom.)",
    "fr": "Addition de fract. (même dén.)",
    "de": "Addition (gleicher Nenner)",
    "pt": "Adição de frações (mesmo denominador)"
  },
  "mtic_g78_m4_add_diff": {
    "en": "Adding Fractions (Diff. Denom.)",
    "fr": "Addition de fract. (dén. diff.)",
    "de": "Addition (versch. Nenner)",
    "pt": "Adição de frações (diferente denominador)"
  },
  "mtic_g78_m4_sub_a": {
    "en": "Subtracting Fractions",
    "fr": "Soustraction de fractions",
    "de": "Brüche subtrahieren",
    "pt": "Subtração de frações"
  },
  "mtic_g78_m4_mult_a_pt1": {
    "en": "Multiplying Fractions - Intro",
    "fr": "Mult. de fractions: intro",
    "de": "Brüche mult. - Einf.",
    "pt": "Multiplicação de frações (Introdução)"
  },
  "mtic_g78_m4_mult_a_pt2": {
    "en": "Multiplying Fractions - Spec. Cases",
    "fr": "Mult. de fractions: cas spéciaux",
    "de": "Brüche mult. - Spezialfälle",
    "pt": "Multiplicação de frações (Casos especiais)"
  },
  "mtic_g78_m4_mult_a_pt3": {
    "en": "Multiplying 3 Fractions",
    "fr": "Multiplication de 3 fractions",
    "de": "Multipl. dreier Brüche",
    "pt": "Multiplicar 3 frações"
  },
  "mtic_g78_m4_div_pt1_a": {
    "en": "Dividing Fractions",
    "fr": "Division de fractions",
    "de": "Brüche dividieren",
    "pt": "Divisão de frações"
  },
  "mtic_g78_m4_div_pt2_a": {
    "en": "Fractions Within Fractions",
    "fr": "Quotient de 2 fractions",
    "de": "Doppelbrüche",
    "pt": "Quociente de 2 frações"
  },
  "mtic_g78_m4_bedmas_a": {
    "en": "Order of Operations in Fractions",
    "fr": "Fractions et ordre des opérations",
    "de": "Reihenfolge beim Rechnen",
    "pt": "Ordem de operações com frações"
  },
  "mtic_g78_m4_conv_dec": {
    "en": "Converting Decimals to Fractions",
    "fr": "Passer de l'écr. déc. en fractionnaire",
    "de": "Umwandeln: Dez. in Brüche",
    "pt": "Converter decimais em frações"
  },
  "mtic_g78_m4_conv_frac": {
    "en": "Converting Fractions to Decimals",
    "fr": "Passer de l'écr. fract. en décimale ",
    "de": "Umwandeln: Brüche in Dez.",
    "pt": "Converter frações em decimais"
  },
  "mtic_g78_m4_multi_tutorial": {
    "en": "Fraction Multi-tool",
    "fr": 'Tutoriel de l\'outil "multi-tâches"',
    "de": "Tutorial \"Brüche-Multi-Tool\"",
    "pt": "Tutorial «multi-funções» usando frações"
  },
  "mtic_g78_m4_divisibility_b": {
    "en": "Apply Divisibility",
    "fr": "Utiliser la divisibilité ",
    "de": "Teilbarkeit ausnutzen",
    "pt": "Utilizar a divisibilidade "
  },
  "mtic_g78_m4_num_line_b": {
    "en": "Fractions on the Number Line Exercises",
    "fr": "Fractions et demi-droite: exercices",
    "de": "Zahlenstrahl: Übungen",
    "pt": "Frações na reta numérica: exercícios"
  },
  "mtic_g78_m4_equiv_b": {
    "en": "Equivalent Fractions Exercises",
    "fr": "Fractions équivalentes: exercices",
    "de": "Äquivalente Brüche: Übg.",
    "pt": "Frações equivalentes: exercícios"
  },
  "mtic_g78_m4_comp_b": {
    "en": "Comparing Fractions Exercises",
    "fr": "Comparer des fractions: exercices",
    "de": "Brüche vergleichen: Übg.",
    "pt": "Comparar frações: exercícios"
  },
  "mtic_g78_m4_mahjong": {
    "en": "Math Mahjong",
    "fr": "Math Mahjong",
    "de": "Mathe Mahjong",
    "pt": "Math Mahjong"
  },
  "mtic_g78_m4_order": {
    "en": "Ordering Fractions",
    "fr": "Ordonner des fractions",
    "de": "Brüche ordnen",
    "pt": "Ordenar frações"
  },
  "mtic_g78_m4_add_b": {
    "en": "Adding Fractions Exercises",
    "fr": "Addition de fractions: exercices",
    "de": "Brüche addieren: Übg.",
    "pt": "Adicionar frações: exercícios"
  },
  "mtic_g78_m4_sub_b": {
    "en": "Subtracting Fractions Exercises",
    "fr": "Soustraction de fractions: exercices",
    "de": "Brüche subtrahieren: Übg.",
    "pt": "Subtrair frações: exercícios"
  },
  "mtic_g78_m4_determine_figure": {
    "en": "Determine the Fraction",
    "fr": "Déterminer une fraction",
    "de": "Brüche bestimmen",
    "pt": "Determinar uma fração"
  },
  "mtic_g78_m4_reproduire_partie_1": {
    "en": "Represent Fractions - Part 1 ",
    "fr": "Représenter des fractions - partie 1",
    "de": "Brüche darstellen (T1)",
    "pt": "Representar frações - Parte 1"
  },
  "mtic_g78_m4_reproduire_partie_2": {
    "en": "Represent Fractions - Part 2 ",
    "fr": "Représenter des fractions - partie 2",
    "de": "Brüche darstellen (T2)",
    "pt": "Representar frações - Parte 2"
  },
  "mtic_g78_m4_mult_b_pt1": {
    "en": "Multiply Fractions Exercises",
    "fr": "Mult. de fractions: ex.",
    "de": "Brüche mult.: Übg.",
    "pt": "Multiplicar frações: exercícios"
  },
  "mtic_g78_m4_mult_b_pt2": {
    "en": "Multiplying Multiple Fractions Exercises",
    "fr": "Mult. de plusieurs fractions: ex.",
    "de": "Mult. mehrere Brüche: Übg.",
    "pt": "Multiplicar várias frações: exercícios"
  },
  "mtic_g78_m4_div_b": {
    "en": "Divide Fractions Exercises",
    "fr": "Division de fractions: exercices",
    "de": "Brüche dividieren: Übg.",
    "pt": "Dividir frações: exercícios"
  },
  "mtic_g78_m4_bedmas_b": {
    "en": "Order of Ops. in Fractions Exercises",
    "fr": "Fractions et ordre des op. : ex.",
    "de": "Reihenfolge: Übg.",
    "pt": "Ordem das operações com frações: exercícios"
  },
  "mtic_g78_m4_conv_b": {
    "en": "Odd One Out",
    "fr": "Chercher l'intrus",
    "de": "Was passt nicht dazu?",
    "pt": "À procura do número intruso"
  },
  "mtic_g78_m4_carrot": {
    "en": "Hop & Crunch",
    "fr": "Course à la carotte",
    "de": "Möhrenjagd",
    "pt": "Hop & Crunch: fatorização e decomposição"
  },
  "mtic_g78_m4_verify_figure": {
    "en": "Fraction Puzzle",
    "fr": "Puzzle fraction",
    "de": "Bruch-Puzzle",
    "pt": "Frações: puzzle"
  },
  "mtic_g78_m4_dominos": {
    "en": "Fraction Dominos",
    "fr": "Dominos avec fractions",
    "de": "Bruch-Domino",
    "pt": "Frações: dominó"
  },
  "mtic_g78_m4_triominos_pt1": {
    "en": "Fraction Triominos",
    "fr": "Triominos avec fractions",
    "de": "Bruch-Triomino",
    "pt": "Frações: triominós"
  },
  "mtic_g78_m4_triominos_pt2": {
    "en": "Fraction Triominos Challenge",
    "fr": "Défi de triominos avec fractions",
    "de": "Bruch-Triomino Challenge",
    "pt": "Frações: triominós - desafio"
  },
  "mtic_g78_m4_slushie_pt1": {
    "en": "Chill Drink - Starter Recipes",
    "fr": "Granita - recettes pour débutants",
    "de": "Slushi-Meister - Anfänger-Rezepte",
    "pt": "Granizado: receita para iniciados"
  },
  "mtic_g78_m4_slushie_pt2": {
    "en": "Chill Drink Master - Peak Flavour",
    "fr": "Granita - recettes pour experts",
    "de": "Slushi-Meister - Meister-Rezepte",
    "pt": "Granizado: receita para peritos"
  },
  "mtic_g78_m4_attack_puz": {
    "en": "Fraction Attack",
    "fr": "Chasse aux fractions",
    "de": "Brüche-Jagd",
    "pt": "Caça às frações"
  },
  "mtic_g78_m4_attack_time": {
    "en": "Fraction Attack - Time Trial",
    "fr": "Chasse aux fractions - contre-la-montre",
    "de": "Brüche-Jagd - Gegen die Uhr",
    "pt": "Caça às frações: versão com tempo"
  },
  "gr78_m5_group__vis_int": {
    "en": "Visualizing Integers",
    "fr": "Visualiser des nombres entiers",
    "de": "Ganze Zahlen darstellen",
    "pt": "Visualizar números inteiros"
  },
  "gr78_m5_group__add_sub_int": {
    "en": "Adding and Subtracting Integers",
    "fr": "Additionner et soustraire des nombres entiers",
    "de": "Addition und Subtraktion ganzer Zahlen",
    "pt": "Adicionar e subtrair números inteiros"
  },
  "gr78_m5_group__mult_div_int": {
    "en": "Multiplying and Dividing Integers",
    "fr": "Multiplier et diviser des nombres entiers",
    "de": "Multiplikation und Division ganzer Zahlen",
    "pt": "Multiplicar e dividir números inteiros"
  },
  "gr78_m5_group__mixed_op_int": {
    "en": "Mixed Operations with Integers",
    "fr": "Opérations mixtes avec des nombres entiers",
    "de": "Vermischte Rechenarten bei ganzen Zahlen",
    "pt": "Operações mistas com números inteiros"
  },
  "gr78_m5_group__num_puz": {
    "en": "Number Puzzles",
    "fr": "Nombre de puzzles",
    "de": "Zahlenpuzzle",
    "pt": "Puzzles de números"
  },

  "ocmt_hse_meta": {
    "en": "OCMT-HSE",
    "fr": "OCMT-HSE",
    "de": "OCMT-HSE",
    "pt": "OCMT-HSE"
  },
  "ocmt_hse_m1": {
    "en": "Whole Numbers",
    "fr": "Whole Numbers",
    "de": "Whole Numbers",
    "pt": "Whole Numbers"
  },
  "ocmt_hse_m1_diag": {
    "en": "Whole Numbers Diagnostic",
    "fr": "Whole Numbers Diagnostic",
    "de": "Whole Numbers Diagnostic",
    "pt": "Whole Numbers Diagnostic"
  },
  "ocmt_hse_m1_l1": {
    "en": "Place Value",
    "fr": "Place Value",
    "de": "Place Value",
    "pt": "Place Value"
  },
  "ocmt_hse_m1_l2": {
    "en": "Reading and Writing Numbers",
    "fr": "Reading and Writing Numbers",
    "de": "Reading and Writing Numbers",
    "pt": "Reading and Writing Numbers"
  },
  "ocmt_hse_m1_l3": {
    "en": "Rounding",
    "fr": "Rounding",
    "de": "Rounding",
    "pt": "Rounding"
  },
  "ocmt_hse_m1_summ": {
    "en": "Whole Numbers Summative",
    "fr": "Whole Numbers Summative",
    "de": "Whole Numbers Summative",
    "pt": "Whole Numbers Summative"
  },

  "ocmt_hse_m2": {
    "en": "Number Sense",
    "fr": "Number Sense",
    "de": "Number Sense",
    "pt": "Number Sense"
  },
  "ocmt_hse_m2_diag": {
    "en": "Number Sense Diagnostic",
    "fr": "Number Sense Diagnostic",
    "de": "Number Sense Diagnostic",
    "pt": "Number Sense Diagnostic"
  },
  "ocmt_hse_m2_l1": {
    "en": "Addition",
    "fr": "Addition",
    "de": "Addition",
    "pt": "Addition"
  },
  "ocmt_hse_m2_l2": {
    "en": "Subtraction",
    "fr": "Subtraction",
    "de": "Subtraction",
    "pt": "Subtraction"
  },
  "ocmt_hse_m2_l3": {
    "en": "Multiplication",
    "fr": "Multiplication",
    "de": "Multiplication",
    "pt": "Multiplication"
  },
  "ocmt_hse_m2_l4": {
    "en": "Division",
    "fr": "Division",
    "de": "Division",
    "pt": "Division"
  },
  "ocmt_hse_m2_l5": {
    "en": "Order of Operations",
    "fr": "Order of Operations",
    "de": "Order of Operations",
    "pt": "Order of Operations"
  },
  "ocmt_hse_m2_l6": {
    "en": "Exponential Notation",
    "fr": "Exponential Notation",
    "de": "Exponential Notation",
    "pt": "Exponential Notation"
  },
  "ocmt_hse_m2_l7": {
    "en": "Factors and Multiples",
    "fr": "Factors and Multiples",
    "de": "Factors and Multiples",
    "pt": "Factors and Multiples"
  },
  "ocmt_hse_m2_l8": {
    "en": "Lowest Common Multiple",
    "fr": "Lowest Common Multiple",
    "de": "Lowest Common Multiple",
    "pt": "Lowest Common Multiple"
  },
  "ocmt_hse_m2_summ": {
    "en": "Number Sense Summative",
    "fr": "Number Sense Summative",
    "de": "Number Sense Summative",
    "pt": "Number Sense Summative"
  },

  "ocmt_hse_m3": {
    "en": "Integers",
    "fr": "Integers",
    "de": "Integers",
    "pt": "Integers"
  },
  "ocmt_hse_m3_diag": {
    "en": "Integers Diagnostic",
    "fr": "Integers Diagnostic",
    "de": "Integers Diagnostic",
    "pt": "Integers Diagnostic"
  },
  "ocmt_hse_m3_l1": {
    "en": "Integer Addition and Subtraction",
    "fr": "Integer Addition and Subtraction",
    "de": "Integer Addition and Subtraction",
    "pt": "Integer Addition and Subtraction"
  },
  "ocmt_hse_m3_l2": {
    "en": "Multiplication and Division",
    "fr": "Multiplication and Division",
    "de": "Multiplication and Division",
    "pt": "Multiplication and Division"
  },
  "ocmt_hse_m3_l3": {
    "en": "Exponent Rules",
    "fr": "Exponent Rules",
    "de": "Exponent Rules",
    "pt": "Exponent Rules"
  },
  "ocmt_hse_m3_summ": {
    "en": "Integers Summative",
    "fr": "Integers Summative",
    "de": "Integers Summative",
    "pt": "Integers Summative"
  },

  "ocmt_hse_m4": {
    "en": "Decimals",
    "fr": "Decimals",
    "de": "Decimals",
    "pt": "Decimals"
  },
  "ocmt_hse_m4_diag": {
    "en": "Decimals Diagnostic",
    "fr": "Decimals Diagnostic",
    "de": "Decimals Diagnostic",
    "pt": "Decimals Diagnostic"
  },
  "ocmt_hse_m4_l1": {
    "en": "Place value",
    "fr": "Place value",
    "de": "Place value",
    "pt": "Place value"
  },
  "ocmt_hse_m4_l2": {
    "en": "Reading and Writing Decimal Numbers",
    "fr": "Reading and Writing Decimal Numbers",
    "de": "Reading and Writing Decimal Numbers",
    "pt": "Reading and Writing Decimal Numbers"
  },
  "ocmt_hse_m4_l3": {
    "en": "Rounding",
    "fr": "Rounding",
    "de": "Rounding",
    "pt": "Rounding"
  },
  "ocmt_hse_m4_l4": {
    "en": "Decimal Additon",
    "fr": "Decimal Additon",
    "de": "Decimal Additon",
    "pt": "Decimal Additon"
  },
  "ocmt_hse_m4_l5": {
    "en": "Decimal Subtraction",
    "fr": "Decimal Subtraction",
    "de": "Decimal Subtraction",
    "pt": "Decimal Subtraction"
  },
  "ocmt_hse_m4_l6": {
    "en": "Decimal Multiplication",
    "fr": "Decimal Multiplication",
    "de": "Decimal Multiplication",
    "pt": "Decimal Multiplication"
  },
  "ocmt_hse_m4_l7": {
    "en": "Decimal Division",
    "fr": "Decimal Division",
    "de": "Decimal Division",
    "pt": "Decimal Division"
  },
  "ocmt_hse_m4_summ": {
    "en": "Decimals Summative",
    "fr": "Decimals Summative",
    "de": "Decimals Summative",
    "pt": "Decimals Summative"
  },

  "ocmt_hse_m5": {
    "en": "Fractions",
    "fr": "Fractions",
    "de": "Fractions",
    "pt": "Fractions"
  },
  "ocmt_hse_m5_diag": {
    "en": "Fractions Diagnostic",
    "fr": "Fractions Diagnostic",
    "de": "Fractions Diagnostic",
    "pt": "Fractions Diagnostic"
  },
  "ocmt_hse_m5_l1": {
    "en": "Type of Fractions and Conversions",
    "fr": "Type of Fractions and Conversions",
    "de": "Type of Fractions and Conversions",
    "pt": "Type of Fractions and Conversions"
  },
  "ocmt_hse_m5_l2": {
    "en": "Equivalent Fractions and Simplifying Fractions",
    "fr": "Equivalent Fractions and Simplifying Fractions",
    "de": "Equivalent Fractions and Simplifying Fractions",
    "pt": "Equivalent Fractions and Simplifying Fractions"
  },
  "ocmt_hse_m5_l3": {
    "en": "Addition and Subtraction",
    "fr": "Addition and Subtraction",
    "de": "Addition and Subtraction",
    "pt": "Addition and Subtraction"
  },
  "ocmt_hse_m5_l4": {
    "en": "Multiplication and Division",
    "fr": "Multiplication and Division",
    "de": "Multiplication and Division",
    "pt": "Multiplication and Division"
  },
  "ocmt_hse_m5_l5": {
    "en": "Order of Operations",
    "fr": "Order of Operations",
    "de": "Order of Operations",
    "pt": "Order of Operations"
  },
  "ocmt_hse_m5_summ": {
    "en": "Fractions Summative",
    "fr": "Fractions Summative",
    "de": "Fractions Summative",
    "pt": "Fractions Summative"
  },

  "ocmt_hse_m6": {
    "en": "Ratios & Proportions",
    "fr": "Ratios & Proportions",
    "de": "Ratios & Proportions",
    "pt": "Ratios & Proportions"
  },
  "ocmt_hse_m6_diag": {
    "en": "Ratios & Proportions Diagnostic",
    "fr": "Ratios & Proportions Diagnostic",
    "de": "Ratios & Proportions Diagnostic",
    "pt": "Ratios & Proportions Diagnostic"
  },
  "ocmt_hse_m6_l1": {
    "en": "Creating Ratios",
    "fr": "Creating Ratios",
    "de": "Creating Ratios",
    "pt": "Creating Ratios"
  },
  "ocmt_hse_m6_l2": {
    "en": "Ratios in Simplest Form",
    "fr": "Ratios in Simplest Form",
    "de": "Ratios in Simplest Form",
    "pt": "Ratios in Simplest Form"
  },
  "ocmt_hse_m6_l3": {
    "en": "Calculations Involving Ratios",
    "fr": "Calculations Involving Ratios",
    "de": "Calculations Involving Ratios",
    "pt": "Calculations Involving Ratios"
  },
  "ocmt_hse_m6_l4": {
    "en": "Proportion",
    "fr": "Proportion",
    "de": "Proportion",
    "pt": "Proportion"
  },
  "ocmt_hse_m6_summ": {
    "en": "Ratios & Proportions Summative",
    "fr": "Ratios & Proportions Summative",
    "de": "Ratios & Proportions Summative",
    "pt": "Ratios & Proportions Summative"
  },

  "ocmt_hse_m7": {
    "en": "Percents",
    "fr": "Percents",
    "de": "Percents",
    "pt": "Percents"
  },
  "ocmt_hse_m7_diag": {
    "en": "Percents Diagnostic",
    "fr": "Percents Diagnostic",
    "de": "Percents Diagnostic",
    "pt": "Percents Diagnostic"
  },
  "ocmt_hse_m7_l1": {
    "en": "Percent Calculations",
    "fr": "Percent Calculations",
    "de": "Percent Calculations",
    "pt": "Percent Calculations"
  },
  "ocmt_hse_m7_l2": {
    "en": "Converting Between Percent, Fraction and Decimal",
    "fr": "Converting Between Percent, Fraction and Decimal",
    "de": "Converting Between Percent, Fraction and Decimal",
    "pt": "Converting Between Percent, Fraction and Decimal"
  },
  "ocmt_hse_m7_l3": {
    "en": "Calculate Percent Change",
    "fr": "Calculate Percent Change",
    "de": "Calculate Percent Change",
    "pt": "Calculate Percent Change"
  },
  "ocmt_hse_m7_summ": {
    "en": "Percents Summative",
    "fr": "Percents Summative",
    "de": "Percents Summative",
    "pt": "Percents Summative"
  },

  "ocmt_hse_m8": {
    "en": "Algebra",
    "fr": "Algebra",
    "de": "Algebra",
    "pt": "Algebra"
  },
  "ocmt_hse_m8_diag": {
    "en": "Algebra Diagnostic",
    "fr": "Algebra Diagnostic",
    "de": "Algebra Diagnostic",
    "pt": "Algebra Diagnostic"
  },
  "ocmt_hse_m8_l1": {
    "en": "Variable Expression (Algebraic Expressions)",
    "fr": "Variable Expression (Algebraic Expressions)",
    "de": "Variable Expression (Algebraic Expressions)",
    "pt": "Variable Expression (Algebraic Expressions)"
  },
  "ocmt_hse_m8_l2": {
    "en": "Solving Equations",
    "fr": "Solving Equations",
    "de": "Solving Equations",
    "pt": "Solving Equations"
  },
  "ocmt_hse_m8_l3": {
    "en": "Word Problems",
    "fr": "Word Problems",
    "de": "Word Problems",
    "pt": "Word Problems"
  },
  "ocmt_hse_m8_summ": {
    "en": "Algebra Summative",
    "fr": "Algebra Summative",
    "de": "Algebra Summative",
    "pt": "Algebra Summative"
  },

  "ocmt_hse_m9": {
    "en": "Conversions",
    "fr": "Conversions",
    "de": "Conversions",
    "pt": "Conversions"
  },
  "ocmt_hse_m9_diag": {
    "en": "Measurement & Unit Conversion Diagnostic",
    "fr": "Measurement & Unit Conversion Diagnostic",
    "de": "Measurement & Unit Conversion Diagnostic",
    "pt": "Measurement & Unit Conversion Diagnostic"
  },
  "ocmt_hse_m9_l1": {
    "en": "Metric System of Measurement",
    "fr": "Metric System of Measurement",
    "de": "Metric System of Measurement",
    "pt": "Metric System of Measurement"
  },
  "ocmt_hse_m9_l2": {
    "en": "Metric-Imperial Conversion",
    "fr": "Metric-Imperial Conversion",
    "de": "Metric-Imperial Conversion",
    "pt": "Metric-Imperial Conversion"
  },
  "ocmt_hse_m9_summ": {
    "en": "Measurement & Unit Conversion Summative",
    "fr": "Measurement & Unit Conversion Summative",
    "de": "Measurement & Unit Conversion Summative",
    "pt": "Measurement & Unit Conversion Summative"
  },

  "c4_m1_1_cambridge": {
    "en": "Area of Rectangles and Squares",
    "fr": "Area of Rectangles and Squares",
    "de": "Area of Rectangles and Squares",
    "pt": "Area of Rectangles and Squares"
  },
  "c4_m1_2_cambridge": {
    "en": "Perimeter of Rectangles and Squares",
    "fr": "Perimeter of Rectangles and Squares",
    "de": "Perimeter of Rectangles and Squares",
    "pt": "Perimeter of Rectangles and Squares"
  },
  "c4_m1_3_cambridge": {
    "en": "Perimeter of Compound Shapes",
    "fr": "Perimeter of Compound Shapes",
    "de": "Perimeter of Compound Shapes",
    "pt": "Perimeter of Compound Shapes"
  },
  "c4_m1_4_cambridge": {
    "en": "Area of Compound Shapes",
    "fr": "Area of Compound Shapes",
    "de": "Area of Compound Shapes",
    "pt": "Area of Compound Shapes"
  },
  "c4_m1_5_cambridge": {
    "en": "Area of Irregular Shapes",
    "fr": "Area of Irregular Shapes",
    "de": "Area of Irregular Shapes",
    "pt": "Area of Irregular Shapes"
  },

  "mtic_g78_m5_intro_neg": {
    "en": "Intro to Integers",
    "fr": "Intro. nombres relatifs",
    "de": "Einf.: ganze Zahlen",
    "pt": "Introdução aos números relativos"
  },
  "mtic_g78_m5_num_line": {
    "en": "Integers on the Number Line",
    "fr": "Relatifs et droite graduée",
    "de": "Ganze Z.: Zahlenstrahl",
    "pt": "Números relativos numa régua graduada"
  },
  "mtic_g78_m5_comp_a": {
    "en": "Comparing Integers",
    "fr": "Comparer des relatifs",
    "de": "Ganze Z.: Vergleich",
    "pt": "Comparar números relativos"
  },
  "mtic_g78_m5_dice_add": {
    "en": "Addition Dice Game",
    "fr": "Addition - Jeu de dés",
    "de": "Addition - Spiel",
    "pt": "Adição - jogo de dados"
  },
  "mtic_g78_m5_rules_add": {
    "en": "Adding Integers",
    "fr": "Relatifs: addition",
    "de": "Ganze Z.: Addition",
    "pt": "Números relativos - adição"
  },
  "mtic_g78_m5_dice_sub": {
    "en": "Subtraction Dice Game",
    "fr": "Soustraction - Jeu de dés",
    "de": "Subtraktion - Spiel",
    "pt": "Subtração - jogo de dados "
  },
  "mtic_g78_m5_rules_sub": {
    "en": "Subtracting Integers",
    "fr": "Relatifs: soustraction",
    "de": "Ganze Z.: Subtraktion",
    "pt": "Números relativos - subtração"
  },
  "mtic_g78_m5_simp_form": {
    "en": "Simplified Form",
    "fr": "Ecriture simplifiée",
    "de": "Vereinf. Schreibweise",
    "pt": "Simplificar operações com números relativos"
  },
  "mtic_g78_m5_add_line": {
    "en": "Add and Subtract on Number Line",
    "fr": "Add. et soust. droite graduée",
    "de": "Add/Subtr - Zahlenstrahl",
    "pt": "Adicionar e subtrair números relativos na régua graduada"
  },
  "mtic_g78_m5_mult_div_pt1": {
    "en": "Multiply and Divide Integers - Pt 1",
    "fr": "Produit et quotient avec rel. 1",
    "de": "Ganze Z.: Prod/Quot T1",
    "pt": "Multiplicar e dividir números relativos - Parte 1"
  },
  "mtic_g78_m5_mult_div_pt2": {
    "en": "Multiply and Divide Integers - Pt 2",
    "fr": "Produit et quotient avec rel. 2",
    "de": "Ganze Z.: Prod/Quot T2",
    "pt": "Multiplicar e dividir números relativos - Parte 2"
  },
  "mtic_g78_m5_mult_div_pt3": {
    "en": "Multiply and Divide Integers - Pt 3",
    "fr": "Produit et quotient avec rel. 3",
    "de": "Ganze Z.: Prod/Quot T3",
    "pt": "Multiplicar e dividir números relativos - Parte 3"
  },
  "mtic_g78_m5_order": {
    "en": "Comparing Integers Exercises",
    "fr": "Comparer des relatifs: exercices",
    "de": "Ganze Z.: Vergleich Üb",
    "pt": "Comparação de números relativos - exercícios "
  },
  "mtic_g78_m5_add_sub_b": {
    "en": "Add and Subtract Exercises",
    "fr": "Add. et soustr.: exercices",
    "de": "Ganze Z.: Add/Subt Üb",
    "pt": "Adição subtração de números relativos - exercícios"
  },
  "mtic_g78_m5_ball_puz": {
    "en": "Total Orbs - Puzzle",
    "fr": "Attaque aux relatifs",
    "de": "Jagd auf ganze Z.",
    "pt": "Jogar com números relativos - Puzzle"
  },
  "mtic_g78_m5_ball_time": {
    "en": "Total Orbs - Time Trial",
    "fr": "Attaque - contre-la-montre",
    "de": "Jagd auf ganze Z. - Zeit",
    "pt": "Jogar com números relativos - Contra-relógio"
  },
  "mtic_g78_m5_mult_div_b": {
    "en": "Multiply and Divide Exercises",
    "fr": "Produit et quotient: exercices",
    "de": "Ganze Z.: Prod/Quot Üb",
    "pt": "Multiplicar e dividir números relativos - exercícios"
  },
  "mtic_g78_m5_word_puz": {
    "en": "Number Search",
    "fr": "A la recherche des nombres",
    "de": "Zahlensuche",
    "pt": "Procurar os números certos"
  },
  "mtic_g78_m5_num_series": {
    "en": "Open the Lock",
    "fr": "Ouvrir la serrure",
    "de": "Knack das Schloss",
    "pt": "Abrir o cadeado"
  },
  "mtic_g78_m5_place_ops": {
    "en": "4 Times 5 Makes 9?",
    "fr": "4 fois 5 donne 9?",
    "de": "4 mal 5 macht 9?",
    "pt": "4 vezes 5 igual a 9 ?"
  },
  "mtic_g78_m5_calc_casse": {
    "en": "Broken Calculator",
    "fr": "Calculatrice cassée",
    "de": "Defekter Taschenrechner",
    "pt": "Usar a calculadora avariada"
  },
  "mtic_g78_m5_create_result": {
    "en": "Build the Expression",
    "fr": "Trouver la bonne expression",
    "de": "Finde den Term",
    "pt": "Encontrar a expressão certa"
  },
  "mtic_g78_m5_diagnostic": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m5_summative": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  // M6 Item Names
  "mtic_g78_m6_t1": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m6_t2": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m6_a11": {
    "en": "Intro to Percentages",
    "fr": "Intro Pourcentages",
    "de": "Einführung in die Prozentrechnung",
    "pt": "Introdução às percentagens"
  },
  "mtic_g78_m6_a12": {
    "en": "Fractions and Percentages",
    "fr": "Fractions et Pourcentages",
    "de": "Brüche und Prozentangaben",
    "pt": "Frações e percentagens"
  },
  "mtic_g78_m6_a13": {
    "en": "Percentage of a Quantity",
    "fr": "Pourcentage d'une Quantité",
    "de": "Prozentangeaben von Mengen",
    "pt": "Percentagem de uma quantidade"
  },
  "mtic_g78_m6_a14": {
    "en": "Comparisons with Percentages",
    "fr": "Comparaisons et Pourcentages",
    "de": "Vergleich von Prozentangaben",
    "pt": "Comparações com percentagens"
  },
  "mtic_g78_m6_a16": {
    "en": "Calc Methods with Percentages",
    "fr": "Méthodes de Calcul",
    "de": "Methode zur Berechnung von Prozentangaben",
    "pt": "Métodos de cálculo de percentagens"
  },
  "mtic_g78_m6_a17": {
    "en": "Converting to Percentages",
    "fr": "Conversion en Pourcentages",
    "de": "Umwandeln in Prozentangaben",
    "pt": "Conversões em percentagens"
  },
  "mtic_g78_m6_a21": {
    "en": "Bar Graphs",
    "fr": "Diagrammes en Barres",
    "de": "Balkendiagramme",
    "pt": "Gráficos de barras"
  },
  "mtic_g78_m6_a22": {
    "en": "Pie Charts",
    "fr": "Diagrammes Circulaires",
    "de": "Kreisdiagramme",
    "pt": "Gráficos circulares"
  },
  "mtic_g78_m6_a23": {
    "en": "Line Graphs",
    "fr": "Diagrammes Linéaires",
    "de": "Liniendiagramme",
    "pt": "Gráficos lineares"
  },
  "mtic_g78_m6_a31": {
    "en": "Intro Statistics Vocab",
    "fr": "Vocabulaire Statistique",
    "de": "Begriffe in der Statistik",
    "pt": "Introdução ao vocabulário estatístico"
  },
  "mtic_g78_m6_a32": {
    "en": "Exploring Frequencies",
    "fr": "Effectifs et Fréquences",
    "de": "Absolute und relative Häufigkeit",
    "pt": "Explorar frequências"
  },
  "mtic_g78_m6_a331": {
    "en": "Investigating Average",
    "fr": "Introduction à la Moyenne",
    "de": "Einführung in den Durchschnitt",
    "pt": "Introdução à média"
  },
  "mtic_g78_m6_a332": {
    "en": "Comparison of Average and Median",
    "fr": "Comparaison Moyenne et Médiane",
    "de": "Vergleich Durchschnitt und Median",
    "pt": "Comparar média e mediana"
  },
  "mtic_g78_m6_b11": {
    "en": "Dojo - Percent and Visualization",
    "fr": "Pourcentages et Visualisation",
    "de": "Prozentangeben und graphische Darstellung",
    "pt": "Dojo - Percentagens: representação gráfica"
  },
  "mtic_g78_m6_b12": {
    "en": "Calculating Percentages",
    "fr": "Calcul de Pourcentages",
    "de": "Prozentangaben berechnen",
    "pt": "Calcular percentagens"
  },
  "mtic_g78_m6_a131": {
    "en": "Tug of War Tutorial",
    "fr": "Tir à la corde - Tutoriel",
    "de": "Tauziehen - Tutorial",
    "pt": "Jogo da corda: tutorial"
  },
  "mtic_g78_m6_b132": {
    "en": "Tug of War",
    "fr": "Tir à la corde - Calcul mental",
    "de": "Tauziehen - Kopfrechnen",
    "pt": "Jogo da corda: cálculo mental"
  },
  "mtic_g78_m6_b14": {
    "en": "Footrace - Percent Change",
    "fr": "Course - Hausse/Baisse en  %",
    "de": "Rennen - prozentuale Zu- und Abnahme",
    "pt": "Corrida pedestre: variação de percentagens"
  },
  "mtic_g78_m6_b15": {
    "en": "Shopping Mall - Percent Change",
    "fr": "Shopping - Hausse/Baisse en  %",
    "de": "Shopping - prozentuale Zu- und Abnahme",
    "pt": "Centro comercial: variação de percentagens"
  },
  "mtic_g78_m6_b21": {
    "en": "Creating Bar Graphs",
    "fr": "Construction Diagrammes Barres",
    "de": "Erstellen von Balkendiagrammen",
    "pt": "Construção de gráficos de barras"
  },
  "mtic_g78_m6_b31": {
    "en": "Calculating Frequencies",
    "fr": "Calculs d'Effectifs et Fréquences",
    "de": "Berechnung von absoluter und relativer Häufigkeit",
    "pt": "Calcular frequências"
  },
  "mtic_g78_m6_b32": {
    "en": "Average and Median",
    "fr": "Calculs avec Moyenne et Médiane",
    "de": "Rechnen mit Durchschnitt und Median",
    "pt": "Calcular média e mediana"
  },
  "mtic_g78_m6_b33": {
    "en": "Statistics Puzzles",
    "fr": "Puzzles Statistiques",
    "de": "Statistik - Puzzles",
    "pt": "Puzzles estatísticos"
  },
  "mtic_g78_m6_c12": {
    "en": "Sweet Drinks and Percentages",
    "fr": "Boissons sucrées et Pourcentages",
    "de": "Softdrinks und Prozentangaben",
    "pt": "Refrigerantes e percentagens"
  },
  "mtic_g78_m6_c13": {
    "en": "Nutrition and Percentages",
    "fr": "Nutrition et Pourcentages",
    "de": "Nährwert und Prozentangaben",
    "pt": "Nutrição e percentagens"
  },
  "mtic_g78_m6_c211": {
    "en": "Bucket of Balls",
    "fr": "Seau de balles",
    "de": "Bälleeimer",
    "pt": "Balde de bolas"
  },
  "mtic_g78_m6_c212": {
    "en": "Bucket of Balls - Challenge",
    "fr": "Seau de balles - Challenge",
    "de": "Bälleeimer - Challenge",
    "pt": "Balde de bolas - desafio"
  },
  "mtic_g78_m6_c22": {
    "en": "Growth Graph",
    "fr": "Courbe de Croissance",
    "de": "Wachstumskurve",
    "pt": "Curva de crescimento: representação gáfica"
  },
  "mtic_g78_m6_c33": {
    "en": "Statistics Puzzles",
    "fr": "Puzzles Statistiques",
    "de": "Statistik - Puzzles",
    "pt": "Puzzles Statistiques"
  },

  // M6 Category Names
  "gr78_m6_group__und_perc": {
    "en": "Understanding Percentages",
    "fr": "Comprendre les Pourcentages",
    "de": "Prozentangaben verstehen",
    "pt": "Compreender percentagens"
  },
  "gr78_m6_group__calc_perc": {
    "en": "Calculations with Percentages",
    "fr": "Calculer avec des Pourcentages",
    "de": "Rechnen mit Prozentangaben",
    "pt": "Cálculos com percentagens"
  },
  "gr78_m6_group__graphs": {
    "en": "Graphs",
    "fr": "Diagrammes",
    "de": "Diagramme",
    "pt": "Gráficos"
  },
  "gr78_m6_group__statistics": {
    "en": "Statistics",
    "fr": "Statistiques",
    "de": "Statistiken",
    "pt": "Estatísticas"
  },
  //M7 category names
  "mtic_g78_m7_group__transfo": {
    "en": "Transformations",
    "fr": "Transformations",
    "de": "Abbildungen",
    "pt": "Transformações"
  },
  "mtic_g78_m7_group__ax_ref": {
    "en": "Axial Reflections",
    "fr": "Symétries axiales",
    "de": "Achsenspiegelungen",
    "pt": "Reflexões axiais"
  },
  "mtic_g78_m7_group__point_ref": {
    "en": "Point Reflections",
    "fr": "Symétries centrales",
    "de": "Punktspiegelungen",
    "pt": "Reflexões axiais"
  },
  "mtic_g78_m7_group__rot": {
    "en": "Rotations",
    "fr": "Rotations",
    "de": "Drehungen",
    "pt": "Rotações"
  },
  "mtic_g78_m7_group__transla": {
    "en": "Translations",
    "fr": "Translations",
    "de": "Verschiebungen",
    "pt": "Translações"
  },
  "mtic_g78_m7_group__mix_iso": {
    "en": "Mixed Isometries",
    "fr": "Diverses isométries",
    "de": "Verschiedenen Isometriens",
    "pt": "Isometrias mistas"
  },

  //M7  item names
  "mtic_g78_m7_transform_1": {
    "en": "Introducing Transformations (Part 1)",
    "fr": "Introduction aux transformations (partie 1)",
    "de": "Abbildungen: Einführung (Teil 1)",
    "pt": "Transformações: introdução (Parte 1)"
  },
  "mtic_g78_m7_transform_2": {
    "en": "Introducing Transformations (Part 2)",
    "fr": "Introduction aux transformations (partie 2)",
    "de": "Abbildungen: Einführung (Teil 2)",
    "pt": "Transformações: introdução (Parte 2)"
  },
  "mtic_g78_m7_axial_intro": {
    "en": "Introducing Axial Reflections",
    "fr": "Symétries axiales: introduction",
    "de": "Achsensymmetrie: Einführung",
    "pt": "Simetrias: reflexão axial - introdução"
  },
  "mtic_g78_m7_axial_prop": {
    "en": "Properties of Axial Reflections",
    "fr": "Symétries axiales: propriétés",
    "de": "Achsensymmetrie: Eigenschaften",
    "pt": "Simetrias: reflexão axial - propriedades"
  },
  "mtic_g78_m7_central_intro": {
    "en": "Introducing Point Reflections",
    "fr": "Symétries centrales: introduction",
    "de": "Punktsymmetrie: Einführung",
    "pt": "Simetrias: reflexão central - introdução"
  },
  "mtic_g78_m7_central_prop": {
    "en": "Properties of Point Reflections",
    "fr": "Symétries centrales: propriétés",
    "de": "Punktsymmetrie: Eigenschaften",
    "pt": "Simetrias: reflexão central - propriedades"
  },
  "mtic_g78_m7_rotat_intro": {
    "en": "Introducing Rotations",
    "fr": "Rotations: introduction",
    "de": "Drehungen: Einführung",
    "pt": "Introdução às rotações"
  },
  "mtic_g78_m7_rotat_prop": {
    "en": "Properties of Rotations",
    "fr": "Rotations: propriétés",
    "de": "Drehungen: Eigenschaften",
    "pt": "Propriedades das rotações"
  },
  "mtic_g78_m7_transl_intro": {
    "en": "Introducing Translations",
    "fr": "Translations: introduction",
    "de": "Verschiebungen: Einführung",
    "pt": "Introdução às translações"
  },
  "mtic_g78_m7_transl_prop": {
    "en": "Properties of Translations",
    "fr": "Translations: propriétés",
    "de": "Verschiebungen: Eigenschaften",
    "pt": "Propriedades das translações"
  },
  "mtic_g78_m7_axial_const": {
    "en": "Axial Reflection Constructions",
    "fr": "Symétries axiales: constructions",
    "de": "Achsensymmetrie: Konstruktionen",
    "pt": "Simetria axial: construções"
  },
  "mtic_g78_m7_axial_find": {
    "en": "Finding Axial Symmetry",
    "fr": "Trouver des axes de symétrie",
    "de": "Symmetrieachsen bestimmen",
    "pt": "Encontrar os eixos de simetria"
  },
  "mtic_g78_m7_central_const": {
    "en": "Point Reflection Constructions",
    "fr": "Symétrie centrales: constructions",
    "de": "Punktsymmetrie: Konstruktionen",
    "pt": "Simetria central: construções"
  },
  "mtic_g78_m7_central_find": {
    "en": "Finding Central Symmetry",
    "fr": "Trouver des centres de symétrie",
    "de": "Spiegelzentren bestimmen",
    "pt": "Encontrar os centros de simetria"
  },
  "mtic_g78_m7_rotat_const": {
    "en": "Rotation Constructions",
    "fr": "Rotations: constructions",
    "de": "Drehungen: Konstruktionen",
    "pt": "Rotações: construções"
  },
  "mtic_g78_m7_transl_const": {
    "en": "Translation Constructions",
    "fr": "Translations: constructions",
    "de": "Verschiebungen: Konstruktionen",
    "pt": "Translações: construções"
  },
  "mtic_g78_m7_isomet_const": {
    "en": "Mixed Transformations on a Grid",
    "fr": "Transformations: exercice avec quadrillage",
    "de": "Vermischte Übungen am Kästchengitter",
    "pt": "Transformações: exercícios"
  },
  "mtic_g78_m7_geo_const": {
    "en": "Constructing Isometries",
    "fr": "Transformations: constructions",
    "de": "Abbildungen: Konstruktionen",
    "pt": "Transformações: construções"
  },
  "mtic_g78_m7_axial_golf": {
    "en": "Axis Ball",
    "fr": "Symétrie-golf",
    "de": "Spiegel-Golf",
    "pt": "Simetria: jogo de golf"
  },
  "mtic_g78_m7_rotat_mandala": {
    "en": "Decorating Cakes",
    "fr": "Gâteaux décorés",
    "de": "Kuchen dekorieren",
    "pt": "Decorar bolos"
  },
  "mtic_g78_m7_transl_ball": {
    "en": "Awkward Football",
    "fr": "Football challenge",
    "de": "Fußball Challenge",
    "pt": "Futebol: desafio"
  },
  "mtic_g78_m7_isomet_maze": {
    "en": "Kentucky Lou & The Temple of Dredd",
    "fr": "Kentucky Lou & le temple maudit",
    "de": "Kentucky Lou und der Tempel der Furcht",
    "pt": "Kentucky Lou e o templo maldito"
  },
  "mtic_g78_m7_isomet_notat": {
    "en": "Isometry Notation",
    "fr": "Transformations: notations",
    "de": "Abbildungen: Notation",
    "pt": "Transformações: notações"
  },
  "mtic_g78_m7_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m7_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  // M8 Category Names
  "gr78_m8_group__conv_units": {
    "en": "Converting Units",
    "fr": "Conversion d'unités",
    "de": "Einheiten umwandeln",
    "pt": "Conversão de unidades"
  },
  "gr78_m8_group__perimeter": {
    "en": "Perimeter",
    "fr": "Périmètre",
    "de": "Umfang",
    "pt": "Perímetro"
  },
  "gr78_m8_group__area": {
    "en": "Area",
    "fr": "Aire",
    "de": "Flächeninhalt",
    "pt": "Área"
  },
  "gr78_m8_group__intro_solids": {
    "en": "Introduction to Solids",
    "fr": "Introduction aux solides",
    "de": "Körper: Einführung",
    "pt": "Introdução aos sólidos"
  },
  "gr78_m8_group__volume": {
    "en": "Volume",
    "fr": "Volume",
    "de": "Volumen",
    "pt": "Volume"
  },
  "gr78_m8_group__surface_area": {
    "en": "Surface Area",
    "fr": "Aire totale",
    "de": "Oberflächeninhalt",
    "pt": "Áreas"
  },

  // M8 Item Names
  "mtic_g78_m8_a1": {
    "en": "Converting Measurements",
    "fr": "Conversion",
    "de": "Einheiten umwandeln",
    "pt": "Conversão"
  },
  "mtic_g78_m8_a2": {
    "en": "Review of Perimeter",
    "fr": "Périmètre de polygones",
    "de": "Umfang Vieleck",
    "pt": "Perímetro de polígonos"
  },
  "mtic_g78_m8_a31": {
    "en": "Perimeter of Circles",
    "fr": "Périmètre de disques",
    "de": "Umfang Kreis",
    "pt": "Perímetro do círculo"
  },
  "mtic_g78_m8_a32": {
    "en": "Value of Pi",
    "fr": "Valeur exacte de pi",
    "de": "Exakter Wert von Pi",
    "pt": "Valor de pi"
  },
  "mtic_g78_m8_a41": {
    "en": "Review of Area",
    "fr": "Aire  rect., paral. et triangles",
    "de": "Fläche RE, Paral, Dreieck",
    "pt": "Área de rectângulos, paralelogramos e triângulos"
  },
  "mtic_g78_m8_a42": {
    "en": "Area of Trapezoids",
    "fr": "Aire de trapèzes",
    "de": "Fläche Trapez",
    "pt": "Área de trapézios"
  },
  "mtic_g78_m8_a5": {
    "en": "Area of Circles",
    "fr": "Aire de disques",
    "de": "Fläche Kreis",
    "pt": "Área do círculo"
  },
  "mtic_g78_m8_a6": {
    "en": "Intro to Solids",
    "fr": "Les solides: introduction",
    "de": "Einf.: Körper",
    "pt": "Sólidos: introdução"
  },
  "mtic_g78_m8_a7": {
    "en": "Prisms and Pyramids",
    "fr": "Prismes, pyr., cyl. et cônes",
    "de": "Prism., Pyr., Zyl., Kegel",
    "pt": "Prismas, pirâm., cilind. e cones"
  },
  "mtic_g78_m8_a8": {
    "en": "Volume of Prisms",
    "fr": "Volume des prismes",
    "de": "Volumen Prisma",
    "pt": "Volume de prismas"
  },
  "mtic_g78_m8_a9": {
    "en": "Surface Area of Prisms",
    "fr": "Aire totale des prismes",
    "de": "Oberfläche Prisma",
    "pt": "Área de prismas"
  },
  "mtic_g78_m8_a101": {
    "en": "Volume of Cylinders",
    "fr": "Volume des cylindres",
    "de": "Volumen Zylinder",
    "pt": "Volume de cilindros"
  },
  "mtic_g78_m8_a102": {
    "en": "Surface Area of Cylinders",
    "fr": "Aire totale des cylindres",
    "de": "Oberfläche Zylinder",
    "pt": "Área de cilindros"
  },
  "mtic_g78_m8_a11": {
    "en": "Volume of Pyramids and Cones",
    "fr": "Volume des pyramides et cônes",
    "de": "Volumen Pyr., Kegel",
    "pt": "Volume de pirâmides e cones"
  },
  "mtic_g78_m8_a12": {
    "en": "Workspace",
    "fr": "Espace de travail",
    "de": "Zus.gesetzte Figuren",
    "pt": "Espaço de trabalho para figuras compostas"
  },
  "mtic_g78_m8_b11": {
    "en": "Ordering Measurements",
    "fr": "Ordonner des mesures",
    "de": "Maße ordnen",
    "pt": "Ordenar medidas"
  },
  "mtic_g78_m8_b12": {
    "en": "Perimeter Exercises",
    "fr": "Périmètre: exercices",
    "de": "Umfang Übungen",
    "pt": "Perímetro: exercícios"
  },
  "mtic_g78_m8_b2": {
    "en": "Area Exercises",
    "fr": "Aire: exercice",
    "de": "Flächeninhalt: Übungen",
    "pt": "Determinação de áreas - exercícios"
  },
  "mtic_g78_m8_b31": {
    "en": "Area of Comp. Shapes",
    "fr": "Aire de figures composées",
    "de": "Fläche zus.ges Figuren",
    "pt": "Área de figuras compostas"
  },
  "mtic_g78_m8_b4": {
    "en": "Volume of Prisms Exercises",
    "fr": "Volume des prismes: exercices",
    "de": "Volumen Prisma Übungen",
    "pt": "Volume de prismas - exercícios"
  },
  "mtic_g78_m8_b5": {
    "en": "Surface Area of Prisms Exercises",
    "fr": "Aire totale des prismes: exercices",
    "de": "Oberfläche Prisma Übg.",
    "pt": "Área do prisma - exercícios"
  },
  "mtic_g78_m8_b7": {
    "en": "Volume of Pyramids Exercises",
    "fr": "Volume des pyramides: exercices",
    "de": "Volumen Pyr. Übungen",
    "pt": "Volume de pirâmides - exercícios"
  },
  "mtic_g78_m8_c1": {
    "en": "Measurements Around You",
    "fr": "Les mesures autour de toi",
    "de": "Maße an dir",
    "pt": "Medidas à tua volta"
  },
  "mtic_g78_m8_c2": {
    "en": "Perimeter of Comp. Shapes",
    "fr": "Périmètre de figures composées",
    "de": "Umfang zus.ges Fig. Übg.",
    "pt": "Perímetro de figuras compostas"
  },
  "mtic_g78_m8_c32": {
    "en": "Area of Comp. Shapes - Challenge",
    "fr": "Aire de figures composées - défi",
    "de": "Fläche zsg Fig - Challenge",
    "pt": "Área de figuras compostas - desafio"
  },
  "mtic_g78_m8_c7": {
    "en": "Volume of Comp. Shapes",
    "fr": "Volume de figures composées",
    "de": "Volumen zus.ges Figuren",
    "pt": "Volume de figuras compostas"
  },
  "mtic_g78_m8_t1": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m8_t2": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  //g78 m9

  "mtic_g78_m9_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m9_summ": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m9_point_line_a": {
    "en": "Investigating Points and Lines",
    "fr": "Notions de base: points, droites,...",
    "de": "Punkte und Geraden erkunden",
    "pt": "Noções básicas: pontos e linhas"
  },
  "mtic_g78_m9_angle_intro": {
    "en": "Investigating Types of Angles",
    "fr": "Les différents types d'angles",
    "de": "Winkelarten erkunden",
    "pt": "Diferentes tipos de ângulos"
  },
  "mtic_g78_m9_angle_parts": {
    "en": "Parts of an angle",
    "fr": "Parties d'un angle",
    "de": "Bestandteile eines Winkels",
    "pt": "Partes de um triângulo"
  },
  "mtic_g78_m9_angle_adjacent": {
    "en": "Adjacent Angles",
    "fr": "Angles adjacents",
    "de": "Nachbarwinkel",
    "pt": "Ângulos adjacentes"
  },
  "mtic_g78_m9_angle_parallel": {
    "en": "Vertical and Alternate Interior Angles",
    "fr": "Angles formés par deux droites et une sécante",
    "de": "Stufen- und Wechselwinkel",
    "pt": "Formação de ângulos"
  },
  "mtic_g78_m9_angle_bisect_a": {
    "en": "Angle Bisectors",
    "fr": "Bissectrice d'un angle",
    "de": "Winkelhalbierende",
    "pt": "Bissectriz de um ângulo"
  },
  "mtic_g78_m9_angle_perp_bisect": {
    "en": "Perpendicular Bisectors",
    "fr": "Médiatrice d'un segment",
    "de": "Mittelsenkrechte",
    "pt": "Mediatriz de um segmento"
  },
  "mtic_g78_m9_circle": {
    "en": "Investigating Circles",
    "fr": "Cercles et leur construction",
    "de": "Kreise erkunden",
    "pt": "Construção de círculos"
  },
  "mtic_g78_m9_tri_intro": {
    "en": "Investigating Types of Triangles",
    "fr": "Les différents types de triangles",
    "de": "Dreiecksarten erkunden",
    "pt": "Investigando tipos de triângulos"
  },
  "mtic_g78_m9_tri_const_a_pt1": {
    "en": "Triangle Construction (SSS)",
    "fr": "Construction des triangles (CCC)",
    "de": "Dreieckskonstruktion (SSS)",
    "pt": "Construção de triângulos (LLL)"
  },
  "mtic_g78_m9_tri_const_a_pt2": {
    "en": "Triangle Construction (AAA)",
    "fr": "Construction des triangles (AAA)",
    "de": "Dreieckskonstruktion (WWW)",
    "pt": "Construção de triângulos (AAA)"
  },
  "mtic_g78_m9_tri_const_a_pt3": {
    "en": "Triangle Construction (ASA and SAS)",
    "fr": "Construction des triangles (ACA-CAC)",
    "de": "Dreieckskonstruktion (WSW und SWS)",
    "pt": "Construção de triângulos (ALA-LAL)"
  },
  "mtic_g78_m9_tri_180": {
    "en": "Sum of Angles of a Triangle",
    "fr": "Somme des angles d'un triangle",
    "de": "Winkelsumme im Dreieck",
    "pt": "Soma dos ângulos de um triângulo"
  },
  "mtic_g78_m9_tri_imposs_a": {
    "en": "The Triangle Inequality",
    "fr": "Inégalité triangulaire",
    "de": "Dreiecksungleichung",
    "pt": "Desigualdade de triângulos"
  },
  "mtic_g78_m9_quad_intro": {
    "en": "Investigating Quadrilaterals",
    "fr": "Les différents types de quadrilatères",
    "de": "Vierecksarten erkunden",
    "pt": "Investigando tipos de quadriláteros"
  },
  "mtic_g78_m9_quad_prop": {
    "en": "Properties of Quadrilaterals",
    "fr": "Propriétés des quadrilatères",
    "de": "Eigenschaften von Vierecken",
    "pt": "Propriedades dos quadriláteros"
  },
  "mtic_g78_m9_quad_hierarchy_1": {
    "en": "Hierarchy of Quadrilaterals",
    "fr": "Hiéarchie des quadrilatères",
    "de": "Hierarchie der Vierecke",
    "pt": "Hierarquia dos quadriláteros"
  },
  "mtic_g78_m9_quad_hierarchy_2": {
    "en": "Properties of Diagonals",
    "fr": "Propriétés des diagonales",
    "de": "Eigenschaften der Diagonalen",
    "pt": "Propriedades das diagonais"
  },
  "mtic_g78_m9_point_line_b": {
    "en": "Points and Lines Training",
    "fr": "Exercice sur les points, droites,...",
    "de": "Übungen zu Punkten und Geraden",
    "pt": "Pontos e linhas: exercícios"
  },
  "mtic_g78_m9_angle_space": {
    "en": "Space Angles",
    "fr": "Space angles",
    "de": "Space Angles",
    "pt": "Ângulos no «espaço»"
  },
  "mtic_g78_m9_angle_space_multi": {
    "en": "Space Angles Multiplayer",
    "fr": "Space angles - multijoueur",
    "de": "Space Angles - Multiplayer",
    "pt": "Ângulos no «espaço»: vários jogadores"
  },
  "mtic_g78_m9_angle_fall": {
    "en": "Fallen Pizzas",
    "fr": "Fallen pizzas",
    "de": "Fallen Pizzas",
    "pt": "«Chuva de pizzas»"
  },
  "mtic_g78_m9_angle_find": {
    "en": "Angles in Parallel Lines",
    "fr": "Exerice : angles formés par deux droites et une sécante",
    "de": "Übungen zu Winkel und Geraden",
    "pt": "Ângulos e linhas paralelas: exercícios"
  },
  "mtic_g78_m9_angle_bisect_b": {
    "en": "Constructing Bisectors",
    "fr": "Construire des bissectrices",
    "de": "Winkelhalbierende konstruieren",
    "pt": "Construir bissectrizes"
  },
  "mtic_g78_m9_circle_const_b": {
    "en": "Constructions: Set of Instructions",
    "fr": "Programmes de tracé",
    "de": "Konstruktionsprotokolle",
    "pt": "Construções: instruções"
  },
  "mtic_g78_m9_tri_const_b": {
    "en": "Constructing Triangles",
    "fr": "Construire des triangles",
    "de": "Dreiecke konstruieren",
    "pt": "Construir triângulos"
  },
  "mtic_g78_m9_tri_calc": {
    "en": "Angles in Triangles",
    "fr": "Angles et triangles",
    "de": "Winkel in Dreiecken",
    "pt": "Ângulos e triângulos"
  },
  "mtic_g78_m9_tri_imposs_b": {
    "en": "Impossible Triangles",
    "fr": "Triangles impossibles",
    "de": "Unmögliche Dreiecke",
    "pt": "Triângulos impossíveis"
  },
  "mtic_g78_m9_quad_ident": {
    "en": "Identifying Quadrilaterals",
    "fr": "Identifier des quadrilatères",
    "de": "Vierecke erkennen",
    "pt": "Identificar quadriláteros"
  },
  "mtic_g78_m9_quad_const": {
    "en": "Constructing Quadrilaterals",
    "fr": "Construire des quadrilatères",
    "de": "Vierecke konstruieren",
    "pt": "Construir quadriláteros"
  },
  "mtic_g78_m9_vocab_point": {
    "en": "Vocabulary: Points, Lines, Angles",
    "fr": "Vocabulaire: points, droites, angles,...",
    "de": "Fachbegriffe: Punkte, Geraden, Winkel",
    "pt": "Pontos, linhas e ângulos: vocabulário"
  },
  "mtic_g78_m9_vocab_shape": {
    "en": "Vocabulary: Polygons",
    "fr": "Vocabulaire: polygones",
    "de": "Fachbegriffe: Vielecke",
    "pt": "Polígonos: vocabulário"
  },
  "mtic_g78_m9_count": {
    "en": "Count the Shapes",
    "fr": "Compter les figures dans une figure",
    "de": "Formen zählen",
    "pt": "Contar figuras"
  },
  "mtic_g78_m9_open": {
    "en": "Make a Video: Measuring Angles",
    "fr": "Faire une vidéo: mesurer des angles",
    "de": "Video drehen: Winkel messen",
    "pt": "Fazer um vídeo: medir ângulos"
  },
  "mtic_g78_m9_treasure_point": {
    "en": "Quest for the Golden Ruler",
    "fr": "Chasse au trésor: règle en or",
    "de": "Auf der Suche nach dem goldenen Kegel",
    "pt": "Caça ao tesouro: a procura da «regra dourada»"
  },
  "mtic_g78_m9_treasure_shape": {
    "en": "Tale of the Magic Compass",
    "fr": "Chasse au trésor: boussole magique",
    "de": "Auf der Suche nach dem magischen Kompass",
    "pt": "Caça ao tesouro: a procura da «bússola mágica»"
  },
  "mtic_g78_m9_point_line_a_short": {
    "en": "Investigating Points and Lines",
    "fr": "Notions de base: points, droites",
    "de": "Punkte und Geraden",
    "pt": "Notions de base: points, droites"
  },
  "mtic_g78_m9_angle_intro_short": {
    "en": "Investigating Types of Angles",
    "fr": "Les différents types d'angles",
    "de": "Winkelarten erkunden",
    "pt": "Les différents types d'angles"
  },
  "mtic_g78_m9_angle_parts_short": {
    "en": "Parts of an Angle",
    "fr": "Parts d'un triangle",
    "de": "Bestandteile eines Winkels",
    "pt": "Parts d'un triangle"
  },
  "mtic_g78_m9_angle_adjacent_short": {
    "en": "Adjacent Angles",
    "fr": "Angles adjacents",
    "de": "Nachbarwinkel",
    "pt": "Angles adjacents"
  },
  "mtic_g78_m9_angle_parallel_short": {
    "en": "Vertical and Alt. Interior Angles",
    "fr": "Angles formés par 2 dr. et 1 séc.",
    "de": "Stufen- und Wechselwinkel",
    "pt": "Angles formés par 2 dr. et 1 séc."
  },
  "mtic_g78_m9_angle_bisect_a_short": {
    "en": "Angle Bisectors",
    "fr": "Bissectrice d'un angle",
    "de": "Winkelhalbierende",
    "pt": "Bissectrice d'un angle"
  },
  "mtic_g78_m9_angle_perp_bisect_short": {
    "en": "Perpendicular Bisectors",
    "fr": "Médiatrice d'un segment",
    "de": "Mittelsenkrechte",
    "pt": "Médiatrice d'un segment"
  },
  "mtic_g78_m9_circle_short": {
    "en": "Investigating Circles",
    "fr": "Cercles et leur construction",
    "de": "Kreise erkunden",
    "pt": "Cercles et leur construction"
  },
  "mtic_g78_m9_tri_intro_short": {
    "en": "Investigating Types of Triangles",
    "fr": "Les types de triangles",
    "de": "Dreiecksarten erkunden",
    "pt": "Les types de triangles"
  },
  "mtic_g78_m9_tri_const_a_pt1_short": {
    "en": "Triangle Construction (SSS)",
    "fr": "Triangles constructions CCC",
    "de": "Dreieckskonstruktion (SSS)",
    "pt": "Triangles constructions CCC"
  },
  "mtic_g78_m9_tri_const_a_pt2_short": {
    "en": "Triangle Construction (AAA)",
    "fr": "Triangles constructions AAA",
    "de": "Dreieckskonstruktion (WWW)",
    "pt": "Triangles constructions AAA"
  },
  "mtic_g78_m9_tri_const_a_pt3_short": {
    "en": "Triangle Construction (ASA, SAS)",
    "fr": "Triangles constructions ACA-CAC",
    "de": "Dreieckskonstruktion (WSW und SWS)",
    "pt": "Triangles constructions ACA-CAC"
  },
  "mtic_g78_m9_tri_180_short": {
    "en": "Sum of Angles of a Triangle",
    "fr": "Somme des angles d'un triangle",
    "de": "Winkelsumme im Dreieck",
    "pt": "Somme des angles d'un triangle"
  },
  "mtic_g78_m9_tri_imposs_a_short": {
    "en": "The Triangle Inequality",
    "fr": "Inégalité triangulaire",
    "de": "Dreiecksungleichung",
    "pt": "Inégalité triangulaire"
  },
  "mtic_g78_m9_quad_intro_short": {
    "en": "Investigating Quadrilaterals",
    "fr": "Les types de quadrilatères",
    "de": "Vierecksarten erkunden",
    "pt": "Les types de quadrilatères"
  },
  "mtic_g78_m9_quad_prop_short": {
    "en": "Properties of Quadrilaterals",
    "fr": "Propriétés des quadrilatères",
    "de": "Eigenschaften von Vierecken",
    "pt": "Propriétés des quadrilatères"
  },
  "mtic_g78_m9_quad_hierarchy_1_short": {
    "en": "Hierarchy of Quadrilaterals",
    "fr": "Hiéarchie des quadrilatères",
    "de": "Hierarchie der Vierecke",
    "pt": "Hiéarchie des quadrilatères"
  },
  "mtic_g78_m9_quad_hierarchy_2_short": {
    "en": "Properties of Diagonals",
    "fr": "Propriétés des diagonales",
    "de": "Eigenschaften der Diagonalen",
    "pt": "Propriétés des diagonales"
  },
  "mtic_g78_m9_point_line_b_short": {
    "en": "Points and Lines Training",
    "fr": "Exercice sur les points, droites",
    "de": "Übung Punkte, Geraden",
    "pt": "Exercice sur les points, droites"
  },
  "mtic_g78_m9_angle_space_short": {
    "en": "Space Angles",
    "fr": "Space angles",
    "de": "Space Angles",
    "pt": "Space angles"
  },
  "mtic_g78_m9_angle_space_multi_short": {
    "en": "Space Angles Multiplayer",
    "fr": "Space angles - multijoueur",
    "de": "Space Angles - Multiplayer",
    "pt": "Space angles - multijoueur"
  },
  "mtic_g78_m9_angle_fall_short": {
    "en": "Fallen Pizzas",
    "fr": "Fallen pizzas",
    "de": "Fallen Pizzas",
    "pt": "Fallen pizzas"
  },
  "mtic_g78_m9_angle_find_short": {
    "en": "Angles in Parallel Lines",
    "fr": "Exercice: angles et droites",
    "de": "Übung Winkel, Geraden",
    "pt": "Exercice: angles et droites"
  },
  "mtic_g78_m9_angle_bisect_b_short": {
    "en": "Constructing Bisectors",
    "fr": "Construire des bissectrices",
    "de": "Konstr Winkelhalbierende",
    "pt": "Construire des bissectrices"
  },
  "mtic_g78_m9_circle_const_b_short": {
    "en": "Constructions: Set of Instructions",
    "fr": "Programmes de tracé",
    "de": "Konstruktionsprotokolle",
    "pt": "Programmes de tracé"
  },
  "mtic_g78_m9_tri_const_b_short": {
    "en": "Constructing Triangles",
    "fr": "Construire des triangles",
    "de": "Dreiecke konstruieren",
    "pt": "Construire des triangles"
  },
  "mtic_g78_m9_tri_calc_short": {
    "en": "Angles in Triangles",
    "fr": "Angles et triangles",
    "de": "Winkel in Dreiecken",
    "pt": "Angles et triangles"
  },
  "mtic_g78_m9_tri_imposs_b_short": {
    "en": "Impossible Triangles",
    "fr": "Triangles impossibles",
    "de": "Unmögliche Dreiecke",
    "pt": "Triangles impossibles"
  },
  "mtic_g78_m9_quad_ident_short": {
    "en": "Identifying Quadrilaterals",
    "fr": "Identifier des quadrilatères",
    "de": "Vierecke erkennen",
    "pt": "Identifier des quadrilatères"
  },
  "mtic_g78_m9_quad_const_short": {
    "en": "Constructing Quadrilaterals",
    "fr": "Construire des quadrilatères",
    "de": "Vierecke konstruieren",
    "pt": "Construire des quadrilatères"
  },
  "mtic_g78_m9_vocab_point_short": {
    "en": "Vocabulary: Points, Lines, Angles",
    "fr": "Vocabulaire: points, droites, angles",
    "de": "Begriffe: Punkte, Geraden, Winkel",
    "pt": "Vocabulaire: points, droites, angles"
  },
  "mtic_g78_m9_vocab_shape_short": {
    "en": "Vocabulary: Polygons",
    "fr": "Vocabulaire: polygones",
    "de": "Fachbegriffe: Vielecke",
    "pt": "Vocabulaire: polygones"
  },
  "mtic_g78_m9_count_short": {
    "en": "Count the Shapes",
    "fr": "Compter les figures",
    "de": "Formen zählen",
    "pt": "Compter les figures"
  },
  "mtic_g78_m9_open_short": {
    "en": "Make a Video: Measuring Angles",
    "fr": "Vidéo: mesurer des angles",
    "de": "Video drehen: Winkel messen",
    "pt": "Vidéo: mesurer des angles"
  },
  "mtic_g78_m9_treasure_point_short": {
    "en": "Quest for the Golden Ruler",
    "fr": "Chasse au trésor: règle en or",
    "de": "Der goldene Kegel",
    "pt": "Chasse au trésor: règle en or"
  },
  "mtic_g78_m9_treasure_shape_short": {
    "en": "Tale of the Magic Compass",
    "fr": "Chasse au trésor:boussole magique",
    "de": "Der magische Kompass",
    "pt": "Chasse au trésor:boussole magique"
  },
  "mtic_g78_m9_points_lines__group": {
    "en": "Points and Lines",
    "fr": "Points et droites",
    "de": "Punkte und Gerade",
    "pt": "Pontos e linhas"
  },
  "mtic_g78_m9_angles__group": {
    "en": "Angles",
    "fr": "Angles",
    "de": "Winkel",
    "pt": "Ângulos"
  },
  "mtic_g78_m9_circles__group": {
    "en": "Circles",
    "fr": "Cercles",
    "de": "Kreise",
    "pt": "Círculos"
  },
  "mtic_g78_m9_triangles__group": {
    "en": "Triangles",
    "fr": "Triangles",
    "de": "Dreiecke",
    "pt": "Triângulos"
  },
  "mtic_g78_m9_quadrilaterls__group": {
    "en": "Quadrilaterals",
    "fr": "Quadrilatères",
    "de": "Vierecke",
    "pt": "Quadriláteros"
  },
  "mtic_g78_m9_constructions__group": {
    "en": "Constructions",
    "fr": "Constructions",
    "de": "Konstruktionen",
    "pt": "Construções "
  },

  // g78 m2
  "mtic_gr78_m2": {
    "en": "Algebra",
    "fr": "Calcul littéral",
    "de": "Algebra",
    "pt": "Calcul littéral"
  },
  "mtic_g78_m2_dist_act": {
    "en": "Distributivity in Action",
    "fr": "Distributivité en action",
    "de": "Anwendung des Distributivgesetzes",
    "pt": "Distribuição em ato"
  },
  "mtic_g78_m2_prog_calc_a": {
    "en": "Proving with Programs",
    "fr": "Prog. de calcul comme preuve",
    "de": "Beweisen mit Rechenprog.",
    "pt": "Programa de cálculo como instrumento de prova"
  },
  "mtic_g78_m2_spread_calc_pt1": {
    "en": "The Power of Spreadsheets",
    "fr": "Le pouvoir des tableurs",
    "de": "Die Möglichkeiten von Kalkulationstabellen",
    "pt": "A capacidade das folhas de cálculo"
  },
  "mtic_g78_m2_spread_calc_pt2": {
    "en": "Program a Spreadsheet",
    "fr": "Programmer un tableur",
    "de": "Eine Kalkulationstabelle programmieren",
    "pt": "Programar uma folha de cálculo"
  },
  "mtic_g78_m2_spread_calc_pt3": {
    "en": "Testing the Program",
    "fr": "Tester un programme",
    "de": "Ein Programm testen",
    "pt": "Testar um programa"
  },
  "mtic_g78_m2_distrib_add_pt1": {
    "en": "Distributivity Over Addition: Does the Pattern Hold?",
    "fr": "Distributivité de la multiplication par rapport à l'addition: est-ce que le modèle reste valable?",
    "de": "Das Distributivgesetz (Multiplikation mit Summen) - Gilt die Gesetzmäßigkeit?",
    "pt": "Distributividade da multiplicação em relação à adição: o modelo permanece?"
  },
  "mtic_g78_m2_distrib_add_pt2": {
    "en": "Distributivity Over Addition: Prove It!",
    "fr": "Distributivité de la multiplication par rapport à l'addition: démontre-le!",
    "de": "Das Distributivgesetz (Multiplikation mit Summen) - Beweisen wir es!",
    "pt": "Distributividade da multiplicação em relação à adição: prova-o!"
  },
  "mtic_g78_m2_distrib_add_pt3": {
    "en": "Distributivity Over Addition: Some Examples",
    "fr": "Distributivité de la multiplication par rapport à l'addition: quelques exemples",
    "de": "Das Distributivgesetz (Multiplikation mit Summen) - Einige Beispiele",
    "pt": "Distributividade da multiplicação em relação à adição: alguns exemplos"
  },
  "mtic_g78_m2_distrib_sub_pt1": {
    "en": "Distributivity Over Subtraction: Build On What We Know",
    "fr": "Distributivité de la multiplication par rapport à la soustraction: Partons de ce qu'on sait",
    "de": "Das Distributivgesetz (Multiplikation mit Differenzen) - Was wir schon wissen",
    "pt": "Distributividade da multiplicação em relação à subtração: Começamos com o que sabemos"
  },
  "mtic_g78_m2_distrib_sub_pt2": {
    "en": "Distributivity Over Subtraction: Continue the Pattern",
    "fr": "Distributivité de la multiplication par rapport à la soustraction: continuer le modèle",
    "de": "Das Distributivgesetz (Multiplikation mit Differenzen) - Die Reihe fortsetzen",
    "pt": "Distributividade da multiplicação em relação à subtração: contiuar o modelo"
  },
  "mtic_g78_m2_distrib_sub_pt3": {
    "en": "Distributivity Over Subtraction: A New Pattern",
    "fr": "Distributivité de la multiplication par rapport à la soustraction: un nouveau modèle",
    "de": "Das Distributivgesetz (Multiplikation mit Differenzen) - Eine neues Muster",
    "pt": "Distributividade da multiplicação em relação à subtração: um novo modelo"
  },
  "mtic_g78_m2_distrib_sub_pt4": {
    "en": "Distributivity Over Subtraction: Some Examples",
    "fr": "Distributivité de la multiplication par rapport à la soustraction: quelques exemples",
    "de": "Das Distributivgesetz (Multiplikation mit Differenzen) - Ein paar Beispiele",
    "pt": "Distributividade da multiplicação em relação à subtração: alguns exemplos"
  },
  "mtic_g78_m2_distrib_exer": {
    "en": "Simple Distributivity: Exercises",
    "fr": "Distributivité simple: exercices",
    "de": "Das Distributivgesetz - Übungen",
    "pt": "Distributividade simples: exercícios"
  },
  "mtic_g78_m2_factoring_pt1": {
    "en": "Factoring: Distributivity and Factoring",
    "fr": "Factorisation: développer et factoriser",
    "de": "Faktorisieren: Ausmultiplizieren und Faktorisieren",
    "pt": "Fatoração: developar e fatorar"
  },
  "mtic_g78_m2_factoring_pt2": {
    "en": "Factoring: Collecting All the Common Factors",
    "fr": "Factorisation: mise en évidence des facteurs communs",
    "de": "Faktorisieren: Ausklammern gemeinsamer Faktoren",
    "pt": "Fatoração: meter em evidência os fatores comuns"
  },
  "mtic_g78_m2_factoring_pt3": {
    "en": "Factoring: Everything is Common",
    "fr": "Factorisation: tout est commun ",
    "de": "Faktorisieren: Alles ist gemeinsam",
    "pt": "Fatoração: todo é comum"
  },
  "mtic_g78_m2_factoring_pt4": {
    "en": "Factoring: Bracketed Factor",
    "fr": "Factorisation: avec des facteurs entre parenthèses",
    "de": "Faktorisieren: Faktoren in Klammern",
    "pt": "Fatoração: com fatores entre parentes"
  },
  "mtic_g78_m2_factoring_ex": {
    "en": "Factoring: Exercises",
    "fr": "Factorisation: exercices",
    "de": "Faktorisieren: Übungen",
    "pt": "Fatoração: exercícios"
  },
  "mtic_g78_m2_equiv_expr": {
    "en": "Equivalent Expressions",
    "fr": "Expressions équivalentes",
    "de": "Äquivalente Terme",
    "pt": "Expressões equivalentes"
  },
  "mtic_g78_m2_grand_stair_pt1": {
    "en": "Growing Pattern: The T",
    "fr": "Motif grandissant: Le T",
    "de": "Wachsende Muster: Das T",
    "pt": "Padrão crescente: O T"
  },
  "mtic_g78_m2_grand_stair_pt2": {
    "en": "Growing Pattern: The Square",
    "fr": "Motif grandissant: Le carré",
    "de": "Wachsende Muster: Das Quadrat",
    "pt": "Padrão crescente: O quadrado"
  },
  "mtic_g78_m2_grand_stair_pt3": {
    "en": "Growing Pattern: The Staircase",
    "fr": "Motif grandissant: L'escalier",
    "de": "Wachsende Muster: Die Treppe",
    "pt": "Padrão crescente: As escadas"
  },
  "mtic_g78_m2_prog_calc_b1": {
    "en": "Calculation Programs (pt. 1)",
    "fr": "Programmes de calculs (pt. 1)",
    "de": "Rechenprogramme (pt. 1)",
    "pt": "Programas de cálculos (pt. 1)"
  },
  "mtic_g78_m2_prog_calc_b2": {
    "en": "Calculation Programs (pt. 2)",
    "fr": "Programmes de calculs (pt. 2)",
    "de": "Rechenprogramme (pt. 2)",
    "pt": "Programas de cálculos (pt. 2)"
  },
  "mtic_g78_m2_prog_calc_b3": {
    "en": "Calculation Programs (pt. 3)",
    "fr": "Programmes de calculs (pt. 3)",
    "de": "Rechenprogramme (pt. 3)",
    "pt": "Programas de cálculos (pt. 3)"
  },
  "mtic_g78_m2_corre_area": {
    "en": "Algebra in Areas",
    "fr": "Algèbre avec des aires",
    "de": "Algebra mit Flächeninhalten",
    "pt": "Álgebra com áreas"
  },
  "mtic_g78_m2_fibonacci": {
    "en": "Fibonacci's Game",
    "fr": "Le jeu de Fibonacci",
    "de": "Das Fibonacci-Spiel",
    "pt": "O jogo de Fibonacci"
  },
  "mtic_g78_m2_factoring_group": {
    "en": "Factoring",
    "fr": "Factorisation",
    "de": "Factorisation",
    "pt": "Factorisation"
  },

  "mtic_g78_m2_sum": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m2_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m2_diag_inbook": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m1_prop_coef": {
    "en": "Proportionality Coefficient",
    "fr": "Coefficient de proportionnalité",
    "pt": "Constante de proporcionalidade",
    "de": "Proportionalitätsfaktor"
  },
  "mtic_g78_m1_analyze_graph": {
    "en": "Is it Proportional? - Graphs",
    "fr": "Proportionnel ou non proportionnel? - Graphes",
    "pt": "Proporcional ou não proporcional? - Gráficos",
    "de": "Proportional oder nicht? - Graphen"
  },
  "mtic_g78_m1_thunder_lightning": {
    "en": "Thunder and Lightning",
    "fr": "Foudre et tonnerre",
    "pt": "Trovoadas e relâmpagos",
    "de": "Blitz und Donner"
  },
  "mtic_g78_m1_candy": {
    "en": "Candy",
    "fr": "Les friandises",
    "pt": "Guloseimas",
    "de": "Die Süßigkeiten"
  },
  "mtic_g78_m1_path": {
    "en": "Morning Walk",
    "fr": "Promenade matinale",
    "pt": "Passeio matinal",
    "de": "Morgendlicher Spaziergang"
  },
  "mtic_g78_m1_graph_form": {
    "en": "Proportionality Graphs",
    "fr": "Représentation graphique",
    "pt": "Gráfico de proporcionalidade direta",
    "de": "Graph einer proportionalen Zuordnung"
  },
  "mtic_g78_m1_look_prop": {
    "en": "It May Only Look Proportional",
    "fr": "Semble être ou non proportionnel",
    "pt": "Parece proporcional mas não é?",
    "de": "Scheinbar proportional"
  },
  "mtic_g78_m1_speed_sound": {
    "en": "Speed of Sound",
    "fr": "La vitesse du son",
    "pt": "A velocidade do som",
    "de": "Schallgeschwindigkeit"
  },
  "mtic_g78_m1_robot": {
    "en": "The Robot",
    "fr": "Le robot",
    "pt": "O robot",
    "de": "Der Roboter"
  },
  "mtic_g78_m1_open": {
    "en": "Make a Video - Proportionality",
    "fr": "Faire une vidéo - Proportionnalité",
    "pt": "Fazer um vídeo - Proporcionalidade",
    "de": "Mache ein Video - Proportionalität"
  },
  "mtic_g78_m1_beaker": {
    "en": "The faucet",
    "fr": "Le robinet",
    "pt": "A torneira",
    "de": "Der Wasserhahn"
  },
  "mtic_g78_m1_prop_table_a": {
    "en": "The Proportionality Table",
    "fr": "Le tableau de proportionnalité",
    "pt": "Tabela de proporcionalidade direta",
    "de": "Die Proportionalitätstabelle"
  },
  "mtic_g78_m1_analyze_coef": {
    "en": "Is it Proportional? - Coefficient",
    "fr": "Proportionnel ou non proportionnel? - Coefficient",
    "pt": "Proporcional ou não proporcional? - Constante",
    "de": "Proportional oder nicht? - Quotientengleichheit"
  },
  "mtic_g78_m1_rule_three": {
    "en": "Rule of 3",
    "fr": "Règle de 3",
    "pt": "Regra de três simples",
    "de": "Dreisatz"
  },
  "mtic_g78_m1_dist_storm": {
    "en": "How Far is the Storm?",
    "fr": "À quelle distance se trouve la tempête ?",
    "pt": "A que distância está a tempestade?",
    "de": "Wie weit ist das Gewitter weg?"
  },
  "mtic_g78_m1_juice": {
    "en": "Apple Juice",
    "fr": "Jus de pommes",
    "pt": "Sumo de maçã",
    "de": "Apfelsaft"
  },
  "mtic_g78_m1_summ": {
    "en": "Summative",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "mtic_g78_m1_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m1_additivity": {
    "en": "Additivity",
    "fr": "Additivité",
    "de": "Additivität",
    "pt": "Aditividade"
  },
  "mtic_g78_m1_analyze_add_line": {
    "en": "Is it Proportional? - Additivity ",
    "fr": "Proportionnel ou non proportionnel? - Additivité",
    "pt": "Proporcional ou não proporcional? - Aditiva",
    "de": "Proportional oder nicht? - Additivität"
  },
  "mtic_g78_m1_prop_table_b": {
    "en": "Proportionality Table Practice",
    "fr": "Tableau de proportionnalité - s'entraîner",
    "pt": "Tabela de proporcionalidade direta - Praticar",
    "de": "Übung zu Proportionalitätstabellen"
  },
  "mtic_g78_m1_conv_speed": {
    "en": "Converting Speeds Part 1",
    "fr": "Convertir des unités de vitesses 1",
    "pt": "Converter velocidades 1",
    "de": "Geschwindigkeiten umwandeln Teil 1"
  },
  "mtic_g78_m1_crepes": {
    "en": "Crêpes",
    "fr": "Crêpes",
    "pt": "Crepes",
    "de": "Pfannkuchen"
  },
  "mtic_g78_m1_linearity": {
    "en": "Linearity",
    "fr": "Linéarité",
    "pt": "Linearidade",
    "de": "Linearität"
  },
  "mtic_g78_m1_analyze_linear": {
    "en": "Is it Proportional? - Linearity",
    "fr": "Proportionnel ou non proportionnel? - Linéarité",
    "pt": "Proporcional ou não proporcional? - Linearidade",
    "de": "Proportional oder nicht? - Linearität"
  },
  "mtic_g78_m1_recipe": {
    "en": "Cafeteria Inventory",
    "fr": "L'inventaire à la cafétéria",
    "pt": "O inventário da cafetaria",
    "de": "Vorrat der Cafeteria"
  },
  "mtic_g78_m1_flooring": {
    "en": "Renovation Estimates",
    "fr": "Les devis",
    "pt": "Fazer o orçamento",
    "de": "Die Kostenanschläge"
  },
  "mtic_g78_m1_meeting": {
    "en": "Theme Park",
    "fr": "Au parc d'attraction",
    "pt": "No parque",
    "de": "Im Vergnügungspark"
  },
  "mtic_g78_m1_conv_speed_2": {
    "en": "Converting Speeds Part 2",
    "fr": "Convertir des unités de vitesses 2",
    "pt": "Converter velocidades 2",
    "de": "Geschwindigkeiten umwandeln Teil 2"
  },
  "mtic_g78_m1_recipe_part_2": {
    "en": "Cafeteria Inventory Challenge",
    "fr": "L'inventaire à la cafétéria - le défi",
    "pt": "O inventário da cafetaria - desafio",
    "de": "Cafeteria Vorrat Herausforderung"
  },
  "mtic_g78_m3_game_sub_pt1": {
    "en": "Balance Game (Part 1)",
    "fr": "Jeu de la balance",
    "de": "Gleichgewichtsspiel (Teil 1)",
    "pt": "Jogo da balança (Parte 1)"
  },
  "mtic_g78_m3_game_sub_pt2": {
    "en": "Balance Game (Part 2)",
    "fr": "Jeu de la balance Partie 2",
    "de": "Gleichgewichtsspiel (Teil 2)",
    "pt": "Jogo da balança (Parte 2)"
  },
  "mtic_g78_m3_alg_balance": {
    "en": "From Balances to Equations",
    "fr": "Balance et équations",
    "de": "Gleichgewicht und Gleichungen",
    "pt": "Balança e equações"
  },
  "mtic_g78_m3_class_eq": {
    "en": "Classifying Equations",
    "fr": "Classement des équations",
    "de": "Klassifizierung von Gleichungen",
    "pt": "Classificação de equações"
  },
  "mtic_g78_m3_inver_oper": {
    "en": "Inverse Operations (Part 1)",
    "fr": "Opérations inverses",
    "de": "Umkehroperationen (Teil 1)",
    "pt": "Operações inversas (Parte 1)"
  },
  "mtic_g78_m3_inver_oper_pt2": {
    "en": "Inverse Operations (Part 2)",
    "fr": "Opérations inverses Partie 2",
    "de": "Umkehroperationen (Teil 2)",
    "pt": "Operações inversas (Parte 2)"
  },
  "mtic_g78_m3_sub_method": {
    "en": "Solving by Substituting",
    "fr": "Résolution par substitution",
    "de": "Lösen durch Substitution",
    "pt": "Resolução por substituição"
  },
  "mtic_g78_m3_bracket_wo": {
    "en": "Solving Equations Without Brackets (Part 1)",
    "fr": "Résolution des équations sans parenthèses Partie 1",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 1)",
    "pt": "Resolução de equações sem parêntesis (Parte 1)"
  },
  "mtic_g78_m3_bracket_wo_pt2": {
    "en": "Solving Equations Without Brackets (Part 2)",
    "fr": "Résolution des équations sans parenthèses Partie 2",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 2)",
    "pt": "Resolução de equações sem parêntesis (Parte 2)"
  },
  "mtic_g78_m3_bracket_incl": {
    "en": "Solving Equations With Brackets",
    "fr": "Résolution des équations avec parenthèses",
    "de": "Lösen von Gleichungen mit Klammern",
    "pt": "Resolução de equações sem parêntesis (Parte 3)"
  },
  "mtic_g78_m3_geo_perim": {
    "en": "Equations from Diagrams (Part 1)",
    "fr": "Équations et représentations graphiques Partie 1",
    "de": "Gleichungen und graphische Darstellungen (Teil 1)",
    "pt": "Equações e representações gráficas (Parte 1)"
  },
  "mtic_g78_m3_geo_area": {
    "en": "Equations from Diagrams (Part 2)",
    "fr": "Équations et représentations graphiques Partie 2",
    "de": "Gleichungen und graphische Darstellungen (Teil 2)",
    "pt": "Equações e representações gráficas (Parte 2)"
  },
  "mtic_g78_m3_word_prob": {
    "en": "Equations from Text (Part 1)",
    "fr": "Résoudre des problèmes à l'aide d'équations\nPartie 1",
    "de": "Probleme mit Hilfe von Gleichungen lösen\n(Teil 1)",
    "pt": "Resolução de problemas com ajuda de equações 1"
  },
  "mtic_g78_m3_word_prob_pt2": {
    "en": "Equations from Text (Part 2)",
    "fr": "Résoudre des problèmes à l'aide d'équations\nPartie 2",
    "de": "Probleme mit Hilfe von Gleichungen lösen\n(Teil 2)",
    "pt": "Resolução de problemas com ajuda de equações 2"
  },
  "mtic_g78_m3_impos_eq": {
    "en": "Indeterminate Equations",
    "fr": "Équations indéterminées",
    "de": "Unbestimmte Gleichungen",
    "pt": "Equações indeterminadas"
  },
  "mtic_g78_m3_impos_eq_pt2": {
    "en": "Impossible Equations",
    "fr": "Équations impossibles",
    "de": "Unmögliche Gleichungen",
    "pt": "Equações impossíveis"
  },
  "mtic_g78_m3_represent_eq": {
    "en": "Representations of Equations",
    "fr": "Représentations des équations",
    "de": "Darstellungen von Gleichungen",
    "pt": "Representação de equações"
  },
  "mtic_g78_m3_alice_bob": {
    "en": "Alice & Bob",
    "fr": "Alice & Bob",
    "de": "Alice e Bob",
    "pt": "Alice e Bob"
  },
  "mtic_g78_m3_equal_area": {
    "en": "Equal Areas",
    "fr": "Aires égales",
    "de": "Gleiche Flächeninhalte",
    "pt": "Áreas iguais"
  },
  "mtic_g78_m3_receipt": {
    "en": "Receipt",
    "fr": "Facture",
    "de": "Rechnung",
    "pt": "Fatura"
  },
  "mtic_g78_m3_graph_area": {
    "en": "Graphing Areas",
    "fr": "Aires et graphiques",
    "de": "Graphische Darstellung von Flächeninhalten",
    "pt": "Áreas e gráficos"
  },
  "mtic_g78_m3_graph_perim": {
    "en": "Area Versus Perimeter",
    "fr": "Aire versus périmètre",
    "de": "Flächeninhalt versus Umfang",
    "pt": "Área versus perímetro"
  },
  "mtic_g78_m3_open": {
    "en": "Make a Video - Equations",
    "fr": "Faire une vidéo - équations",
    "de": "Ein Video drehen- Gleichungen",
    "pt": "Fazer um vídeo - equações"
  },
  "Strategies": {
    "en": "Strategies",
    "fr": "Stratégies",
    "de": "Strategien",
    "pt": "Estratégias"
  },
  "Problems": {
    "en": "Problems",
    "fr": "Problèmes",
    "de": "Problèmes",
    "pt": "Problemas"
  },
  "Speed": {
    "en": "Speed",
    "fr": "La vitesse",
    "de": "La vitesse",
    "pt": "Velocidade"
  },
  "Is it proportional?": {
    "en": "Is it proportional?",
    "fr": "Est-ce proportionnel ?",
    "de": "Est-ce proportionnel ?",
    "pt": "Est-ce proportionnel ?"
  },
  "Thinking about equality": {
    "en": "Thinking about equality",
    "fr": "Notion d'égalité",
    "de": "Der Begriff der Gleichheit",
    "pt": "Pensar em equações"
  },
  "Solving Strategies": {
    "en": "Solving Strategies",
    "fr": "Résolution des équations",
    "de": "Lösen von Gleichungen",
    "pt": "Estratégias para resolver equações"
  },
  "Building Equations": {
    "en": "Building Equations",
    "fr": "Équations et représentations",
    "de": "Gleichungen und deren Darstellung",
    "pt": "Construindo equações"
  },
  "Special Equations": {
    "en": "Special Equations",
    "fr": "Cas particuliers",
    "de": "Sonderfälle",
    "pt": "Equações especiais"
  },
  "Equations and Graphs": {
    "en": "Equations and Graphs",
    "fr": "Equations et Graphiques",
    "de": "Equations et Graphiques",
    "pt": "Equations et Graphiques"
  },
  "mtic_gr78_c4_m1": {
    "en": "Review of Area & Perimeter",
    "fr": "Révision: Aire et périmètre",
    "de": "Révision: Aire et périmètre",
    "pt": "Révision: Aire et périmètre"
  },
  "mtic_gr78_c4_m6": {
    "en": "Review of Spaces and shapes",
    "fr": "Révision: Espaces et formes",
    "de": "Révision: Espaces et formes",
    "pt": "Révision: Espaces et formes"
  },

  "c4_m2_diagnostic": {
    "en": "Diagnostic (Natural Numbers)",
    "fr": "Test diagnostique (nombres naturels)",
    "de": "Anfangstest (Natürliche Zahlen)",
    "pt": "Teste diagnóstico (Números naturais)"
  },
  "c4_m2_summative": {
    "en": "Summative Test (Natural Numbers)",
    "fr": "Test bilan (nombres naturels)",
    "de": "Abschlusstest (Natürliche Zahlen)",
    "pt": "Teste sumativo (Números naturais)"
  },
  "c4_m2_formative_1": {
    "en": "Multiplication and Division",
    "fr": "Multiplication et division",
    "de": "Multiplikation und Division",
    "pt": "Multiplication et division"
  },
  "c4_m2_formative_2": {
    "en": "Applying Arithmetic Properties",
    "fr": "Multiplication (calcul astucieux)",
    "de": "Multiplikation (geschickt rechnen)",
    "pt": "Multiplication (calcul astucieux)"
  },
  "c4_m2_formative_3": {
    "en": "Addition and Subtraction",
    "fr": "Additions et soustractions (calcul astucieux)",
    "de": "Addition und Subtraktion (geschickt rechnen)",
    "pt": "Additions et soustractions (calcul astucieux)"
  },
  "c4_m2_a_1_1_com_mul_exp": {
    "en": "Commutativity of multiplication",
    "fr": "Commutativité de la multiplication",
    "de": "Kommutativgesetz bei der Multiplikation",
    "pt": "Comutatividade da multiplicação"
  },
  "c4_m2_a_1_2_com_add_exp": {
    "en": "Commutativity of addition",
    "fr": "Commutativité de l'addition",
    "de": "Kommutativgesetz bei der Addition.",
    "pt": "Comutatividade da adição"
  },
  "c4_m2_a_1_3_ass_exp": {
    "en": "Associativity",
    "fr": "Associativité",
    "de": "Assoziativgesetz",
    "pt": "Associatividade"
  },
  "c4_m2_a_1_4_dis_exp": {
    "en": "Distributivity",
    "fr": "Distributivité",
    "de": "Distributivgesetz",
    "pt": "Distributividade"
  },
  "c4_m2_a_2_1_div_2_exp": {
    "en": "Divisibility by 2",
    "fr": "Divisibilité par 2",
    "de": "Teilbarkeit durch 2",
    "pt": "Divisibilidade por 2"
  },
  "c4_m2_a_2_2_div_5_exp": {
    "en": "Divisibility by 5",
    "fr": "Divisibilité par 5",
    "de": "Teilbarkeit durch 5",
    "pt": "Divisibilidade por 5"
  },
  "c4_m2_a_2_3_div_10_exp": {
    "en": "Divisibility by 10",
    "fr": "Divisibilité par 10",
    "de": "Teilbarkeit durch 10",
    "pt": "Divisibilidade por 10"
  },
  "c4_m2_a_2_4_div_4_exp": {
    "en": "Divisibility by 4",
    "fr": "Divisibilité par 4",
    "de": "Teilbarkeit durch 4",
    "pt": "Divisibilidade por 4"
  },
  "c4_m2_a_2_5_div_3_exp": {
    "en": "Divisibility by 3",
    "fr": "Divisibilité par 3",
    "de": "Teilbarkeit durch 3",
    "pt": "Divisibilidade por 3"
  },
  "c4_m2_b_1_1_add_sou_dec": {
    "en": "Decomposed addition",
    "fr": "Décomposition de l'addition",
    "de": "Schrittweise Addition",
    "pt": "Decomposição da Adição"
  },
  "c4_m2_b_1_2_add_sou_dec": {
    "en": "Decomposed subtraction",
    "fr": "Soustraction décomposée",
    "de": "Schrittweise Subtraktion",
    "pt": "Decomposição da Subtração"
  },
  "c4_m2_b_2_1_cou_mul_tre": {
    "en": "Counting elements of a set",
    "fr": "Déterminer les éléments d'un ensemble",
    "de": "Mengen bestimmen",
    "pt": "Contagem de conjuntos"
  },
  "c4_m2_b_3_1_fac_cre_pro": {
    "en": "Write the number as a product (Part 2)",
    "fr": "Ecrire un nombre sous la forme d'un produit (Partie 2)",
    "de": "Eine Zahl als Produkt schreiben (Teil 2)",
    "pt": "Escrever um número como produto de dois fatores (Parte 2)"
  },
  "c4_m2_b_3_2_fac_cre_res": {
    "en": "Write a number as a product (Part 1)",
    "fr": "Ecrire un nombre sous la forme d'un produit (Partie 1)",
    "de": "Eine Zahl als Produkt schreiben (Teil 1)",
    "pt": "Escrever um número como produto de dois fatores (Parte 1)"
  },
  "c4_m2_b_3_3_com_mul": {
    "en": "Find common multiples",
    "fr": "Identifier des multiples communs",
    "de": "Gemeinsame Vielfache finden",
    "pt": "Reconhecer múltiplos comuns"
  },
  "c4_m2_b_4_1_rou_num": {
    "en": "Rounding",
    "fr": "Arrondir",
    "de": "Runden",
    "pt": "Arredondamento"
  },
  "c4_m2_b_5_1_est_lor_de_gra_de_res_ave_ass": {
    "en": "Estimate the results (addition and subtraction)",
    "fr": "Estimer les résultats (additions et soustrations)",
    "de": "Ergebnisse überschlagen (Addition und Subtraktion)",
    "pt": "Estimativa de resultados (adição e subtração)"
  },
  "c4_m2_b_5_2_est_lor_de_gra_de_res_ave_ass": {
    "en": "Estimate the results",
    "fr": "Estimer les résultats",
    "de": "Ergebnisse überschlagen",
    "pt": "Estimativa de resultados"
  },
  "c4_m2_b_5_3_con_the_pat_v2": {
    "en": "Continue the pattern",
    "fr": "Compléter des séries",
    "de": "Zahlenfolgen fortführen",
    "pt": "Continuar a sequência"
  },
  "c4_m2_b_6_1_mul_div_cal_rel": {
    "en": "Related computations (multiplication)",
    "fr": "Calcul relié (multiplication)",
    "de": "Analoges Rechnen (Multiplikation)",
    "pt": "Cálculos análogos (multiplição)"
  },
  "c4_m2_b_6_2_mul_div_cal_rel": {
    "en": "Related computations (division)",
    "fr": "Calcul relié (division)",
    "de": "Analoges Rechnen (Division)",
    "pt": "Cálculos análogos (divisão)"
  },
  "c4_m2_b_6_3_mul_add_dis": {
    "en": "Distributivity - Exercise",
    "fr": "Distributivité - Exercice",
    "de": "Distributivgesetz - Übung",
    "pt": "Distributividade - Exercício"
  },
  "c4_m2_b_6_4_mul_dec": {
    "en": "Decomposed multiplication",
    "fr": "Décomposition de la multiplication",
    "de": "Schrittweise Multiplikation",
    "pt": "Decomposição da Multiplição"
  },
  "c4_m2_c_3_0_lag_cod_3_0": {
    "en": "Robocode's planet - Introduction",
    "fr": "Planète de RoboCODE - Introduction",
    "de": "RoboCODEs Planet - Einführung",
    "pt": "Planeta do RoboCODE - Introdução"
  },
  "c4_m2_c_3_1_lag_cod_3_1_v2": {
    "en": "RoboCODE’s planet - Complete the code",
    "fr": "Planète de RoboCODE - Complète le code",
    "de": "RoboCODEs Planet - Vervollständige den Code",
    "pt": "Planeta do RoboCODE - Completar o código"
  },
  "c4_m2_c_3_2_lag_cod_3_2_v2": {
    "en": "RoboCODE’s planet - Correct the code",
    "fr": "Planète de RoboCODE - Corrige le code",
    "de": "RoboCODEs Planet - Korrigiere den Code",
    "pt": "Planeta do RoboCODE - Corrigir o código"
  },
  "c4_m2_c_3_3_lag_cod_3_3_v2": {
    "en": "RoboCODE’s planet - Validate the code",
    "fr": "Planète de RoboCODE - Valide le code",
    "de": "RoboCODEs Planet - Bestätige den Code",
    "pt": "Planeta do RoboCODE - Validar o código"
  },
  "c4_m2_c_4_0_lag_cod_4_0": {
    "en": "RoboCODE on Earth - Introduction",
    "fr": "RoboCODE sur la Terre - Introduction",
    "de": "RoboCODE auf der Erde - Einführung",
    "pt": "RoboCODE na Terra - Introdução"
  },
  "c4_m2_c_4_1_lag_cod_4_1": {
    "en": "RoboCODE on Earth - Find the origin",
    "fr": "RoboCODE sur la Terre - Trouve le pays d'origine",
    "de": "RoboCODE auf der Erde - Finde das Herkunftsland",
    "pt": "RoboCODE na Terra - Encontrar a origem"
  },
  "c4_m2_c_4_2_lag_cod_4_2_v2": {
    "en": "RoboCODE on Earth - Find the error",
    "fr": "RoboCODE sur la Terre - Trouve l'erreur",
    "de": "RoboCODE auf der Erde - Finde den Fehler",
    "pt": "RoboCODE na Terra - Encontrar a erro"
  },
  "c4_m2_c_4_3_lag_cod_4_3_v2": {
    "en": "RoboCODE on Earth - Complete the code (Part 1)",
    "fr": "RoboCODE sur la Terre - Complète le code (Partie 1)",
    "de": "RoboCODE auf der Erde - Vervollständige den Code (Teil 1)",
    "pt": "RoboCODE na Terra - Completar o código (Parte 1)"
  },
  "c4_m2_c_4_4_lag_cod_4_4_v2": {
    "en": "RoboCODE on Earth - Complete the code (Part 2)",
    "fr": "RoboCODE sur la Terre - Complète le code (Partie 2)",
    "de": "RoboCODE auf der Erde - Vervollständige den Code (Teil 2)",
    "pt": "RoboCODE na Terra - Completar o código (Parte 2)"
  },
  "c4_m2_a_arith_tut": {
    "en": "Special Calculator Tool (Tutorial)",
    "fr": "La calculatrice spéciale (Tutoriel)",
    "de": "Der besondere Taschenrechner (Einführung)",
    "pt": "Tutorial da ferramenta Calculadora"
  },

  "c4_m1_diagnostic": {
    "en": "Diagnostic (Area and Perimeter)",
    "fr": "Test diagnostique (aire et périmètre)",
    "de": "Anfangstest (Flächeninhalt und Umfang)",
    "pt": "Teste diagnóstico (área e perímetro)"
  },
  "c4_m1_summative": {
    "en": "Summative Test (Area and Perimeter)",
    "fr": "Test bilan (aire et périmètre)",
    "de": "Abschlusstest (Flächeninhalt und Umfang)",
    "pt": "Teste sumativo (área e perímetro)"
  },
  "c4_m1_formative_1": {
    "en": "Understanding Area",
    "fr": "Aire et périmètre",
    "de": "Flächeninhalt und Umfang",
    "pt": "Aire et périmètre"
  },
  "c4_m1_formative_2": {
    "en": "Area Calculations",
    "fr": "Aire 2",
    "de": "Flächeninhalt 2",
    "pt": "Aire 2"
  },
  "c4_m1_formative_3": {
    "en": "Perimeter",
    "fr": "Périmètre",
    "de": "Umfang",
    "pt": "Perímetro"
  },
  "c4_m1_formative_4": {
    "en": "Area of Right-Angled Polygons",
    "fr": "Aire 1",
    "de": "Flächeninhalt 1",
    "pt": "Aire 1"
  },
  "c4_m1_a_1_1_per_int_exp": {
    "en": "Introduction to Perimeter",
    "fr": "Introduction à la notion de périmètre",
    "de": "Einführung in den Umfang",
    "pt": "Introdução ao perímetro"
  },
  "c4_m1_a_1_2_per_sum_of_sid_exp": {
    "en": "Perimeter of Polygons",
    "fr": "Périmètre de polygones",
    "de": "Umfang von Vielecken",
    "pt": "Perímetro de polígonos"
  },
  "c4_m1_a_1_4_per_rec_squ_exp": {
    "en": "Perimeter of Rectangles (and Squares)",
    "fr": "Périmètre des rectangles (et carrés)",
    "de": "Umfang eines Rechtecks",
    "pt": "Perímetro de um retângulo"
  },
  "c4_m1_a_2_1_are_int_exp": {
    "en": "Introduction to Area",
    "fr": "Introduction aux aires",
    "de": "Einführung in den Flächeninhalt",
    "pt": "Introdução às áreas"
  },
  "c4_m1_a_2_2_are_rec_exp": {
    "en": "Area of Rectangles (and Squares)",
    "fr": "L'aire des rectangles (et carrés)",
    "de": "Flächeninhalt von Rechtecken (und Quadraten)",
    "pt": "Área de rectângulos (e quadrados)"
  },
  "c4_m1_a_2_3_are_par_exp": {
    "en": "Area of Parallelograms",
    "fr": "L'aire du parallélogramme",
    "de": "Flächeninhalt von Parallelogrammen",
    "pt": "Área de paralelogramos"
  },
  "c4_m1_a_2_4_are_tri_exp": {
    "en": "Area of Triangles",
    "fr": "L'aire du triangle",
    "de": "Flächeninhalt von Dreiecken",
    "pt": "Área de triângulos"
  },
  "c4_m1_b_1_1_per_rec_squ": {
    "en": "Perimeter of Rectangles",
    "fr": "Périmètre de rectangles",
    "de": "Umfang eines Rechtecks",
    "pt": "Perímetro de retângulos"
  },
  "c4_m1_b_1_2_per_non_pol": {
    "en": "Perimeter of Polygons",
    "fr": "Périmètre des polygones",
    "de": "Umfang von Vielecken",
    "pt": "Perímetro de polígonos"
  },
  "c4_m1_b_1_3_per_rig_pol": {
    "en": "Perimeter of Right-Angled Polygons",
    "fr": "Périmètre des polygones à angle droit",
    "de": "Umfang von rechtwinkligen Vielecken",
    "pt": "Perímetro de polígonos retangulares)"
  },
  "c4_m1_b_1_4_per_rig_pol_res": {
    "en": "Perimeter of Right-Angled Polygons (Part 2)",
    "fr": "Périmètre des polygones à angle droit (Partie 2)",
    "de": "Umfang von rechtwinkligen Vielecken (Teil 2)",
    "pt": "Perímetro de polígonos retangulares (Parte 2)"
  },
  "c4_m1_b_2_1_are_rec_squ": {
    "en": "Area of Rectangles",
    "fr": "Aire d´un rectangle",
    "de": "Flächeninhalt eines Rechtecks",
    "pt": "Área de retângulos"
  },
  "c4_m1_b_2_2_are_rig_pol": {
    "en": "Area of Right-Angled Polygons (Part 1)",
    "fr": "L'aire des polygones à angle droit (Partie 1)",
    "de": "Flächeninhalt von rechtwinkligen Vielecken (Teil 1)",
    "pt": "Área de polígonos retangulares (Parte 1)"
  },
  "c4_m1_b_2_3_are_non_pol": {
    "en": "Area of Non-Right-Angled Polygons",
    "fr": "L'aire des polygones quelconques",
    "de": "Flächeninhalt von nicht-rechtwinkligen Vielecken",
    "pt": "Área de polígonos não-retangulares"
  },
  "c4_m1_b_2_4_are_rig_pol_res": {
    "en": "Area of Right-Angled Polygons (Part 2)",
    "fr": "L'aire des polygones à angle droit (Partie 2)",
    "de": "Flächeninhalt von rechtwinkligen Vielecken (Teil 2)",
    "pt": "Superfícies de polígonos retangulares (Parte 2)"
  },
  "c4_m1_b_2_5_are_non_pol_res": {
    "en": "Area of polygons",
    "fr": "L'aire des polygones",
    "de": "Flächeninhalt von Vielecken",
    "pt": "Área de polígonos"
  },
  "c4_m1_b_2_6_are_pol_peg": {
    "en": "Area of polygons : pegboard",
    "fr": "L'aire des polygones : géoplan",
    "de": "Flächeninhalt von Vielecken: Geobrett",
    "pt": "Área de polígonos: Geoplano"
  },
  "c4_m1_b_3_1_are_com": {
    "en": "Comparing Areas",
    "fr": "Comparer les aires",
    "de": "Flächen vergleichen",
    "pt": "Comparar áreas"
  },
  "c4_m1_b_3_2_are_com_tan": {
    "en": "Comparing Areas: tangrams",
    "fr": "Comparer les aires: tangram",
    "de": "Flächen vergleichen: Tangram",
    "pt": "Comparar áreas: tangram"
  },
  "c4_m1_b_4_1_ope": {
    "en": "Perimeter Construction",
    "fr": "Construction de polygones d'un certain périmètre",
    "de": "Übungen zum Umfang",
    "pt": "Exercícios com perímetros"
  },
  "c4_m1_b_4_2_ope": {
    "en": "Area Construction",
    "fr": "Construire des polygones d'une certaine aire",
    "de": "Flächeninhalt - Übungen",
    "pt": "Exercícios com áreas"
  },
  "c4_m1_c_1_1_ope": {
    "en": "Lake",
    "fr": "Lac",
    "de": "See",
    "pt": "Lago"
  },
  "c4_m1_c_2_1_are_roo_sce": {
    "en": "Room Remodelling",
    "fr": "Constructions de chambres",
    "de": "Umbau der Zimmer",
    "pt": "Remodelação de quartos"
  },
  "c4_m1_c_3_1_mea_gua_dog": {
    "en": "Guard Dog",
    "fr": "Chien de garde",
    "de": "Der Wachhund",
    "pt": "Cão de guarda"
  },

  "c4_m3_group__viz_frac": {
    "en": "Visualizing Fractions",
    "fr": "Représentation des fractions",
    "de": "Brüche veranschaulichen",
    "pt": "Visualizar Frações"
  },

  "c4_m3_group__frac_num_line": {
    "en": "Fractions on the Number Line",
    "fr": "Fraction sur la demi-droite graduée",
    "de": "Brüche auf dem Zahlenstrahl",
    "pt": "Frações na Reta Numérica"
  },

  "c4_m3_group__equiv_frac_comp": {
    "en": "Equivalent Fractions and Comparisons",
    "fr": "Fractions équivalentes",
    "de": "Gleichwertige Brüche und Vergleiche",
    "pt": "Frações Equivalentes e Comparações "
  },

  "c4_m3_group__op_frac": {
    "en": "Operations with Fractions",
    "fr": "Calculs avec les fractions",
    "de": "Bruchrechnung",
    "pt": "Operações com Frações"
  },

  "c4_m4_group__intro_dec_num": {
    "en": "Introduction to Decimal Numbers",
    "fr": "Introduction aux nombres décimaux",
    "de": "Einführung Dezimalzahlen",
    "pt": "Introdução aos números decimais"
  },

  "c4_m4_group__add_sub": {
    "en": "Addition and Subtraction",
    "fr": "Addition et soustraction",
    "de": "Addition und Subtraktion",
    "pt": "Adição e Subtração"
  },

  "c4_m4_group__mult_div": {
    "en": "Multiplication and Division",
    "fr": "Multiplication et division",
    "de": "Multiplikation und Division",
    "pt": "Multiplicação e divisão"
  },

  "c4_m4_group__convert_dec_frac": {
    "en": "Converting between Decimals and Fractions",
    "fr": "Conversion entre l’écriture décimale et l’écriture fractionnaire",
    "de": "Umwandlung zwischen Dezimalzahlen und Brüchen",
    "pt": "Conversão entre números racionais e dízimas"
  },

  "c4_m4_group__unit_meas": {
    "en": "Units of Measurement",
    "fr": "Unités de mesure",
    "de": "Maßeinheiten",
    "pt": "Unidades de medida"
  },

  "c4_m4_group__prob_solv": {
    "en": "Problem Solving",
    "fr": "Résolution de problème",
    "de": "Sachaufgaben",
    "pt": "Resolução de problemas"
  },

  "c4_m6_group__solids": {
    "en": "Solids",
    "fr": "Solides",
    "de": "Körper",
    "pt": "Sólidos"
  },

  "c4_m6_group__surf_sol": {
    "en": "Surfaces of Solids",
    "fr": "Aire totale de solides",
    "de": "Flächeninhalt von Körpern",
    "pt": "Áreas de superfícies"
  },

  "c4_m6_group__angles": {
    "en": "Angles",
    "fr": "Angles",
    "de": "Winkel",
    "pt": "Ângulos"
  },

  "c4_m6_group__trans_refl": {
    "en": "Translations, Axial Reflections, and Radial Reflections",
    "fr": "Translations, symétries et rotations",
    "de": "Verschiebungen, Achsensymmetrie, Punktsymmetrie",
    "pt": "Translações, reflexões axiais e reflexões por rotação"
  },

  "c4_m6_group__convert_length": {
    "en": "Converting Length",
    "fr": "Conversion d’unités de longueurs",
    "de": "Längen umwandeln",
    "pt": "Conversão de comprimentos"
  },

  "c4_m6_group__convert_area": {
    "en": "Converting Area",
    "fr": "Conversion d'unités d’aires",
    "de": "Flächen umwandeln",
    "pt": "Conversão de áreas"
  },

  "c4_m6_group__convert_vol": {
    "en": "Converting Volume",
    "fr": "Conversion d’unités de volumes",
    "de": "Volumen umwandeln",
    "pt": "Conversão de volumes"
  },

  "c4_m5_group__cart_grid": {
    "en": "The Cartesian Grid",
    "fr": "Plan cartésien",
    "de": "Koordinatensystem",
    "pt": "O referencial cartesiano"
  },

  "c4_m5_group__graph_tables": {
    "en": "Graphs and Tables",
    "fr": "Graphes et tableaux",
    "de": "Grafiken und Tabellen",
    "pt": "Gráficos e Tabelas"
  },

  "c4_m5_group__data_extr": {
    "en": "Data Extraction",
    "fr": "Lecture de données",
    "de": "Daten lesen",
    "pt": "Ler dados"
  },

  "c4_m5_group__perc": {
    "en": "Percentages",
    "fr": "Pourcentages",
    "de": "Prozentrechnung",
    "pt": "Percentagens"
  },

  "c4_m5_group__patt_algo": {
    "en": "Patterns and Algorithms",
    "fr": "Programmes et algorithmes",
    "de": "Muster und Rechenregeln",
    "pt": "Padrões e Algoritmos"
  },

  "c4_m1_group__peri": {
    "en": "Perimeter",
    "fr": "Périmètre",
    "de": "Umfang",
    "pt": "Perímetro"
  },

  "c4_m1_group__area": {
    "en": "Area",
    "fr": "Aire",
    "de": "Flächeninhalt",
    "pt": "Área"
  },

  "c4_m1_group__prob": {
    "en": "Problem Solving",
    "fr": "Résolution de problème",
    "de": "Problem lösen",
    "pt": "Resolução de problemas"
  },

  "c4_m2_group__comm_asso_dist": {
    "en": "Commutativity, Associativity, Distributivity",
    "fr": "Commutativité, associativité, distributivité",
    "de": "Kommutativität, Assoziativität, Distributivität",
    "pt": "Comutatividade, Associatividade, Distributividade"
  },

  "c4_m2_group__divis": {
    "en": "Divisibility",
    "fr": "Divisibilité",
    "de": "Teilbarkeit",
    "pt": "Divisibilidade"
  },

  "c4_m2_group__add_sub": {
    "en": "Addition and Subtraction",
    "fr": "Addition et soustraction",
    "de": "Addition und Subtraktion",
    "pt": "Adição e Subtração"
  },

  "c4_m2_group__mult_div": {
    "en": "Multiplication, Multiples, and Division",
    "fr": "Multiplication, multiples et division",
    "de": "Multiplikation, Vielfache und Division",
    "pt": "Multiplicação, Múltiplos e Divisão"
  },

  "c4_m2_group__round_estim_seq": {
    "en": "Rounding, Estimation, and Sequences",
    "fr": "Arrondir, estimer et suites",
    "de": "Runden, Schätzen und Folgen",
    "pt": "Arredondamentos, Estimativas e Sequencias"
  },

  "c4_m2_group__probsolv1": {
    "en": "Problem Solving: RoboCODE’s Planet",
    "fr": "Résolution de problèmes: Planète de RoboCODE",
    "de": "Sachaufgaben: RoboCODEs Planet",
    "pt": "Resolução de problemas: Planeta do RoboCODE"
  },

  "c4_m2_group__probsolv2": {
    "en": "Problem Solving: RoboCODE on Earth",
    "fr": "Résolution de problèmes: RoboCODE sur la Terre",
    "de": "Sachaufgaben: RoboCODEs auf der Erde",
    "pt": "Resolução de problemas: RoboCODE na Terra"
  },

  "gr78_m2_group__programme_de_calc": {
    "en": "Calculation Program",
    "fr": "Programmes de calculs",
    "de": "Rechenprogramme",
    "pt": "Programmes de calculs"
  },

  "gr78_m2_group__spread_calc": {
    "en": "The Power of Spreadsheets",
    "fr": "Les tableurs",
    "de": "Kalkulationstabellen",
    "pt": "Les tableurs"
  },

  "gr78_m2_group__distrib": {
    "en": "Distributivity",
    "fr": "Distributivité",
    "de": "Distibutivgesetz",
    "pt": "Distributivité"
  },

  "gr78_m2_group__distrib_add": {
    "en": "Distributivity Over Addition",
    "fr": "Distributivité de la multiplication par rapport à l'addition",
    "de": "Distributivgesetz bei Summen",
    "pt": "Distributivité de la multiplication par rapport à l'addition"
  },

  "mtic_g78_m2_group__distrib_sub": {
    "en": "Distributivity Over Subtraction",
    "fr": "Distributivité de la multiplication par rapport à la soustraction",
    "de": "Distributivgesetz bei Differenzen",
    "pt": "Distributivité de la multiplication par rapport à la soustraction"
  },

  "mtic_g78_m2_group__factor": {
    "en": "Factoring",
    "fr": "Factorisation",
    "de": "Faktorisieren",
    "pt": "Factorisation"
  },

  "mtic_c3_m1v2_group__problem_solving": {
    "en": "How to Solve Problems",
    "fr": "Comment résoudre des problèmes ?",
    "pt": "Como resolver problemas?",
    "de": "Wie löse ich Sachaufgaben?"
  },
  "mtic_c3_m1v2_group__quantity": {
    "en": "Quantity",
    "fr": "Quantité",
    "pt": "Quantidade",
    "de": "Anzahl"
  },
  "mtic_c3_m1v2_group__distance": {
    "en": "Distance",
    "fr": "Distance",
    "pt": "Distância",
    "de": "Längen"
  },
  "mtic_c3_m1v2_group__money": {
    "en": "Money",
    "fr": "Argent",
    "pt": "Dinheiro",
    "de": "Geld"
  },
  "mtic_c3_m1v2_group__time": {
    "en": "Time",
    "fr": "Temps",
    "pt": "Tempo",
    "de": "Zeit"
  },

  "mtic_c3_m2_group__add": {
    "en": "Mental Math Addition",
    "fr": "Calcul Mental Addition",
    "de": "Kopfrechnen Addition",
    "pt": "Cálculo Mental Adição"
  },

  "mtic_c3_m2_group__sub": {
    "en": "Mental Math Subtraction",
    "fr": "Calcul Mental Soustraction",
    "de": "Kopfrechnen Subtraktion",
    "pt": "Cálculo Mental Subtração"
  },

  "mtic_c3_m2_group__mult": {
    "en": "Mental Math Multiplication",
    "fr": "Calcul Mental Multiplication",
    "de": "Kopfrechnen Multiplikation",
    "pt": "Cálculo Mental Multiplicação"
  },

  "mtic_c3_m2_group__div": {
    "en": "Mental Math Division",
    "fr": "Calcul Mental Division",
    "de": "Kopfrechnen Division",
    "pt": "Cálculo Mental Divisão"
  },

  "mtic_c3_m34_group__toyfact": {
    "en": "Toy Factory",
    "fr": "Usine de jouets",
    "de": "Spielzeugfabrik",
    "pt": "Fábrica de brinquedos"
  },

  "mtic_c3_m34_group__placeval": {
    "en": "Place Value",
    "fr": "Tableau de numération",
    "de": "Stellentafel",
    "pt": "Valor posicional"
  },

  "mtic_c3_m34_group__numline": {
    "en": "Number Line",
    "fr": "Demi-droite graduée",
    "de": "Zahlenstrahl",
    "pt": "Reta numérica"
  },

  "mtic_c3_m34_group__equ": {
    "en": "Equality",
    "fr": "Égalités",
    "de": "Gleichheitszeichen",
    "pt": "Égalités"
  },

  "mtic_c3_m34_group__addsub": {
    "en": "Addition and Subtraction",
    "fr": "Addition et soustraction",
    "de": "Addition und Subtraktion",
    "pt": "Adição e Subtração"
  },

  "mtic_c3_m34_group__numbri": {
    "en": "Number Bricks: Build the wall",
    "fr": "Constructuire des pyramides",
    "de": "Zahlenmauern bauen",
    "pt": "Construir pirâmides numéricas"
  },

  "mtic_c3_m34_group__numbri2": {
    "en": "Number Bricks: Empty spaces within the wall",
    "fr": "Rangée du bas, briques",
    "de": "Zahlenmauern: Fehlende Steine",
    "pt": "Rangée du bas, briques"
  },

  "mtic_c3_m34_group__calcclouds": {
    "en": "Calculation Clouds",
    "fr": "Nuage MathemaTIC",
    "de": "Rechenwolken plus/minus",
    "pt": "Nuvens MathemaTIC"
  },

  "mtic_c3_m34_group__multdiv": {
    "en": "Multiplication and Division",
    "fr": "Multiplication et division",
    "de": "Multiplikation und Division",
    "pt": "Multiplicação e Divisão"
  },

  "mtic_c3_m34_group__multgarden": {
    "en": "Multiplication Garden",
    "fr": "Jardin de multiplication",
    "de": "Multiplikationsgarten",
    "pt": "Jardim de multiplicação"
  },

  "mtic_c3_m34_group__calccloud2": {
    "en": "Calculation Cloud",
    "fr": "Nuage MathemaTIC",
    "de": "Rechenwolken mal/geteilt",
    "pt": "Nuvem MathemaTIC"
  },

  "mtic_c3_m34_group__probsolv": {
    "en": "Problem Solving",
    "fr": "Résolution de problèmes",
    "de": "Sachaufgaben",
    "pt": "Resolução de problemas"
  },

  "mtic_g78_m4_group__multiples_divisors": {
    "en": "Multiples and Divisors",
    "fr": "Multiples et diviseurs",
    "de": "Vielfache und Teiler",
    "pt": "Múltiplos e divisores"
  },
  "mtic_g78_m4_group__viz_fractions": {
    "en": "Visualizing Fractions",
    "fr": "Représenter des fractions",
    "de": "Brüche darstellen",
    "pt": "Representar frações"
  },
  "mtic_g78_m4_group__equiv_fractions": {
    "en": "Equivalent Fractions",
    "fr": "Fraction équivalentes",
    "de": "Äquivalente Brüche",
    "pt": "Frações equivalentes"
  },
  "mtic_g78_m4_group__comp_frac": {
    "en": "Comparing Fractions",
    "fr": "Comparer des fractions",
    "de": "Brüche vergleichen",
    "pt": "Comparar frações"
  },
  "mtic_g78_m4_group__frac_of_quant": {
    "en": "Problem Solving",
    "fr": "Résolution de problèmes",
    "de": "Probleme lösen",
    "pt": "Resolução de problemas"
  },
  "mtic_g78_m4_group__frac_dec": {
    "en": "Fractions and Decimals",
    "fr": "Convertir des fractions",
    "de": "Brüche umwandeln",
    "pt": "Frações e decimais"
  },
  "mtic_g78_m4_group__op_frac": {
    "en": "Operations with Fractions",
    "fr": "Opérations avec des fractions",
    "de": "Rechnen mit Brüchen",
    "pt": "Operações com frações"
  },

  "mtic_c3_m1_group__stage1": {
    "en": "The 4 Stages: Understand the Problem",
    "fr": "Les 4 étapes: comprendre le problème",
    "de": "Die Sachaufgabe verstehen",
    "pt": "Les 4 étapes: comprendre le problème"
  },

  "mtic_c3_m1_group__stage2": {
    "en": "The 4 Stages: Make a Plan",
    "fr": "Les 4 étapes: faire un plan",
    "de": "Einen Rechenweg finden",
    "pt": "Les 4 étapes: faire un plan"
  },

  "mtic_c3_m1_group__stage3": {
    "en": "The 4 Stages: Carry Out the Plan",
    "fr": "Les 4 étapes: Réaliser le plan",
    "de": "Das Resultat ausrechnen",
    "pt": "Les 4 étapes: Réaliser le plan"
  },

  "mtic_c3_m1_group__stage4": {
    "en": "The 4 Stages: Look Back at the Solution",
    "fr": "Les 4 étapes: vérification",
    "de": "Das Ergebnis überprüfen",
    "pt": "Les 4 étapes: vérification"
  },

  "mtic_c3_m1_group__disc": {
    "en": "Discovery",
    "fr": "Découverte",
    "de": "Entdecken",
    "pt": "Découverte"
  },

  "mtic_c3_m1_group__compr": {
    "en": "Comprehension",
    "fr": "Compréhension",
    "de": "Verständnis",
    "pt": "Compréhension"
  },

  "mtic_c3_m1_group__apprea": {
    "en": "Application & Reasoning",
    "fr": "Application et raisonnement",
    "de": "Application et raisonnement",
    "pt": "Application et raisonnement"
  },

  "mtic_c3_m56_group__or_spat": {
    "en": "Orientation and Spatial Reasoning",
    "fr": "Orientation et raisonnement spatial",
    "de": "Orientierung und räumliches Denken",
    "pt": "Orientation et raisonnement spatial"
  },

  "mtic_c3_m56_group__trans_sym_rot": {
    "en": "Translation, Symmetry, and Rotations",
    "fr": "Translations, symétries, et rotations",
    "de": "Figuren auslegen, Symmetrien und Drehungen",
    "pt": "Translations, symétries, et rotations"
  },

  "mtic_c3_m56_group__time": {
    "en": "Time",
    "fr": "Temps",
    "de": "Zeit",
    "pt": "Tempo"
  },

  "mtic_c3_m56_group__area_per": {
    "en": "Area and Perimeter",
    "fr": "Aire et périmètre",
    "de": "Flächeninhalt und Umfang",
    "pt": "Área e perímetro"
  },

  "mtic_c3_m56_group__wei_cap": {
    "en": "Weight and Capacity",
    "fr": "Poids et capacité",
    "de": "Gewicht und Volumen",
    "pt": "Peso e capacidade"
  },

  "mtic_c3_m56_group__chal": {
    "en": "Challenge",
    "fr": "Défi",
    "de": "Herausforderung",
    "pt": "Défi"
  },

  "mtic_g78_m3_group__think_eq": {
    "en": "Thinking about equality",
    "fr": "Introduction",
    "de": "Einführung in Gleichungen",
    "pt": "Introduction"
  },

  "mtic_g78_m3_group__solv_strat": {
    "en": "Solving Strategies",
    "fr": "Stratégies",
    "de": "Strategien zum Lösen",
    "pt": "Stratégies"
  },

  "mtic_g78_m3_group__build_eq": {
    "en": "Building Equations",
    "fr": "Établir des équations",
    "de": "Gleichungen aufstellen",
    "pt": "Établir des équations"
  },

  "mtic_g78_m3_group__spec_eq": {
    "en": "Special Equations",
    "fr": "Cas spéciaux",
    "de": "Sonderfälle",
    "pt": "Cas spéciaux"
  },

  "mtic_g78_m3_group__prob": {
    "en": "Problems",
    "fr": "Problèmes",
    "de": "Probleme",
    "pt": "Problemas"
  },

  "mtic_g78_m3_group__equ_graph": {
    "en": "Equations and Graphs",
    "fr": "Equations et graphiques",
    "de": "Gleichungen und Graphen",
    "pt": "Equações e gráficos"
  },

  "mtic_g78_m1_group__strat": {
    "en": "Strategies",
    "fr": "Stratégies",
    "de": "Strategien",
    "pt": "Stratégies"
  },

  "mtic_g78_m1_group__strat_speed": {
    "en": "Speed",
    "fr": "Vitesse",
    "de": "Geschwindigkeit",
    "pt": "Vitesse"
  },

  "mtic_g78_m1_group__prob": {
    "en": "Problems",
    "fr": "Problèmes",
    "de": "Problèmes",
    "pt": "Problemas"
  },

  "mtic_g78_m1_group__prob_speed": {
    "en": "Speed",
    "fr": "Vitesse",
    "de": "Geschwindigkeit",
    "pt": "Vitesse"
  },

  "mtic_g78_m1_group__is_prop": {
    "en": "Is it proportional?",
    "fr": "Est-ce proportionnel ?",
    "de": "Ist dies proportional?",
    "pt": "Será que é proporcional?"
  },
  "c4_m3_diagnostic": {
    "en": "Diagnostic (Fractions)",
    "fr": "Test diagnostique (fractions)",
    "de": "Anfangstest (Brüche)",
    "pt": "Teste diagnóstico (Frações)"
  },
  "c4_m3_summative": {
    "en": "Summative Test (Fractions)",
    "fr": "Test bilan (fractions)",
    "de": "Abschlusstest (Brüche)",
    "pt": "Teste sumativo (Frações)"
  },
  "c4_m3_formative_1": {
    "en": "Visualizing Fractions",
    "fr": "Représentation de fractions",
    "de": "Brüche darstellen",
    "pt": "Représentation de fractions"
  },
  "c4_m3_formative_2": {
    "en": "Fractions on the Number Line",
    "fr": "Droite graduée",
    "de": "Zahlenstrahl",
    "pt": "Droite graduée"
  },
  "c4_m3_formative_3": {
    "en": "Multiplying Fractions",
    "fr": "Multiplication",
    "de": "Multiplikation",
    "pt": "Multiplication"
  },
  "c4_m3_formative_4": {
    "en": "Adding Fractions",
    "fr": "Additions",
    "de": "Addition",
    "pt": "Additions"
  },
  "c4_m3_formative_5": {
    "en": "Equivalent Fractions and Comparisons",
    "fr": "Comparaison de fractions",
    "de": "Brüche vergleichen",
    "pt": "Comparaison de fractions"
  },
  "c4_m3_a_1_1_lir_fra_exp": {
    "de": "Einen Bruch an einer Figur ablesen",
    "en": "Reading a fraction from a figure",
    "fr": "Lire une fraction à partir d'une figure",
    "pt": "Ler uma fração a partir de uma figura"
  },
  "c4_m3_a_2_1_fra_sur_dro_exp": {
    "de": "Einen Bruch auf einem Zahlenstrahl darstellen",
    "en": "Representing a fraction on a number line",
    "fr": "Représenter une fraction sur une droite graduée",
    "pt": "Representar uma fração numa reta"
  },
  "c4_m3_a_2_2_com_fra_exp": {
    "de": "Brüche vergleichen",
    "en": "Comparing fractions",
    "fr": "Comparer des fractions",
    "pt": "Comparar frações"
  },
  "c4_m3_a_2_3_equ_fra_exp": {
    "de": "Gleichwertige Brüche",
    "en": "Equivalent fractions",
    "fr": "Fractions équivalentes",
    "pt": "Frações equivalentes"
  },
  "c4_m3_a_3_1_add_fra_exp": {
    "de": "Addition von Brüchen",
    "en": "Addition of fractions",
    "fr": "Addition de fractions",
    "pt": "Adição de frações"
  },
  "c4_m3_a_3_2_sou_fra_exp": {
    "de": "Subtraktion von Brüchen",
    "en": "Subtraction of fractions",
    "fr": "Soustraction de fractions",
    "pt": "Subtração de frações"
  },
  "c4_m3_a_3_3_mul_fra_exp": {
    "de": "Multiplikation von Brüchen",
    "en": "Multiplication of fractions",
    "fr": "Multiplication de fractions",
    "pt": "Multiplicação de frações"
  },
  "c4_m3_b_1_1_ope": {
    "de": "Den Bruchteil einer Menge bestimmen",
    "en": "Determine the fraction from a set",
    "fr": "Déterminer la fraction d'un ensemble",
    "pt": "Determinar a fração de um conjunto"
  },
  "c4_m3_b_1_2_ope": {
    "de": "Den Bruchteil einer Figur bestimmen (Teil 1)",
    "en": "Determine the fraction from a figure (Part 1)",
    "fr": "Déterminer la fraction d'une figure (Partie 1)",
    "pt": "Determinar a fração de uma figura (Parte 1)"
  },
  "c4_m3_b_1_3_ope": {
    "de": "Den Bruchteil einer Figur bestimmen (Teil 2)",
    "en": "Determine the fraction from a figure (Part 2)",
    "fr": "Déterminer la fraction d'une figure (Partie 2)",
    "pt": "Determinar a fração a partir de uma figura (Parte 2)"
  },
  "c4_m3_b_1_4_ope": {
    "de": "Flaggen",
    "en": "Flags",
    "fr": "Drapeaux",
    "pt": "Bandeiras"
  },
  "c4_m3_b_2_1_ope": {
    "de": "Einen Bruch darstellen (Teil 1)",
    "en": "Represent a fraction (Part 1)",
    "fr": "Représenter une fraction (partie 1)",
    "pt": "Representar uma fração (Parte 1)"
  },
  "c4_m3_b_2_2_ope": {
    "de": "Einen Bruch darstellen (Teil 2)",
    "en": "Represent a fraction (Part 2)",
    "fr": "Représenter une fraction (Partie 2)",
    "pt": "Representar uma fração (Parte 2)"
  },
  "c4_m3_b_3_1_ope": {
    "de": "Einen Bruch auf den Zahlenstrahl setzen",
    "en": "Place the fraction on the number line",
    "fr": "Placer le point sur la droite graduée",
    "pt": "Colocar o ponto sobre a reta graduada"
  },
  "c4_m3_b_3_2_ope": {
    "de": "Den auf dem Zahlenstrahl dargestellten Bruch bestimmen",
    "en": "Determine the fraction from the number line",
    "fr": "Déterminer la fraction représentée sur la droite graduée",
    "pt": "Calcular a fração representada na régua graduada"
  },
  "c4_m3_b_4_1_ope": {
    "de": "Gleichwertige Brüche",
    "en": "Equivalent fractions",
    "fr": "Fractions équivalentes",
    "pt": "Frações equivalentes"
  },
  "c4_m3_b_4_2_ope": {
    "de": "Brüche vergleichen",
    "en": "Comparing fractions",
    "fr": "Comparer des fractions",
    "pt": "Comparação de frações"
  },
  "c4_m3_b_4_3_ope": {
    "de": "Brüche ordnen",
    "en": "Ordering fractions",
    "fr": "Ordonner des fractions",
    "pt": "Ordenar as frações"
  },
  "c4_m3_b_4_4_ope": {
    "de": "Brüche einfügen",
    "en": "Inserting fractions",
    "fr": "Intercaler des fractions",
    "pt": "Intercalar frações"
  },
  "c4_m3_b_5_1_ope": {
    "de": "Addition von Brüchen (Teil 1)",
    "en": "Addition of fractions (Part 1)",
    "fr": "Addition de fractions (partie 1)",
    "pt": "Adição de frações (Parte 1)"
  },
  "c4_m3_b_5_2_ope": {
    "de": "Subtraktion von Brüchen (Teil 1)",
    "en": "Substraction of fractions (Part 1)",
    "fr": "Soustraction de fractions (partie 1)",
    "pt": "Subtração das frações (Parte 1)"
  },
  "c4_m3_b_5_3_ope": {
    "de": "Addition von Brüchen (Teil 2)",
    "en": "Addition of fractions (Part 2)",
    "fr": "Addition de fractions (partie 2)",
    "pt": "Adição de frações (Parte 2)"
  },
  "c4_m3_b_5_4_ope": {
    "de": "Subtraktion von Brüchen (Teil 2)",
    "en": "Substraction of fractions (Part 2)",
    "fr": "Soustraction de fractions (partie 2)",
    "pt": "Subtração de frações (Parte 2)"
  },
  "c4_m3_b_6_1_ope": {
    "de": "Multiplikation von Brüchen (Teil 1)",
    "en": "Multiplication of fractions (Part 1)",
    "fr": "Multiplication de fractions (partie 1)",
    "pt": "Multiplicação de frações (Parte 1)"
  },
  "c4_m3_b_6_2_ope": {
    "de": "Multiplikation von Brüchen (Teil 2)",
    "en": "Multiplication of fractions (Part 2)",
    "fr": "Multiplication de fractions (partie 2)",
    "pt": "Multiplicação de frações (Parte 2)"
  },
  "c4_m3_c_1_1_ope": {
    "de": "Domino mit gleichwertigen Brüchen (Teil 1)",
    "en": "Dominoes: Equivalent fractions (Part 1)",
    "fr": "Dominos de fractions équivalentes (partie 1)",
    "pt": "Dominós de frações equivalentes (Parte 1)"
  },
  "c4_m3_c_1_2_ope": {
    "pt": "Dominós de frações equivalentes (Parte 2)",
    "en": "Dominoes: Equivalent fractions (Part 2)",
    "de": "Domino mit gleichwertigen Brüchen (Teil 2)",
    "fr": "Dominos de fractions équivalentes (partie 2)"
  },
  "c4_m3_c_1_3_ope": {
    "pt": "Triominós: Frações equivalentes (parte 1)",
    "en": "Triominoes: Equivalent fractions (Part 1)",
    "de": "Trinominos: gleichwertige Brüche (Teil 1)",
    "fr": "Triominos: Fractions équivalentes (1re partie)"
  },
  "c4_m3_c_1_4_ope": {
    "pt": "Triominós: Frações equivalentes (parte 2)",
    "en": "Triominoes: Equivalent fractions (Part 2)",
    "de": "Trinominos: gleichwertige Brüche (Teil 2)",
    "fr": "Triominos: Fractions équivalentes (partie 2)"
  },
  "c4_m3_c_2_1_ope": {
    "de": "Das Zahlenschloss",
    "en": "The PAD",
    "fr": "Débloquer un code",
    "pt": "Quebrar o código"
  },
  "c4_m3_c_3_1_ope": {
    "de": "Zahnräder (Teil 1)",
    "en": "Gears (Part 1)",
    "fr": "Engrenages (partie 1)",
    "pt": "Engrenagens (Parte 1)"
  },
  "c4_m3_c_3_2_ope": {
    "de": "Zahnräder (Teil 2)",
    "en": "Gears (Part 2)",
    "fr": "Engrenages (partie 2)",
    "pt": "Engrenagens (Parte 2)"
  },
  "c4_m3_c_4_1_ope": {
    "de": "Puzzle (Teil 1)",
    "en": "Puzzle (Part 1)",
    "fr": "Puzzle (partie 1)",
    "pt": "Puzzle (Parte 1)"
  },
  "c4_m3_c_4_2_ope": {
    "de": "Puzzle (Teil 2)",
    "en": "Puzzle (Part 2)",
    "fr": "Puzzle (partie 2)",
    "pt": "Puzzle (Parte 2)"
  },
  "c4_m3_c_4_3_ope": {
    "de": "Puzzle (Teil 3)",
    "en": "Puzzle (Part 3)",
    "fr": "Puzzle (partie 3)",
    "pt": "Puzzle (Parte 3)"
  },
  "c4_m3_c_4_4_ope": {
    "de": "Puzzle (Teil 4)",
    "en": "Puzzle (Part 4)",
    "fr": "Puzzle (partie 4)",
    "pt": "Puzzle (Parte 4)"
  },

  "c4_m4_diagnostic": {
    "en": "Diagnostic (Decimal Numbers)",
    "fr": "Test diagnostique (nombres décimaux)",
    "de": "Anfangstest (Dezimalzahlen)",
    "pt": "Teste diagnóstico (Números decimais)"
  },
  "c4_m4_summative": {
    "en": "Summative Test (Decimal Numbers)",
    "fr": "Test bilan (nombres décimaux)",
    "de": "Abschlusstest (Dezimalzahlen)",
    "pt": "Teste sumativo (Números decimais)"
  },
  "c4_m4_formative_1": {
    "en": "Multiplying Decimals 1",
    "fr": "Multiplications 1",
    "de": "Multiplikation 1",
    "pt": "Multiplications 1"
  },
  "c4_m4_formative_2": {
    "en": "Adding and Subtracting Decimals 1",
    "fr": "Additions et soustractions 1",
    "de": "Addition und Subtraktion 1",
    "pt": "Additions et soustractions 1"
  },
  "c4_m4_formative_3": {
    "en": "Adding and Subtracting Decimals 2",
    "fr": "Additions et soustractions 2",
    "de": "Addition und Subtraktion 2",
    "pt": "Additions et soustractions 2"
  },
  "c4_m4_formative_4": {
    "en": "Multiplying Decimals 2",
    "fr": "Multiplications 2",
    "de": "Multiplikation 2",
    "pt": "Multiplications 2"
  },
  "c4_m4_formative_5": {
    "en": "Converting Units",
    "fr": "Conversions",
    "de": "Umwandeln",
    "pt": "Conversions"
  },
  "c4_m4_a_1_1_mti_c4_dec_exp_int": {
    "de": "Einführung in die Dezimalzahlen (Teil 1)",
    "fr": "Introduction aux nombres décimaux (partie 1)",
    "en": "Introduction to Decimal Numbers (Part 1)",
    "pt": "Introdução aos números décimais (Parte 1)"
  },
  "c4_m4_a_1_2_mti_c4_dec_exp_par_2": {
    "de": "Einführung in die Dezimalzahlen (Teil 2)",
    "fr": "Introduction aux nombres décimaux (partie 2)",
    "en": "Introduction to Decimal Numbers (Part 2)",
    "pt": "Introdução aos números décimais (Parte 2)"
  },
  "c4_m4_a_1_3_mti_c4_dec_exp_par_3": {
    "de": "Einführung in die Dezimalzahlen (Teil 3)",
    "fr": "Introduction aux nombres décimaux (partie 3)",
    "en": "Introduction to Decimal Numbers (Part 3)",
    "pt": "Introdução aos números décimais (Parte 3)"
  },
  "c4_m4_a_2_1_mti_c4_dec_exp_add_sub": {
    "de": "Addition von Dezimalzahlen",
    "fr": "Addition de nombres décimaux",
    "en": "Addition of Decimal Numbers",
    "pt": "Adição de números decimais"
  },
  "c4_m4_a_2_2_mti_c4_dec_exp_add_sub_spl": {
    "de": "Subtraktion von Dezimalzahlen",
    "fr": "Soustraction de nombres décimaux",
    "en": "Subtraction of Decimal Numbers",
    "pt": "Subtração de números decimais"
  },
  "c4_m4_a_2_3_ope": {
    "de": "Addition und Subtraktion von Dezimalzahlen - Übungen",
    "fr": "Addition et soustraction de nombres décimaux - Exercice",
    "en": "Addition and Subtraction of Decimal Numbers - Exercise",
    "pt": "Adição e subtração de números decimais - Exercícios"
  },
  "c4_m4_a_2_4_mti_c4_dec_exp_mul": {
    "de": "Multiplikation von Dezimalzahlen (Teil 1)",
    "fr": "Multiplication de nombres décimaux (partie 1)",
    "en": "Multiplication of Decimal Numbers (Part 1)",
    "pt": "Multiplicação de números decimais (Parte 1)"
  },
  "c4_m4_a_2_5_mti_c4_dec_exp_mul_par": {
    "de": "Multiplikation von Dezimalzahlen (Teil 2)",
    "fr": "Multiplication de nombres décimaux (partie 2)",
    "en": "Multiplication of Decimal Numbers (Part 2)",
    "pt": "Multiplicação de números decimais (Parte 2)"
  },
  "c4_m4_a_2_6_mti_c4_dec_exp_div": {
    "de": "Division von Dezimalzahlen (Teil 1)",
    "fr": "Division de nombres décimaux (partie 1)",
    "en": "Division of Decimal Numbers (Part 1)",
    "pt": "Divisão de números decimais (Parte 1)"
  },
  "c4_m4_a_2_7_mti_c4_dec_exp_div_par": {
    "de": "Division von Dezimalzahlen (Teil 2)",
    "fr": "Division de nombres décimaux (partie 2)",
    "en": "Division of Decimal Numbers (Part 2)",
    "pt": "Divisão de números decimais (Parte 2)"
  },
  "c4_m4_a_3_1_mti_c4_dec_exp_con_fra": {
    "de": "Dezimalzahlen in Brüche umwandeln",
    "fr": "Passer de l’écriture décimale à l’écriture fractionnaire",
    "en": "Converting Decimal Numbers to Fractions",
    "pt": "Alternar entre a formal decimal e a forma fracionária"
  },
  "c4_m4_a_3_2_mti_c4_dec_exp_con_dec": {
    "de": "Brüche in Dezimalzahlen umwandeln",
    "fr": "Passer de l’écriture fractionnaire à l’écriture décimale",
    "en": "Converting Fractions to Decimal Numbers",
    "pt": "Passar da forma fracionária à forma decimal"
  },
  "c4_m4_a_3_3_ope": {
    "de": "Brüche in Dezimalzahlen umwandeln - Übungen",
    "fr": "Passer de l’écriture fractionnaire à l’écriture décimale - Exercice",
    "en": "Converting Fractions to Decimal Numbers - Exercise",
    "pt": "Passar da forma fracionária à forma decimal - Exercício"
  },
  "c4_m4_a_3_4_mti_c4_dec_exp_con_dec_par": {
    "de": "Brüche in Dezimalzahlen umwandeln mit Hilfe von gleichwertigen Brüchen",
    "fr": "Passer de l'écriture fractionnaire à l'écriture décimale avec des fractions équivalentes",
    "en": "Converting Fractions to Decimal Numbers with Equivalent Fractions",
    "pt": "Passar da forma fracionária à forma decimal com frações equivalentes"
  },
  "c4_m4_a_3_5_ope": {
    "de": "Brüche in Dezimalzahlen umwandeln - Übungen",
    "fr": "Passer de l'écriture fractionnaire à l'écriture décimale - Exercice",
    "en": "Converting Fractions to Decimal Numbers - Exercise",
    "pt": "Passar da escrita fracionária à escrita decimal - Exercícios"
  },
  "c4_m4_a_3_6_mti_c4_dec_exp_fra_par": {
    "de": "Nicht dezimale Brüche (Teil 1)",
    "fr": "Fractions non-decimales (partie 1)",
    "en": "Non-decimal Fractions (Part 1)",
    "pt": "Frações não decimais (Parte 1)"
  },
  "c4_m4_a_3_7_ope": {
    "de": "Nicht dezimale Brüche - Übungen",
    "fr": "Fractions non-decimales - Exercice",
    "en": "Non-decimal Fractions - Exercises",
    "pt": "Frações não decimais  - Exercícios"
  },
  "c4_m4_a_3_8_mti_c4_dec_exp_fra_par": {
    "de": "Nicht dezimale Brüche (Teil 2)",
    "fr": "Fractions non-decimales (Part 2)",
    "en": "Non-decimal Fractions (Part 2)",
    "pt": "Frações não decimais  (Parte 2)"
  },
  "c4_m4_a_4_1_mti_c4_dec_exp_tim": {
    "de": "Zeitspannen umrechnen",
    "fr": "Conversion des unités de temps",
    "en": "Converting Units of Time",
    "pt": "Conversões de medidas de tempo"
  },
  "c4_m4_a_4_2_mti_c4_dec_con_dar": {
    "de": "Geldbeträge umrechnen",
    "fr": "Conversion d’argent",
    "en": "Converting Units of Money",
    "pt": "Conversão de dinheiro"
  },
  "c4_m4_b_1_1_ope": {
    "de": "Karten (Teil 1)",
    "fr": "Étiquettes (partie 1)",
    "en": "Cards (Part 1)",
    "pt": "Etiquetas (Parte 1)"
  },
  "c4_m4_b_1_2_ope": {
    "de": "Karten (Teil 2)",
    "fr": "Étiquettes (Part 2)",
    "en": "Cards (Part 2)",
    "pt": "Etiquetas (Parte 2)"
  },
  "c4_m4_b_1_3_ope": {
    "de": "Am Zahlenstrahl zoomen (Teil 1)",
    "fr": "Droite zoomée (partie 1)",
    "en": "Zoom! (Part 1)",
    "pt": "Semirreta com zoom (Parte 1)"
  },
  "c4_m4_b_1_4_ope": {
    "de": "Dominos (Teil 1)",
    "fr": "Dominos (partie 1)",
    "en": "Dominos (Part 1)",
    "pt": "Dominós (Parte 1)"
  },
  "c4_m4_b_1_5_ope": {
    "de": "Dezimalzahlen vergleichen",
    "fr": "Comparaison de nombres décimaux",
    "en": "Comparing Decimal Numbers",
    "pt": "Comparar números decimais"
  },
  "c4_m4_b_1_6_ope": {
    "de": "Dezimalzahlen ordnen",
    "fr": "Ordonner de nombres décimaux",
    "en": "Ordering Decimal Numbers",
    "pt": "Ordenar números décimais"
  },
  "c4_m4_b_1_7_ope": {
    "de": "Dezimalzahlen einfügen",
    "fr": "Intercaler de nombres décimaux",
    "en": "Interposing Decimal Numbers",
    "pt": "Intercalar números décimais"
  },
  "c4_m4_b_2_1_est_lor_de_gra_de_res_ave_ass": {
    "de": "Ergebnisse schätzen (Teil 1)",
    "fr": "Estimer le résultat (partie 1)",
    "en": "Approximating the Result (Part 1)",
    "pt": "Fazer estimativas (Parte 1)"
  },
  "c4_m4_b_2_2_ope": {
    "de": "Addition von Dezimalzahlen",
    "fr": "Addition de nombres décimaux",
    "en": "Addition of Decimal Numbers",
    "pt": "Adição de números decimais"
  },
  "c4_m4_b_2_3_ope": {
    "de": "Subtraktion von Dezimalzahlen",
    "fr": "Soustraction de nombres décimaux",
    "en": "Subtraction of Decimal Numbers",
    "pt": "Subtração de números decimais"
  },
  "c4_m4_b_3_1_ope": {
    "de": "Multiplikation von Dezimalzahlen",
    "fr": "Multiplication de nombres décimaux",
    "en": "Multiplication of Decimal Numbers",
    "pt": "Multiplicação de números decimais"
  },
  "c4_m4_b_4_1_ope": {
    "de": "Am Zahlenstrahl zoomen (Teil 2)",
    "fr": "Droite zoomée (partie 2)",
    "en": "Zoom! (Part 2)",
    "pt": "Reta com zoom (Parte 2)"
  },
  "c4_m4_b_4_2_est_lor_de_gra_de_res_ave_ass": {
    "de": "Ergebnisse schätzen (Teil 2)",
    "fr": "Estimer le résultat (partie 2)",
    "en": "Approximating the Result (Part 2)",
    "pt": "Fazer estimativas (Parte 2)"
  },
  "c4_m4_b_4_3_ope": {
    "de": "Division von Dezimalzahlen",
    "fr": "Division de nombres décimaux",
    "en": "Division of Decimal Numbers",
    "pt": "Divisão de números decimais"
  },
  "c4_m4_b_5_1_ope": {
    "de": "Zauberhut  (Teil 1)",
    "fr": "Chapeau magique (partie 1)",
    "en": "Magic Hat (Part 1)",
    "pt": "Chapéu Mágico (Parte 1)"
  },
  "c4_m4_b_5_2_ope": {
    "de": "Zauberhut  (Teil 2)",
    "fr": "Chapeau magique (partie 2)",
    "en": "Magic Hat (Part 2)",
    "pt": "Chapéu Mágico (Parte 2)"
  },
  "c4_m4_b_5_3_ope": {
    "de": "Zauberhut  (Teil 3)",
    "fr": "Chapeau magique (partie 3)",
    "en": "Magic Hat (Part 3)",
    "pt": "Chapéu Mágico (Parte 3)"
  },
  "c4_m4_b_6_1_ope": {
    "de": "Dominos (Teil 2)",
    "fr": "Dominos (Partie 2)",
    "en": "Dominos (Part 2)",
    "pt": "Dominós (Parte 2)"
  },
  "c4_m4_b_6_2_ope": {
    "de": "Dominos (Teil 3)",
    "fr": "Dominos (partie 3)",
    "en": "Dominos (Part 3)",
    "pt": "Dominós (Parte 3)"
  },
  "c4_m4_b_7_1_ope": {
    "de": "Zeitspannen umrechnen",
    "fr": "Conversion des unités de temps",
    "en": "Converting units of time",
    "pt": "Conversões de medidas de tempo"
  },
  "c4_m4_b_7_2_ope": {
    "de": "Im Radio",
    "fr": "À l'antenne",
    "en": "On air",
    "pt": "No ar"
  },
  "c4_m4_b_7_3_ope": {
    "de": "Zeitspannen runden",
    "fr": "Arrondir des unités de temps",
    "en": "Rounding Time",
    "pt": "Arredondar medidas de tempo"
  },
  "c4_m4_b_7_4_ope": {
    "de": "Geldbeträge runden",
    "fr": "Arrondir des unités d'argent ",
    "en": "Rounding Money",
    "pt": "Arredondar quantias de dinheiro"
  },
  "c4_m4_c_1_1_ope": {
    "de": "Saftautomat",
    "fr": "Distributeur automatique",
    "en": "Vending machine",
    "pt": "Máquina de venda automática"
  },
  "c4_m4_c_2_1_mti_c4_dec_dep_vac": {
    "de": "Einkaufen im Urlaub",
    "fr": "Dépenses de vacances",
    "en": "Vacation Shopping",
    "pt": "As despesas das férias"
  },
  "c4_m4_c_3_1_ope": {
    "de": "Das Mobile",
    "fr": "Le pendule",
    "en": "The Mobile",
    "pt": "O pêndulo"
  },
  "c4_m4_c_4_1_ope": {
    "de": "Defekter Taschenrechner",
    "fr": "Calculatrice cassée",
    "en": "Broken Calculator",
    "pt": "Calculadora defeituosa"
  },
  "c4_m5_diagnostic": {
    "en": "Diagnostic (Data Management)",
    "fr": "Test diagnostique (gestion de données)",
    "de": "Anfangstest (Datenmanagement)",
    "pt": "Teste diagnóstico (Gestão de Dados)"
  },
  "c4_m5_summative": {
    "en": "Summative Test (Data Management)",
    "fr": "Test bilan (gestion de données)",
    "de": "Abschlusstest (Datenmanagement)",
    "pt": "Teste sumativo (Gestão de Dados)"
  },
  "c4_m5_formative_1": {
    "en": "Graphs and Tables",
    "fr": "Graphiques et tableaux",
    "de": "Tabellen und Diagramme",
    "pt": "Graphiques et tableaux"
  },
  "c4_m5_formative_2": {
    "en": "Extracting Data from Text",
    "fr": "Problèmes",
    "de": "Textaufgabe",
    "pt": "Problèmes"
  },
  "c4_m5_formative_3": {
    "en": "The Cartesian Grid",
    "fr": "Cooordonnées",
    "de": "Koordinaten",
    "pt": "Cooordonnées"
  },
  "c4_m5_formative_4": {
    "en": "Calculation Programs",
    "fr": "Programmes de calculations",
    "de": "Rechenprogramm",
    "pt": "Programmes de calculations"
  },
  "c4_m5_a_1_1_mti_c4_m5_rep_des_pir": {
    "fr": "Le repère des pirates !",
    "en": "The Pirate's Coordinate System!",
    "de": "Das Koordinatensystem der Piraten!",
    "pt": "O reduto dos piratas!"
  },
  "c4_m5_a_1_2_ope": {
    "fr": "Trouver le trésor à partir des coordonnées",
    "en": "Find the treasure using its coordinates",
    "de": "Koordinaten für die Schatzsuche nutzen",
    "pt": "Encontra o tesouro utilizando as coordenadas"
  },
  "c4_m5_a_1_3_ope": {
    "fr": "Identifier les coordonnées des étapes",
    "en": "Identify the coordinates of the landmark",
    "de": "Koordianten von Sehenswürdigkeiten herausfinden",
    "pt": "Identificar as coordenadas de monumentos ou locais de interesse"
  },
  "c4_m5_a_1_4_ope": {
    "fr": "Compléter la figure",
    "en": "Complete the shape",
    "de": "Figuren vervollständigen",
    "pt": "Completa a figura"
  },
  "c4_m5_a_2_1_mti_c4_m5_pou": {
    "fr": "Pourcentages - introduction",
    "en": "Percentages - Introduction",
    "de": "Prozente - Einführung",
    "pt": "Percentagens - introdução"
  },
  "c4_m5_a_2_2_mti_c4_m5_pou_par_2": {
    "fr": "Pourcentages - dans le jardin",
    "en": "Percentages - Vegetable garden",
    "de": "Prozente - im Gemüsegarten",
    "pt": "Percentagens - na horta"
  },
  "c4_m5_a_2_3a_mti_c4_m5_gra_his": {
    "fr": "Centre national pour l´infographie - créer un diagramme en bâtons",
    "en": "Graphic Design Center - Create a bar graph",
    "de": "Grafikzentrum - ein Säulendiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico de colunas"
  },
  "c4_m5_a_2_3b_mti_c4_m5_gra_his_pt2": {
    "fr": "Centre national pour l´infographie - lire un diagramme en bâtons",
    "en": "Graphic Design Center - Read your bar graph",
    "de": "Grafikzentrum - ein Säulendiagramm lesen",
    "pt": "Centro Nacional para a Infografia - ler um gráfico de colunas"
  },
  "c4_m5_a_2_4_mti_c4_m5_gra_his_ex": {
    "fr": "Exercices sur les diagrammes à bâtons",
    "en": "Bar graph practice",
    "de": "Übungen zum Säulendiagramm",
    "pt": "Exercícios sobre os gráficos de colunas"
  },
  "c4_m5_a_2_5_mti_c4_m5_gra_lin": {
    "fr": "Centre national pour l´infographie - créer un diagramme linéaire",
    "en": "Graphic Design Center - Create a line graph",
    "de": "Grafikzentrum - ein Liniendiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico de linhas"
  },
  "c4_m5_a_2_6_mti_c4_m5_gra_lin_ex": {
    "fr": "Exercices sur les diagrammes linéaires",
    "en": "Line graph practice",
    "de": "Übungen zum Liniendiagramm",
    "pt": "Exercícios sobre os gráficos de linhas"
  },
  "c4_m5_a_2_7_mti_c4_m5_gra_cir": {
    "fr": "Centre national pour l´infographie - créer un diagramme circulaire",
    "en": "Graphic Design Center - Create a pie graph",
    "de": "Grafikzentrum - ein Kreisdiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico circular"
  },
  "c4_m5_a_2_8_mti_c4_m5_gra_exe": {
    "fr": "Exercices diagrammes circulaires",
    "en": "Pie graph practice",
    "de": "Übungen zum Kreisdiagramm",
    "pt": "Exercícios de gráfico circulares"
  },
  "c4_m5_a_2_9_ope": {
    "fr": "Construction de diagrammes",
    "en": "Creating graphs",
    "de": "Diagramme erstellen",
    "pt": "Construção de gráficos"
  },
  "c4_m5_a_3_1_mti_c4_m5_mat_mat_mac": {
    "fr": "La folle machine du professeur Cal Culator",
    "en": "Professor Cal Culator's Wacky Machine!",
    "de": "Die verrückte Maschine von Professor Cal Culator",
    "pt": "A máquina louca do professor Cal Culator!"
  },
  "c4_m5_a_3_2_mti_c4_m5_sim_exp": {
    "fr": "Simplifier le programme",
    "en": "Simplify the program",
    "de": "Das Programm vereinfachen",
    "pt": "Simplificar o programa"
  },
  "c4_m5_a_3_3_mti_c4_m5_sim_exp": {
    "fr": "Trouver le nombre mystérieux",
    "en": "Find the mystery number",
    "de": "Die Geheimzahl finden",
    "pt": "Encontrar o número misterioso"
  },
  "c4_m5_a_3_4_mti_c4_m5_sim_exp": {
    "fr": "Trouver le programme mystérieux",
    "en": "Find the mystery program",
    "de": "Das geheime Programm finden",
    "pt": "Encontrar o programa misterioso"
  },
  "c4_m5_b_1_1_ope": {
    "fr": "Choisir la zone coloriée",
    "en": "Choose the coloured zone",
    "de": "Den farbigen Bereich wählen",
    "pt": "Escolher a zona pintada"
  },
  "c4_m5_b_1_2_ope": {
    "fr": "Créer des polygones",
    "en": "Create the shape",
    "de": "Ebene Formen bilden",
    "pt": "Construir polígonos"
  },
  "c4_m5_b_1_3_ope": {
    "fr": "Placer les joueurs",
    "en": "Position the team's players",
    "de": "Spieler setzen",
    "pt": "Colocar os jogadores"
  },
  "c4_m5_b_2_1_ope": {
    "fr": "Etude de la croissance de deux arbres",
    "en": "Investigating tree growth",
    "de": "Baumwachstum erforschen",
    "pt": "Estudar o crescimento de duas árvores"
  },
  "c4_m5_b_2_2_ope": {
    "fr": "Planche de Galton",
    "en": "The Galton Board",
    "de": "Das Galtonbrett",
    "pt": "Máquina de Galton"
  },
  "c4_m5_b_2_3_ope": {
    "fr": "Jetons de poker",
    "en": "Poker chips",
    "de": "Poker-Chips",
    "pt": "Fichas de poker"
  },
  "c4_m5_b_3_1_mti_c4_m5_syr_int": {
    "fr": "Le programme de Syracuse (Introduction)",
    "en": "Syracuse's Program (Introduction)",
    "de": "Syrakus' Programm (Einführung)",
    "pt": "O programa de Syracuse (Introdução)"
  },
  "c4_m5_b_3_2_ope": {
    "fr": "Tester le programme de Syracuse",
    "en": "Testing Syracuse's Program",
    "de": "Syrakus' Programm testen",
    "pt": "Testar o programa de Syracuse"
  },
  "c4_m5_b_3_3_ope": {
    "fr": "Représenter graphiquement le programme de Syracuse",
    "en": "Graphing Syracuse's Program",
    "de": "Syrakus' Programm bildlich darstellen",
    "pt": "Representar graficamente o programa de Syracuse"
  },
  "c4_m5_b_3_4_ope": {
    "fr": "Interpréter la représentation graphique du programme de Syracuse",
    "en": "Reading Syracuse's graph",
    "de": "Syrakus' Grafik verstehen",
    "pt": "Interpretar a representar de forma gráfica o programa de Syracuse"
  },
  "c4_m5_b_4_1_mti_c4_m5_ath": {
    "fr": "Athlétisme - compléter des tableaux",
    "en": "Track and field - Completing tables",
    "de": "Leichtathletik - Tabellen ausfüllen",
    "pt": "Atletismo - completar tabelas"
  },
  "c4_m5_b_4_2_mti_c4_m5_ath_pt2": {
    "fr": "Athlétisme - interpréter des données",
    "en": "Track and field - Interpreting data",
    "de": "Leichtathletik - Daten auswerten",
    "pt": "Atletismo - interpretar dados"
  },
  "c4_m5_b_5_1_ope": {
    "fr": "Programmes de calcul d´Alice et de Bob",
    "en": "Alice's and Bob's Calculation Programs",
    "de": "Das Rechenprogramm von Alice und Bob",
    "pt": "Programas de cálculo da Alice e do Bob"
  },
  "c4_m5_c_1_1_ope": {
    "fr": "La règle du capitaine",
    "en": "Captain's rule",
    "de": "Die Regeln des Käpt'ns",
    "pt": "A regra do capitão"
  },
  "c4_m5_c_2_1_ope": {
    "fr": "Le menuisier",
    "en": "The Carpenter",
    "de": "Der Schreiner",
    "pt": "O marceneiro"
  },
  "c4_m5_c_3_1_ope": {
    "fr": "Trouver le modèle des points",
    "en": "Find the pattern in the dots",
    "de": "Punktmuster herausfinden",
    "pt": "Determinar o padrão"
  },

  "c4_m6_diagnostic": {
    "en": "Diagnostic (Geometry)",
    "fr": "Test diagnostique (géométrie)",
    "de": "Anfangstest (Geometrie)",
    "pt": "Teste diagnóstico (Geometria)"
  },
  "c4_m6_summative": {
    "en": "Summative Test (Geometry)",
    "fr": "Test bilan (géométrie)",
    "de": "Abschlusstest (Geometrie)",
    "pt": "Teste sumativo (Geometria)"
  },
  "c4_m6_formative_1": {
    "en": "Solids",
    "fr": "Solides",
    "de": "Körper",
    "pt": "Solides"
  },
  "c4_m6_formative_2": {
    "en": "Volume",
    "fr": "Volumes",
    "de": "Volumen",
    "pt": "Volumes"
  },
  "c4_m6_formative_3": {
    "en": "Perpendicular and Parallel",
    "fr": "Perpendidulaire, parallèle et symétrique",
    "de": "Senkrecht, parallel und symmetrisch",
    "pt": "Perpendidulaire, parallèle et symétrique"
  },
  "c4_m6_formative_4": {
    "en": "Converting Length",
    "fr": "Longueurs",
    "de": "Längen",
    "pt": "Longueurs"
  },
  "c4_m6_formative_5": {
    "en": "Converting Area",
    "fr": "Aires",
    "de": "Flächen",
    "pt": "Aires"
  },
  "c4_m6_a_1_1_mti_c4_m6_tom_arc": {
    "en": "Abacis and Metrâh - Tomb architechts",
    "pt": "Abacis e Metrâh - arquitetos de túmulos",
    "fr": "Abacis et Metrâh - architectes de tombes",
    "de": "Abacis und Metrâh - die kleinen Baumeister"
  },
  "c4_m6_a_1_2_ope": {
    "en": "Sorting solids - Curved surfaces, pyramids and prisms",
    "pt": "Separar sólidos - sólidos, pirâmides e prismas",
    "fr": "Trier des solides - surfaces courbées, pyramides et prismes",
    "de": "Körper sortieren - gebogene Flächen, Pyramiden und Prismen"
  },
  "c4_m6_a_1_3_ope": {
    "en": "Sorting solids - Make your own sorting!",
    "pt": "Separar sólidos - criar categorias !",
    "fr": "Trier des solides - trie selon tes propres catégories !",
    "de": "Körper sortieren - eigene Gruppen bilden"
  },
  "c4_m6_a_1_4_mti_c4_m6_tom_mod": {
    "en": "Find possible models for tombs",
    "pt": "Determinar figuras para túmulos",
    "fr": "Trouver des modèles pour des tombes",
    "de": "Modelle für Grabmale finden"
  },
  "c4_m6_a_1_5_ope": {
    "en": "Faces, edges, and vertices",
    "pt": "Faces, arestas e vértices",
    "fr": "Faces, arêtes et sommets",
    "de": "Flächen, Kanten und Ecken"
  },
  "c4_m6_a_1_6_ope": {
    "en": "The architect's secret formula",
    "pt": "A fórmula secreta do arquiteto",
    "fr": "La formule secrète de l´architecte",
    "de": "Die geheime Formel der Baumeister"
  },
  "c4_m6_a_1_7_mti_c4_m6_tom_bui": {
    "en": "Making models of the tombs",
    "pt": "Criar figuras pros túmulos",
    "fr": "Créer des modèles pour les tombes",
    "de": "Modelle für Grabmale bauen"
  },
  "c4_m6_a_1_8_ope": {
    "en": "Unfolding the models",
    "pt": "Desdobrar figuras",
    "fr": "Déplier des modèles",
    "de": "Modelle auseinanderfalten"
  },
  "c4_m6_a_2_1_mti_c4_m6_mea_ang": {
    "en": "Measuring steepness with angles",
    "pt": "Medir a inclinação com a ajuda de ângulos",
    "fr": "Mesurer la pente à l´aide d´angles",
    "de": "Steigungen mit Winkeln messen"
  },
  "c4_m6_a_3_1_mti_c4_m6_con_why": {
    "en": "Abacis and Metrâh convert lengths",
    "pt": "Abacis e Metrâh - Conversão de medidas de comprimentos",
    "fr": "Abacis et Metrâh - convertir des longueurs",
    "de": "Abacis und Metrâh - Längen umwandeln"
  },
  "c4_m6_a_3_2_mti_c4_m6_con_len_pt1": {
    "en": "Converting length - Conversion table (Part 1)",
    "pt": "Conversão de comprimentos - Tabela de conversão (Parte 1)",
    "fr": "Convertir des longueurs - Tableau de conversion (partie 1)",
    "de": "Längen umwandeln - Umwandlungstabelle (Teil 1)"
  },
  "c4_m6_a_3_3_mti_c4_m6_con_len_pt2": {
    "en": "Converting length - Conversion table (Part 2)",
    "pt": "Conversão de comprimentos - Tabela de conversão (Parte 2)",
    "fr": "Convertir des longueurs - Tableau de conversion (partie 2)",
    "de": "Längen umwandeln - Umwandlungstabelle (Teil 2)"
  },
  "c4_m6_a_3_4_ope": {
    "en": "Converting length - Practice (Part 1)",
    "pt": "Converter comprimentos - Exercícios de treino (parte 1)",
    "fr": "Convertir des longueurs - Exercices d´entraînement (partie 1)",
    "de": "Längen umwandeln - Übungen (Teil 1)"
  },
  "c4_m6_a_3_5_mti_c4_m6_con_len_pt4": {
    "en": "Converting length - Conversion table (Part 3)",
    "pt": "Conversão de comprimentos - Tabela de conversão (parte 3)",
    "fr": "Convertir des longueurs - Tableau de conversion (partie 3)",
    "de": "Längen umwandeln - Umwandlungstabelle (Teil 3)"
  },
  "c4_m6_a_3_6_ope": {
    "en": "Converting length - Practice (Part 2)",
    "pt": "Conversão de comprimentos - Exercícios (Parte 2)",
    "fr": "Convertir des longueurs - Exercices d´entraînement (partie 2)",
    "de": "Längen umwandeln - Übungen (Teil 2)"
  },
  "c4_m6_a_3_7_ope": {
    "en": "Converting length - Practice (Part 3)",
    "pt": "Conversão de comprimentos - Exercícios (Parte 3)",
    "fr": "Convertir des longueurs - Exercices d´entraînement (partie 3)",
    "de": "Längen umwandeln - Übungen (Teil 3)"
  },
  "c4_m6_a_3_8_mti_c4_m6_con_are": {
    "en": "Abacis and Metrâh - convert areas",
    "pt": "Abacis e Metrâh - Conversão de áreas",
    "fr": "Abacis et Metrâh - convertir des aires",
    "de": "Abacis und Metrâh - Flächen umwandeln"
  },
  "c4_m6_a_3_9_mti_c4_m6_con_are_tbl": {
    "en": "Converting area - Conversion table",
    "pt": "Conversão de áreas - Tabela de conversão",
    "fr": "Convertir des aires - Tableau de conversion",
    "de": "Flächen umwandeln - Umwandlungstabelle"
  },
  "c4_m6_a_3_10_ope": {
    "en": "Converting area - Practice",
    "pt": "Conversão de áreas - Exercícios",
    "fr": "Convertir des aires - Exercices d´entraînement",
    "de": "Flächen umwandeln - Übungen"
  },
  "c4_m6_a_3_11_mti_c4_m6_con_vol": {
    "en": "Abacis and Metrâh - convert volumes",
    "pt": "Abacis e Metrâh - Conversão de volumes",
    "fr": "Abacis et Metrâh - convertir des volumes",
    "de": "Abacis und Metrâh - Volumen umwandeln"
  },
  "c4_m6_a_3_12_mti_c4_m6_con_vol_tbl": {
    "en": "Converting volume - Conversion table",
    "pt": "Conversão de volumes - Tabela de conversão",
    "fr": "Convertir des volumes - Tableau de conversion",
    "de": "Volumen umwandeln - Umwandlungstabelle"
  },
  "c4_m6_a_3_13_ope": {
    "en": "Converting volume - Practice",
    "pt": "Conversão de volumes - Exercícios",
    "fr": "Convertir des volumes - Exercices d´entraînement",
    "de": "Volumen umwandeln - Übungen"
  },
  "c4_m6_a_3_14_ope": {
    "en": "Converting length, area, and volume - Practice",
    "pt": "Conversão de comprimentos, áreas e volumes - Exercícios",
    "fr": "Convertir des longueurs, des aires et des volumes - Exercices d´entraînement",
    "de": "Längen, Flächen und Volumen umwandeln - Übungen"
  },
  "c4_m6_a_4_1_mti_c4_m6_dec_tra": {
    "en": "Decorating the Tombs - Translations",
    "fr": "Décorer des tombes - translations",
    "de": "Grabmale dekorieren: Verschiebungen ",
    "pt": "Decorar túmulos - translações"
  },
  "c4_m6_a_4_2_ope": {
    "en": "Try out translations",
    "pt": "Utilizar translações",
    "fr": "Utiliser des translations",
    "de": "Verschiebungen anwenden"
  },
  "c4_m6_a_4_3_mti_c4_m6_dec_axi": {
    "en": "Decorating the tombs - Axial reflections",
    "pt": "Decorar túmulos - simetrias axiais",
    "fr": "Décorer des tombes - symétries axiales",
    "de": "Grabmale dekorieren - Achsensymmetrie"
  },
  "c4_m6_a_4_4_ope": {
    "en": "Try out axial reflections",
    "pt": "Utilizar simetrias axiais",
    "fr": "Utiliser des symétries axiales",
    "de": "Achsensymmetrie anwenden"
  },
  "c4_m6_a_4_5_mti_c4_m6_dec_rad": {
    "en": "Decorating the tombs - Radial reflections",
    "pt": "Decorar túmulos - simetrias centrais",
    "fr": "Décorer des tombes - symétries centrales",
    "de": "Grabmale dekorieren - Punktsymmetrie"
  },
  "c4_m6_a_4_6_ope": {
    "en": "Try out radial reflections",
    "pt": "Utilizar simetrias centrais",
    "fr": "Utiliser des symétries centrales",
    "de": "Punktsymmetrie anwenden"
  },
  "c4_m6_a_4_7_mti_c4_m6_dec_rot": {
    "en": "Decorating the tombs - Rotations",
    "pt": "Decorar túmulos - rotações",
    "fr": "Décorer des tombes - rotations",
    "de": "Grabmale dekorieren - Drehsymmetrie"
  },
  "c4_m6_b_1_1_ope": {
    "en": "Faulty nets",
    "pt": "Planificações erradas",
    "fr": "Mauvais patrons",
    "de": "Fehlerhafte Netze"
  },
  "c4_m6_b_2_1_ope": {
    "en": "Complete the cube",
    "pt": "Completar o cubo",
    "fr": "Compléter le cube",
    "de": "Würfel fertig bauen"
  },
  "c4_m6_b_3_1_ope": {
    "en": "Blocks and volume",
    "pt": "Blocos e o seu volume",
    "fr": "Des blocs et leur volume",
    "de": "Würfel und Volumen"
  },
  "c4_m6_b_3_2_ope": {
    "en": "Blocks and surface area",
    "pt": "Blocos e a área deles",
    "fr": "Des blocs et leur aire",
    "de": "Würfel und Flächeninhalt"
  },
  "c4_m6_b_4_1_ope": {
    "en": "Combining angles",
    "pt": "Combinar ângulos",
    "fr": "Combiner des angles",
    "de": "Winkel kombinieren"
  },
  "c4_m6_b_5_1_ope": {
    "en": "Ordering lengths",
    "pt": "Ordenar medidas de comprimento",
    "fr": "Ordonner des longueurs",
    "de": "Längen sortieren"
  },
  "c4_m6_b_5_2_ope": {
    "en": "Ordering areas",
    "pt": "Ordenar medições de áreas",
    "fr": "Ordonner des aires",
    "de": "Flächen sortieren"
  },
  "c4_m6_b_5_3_ope": {
    "en": "Ordering volumes",
    "pt": "Ordenar medições de volumes",
    "fr": "Ordonner des volumes",
    "de": "Volumen sortieren"
  },
  "c4_m6_b_6_1_ope": {
    "en": "Find the translated point",
    "pt": "Encontrar o ponto transformado por uma translação",
    "fr": "Trouver le point transformé par une translation",
    "de": "Finde den verschobenen Punkt"
  },
  "c4_m6_b_6_2_ope": {
    "en": "Place the translated point",
    "pt": "Colocar o ponto transformado por uma translação",
    "fr": "Placer le point transformé par une translation",
    "de": "Setze den verschobenen Punkt"
  },
  "c4_m6_b_6_3_ope": {
    "en": "Find the reflected point",
    "pt": "Encontrar o ponto simétrico",
    "fr": "Trouver le point symétrique",
    "de": "Finde den gespiegelten Punkt"
  },
  "c4_m6_b_6_4_ope": {
    "en": "Place the reflected point",
    "pt": "Colocar o ponto simétrico",
    "fr": "Placer le point symétrique",
    "de": "Setze den gespiegelten Punkt"
  },
  "c4_m6_b_7_1_ope": {
    "en": "Complete the tiling",
    "pt": "Completar o padrão",
    "fr": "Compléter le motif à tuiles",
    "de": "Beende das Muster"
  },
  "c4_m6_c_1_1_ope": {
    "en": "New York Cabbie",
    "pt": "O táxi em Nova Iorque",
    "fr": "Le taxi à New-York",
    "de": "Taxi in New York"
  },
  "c4_m6_c_2_1_ope": {
    "en": "Stamps - Which one doesn't belong?",
    "pt": "Carimbos - qual é que não serve?",
    "fr": "Tampons - lequel ne convient pas?",
    "de": "Stempel - Welcher passt nicht?"
  },
  "c4_m6_c_2_2_ope": {
    "en": "Stamps - Collect them all!",
    "pt": "Carimbos - coleciona-os todos!",
    "fr": "Tampons - collectionne les tous!",
    "de": "Stempel - finde alle Abdrücke!"
  },

  "mtic_c3_m34_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "c4_m6_b_6_3": {
    "en": "Find the reflected point",
    "pt": "Encontrar o ponto simétrico",
    "fr": "Trouver le point symétrique",
    "de": "Finde den gespiegelten Punkt"
  },

  "c4_m6_c_1_1": {
    "en": "New York Cabbie",
    "pt": "O táxi em Nova Iorque",
    "fr": "Le taxi à New-York",
    "de": "Taxi in New York"
  },

  "math_10062_ang": {
    "en": "Angles",
    "fr": "Angles",
    "pt": "Angles",
    "de": "Angles"
  },
  "math_10062_nat_num": {
    "en": "Natural Numbers",
    "fr": "Natural Numbers",
    "pt": "Natural Numbers",
    "de": "Natural Numbers"
  },
  "math_10062_frac": {
    "en": "Fractions",
    "fr": "Fractions",
    "pt": "Fractions",
    "de": "Fractions"
  },
  "math_10062_per": {
    "en": "Percents",
    "fr": "Percents",
    "pt": "Percents",
    "de": "Percents"
  },

  "math_10080_m1": {
    "en": "Mental Math",
    "fr": "Mental Math",
    "pt": "Mental Math",
    "de": "Mental Math"
  },
  "math_10080_m2": {
    "en": "Geometry and Measurement",
    "fr": "Geometry and Measurement",
    "pt": "Geometry and Measurement",
    "de": "Geometry and Measurement"
  },
  "math_10080_m3": {
    "en": "Natural Numbers",
    "fr": "Natural Numbers",
    "pt": "Natural Numbers",
    "de": "Natural Numbers"
  },
  "math_10080_m4": {
    "en": "Fractions",
    "fr": "Fractions",
    "pt": "Fractions",
    "de": "Fractions"
  },
  "math_10080_m5": {
    "en": "Data Management",
    "fr": "Data Management",
    "pt": "Data Management",
    "de": "Data Management"
  },

  "mtic_c3_m1v2_diagnostic": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "mtic_c3_m1v2_4stages": {
    "en": "Using the Logbook",
    "fr": "Utiliser le carnet",
    "pt": "Utilizar o bloco de notas",
    "de": "Mit dem Logbuch arbeiten"
  },
  "mtic_c3_m1v2_aquarium": {
    "en": "Aquarium",
    "fr": "À l'aquarium",
    "pt": "Aquário",
    "de": "Im Aquarium"
  },
  "mtic_c3_m1v2_lemurs": {
    "en": "Lemurs at the park",
    "fr": "Les singes au zoo",
    "pt": "Lémures no jardim zoológico",
    "de": "Affen im Zoo"
  },
  "mtic_c3_m1v2_stickers": {
    "en": "Stickers",
    "fr": "Autocollants",
    "pt": "Autocolantes",
    "de": "Sticker"
  },
  "mtic_c3_m1v2_tower": {
    "en": "Tower of Cubes",
    "fr": "Bâtir une tour",
    "pt": "Torre de blocos",
    "de": "Turm bauen"
  },
  "mtic_c3_m1v2_bike": {
    "en": "Bike tour",
    "fr": "Randonnée à vélo",
    "pt": "Volta de bicicleta",
    "de": "Radtour"
  },
  "mtic_c3_m1v2_granny": {
    "en": "Visiting Granny",
    "fr": "Visite chez grand-mère",
    "pt": "Visitar a avó",
    "de": "Besuch bei Oma"
  },
  "mtic_c3_m1v2_jump": {
    "en": "Jump",
    "fr": "Saut en longueur",
    "pt": "Salto",
    "de": "Weitsprung"
  },
  "mtic_c3_m1v2_zooshop": {
    "en": "Zoo Shop",
    "fr": "Boutique-souvenirs au zoo",
    "pt": "Loja do jardim zoológico",
    "de": "Souvenirladen im Zoo"
  },
  "mtic_c3_m1v2_skate": {
    "en": "The Skateshop",
    "fr": "Faire du skateboard",
    "pt": "O Skateshop",
    "de": "Skateboard fahren"
  },
  "mtic_c3_m1v2_camp": {
    "en": "Camping",
    "fr": "Camping",
    "pt": "Acampar",
    "de": "Zelten"
  },
  "mtic_c3_m1v2_stuffedanimal": {
    "en": "Stuffed Animals",
    "fr": "Peluches",
    "pt": "Loja de peluches",
    "de": "Stofftiere"
  },
  "mtic_c3_m1v2_elephants": {
    "en": "Elephants at the Park",
    "fr": "Les éléphants au zoo",
    "pt": "Elefantes no jardim zoológico",
    "de": "Elefanten im Zoo"
  },
  "mtic_c3_m1v2_train": {
    "en": "Train Trip",
    "fr": "Voyage en train",
    "pt": "Viagem de comboio",
    "de": "Zugfahrt"
  },
  "mtic_c3_m1v2_plane": {
    "en": "Plane Flight",
    "fr": "Voyage en avion",
    "pt": "Viagem de avião",
    "de": "Reise im Flugzeug"
  },
  "mtic_c3_m1v2_tram": {
    "en": "The Tram",
    "fr": "Le tramway",
    "pt": "O carro eléctrico",
    "de": "Die Tram"
  },

  "mtic_c3_m34_place_val": {
    "en": "Introduction to Place Value",
    "fr": "Tableau de numération - introduction",
    "de": "Stellentafel Einführung",
    "pt": "Introdução: Valor posicional"
  },
  "mtic_c3_m34_place_tool": {
    "en": "Comparing Numbers Using Place Value ",
    "fr": "Comparer des nombres en utilisant le tableau de numération",
    "de": "Zahlen vergleichen mit der Stellentafel",
    "pt": "Comparar numeros usando o valor posicional"
  },
  "mtic_c3_m34_toyfac_1k": {
    "en": "Toy Factory: 1 000",
    "fr": "Usine de jouets 1 000 ",
    "de": "Spielzeugfabrik 1 000",
    "pt": "Fábrica de brinquedos 1 000"
  },
  "mtic_c3_m34_toyfac_1m": {
    "en": "Toy Factory: 1 000 000",
    "fr": "Usine de jouets 1 000 000",
    "de": "Spielzeugfabrik 1 000 000",
    "pt": "Fábrica de brinquedos 1 000 000"
  },
  "mtic_c3_m34_num_zoom": {
    "en": "Numberline: Animal Rescue ",
    "fr": "Demi-droite graduée: Sauver des animaux ",
    "de": "Zahlenstrahl: Tiere retten",
    "pt": "Reta numérica: Resgatar animais"
  },
  "mtic_c3_m34_equal_lesn": {
    "en": "Magician Magicus - Presentation",
    "fr": "Magicien Magicus - Présentation",
    "de": "Zauberer Magicus - Vorstellung",
    "pt": "Ilusionista Magicus - Introdução"
  },
  "mtic_c3_m34_decomp_add": {
    "en": "Addition Decomposition Strategy",
    "fr": "Ligne de calcul - addition",
    "de": "Rechenstrich - Addition",
    "pt": "Reta numérica - Adição"
  },
  "mtic_c3_m34_decomp_sub": {
    "en": "Subtraction Decomposition Strategy",
    "fr": "Ligne de calcul - soustraction",
    "de": "Rechenstrich -  Subtraktion",
    "pt": "Reta numérica - Subtração "
  },
  "mtic_c3_m34_mult_tool": {
    "en": "Box Tool - Multiplication",
    "fr": "Outil boîte - multiplication",
    "de": "Box - Multiplikation",
    "pt": "Ferramenta caixa - Multiplicação"
  },
  "mtic_c3_m34_div_concept": {
    "en": "Concept of Division",
    "fr": "Concept de la division",
    "de": "Division",
    "pt": "Conceito da divisão"
  },
  "mtic_c3_m34_div_tool": {
    "en": "Box Tool - Division ",
    "fr": "Outil  boîte - division",
    "de": "Box - Division",
    "pt": "Ferramenta caixa - Divisão"
  },
  "mtic_c3_m34_dot": {
    "en": "Finding the Number of Dots",
    "fr": "Trouver le nombre de points",
    "de": "Zahlen durch Punkte darstellen ",
    "pt": "Descobrir o número de pontos"
  },
  "mtic_c3_m34_dot_invalid": {
    "en": "Invalid Number of Dots",
    "fr": "Nombre de points incorrect",
    "de": "Punkte korrigieren",
    "pt": "Número errado de pontos"
  },
  "mtic_c3_m34_comp_digit": {
    "en": "Comparing Individual Digits",
    "fr": "Comparer des nombres",
    "de": "Zahlen vergleichen",
    "pt": "Comparar algarismos individuais"
  },
  "mtic_c3_m34_toydeli_1k": {
    "en": "Deliver Toys: 1 000",
    "fr": "Commande de jouets: 1 000",
    "de": "Spielzeugversand: 1 000",
    "pt": "Entregar brinquedos: 1 000"
  },
  "mtic_c3_m34_toydeli_1m": {
    "en": "Deliver Toys: 1 000 000",
    "fr": "Commande de jouets: 1 000 000",
    "de": "Spielzeugversand: 1 000 000",
    "pt": "Entregar brinquedos: 1 000 000"
  },
  "mtic_c3_m34_briefcase": {
    "en": "Briefcase Clues",
    "fr": "Indices malettes",
    "de": "Schatzkisten knacken",
    "pt": "Desbloquear tesouros"
  },
  "mtic_c3_m34_helicopter": {
    "en": "Numberline: Animal Rescue 2",
    "fr": "Demi-droite graduée :Sauver des animaux 2",
    "de": "Zahlenstrahl: Tiere retten 2",
    "pt": "Reta numérica: Resgatar animais 2"
  },
  "mtic_c3_m34_equal_ex": {
    "en": "Magician Magicus - Tricks",
    "fr": "Magicien Magicus - défis",
    "de": "Zauberer Magicus - Aufgaben",
    "pt": "Ilusionista Magicus - Exercícios"
  },
  "mtic_c3_m34_decomp_tool": {
    "en": "Decomposition Tool Training",
    "fr": "Ligne de calcul - exercices",
    "de": "Rechenstrich - Übungen",
    "pt": "Reta numérica - Exercícios"
  },
  "mtic_c3_m34_zahlen_fill_intro": {
    "en": "Build the Wall Introduction",
    "fr": "Construire des pyramides - introduction",
    "de": "Zahlenmauern bauen",
    "pt": "Construir pirâmides numéricas - Introdução"
  },
  "mtic_c3_m34_zahlen_fill_lv1": {
    "en": "Small Walls - 50",
    "fr": "Petites pyramides 50",
    "de": "Kleine Zahlenmauern - 50",
    "pt": "Pequenas pirâmides - 50"
  },
  "mtic_c3_m34_zahlen_fill_lv2": {
    "en": "Small Walls - 100",
    "fr": "Petites pyramides 100",
    "de": "Kleine Zahlenmauern - 100",
    "pt": "Pequenas pirâmides - 100"
  },
  "mtic_c3_m34_zahlen_fill_lv3": {
    "en": "Small Walls - 500",
    "fr": "Petites pyramides 500",
    "de": "Kleine Zahlenmauern - 500",
    "pt": "Pequenas pirâmides - 500"
  },
  "mtic_c3_m34_zahlen_fill_lv4": {
    "en": "Big Walls - 50",
    "fr": "Grandes pyramides 50",
    "de": "Große Zahlenmauern - 50",
    "pt": "Grandes pirâmides - 50"
  },
  "mtic_c3_m34_zahlen_fill_lv5": {
    "en": "Big walls - 100",
    "fr": "Grandes pyramides 100",
    "de": "Große Zahlenmauern - 100",
    "pt": "Grandes pirâmides - 100"
  },
  "mtic_c3_m34_zahlen_fill_lv6": {
    "en": "Big Walls - 500",
    "fr": "Grandes pyramides 500",
    "de": "Große Zahlenmauern - 500",
    "pt": "Grandes pirâmides - 500"
  },
  "mtic_c3_m34_zahlen_empty_intro": {
    "en": "Complete the Bricks Introduction",
    "fr": "Compléter des pyramides - introduction",
    "de": "Zahlenmauern füllen - Einführung",
    "pt": "Completar pirâmides numéricas - Introdução"
  },
  "mtic_c3_m34_zahlen_empty_lv1": {
    "en": "Bottom Row - 50",
    "fr": "Rangée du bas - 50",
    "de": "Untere Reihe - 50",
    "pt": "Linha inferior - 50"
  },
  "mtic_c3_m34_zahlen_empty_lv2": {
    "en": "Bottom Row - 100",
    "fr": "Rangée du bas - 100",
    "de": "Untere Reihe - 100",
    "pt": "Linha inferior - 100"
  },
  "mtic_c3_m34_zahlen_empty_lv3": {
    "en": "Bottom Row - 1000",
    "fr": "Rangée du bas - 1000",
    "de": "Untere Reihe - 1000",
    "pt": "Linha inferior - 1000"
  },
  "mtic_c3_m34_zahlen_empty_lv4": {
    "en": "Mixed Bricks - 50",
    "fr": "Briques pêle-mêle - 50",
    "de": "Lücken - 50",
    "pt": "Blocos mistos - 50"
  },
  "mtic_c3_m34_zahlen_empty_lv5": {
    "en": "Mixed Bricks - 100",
    "fr": "Briques pêle-mêle - 100",
    "de": "Lücken - 100",
    "pt": "Blocos mistos - 100"
  },
  "mtic_c3_m34_zahlen_empty_lv6": {
    "en": "Mixed Bricks - 1000",
    "fr": "Briques pêle-mêle - 1000",
    "de": "Lücken - 1000",
    "pt": "Blocos mistos - 500"
  },
  "mtic_c3_m34_zahlen_empty_lv7": {
    "en": "Creative Walls - Capstone",
    "fr": "Pyramides créatives - sommet",
    "de": "Kreative Zahlenmauern - Schlussstein",
    "pt": "Pirâmides criativas - cimeira"
  },
  "mtic_c3_m34_zahlen_empty_lv8": {
    "en": "Creative Walls - mixed bricks",
    "fr": "Pyramides créatives - pêle-mêle",
    "de": "Kreative Zahlenmauern - Lücken",
    "pt": "Pirâmides criativas - blocos mistos"
  },
  "mtic_c3_m34_zahlen_empty_lv9": {
    "en": "Big Creative Walls",
    "fr": "Grandes pyramides créatives",
    "de": "Große kreative Zahlenmauern",
    "pt": "Completar pirâmides numéricas"
  },
  "mtic_c3_m34_addsub_clouds_lv1": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 1",
    "fr": "Nuage MathemaTIC - addition et soustraction 1",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 1",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 1"
  },
  "mtic_c3_m34_addsub_clouds_lv2": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 2",
    "fr": "Nuage MathemaTIC - addition et soustraction 2",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 2",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 2"
  },
  "mtic_c3_m34_addsub_clouds_lv3": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 3",
    "fr": "Nuage MathemaTIC - addition et soustraction 3",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 3",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 3"
  },
  "mtic_c3_m34_get_mult": {
    "en": "3 Ways to Get to A Number",
    "fr": "3 façons d'arriver à un nombre",
    "de": "Dreimal mit einer Zahl rechnen",
    "pt": "3 maneiras para obter um número"
  },
  "mtic_c3_m34_garden_mult_lv1": {
    "en": "Multiplication Garden: 1 Flower",
    "fr": "Jardin de multiplication 1 fleur",
    "de": "Multiplikationsgarten: 1 Blume",
    "pt": "Jardim de multiplicação: 1 flor"
  },
  "mtic_c3_m34_garden_mult_lv2": {
    "en": "Multiplication Garden: 2 Flowers",
    "fr": "Jardin de multiplication 2 fleurs",
    "de": "Multiplikationsgarten: 2 Blumen",
    "pt": "Jardim de multiplicação: 2 flores"
  },
  "mtic_c3_m34_garden_mult_lv3": {
    "en": "Multiplication Garden: 3 Flowers",
    "fr": "Jardin de multiplication 3 fleurs",
    "de": "Multiplikationsgarten: 3 Blumen",
    "pt": "Jardim de multiplicação: 3 flores"
  },
  "mtic_c3_m34_div_concept_ex": {
    "en": "Concept of Division Exercises",
    "fr": "Concept de la division - exercices",
    "de": "Division - Übungen",
    "pt": "Conceito da divisão - exercícios"
  },
  "mtic_c3_m34_get_div": {
    "en": "3 Ways to Divide a Number ",
    "fr": "3 façons pour diviser un nombre",
    "de": "Dreimal eine Zahl dividieren",
    "pt": "3 maneiras para dividir um número"
  },
  "mtic_c3_m34_multdiv_clouds_lv1": {
    "en": "MathemaTIC Clouds - Multiplication and Division 1",
    "fr": "Nuage MathemaTIC - multiplication et division 1",
    "de": "MathemaTIC Wolke - Multiplikation und Division 1",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 1"
  },
  "mtic_c3_m34_multdiv_clouds_lv2": {
    "en": "MathemaTIC Clouds - Multiplication and Division 2",
    "fr": "Nuage MathemaTIC - multiplication et division 2",
    "de": "MathemaTIC Wolke - Multiplikation und Division 2",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 2"
  },
  "mtic_c3_m34_multdiv_clouds_lv3": {
    "en": "MathemaTIC Clouds - Multiplication and DIvision 3",
    "fr": "Nuage MathemaTIC - multiplication et division 3",
    "de": "MathemaTIC Wolke - Multiplikation und Division 3",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 3"
  },
  "mtic_c3_m34_mixed_clouds_lv1": {
    "en": "MathemaTIC Clouds - Mixed Operation 1",
    "fr": "Nuage MathemaTIC - diverses opérations 1",
    "de": "MathemaTIC Wolke - Gemischte Übungen 1",
    "pt": "Nuvens MatemaTIC - Operações Mistas 1"
  },
  "mtic_c3_m34_mixed_clouds_lv2": {
    "en": "MathemaTIC Clouds - Mixed Operation 2",
    "fr": "Nuage MathemaTIC - diverses opérations 2",
    "de": "MathemaTIC Wolke - Gemischte Übungen 2",
    "pt": "Nuvens MatemaTIC - Operações Mistas 2"
  },
  "mtic_c3_m34_canoe_lv1": {
    "en": "Renting Canoes 1",
    "fr": "Location de canoës 1",
    "de": "Kanuverleih 1",
    "pt": "Aluguer de Canoas 1"
  },
  "mtic_c3_m34_canoe_lv2": {
    "en": "Renting Canoes 2 ",
    "fr": "Location de canoës 2",
    "de": "Kanuverleih 2",
    "pt": "Aluguer de Canoas 2"
  },
  "mtic_c3_m34_fishing_lv1": {
    "en": "Cargo Fishing - Level 1",
    "fr": "Navires de pêche - niveau 1",
    "de": "Fische fangen - Level 1",
    "pt": "Barcos de pesca - Nível 1"
  },
  "mtic_c3_m34_fishing_lv2": {
    "en": "Cargo Fishing - Level 2",
    "fr": "Navires de pêche - niveau 2",
    "de": "Fische fangen - Level 2",
    "pt": "Barcos de pesca - Nível 2"
  },
  "mtic_c3_m34_fishing_lv3": {
    "en": "Cargo Fishing - Level 3",
    "fr": "Navires de pêche - niveau 3",
    "de": "Fische fangen - Level 3",
    "pt": "Barcos de pesca - Nível 3"
  },
  "mtic_c3_m34_fishing_lv4": {
    "en": "Cargo Fishing - Level 4",
    "fr": "Navires de pêche - niveau 4",
    "de": "Fische fangen - Level 4",
    "pt": "Barcos de pesca - Nível 4"
  },

  "mtic_c3_m56_lab_1": {
    "en": "Moving in a maze",
    "fr": "Déplacement dans le labyrinthe",
    "de": "Fortbewegen im Labyrinth",
    "pt": "Mover-se no labirinto"
  },
  "mtic_c3_m56_lab_2": {
    "en": "Orientation with GPS",
    "fr": "Orientation par GPS",
    "de": "Orientierung mit GPS",
    "pt": "Orientação com o GPS"
  },
  "mtic_c3_m56_lab_3": {
    "en": "Key building and symmetries",
    "fr": "Constructions de figures et symétries",
    "de": "Figuren auslegen und Symmetrien",
    "pt": "Construção de figuras e simetrias"
  },
  "mtic_c3_m56_lab_4": {
    "en": "Symmetries",
    "fr": "Symétries",
    "de": "Symmetrien",
    "pt": "Simetrias"
  },
  "mtic_c3_m56_lab_5": {
    "en": "Time - set the clock",
    "fr": "Temps - régler l'heure",
    "de": "Zeit - Uhr stellen",
    "pt": "Tempo - acertar o relógio"
  },
  "mtic_c3_m56_lab_6": {
    "en": "Time - find a duration",
    "fr": "Temps - mesurer une durée",
    "de": "Zeit - Dauer messen",
    "pt": "Tempo - medir uma duração"
  },
  "mtic_c3_m56_lab_7": {
    "en": "Time - departure and arrival",
    "fr": "Temps - départ et arrivée",
    "de": "Zeit - Zeitpunkt bestimmen",
    "pt": "Tempo - hora de partida e de chegada"
  },
  "mtic_c3_m56_lab_8": {
    "en": "Perimeter",
    "fr": "Périmètre",
    "de": "Umfang",
    "pt": "Perímetro"
  },
  "mtic_c3_m56_lab_9": {
    "en": "Area",
    "fr": "Aire",
    "de": "Flächeninhalt",
    "pt": "Área"
  },
  "mtic_c3_m56_lab_10": {
    "en": "Perimeter and area",
    "fr": "Périmètre et aire",
    "de": "Umfang und Flächeninhalt",
    "pt": "Perímetro e área"
  },
  "mtic_c3_m56_lab_11": {
    "en": "Weight (g and kg)",
    "fr": "Poids (g et kg)",
    "de": "Gewicht (g und kg)",
    "pt": "Peso (g e kg)"
  },
  "mtic_c3_m56_lab_12": {
    "en": "Liquid measure (ml and l)",
    "fr": "Capacités (ml et l)",
    "de": "Hohlmaße (ml und l)",
    "pt": "Capacidades (ml e l)"
  },
  "mtic_c3_m56_lab_13": {
    "en": "Mix 1",
    "fr": "Mix 1",
    "de": "Mix 1",
    "pt": "Mix 1"
  },
  "mtic_c3_m56_lab_14": {
    "en": "Mix 2",
    "fr": "Mix 2",
    "de": "Mix 2",
    "pt": "Mix 2"
  },

  "mtic_gr910_m1": { "en": "Square Roots and Pythagoras", "fr": "Racines carrées et Pythagore", "de": "Quadratwurzeln", "pt": "Raízes quadradas e Pitágoras" },

  "mtic_g910_m1_group__sqr_rts": { "en": "Square Roots", "fr": "Racines carrées", "de": "Quadratwurzeln", "pt": "Raízes quadradas" },
  "mtic_g910_m1_group__pyth_theorem": { "en": "Pythagorean Theorem", "fr": "Théorème de Pythagore", "de": "Satz des Pythagoras", "pt": "Teorema de Pitágoras" },
  "mtic_g910_m1_group__thales_circle": { "en": "Thales Circle", "fr": "Cercle de Thalès", "de": "Satz des Thales", "pt": "Teorema de Tales" },

  "mtic_g910_m1_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g910_m1_summ": {
    "en": "Summative",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  "mtic_g910_m1_sqrts_intro_1": { "en": "Introduction to Square Roots", "fr": "Introduction aux racines carrées", "de": "Einführung in Quadratwurzeln", "pt": "Introdução - Raízes Quadradas" },
  "mtic_g910_m1_sqrts_intro_2": { "en": "Integer, Decimal, and Irrational Roots", "fr": "Racines naturelles, décim. et irrationnelles", "de": "Wurzeln - natürliche, Dezimal- und irrationale Zahlen", "pt": "Números Inteiros, Decimais e Raízes Irracionais" },
  "mtic_g910_m1_sqrts_def": { "en": "Definition of Square Roots", "fr": "Définition de la racine carrée", "de": "Definition der Quadratwurzel", "pt": "Definição de Raiz Quadrada" },
  "mtic_g910_m1_sqrts_prop": { "en": "Properties of Square Roots", "fr": "Propriétés des racines carrées", "de": "Eigenschaften der Quadratwurzel", "pt": "Propriedades das Raízes Quadradas" },
  "mtic_g910_m1_sqrts_simp": { "en": "Simplifying Square Roots", "fr": "Simplifier des racines carrées", "de": "Quadratwurzeln vereinfachen", "pt": "Simplificação de Raízes Quadradas" },
  "mtic_g910_m1_pyth_intro": { "en": "Introduction to Pythagorean Theorem", "fr": "Introduction au théorème de Pythagore", "de": "Einführung Satz des Pythagoras", "pt": "Introdução ao Teorema de Pitágoras" },
  "mtic_g910_m1_pyth_proof": { "en": "Proof of Pythagorean Theorem", "fr": "Preuve du théorème de Pythagore", "de": "Beweis des Satzes des Pythagoras", "pt": "Demonstração do Teorema de Pitágoras" },
  "mtic_g910_m1_pyth_theorem": { "en": "Setting Up Pythagorean Theorem", "fr": "Mise en place du théorème de Pythagore", "de": "Einsatz des Satzes des Pythagoras", "pt": "Definindo o Teorema de Pitágoras" },
  "mtic_g910_m1_pyth_use": { "en": "Using Pythagorean Theorem", "fr": "Utiliser le théorème de Pythagore", "de": "Anwendung des Satzes des Pythagoras", "pt": "Utilização do Teorema de Pitágoras" },
  "mtic_g910_m1_pyth_conv": { "en": "Converse of Pythagoren Theorem", "fr": "Réciproque du théorème de Pythagore", "de": "Umkehrsatz des Satzes des Pythagoras", "pt": "Aplicação do Teorema de Pitágoras" },
  "mtic_g910_m1_thales": { "en": "Thales Circle", "fr": "Cercle de Thalès", "de": "Satz des Thales", "pt": "Teorema de Tales" },
  "mtic_g910_m1_sqrts_intro_b": { "en": "Computing Square Roots", "fr": "Déterminer des racines carrées", "de": "Quadratwurzeln bestimmen", "pt": "Calcular Raízes Quadradas" },
  "mtic_g910_m1_sqrts_no_prop_b": { "en": "Comparing Square Roots", "fr": "Comparer des racines carrées", "de": "Quadratwurzeln vergleichen", "pt": "Comparar Raízes Quadradas" },
  "mtic_g910_m1_sqrts_prop_b": { "en": "Properties of Square Roots - Exercises", "fr": "Propriétés des racines carrées: exercice", "de": "Eigenschaften der Quadratwurzel - Übungen", "pt": "Propriedades das Raízes Quadradas - Exercícios" },
  "mtic_g910_m1_sqrts_simp_b": { "en": "Simplifying Square Roots - Exercises", "fr": "Simplifier des racines carrées: exercice", "de": "Quadratwurzeln vereinfachen - Übungen", "pt": "Simplificação de Raízes Quadradas" },
  "mtic_g910_m1_pyth_use_b": { "en": "Pythagorean Theorem - Exercises", "fr": "Théorème de Pythagore: exercice", "de": "Satz des Pythagoras - Übungen", "pt": "Teorema de Pitágoras - Exercícios" },
  "mtic_g910_m1_pyth_geo": { "en": "Pythagorean Theorem, Area, and Perimeter", "fr": "Théorème de Pythagore, aires et périmètres", "de": "Satz des Pythagoras, Flächeninhalt und Umfang", "pt": "Teorema de Pitágoras, Área e Perímetro" },
  "mtic_g910_m1_pyth_conv_b": { "en": "Identifying Right-Angled Triangles", "fr": "Identifier des triangles rectangles", "de": "Rechtwinklige Dreiecke erkennen", "pt": "Identificar triângulos retângulos" },
  "mtic_g910_m1_thales_b": { "en": "Thales Circle - Exercises", "fr": "Cercle de Thalès: exercice", "de": "Thaleskreis - Übungen", "pt": "Teorema de Tales - Exercícios" },
  "mtic_g910_m1_thales_pyth_b": { "en": "Pythagorean Theorem and Thales Circle", "fr": "Th. de Pyth. et cercle de Thalès: exercice", "de": "Satz des Pythagoras und Thaleskreis - Übungen", "pt": "Teorema de Pitágoras e de Tales" },
  "mtic_g910_m1_carrot": { "en": "Hop & Crunch: Square Roots", "fr": "Course à la carrotte: racines carrées", "de": "Möhrenjagd: Quadratwurzeln", "pt": "Hop & Crunch: Raízes Quadradas" },
  "mtic_g910_m1_attack_puz": { "en": "Square Root Attack - Puzzle Mode", "fr": "Chasse aux racines carrées", "de": "Wurzeljagd", "pt": "Ataque às Raízes Quadradas - Modo puzzle" },
  "mtic_g910_m1_attack_time": { "en": "Square Root Attack - Time Trial", "fr": "Chasse aux racines car. - contre-la-montre", "de": "Wurzeljagd - gegen die Zeit", "pt": "Ataque às Raízes Quadradas - Tempo" },
  "mtic_g910_m1_irrational": { "en": "Square Roots and Irrationals", "fr": "Racines carrées et nombres irrationnels", "de": "Wurzeln und irrationale Zahlen", "pt": "Raízes Quadradas e Números Irracionais" },
  "mtic_g910_m1_pyth_grid": { "en": "Square Roots on a Grid", "fr": "Racines carrées dans un quadrillage", "de": "Wurzeln im Koordinatengitter", "pt": "Raízes Quadradas" },
  "mtic_g910_m1_pyth_treasure": { "en": "Search for the Ancient Triangle", "fr": "À la recherche d'un triangle ancien", "de": "Auf der Suche nach dem antiken Dreieck", "pt": "À procura do «Antigo Triângulo»" },
  "mtic_g910_m1_pyth_3d": { "en": "Pythagorean Theorem in 3D", "fr": "Théorème de Pythagore dans l'espace", "de": "Satz des Pythagoras im Raum", "pt": "O Teorema de Pitágoras em 3D" },
  "mtic_g910_m1_pyth_maze": { "en": "Minotaur Maze", "fr": "Le labyrinthe de Minotaure", "de": "Das Labyrinth des Minotaurus", "pt": "Labirinto do Minotauro" },

  "mtic_gr910_m2": { "en": "Algebra", "fr": "Calcul littéral", "de": "Algebra", "pt": "Álgebra" },

  "mtic_g910_m2_group__intro_alg": { "en": "Introduction to Algebra", "fr": "Introduction", "de": "Einführung in die Algebra", "pt": "Álgebra: introdução" },
  "mtic_g910_m2_group__simp_alg_expr": { "en": "Simplifying Algebraic Expressions", "fr": "Simplifier", "de": "Algebraische Terme vereinfachen", "pt": "Simplificar Expressões Algébricas" },
  "mtic_g910_m2_group__dist": { "en": "Distributivity", "fr": "Distributivité", "de": "Distributivität", "pt": "Distributividade" },
  "mtic_g910_m2_group__factoring": { "en": "Factoring", "fr": "Factorisation", "de": "Faktorisieren", "pt": "Fatorização" },
  "mtic_g910_m2_group__calc_prog": { "en": "Calculation Programs", "fr": "Programmes de calculs", "de": "Rechenprogramme", "pt": "Programa de cálculo" },

  "mtic_g910_m2_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g910_m2_summ": {
    "en": "Summative",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  "mtic_g910_m2_grow_pat": { "en": "Growing Pattern", "fr": "Motif grandissant", "de": "Wachsende Muster", "pt": "Padrão crescente" },
  "mtic_g910_m2_alg_area": { "en": "Algebra in Areas", "fr": "Algèbre avec des aires", "de": "Algebra mit Flächeninhalten", "pt": "Álgebra com áreas" },
  "mtic_g910_m2_add_terms_ex": { "en": "Adding Like Monomials Exercises", "fr": "Exercice: réduire des monômes", "de": "Gleichartige Termglieder addieren - Übungen", "pt": "Exercícios: adição de monómios" },
  "mtic_g910_m2_rem_brackets_ex": { "en": "Removing Brackets Exercises", "fr": "Exercice: enlever des parenthèses", "de": "Klammern auflösen - Übungen", "pt": "Exercícios: remover parêntesis" },
  "mtic_g910_m2_mult_monom_ex": { "en": "Multiplying Monomials Exercises", "fr": "Exercice: multiplier des monômes", "de": "Termglieder multiplizieren - Übungen", "pt": "Exercícios: multiplicar monómios " },
  "mtic_g910_m2_prov_prog": { "en": "Proving with Programs", "fr": "Programme de calcul comme outil de preuve", "de": "Beweisen mit Hilfe von Rechenprogrammen", "pt": "Programa de cálculo como instrumento de prova" },
  "mtic_g910_m2_exp_and_var": { "en": "Variables and Expressions", "fr": "Notion de variable", "de": "Variable und Terme", "pt": "Noção de variável" },
  "mtic_g910_m2_alg_sums": { "en": "Algebraic Sums", "fr": "Somme algébrique", "de": "Algebraische Summen", "pt": "Soma algébrica" },
  "mtic_g910_m2_rearrang_terms": { "en": "Identifying and Rearranging Terms", "fr": "Réarranger des termes", "de": "Termglieder erkennen und umordnen", "pt": "Reordenar os termos numa expressão algébrica" },
  "mtic_g910_m2_add_terms": { "en": "Adding Like Monomials", "fr": "Somme de monômes semblables", "de": "Gleichartige eingliedrige Termglieder addieren", "pt": "Adição de monómios semelhantes" },
  "mtic_g910_m2_rem_brackets": { "en": "Removing Brackets", "fr": "Enlever des parenthèses", "de": "Klammern auflösen", "pt": "Remove os parêntesis" },
  "mtic_g910_m2_mult_monom": { "en": "Multiplying Monomials", "fr": "Produit de monômes", "de": "Eingliedrige Termglieder multiplizieren", "pt": "Multiplicar monómios" },
  "mtic_g910_m2_fractions": { "en": "Dealing with Fractions", "fr": "Coefficients fractionnaires", "de": "Umgang mit Brüchen", "pt": "Coeficientes fracionários" },
  "mtic_g910_m2_dist_simple": { "en": "Single Distributivity", "fr": "Simple distributivité simple ", "de": "Einfaches Distributivgesetz", "pt": "Distributividade simples" },
  "mtic_g910_m2_dist_double": { "en": "Double Distributivity", "fr": "Double distributivité ", "de": "Zweifaches Anwenden des Distributivgesetzes", "pt": "Distributividade dupla" },
  "mtic_g910_m2_dist_identities": { "en": "Expanding Remarkable Identities", "fr": "Développer à l'aide des id. remarq.", "de": "Klammern auflösen bei bestimmten Termen", "pt": "Casos notáveis: desenvolver expressões" },
  "mtic_g910_m2_factor_comm_1": { "en": "Common Factoring", "fr": "Factoriser par mise en évid. n:1", "de": "Gemeinsame Faktoren", "pt": "Fatorização: 1" },
  "mtic_g910_m2_factor_comm_2": { "en": "Common Factoring Extended", "fr": "Factoriser par mise en évid. n:2", "de": "Gemeinsame besondere Faktoren", "pt": "Fatorização: 2" },
  "mtic_g910_m2_factor_identities": { "en": "Factoring Remarkable Identities", "fr": "Factoriser à l'aide des id. remarq.", "de": "Faktorisieren - Identische Teilterme", "pt": "Fatorização: termos semelhantes" },
  "mtic_g910_m2_factor_comb": { "en": "Combining Factoring Techniques", "fr": "Factoriser à l'aide de 2 méthodes", "de": "Kombinieren von Methoden zum Faktorisieren", "pt": "Fatorização: combinar métodos" },
  "mtic_g910_m2_factor_group": { "en": "Factoring by Grouping", "fr": "Factoriser par groupement", "de": "Faktorisieren durch Zusammenfassen", "pt": "Fatorização: método de agrupamento" },
  "mtic_g910_m2_rearrange-_and_add_like_terms_b": { "en": "Adding Like Monomials Exercises", "fr": "Exercice: réduire des monômes", "de": "Gleichartige Termglieder addieren - Übungen", "pt": "Exercícios: adição de monómios" },
  "mtic_g910_m2_remove_brackets_and_add_like_terms_b": { "en": "Removing Brackets Exercises", "fr": "Exercice: enlever des parenthèses", "de": "Klammern auflösen - Übungen", "pt": "Exercícios: remover parêntesis" },
  "mtic_g910_m2_multiplying_monomials_b": { "en": "Multiplying Monomials Exercises", "fr": "Exercice: multiplier des monômes", "de": "Termglieder multiplizieren - Übungen", "pt": "Exercícios: multiplicar monómios " },
  "mtic_g910_m2_simplify": { "en": "Simplifying Algebraic Expressions", "fr": "Exercice: effectuer et réduire ", "de": "Terme vereinfachen - Übungen", "pt": "Exercícios: simplificar expressões algébricas" },
  "mtic_g910_m2_dist_simple_double_ex": { "en": "Distributivity Exercises", "fr": "Exercice: distr. simple et double", "de": "Distributivgesetz - Übungen", "pt": "Exercícios: distributividade" },
  "mtic_g910_m2_dist_identities_ex": { "en": "Expanding Remarkable Identities Exercises", "fr": "Exercice: développer-id. remarq.", "de": "Klammern auflösen bei best. Termen - Übungen", "pt": "Exercícios: casos notáveis" },
  "mtic_g910_m2_dist_comb_ex": { "en": "Expanding Expressions", "fr": "Exercice: développer toutes méth.", "de": "Terme auflösen - Übungen", "pt": "Exercícios: desenvolver expressões algébricas" },
  "mtic_g910_m2_factor_comm_ex": { "en": "Common Factoring Exercises", "fr": "Exercice: factoriser par mise en év.", "de": "Gemeinsame Faktoren - Übungen", "pt": "Exercícios: fatores comuns" },
  "mtic_g910_m2_factor_identities_ex": { "en": "Factoring Remarkable Identities Exercises", "fr": "Exercice: factoriser id. remarq.", "de": "Faktorisieren bestimmter Terme - Übungen", "pt": "Exercícios: casos notáveis" },
  "mtic_g910_m2_factor_group_ex": { "en": "Factoring by Grouping Exercises", "fr": "Exercice: fact. par groupement", "de": "Faktorisieren durch Zusammenfassen - Übungen", "pt": "Exercícios: fatorizar por agrupamento" },
  "mtic_g910_m2_factor_comb_ex": { "en": "Combined Factoring Exercises", "fr": "Exercice: factoriser toutes méth.", "de": "Methoden zum Faktorisieren - Übungen", "pt": "Exercícios: combinar métodos de fatorização" },
  "mtic_g910_m2_solve": { "en": "Creating an Expression", "fr": "Créer une expression algébrique", "de": "Terme aufstellen", "pt": "Criar uma expressão algébrica" },
  "mtic_g910_m2_sort_monom": { "en": "Sorting Like Monomials", "fr": "Trier des monômes", "de": "Gleichartige Termglieder ordnen", "pt": "Classificar monómios" },
  "mtic_g910_m2_puzz_simp": { "en": "Expanding Puzzle", "fr": "Puzzle: calcul littéral-développer", "de": "Klammern auflösen", "pt": "Expandir o puzzle: exercícios de cálculo " },
  "mtic_g910_m2_calc_prog": { "en": "Computer Laboratory", "fr": "Le labo. des program. de calcul", "de": "Computer Labor", "pt": "Laboratório de programas de cálculo" },
  "mtic_g910_m2_substitution": { "en": "Substituting Efficiently", "fr": "Valeur numérique d'une expr.", "de": "Effektiv ersetzen", "pt": "Valor numérico de uma expressão" },
  "mtic_g910_m2_puzz_factor": { "en": "Factoring Puzzle", "fr": "Puzzle: calcul littéral-factoriser", "de": "Faktorisieren - Puzzle", "pt": "Fatorização: Puzzle" },
  "mtic_g910_m2_calc_prog_1": { "en": "Calculation Programs (pt. 1)", "fr": "Programmes de calculs (pt. 1)", "de": "Rechenprogramme (pt. 1)", "pt": "Programas de cálculos (parte 1)" },
  "mtic_g910_m2_calc_prog_2": { "en": "Calculation Programs (pt. 2)", "fr": "Programmes de calculs (pt. 2)", "de": "Rechenprogramme (pt. 2)", "pt": "Programas de cálculos (parte 2)" },
  "mtic_g910_m2_calc_prog_3": { "en": "Calculation Programs (pt. 3)", "fr": "Programmes de calculs (pt. 3)", "de": "Rechenprogramme (pt. 3)", "pt": "Programas de cálculos (parte 3)" },

  "c4_m3_a_3_2_sou_fra_exp_vpm4": {
    "de": "Subtraktion von Brüchen",
    "en": "Subtraction of fractions",
    "fr": "Soustraction de fractions",
    "pt": "Subtração de frações"
  },
  "mtic_c3_m34_addsub_clouds_lv2_vpm4": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 2",
    "fr": "Nuage MathemaTIC - addition et soustraction 2",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 2",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 2"
  }, "c4_m3_a_2_2_com_fra_exp_vpm4": {
    "de": "Brüche vergleichen",
    "en": "Comparing fractions",
    "fr": "Comparer des fractions",
    "pt": "Comparar frações"
  }, "mtic_g78_m4_slushie_pt2_vpm4": {
    "en": "Chill Drink Master - Peak Flavour",
    "fr": "Granita - recettes pour experts",
    "de": "Slushi-Meister - Meister-Rezepte",
    "pt": "Chill Drink Master - Peak Flavour"
  }, "c4_m3_b_5_4_ope_vpm4": {
    "de": "Subtraktion von Brüchen (Teil 2)",
    "en": "Substraction of fractions (Part 2)",
    "fr": "Soustraction de fractions (partie 2)",
    "pt": "Subtração de frações (Parte 2)"
  }, "c4_m4_b_7_3_ope_vpm4": {
    "de": "Zeitspannen runden",
    "fr": "Arrondir des unités de temps",
    "en": "Rounding Time",
    "pt": "Arredondar medidas de tempo"
  },
  "mtic_g78_m9_tri_intro_vpm4": { "en": "Investigating Types of Triangles",
    "fr": "Les différents types de triangles",
    "de": "Untersuchung von Arten von Dreiecken",
    "pt": "Investigando tipos de triângulos"
  },

  "mtic_g78_m9_angle_find_vpm4": { "en": "Angles in Parallel Lines",
    "fr": "Exerice : angles formés par deux droites et une sécante",
    "de": "Winkel in parallelen Linien",
    "pt": "Ângulos em linhas paralelas" },

  "mtic_g78_m9_angle_parallel_vpm4": { "en": "Vertical and Alt. Interior Angles",
    "fr": "Angles formés par 2 dr. et 1 séc. ",
    "de": "Vertikal- und Innenwinkel",
    "pt": "Ângulos verticais e interiores" },

  "c4_m6_formative_2_vpm4": {
    "en": "Volume",
    "fr": "Volumes",
    "de": "Volumen",
    "pt": "Volumes"
  },
  "c4_m3_formative_2_vpm4": {
    "en": "Fractions on the Number Line",
    "fr": "Droite graduée",
    "de": "Zahlenstrahl",
    "pt": "Droite graduée"
  },

  "c4_m3_formative_4_vpm4": {
    "en": "Adding Fractions",
    "fr": "Additions",
    "de": "Addition",
    "pt": "Additions"
  },
  "c4_m3_formative_3_vpm4": {
    "en": "Multiplying Fractions",
    "fr": "Multiplication",
    "de": "Multiplikation",
    "pt": "Multiplication"
  },
  "c4_m4_formative_5_vpm4": {
    "en": "Converting Units",
    "fr": "Conversions",
    "de": "Umwandeln",
    "pt": "Conversions"
  },
  "c4_m6_a_3_9_mti_c4_m6_con_are_tbl_vpm4": {
    "en": "Converting area - Conversion table",
    "pt": "Conversão de áreas - Tabela de conversão",
    "fr": "Convertir des aires - Tableau de conversion",
    "de": "Flächen umwandeln - Umwandlungstabelle"
  },
  "c4_m6_a_3_8_mti_c4_m6_con_are_vpm4": {
    "en": "Abacis and Metrâh - convert areas",
    "pt": "Abacis e Metrâh - Conversão de áreas",
    "fr": "Abacis et Metrâh - convertir des aires",
    "de": "Abacis und Metrâh - Flächen umwandeln"
  },
  "c4_m6_a_3_13_ope_vpm4": {
    "en": "Converting volume - Practice",
    "pt": "Conversão de volumes - Exercícios",
    "fr": "Convertir des volumes - Exercices d´entraînement",
    "de": "Volumen umwandeln - Übungen"
  },
  "c4_m6_a_3_10_ope_vpm4": {
    "en": "Converting area - Practice",
    "pt": "Conversão de áreas - Exercícios",
    "fr": "Convertir des aires - Exercices d´entraînement",
    "de": "Flächen umwandeln - Übungen"
  },
  "c4_m4_c_1_1_ope_vpm4": {
    "de": "Saftautomat",
    "fr": "Distributeur automatique",
    "en": "Vending machine",
    "pt": "Máquina de venda automática"
  },
  "c4_m4_b_7_2_ope_vpm4": {
    "de": "Im Radio",
    "fr": "À l'antenne",
    "en": "On air",
    "pt": "No ar"
  },
  "c4_m4_b_7_1_ope_vpm4": {
    "de": "Zeitspannen umrechnen",
    "fr": "Conversion des unités de temps",
    "en": "Converting units of time",
    "pt": "Conversões de medidas de tempo"
  },
  "c4_m4_a_4_1_mti_c4_dec_exp_tim_vpm4": {
    "de": "Zeitspannen umrechnen",
    "fr": "Conversion des unités de temps",
    "en": "Converting Units of Time",
    "pt": "Conversões de medidas de tempo"
  },
  "c4_m3_b_6_2_ope_vpm4": {
    "de": "Multiplikation von Brüchen (Teil 2)",
    "en": "Multiplication of fractions (Part 2)",
    "fr": "Multiplication de fractions (partie 2)",
    "pt": "Multiplicação de frações (Parte 2)"
  },

  "c4_m3_b_6_1_ope_vpm4": {
    "de": "Multiplikation von Brüchen (Teil 1)",
    "en": "Multiplication of fractions (Part 1)",
    "fr": "Multiplication de fractions (partie 1)",
    "pt": "Multiplicação de frações (Parte 1)"
  },
  "c4_m3_b_5_3_ope_vpm4": {
    "de": "Addition von Brüchen (Teil 2)",
    "en": "Addition of fractions (Part 2)",
    "fr": "Addition de fractions (partie 2)",
    "pt": "Adição de frações (Parte 2)"
  },
  "c4_m3_b_5_2_ope_vpm4": {
    "de": "Subtraktion von Brüchen (Teil 1)",
    "en": "Substraction of fractions (Part 1)",
    "fr": "Soustraction de fractions (partie 1)",
    "pt": "Subtração das frações (Parte 1)"
  },
  "c4_m3_b_5_1_ope_vpm4": {
    "de": "Addition von Brüchen (Teil 1)",
    "en": "Addition of fractions (Part 1)",
    "fr": "Addition de fractions (partie 1)",
    "pt": "Adição de frações (Parte 1)"
  },
  "c4_m3_b_4_4_ope_vpm4": {
    "de": "Brüche einfügen",
    "en": "Inserting fractions",
    "fr": "Intercaler des fractions",
    "pt": "Intercalar frações"
  },
  "c4_m3_b_4_1_ope_vpm4": {
    "de": "Gleichwertige Brüche",
    "en": "Equivalent fractions",
    "fr": "Fractions équivalentes",
    "pt": "Frações equivalentes"
  },
  "c4_m3_b_3_2_ope_vpm4": {
    "de": "Den auf dem Zahlenstrahl dargestellten Bruch bestimmen",
    "en": "Determine the fraction from the number line",
    "fr": "Déterminer la fraction représentée sur la droite graduée",
    "pt": "Calcular a fração representada na régua graduada"
  },
  "c4_m3_b_3_1_ope_vpm4": {
    "de": "Einen Bruch auf den Zahlenstrahl setzen",
    "en": "Place the fraction on the number line",
    "fr": "Placer le point sur la droite graduée",
    "pt": "Colocar o ponto sobre a reta graduada"
  },
  "c4_m3_a_3_3_mul_fra_exp_vpm4": {
    "de": "Multiplikation von Brüchen",
    "en": "Multiplication of fractions",
    "fr": "Multiplication de fractions",
    "pt": "Multiplicação de frações"
  },
  "c4_m3_a_3_1_add_fra_exp_vpm4": {
    "de": "Addition von Brüchen",
    "en": "Addition of fractions",
    "fr": "Addition de fractions",
    "pt": "Adição de frações"
  },
  "c4_m3_a_2_3_equ_fra_exp_vpm4": {
    "de": "Gleichwertige Brüche",
    "en": "Equivalent fractions",
    "fr": "Fractions équivalentes",
    "pt": "Frações equivalentes"
  },
  "c4_m3_summative_vpm4": {
    "en": "Summative Test (Fractions)",
    "fr": "Test bilan (fractions)",
    "de": "Abschlusstest (Brüche)",
    "pt": "Teste sumativo (Frações)"
  },
  "c4_m6_summative_vpm4": {
    "en": "Summative Test (Geometry)",
    "fr": "Test bilan (géométrie)",
    "de": "Abschlusstest (Geometrie)",
    "pt": "Teste sumativo (Geometria)"
  },
  "c4_m4_summative_vpm4": {
    "en": "Summative Test (Decimal Numbers)",
    "fr": "Test bilan (nombres décimaux)",
    "de": "Abschlusstest (Dezimalzahlen)",
    "pt": "Teste sumativo (Números decimais)"
  },
  "c4_m4_c_2_1_mti_c4_dec_dep_vac_vpm4": {
    "de": "Einkaufen im Urlaub",
    "fr": "Dépenses de vacances",
    "en": "Vacation Shopping",
    "pt": "As despesas das férias"
  },
  "c4_m4_b_7_4_ope_vpm4": {
    "de": "Geldbeträge runden",
    "fr": "Arrondir des unités d'argent ",
    "en": "Rounding Money",
    "pt": "Arredondar quantias de dinheiro"
  },
  "c4_m4_a_4_2_mti_c4_dec_con_dar_vpm4": {
    "de": "Geldbeträge umrechnen",
    "fr": "Conversion d’argent",
    "en": "Converting Units of Money",
    "pt": "Conversão de dinheiro"
  },
  "c4_m3_b_4_2_ope_vpm4": {
    "de": "Brüche vergleichen",
    "en": "Comparing fractions",
    "fr": "Comparer des fractions",
    "pt": "Comparação de frações"
  },
  "mtic_c3_m34_fishing_lv2_vpm4": {
    "en": "Cargo Fishing - Level 2",
    "fr": "Navires de pêche - niveau 2",
    "de": "Fische fangen - Level 2",
    "pt": "Barcos de pesca - Nível 2"
  },
  "c4_m6_a_3_14_ope_vpm4": {
    "en": "Converting length, area, and volume - Practice",
    "pt": "Conversão de comprimentos, áreas e volumes - Exercícios",
    "fr": "Convertir des longueurs, des aires et des volumes - Exercices d´entraînement",
    "de": "Längen, Flächen und Volumen umwandeln - Übungen"
  },
  "c4_m6_b_5_3_ope_vpm4": {
    "en": "Ordering volumes",
    "pt": "Ordenar medições de volumes",
    "fr": "Ordonner des volumes",
    "de": "Volumen sortieren"
  },
  "mtic_c3_m34_zahlen_empty_lv4_vpm4": {
    "en": "Mixed Bricks - 50",
    "fr": "Briques pêle-mêle - 50",
    "de": "Lücken - 50",
    "pt": "Blocos mistos - 50"
  },
  "c4_m6_b_3_1_ope_vpm4": {
    "en": "Blocks and volume",
    "pt": "Blocos e o seu volume",
    "fr": "Des blocs et leur volume",
    "de": "Würfel und Volumen"
  },
  "c4_m3_b_4_3_ope_vpm4": {
    "de": "Brüche ordnen",
    "en": "Ordering fractions",
    "fr": "Ordonner des fractions",
    "pt": "Ordenar as frações"
  },
  "mtic_c3_m34_dot_invalid_vpm4": {
    "en": "Invalid Number of Dots",
    "fr": "Nombre de points incorrect",
    "de": "Punkte korrigieren",
    "pt": "Número errado de pontos"
  },
  "mtic_c3_m34_zahlen_empty_lv3_vpm4": {
    "en": "Bottom Row - 1000",
    "fr": "Rangée du bas - 1000",
    "de": "Untere Reihe - 1000",
    "pt": "Linha inferior - 1000"
  },
  "mtic_c3_m34_zahlen_empty_lv5_vpm4": {
    "en": "Mixed Bricks - 100",
    "fr": "Briques pêle-mêle - 100",
    "de": "Lücken - 100",
    "pt": "Blocos mistos - 100"
  },
  "mtic_c3_m34_mult_tool_vpm4": {
    "en": "Box Tool - Multiplication",
    "fr": "Outil boîte - multiplication",
    "de": "Box - Multiplikation",
    "pt": "Ferramenta caixa - Multiplicação"
  },
  "mtic_c3_m34_zahlen_empty_lv9_vpm4": {
    "en": "Big Creative Walls",
    "fr": "Grandes pyramides créatives",
    "de": "Große kreative Zahlenmauern",
    "pt": "Completar pirâmides numéricas"
  },
  "mtic_c3_m34_zahlen_fill_lv1_vpm4": {
    "en": "Small Walls - 50",
    "fr": "Petites pyramides 50",
    "de": "Kleine Zahlenmauern - 50",
    "pt": "Pequenas pirâmides - 50"
  },
  "mtic_c3_m34_addsub_clouds_lv3_vpm4": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 3",
    "fr": "Nuage MathemaTIC - addition et soustraction 3",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 3",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 3"
  },

  "mtic_c3_m34_zahlen_empty_lv2_vpm4": {
    "en": "Bottom Row - 100",
    "fr": "Rangée du bas - 100",
    "de": "Untere Reihe - 100",
    "pt": "Linha inferior - 100"
  },
  "mtic_c3_m34_addsub_clouds_lv1_vpm4": {
    "en": "MathemaTIC Clouds - Addition and Subtraction 1",
    "fr": "Nuage MathemaTIC - addition et soustraction 1",
    "de": "MathemaTIC Wolke - Addition und Subtraktion 1",
    "pt": "Nuvens MathemaTIC - Adição e Subtração 1"
  },
  "mtic_c3_m34_dot_vpm4": {
    "en": "Finding the Number of Dots",
    "fr": "Trouver le nombre de points",
    "de": "Zahlen durch Punkte darstellen ",
    "pt": "Descobrir o número de pontos"
  },
  "mtic_c3_m34_fishing_lv1_vpm4": {
    "en": "Cargo Fishing - Level 1",
    "fr": "Navires de pêche - niveau 1",
    "de": "Fische fangen - Level 1",
    "pt": "Barcos de pesca - Nível 1"
  },
  "mtic_c3_m34_get_div_vpm4": {
    "en": "3 Ways to Divide a Number ",
    "fr": "3 façons pour diviser un nombre",
    "de": "Dreimal eine Zahl dividieren",
    "pt": "3 maneiras para dividir um número"
  },
  "mtic_c3_m34_canoe_lv2_vpm4": {
    "en": "Renting Canoes 2 ",
    "fr": "Location de canoës 2",
    "de": "Kanuverleih 2",
    "pt": "Aluguer de Canoas 2"
  },
  "mtic_c3_m34_zahlen_fill_lv6_vpm4": {
    "en": "Big Walls - 500",
    "fr": "Grandes pyramides 500",
    "de": "Große Zahlenmauern - 500",
    "pt": "Grandes pirâmides - 500"
  },
  "mtic_c3_m34_zahlen_fill_lv2_vpm4": {
    "en": "Small Walls - 100",
    "fr": "Petites pyramides 100",
    "de": "Kleine Zahlenmauern - 100",
    "pt": "Pequenas pirâmides - 100"
  },
  "mtic_c3_m34_garden_mult_lv3_vpm4": {
    "en": "Multiplication Garden: 3 Flowers",
    "fr": "Jardin de multiplication 3 fleurs",
    "de": "Multiplikationsgarten: 3 Blumen",
    "pt": "Jardim de multiplicação: 3 flores"
  },
  "mtic_c3_m34_div_concept_vpm4": {
    "en": "Concept of Division Exercises",
    "fr": "Concept de la division - exercices",
    "de": "Division - Übungen",
    "pt": "Conceito da divisão - exercícios"
  },
  "mtic_c3_m34_zahlen_empty_lv1_vpm4": {
    "en": "Bottom Row - 50",
    "fr": "Rangée du bas - 50",
    "de": "Untere Reihe - 50",
    "pt": "Linha inferior - 50"
  },
  "mtic_c3_m34_div_tool_vpm4": {
    "en": "Box Tool - Division ",
    "fr": "Outil  boîte - division",
    "de": "Box - Division",
    "pt": "Ferramenta caixa - Divisão"
  },
  "mtic_c3_m34_fishing_lv3_vpm4": {
    "en": "Cargo Fishing - Level 3",
    "fr": "Navires de pêche - niveau 3",
    "de": "Fische fangen - Level 3",
    "pt": "Barcos de pesca - Nível 3"
  },
  "mtic_c3_m34_zahlen_empty_lv6_vpm4": {
    "en": "Mixed Bricks - 1000",
    "fr": "Briques pêle-mêle - 1000",
    "de": "Lücken - 1000",
    "pt": "Blocos mistos - 500"
  },
  "mtic_c3_m34_div_concept_ex_vpm4": {
    "en": "Concept of Division Exercises",
    "fr": "Concept de la division - exercices",
    "de": "Division - Übungen",
    "pt": "Conceito da divisão - exercícios"
  },
  "mtic_c3_m34_zahlen_fill_lv3_vpm4": {
    "en": "Small Walls - 500",
    "fr": "Petites pyramides 500",
    "de": "Kleine Zahlenmauern - 500",
    "pt": "Pequenas pirâmides - 500"
  },
  "mtic_c3_m34_zahlen_empty_intro_vpm4": {
    "en": "Complete the Bricks Introduction",
    "fr": "Compléter des pyramides - introduction",
    "de": "Zahlenmauern füllen - Einführung",
    "pt": "Completar pirâmides numéricas - Introdução"
  },
  "mtic_c3_m34_zahlen_fill_intro_vpm4": {
    "en": "Build the Wall Introduction",
    "fr": "Construire des pyramides - introduction",
    "de": "Zahlenmauern bauen",
    "pt": "Construir pirâmides numéricas - Introdução"
  },
  "mtic_c3_m34_zahlen_fill_lv5_vpm4": {
    "en": "Big walls - 100",
    "fr": "Grandes pyramides 100",
    "de": "Große Zahlenmauern - 100",
    "pt": "Grandes pirâmides - 100"
  },
  "mtic_g78_m4_slushie_pt1_vpm4": {
    "en": "Chill Drink - Starter Recipes",
    "fr": "Granita - recettes pour débutants",
    "de": "Slushi-Meister - Anfänger-Rezepte",
    "pt": "Chill Drink - Starter Recipes"
  },
  "mtic_c3_m34_canoe_lv1_vpm4": {
    "en": "Renting Canoes 1",
    "fr": "Location de canoës 1",
    "de": "Kanuverleih 1",
    "pt": "Aluguer de Canoas 1"
  },
  "mtic_g78_m4_conv_frac_vpm4": {
    "en": "Converting Fractions to Decimals",
    "fr": "Passer de l'écr. fract. en décimale ",
    "de": "Umwandeln: Brüche in Dez.",
    "pt": "Converting Fractions to Decimals"
  },
  "mtic_g78_m4_conv_dec_vpm4": {
    "en": "Converting Decimals to Fractions",
    "fr": "Passer de l'écr. déc. en fractionnaire",
    "de": "Umwandeln: Dez. in Brüche",
    "pt": "Converting Decimals to Fractions"
  },
  "mtic_c3_m34_zahlen_empty_lv7_vpm4": {
    "en": "Creative Walls - Capstone",
    "fr": "Pyramides créatives - sommet",
    "de": "Kreative Zahlenmauern - Schlussstein",
    "pt": "Pirâmides criativas - cimeira"
  },
  "mtic_c3_m34_zahlen_fill_lv4_vpm4": {
    "en": "Big Walls - 50",
    "fr": "Grandes pyramides 50",
    "de": "Große Zahlenmauern - 50",
    "pt": "Grandes pirâmides - 50"
  },
  "mtic_c3_m34_get_mult_vpm4": {
    "en": "3 Ways to Get to A Number",
    "fr": "3 façons d'arriver à un nombre",
    "de": "Dreimal mit einer Zahl rechnen",
    "pt": "3 maneiras para obter um número"
  },
  "mtic_c3_m34_comp_digit_vpm4": {
    "en": "Comparing Individual Digits",
    "fr": "Comparer des nombres",
    "de": "Zahlen vergleichen",
    "pt": "Comparar algarismos individuais"
  },
  "mtic_c3_m34_garden_mult_lv2_vpm4": {
    "en": "Multiplication Garden: 2 Flowers",
    "fr": "Jardin de multiplication 2 fleurs",
    "de": "Multiplikationsgarten: 2 Blumen",
    "pt": "Jardim de multiplicação: 2 flores"
  },
  "mtic_c3_m34_multdiv_clouds_lv3_vpm4": {
    "en": "MathemaTIC Clouds - Multiplication and DIvision 3",
    "fr": "Nuage MathemaTIC - multiplication et division 3",
    "de": "MathemaTIC Wolke - Multiplikation und Division 3",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 3"
  },
  "mtic_c3_m34_multdiv_clouds_lv1_vpm4": {
    "en": "MathemaTIC Clouds - Multiplication and Division 1",
    "fr": "Nuage MathemaTIC - multiplication et division 1",
    "de": "MathemaTIC Wolke - Multiplikation und Division 1",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 1"
  },
  "mtic_c3_m34_fishing_lv4_vpm4": {
    "en": "Cargo Fishing - Level 4",
    "fr": "Navires de pêche - niveau 4",
    "de": "Fische fangen - Level 4",
    "pt": "Barcos de pesca - Nível 4"
  },
  "mtic_c3_m34_garden_mult_lv1_vpm4": {
    "en": "Multiplication Garden: 1 Flower",
    "fr": "Jardin de multiplication 1 fleur",
    "de": "Multiplikationsgarten: 1 Blume",
    "pt": "Jardim de multiplicação: 1 flor"
  },
  "mtic_c3_m34_zahlen_empty_lv8_vpm4": {
    "en": "Creative Walls - mixed bricks",
    "fr": "Pyramides créatives - pêle-mêle",
    "de": "Kreative Zahlenmauern - Lücken",
    "pt": "Pirâmides criativas - blocos mistos"
  },
  "mtic_c3_m34_multdiv_clouds_lv2_vpm4": {
    "en": "MathemaTIC Clouds - Multiplication and Division 2",
    "fr": "Nuage MathemaTIC - multiplication et division 2",
    "de": "MathemaTIC Wolke - Multiplikation und Division 2",
    "pt": "Nuvens MathemaTIC - Multiplicação e Divisão 2"
  },
  "mtic_vp_m4": {
    "en": "Module 4",
    "fr": "Module 4",
    "de": "Modul 4",
    "pt": "Módulo 4"
  },
  "vp_m4_diag": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "c4_m6_a_3_12_mti_c4_m6_con_vol_tbl_vpm4": {
    "en": "Converting volume - Conversion table",
    "pt": "Conversão de volumes - Tabela de conversão",
    "fr": "Convertir des volumes - Tableau de conversion",
    "de": "Volumen umwandeln - Umwandlungstabelle"
  },

  "c4_m6_a_3_11_mti_c4_m6_con_vol_vpm4": {
    "en": "Abacis and Metrâh - convert volumes",
    "pt": "Abacis e Metrâh - Conversão de volumes",
    "fr": "Abacis et Metrâh - convertir des volumes",
    "de": "Abacis und Metrâh - Volumen umwandeln"
  },

  "mtic_g78_m4_conv_b_vpm5": {
    "en": "Odd One Out",
    "fr": "Chercher l'intrus",
    "de": "Was passt nicht dazu?",
    "pt": "Which Fraction Doesn't Belong?"
  },

  "mtic_g78_m1_diag_vpm5": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },

  "mtic_g78_m1_prop_table_a_vpm5": {
    "en": "The Proportionality Table",
    "fr": "Le tableau de proportionnalité",
    "pt": "Le tableau de proportionnalité",
    "de": "Die Proportionalitätstabelle"
  },

  "mtic_g78_m1_additivity_vpm5": {
    "en": "Additivity",
    "fr": "Additivité",
    "de": "Additivität",
    "pt": "Aditividade"
  },

  "mtic_g78_m1_linearity_vpm5": {
    "en": "Linearity",
    "fr": "Linéarité",
    "pt": "Linéarité",
    "de": "Linearität"
  },

  "mtic_g78_m1_prop_coef_vpm5": {
    "en": "Proportionality Coefficient",
    "fr": "Coefficient de proportionnalité",
    "pt": "Constante de proporcionalidade",
    "de": "Proportional oder nicht? - Quotientengleichheit"
  },

  "mtic_g78_m1_graph_form_vpm5": {
    "en": "Proportionality Graphs",
    "fr": "Représentation graphique",
    "pt": "Représentation graphique",
    "de": "Graph einer proportionalen Zuordnung"
  },

  "mtic_g78_m1_rule_three_vpm5": {
    "en": "Rule of 3",
    "fr": "Règle de 3",
    "pt": "Règle de 3",
    "de": "Dreisatz"
  },

  "mtic_g78_m1_conv_speed_vpm5": {
    "en": "Converting Speeds Part 1",
    "fr": "Convertir des unités de vitesses 1",
    "pt": "Convertir des unités de vitesses 1",
    "de": "Geschwindigkeiten umwandeln Teil 1"
  },

  "mtic_g78_m1_conv_speed_2_vpm5": {
    "en": "Converting Speeds Part 2",
    "fr": "Convertir des unités de vitesses 2",
    "pt": "Convertir des unités de vitesses 2",
    "de": "Geschwindigkeiten umwandeln Teil 2"
  },

  "mtic_g78_m4_add_b_vpm5": {
    "en": "Adding Fractions Exercises",
    "fr": "Addition de fractions: exercices",
    "de": "Brüche addieren: Übg.",
    "pt": "Adding Fractions Exercises"
  },

  "mtic_g78_m4_add_diff_vpm5": {
    "en": "Adding Fractions (Diff. Denom.)",
    "fr": "Addition de fract. (dén. diff.)",
    "de": "Addition (versch. Nenner)",
    "pt": "Adding Fractions (Diff. Denom.)"
  },

  "mtic_g78_m4_add_same_vpm5": {
    "en": "Adding Fractions (Same Denom.)",
    "fr": "Addition de fract. (même dén.)",
    "de": "Addition (gleicher Nenner)",
    "pt": "Adding Fractions (Same Denom.)"
  },

  "mtic_g78_m4_attack_puz_vpm5": {
    "en": "Fraction Attack",
    "fr": "Chasse aux fractions",
    "de": "Brüche-Jagd",
    "pt": "Equation Attack - Puzzle"
  },

  "mtic_g78_m4_bedmas_b_vpm5": {
    "en": "Order of Ops. in Fractions Exercises",
    "fr": "Fractions et ordre des op. : ex.",
    "de": "Reihenfolge: Übg.",
    "pt": "Order of Ops. in Fractions Exercises"
  },

  "mtic_g78_m4_conv_dec_vpm5": {
    "en": "Converting Decimals to Fractions",
    "fr": "Passer de l'écr. déc. en fractionnaire",
    "de": "Umwandeln: Dez. in Brüche",
    "pt": "Converting Decimals to Fractions"
  },

  "mtic_g78_m4_conv_frac_vpm5": {
    "en": "Converting Fractions to Decimals",
    "fr": "Passer de l'écr. fract. en décimale ",
    "de": "Umwandeln: Brüche in Dez.",
    "pt": "Converting Fractions to Decimals"
  },

  "mtic_g78_m4_div_b_vpm5": {
    "en": "Divide Fractions Exercises",
    "fr": "Division de fractions: exercices",
    "de": "Brüche dividieren: Übg.",
    "pt": "Divide Fractions Exercises"
  },

  "mtic_g78_m4_div_pt1_a_vpm5": {
    "en": "Dividing Fractions",
    "fr": "Division de fractions",
    "de": "Brüche dividieren",
    "pt": "Dividing Fractions"
  },

  "mtic_g78_m4_div_pt2_a_vpm5": {
    "en": "Fractions Within Fractions",
    "fr": "Quotient de 2 fractions",
    "de": "Doppelbrüche",
    "pt": "Fractions Within Fractions"
  },

  "mtic_g78_m4_mahjong_vpm5": {
    "en": "Math Mahjong",
    "fr": "Math Mahjong",
    "de": "Mathe Mahjong",
    "pt": "Math Mahjong"
  },

  "mtic_g78_m4_mult_a_pt1_vpm5": {
    "en": "Multiplying Fractions - Intro",
    "fr": "Mult. de fractions: intro",
    "de": "Brüche mult. - Einf.",
    "pt": "Multiplying Fractions - Intro"
  },

  "mtic_g78_m4_mult_a_pt2_vpm5": {
    "en": "Multiplying Fractions - Spec. Cases",
    "fr": "Mult. de fractions: cas spéciaux",
    "de": "Brüche mult. - Spezialfälle",
    "pt": "Multiplying Fractions - Spec. Cases"
  },

  "mtic_g78_m4_mult_a_pt3_vpm5": {
    "en": "Multiplying 3 Fractions",
    "fr": "Multiplication de 3 fractions",
    "de": "Multipl. dreier Brüche",
    "pt": "Multiplying 3 Fractions"
  },

  "mtic_g78_m4_mult_b_pt1_vpm5": {
    "en": "Multiply Fractions Exercises",
    "fr": "Mult. de fractions: ex.",
    "de": "Brüche mult.: Übg.",
    "pt": "Multiply Fractions Exercises"
  },

  "mtic_g78_m4_mult_b_pt2_vpm5": {
    "en": "Multiplying Multiple Fractions Exercises",
    "fr": "Mult. de plusieurs fractions: ex.",
    "de": "Mult. mehrere Brüche: Übg.",
    "pt": "Multiply Many Fractions Exercises"
  },

  "mtic_g78_m4_multi_tutorial_vpm5": {
    "en": "Fraction Multi-tool",
    "fr": 'Tutoriel de l\'outil "multi-tâches"',
    "de": "Tutorial \"Brüche-Multi-Tool\"",
    "pt": "Fraction Multi-tool"
  },

  "mtic_g78_m4_sub_a_vpm5": {
    "en": "Subtracting Fractions",
    "fr": "Soustraction de fractions",
    "de": "Brüche subtrahieren",
    "pt": "Subtracting Fractions"
  },

  "mtic_g78_m4_sub_b_vpm5": {
    "en": "Subtracting Fractions Exercises",
    "fr": "Soustraction de fractions: exercices",
    "de": "Brüche subtrahieren: Übg.",
    "pt": "Subtracting Fractions Exercises"
  },

  "c4_m6_formative_3_vpm5": {
    "en": "Perpendicular and Parallel",
    "fr": "Perpendidulaire, parallèle et symétrique",
    "de": "Senkrecht, parallel und symmetrisch",
    "pt": "Perpendidulaire, parallèle et symétrique"
  },

  "c4_m5_a_2_2_mti_c4_m5_pou_par_2_vpm5": {
    "fr": "Pourcentages - dans le jardin",
    "en": "Percentages - Vegetable garden",
    "de": "Prozente - im Gemüsegarten",
    "pt": "Percentagens - na horta"
  },

  "c4_m5_c_1_1_ope_vpm5": {
    "fr": "La règle du capitaine",
    "en": "Captain's rule",
    "de": "Die Regeln des Käpt'ns",
    "pt": "A regra do capitão"
  },

  "c4_m6_summative_vpm5": {
    "en": "Summative Test (Geometry)",
    "fr": "Test bilan (géométrie)",
    "de": "Abschlusstest (Geometrie)",
    "pt": "Teste sumativo (Geometria)"
  },

  "c4_m6_a_4_1_mti_c4_m6_dec_tra_vpm5": {
    "en": "Decorating the Tombs - Translations",
    "fr": "Décorer des tombes - translations",
    "de": "Grabmale dekorieren: Verschiebungen ",
    "pt": "Decorar túmulos - translações"
  },

  "c4_m6_a_4_2_ope_vpm5": {
    "en": "Try out translations",
    "pt": "Utilizar translações",
    "fr": "Utiliser des translations",
    "de": "Verschiebungen anwenden"
  },

  "c4_m6_a_4_4_ope_vpm5": {
    "en": "Try out axial reflections",
    "pt": "Utilizar simetrias axiais",
    "fr": "Utiliser des symétries axiales",
    "de": "Achsensymmetrie anwenden"
  },

  "c4_m6_a_4_5_mti_c4_m6_dec_rad_vpm5": {
    "en": "Decorating the tombs - Radial reflections",
    "pt": "Decorar túmulos - simetrias centrais",
    "fr": "Décorer des tombes - symétries centrales",
    "de": "Grabmale dekorieren - Punktsymmetrie"
  },

  "c4_m6_a_4_6_ope_vpm5": {
    "en": "Try out radial reflections",
    "pt": "Utilizar simetrias centrais",
    "fr": "Utiliser des symétries centrales",
    "de": "Punktsymmetrie anwenden"
  },

  "c4_m6_b_6_2_ope_vpm5": {
    "en": "Place the translated point",
    "pt": "Colocar o ponto transformado por uma translação",
    "fr": "Placer le point transformé par une translation",
    "de": "Setze den verschobenen Punkt"
  },

  "c4_m6_b_6_1_ope_vpm5": {
    "en": "Find the translated point",
    "pt": "Encontrar o ponto transformado por uma translação",
    "fr": "Trouver le point transformé par une translation",
    "de": "Finde den verschobenen Punkt"
  },

  "c4_m6_b_6_3_ope_vpm5": {
    "en": "Find the reflected point",
    "pt": "Encontrar o ponto simétrico",
    "fr": "Trouver le point symétrique",
    "de": "Finde den gespiegelten Punkt"
  },

  "c4_m6_b_6_4_ope_vpm5": {
    "en": "Place the reflected point",
    "pt": "Colocar o ponto simétrico",
    "fr": "Placer le point symétrique",
    "de": "Setze den gespiegelten Punkt"
  },

  "c4_m6_b_7_1_ope_vpm5": {
    "en": "Complete the tiling",
    "pt": "Completar o padrão",
    "fr": "Compléter le motif à tuiles",
    "de": "Beende das Muster"
  },

  "mtic_g78_m4_attack_time_vpm5": {
    "en": "Fraction Attack - Time Trial",
    "fr": "Chasse aux fractions - contre-la-montre",
    "de": "Brüche-Jagd - Gegen die Uhr",
    "pt": "Equation Attack - Time Trial"
  },

  "mtic_g78_m4_bedmas_a_vpm5": {
    "en": "Order of Operations in Fractions",
    "fr": "Fractions et ordre des opérations",
    "de": "Reihenfolge beim Rechnen",
    "pt": "Order of Operations in Fractions"
  },

  "c4_m6_a_4_3_mti_c4_m6_dec_axi_vpm5": {
    "en": "Decorating the tombs - Axial reflections",
    "pt": "Decorar túmulos - simetrias axiais",
    "fr": "Décorer des tombes - symétries axiales",
    "de": "Grabmale dekorieren - Achsensymmetrie"
  },

  "c4_m6_a_4_7_mti_c4_m6_dec_rot_vpm5": {
    "en": "Decorating the tombs - Rotations",
    "pt": "Decorar túmulos - rotações",
    "fr": "Décorer des tombes - rotations",
    "de": "Grabmale dekorieren - Drehsymmetrie"
  },

  "c4_m5_a_2_1_mti_c4_m5_pou_vpm5": {
    "fr": "Pourcentages - introduction",
    "en": "Percentages - Introduction",
    "de": "Prozente - Einführung",
    "pt": "Percentagens - introdução"
  },

  // VP Modules 6,7,8

  "mtic_g78_m5_rules_sub_vpm6": {
    "en": "Subtracting Integers",
    "fr": "Relatifs: soustraction",
    "de": "Ganze Z.: Subtraktion",
    "pt": "Relatifs: soustraction"
  },
  "mtic_g78_m5_rules_add_vpm6": {
    "en": "Adding Integers",
    "fr": "Relatifs: addition",
    "de": "Ganze Z.: Addition",
    "pt": "Relatifs: addition"
  },
  "mtic_g78_m5_comp_a_vpm6": {
    "en": "Comparing Integers",
    "fr": "Comparer des relatifs",
    "de": "Ganze Z.: Vergleich",
    "pt": "Comparer des relatifs"
  },
  "mtic_g78_m5_num_line_vpm6": {
    "en": "Integers on the Number Line",
    "fr": "Relatifs et droite graduée",
    "de": "Ganze Z.: Zahlenstrahl",
    "pt": "Relatifs et droite graduée"
  },
  "mtic_g78_m5_num_series_vpm6": {
    "en": "Open the Lock",
    "fr": "Ouvrir la serrure",
    "de": "Knack das Schloss",
    "pt": "Ouvrir la serrure"
  },
  "mtic_g78_m5_simp_form_vpm6": {
    "en": "Simplified Form",
    "fr": "Ecriture simplifiée",
    "de": "Vereinf. Schreibweise",
    "pt": "Ecriture simplifiée"
  },
  "mtic_g78_m5_order_vpm6": {
    "en": "Comparing Integers Exercises",
    "fr": "Comparer des relatifs: exercices",
    "de": "Ganze Z.: Vergleich Üb",
    "pt": "Comparer des relatifs: exercices"
  },
  "mtic_g78_m5_mult_div_pt2_vpm6": {
    "en": "Multiply and Divide Integers - Pt 2",
    "fr": "Produit et quotient avec rel. 2",
    "de": "Ganze Z.: Prod/Quot T2",
    "pt": "Produit et quotient avec rel. 2"
  },

  "mtic_g78_m5_dice_add_vpm6": {
    "en": "Addition Dice Game",
    "fr": "Addition - Jeu de dés",
    "de": "Addition - Spiel",
    "pt": "Addition - Jeu de dés"
  },

  "mtic_g78_m5_add_sub_b_vpm6": {
    "en": "Add and Subtract Exercises",
    "fr": "Add. et soustr.: exercices",
    "de": "Ganze Z.: Add/Subt Üb",
    "pt": "Add. et soustr.: exercices"
  },
  "mtic_g78_m5_ball_puz_vpm6": {
    "en": "Total Orbs - Puzzle",
    "fr": "Attaque aux relatifs",
    "de": "Jagd auf ganze Z.",
    "pt": "Attaque aux relatifs"
  },
  "mtic_g78_m5_ball_time_vpm6": {
    "en": "Total Orbs - Time Trial",
    "fr": "Attaque - contre-la-montre",
    "de": "Jagd auf ganze Z. - Zeit",
    "pt": "Attaque - contre-la-montre"
  },
  "mtic_g78_m5_mult_div_pt3_vpm6": {
    "en": "Multiply and Divide Integers - Pt 3",
    "fr": "Produit et quotient avec rel. 3",
    "de": "Ganze Z.: Prod/Quot T3",
    "pt": "Produit et quotient avec rel. 3"
  },
  "mtic_g78_m5_mult_div_b_vpm6": {
    "en": "Multiply and Divide Exercises",
    "fr": "Produit et quotient: exercices",
    "de": "Ganze Z.: Prod/Quot Üb",
    "pt": "Produit et quotient: exercices"
  },
  "mtic_g78_m3_bracket_wo_pt2_vpm6": {
    "en": "Solving Equations Without Brackets (Part 2)",
    "fr": "Résolution des équations sans parenthèses Partie 2",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 2)",
    "pt": "Résolution des équations sans parenthèses Partie 2"
  },
  "mtic_g78_m3_game_sub_pt2_vpm6": {
    "en": "Balance Game (Part 2)",
    "fr": "Jeu de la balance Partie 2",
    "de": "Gleichgewichtsspiel (Teil 2)",
    "pt": "Jeu de la balance Partie 2"
  },
  "mtic_g78_m3_game_sub_pt1_vpm6": {
    "en": "Balance Game (Part 1)",
    "fr": "Jeu de la balance",
    "de": "Gleichgewichtsspiel (Teil 1)",
    "pt": "Jeu de la balance"
  },
  "mtic_g78_m2_distrib_exer_vpm6": {
    "en": "Simple Distributivity: Exercises",
    "fr": "Distributivité simple: exercices",
    "de": "Das Distributivgesetz - Übungen",
    "pt": "Distributividade simples: exercícios"
  },
  "mtic_g78_m2_dist_act_vpm6": {
    "en": "Distributivity in Action",
    "fr": "Distributivité en action",
    "de": "Anwendung des Distributivgesetzes",
    "pt": "Distribuição em ato"
  },
  "mtic_g78_m3_bracket_incl_vpm6": {
    "en": "Solving Equations With Brackets",
    "fr": "Résolution des équations avec parenthèses",
    "de": "Lösen von Gleichungen mit Klammern",
    "pt": "Résolution des équations avec parenthèses"
  },

  "mtic_g78_m3_inver_oper_pt2_vpm6": {
    "en": "Inverse Operations (Part 2)",
    "fr": "Opérations inverses Partie 2",
    "de": "Umkehroperationen (Teil 2)",
    "pt": "Opérations inverses Partie 2"
  },

  "mtic_g78_m5_place_ops_vpm6": {
    "en": "4 Times 5 Makes 9?",
    "fr": "4 fois 5 donne 9?",
    "de": "4 mal 5 macht 9?",
    "pt": "4 fois 5 donne 9?"
  },
  "mtic_g78_m5_mult_div_pt1_vpm6": {
    "en": "Multiply and Divide Integers - Pt 1",
    "fr": "Produit et quotient avec rel. 1",
    "de": "Ganze Z.: Prod/Quot T1",
    "pt": "Produit et quotient avec rel. 1"
  },
  "mtic_g78_m5_intro_neg_vpm6": {
    "en": "Intro to Integers",
    "fr": "Intro. nombres relatifs",
    "de": "Einf.: ganze Zahlen",
    "pt": "Intro. nombres relatifs"
  },
  "mtic_g78_m5_dice_sub_vpm6": {
    "en": "Subtraction Dice Game",
    "fr": "Soustraction - Jeu de dés",
    "de": "Subtraktion - Spiel",
    "pt": "Soustraction - Jeu de dés"
  },
  "mtic_g78_m5_diagnostic_vpm6": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m2_diag_inbook_vpm6": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "mtic_g78_m3_alg_balance_vpm6": {
    "en": "From Balances to Equations",
    "fr": "Balance et équations",
    "de": "Gleichgewicht und Gleichungen",
    "pt": "Balance et équations"
  },
  "mtic_g78_m3_bracket_wo_vpm6": {
    "en": "Solving Equations Without Brackets (Part 1)",
    "fr": "Résolution des équations sans parenthèses Partie 1",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 1)",
    "pt": "Résolution des équations sans parenthèses Partie 1"
  },
  "mtic_g78_m3_sub_method_vpm6": {
    "en": "Solving by Substituting",
    "fr": "Résolution par substitution",
    "de": "Lösen durch Substitution",
    "pt": "Résolution par substitution"
  },
  "mtic_g78_m3_inver_oper_vpm6": {
    "en": "Inverse Operations (Part 1)",
    "fr": "Opérations inverses",
    "de": "Umkehroperationen (Teil 1)",
    "pt": "Opérations inverses"
  },
  "mtic_g78_m8_c7_vpm7": {
    "en": "Volume of Comp. Shapes",
    "fr": "Volume de figures composées",
    "de": "Volumen zus.ges Figuren",
    "pt": "Volume de figures composées"
  },
  "c4_m6_formative_2_vpm7": {
    "en": "Volume",
    "fr": "Volumes",
    "de": "Volumen",
    "pt": "Volumes"
  },
  "mtic_g78_m8_b7_vpm7": {
    "en": "Volume of Pyramids Exercises",
    "fr": "Volume des pyramides: exercices",
    "de": "Volumen Pyr. Übungen",
    "pt": "Volume des pyramides: exercices"
  },
  "mtic_g78_m8_a11_vpm7": {
    "en": "Volume of Pyramids and Cones",
    "fr": "Volume des pyramides et cônes",
    "de": "Volumen Pyr., Kegel",
    "pt": "Volume des pyramides et cônes"
  },
  "c4_m6_a_3_13_ope_vpm7": {
    "en": "Converting volume - Practice",
    "pt": "Conversão de volumes - Exercícios",
    "fr": "Convertir des volumes - Exercices d´entraînement",
    "de": "Volumen umwandeln - Übungen"
  },
  "c4_m6_a_3_12_mti_c4_m6_con_vol_tbl_vpm7": {
    "en": "Converting volume - Conversion table",
    "pt": "Conversão de volumes - Tabela de conversão",
    "fr": "Convertir des volumes - Tableau de conversion",
    "de": "Volumen umwandeln - Umwandlungstabelle"
  },
  "c4_m6_a_3_11_mti_c4_m6_con_vol_vpm7": {
    "en": "Abacis and Metrâh - convert volumes",
    "pt": "Abacis e Metrâh - Conversão de volumes",
    "fr": "Abacis et Metrâh - convertir des volumes",
    "de": "Abacis und Metrâh - Volumen umwandeln"
  },
  "c4_m6_b_5_3_ope_vpm7": {
    "en": "Ordering volumes",
    "pt": "Ordenar medições de volumes",
    "fr": "Ordonner des volumes",
    "de": "Volumen sortieren"
  },
  "c4_m6_b_3_1_ope_vpm7": {
    "en": "Blocks and volume",
    "pt": "Blocos e o seu volume",
    "fr": "Des blocs et leur volume",
    "de": "Würfel und Volumen"
  },
  "mtic_g78_m8_b4_vpm7": {
    "en": "Volume of Prisms Exercises",
    "fr": "Volume des prismes: exercices",
    "de": "Volumen Prisma Übungen",
    "pt": "Volume des prismes: exercices"
  },
  "mtic_g78_m8_a8_vpm7": {
    "en": "Volume of Prisms",
    "fr": "Volume des prismes",
    "de": "Volumen Prisma",
    "pt": "Volume des prismes"
  },
  "mtic_g78_m3_bracket_wo_pt2_vpm7": {
    "en": "Solving Equations Without Brackets (Part 2)",
    "fr": "Résolution des équations sans parenthèses Partie 2",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 2)",
    "pt": "Résolution des équations sans parenthèses Partie 2"
  },
  "mtic_g78_m3_class_eq_vpm7": {
    "en": "Classifying Equations",
    "fr": "Classement des équations",
    "de": "Klassifizierung von Gleichungen",
    "pt": "Classement des équations"
  },

  "mtic_g78_m3_game_sub_pt2_vpm7": {
    "en": "Balance Game (Part 2)",
    "fr": "Jeu de la balance Partie 2",
    "de": "Gleichgewichtsspiel (Teil 2)",
    "pt": "Jeu de la balance Partie 2"
  },
  "mtic_g78_m3_game_sub_pt1_vpm7": {
    "en": "Balance Game (Part 1)",
    "fr": "Jeu de la balance",
    "de": "Gleichgewichtsspiel (Teil 1)",
    "pt": "Jeu de la balance"
  },
  "mtic_g78_m3_inver_oper_pt2_vpm7": {
    "en": "Inverse Operations (Part 2)",
    "fr": "Opérations inverses Partie 2",
    "de": "Umkehroperationen (Teil 2)",
    "pt": "Opérations inverses Partie 2"
  },
  "mtic_g78_m8_a101_vpm7": {
    "en": "Volume of Cylinders",
    "fr": "Volume des cylindres",
    "de": "Volumen Zylinder",
    "pt": "Volume des cylindres"
  },
  "mtic_g78_m3_diag_vpm7": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "mtic_g78_m3_alg_balance_vpm7": {
    "en": "From Balances to Equations",
    "fr": "Balance et équations",
    "de": "Gleichgewicht und Gleichungen",
    "pt": "Balance et équations"
  },
  "mtic_g78_m3_bracket_wo_vpm7": {
    "en": "Solving Equations Without Brackets (Part 1)",
    "fr": "Résolution des équations sans parenthèses Partie 1",
    "de": "Lösen von Gleichungen ohne Klammern (Teil 1)",
    "pt": "Résolution des équations sans parenthèses Partie 1"
  },
  "mtic_g78_m3_sub_method_vpm7": {
    "en": "Solving by Substituting",
    "fr": "Résolution par substitution",
    "de": "Lösen durch Substitution",
    "pt": "Résolution par substitution"
  },
  "mtic_g78_m3_inver_oper_vpm7": {
    "en": "Inverse Operations (Part 1)",
    "fr": "Opérations inverses",
    "de": "Umkehroperationen (Teil 1)",
    "pt": "Opérations inverses"
  },

  "mtic_g78_m9_tri_const_b_vpm8": {
    "en": "Constructing Triangles",
    "fr": "Construire des triangles",
    "de": "Dreiecke konstruieren",
    "pt": "Construire des triangles"
  },
  "mtic_g78_m9_tri_const_a_pt1_vpm8": {
    "en": "Triangle Construction (SSS)",
    "fr": "Construction des triangles (CCC)",
    "de": "Dreieckskonstruktion (SSS)",
    "pt": "Construction des triangles (CCC)"
  },
  "mtic_g78_m9_tri_const_a_pt3_vpm8": {
    "en": "Triangle Construction (ASA and SAS)",
    "fr": "Construction des triangles (ACA-CAC)",
    "de": "Dreieckskonstruktion (WSW und SWS)",
    "pt": "Construction des triangles (ACA-CAC)"
  },
  "mtic_g78_m9_tri_const_a_pt2_vpm8": {
    "en": "Triangle Construction (AAA)",
    "fr": "Construction des triangles (AAA)",
    "de": "Dreieckskonstruktion (WWW)",
    "pt": "Construction des triangles (AAA)"
  },
  "mtic_g78_m4_diagnostic_vpm8": {
    "en": "Diagnostic Test",
    "fr": "Test diagnostic",
    "de": "Anfangstest",
    "pt": "Teste diagnóstico"
  },
  "c4_m3_c_3_2_ope_vpm8": {
    "de": "Zahnräder (Teil 2)",
    "en": "Gears (Part 2)",
    "fr": "Engrenages (partie 2)",
    "pt": "Engrenagens (Parte 2)"
  },
  "c4_m3_b_6_2_ope_vpm8": {
    "de": "Multiplikation von Brüchen (Teil 2)",
    "en": "Multiplication of fractions (Part 2)",
    "fr": "Multiplication de fractions (partie 2)",
    "pt": "Multiplicação de frações (Parte 2)"
  },
  "c4_m3_b_6_1_ope_vpm8": {
    "de": "Multiplikation von Brüchen (Teil 1)",
    "en": "Multiplication of fractions (Part 1)",
    "fr": "Multiplication de fractions (partie 1)",
    "pt": "Multiplicação de frações (Parte 1)"
  },
  "c4_m3_b_5_4_ope_vpm8": {
    "de": "Subtraktion von Brüchen (Teil 2)",
    "en": "Substraction of fractions (Part 2)",
    "fr": "Soustraction de fractions (partie 2)",
    "pt": "Subtração de frações (Parte 2)"
  },
  "c4_m3_b_5_3_ope_vpm8": {
    "de": "Addition von Brüchen (Teil 2)",
    "en": "Addition of fractions (Part 2)",
    "fr": "Addition de fractions (partie 2)",
    "pt": "Adição de frações (Parte 2)"
  },
  "c4_m3_b_5_2_ope_vpm8": {
    "de": "Subtraktion von Brüchen (Teil 1)",
    "en": "Substraction of fractions (Part 1)",
    "fr": "Soustraction de fractions (partie 1)",
    "pt": "Subtração das frações (Parte 1)"
  },
  "c4_m3_b_5_1_ope_vpm8": {
    "de": "Addition von Brüchen (Teil 1)",
    "en": "Addition of fractions (Part 1)",
    "fr": "Addition de fractions (partie 1)",
    "pt": "Adição de frações (Parte 1)"
  },
  "c4_m3_a_3_3_mul_fra_exp_vpm8": {
    "de": "Multiplikation von Brüchen",
    "en": "Multiplication of fractions",
    "fr": "Multiplication de fractions",
    "pt": "Multiplicação de frações"
  },

  "c4_m3_a_3_1_add_fra_exp_vpm8": {
    "de": "Addition von Brüchen",
    "en": "Addition of fractions",
    "fr": "Addition de fractions",
    "pt": "Adição de frações"
  },

  "c4_m2_b_3_3_com_mul_vpm8": {
    "en": "Find common multiples",
    "fr": "Identifier des multiples communs",
    "de": "Gemeinsame Vielfache finden",
    "pt": "Reconhecer múltiplos comuns"
  },
  "c4_m3_summative_vpm8": {
    "en": "Summative Test (Fractions)",
    "fr": "Test bilan (fractions)",
    "de": "Abschlusstest (Brüche)",
    "pt": "Teste sumativo (Frações)"
  },
  "c4_m3_diagnostic_vpm8": {
    "en": "Diagnostic (Fractions)",
    "fr": "Test diagnostique (fractions)",
    "de": "Anfangstest (Brüche)",
    "pt": "Teste diagnóstico (Frações)"
  },
  "c4_m3_c_3_1_ope_vpm8": {
    "de": "Zahnräder (Teil 1)",
    "en": "Gears (Part 1)",
    "fr": "Engrenages (partie 1)",
    "pt": "Engrenagens (Parte 1)"
  },

  "mtic_g78_m4_summ_vpm8": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },

  "c4_m3_a_3_2_sou_fra_exp_vpm8": {
    "de": "Subtraktion von Brüchen",
    "en": "Subtraction of fractions",
    "fr": "Soustraction de fractions",
    "pt": "Subtração de frações"
  },
  "mtic_c3_m34_get_div_vpm8": {
    "en": "3 Ways to Divide a Number ",
    "fr": "3 façons pour diviser un nombre",
    "de": "Dreimal eine Zahl dividieren",
    "pt": "3 maneiras para dividir um número"
  },
  "mtic_c3_m34_garden_mult_lv3_vpm8": {
    "en": "Multiplication Garden: 3 Flowers",
    "fr": "Jardin de multiplication 3 fleurs",
    "de": "Multiplikationsgarten: 3 Blumen",
    "pt": "Jardim de multiplicação: 3 flores"
  },
  "mtic_g78_m4_conv_frac_vpm8": {
    "en": "Converting Fractions to Decimals",
    "fr": "Passer de l'écr. fract. en décimale ",
    "de": "Umwandeln: Brüche in Dez.",
    "pt": "Converting Fractions to Decimals"
  },

  "mtic_g78_m4_conv_dec_vpm8": {
    "en": "Converting Decimals to Fractions",
    "fr": "Passer de l'écr. déc. en fractionnaire",
    "de": "Umwandeln: Dez. in Brüche",
    "pt": "Converting Decimals to Fractions"
  },
  "mtic_c3_m34_get_mult_vpm8": {
    "en": "3 Ways to Get to A Number",
    "fr": "3 façons d'arriver à un nombre",
    "de": "Dreimal mit einer Zahl rechnen",
    "pt": "3 maneiras para obter um número"
  },
  "mtic_g78_m4_conv_b_vpm8": {
    "en": "Odd One Out",
    "fr": "Chercher l'intrus",
    "de": "Was passt nicht dazu?",
    "pt": "Which Fraction Doesn't Belong?"
  },
  "mtic_c3_m34_comp_digit_vpm8": {
    "en": "Comparing Individual Digits",
    "fr": "Comparer des nombres",
    "de": "Zahlen vergleichen",
    "pt": "Comparar algarismos individuais"
  },

  "mtic_c3_m34_garden_mult_lv2_vpm8": {
    "en": "Multiplication Garden: 2 Flowers",
    "fr": "Jardin de multiplication 2 fleurs",
    "de": "Multiplikationsgarten: 2 Blumen",
    "pt": "Jardim de multiplicação: 2 flores"
  },
  "mtic_c3_m34_garden_mult_lv1_vpm8": {
    "en": "Multiplication Garden: 1 Flower",
    "fr": "Jardin de multiplication 1 fleur",
    "de": "Multiplikationsgarten: 1 Blume",
    "pt": "Jardim de multiplicação: 1 flor"
  },

  // VP Modules 5,6,7,8 Module Names
  "mtic_vp_m5": {
    "en": "Module 5",
    "fr": "Module 5",
    "de": "Modul 5",
    "pt": "Módulo 5"
  },
  "mtic_vp_m6": {
    "en": "Module 6",
    "fr": "Module 6",
    "de": "Modul 6",
    "pt": "Módulo 6"
  },
  "mtic_vp_m7": {
    "en": "Module 7",
    "fr": "Module 7",
    "de": "Modul 7",
    "pt": "Módulo 7"
  },

  "mtic_vp_m8": {
    "en": "Module 8",
    "fr": "Module 8",
    "de": "Modul 8",
    "pt": "Módulo 8"
  },

  "mtic_vp_m9": {
    "en": "Module 9",
    "fr": "Module 9",
    "de": "Modul 9",
    "pt": "Módulo 9"
  },

  "agenda_error_update": {
    "en": "Oops! Something went wrong. The Agenda was not updated. Please try again.",
    "fr": "Oops! Quelque chose n'a pas fonctionné. L'agenda n'a pas été mis à jour. Veuillez réessayer.",
    "de": "Oops! Quelque chose n'a pas fonctionné. L'agenda n'a pas été mis à jour. Veuillez réessayer.",
    "pt": "Ops! Algo não funcionou. O calendário não foi atualizado. Por favor, tenta novamente."
  },
  "agenda_error_publish": {
    "en": "Oops! Something went wrong. The Agenda was not published. Please try again.",
    "fr": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été publié. Veuillez réessayer.",
    "de": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été publié. Veuillez réessayer.",
    "pt": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été publié. Veuillez réessayer."
  },
  "agenda_error_delete": {
    "en": "Oops! Something went wrong. The Agenda was not deleted. Please try again.",
    "fr": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été supprimé. Veuillez réessayer.",
    "de": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été supprimé. Veuillez réessayer.",
    "pt": "Oops! Quelque chose n'a pas fonctionné. L’agenda n’a pas été supprimé. Veuillez réessayer."
  },
  "agenda_error_save": {
    "en": "Oops! Something went wrong. The changes to the Agenda were not saved. Please try again.",
    "fr": "Oops! Quelque chose n'a pas fonctionné. Les modifications apportées à l'agenda n'ont pas été enregistrées. Veuillez réessayer.",
    "de": "Oops! Quelque chose n'a pas fonctionné. Les modifications apportées à l'agenda n'ont pas été enregistrées. Veuillez réessayer.",
    "pt": "Oops! Quelque chose n'a pas fonctionné. Les modifications apportées à l'agenda n'ont pas été enregistrées. Veuillez réessayer."
  },
  "agenda_empty_student_list": {
    "en": "Please select atleast 1 student, or the whole class",
    "fr": "Please select atleast 1 student, or the whole class",
    "de": "Please select atleast 1 student, or the whole class",
    "pt": "Please select atleast 1 student, or the whole class"
  },

  "load_more": {
    "en": 'load more...',
    "fr": 'charger davantage ...',
    "de": 'mehr laden ...',
    "pt": 'carregar mais ...'
  },

  "c4_maintenance_header": {
    "en": 'Cycle 4 Under Maintenance',
    "fr": 'Cycle 4 en maintenance',
    "de": 'Cycle 4 en maintenance',
    "pt": 'Cycle 4 en maintenance'
  },
  "c4_maintenance_body": {
    "en": 'For the next few days, please excuse some disabled features and minor display issues. These will be corrected shortly.',
    "fr": "Durant les prochains jours, veuillez excuser certaines fonctionnalités désactivées et des problèmes d'affichage mineurs. Ils seront corrigés sous peu.",
    "de": "Durant les prochains jours, veuillez excuser certaines fonctionnalités désactivées et des problèmes d'affichage mineurs. Ils seront corrigés sous peu.",
    "pt": "Durant les prochains jours, veuillez excuser certaines fonctionnalités désactivées et des problèmes d'affichage mineurs. Ils seront corrigés sous peu."
  },

  "gr78_maintenance_header": {
    "en": 'Cycle inferieur – under maintenance',
    "fr": 'Cycle inférieur – en maintenance',
    "de": 'Cycle inferieur – under maintenance',
    "pt": 'Cycle inferieur – under maintenance'
  },
  "gr78_maintenance_body": {
    "en": 'The implementation of German and Portuguese will be made gradually. We are revising the texts and interactions. Thanks you for your understanding.',
    "fr": "L’implémentation de l’allemand et du portugais sera faite au fur et à mesure. Nous révisons les textes et les interactions. Merci pour votre compréhension.",
    "de": "The implementation of German and Portuguese will be made gradually. We are revising the texts and interactions. Thanks you for your understanding.",
    "pt": "The implementation of German and Portuguese will be made gradually. We are revising the texts and interactions. Thanks you for your understanding."
  },

  "c3_maintenance_body": {
    "en": 'This module is being reviewed by the didactics team who are working on an upgraded experience for learners.',
    "fr": "Ce module est en cours de révision par l'équipe de didactique.",
    "de": "This module is being reviewed by the didactics team who are working on an upgraded experience for learners.",
    "pt": "This module is being reviewed by the didactics team who are working on an upgraded experience for learners."
  },
  "module_is_locked": {
    "en": "This module is locked!",
    "fr": "Ce module est verrouillé.",
    "de": "Dieses Modul ist gesperrt!",
    "pt": "Ce module est verrouillé."
  },

  "run_like_math_addition_lv": {
    "en": 'Mental Math Addition Level',
    "fr": 'Calcul Mental Addition Niveau',
    "de": 'Kopfrechnen Addition Level',
    "pt": 'Cálculo Mental Adição Nível'
  },
  "run_like_math_subtraction_lv": {
    "en": 'Mental Math Subtraction Level',
    "fr": 'Calcul Mental Soustraction Niveau',
    "de": 'Kopfrechnen Subtraktion Level',
    "pt": 'Cálculo Mental Subtração Nível'
  },
  "run_like_math_multiplication_lv": {
    "en": 'Mental Math Multiplication Level',
    "fr": 'Calcul Mental Multiplication Niveau',
    "de": 'Kopfrechnen Multiplikation Level',
    "pt": 'Cálculo Mental Multiplicação Nível'
  },
  "run_like_math_division_lv": {
    "en": 'Mental Math Division Level',
    "fr": 'Calcul Mental Division Niveau',
    "de": 'Kopfrechnen Division Level',
    'pt': 'Cálculo Mental Divisão Nível'
  },
  "run_like_math_addition_lv_short": {
    "en": 'Level __ - Addition',
    "fr": 'Niveau __ - Addition',
    "de": 'Niveau __ - Addition',
    "pt": 'Nível __ - Adição'
  },
  "run_like_math_subtraction_lv_short": {
    "en": 'Level __ - Subtraction',
    "fr": 'Niveau __ - Soustraction',
    "de": 'Niveau __ - Subtraktion',
    "pt": 'Nível __ - Subtração'
  },
  "run_like_math_multiplication_lv_short": {
    "en": 'Level __ - Multiplication',
    "fr": 'Niveau __ - Multiplication',
    "de": 'Niveau __ - Multiplikation',
    "pt": 'Nível __ - Multiplicação'
  },
  "run_like_math_division_lv_short": {
    "en": 'Level __ - Division',
    "fr": 'Niveau __ - Division',
    "de": 'Niveau __ - Division',
    'pt': 'Nível __ - Divisão'
  },

  //RLM item names

  //Addition
  "run_like_math_addition_lv_1": {
    "en": 'Mental Math Addition Level 1',
    "fr": 'Calcul Mental Addition Niveau 1',
    "de": 'Kopfrechnen Addition Level 1',
    'pt': 'Cálculo Mental Adição Nível 1'
  },
  "run_like_math_addition_lv_2": {
    "en": 'Mental Math Addition Level 2',
    "fr": 'Calcul Mental Addition Niveau 2',
    "de": 'Kopfrechnen Addition Level 2',
    'pt': 'Cálculo Mental Adição Nível 2'
  },
  "run_like_math_addition_lv_3": {
    "en": 'Mental Math Addition Level 3',
    "fr": 'Calcul Mental Addition Niveau 3',
    "de": 'Kopfrechnen Addition Level 3',
    'pt': 'Cálculo Mental Adição Nível 3'
  },
  "run_like_math_addition_lv_4": {
    "en": 'Mental Math Addition Level 4',
    "fr": 'Calcul Mental Addition Niveau 4',
    "de": 'Kopfrechnen Addition Level 4',
    'pt': 'Cálculo Mental Adição Nível 4'
  },
  "run_like_math_addition_lv_5": {
    "en": 'Mental Math Addition Level 5',
    "fr": 'Calcul Mental Addition Niveau 5',
    "de": 'Kopfrechnen Addition Level 5',
    'pt': 'Cálculo Mental Adição Nível 5'
  },
  "run_like_math_addition_lv_6": {
    "en": 'Mental Math Addition Level 6',
    "fr": 'Calcul Mental Addition Niveau 6',
    "de": 'Kopfrechnen Addition Level 6',
    'pt': 'Cálculo Mental Adição Nível 6'
  },
  "run_like_math_addition_lv_7": {
    "en": 'Mental Math Addition Level 7',
    "fr": 'Calcul Mental Addition Niveau 7',
    "de": 'Kopfrechnen Addition Level 7',
    'pt': 'Cálculo Mental Adição Nível 7'
  },
  "run_like_math_addition_lv_8": {
    "en": 'Mental Math Addition Level 8',
    "fr": 'Calcul Mental Addition Niveau 8',
    "de": 'Kopfrechnen Addition Level 8',
    'pt': 'Cálculo Mental Adição Nível 8'
  },
  "run_like_math_addition_lv_9": {
    "en": 'Mental Math Addition Level 9',
    "fr": 'Calcul Mental Addition Niveau 9',
    "de": 'Kopfrechnen Addition Level 9',
    'pt': 'Cálculo Mental Adição Nível 9'
  },
  "run_like_math_addition_lv_10": {
    "en": 'Mental Math Addition Level 10',
    "fr": 'Calcul Mental Addition Niveau 10',
    "de": 'Kopfrechnen Addition Level 10',
    'pt': 'Cálculo Mental Adição Nível 10'
  },
  //Subtraction
  "run_like_math_subtraction_lv_1": {
    "en": 'Mental Math Subtraction Level 1',
    "fr": 'Calcul Mental Soustraction Niveau 1',
    "de": 'Kopfrechnen Subtraktion Level 1',
    'pt': 'Cálculo Mental Subtração Nível 1'
  },
  "run_like_math_subtraction_lv_2": {
    "en": 'Mental Math Subtraction Level 2',
    "fr": 'Calcul Mental Soustraction Niveau 2',
    "de": 'Kopfrechnen Subtraktion Level 2',
    'pt': 'Cálculo Mental Subtração Nível 2'
  },
  "run_like_math_subtraction_lv_3": {
    "en": 'Mental Math Subtraction Level 3',
    "fr": 'Calcul Mental Soustraction Niveau 3',
    "de": 'Kopfrechnen Subtraktion Level 3',
    'pt': 'Cálculo Mental Subtração Nível 3'
  },
  "run_like_math_subtraction_lv_4": {
    "en": 'Mental Math Subtraction Level 4',
    "fr": 'Calcul Mental Soustraction Niveau 4',
    "de": 'Kopfrechnen Subtraktion Level 4',
    'pt': 'Cálculo Mental Subtração Nível 4'
  },
  "run_like_math_subtraction_lv_5": {
    "en": 'Mental Math Subtraction Level 5',
    "fr": 'Calcul Mental Soustraction Niveau 5',
    "de": 'Kopfrechnen Subtraktion Level 5',
    'pt': 'Cálculo Mental Subtração Nível 5'
  },
  "run_like_math_subtraction_lv_6": {
    "en": 'Mental Math Subtraction Level 6',
    "fr": 'Calcul Mental Soustraction Niveau 6',
    "de": 'Kopfrechnen Subtraktion Level 6',
    'pt': 'Cálculo Mental Subtração Nível 6'
  },
  "run_like_math_subtraction_lv_7": {
    "en": 'Mental Math Subtraction Level 7',
    "fr": 'Calcul Mental Soustraction Niveau 7',
    "de": 'Kopfrechnen Subtraktion Level 7',
    'pt': 'Cálculo Mental Subtração Nível 7'
  },
  "run_like_math_subtraction_lv_8": {
    "en": 'Mental Math Subtraction Level 8',
    "fr": 'Calcul Mental Soustraction Niveau 8',
    "de": 'Kopfrechnen Subtraktion Level 8',
    'pt': 'Cálculo Mental Subtração Nível 8'
  },
  "run_like_math_subtraction_lv_9": {
    "en": 'Mental Math Subtraction Level 9',
    "fr": 'Calcul Mental Soustraction Niveau 9',
    "de": 'Kopfrechnen Subtraktion Level 9',
    'pt': 'Cálculo Mental Subtração Nível 9'
  },
  "run_like_math_subtraction_lv_10": {
    "en": 'Mental Math Subtraction Level 10',
    "fr": 'Calcul Mental Soustraction Niveau 10',
    "de": 'Kopfrechnen Subtraktion Level 10',
    'pt': 'Cálculo Mental Subtração Nível 10'
  },
  //Multiplication
  "run_like_math_multiplication_lv_1": {
    "en": 'Mental Math Multiplication Level 1',
    "fr": 'Calcul Mental Multiplication Niveau 1',
    "de": 'Kopfrechnen Multiplikation Level 1',
    'pt': 'Cálculo Mental Multiplicação Nível 1'
  },
  "run_like_math_multiplication_lv_2": {
    "en": 'Mental Math Multiplication Level 2',
    "fr": 'Calcul Mental Multiplication Niveau 2',
    "de": 'Kopfrechnen Multiplikation Level 2',
    'pt': 'Cálculo Mental Multiplicação Nível 2'
  },
  "run_like_math_multiplication_lv_3": {
    "en": 'Mental Math Multiplication Level 3',
    "fr": 'Calcul Mental Multiplication Niveau 3',
    "de": 'Kopfrechnen Multiplikation Level 3',
    'pt': 'Cálculo Mental Multiplicação Nível 3'
  },
  "run_like_math_multiplication_lv_4": {
    "en": 'Mental Math Multiplication Level 4',
    "fr": 'Calcul Mental Multiplication Niveau 4',
    "de": 'Kopfrechnen Multiplikation Level 4',
    'pt': 'Cálculo Mental Multiplicação Nível 4'
  },
  "run_like_math_multiplication_lv_5": {
    "en": 'Mental Math Multiplication Level 5',
    "fr": 'Calcul Mental Multiplication Niveau 5',
    "de": 'Kopfrechnen Multiplikation Level 5',
    'pt': 'Cálculo Mental Multiplicação Nível 5'
  },
  "run_like_math_multiplication_lv_6": {
    "en": 'Mental Math Multiplication Level 6',
    "fr": 'Calcul Mental Multiplication Niveau 6',
    "de": 'Kopfrechnen Multiplikation Level 6',
    'pt': 'Cálculo Mental Multiplicação Nível 6'
  },
  "run_like_math_multiplication_lv_7": {
    "en": 'Mental Math Multiplication Level 7',
    "fr": 'Calcul Mental Multiplication Niveau 7',
    "de": 'Kopfrechnen Multiplikation Level 7',
    'pt': 'Cálculo Mental Multiplicação Nível 7'
  },
  "run_like_math_multiplication_lv_8": {
    "en": 'Mental Math Multiplication Level 8',
    "fr": 'Calcul Mental Multiplication Niveau 8',
    "de": 'Kopfrechnen Multiplikation Level 8',
    'pt': 'Cálculo Mental Multiplicação Nível 8'
  },
  "run_like_math_multiplication_lv_9": {
    "en": 'Mental Math Multiplication Level 9',
    "fr": 'Calcul Mental Multiplication Niveau 9',
    "de": 'Kopfrechnen Multiplikation Level 9',
    'pt': 'Cálculo Mental Multiplicação Nível 9'
  },
  "run_like_math_multiplication_lv_10": {
    "en": 'Mental Math Multiplication Level 10',
    "fr": 'Calcul Mental Multiplication Niveau 10',
    "de": 'Kopfrechnen Multiplikation Level 10',
    'pt': 'Cálculo Mental Multiplicação Nível 10'
  },
  //Division
  "run_like_math_division_lv_1": {
    "en": 'Mental Math Division Level 1',
    "fr": 'Calcul Mental Division Niveau 1',
    "de": 'Kopfrechnen Division Level 1',
    'pt': 'Cálculo Mental Divisão Nível 1'
  },
  "run_like_math_division_lv_2": {
    "en": 'Mental Math Division Level 2',
    "fr": 'Calcul Mental Division Niveau 2',
    "de": 'Kopfrechnen Division Level 2',
    'pt': 'Cálculo Mental Divisão Nível 2'
  },
  "run_like_math_division_lv_3": {
    "en": 'Mental Math Division Level 3',
    "fr": 'Calcul Mental Division Niveau 3',
    "de": 'Kopfrechnen Division Level 3',
    'pt': 'Cálculo Mental Divisão Nível 3'
  },
  "run_like_math_division_lv_4": {
    "en": 'Mental Math Division Level 4',
    "fr": 'Calcul Mental Division Niveau 4',
    "de": 'Kopfrechnen Division Level 4',
    'pt': 'Cálculo Mental Divisão Nível 4'
  },
  "run_like_math_division_lv_5": {
    "en": 'Mental Math Division Level 5',
    "fr": 'Calcul Mental Division Niveau 5',
    "de": 'Kopfrechnen Division Level 5',
    'pt': 'Cálculo Mental Divisão Nível 5'
  },
  "run_like_math_division_lv_6": {
    "en": 'Mental Math Division Level 6',
    "fr": 'Calcul Mental Division Niveau 6',
    "de": 'Kopfrechnen Division Level 6',
    'pt': 'Cálculo Mental Divisão Nível 6'
  },
  "run_like_math_division_lv_7": {
    "en": 'Mental Math Division Level 7',
    "fr": 'Calcul Mental Division Niveau 7',
    "de": 'Kopfrechnen Division Level 7',
    'pt': 'Cálculo Mental Divisão Nível 7'
  },
  "run_like_math_division_lv_8": {
    "en": 'Mental Math Division Level 8',
    "fr": 'Calcul Mental Division Niveau 8',
    "de": 'Kopfrechnen Division Level 8',
    'pt': 'Cálculo Mental Divisão Nível 8'
  },
  "run_like_math_division_lv_9": {
    "en": 'Mental Math Division Level 9',
    "fr": 'Calcul Mental Division Niveau 9',
    "de": 'Kopfrechnen Division Level 9',
    'pt': 'Cálculo Mental Divisão Nível 9'
  },
  "run_like_math_division_lv_10": {
    "en": 'Mental Math Division Level 10',
    "fr": 'Calcul Mental Division Niveau 10',
    "de": 'Kopfrechnen Division Level 10',
    'pt': 'Cálculo Mental Divisão Nível 10'
  },

  "module_translation": {
    "id": 9999999,
    "en": "Module",
    "fr": "Module",
    "de": "Modul",
    "pt": "Módulo"
  },
  "mtic_teacher_onboarding": {
    "en": "Questionnaire",
    "fr": "Enquête",
    "de": "Umfrage",
    "pt": "Questionário"
  },
  "teacher_onboarding": {
    "en": "Questionnaire",
    "fr": "Enquête",
    "de": "Umfrage",
    "pt": "Questionário"
  },
  "mtic_baseline_assessment": {
    "en": "Baseline Test",
    "fr": "Baseline Test",
    "de": "Baseline Test",
    "pt": "Baseline Test"
  },
  "mtic_student_onboarding": {
    "en": "Student Questionnaire",
    "fr": "Student Questionnaire",
    "de": "Student Questionnaire",
    "pt": "Student Questionnaire"
  },
  'rotate_device': {
    "en": "For best experience, rotate your device horizontally.",
    "fr": "Pour une meilleure expérience, faites pivoter votre appareil horizontalement.",
    "de": "Drehen Sie Ihr Gerät horizontal, um optimale Ergebnisse zu erzielen.",
    "pt": "Para uma melhor experiência, gire seu dispositivo horizontalmente."
  },
  "mtic_close_opened_lesson": {
    "en": "Close currently opened lesson?",
    "fr": "Fermer la leçon actuellement ouverte?",
    "de": "Möchten Sie diese Seite schließen?",
    "pt": "Fermer la leçon actuellement ouverte?"
  },

  // Notifications 2021
  "upcoming_events_2021": {
    "en": "Upcoming events & MathemaTIC News",
    "fr": "Prochains événements et actualités MathemaTIC",
    "de": "Bevorstehende Veranstaltungen & MathemaTIC Neuigkeiten",
    "pt": "Próximos eventos & Notícias MathemaTIC"
  },
  "live_events": {
    "en": "MathemaTIC Live Events @ IFEN!",
    "fr": "MathemaTIC Live Events @ IFEN",
    "de": "MathemaTIC Live Events @ IFEN",
    "pt": "MathemaTIC Live Events @ IFEN"
  },
  "notification_mathletic_challenge_2021": {
    "en": "MathleTIC Challenge",
    "fr": "MathleTIC Challenge",
    "de": "MathleTIC Challenge",
    "pt": "MathleTIC Challenge"
  },
  "language_updates_2021": {
    "en": "Language Updates",
    "fr": "Mise à jour des langues",
    "de": "Update der Sprachen",
    "pt": "Actualização das línguas"
  },
  "agenda_updates_2021": {
    "en": "Agenda updates",
    "fr": "Mises à jour de l'agenda",
    "de": "Update des Agenda-Tools",
    "pt": "Actualizações da Agenda"
  },
  "teacher_view_update_2022": {
    "en": "Teacher View Update",
    "fr": "Mise à jour de la vue des enseignants",
    "de": "Lehrersicht Update",
    "pt": "Actualização da Vista do Professor"
  },
  "teacher_view_update_2023": {
    "en": "Teacher View Update",
    "fr": "Mise à jour de la vue des enseignants",
    "de": "Lehrersicht Update",
    "pt": "Actualização da Vista do Professor"
  },
  "mathleticNotice2024": {
    "en": "Teacher View Update",
    "fr": "Mise à jour de la vue des enseignants",
    "de": "Lehrersicht Update",
    "pt": "Actualização da Vista do Professor"
  },
  "updated_slug": {
    "en": "UPDATED!",
    "fr": "mis à jour!",
    "de": "NEU",
    "pt": "Atualizada!"
  },

  //MATHLETIC COMP STUFF
  'notification_teacher_view': {
    'en': 'Teacher View Update',
    'fr': 'Mise à jour de l’aperçu enseignant',
    'de': 'Mise à jour de l’aperçu enseignant',
    'pt': 'Mise à jour de l’aperçu enseignant'
  },
  'notification_mathletic': {
    'en': 'MathleTIC Kapprechen-Challenge',
    'fr': 'MathleTIC Kapprechen-Challenge',
    'de': 'MathleTIC Kapprechen-Challenge',
    'pt': 'MathleTIC Kapprechen-Challenge'
  },
  'notification_cycle_prompt': {
    'en': 'Cycle of Instruction (Questionnaire)',
    'fr': 'Cycle/Niveau (Questionnaire)',
    'de': 'Zyklus (Fragebogen)',
    'pt': 'Ciclo/Nível (Questionário)'
  },
  'notification_teacher_questionnaire': {
    'en': 'Questionnaire',
    'fr': 'Enquête',
    'de': 'Umfrage',
    'pt': 'Questionário'
  },
  'NOTIFICATIONS': {
    'en': 'NOTIFICATIONS',
    'fr': 'NOTIFICATIONS',
    'de': 'BENACHRICHTIGUNGEN',
    'pt': 'NOTIFICAÇÕES'
  },
  'import': {
    'en': 'Import',
    'fr': 'Importer',
    'de': 'Importieren',
    'pt': 'Importar'
  },
  'share_agenda_inst': {
    'en': 'Sharing this code with another teacher will allow them to import a copy of this agenda. This copy can be edited independently.',
    'fr': 'Partager ce code avec un autre enseignant permettra d\'importer une copie de cet agenda. Cette copie pourra édité indépendamment.',
    'de': 'Geben Sie diesen Code ihrer Kollegin/ihrem Kollegen, damit sie/er diese Agenda in ihre/seine Unterlagen importieren kann. Diese Agenda kann dann unabhängig bearbeitet werden.',
    'pt': 'Compartilhe este código com um professor com quem você gostaria de dividir esta agenda:'
  },
  'got_it': {
    'en': 'Got it!',
    'fr': 'Je comprends!',
    'de': 'Verstanden!',
    'pt': 'Consegui!'
  },
  'share_agenda': {
    'en': 'Share Agenda',
    'fr': 'Partager l\'agenda',
    'de': 'Teilen Sie die Agenda',
    'pt': 'Compartilhar Agenda'
  },
  'enter_valid_code': {
    'en': 'Please enter a valid agenda code',
    'fr': "Veuillez entrer un code d’agenda valide",
    'de': "Bitte geben Sie einen gültigen Agenda Code ein",
    'pt': "Por favor, insira um código de agenda válido"
  },
  'import_agenda': {
    'en': 'Import an Agenda',
    'fr': 'Importer un agenda',
    'de': 'Importieren Sie eine Agenda',
    'pt': 'Importar agenda'
  },
  'enter_agenda_code': {
    'en': 'Enter an agenda code to import a copy of another teacher\'s agenda. Once you have imported it, you can make modifications to the agenda.',
    'fr': 'Entrer un code d\'agenda permettra d’importer une copie d\'un agenda d\'un autre enseignant. Une fois l’agenda importé, il pourra être modifié.',
    'de': 'Geben Sie hier den Code der Agenda ein, die sie in Ihre Unterlagen importieren möchten. Nach dem Importieren können Sie die Agenda beliebig verändern.',
    'pt': 'Digite o código da agenda:'
  },
  'ios_app_issue': {
    'en': 'We have detected a temporary issue with your Office 365 login, please use your Safari browser to login.',
    'fr': 'Nous avons détecté un problème temporaire avec votre connexion à Office 365, veuillez utiliser votre navigateur Safari pour vous connecter.',
    'de': 'Nous avons détecté un problème temporaire avec votre connexion à Office 365, veuillez utiliser votre navigateur Safari pour vous connecter.',
    'pt': 'Nous avons détecté un problème temporaire avec votre connexion à Office 365, veuillez utiliser votre navigateur Safari pour vous connecter.'
  },
  'NEW': {
    'en': 'NEW',
    'fr': 'NOUVEAU',
    'de': 'NEU',
    'pt': 'NOVO'
  },
  'follow_up': {
    'en': 'Follow-up',
    'fr': 'Partie suivante',
    'de': 'Nächster Teil',
    'pt': 'Partie suivante'
  },
  'notification_mandatory_1': {
    'en': 'This questionnaire will become mandatory in __ logins.',
    'fr': 'Ce questionnaire deviendra obligatoire après __ connexions.',
    'de': 'Dieser Fragebogen wird nach __ Logins verpflichtend.',
    'pt': 'Este questionário tornar-se-á obrigatório após __ logins.'
  },
  'notification_mandatory_2': {
    'en': 'This questionnaire will become mandatory on your next login',
    'fr': 'Ce questionnaire deviendra obligatoire lors de votre prochaine connexion.',
    'de': 'Dieser Fragebogen wird bei Ihrem nächsten Login verpflichtend.',
    'pt': 'Este questionário tornar-se-á obrigatório no seu próximo login.'
  },
  'mathletic_comp_header': {
    'en': 'MathleTIC Kapprechen-Challenge 2018',
    'fr': 'MathleTIC Kapprechen-Challenge 2018',
    'de': 'MathleTIC Kapprechen-Challenge 2018',
    'pt': 'MathleTIC Kapprechen-Challenge 2018'
  },
  'mathletic_comp_page1': {
    'en': "The MathleTIC Competition is coming up June 27th! It's time to start collecting stars! Click continue to add the MathleTIC Competition to your class calendar.",
    'fr': 'La compétition MathleTIC arrive le 27 juin! Il est temps de commencer à collectionner des étoiles. Cliquez sur suivant pour ajouter la compétition MathleTIC  à votre agenda de classe.',
    'de': 'La compétition MathleTIC arrive le 27 juin! Il est temps de commencer à collectionner des étoiles. Cliquez sur suivant pour ajouter la compétition MathleTIC  à votre agenda de classe.',
    'pt': 'La compétition MathleTIC arrive le 27 juin! Il est temps de commencer à collectionner des étoiles. Cliquez sur suivant pour ajouter la compétition MathleTIC  à votre agenda de classe.'
  },
  'mathletic_comp_page2_1': {
    'en': "Please select the classes which you would want participate in the competition.",
    'fr': 'Sélectionnez les classes que vous voudriez faire participer à la compétition.',
    'de': 'Sélectionnez les classes que vous voudriez faire participer à la compétition.',
    'pt': 'Sélectionnez les classes que vous voudriez faire participer à la compétition.'
  },
  'mathletic_comp_page2_2': {
    'en': "already assigned",
    'fr': 'Déjà attribué',
    'de': 'Déjà attribué',
    'pt': 'Déjà attribué'
  },
  'mathletic_comp_page2_3': {
    'en': "MathleTIC is a module from Cycle 3. To participate in the competition, you must create a cycle 3 class and the students must register by integrating the code of the new class.",
    'fr': 'MathleTIC est un module du cycle 3. Pour participer au concours il faut créer une classe du cycle 3 et les élèves doivent s’y inscrire en intégrant le code de la nouvelle classe.',
    'de': 'MathleTIC est un module du cycle 3. Pour participer au concours il faut créer une classe du cycle 3 et les élèves doivent s’y inscrire en intégrant le code de la nouvelle classe.',
    'pt': 'MathleTIC est un module du cycle 3. Pour participer au concours il faut créer une classe du cycle 3 et les élèves doivent s’y inscrire en intégrant le code de la nouvelle classe.'
  },
  'mathletic_comp_page2_3b': {
    'en': "The creation of a Cycle 3 class does not change the use of Cycle 4 or lower cycle (secondary classes) items.",
    'fr': 'La création d’une classe de cycle 3 ne change en rien l’utilisation des items du cycle 4 ou du cycle inférieur (classes secondaires)',
    'de': 'La création d’une classe de cycle 3 ne change en rien l’utilisation des items du cycle 4 ou du cycle inférieur (classes secondaires)',
    'pt': 'La création d’une classe de cycle 3 ne change en rien l’utilisation des items du cycle 4 ou du cycle inférieur (classes secondaires)'
  },
  'mathletic_comp_page2_4': {
    'en': "Name:",
    'fr': 'Nom:',
    'de': 'Nom:',
    'pt': 'Nom:'
  },
  'mathletic_comp_page2_5': {
    'en': "Create",
    'fr': 'Créer',
    'de': 'Créer',
    'pt': 'Créer'
  },
  'mathletic_comp_page3_1': {
    'en': "The competition has been added to your Agenda! Your students can start on June 27, and you will be able to track your class's progress on the Leaderboard.",
    'fr': 'La compétition à été ajoutée à votre agenda! Vos élèves peuvent commencer le 27 juin, et vous serez en mesure de suivre le progrès de votre classe à travers le classement.',
    'de': 'La compétition à été ajoutée à votre agenda! Vos élèves peuvent commencer le 27 juin, et vous serez en mesure de suivre le progrès de votre classe à travers le classement.',
    'pt': 'La compétition à été ajoutée à votre agenda! Vos élèves peuvent commencer le 27 juin, et vous serez en mesure de suivre le progrès de votre classe à travers le classement.'
  },
  'mathletic_comp_page3_2': {
    'en': "Your class has been created, your students can join with the following class code:",
    'fr': 'Votre classe a été créée, vos élèves peuvent la rejoindre à partir du code:',
    'de': 'Votre classe a été créée, vos élèves peuvent la rejoindre à partir du code:',
    'pt': 'Votre classe a été créée, vos élèves peuvent la rejoindre à partir du code:'
  },
  'mathletic_comp_page3_3': {
    'en': "Click continue to assign the competition to your new class!",
    'fr': 'Cliquez sur suivant pour attribuer la compétition à votre nouvelle classe.',
    'de': 'Cliquez sur suivant pour attribuer la compétition à votre nouvelle classe.',
    'pt': 'Cliquez sur suivant pour attribuer la compétition à votre nouvelle classe.'
  },
  'android_block': {
    'en': 'The Android app has been temporarily discontinued.\nPlease use your web browser to access the Cycle 3 and Cycle Inférieur modules.',
    'fr': "L'application Android a été temporairement interrompue.\nVeuillez utiliser votre navigateur Web pour accéder aux modules Cycle 3 et Cycle Inférieur.",
    'de': "L'application Android a été temporairement interrompue.\nVeuillez utiliser votre navigateur Web pour accéder aux modules Cycle 3 et Cycle Inférieur.",
    'pt': "L'application Android a été temporairement interrompue.\nVeuillez utiliser votre navigateur Web pour accéder aux modules Cycle 3 et Cycle Inférieur."
  },
  "student_cycle_prompt": {
    "en": "Select the grade you are enrolled in:",
    "fr": "Sélectionne l’année scolaire dans laquelle tu es inscrit(e):",
    "de": "Wähle deine Klassenstufe aus:",
    "pt": "Seleciona o ano escolar em que estás inscrito/a:"
  },

  "item_links_create_class": {
    "en": "You don't currently have a class with this module id, would you like to create one?",
    "fr": "Vous n'avez actuellement pas de classe avec le numéro identifiant de ce module, souhaitez-vous en créer une?",
    "de": "Sie haben derzeit keine Klasse mit dieser Modul ID, möchten Sie eine erstellen?",
    "pt": "Atualmente não possui uma classe com esta identificação de módulo, deseja criar uma?"
  },
  "item_links_invalid_mod": {
    "en": "Invalid module id, could not open item.",
    "fr": "Identifiant de module incorrect, impossible d'ouvrir l'item.",
    "de": "Ungültige Modul-ID, konnte das Item nicht öffnen",
    "pt": "Identificação de módulo incorrecta, não foi possível abrir o item."
  },
  "item_links_item_name": {
    "en": "Item Name",
    "fr": "Nom de I'item",
    "de": "Item Name",
    "pt": "Nome do item"
  },
  "item_links_link_url": {
    "en": "Link URL",
    "fr": "Lien URL",
    "de": "Link URL",
    "pt": "URL do link"
  },
  "item_links_download_csv": {
    "en": "Download as CSV file",
    "fr": "Télécharger le fichier CSV",
    "de": "Als CSV-Datei herunterladen",
    "pt": "Download como ficheiro CSV"
  },
  "item_links_show_links": {
    "en": "Show item links lists",
    "fr": "Afficher la liste avec les liens des items",
    "de": "Item Links anzeigen",
    "pt": "Ver a lista com os links de itens"
  },

  "item_links_hide_links": {
    "en": "Hide item links lists",
    "fr": "Fermer la liste avec les liens des items",
    "de": "Item Links ausblenden",
    "pt": "Ocultar a lista com os links de itens"
  },
  "item_links_hide_link": {
    "en": "Hide",
    "fr": "Masquer",
    "de": "Ausblenden",
    "pt": "Ocultar"
  },
  "item_links_missing_item": {
    "en": "The item id: __ you are trying to access could not be found",
    "fr": "L'élément avec l'identifiant : __ auquel vous essayez d'accéder est introuvable",
    "de": "Das Item mit der ID: __, auf das Sie zugreifen wollen, konnte nicht gefunden werden.",
    "pt": " O item com a identificação: __ que está a tentar aceder não foi encontrado"
  },
  "item_links_copy_link": {
    "en": "Copy Item Link",
    "fr": "Copier le lien de l'item",
    "de": "Item-Link kopieren",
    "pt": "Copiar link do item"
  },

  "class_certificate": {
    "en": "Class Certificate",
    "fr": "Diplôme de la classe",
    "de": "Klassenurkunde",
    "pt": "Diploma da classe"
  },
  "score_total": {
    "en": "Score (Total)",
    "fr": "Score (Total)",
    "de": "Ergebnis (gesamt)",
    "pt": "Pontuação (Total)"
  },
  "score_average": {
    "en": "Score (Average)",
    "fr": "Score (Moyenne)",
    "de": "Ergebnis (Durchschnitt)",
    "pt": "Pontuação (Média)"
  },
  "score_total_calculation": {
    "en": "Your score is calculated as follows: 100 x (Tot. Stars Earned + Tot. Medals Earned)",
    "fr": "Ton score est calculé comme suit: 100 x (nombre total d'étoiles + total des médailles)",
    "de": "Deine Punktzahl wird wie folgt berechnet:100 x (Sterne gesamt + Medaillen gesamt)",
    "pt": "Sua pontuação é calculada da forma seguinte:100 x (Total de estrelas + Total de medalhas)"
  },
  "score_average_calculation": {
    "en": "Your score is calculated as follows: 100 x (Avg. Stars Earned + Avg. Medals Earned)\nScores are reported as whole numbers.",
    "fr": "Ton score est calculé comme suit: 100 x (moyenne des étoiles + moyenne des médailles)\nLes scores sont affichés sous forme de nombres entiers.",
    "de": "Deine Punktzahl wird wie folgt berechnet: 100 x (Sterne im Durchschnitt + Medaillen im Durchschnitt)\nErgebnisse werden auf ganze Zahlen gerundet.",
    "pt": "Sua pontuação é calculada da seguinte forma: 100 x (Média de estrelas + média de medalhas)\nA pontuação é exibida com números inteiros."
  },
  "MathemaTIC": {
    "en": "MathemaTIC",
    "fr": "Classements",
    "de": "MathemaTIC",
    "pt": "Classificação"
  },
  "Leaderboards": {
    "en": "Leaderboards",
    "fr": "MathemaTIC",
    "de": "Bestenliste",
    "pt": "MathemaTIC"
  },
  "Current_Leaderboards": {
    "en": "Current Leaderboards",
    "fr": "Classements en cours",
    "de": "Aktuelle Bestenliste",
    "pt": "Classificação actual"
  },
  "Past_Leaderboards": {
    "en": "Past Leaderboards",
    "fr": "Classements précédents",
    "de": "Frühere Bestenliste",
    "pt": "Classificações anteriores"
  },
  "Upcoming_Leaderboards": {
    "en": "Upcoming Leaderboards",
    "fr": "Classements à venir",
    "de": "Zukünftige Bestenliste",
    "pt": "Classificações futuras"
  },
  "June_Leaderboards": {
    "en": "MathleTIC June 2018",
    "fr": "MathleTIC Juin 2018",
    "de": "MathleTIC Juni 2018",
    "pt": "MathleTIC Junho 2018"
  },
  "view_results": {
    "en": "View Results",
    "fr": "Voir les résultats",
    "de": "Ergebnisse zeigen",
    "pt": "Ver resultados"
  },

  //END MATHLETIC COMP

  "srs_discrepancy": {
    "en": "Submission received prior to February 2019 may not be fully reflected in the view on the right.",
    "fr": "Les soumissions reçues avant février 2019 peuvent ne pas être entièrement reflétées dans la vue à droite.",
    "de": "Les soumissions reçues avant février 2019 peuvent ne pas être entièrement reflétées dans la vue à droite.",
    "pt": "Les soumissions reçues avant février 2019 peuvent ne pas être entièrement reflétées dans la vue à droite."
  },
  "shared_with": {
    "en": "Shared with",
    "de": "Partagée avec",
    "pt": "Partagée avec",
    "fr": "Partagée avec"
  },

  // FAQ videos
  "faq_video_2_header": {
    "lu": "Eng Agenda importéieren a mat bestëmmte Schüler deelen",
    "fr": "Importer un agenda et le partager avec des élèves",
    "de": "Ein Agenda importieren und mit Schülern teilen",
    "pt": "Importar uma agenda e partilhá-la com os alunos",
    "en": "Import an agenda and share it with learners"
  },
  "faq_video_2_pre_vid_text": {
    "lu": "D’Enseignante kënnen ënner sech Agendae fir hir Schüler deelen, déi se schonn erstallt hunn an se der ganzer Klass oder just vereenzelten Schüler zouweisen...",
    "fr": "Les enseignants peuvent partager des agendas entre eux, qui ont déjà été créés pour une autre classe ou seulement pour des élèves individuels...",
    "de": "Lehrer können ihre Agenda miteinander teilen, die bereits für eine andere Klasse oder nur für einzelne Schüler erstellt wurde...",
    "pt": "Os professores podem partilhar agendas que já foram criadas para outras turmas ou somente para alunos individuais...",
    "en": "Teachers can share an agenda that has already been created for another class or only for individual learners..."
  },
  "faq_video_3_header": {
    "lu": "Klassen erstellen",
    "fr": "Créer des classes",
    "de": "Klassen erstellen",
    "pt": "Criar classes",
    "en": "Create classes"
  },
  "faq_video_3_pre_vid_text": {
    "lu": "Nodeems een sech als Enseignant mat sengem IAM ugemellt huet, da kann een a senger Enseignants-Vue esou vill Klassen erstellen wéi ee brauch oder wëll hunn...",
    "fr": "En se connectant en tant qu'enseignant, vous avez la possibilité de créer autant de classes ou de groupes selon les besoins ou vos envies...",
    "de": "Wenn Sie sich als Lehrer verbinden, haben Sie die Möglichkeit, so viele Klassen oder Gruppen zu erstellen, wie Sie benötigen oder wünschen...",
    "pt": "Ao conectar-se como professor, terá a possibilidade de criar quantas classes ou grupos quiser ou precisar...",
    "en": "When you connect as a teacher, you can create as many classes or groups as you need or want..."
  },
  "faq_video_4_header": {
    "lu": "Als Enseignant Accès op all d'Inhalter hunn",
    "fr": "Avoir accès à tous les contenus en tant qu'enseignant",
    "de": "Als Lehrer auf alle Inhalte von MathemaTIC zugreifen",
    "pt": "Aceder a todos os conteúdos como professor",
    "en": "Access all MathemaTIC contents as a teacher"
  },
  "faq_video_4_pre_vid_text": {
    "lu": "An der Enseignants-Vue kann een esou vill Klassen erstellen wéi ee brauch oder wëll hunn.\n Fir Accès op all d‘Inhalter vum MathemaTIC ze hunn muss een sech jeweils eng Klass erstellen fir de Cycle 3, de Cycle 4 an den Enseignement secondaire...",
    "fr": "En tant qu'enseignant, vous avez la possibilité de créer autant de classes ou de groupes selon les besoins ou vos envies.\n Pour accéder à tous les contenus de MathemaTIC, vous devrez créer une classe pour le cycle 3, pour le cycle 4 et pour l'enseignement secondaire...",
    "de": "Als Lehrer haben Sie die Möglichkeit, so viele Klassen oder Gruppen zu erstellen, wie Sie benötigen oder wünschen.\n Um auf alle Inhalte von MathemaTIC zugreifen zu können, müssen Sie eine Klasse für den Zyklus 3, den Zyklus 4 und die Sekundarstufe anlegen...",
    "pt": "Como professor, tem a possibilidade de criar quantas classes ou grupos quiser ou precisar.\n Para aceder a todos os conteúdos do MathemaTIC, terá de criar uma classe para o Ciclo 3, o Ciclo 4 e o Ensino Secundário...",
    "en": "As a teacher, you can create as many classes or groups as you need or want.\n To access all MathemaTIC contents, you must create a class for Cycle 3, Cycle 4, and Secondary..."
  },
  "faq_video_5_header": {
    "lu": "Ee Kand op méi Klassen aschreiwen fir ze differenzéieren",
    "fr": "Inscrire un élève dans plusieurs classes pour différencier",
    "de": "Einen Schüler in mehrere Klassen einschreiben um zu differenzieren",
    "pt": "Inscrever um aluno em várias classes para diferenciar",
    "en": "Enrolling a student in several classes to differenciate"
  },
  "faq_video_5_pre_vid_text": {
    "lu": "Ee Schüler ka gläichzäiteg a méi wéi enger Grupp/Cycle ageschriwwen sinn fir ze differenzéieren...",
    "fr": "Un élève peut être inscrit dans plusieurs groupes/cycles à la fois pour différencier...",
    "de": "Ein Schüler kann im Rahmen der Differenzierung in mehreren Gruppen/Zyklen gleichzeitig eingeschrieben werden...",
    "pt": "Um aluno pode estar inscrito em vários grupos/ciclos ao mesmo tempo para diferenciar...",
    "en": "A student can be enrolled in several groups/cycles at the same time as part of the differentiation process..."
  },
  "faq_video_6_header": {
    "lu": "Eng Agenda erstellen",
    "fr": "Créer un agenda",
    "de": "Erstellen einer Agenda",
    "pt": "Criar uma agenda",
    "en": "Create an agenda"
  },
  "faq_video_6_pre_vid_text": {
    "lu": "D’Funktioun Agenda erméiglecht iech als Enseignant Ärer ganzer Klasse oder just spezifische Schüler eng oder méi Agendaen ze erstellen mat enger oder méi Aufgaben, déi an enger bestëmmter Periode sollen oder musse gemaach ginn...",
    "fr": "La fonction Agenda vous permet de créer un ou plusieurs agendas en tant qu'enseignant pour l'ensemble de la classe ou seulement pour des élèves spécifiques, avec un ou plusieurs items à réaliser pendant des périodes prédéfinies...",
    "de": "Mit der Agenda-Funktion können Sie als Lehrer eine oder mehrere Agenden für die ganze Klasse oder nur für bestimmte Schüler erstellen, wobei ein oder mehrere Items in vordefinierten Zeiträumen erledigt werden müssen...",
    "pt": "A função Agenda permite criar uma ou mais agendas como um professor para toda a turma ou apenas para alunos específicos, com um ou mais itens a serem concluídos durante períodos predefinidos...",
    "en": "With the Agenda function, you as a teacher can create one or more agendas for the whole class or only for certain learners, in which one or more items must be completed in predefined time periods..."
  },
  "faq_video_7_header": {
    "lu": "Léierberichter notzen",
    "fr": "Exploiter les rapports d'apprentissage",
    "de": "Lernberichte nutzen",
    "pt": "Utilizar os relatórios de aprendizagem",
    "en": "Use the student reports"
  },
  "faq_video_7_pre_vid_text": {
    "lu": "An der Enseignants-Vue hutt dir op engem Bléck eng Hellewull Informatiounen iwwer all d’Schüler, déi iech als Enseignant dobäi ënnerstëtzen ären Unterrecht besser ze differenzéieren.\n Fir all Module gesitt dirpro Schüler graphesch duergestallt wéi en am Diagnosetest ofgeschnidden huet, wéi seng Progressioun bei den Léieritemer ass an wéi en beim Ofschlosstest ofgeschridden huet. D’Kreeser fëllen sech prozentual mat gieler Faarw an ab 80% Réussite fierwt sech de Krees gréng...",
    "fr": "Dans la vue enseignant vous aurez accès à une panoplie d’informations sur les apprentissages des élèves, qui vous aideront en tant qu'enseignant, à mieux différencier vos leçons. Pour chaque module, vous pouvez visualiser graphiquement par étudiant comment il a résolu le test de Diagnostic, sa progression dans les apprentissages et comment il a réussi au test sommatif. Les cercles se remplissent graduellement avec la couleur jaune et à partir de 80% de réussite, les cercles deviennent verts...",
    "de": "In der Lehreransicht haben Sie Zugang zu einer Reihe von Informationen über den Lernprozess der Schüler, die Ihnen als Lehrer helfen, Ihren Unterricht besser zu differenzieren. Für jedes Modul können Sie pro Schüler grafisch visualisieren, wie er den Diagnosetest gelöst hat, welchen Lernfortschritt er hat und wie er den Abschlusstest bestanden hat. Die Kreise füllen sich allmählich mit der gelben Farbe und ab 80% Erfolg werden die Kreise grün...",
    "pt": "Na vista do professor você terá acesso a uma ampla gama de informações sobre a aprendizagem do aluno, o que o ajudará como professor a diferenciar melhor suas aulas. Para cada módulo, poderá visualizar graficamente por aluno como resolveram o teste diagnóstico, o seu progresso na aprendizagem e como superaram o teste final. Os círculos enchem-se gradualmente com a cor amarela e a partir de 80% de sucesso, os círculos tornam-se verdes...",
    "en": "The teacher view gives you access to a range of information about the learners' progress that will help you as a teacher to better differentiate your teaching. For each module, you can graphically visualize for each learner how they performed on the diagnostic test, how they progressed, and how they passed the final test. The circles are gradually fill with the yellow color, unless their results is greater or equal to 80% of success, then the circles turn green..."
  },
  "faq_video_8_header": {
    "lu": "Ofschlosstester fräischalten",
    "fr": "Débloquer un test sommatif",
    "de": "Einen Abschlusstest freischalten",
    "pt": "Desbloquear um teste sumativo",
    "en": "Unlock a summative test"
  },
  "faq_video_8_pre_vid_text": {
    "lu": "Fir engem Schüler oder der ganzer Klass een Ofschlosstest fräizeschalten, da musst der heifir op de Menü vun der Agenda goen...",
    "fr": "Afin de débloquer le test sommatif pour un ou plusieurs élèves d'une classe, vous devrez vous rendre dans le menu de l'agenda...",
    "de": "Um den Abschlusstest für einen oder mehrere Schüler in einer Klasse freizuschalten, müssen Sie zum Menü Agenda gehen...",
    "pt": "Para desbloquear o teste sumativo para um ou mais alunos de uma turma, terá de ir ao menu da agenda...",
    "en": "To unlock the summative test for one or more learners in a class, go to the Agenda menu..."
  },
  "faq_video_9_header": {
    "lu": "Den Opbau vun engem Modul",
    "fr": "La constitution d'un module",
    "de": "Der Aufbau eines Moduls",
    "pt": "A constituição de um módulo",
    "en": "The structure of a module"
  },
  "faq_video_9_pre_vid_text": {
    "lu": "All Ordre d’Enseignement besteet aus verschiddenen Moduler, déi mat engem oder méi mathemateschen Themen a Verbindung stinn. Visuell ënnerscheeden sech déi verschidden Welten duerch een ganz spillereschen Design am Cycle 3 bis op eng ganz abstrakt Duerstellung am Cycle inférieur...",
    "fr": "Chaque Ordre d'Enseignement se compose de différents modules liés à un ou plusieurs thèmes mathématiques. Visuellement, ces différents univers se distinguent par un design totalement ludique pour le Cycle 3, jusqu'à une représentation totalement abstraite pour le Cycle inférieur...",
    "de": "Jede Lehrordnung besteht aus verschiedenen Modulen, die sich auf ein oder mehrere mathematische Themen beziehen. Visuell unterscheiden sich diese verschiedenen Welten durch ein spielerisches Design für denZyklus 3 bis hin zu einer völlig abstrakten Darstellung für den Cycle inférieur aus...",
    "pt": "Cada Ordem de Ensino contém diferentes módulos relacionados a um ou mais temas matemáticos. Visualmente, estes diferentes universos distinguem- se por um design totalmente lúdico para o ciclo 3, até uma representação totalmente abstrata para o ciclo inferior...",
    "en": "Each Teaching Level consists of different modules related to one or more mathematical themes. Visually, these different universes are distinguished by a totally playful design for Cycle 3, up to a totally abstract representation for the Cycle inférieur..."
  },
  "faq_video_10_header": {
    "lu": "Den Tableau de bord verstoen",
    "fr": "Comprendre le tableau de bord",
    "de": "Die Benutzeroberfläche verstehen",
    "pt": "Compreender o painel de controlo",
    "en": "Understanding the dashboard"
  },
  "faq_video_10_pre_vid_text": {
    "lu": "Wann een eng Klass/Grupp ausgewielt huet, huet een eng Iwwersiicht iwwer all déi Schüler déi an där Class ageschriwwe sinn...",
    "fr": "Lorsqu'une classe ou un groupe a été sélectionné, on obtient une vue d'ensemble de tous les élèves de cette classe ou de ce groupe...",
    "de": "Sobald eine Klasse oder Gruppe ausgewählt wurde, wird eine Übersicht über alle Schüler dieser Klasse oder Gruppe angezeigt...",
    "pt": "Uma vez que uma classe ou grupo tenha sido selecionado, uma lista de todos os alunos dessa classe ou grupo é apresentada...",
    "en": "Once a class or group has been selected, an overview of all students in that class or group is provided..."
  },
  "faq_video_11_header": {
    "lu": "Den Aarbechtsverlaf verstoen",
    "fr": "Comprendre l'historique des travaux",
    "de": "Den Arbeitsverlauf verstehen",
    "pt": "Compreender o histórico de trabalho",
    "en": "Understand the activity log"
  },
  "faq_video_11_pre_vid_text": {
    "lu": "An der Enseignants-Vue kann een am Menü “Historique des Travaux” eng Iwwersiicht driwwer kréien wat fir eng Schüler wat geschafft hunn...",
    "fr": "Dans la vue Enseignant, vous pouvez consulter ce que les élèves ont travaillé grâce au menu “Historique des Travaux”...",
    "de": "In der Lehreransicht können Sie über das Menü \"Arbeitsverlauf\" sehen, woran die Schüler gearbeitet haben...",
    "pt": "No painel do professor, poderá ver o que os alunos têm trabalhado através do menu \"Histórico de trabalho\"...",
    "en": "In the Teacher view, you can see what the students have been working on through the \"Activity Log\" menu..."
  },
  "faq_video_12_header": {
    "lu": "Meet the Developers",
    "fr": "Meet the Developers",
    "de": "Meet the Developers",
    "pt": "Meet the Developers",
    "en": "Meet the Developers"
  },
  "faq_video_12_pre_vid_text": {
    "lu": "",
    "fr": "",
    "de": "",
    "pt": "",
    "en": ""
  },

  "login_using_iam": {
    "fr": "Connexion avec IAM",
    "de": "Anmelden mit IAM",
    "pt": "Conectar-se usando IAM",
    "en": "Login using IAM"
  },
  "login_using_office365": {
    "fr": "Connexion avec Office365",
    "de": "Anmelden mit Office365",
    "pt": "Conectar-se usando Office365",
    "en": "Login using Office365"
  },
  "mtic_vp_meta": {
    "de": "Voie de préparation",
    "fr": "Voie de préparation",
    "en": "Voie de préparation",
    "pt": "Voie de préparation"
  },
  "mtic_vp": {
    "de": "Voie de préparation",
    "fr": "Voie de préparation",
    "en": "Voie de préparation",
    "pt": "Voie de préparation"
  },
  "vp_m2_diag": {
    "en": "Module 2 Diagnostic",
    "fr": "Module 2 Diagnostique",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "vp_m3_diag": {
    "en": "Module 3 Diagnostic",
    "fr": "Module 3 Diagnostique",
    "pt": "Teste diagnóstico",
    "de": "Anfangstest"
  },
  "vp_m3_c4_m1_b_2_5_are_non_pol_res": {
    "en": "Area of polygons",
    "fr": "L'aire des polygones",
    "de": "Flächeninhalt von Vielecken",
    "pt": "Área de polígonos"
  },
  "vp_m3_mtic_g78_m4_divisibility_a_pt1": {
    "en": "Divisibility (2, 5, 10 and 4)",
    "fr": "Divisibilité (2, 5, 10 et 4)",
    "de": "Teilbarkeit (2, 5, 10, 4)",
    "pt": "Divisibilité (2, 5, 10 et 4)"
  },
  "vp_m3_c4_m1_b_2_3_are_non_pol": {
    "en": "Area of Non-Right-Angled Polygons",
    "fr": "L'aire des polygones quelconques",
    "de": "Flächeninhalt von nicht-rechtwinkligen Vielecken",
    "pt": "Área de polígonos não-retangulares"
  },
  "vp_m3_c4_m2_b_3_2_fac_cre_res": {
    "en": "Write a number as a product (Part 1)",
    "fr": "Ecrire un nombre sous la forme d'un produit (Partie 1)",
    "de": "Eine Zahl als Produkt schreiben (Teil 1)",
    "pt": "Escrever um número como produto de dois fatores (Parte 1)"
  },
  "vp_m3_mtic_g78_m4_divisibility_a_pt2": {
    "en": "Divisibility (3, 6 and 9)",
    "fr": "Divisibilité (3, 6 et 9)",
    "de": "Teilbarkeit (3, 6, 9)",
    "pt": "Divisibilité (3, 6 et 9)"
  },
  "vp_m3_mtic_g78_m4_divisibility_b": {
    "en": "Apply Divisibility",
    "fr": "Utiliser la divisibilité ",
    "de": "Teilbarkeit ausnutzen",
    "pt": "Divisibility"
  },
  "vp_m3_mtic_g78_m4_divisors": {
    "en": "Divisors",
    "fr": "Diviseurs",
    "de": "Teiler",
    "pt": "Diviseurs"
  },
  "vp_m3_mtic_g78_m4_equiv_a": {
    "en": "Equivalent Fractions",
    "fr": "Fractions équivalentes",
    "de": "Äquivalente Brüche",
    "pt": "Equivalent Fractions"
  },
  "vp_m3_c4_m1_summative": {
    "en": "Summative Test (Area and Perimeter)",
    "fr": "Test bilan (aire et périmètre)",
    "de": "Abschlusstest (Flächeninhalt und Umfang)",
    "pt": "Teste sumativo (área e perímetro)"
  },
  "vp_m3_c4_m2_b_3_3_com_mul": {
    "en": "Find common multiples",
    "fr": "Identifier des multiples communs",
    "de": "Gemeinsame Vielfache finden",
    "pt": "Reconhecer múltiplos comuns"
  },
  "vp_m3_c4_m5_a_2_4_mti_c4_m5_gra_his_ex": {
    "fr": "Exercices sur les diagrammes à bâtons",
    "en": "Bar graph practice",
    "de": "Übungen zum Säulendiagramm",
    "pt": "Exercícios sobre os gráficos de barras"
  },
  "vp_m3_mtic_g78_m4_simp": {
    "en": "Simplification",
    "fr": "Simplifier des fractions",
    "de": "Brüche kürzen",
    "pt": "Simplification"
  },
  "vp_m3_c4_m5_a_2_6_mti_c4_m5_gra_lin_ex": {
    "fr": "Exercices sur les diagrammes linéaires",
    "en": "Line graph practice",
    "de": "Übungen zum Liniendiagramm",
    "pt": "Exercícios sobre os gráficos de linhas"
  },
  "vp_m3_c4_m5_formative_1": {
    "en": "Graphs and Tables",
    "fr": "Graphiques et tableaux",
    "de": "Tabellen und Diagramme",
    "pt": "Graphiques et tableaux"
  },
  "vp_m3_mtic_g78_m8_t2": {
    "en": "Summative Test",
    "fr": "Test bilan",
    "de": "Abschlusstest",
    "pt": "Teste final"
  },
  "vp_m3_mtic_g78_m8_c32": {
    "en": "Area of Comp. Shapes - Challenge",
    "fr": "Aire de figures composées - défi",
    "de": "Fläche zsg Fig - Challenge",
    "pt": "Aire de figures composées - défi"
  },
  "vp_m3_c4_m6_a_1_7_mti_c4_m6_tom_bui": {
    "en": "Making models of the tombs",
    "pt": "Criar figuras pros túmulos",
    "fr": "Créer des modèles pour les tombes",
    "de": "Modelle für Grabmale bauen"
  },
  "vp_m3_mtic_g78_m4_carrot": {
    "en": "Hop & Crunch",
    "fr": "Course à la carotte",
    "de": "Möhrenjagd",
    "pt": "Hop & Crunch"
  },
  "vp_m3_mtic_g78_m4_intro_frac": {
    "en": "Intro to Fractions",
    "fr": "Introduction aux fractions",
    "de": "Einführung in Brüche",
    "pt": "Intro to Fractions"
  },
  "vp_m3_c4_m4_a_3_6_mti_c4_dec_exp_fra_par": {
    "de": "Nicht dezimale Bruche (Teil 1)",
    "fr": "Fractions non-decimales (partie 1)",
    "en": "Non-decimal Fractions (Part 1)",
    "pt": "Frações não decimais (Parte 1)"
  },
  "vp_m3_c4_m4_b_2_1_est_lor_de_gra_de_res_ave_ass": {
    "de": "Ergebnisse schätzen (Teil 1)",
    "fr": "Estimer le résultat (partie 1)",
    "en": "Approximating the Result (Part 1)",
    "pt": "Fazer estimativas (Parte 1)"
  },
  "vp_m3_c4_m4_b_2_3_ope": {
    "de": "Subtraktion von Dezimalzahlen",
    "fr": "Soustraction de nombres décimaux",
    "en": "Subtraction of Decimal Numbers",
    "pt": "Subtração de números decimais"
  },
  "vp_m3_c4_m3_b_2_2_ope": {
    "de": "Einen Bruch darstellen (Teil 2)",
    "en": "Represent a fraction (Part 2)",
    "fr": "Représenter une fraction (Partie 2)",
    "pt": "Representar uma fração (Parte 2)"
  },
  "vp_m3_c4_m4_a_3_1_mti_c4_dec_exp_con_fra": {
    "de": "Dezimalzahlen in Brüche umwandeln",
    "fr": "Passer de l’écriture décimale à l’écriture fractionnaire",
    "en": "Converting Decimal Numbers to Fractions",
    "pt": "Alternar entre a formal decimal e a forma fracionária"
  },
  "vp_m3_c4_m4_a_3_2_mti_c4_dec_exp_con_dec": {
    "de": "Brüche in Dezimalzahlen umwandeln",
    "fr": "Passer de l’écriture fractionnaire à l’écriture décimale",
    "en": "Converting Fractions to Decimal Numbers",
    "pt": "Passar da forma fracionária à forma decimal"
  },
  "vp_m3_c4_m6_b_5_2_ope": {
    "en": "Ordering areas",
    "pt": "Ordenar medições de áreas",
    "fr": "Ordonner des aires",
    "de": "Flächen sortieren"
  },
  "vp_m3_c4_m6_c_2_1_ope": {
    "en": "Stamps - Which one doesn't belong?",
    "pt": "Carimbos - qual é que não serve?",
    "fr": "Tampons - lequel ne convient pas?",
    "de": "Stempel - Welcher passt nicht?"
  },
  "vp_m3_c4_m6_c_2_2_ope": {
    "en": "Stamps - Collect them all!",
    "pt": "Carimbos - coleciona-os todos!",
    "fr": "Tampons - collectionne les tous!",
    "de": "Stempel - finde alle Abdrücke!"
  },
  "vp_m3_c4_m6_a_1_8_ope": {
    "en": "Unfolding the models",
    "pt": "Desdobrar figuras",
    "fr": "Déplier des modèles",
    "de": "Modelle auseinanderfalten"
  },
  "vp_m3_c4_m6_a_3_8_mti_c4_m6_con_are": {
    "en": "Abacis and Metrâh - convert areas",
    "pt": "Abacis e Metrâh - Conversão de áreas",
    "fr": "Abacis et Metrâh - convertir des aires",
    "de": "Abacis und Metrâh - Flächen umwandeln"
  },
  "vp_m3_c4_m4_b_6_1_ope": {
    "de": "Dominos (Teil 2)",
    "fr": "Dominos (Partie 2)",
    "en": "Dominos (Part 2)",
    "pt": "Dominós (Parte 2)"
  },
  "vp_m3_c4_m4_a_3_3_ope": {
    "de": "Brüche in Dezimalzahlen umwandeln - Übungen",
    "fr": "Passer de l’écriture fractionnaire à l’écriture décimale - Exercice",
    "en": "Converting Fractions to Decimal Numbers - Exercise",
    "pt": "Passar da forma fracionária à forma decimal - Exercício"
  },
  "vp_m3_c4_m4_a_2_1_mti_c4_dec_exp_add_sub": {
    "de": "Addition von Dezimalzahlen",
    "fr": "Addition de nombres décimaux",
    "en": "Addition of Decimal Numbers",
    "pt": "Adição de números decimais"
  },
  "vp_m3_c4_m5_formative_3": {
    "en": "The Cartesian Grid",
    "fr": "Cooordonnées",
    "de": "Koordinaten",
    "pt": "Cooordonnées"
  },
  "vp_m3_c4_m5_c_2_1_ope": {
    "fr": "Le menuisier",
    "en": "The Carpenter",
    "de": "Der Schreiner",
    "pt": "O marceneiro"
  },
  "vp_m3_c4_m5_c_3_1_ope": {
    "fr": "Trouver le modèle des points",
    "en": "Find the pattern in the dots",
    "de": "Punktmuster herausfinden",
    "pt": "Determinar o padrão"
  },
  "vp_m3_c4_m1_a_2_4_are_tri_exp": {
    "en": "Area of Triangles",
    "fr": "L'aire du triangle",
    "de": "Flächeninhalt von Dreiecken",
    "pt": "Área de triângulos"
  },
  "vp_m3_c4_m2_a_2_3_div_10_exp": {
    "en": "Divisibility by 10",
    "fr": "Divisibilité par 10",
    "de": "Teilbarkeit durch 10",
    "pt": "Divisibilidade por 10"
  },
  "vp_m3_c4_m1_a_2_3_are_par_exp": {
    "en": "Area of Parallelograms",
    "fr": "L'aire du parallélogramme",
    "de": "Flächeninhalt von Parallelogrammen",
    "pt": "Área de paralelogramos"
  },
  "vp_m3_c4_m5_a_2_3a_mti_c4_m5_gra_his": {
    "fr": "Centre national pour l´infographie - créer un diagramme en bâtons",
    "en": "Graphic Design Center - Create a bar graph",
    "de": "Grafik-Zentrum - ein Säulendiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico de barras"
  },
  "vp_m3_c4_m1_a_2_2_are_rec_exp": {
    "en": "Area of Rectangles (and Squares)",
    "fr": "L'aire des rectangles (et carrés)",
    "de": "Flächeninhalt von Rechtecken (und Quadraten)",
    "pt": "Área de rectângulos (e quadrados)"
  },
  "vp_m3_c4_m5_a_2_9_ope": {
    "fr": "Construction de diagrammes",
    "en": "Creating graphs",
    "de": "Diagramme erstellen",
    "pt": "Construção de gráficos"
  },
  "vp_m3_c4_m5_a_2_8_mti_c4_m5_gra_exe": {
    "fr": "Exercices diagrammes circulaires",
    "en": "Pie graph practice",
    "de": "Übungen zum Kreisdiagramm",
    "pt": "Exercícios de gráfico circulares"
  },
  "vp_m3_mtic_g78_m4_reproduire_partie_2": {
    "en": "Represent Fractions - Part 2 ",
    "fr": "Représenter des fractions - partie 2",
    "de": "Brüche darstellen (T2)",
    "pt": "Represent Fractions - Part 2"
  },
  "vp_m3_mtic_g78_m4_order": {
    "en": "Ordering Fractions",
    "fr": "Ordonner des fractions",
    "de": "Brüche ordnen",
    "pt": "Ordering Fractions"
  },
  "vp_m3_c4_m5_a_2_7_mti_c4_m5_gra_cir": {
    "fr": "Centre national pour l´infographie - créer un diagramme circulaire",
    "en": "Graphic Design Center - Create a pie graph",
    "de": "Grafik-Zentrum - ein Kreisdiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico circular"
  },
  "vp_m3_c4_m5_b_1_1_ope": {
    "fr": "Choisir la zone coloriée",
    "en": "Choose the coloured zone",
    "de": "Den farbigen Bereich wählen",
    "pt": "Escolher a zona pintada"
  },
  "vp_m3_c4_m5_b_2_1_ope": {
    "fr": "Etude de la croissance de deux arbres",
    "en": "Investigating tree growth",
    "de": "Baumwachstum erforschen",
    "pt": "Estudar o crescimento de duas árvores"
  },
  "vp_m3_c4_m6_b_1_1_ope": {
    "en": "Faulty nets",
    "pt": "Planificações erradas",
    "fr": "Mauvais patrons",
    "de": "Fehlerhafte Netze"
  },
  "vp_m3_c4_m1_c_2_1_are_roo_sce": {
    "en": "Room Remodelling",
    "fr": "Constructions de chambres",
    "de": "Umbau der Zimmer",
    "pt": "Remodelação de quartos"
  },
  "vp_m3_c4_m1_c_1_1_ope": {
    "en": "Lake",
    "fr": "Lac",
    "de": "See",
    "pt": "Lago"
  },
  "vp_m3_c4_m1_b_3_2_are_com_tan": {
    "en": "Comparing Areas: tangrams",
    "fr": "Comparer les aires: tangram",
    "de": "Flächen vergleichen: Tangram",
    "pt": "Comparar áreas: tangram"
  },
  "vp_m3_c4_m5_a_2_5_mti_c4_m5_gra_lin": {
    "fr": "Centre national pour l´infographie - créer un diagramme linéaire",
    "en": "Graphic Design Center - Create a line graph",
    "de": "Grafik-Zentrum - ein Liniendiagramm erstellen",
    "pt": "Centro Nacional para a Infografia - criar um gráfico de linhas"
  },
  "vp_m3_c4_m4_a_2_5_mti_c4_dec_exp_mul_par": {
    "de": "Multiplikation von Dezimalzahlen (Teil 2)",
    "fr": "Multiplication de nombres décimaux (partie 2)",
    "en": "Multiplication of Decimal Numbers (Part 2)",
    "pt": "Multiplicação de números decimais (Parte 2)"
  },
  "vp_m3_c4_m3_b_1_3_ope": {
    "de": "Den Bruchteil einer Figur bestimmen (Teil 2)",
    "en": "Determine the fraction from a figure (Part 2)",
    "fr": "Déterminer la fraction d'une figure (Partie 2)",
    "pt": "Determinar a fração a partir de uma figura (Parte 2)"
  },
  "vp_m3_c4_m4_a_2_7_mti_c4_dec_exp_div_par": {
    "de": "Division von Dezimalzahlen (Teil 2)",
    "fr": "Division de nombres décimaux (partie 2)",
    "en": "Division of Decimal Numbers (Part 2)",
    "pt": "Divisão de números decimais (Parte 2)"
  },
  "vp_m3_c4_m4_a_3_8_mti_c4_dec_exp_fra_par": {
    "de": "Nicht dezimale Bruche (Teil 2)",
    "fr": "Fractions non-decimales (Part 2)",
    "en": "Non-decimal Fractions (Part 2)",
    "pt": "Frações não decimais  (Parte 2)"
  },
  "vp_m3_c4_m4_a_2_6_mti_c4_dec_exp_div": {
    "de": "Division von Dezimalzahlen (Teil 1)",
    "fr": "Division de nombres décimaux (partie 1)",
    "en": "Division of Decimal Numbers (Part 1)",
    "pt": "Divisão de números decimais (Parte 1)"
  },
  "vp_m3_c4_m4_a_3_7_ope": {
    "de": "Nicht dezimale Bruche - Übungen",
    "fr": "Fractions non-decimales - Exercice",
    "en": "Non-decimal Fractions - Exercises",
    "pt": "Frações não decimais  - Exercícios"
  },
  "vp_m3_c4_m1_a_2_1_are_int_exp": {
    "en": "Introduction to Area",
    "fr": "Introduction aux aires",
    "de": "Einführung in den Flächeninhalt",
    "pt": "Introdução às áreas"
  },
  "vp_m3_c4_m6_a_3_1_mti_c4_m6_con_why": {
    "en": "Abacis and Metrâh convert lengths",
    "pt": "Abacis e Metrâh - Conversão de medidas de comprimentos",
    "fr": "Abacis et Metrâh - convertir des longueurs",
    "de": "Abacis und Metrâh - Längen umwandeln"
  },
  "vp_m3_mtic_g78_m8_a9": {
    "en": "Surface Area of Prisms",
    "fr": "Aire totale des prismes",
    "de": "Oberfläche Prisma",
    "pt": "Aire totale des prismes"
  },
  "vp_m3_c4_m4_a_3_4_mti_c4_dec_exp_con_dec_par": {
    "de": "Brüche in Dezimalzahlen umwandeln mit Hilfe von gleichwertigen Brüchen",
    "fr": "Passer de l'écriture fractionnaire à l'écriture décimale avec des fractions équivalentes",
    "en": "Converting Fractions to Decimal Numbers with Equivalent Fractions",
    "pt": "Passar da forma fracionária à forma decimal com frações equivalentes"
  },
  "vp_m3_c4_m5_a_2_3b_mti_c4_m5_gra_his_pt2": {
    "fr": "Centre national pour l´infographie - lire un diagramme en bâtons",
    "en": "Graphic Design Center - Read your bar graph",
    "de": "Grafik-Zentrum - ein Säulendiagramm lesen",
    "pt": "Centro Nacional para a Infografia - ler um gráfico de barras"
  },
  "vp_m3_c4_m5_b_1_2_ope": {
    "fr": "Créer des polygones",
    "en": "Create the shape",
    "de": "Ebene Formen bilden",
    "pt": "Construir polígonos"
  },
  "vp_m3_mtic_g78_m8_b2": {
    "en": "Area Exercises",
    "fr": "Aire: exercice",
    "de": "Flächeninhalt: Übungen",
    "pt": "Aire: exercice"
  },
  "vp_m3_mtic_g78_m8_b31": {
    "en": "Area of Comp. Shapes",
    "fr": "Aire de figures composées",
    "de": "Fläche zus.ges Figuren",
    "pt": "Aire de figures composées"
  },
  "vp_m3_mtic_g78_m8_b5": {
    "en": "Surface Area of Prisms Exercises",
    "fr": "Aire totale des prismes: exercices",
    "de": "Oberfläche Prisma Übg.",
    "pt": "Aire totale des prismes: exercices"
  },
  "vp_m3_c4_m3_b_1_4_ope": {
    "de": "Flaggen",
    "en": "Flags",
    "fr": "Drapeaux",
    "pt": "Bandeiras"
  },
  "vp_m3_c4_m4_a_2_4_mti_c4_dec_exp_mul": {
    "de": "Multiplikation von Dezimalzahlen (Teil 1)",
    "fr": "Multiplication de nombres décimaux (partie 1)",
    "en": "Multiplication of Decimal Numbers (Part 1)",
    "pt": "Multiplicação de números decimais (Parte 1)"
  },
  "vp_m3_c4_m4_b_2_2_ope": {
    "de": "Addition von Dezimalzahlen",
    "fr": "Addition de nombres décimaux",
    "en": "Addition of Decimal Numbers",
    "pt": "Adição de números decimais"
  },
  "vp_m3_c4_m6_b_3_2_ope": {
    "en": "Blocks and surface area",
    "pt": "Blocos e a área deles",
    "fr": "Des blocs et leur aire",
    "de": "Würfel und Flächeninhalt"
  },
  "vp_m3_mtic_g78_m4_determine_figure": {
    "en": "Determine the Fraction",
    "fr": "Déterminer une fraction",
    "de": "Brüche bestimmen",
    "pt": "Determine the fraction"
  },
  "vp_m3_mtic_g78_m4_equiv_b": {
    "en": "Equivalent Fractions Exercises",
    "fr": "Fractions équivalentes: exercices",
    "de": "Äquivalente Brüche: Übg.",
    "pt": "Equivalent Fractions Exercises"
  },
  "vp_m3_mtic_g78_m4_num_line_b": {
    "en": "Fractions on the Number Line Exercises",
    "fr": "Fractions et demi-droite: exercices",
    "de": "Zahlenstrahl: Übungen",
    "pt": "Fractions on Number Line Exercises"
  },
  "vp_m3_c4_m3_b_2_1_ope": {
    "de": "Einen Bruch darstellen (Teil 1)",
    "en": "Represent a fraction (Part 1)",
    "fr": "Représenter une fraction (partie 1)",
    "pt": "Representar uma fração (Parte 1)"
  },
  "vp_m3_c4_m4_a_2_2_mti_c4_dec_exp_add_sub_spl": {
    "de": "Subtraktion von Dezimalzahlen",
    "fr": "Soustraction de nombres décimaux",
    "en": "Subtraction of Decimal Numbers",
    "pt": "Subtração de números decimais"
  },
  "vp_m3_c4_m4_a_2_3_ope": {
    "de": "Addition und Subtraktion von Dezimalzahlen - Übungen",
    "fr": "Addition et soustraction de nombres décimaux - Exercice",
    "en": "Addition and Subtraction of Decimal Numbers - Exercise",
    "pt": "Adição e subtração de números decimais - Exercícios"
  },
  "vp_m3_c4_m4_a_3_5_ope": {
    "de": "Brüche in Dezimalzahlen umwandeln - Übungen",
    "fr": "Passer de l'écriture fractionnaire à l'écriture décimale - Exercice",
    "en": "Converting Fractions to Decimal Numbers - Exercise",
    "pt": "Passar da escrita fracionária à escrita decimal - Exercícios"
  },
  "vp_m3_c4_m5_a_1_1_mti_c4_m5_rep_des_pir": {
    "fr": "Le repère des pirates !",
    "en": "The Pirate's Coordinate System!",
    "de": "Das Koordinatensystem der Piraten!",
    "pt": "O reduto dos piratas!"
  },
  "vp_m3_c4_m1_b_4_1_ope": {
    "en": "Perimeter Construction",
    "fr": "Construction de polygones d'un certain périmètre",
    "de": "Übungen zum Umfang",
    "pt": "Exercícios com perímetros"
  },
  "vp_m3_c4_m1_b_4_2_ope": {
    "en": "Area Construction",
    "fr": "Construire des polygones d'une certaine aire",
    "de": "Flächeninhalt - Übungen",
    "pt": "Exercícios com áreas"
  },
  "vp_m3_mtic_g78_m4_reproduire_partie_1": {
    "en": "Represent Fractions - Part 1 ",
    "fr": "Représenter des fractions - partie 1",
    "de": "Brüche darstellen (T1)",
    "pt": "Represent Fractions - Part 1"
  },
  "vp_m3_c4_m2_a_2_1_div_2_exp": {
    "en": "Divisibility by 2",
    "fr": "Divisibilité par 2",
    "de": "Teilbarkeit durch 2",
    "pt": "Divisibilidade por 2"
  },
  "vp_m3_c4_m2_b_3_1_fac_cre_pro": {
    "en": "Write the number as a product (Part 2)",
    "fr": "Ecrire un nombre sous la forme d'un produit (Partie 2)",
    "de": "Eine Zahl als Produkt schreiben (Teil 2)",
    "pt": "Escrever um número como produto de dois fatores (Parte 2)"
  },
  "vp_m3_c4_m5_a_1_2_ope": {
    "fr": "Trouver le trésor à partir des coordonnées",
    "en": "Find the treasure using its coordinates",
    "de": "Koordinaten für die Schatzsuche nutzen",
    "pt": "Encontra o tesouro utilizando as coordenadas"
  },
  "vp_m3_c4_m5_b_1_3_ope": {
    "fr": "Placer les joueurs",
    "en": "Position the team's players",
    "de": "Spieler setzen",
    "pt": "Colocar os jogadores"
  },
  "vp_m3_c4_m1_b_2_2_are_rig_pol": {
    "en": "Area of Right-Angled Polygons (Part 1)",
    "fr": "L'aire des polygones à angle droit (Partie 1)",
    "de": "Flächeninhalt von rechtwinkligen Vielecken (Teil 1)",
    "pt": "Área de polígonos retangulares (Parte 1)"
  },
  "vp_m3_c4_m5_b_2_2_ope": {
    "fr": "Planche de Galton",
    "en": "The Galton Board",
    "de": "Das Galton'sche Brett",
    "pt": "Máquina de Galton"
  },
  "vp_m3_c4_m5_a_1_4_ope": {
    "fr": "Compléter la figure",
    "en": "Complete the shape",
    "de": "Figuren vervollständigen",
    "pt": "Completa a figura"
  },
  "vp_m3_c4_m5_a_1_3_ope": {
    "fr": "Identifier les coordonnées des étapes",
    "en": "Identify the coordinates of the landmark",
    "de": "Koordianten von Sehenswürdigkeiten herausfinden",
    "pt": "Identificar as coordenadas de monumentos ou locais de interesse"
  },
  "vp_m3_mtic_g78_m8_a12": {
    "en": "Workspace",
    "fr": "Espace de travail",
    "de": "Zus.gesetzte Figuren",
    "pt": "Espace de travail"
  },
  "vp_m3_c4_m1_b_2_4_are_rig_pol_res": {
    "en": "Area of Right-Angled Polygons (Part 2)",
    "fr": "L'aire des polygones à angle droit (Partie 2)",
    "de": "Flächeninhalt von rechtwinkligen Vielecken (Teil 2)",
    "pt": "Superfícies de polígonos retangulares (Parte 2)"
  },
  "vp_m3_c4_m3_a_2_1_fra_sur_dro_exp": {
    "de": "Einen Bruch auf einem Zahlenstrahl darstellen",
    "en": "Representing a fraction on a number line",
    "fr": "Représenter une fraction sur une droite graduée",
    "pt": "Representar uma fração numa reta"
  },
  "vp_m3_c4_m3_b_1_1_ope": {
    "de": "Den Bruchteil einer Menge bestimmen",
    "en": "Determine the fraction from a set",
    "fr": "Déterminer la fraction d'un ensemble",
    "pt": "Determinar a fração de um conjunto"
  },
  "vp_m3_c4_m3_b_1_2_ope": {
    "de": "Den Bruchteil einer Figur bestimmen (Teil 1)",
    "en": "Determine the fraction from a figure (Part 1)",
    "fr": "Déterminer la fraction d'une figure (Partie 1)",
    "pt": "Determinar a fração de uma figura (Parte 1)"
  },
  "vp_m3_c4_m5_b_2_3_ope": {
    "fr": "Jetons de poker",
    "en": "Poker chips",
    "de": "Poker-Chips",
    "pt": "Fichas de poker"
  },
  "vp_m3_c4_m5_b_4_2_mti_c4_m5_ath_pt2": {
    "fr": "Athlétisme - interpréter des données",
    "en": "Track and field - Interpreting data",
    "de": "Leichtathletik - Daten auswerten",
    "pt": "Atletismo - interpretar dados"
  },
  "vp_m3_c4_m1_c_3_1_mea_gua_dog": {
    "en": "Guard Dog",
    "fr": "Chien de garde",
    "de": "Der Wachhund",
    "pt": "Cão de guarda"
  },
  "vp_m3_c4_m3_a_1_1_lir_fra_exp": {
    "de": "Einen Bruch an einer Figur ablesen",
    "en": "Reading a fraction from a figure",
    "fr": "Lire une fraction à partir d'une figure",
    "pt": "Ler uma fração a partir de uma figura"
  },
  "vp_m3_c4_m5_b_4_1_mti_c4_m5_ath": {
    "fr": "Athlétisme - compléter des tableaux",
    "en": "Track and field - Completing tables",
    "de": "Leichtathletik - Tabellen ausfüllen",
    "pt": "Atletismo - completar tabelas"
  },
  "vp_m3_mtic_g78_m4_triominos_pt2": {
    "en": "Fraction Triominos Challenge",
    "fr": "Défi de triominos avec fractions",
    "de": "Bruch-Triomino Challenge",
    "pt": "Fraction Triominos Challenge"
  },
  "vp_m3_mtic_g78_m4_triominos_pt1": {
    "en": "Fraction Triominos",
    "fr": "Triominos avec fractions",
    "de": "Bruch-Triomino",
    "pt": "Fraction Triominos"
  },
  "vp_m3_mtic_g78_m8_a5": {
    "en": "Area of Circles",
    "fr": "Aire de disques",
    "de": "Fläche Kreis",
    "pt": "Aire de disques"
  },
  "vp_m3_mtic_g78_m4_dominos": {
    "en": "Fraction Dominos",
    "fr": "Dominos avec fractions",
    "de": "Bruch-Domino",
    "pt": "Fraction Dominos"
  },
  "vp_m3_mtic_g78_m8_a102": {
    "en": "Surface Area of Cylinders",
    "fr": "Aire totale des cylindres",
    "de": "Oberfläche Zylinder",
    "pt": "Aire totale des cylindres"
  },
  "vp_m3_mtic_g78_m8_a41": {
    "en": "Review of Area",
    "fr": "Aire  rect., paral. et triangles",
    "de": "Fläche RE, Paral, Dreieck",
    "pt": "Aire  rect., paral. et triangles"
  },
  "vp_m3_mtic_g78_m8_a42": {
    "en": "Area of Trapezoids",
    "fr": "Aire de trapèzes",
    "de": "Fläche Trapez",
    "pt": "Aire de trapèzes"
  },
  "vp_m3_c4_m6_a_3_9_mti_c4_m6_con_are_tbl": {
    "en": "Converting area - Conversion table",
    "pt": "Conversão de áreas - Tabela de conversão",
    "fr": "Convertir des aires - Tableau de conversion",
    "de": "Flächen umwandeln - Umwandlungstabelle"
  },
  "vp_m3_c4_m4_b_6_2_ope": {
    "de": "Dominos (Teil 3)",
    "fr": "Dominos (partie 3)",
    "en": "Dominos (Part 3)",
    "pt": "Dominós (Parte 3)"
  },
  "vp_m3_mtic_g78_m4_comp_a": {
    "en": "Comparing Fractions",
    "fr": "Comparer des fractions",
    "de": "Brüche vergleichen",
    "pt": "Intro to Comparing Fractions"
  },
  "vp_m3_c4_m1_b_2_1_are_rec_squ": {
    "en": "Area of Rectangles",
    "fr": "Aire d´un rectangle",
    "de": "Flächeninhalt eines Rechtecks",
    "pt": "Área de retângulos"
  },
  "vp_m3_mtic_g78_m4_multiple": {
    "en": "Multiples",
    "fr": "Multiples",
    "de": "Vielfache",
    "pt": "Múltiplos"
  },
  "vp_m3_mtic_g78_m4_num_line_a": {
    "en": "Fractions on the Number Line",
    "fr": "Fractions et demi-droite graduée",
    "de": "Brüche am Zahlenstrahl",
    "pt": "Fractions on the Number Line"
  },
  "vp_m3_mtic_g78_m4_comp_b": {
    "en": "Comparing Fractions Exercises",
    "fr": "Comparer des fractions: exercices",
    "de": "Brüche vergleichen: Übg.",
    "pt": "Compare Fractions Exercises"
  },
  "vp_m3_c4_m1_b_2_6_are_pol_peg": {
    "en": "Area of polygons : pegboard",
    "fr": "L'aire des polygones : géoplan",
    "de": "Flächeninhalt von Vielecken: Geobrett",
    "pt": "Área de polígonos: Geoplano"
  },
  "vp_m3_c4_m1_b_3_1_are_com": {
    "en": "Comparing Areas",
    "fr": "Comparer les aires",
    "de": "Flächen vergleichen",
    "pt": "Comparar áreas"
  },
  "vp_m3_c4_m2_a_2_2_div_5_exp": {
    "en": "Divisibility by 5",
    "fr": "Divisibilité par 5",
    "de": "Teilbarkeit durch 5",
    "pt": "Divisibilidade por 5"
  },
  "vp_m3_c4_m2_a_2_4_div_4_exp": {
    "en": "Divisibility by 4",
    "fr": "Divisibilité par 4",
    "de": "Teilbarkeit durch 4",
    "pt": "Divisibilidade por 4"
  },
  "vp_m3_c4_m2_a_2_5_div_3_exp": {
    "en": "Divisibility by 3",
    "fr": "Divisibilité par 3",
    "de": "Teilbarkeit durch 3",
    "pt": "Divisibilidade por 3"
  },
  "vp_m3_c4_m4_b_3_1_ope": {
    "de": "Multiplikation von Dezimalzahlen",
    "fr": "Multiplication de nombres décimaux",
    "en": "Multiplication of Decimal Numbers",
    "pt": "Multiplicação de números decimais"
  },
  "vp_m3_c4_m4_b_4_2_est_lor_de_gra_de_res_ave_ass": {
    "de": "Ergebnisse schätzen (Teil 2)",
    "fr": "Estimer le résultat (partie 2)",
    "en": "Approximating the Result (Part 2)",
    "pt": "Fazer estimativas (Parte 2)"
  },
  "vp_m3_c4_m4_b_4_3_ope": {
    "de": "Division von Dezimalzahlen",
    "fr": "Division de nombres décimaux",
    "en": "Division of Decimal Numbers",
    "pt": "Divisão de números decimais"
  },
  "class_is_archived": {
    "en": "This class is currently archived.",
    "fr": "This class is currently archived.",
    "de": "This class is currently archived.",
    "pt": "This class is currently archived."
  },

  // VP Modulaire Module module names
  "mtic_vp_m1": {
    "en": "Module 1",
    "fr": "Module 1",
    "de": "Modul 1",
    "pt": "Módulo 1"
  },

  "mtic_vp_m2": {
    "en": "Module 2",
    "fr": "Module 2",
    "de": "Modul 2",
    "pt": "Módulo 2"
  },
  "mtic_vp_m3": {
    "en": "Module 3",
    "fr": "Module 3",
    "de": "Modul 3",
    "pt": "Módulo 3"
  },

  "agenda_items_included": {
    "en": "Items included in the agenda:",
    "fr": "Exercices inclus dans l'agenda:",
    "de": "In der Agenda enthaltene Aufgaben:",
    "pt": "Exercícios incluídos na agenda:"
  }

});

angular.module('mtic').constant('LANGUAGE_SLUG_LINK', {
  "username": 11291,
  "password": 11292,
  "dont_have_an_account": 11293,
  "sign_up": 11294,
  "student": 11295,
  "teacher": 11296,
  "teacher_id": 11297,
  "class_id": 11298,
  "first_name": 11299,
  "last_name": 11300,
  "confirm_password": 11301,
  "already_have_an_account": 11302,
  "access_code": 11303,
  "email": 11304,
  "logout": 11305,
  "please_fill_in_both_username_and_password": 11306,
  "username_is_not_found": 11307,
  "invalid_password": 11308,
  "please_complete_all_fields_to_sign_up": 11309,
  "the_access_code_you_entered_is_not_valid": 11310,
  "this_username_already_exists": 11311,
  "invalid_class_id_or_teacher_id": 11312,

  "mtic_c3_m1_plane": 10734,
  "mtic_c3_m1_airport": 10735,
  "mtic_c3_m1_bus": 10736,
  "mtic_c3_m1_monkey": 10737,
  "mtic_c3_m1_flamingo": 10738,
  "mtic_c3_m1_plan_bakery": 10739,
  "mtic_c3_m1_plan_park": 10740,
  "mtic_c3_m1_plan_rollercoaster": 10741,
  "mtic_c3_m1_plan_chocolate": 10742,
  "mtic_c3_m1_exec_bakery": 10743,
  "mtic_c3_m1_exec_park": 10744,
  "mtic_c3_m1_exec_rollercoaster": 10745,
  "mtic_c3_m1_exec_chocolate": 10746,
  "mtic_c3_m1_logbook": 10747,
  "mtic_c3_m1_elephants": 10748,
  "mtic_c3_m1_fish": 10749,
  "mtic_c3_m1_train_paris": 10750,
  "mtic_c3_m1_bike_tachometer": 10751,
  "mtic_c3_m1_sticker": 10752,
  "mtic_c3_m1_skateshop": 10753,
  "mtic_c3_m1_souvenir_b": 10754,
  "mtic_c3_m1_lemur": 10755,
  "mtic_c3_m1_airplane_porto": 10756,
  "mtic_c3_m1_car_tachometer": 10757,
  "mtic_c3_m1_jump": 10758,
  "mtic_c3_m1_camping": 10759,
  "mtic_c3_m1_souvenir_c": 10760,
  "mtic_c3_m1_tram": 10761,
  "mtic_c3_m1_block_tower": 10762,

  "agenda_attempt_limit": 12661,
  "agenda_force_redo": 12662,
  "agenda_force_unlock_description_0": 12663,
  "agenda_force_unlock_description_3": 12664,
  "agenda_force_unlock_description_1": 12665,
  "agenda_force_unlock_description_2": 12666,
  "agenda_force_lock_default": 12667,
  "agenda_force_unlock": 12668,
  "agenda_force_lock": 12669,
  "agenda_options": 12670,
  "agenda_publish": 12671,
  "agenda_unpublish": 12672,
  "agenda_info": 12673,
  "agenda_edit": 12674,
  "agenda_main_name": 12675,
  "agenda_create": 12676,
  "agenda_delete": 12677,
  "agenda_update": 12678,
  "cancel": 12679,
  "agenda_resource": 12680,
  "agenda_update_custom_resource": 12681,
  "agenda_add_custom_resource": 12682,
  "agenda_custom_resource": 12683,
  "agenda_add_students": 12684,
  "agenda_students": 12685,
  "agenda_assignee": 12686,
  "agenda_date": 12687,
  "agenda_title": 12688,
  "error_something_happened": 12689,
  "make_new_agenda": 12690,
  "new_agenda": 12691,
  "edit_agenda": 12692,
  "do_not_see_text": 12693,
  "link_in_another_window": 12694
});
'use strict';

angular.module('mtic').constant('ITEM_VERSION_MAP', {
    "mtic_c3_m1_assessment": "0.4.12",
    "mtic_c3_m1_bike_tachometer": "Hw9AsuXR.tiPUd5Drk39BFQdDep_0Yj7",
    "mtic_c3_m1_elephants": "tO.KinG880iiqRfTrzC3Ahj7esRN_FU.",
    "mtic_c3_m1_fish": "3t0lKF8cFRDCgwnl8cJS8viZEkzd_H2h",
    "mtic_c3_m1_skateshop": "XCvG3R.jhPzbAbq7C.POqMIBtjIADT1P",
    "mtic_c3_m1_sticker": "n3TrpNbUEQRM4PmwpJ7fbE79vTTbJoZl",
    "mtic_c3_m1_airplane_porto": "kjgZuzSN_cf32Vucv7L94bK1C_PVfGMj",
    "mtic_c3_m1_train_paris": "PP9llPLSPNRbEXl2kNgPAJ0e2E5rCFzi",
    "mtic_c3_m1_jump": "S6Yy0eRLxA_HiVD0K1ZZsiI.jfkV9Aa1",
    "mtic_c3_m1_camping": "0GHNnDc1KnCXcqkp2akFInQ9Z2hd2YaS",
    "mtic_c3_m1_lemur": "9XCPVKtC7p_SFok7Xuo0jFyETk4wwyXX",
    "mtic_c3_m1_car_tachometer": "LInsj.PzkYEG4quEUmuIi1fDiww2CbmY",
    "mtic_c3_m1_souvenir_b": "OI7xpq.dj5SDCMR7LDpyr.5WBRsM9G4h",
    "mtic_c3_m1_airport": "IJhikYGIbHCZaifMSq_6dSP1zPJuameP",
    "mtic_c3_m1_souvenir_c": "OH46dUeaYidCbsEaUWieeO369I9e1jNM",
    "mtic_c3_m1_block_tower": "SoU_9v.oR5C1PZMjtSEiix.2tVVsJGsH",
    "mtic_c3_m1_tram": "xqyma0YVaeTfhy_isc.nHkoxZBaMvwQG",
    "mtic_c3_m1_exec_rollercoaster": "gndgdzGSIAeaOYfwjohw1iLd28wbXuJl",
    "mtic_c3_m1_exec_chocolate": "66GoQc4QuR.Ia4Iq0dRxQ63Dt2NDHg_h",
    "mtic_c3_m1_plan_chocolate": "hIQXalX4gAXKAEpT7uyKLlMktS8C4Ih2",
    "mtic_c3_m1_plan_rollercoaster": "j162nfzk8oiU5wtLPlba0z1F5MpiTYWj",
    "mtic_c3_m1_plane": "O9Bw1CfbKHCwSFD.9TviiWKyhABXKCt5",
    "mtic_c3_m1_plan_park": "9ZkWoa7CWuhWDto3IZzAo5CmBX_k6_cd",
    "mtic_c3_m1_plan_bakery": "N4Ie6MC1lOy0HNXeF9kKJrby2eZfb6BF",
    "mtic_c3_m1_flamingo": "ewTbILSTwgcuPvrU.JQE3UG931aTrEnI",
    "mtic_c3_m1_monkey": "aZN5L5JhpiPVfdDTCVDPqb8WryPy7Ldm",
    "mtic_c3_m1_bus": "skKRj2K9Cmy1NQ_IbQ.Wpj57ae4PLJ5F",
    "mtic_c3_m1_exec_bakery": "BDMH19aigzS5FoNtKzclVyZI8hNYOPff",
    "mtic_c3_m1_exec_park": "lPwRcJbFkef8mKFfR.wbNqVn47UlysK5",
    "mtic_c3_m1_logbook": "hV5fjiED0zyHrS4jiOljysFCDA8yQ0AW",
    "mtic_c3_m1_diagnostic": "0.4.8",
    "mtic_c3_m1_summative": "0.3.8",
    "mtic_g78_m1_additivity": "v2.0.36",
    "mtic_g78_m1_analyze_add_line": "v1.0.23",
    "mtic_g78_m1_analyze_coef": "v2.0.29",
    "mtic_g78_m1_analyze_graph": "v1.0.43",
    "mtic_g78_m1_analyze_linear": "v1.0.30",
    "mtic_g78_m1_candy": "v2.1.45",
    "mtic_g78_m1_conv_speed": "v2.0.44",
    "mtic_g78_m1_conv_speed_2": "v2.0.39",
    "mtic_g78_m1_crepes": "v1.1.21",
    "mtic_g78_m1_diag": "v1.0.24",
    "mtic_g78_m1_dist_storm": "v2.0.50",
    "mtic_g78_m1_flooring": "v1.0.61",
    "mtic_g78_m1_graph_form": "v3.1.39",
    "mtic_g78_m1_juice": "v1.0.60",
    "mtic_g78_m1_linearity": "v2.0.48",
    "mtic_g78_m1_look_prop": "v3.0.35",
    "mtic_g78_m1_meeting": "v1.0.53",
    "mtic_g78_m1_open": "v0.2.25",
    "mtic_g78_m1_path": "v1.1.25",
    "mtic_g78_m1_prop_coef": "v2.0.42",
    "mtic_g78_m1_prop_table_a": "v4.1.53",
    "mtic_g78_m1_prop_table_b": "v2.0.20",
    "mtic_g78_m1_recipe": "v3.0.44",
    "mtic_g78_m1_recipe_part_2": "v4.0.33",
    "mtic_g78_m1_robot": "v1.0.56",
    "mtic_g78_m1_rule_three": "v4.0.36",
    "mtic_g78_m1_speed_sound": "v1.0.41",
    "mtic_g78_m1_summ": "v1.0.2",
    "mtic_g78_m1_thunder_lightning": "v2.0.33",
    "mtic_g78_m2_diag_inbook": "v1.0.18",
    "mtic_g78_m2_corre_area": "IE7GOg3nIexlG_LqO0t15YFsNkUSQ19.",
    "mtic_g78_m2_fibonacci": "CCYrIWM7BJtCmJznrcHrVv8QGoMmbHA1",
    "mtic_g78_m2_dist_act": "e0R9U4hAUz7IzyKZjoqNXw9x6NIGk9dl",
    "mtic_g78_m2_dist_act_vpm6": "mBDUV8Gbjh20q4i9CSToB1ICgW_mtMNK",
    "mtic_g78_m2_diag": "jz3NdwChiGkdOxjQFBG_9O_jbiQohL.r",
    "mtic_g78_m2_distrib_add_pt1": "FJ.efav0FBpbs8jzVgIeeegR7rTDFsr1",
    "mtic_g78_m2_distrib_add_pt2": "BIPnc_UL8HUzI8JEx0cHG7qp3zSjsRre",
    "mtic_g78_m2_distrib_add_pt3": "di_oVFlIUZagKhb7zKYyd16RsPiAMesp",
    "mtic_g78_m2_distrib_exer": "gp90s91grWtUBLrDXOezBleI5QOOtiIW",
    "mtic_g78_m2_distrib_exer_vpm6": "j80U37Th7D0UYkUJYDClj7INMVMQLKSE",
    "mtic_g78_m2_distrib_sub_pt1": "66jde1kRPSJwfaYspOIY9AfLCSlQYNfs",
    "mtic_g78_m2_distrib_sub_pt2": "riql_0OQ3wh3XPmNykNobGYXGZnfS4H8",
    "mtic_g78_m2_distrib_sub_pt3": "Oy4rBob_0DqUX4rAFg1.zsiWYxt4i6O6",
    "mtic_g78_m2_distrib_sub_pt4": "Rr2uuObLQ1vEVS7yv8AnD4mQ9NAukjRq",
    "mtic_g78_m2_equiv_expr": "6gWJ0jg5LXZolI.Kr2iSwGxiCRjynRBK",
    "mtic_g78_m2_factoring_ex": "Hgb84pF5DGtGmLTOwhjL1sLBeHQ4EIGe",
    "mtic_g78_m2_factoring_pt1": "7RkU3mG_8nHCX0lElDiCC03dQ1t7MC4E",
    "mtic_g78_m2_factoring_pt2": "zKb8TKhOUVrRI6MY3DP6yLuze47eHGKa",
    "mtic_g78_m2_factoring_pt3": "N_9a_biVWbr9aJc_IxqdoGWGOfE7RB.X",
    "mtic_g78_m2_factoring_pt4": "3D.4XIFYmOFedknJmz6PN8FJpig.dlSO",
    "mtic_g78_m2_grand_stair": "Gm2P4sovmcXWHwrr9F.gkC3TKXYu0DMg",
    "mtic_g78_m2_prog_calc_a": "Xc2jtM2YsPtResKbcBjq42W8HVM8ESZe",
    "mtic_g78_m2_prog_calc_b1": "8f_XxurZFF.y3rYs6PRCCfeH9RR__sM9",
    "mtic_g78_m2_prog_calc_b2": "Tf.IN5oP7XCx4YE3SZcUBMZk5vSF4hz5",
    "mtic_g78_m2_spread_calc_pt1": "b5Jl1tTM_NJJteJ_aojQ7y.sxEuzfsEf",
    "mtic_g78_m2_spread_calc_pt2": "QMzkp4DCpSlJfNMZgVW47Jh3ZQXeQ6.L",
    "mtic_g78_m2_spread_calc_pt3": "7OPvyjKoXZg9t5CpoV3ErtX3xhStCp2D",
    "mtic_g78_m2_prog_calc_b3": "LeyCnhLYuZlq9Z1nqwOK7bLEIRb9XC1z",
    "mtic_g78_m2_grand_stair_pt1": "iV7s6OJIKpi.UFYW59LRnLMlb.ChqGbD",
    "mtic_g78_m2_grand_stair_pt2": "AsbWHGNhSZ7gIbjF6f7P8zD0ZBit83QC",
    "mtic_g78_m2_grand_stair_pt3": "mbzsCbd34pIkBKshjE2jOzs8I6Dv7TMa",
    "run_like_math": "OkMMcRRlUqXUseLbLTKqaBJ4gG4VcdwN",
    "run_like_math_teacher": "3dNf9YzQ2.HIFAXmZ1ZeJ8tXEfZQgJMr",
    "mtic_g78_m3_alg_balance": "v1.0.32",
    "mtic_g78_m3_alice_bob": "v2.2.32",
    "mtic_g78_m3_bracket_incl": "v1.0.45",
    "mtic_g78_m3_bracket_wo": "v1.0.45",
    "mtic_g78_m3_bracket_wo_pt2": "v1.0.37",
    "mtic_g78_m3_class_eq": "v1.0.29",
    "mtic_g78_m3_diag": "v1.1.32",
    "mtic_g78_m3_equal_area": "v1.0.41",
    "mtic_g78_m3_game_sub_pt1": "v1.0.34",
    "mtic_g78_m3_game_sub_pt2": "v1.0.34",
    "mtic_g78_m3_geo_area": "v1.0.40",
    "mtic_g78_m3_geo_perim": "v1.0.33",
    "mtic_g78_m3_graph_area": "v3.3.30",
    "mtic_g78_m3_graph_perim": "v1.1.34",
    "mtic_g78_m3_impos_eq": "v1.0.50",
    "mtic_g78_m3_impos_eq_pt2": "v1.0.41",
    "mtic_g78_m3_inver_oper": "v1.0.33",
    "mtic_g78_m3_inver_oper_pt2": "v1.0.31",
    "mtic_g78_m3_open": "v1.0.32",
    "mtic_g78_m3_receipt": "v2.0.31",
    "mtic_g78_m3_represent_eq": "v1.0.25",
    "mtic_g78_m3_sub_method": "v1.0.27",
    "mtic_g78_m3_summ": "v1.0.12",
    "mtic_g78_m3_word_prob": "v1.0.48",
    "mtic_g78_m3_word_prob_pt2": "v1.0.34",
    "mtic_c3_m34_diag": "v1.0.12",
    "mtic_c3_m34_dot": "WNa_zGYfI7kDe51TDJiA1B3SPVH_DOI6",
    "mtic_c3_m34_dot_vpm4": "3ZZvXir00bL5UPPVJwBDUn0.Cor0gEk4",
    "mtic_c3_m34_helicopter": "uLAtG.S_7wa0L15NS6zpD3AkyyVhV4nv",
    "mtic_c3_m34_dot_invalid": ".serUNsArTdlPSs.7XxWGlMXNbEwKpfl",
    "mtic_c3_m34_dot_invalid_vpm4": "wum__NuKVCg_skF3LH7o8l1p85hzElPr",
    "mtic_c3_m34_addsub_clouds_lv3": "Ir4lzwbJkNpUhwtBlOSSYBmqLtfHrYNh",
    "mtic_c3_m34_addsub_clouds_lv3_vpm4": "jol2EfVQVUhiMso73bkmNA.WBUqjUhEx",
    "mtic_c3_m34_addsub_clouds_lv2": "fgYROSB3WY7fplyOJuUTL60mx0PrfGEr",
    "mtic_c3_m34_addsub_clouds_lv2_vpm4": "pJSzF4lCyDw2iJJ09nUTMWJOYh2y7SJg",
    "mtic_c3_m34_addsub_clouds_lv1": "dmp80qGodU5VpQob3nxs4a39bp1AkBNg",
    "mtic_c3_m34_addsub_clouds_lv1_vpm4": "fqVA0O0ujtB_oxKDFiFBte3botwl9hKM",
    "mtic_c3_m34_decomp_tool": "upgasgQ8nrdgNGfhGWXazr_8NjF04f7L",
    "mtic_c3_m34_comp_digit": "fzu8J82se7KgK3GH1MVS.YWkOTKhlYr2",
    "mtic_c3_m34_comp_digit_vpm4": "k_M6dUTFYzQ.S1vU3zsvSaRXBcoaO2zt",
    "mtic_c3_m34_comp_digit_vpm8": "71dFVC_QFioUp3jwKJ6Ll1sSNEZ2V44U",
    "mtic_c3_m34_zahlen_fill_lv1": "9DdazPB2ZzrHLkdxFHyXXT0n7p7p_j05",
    "mtic_c3_m34_zahlen_fill_lv1_vpm4": "6gD2hSyFc6y6zk.cUYlYf9GdUaUnR_0T",
    "mtic_c3_m34_briefcase": "gnaFp87GCVFGzdXhoRwHTWtB4w_gixla",
    "mtic_c3_m34_get_mult": "9ZUDWAXuPWraAesWNqQsrP9qS_ZPRmvI",
    "mtic_c3_m34_get_mult_vpm4": "IIlTxKBKslxqicnbapFmduce72VHTkqq",
    "mtic_c3_m34_get_mult_vpm8": "ZTgpmZgbkBl_ylmOtIi9yFgyzHh9xMhH",
    "mtic_c3_m34_get_div": "cAF6N5wxufLPhtiUOSVV3Ki2gLRtgFCG",
    "mtic_c3_m34_get_div_vpm4": "OJ4.K.jdcLyi_zEWXaIArGcfetO0Ewyo",
    "mtic_c3_m34_get_div_vpm8": "EgHflArigROl7UbjcXfNEt.WyNq2Zo4T",
    "mtic_c3_m34_place_tool": "cMDKVnihko20vutD.okbqFrHqMB2j_e1",
    "mtic_c3_m34_zahlen_empty_lv1": "L70rA2Ekx.50LMt5hRYVj35eQFr026m8",
    "mtic_c3_m34_zahlen_empty_lv1_vpm4": "WTG8k81Nr_R1d2EFhnKzEokb33_H1Dzz",
    "mtic_c3_m34_zahlen_empty_lv5": "qPqIlrWQiq_KELQFdRrSGdDP5RCnPjDG",
    "mtic_c3_m34_zahlen_empty_lv5_vpm4": "MqpNMT8GJf4Vw2m0C4_82mb8Ds0mcgaj",
    "mtic_c3_m34_zahlen_empty_lv7": "mxm7_5UuLhtAJQpH95YWt21i9LDcOgXm",
    "mtic_c3_m34_zahlen_empty_lv7_vpm4": "UwLFU_Eetw6eVJpzvT2I48ig4EyENcXM",
    "mtic_c3_m34_zahlen_empty_lv6": "lTVLhPKdFvDxBa76PaoQNqGP4V.1lDHy",
    "mtic_c3_m34_zahlen_empty_lv6_vpm4": "ZfjgACkCayxE3tQguRZOLXrWyRJWe_mT",
    "mtic_c3_m34_zahlen_empty_lv8": "W26UxML6XcCxjZZuP98qkw_9BGzNhnQe",
    "mtic_c3_m34_zahlen_empty_lv8_vpm4": "DZUwpGEVF.QZx0dQ8cJh_I2ybt8lFj36",
    "mtic_c3_m34_zahlen_empty_lv3": "I9NFfZuJYQn_lWSmEJJgK.3Df81Yee6W",
    "mtic_c3_m34_zahlen_empty_lv3_vpm4": "lbHH2KxhMGQdMX2qeAZx05qn8In3wbHS",
    "mtic_c3_m34_zahlen_empty_lv4": "naRzDCgEN3VL8uYwq0E.e7bMbOtSUQE6",
    "mtic_c3_m34_zahlen_empty_lv4_vpm4": "7MVSVUrb2czfWjKNAweOkcvC0YlhB1sL",
    "mtic_c3_m34_zahlen_empty_lv9": "EiPL77Hcack2yM0_niZ_FgeS4PasZmxO",
    "mtic_c3_m34_zahlen_empty_lv9_vpm4": "5pWscfgOAZQLZF_FfzXJbA57yUzZ4csw",
    "mtic_c3_m34_zahlen_empty_lv2": "2yvlGs1GPrLtGIOViv4RNwQiKF4ObXpl",
    "mtic_c3_m34_zahlen_empty_lv2_vpm4": "99OlNsoK.imwVwXm0Iwgm03ja710oJhj",
    "mtic_c3_m34_num_zoom": "HEdGTa43D.RkgQgfv_Y7eaqHQGYCEaRb",
    "mtic_c3_m34_fishing_lv1": "VENzt1sB3xdJBiqw3tyaqX3sCYBXTx7U",
    "mtic_c3_m34_fishing_lv1_vpm4": "9Gm1RFT87kQ11vSt27N0EcH_1lpiyXi2",
    "mtic_c3_m34_div_concept_ex": "816vgyvaeW4T_9JV4egzzA5.bFgoczj9",
    "mtic_c3_m34_div_concept_ex_vpm4": "6Mp38JRtGMiGxIznZJJjkaiVq4cP0sl0",
    "mtic_c3_m34_fishing_lv3": "8W09YUHMLvrri5TbCq09_a_Rpf1XPOLM",
    "mtic_c3_m34_fishing_lv3_vpm4": "LfqNeHM68.W8U0ilQjIy_tobPUwmfwhx",
    "mtic_c3_m34_fishing_lv2": "1z0wwoxkU1wysq7X.cexuzyapSl8uVCa",
    "mtic_c3_m34_fishing_lv2_vpm4": "KqDR07BaHHIrZqiafnI3FPuUk_9_v9o.",
    "mtic_c3_m34_fishing_lv4": "47uUxjVAkv8BzWVGay7lkaGT223lgqQ3",
    "mtic_c3_m34_fishing_lv4_vpm4": "h8e4njF1TAmh.wyHgF9kojzOf3j6Z0DV",
    "mtic_c3_m34_toydeli_1k": "m3i4Zji8W2ZojQzylQ3FDsuzHtn54jLD",
    "mtic_c3_m34_toydeli_1m": "FLOgI1m0b14H8dOlESSLPRgCfuNYZlcg",
    "mtic_c3_m34_div_tool": "7Fny3Z3PoSJZGFeLrSZ7q95VVoSCsAxs",
    "mtic_c3_m34_div_tool_vpm4": "RnIA5Fw628SuP5x7PECF8sj0eYzVsMHY",
    "mtic_c3_m34_equal_ex": "tqRTJaS2ROUlk6CWzg9SA.wUip7j6FNZ",
    "mtic_c3_m34_mult_tool": "oLj8GUcPtqRzFxMxTWjoWnWXe43QDbp5",
    "mtic_c3_m34_mult_tool_vpm4": "FBWF7KOKtzUkrFEurg7IkwJd2r_Z.q2H",
    "mtic_c3_m34_multdiv_clouds_lv3": "B4bqVPkLVoUAFIdXxpkyWBNrelYxr6SA",
    "mtic_c3_m34_multdiv_clouds_lv3_vpm4": "YFAcwnXzRUdPvGU.P2rnNLaExiSQ3TrP",
    "mtic_c3_m34_multdiv_clouds_lv1": "X63Q0nNHk9nAMjvO9iKW9cXH6CQybZcE",
    "mtic_c3_m34_multdiv_clouds_lv1_vpm4": "DjYimNHAd5BPfCrXnPNhA5CbGR4pQwdV",
    "mtic_c3_m34_multdiv_clouds_lv2": "Q5ddyyjGxUNST1j9sq5jr3WYSQw.KkmF",
    "mtic_c3_m34_multdiv_clouds_lv2_vpm4": "85trbR82VHcSPl0uttADp4lL6JqFhhgH",
    "mtic_c3_m34_zahlen_fill_lv6": "IWcptUzeae1dO1lqBhT.CoSCajBW6D7i",
    "mtic_c3_m34_zahlen_fill_lv6_vpm4": "d9VbJur6_5.ejMCgSCG33P3sOr8VLczt",
    "mtic_c3_m34_zahlen_fill_lv2": "qoj1fcceJ78Hd0uYIKMfjBqxPUTvo7A4",
    "mtic_c3_m34_zahlen_fill_lv2_vpm4": "pvZAVCuY50foa1jE0ah2QD4ZKNF2_yqo",
    "mtic_c3_m34_zahlen_fill_lv4": "uVtn9r0.zE9_iDX3v3pYlnsnkj6oK4WT",
    "mtic_c3_m34_zahlen_fill_lv4_vpm4": "yYha1PzC.j7S92aO5Djhao2kgwPExehM",
    "mtic_c3_m34_zahlen_fill_lv3": "KcCX01ZdG63dvy8Q36iEk19oeqFJpFFL",
    "mtic_c3_m34_zahlen_fill_lv3_vpm4": "NhJGM2.PQSulC_RR0Dj6gzTlKfLs2HID",
    "mtic_c3_m34_zahlen_fill_lv5": "nfwBEXDG51yuliGQluAnkFhxwjsd2qsk",
    "mtic_c3_m34_zahlen_fill_lv5_vpm4": "QNKs17u5htFVUtOoV65HVCxrctCsKPLU",
    "mtic_c3_m34_mixed_clouds_lv2": "EinqxcVDn4QU3ealF1YtEQRl.KlvviVN",
    "mtic_c3_m34_mixed_clouds_lv1": "H_wohOAjA.koO2e11X72T2NH8WCKdkTw",
    "mtic_c3_m34_decomp_sub": "UUVMIUfPU2aRaJ9c8WN8UxFIP.Jez_wT",
    "mtic_c3_m34_decomp_add": "FZUUUPHi46k1ow1.gENeTjlWNqJYlPFQ",
    "mtic_c3_m34_canoe_lv1": "C_VQB9F5uWPjYpQNM1WMyxj9VbAX1.gC",
    "mtic_c3_m34_canoe_lv1_vpm4": "C7qEHRCWCfZusBLVXA6uSbWoIolbOY0l",
    "mtic_c3_m34_garden_mult_lv3": "7LZeyWmNxcKr9xRUUPVr0Ip9oXxOA7fK",
    "mtic_c3_m34_garden_mult_lv3_vpm4": "j5oViTN3ZKgSc0S8BCSa59FwXw5tx3If",
    "mtic_c3_m34_garden_mult_lv3_vpm8": "PKY8zehnBHaodxQRoyTMKO0htz4UYhEy",
    "mtic_c3_m34_garden_mult_lv2": "dWvuTL5ctu867njs296Hfm4m2Hrpc5fQ",
    "mtic_c3_m34_garden_mult_lv2_vpm4": "tLwVmrXGGEO5ka6gBWcCLDxWSoJYyQOr",
    "mtic_c3_m34_garden_mult_lv2_vpm8": "Kr_2_.fkUIruvqNS2xO3IsrMicumOuKd",
    "mtic_c3_m34_garden_mult_lv1": "TvbCW2MPd2sqX6DxDK6r3eopnUOritaQ",
    "mtic_c3_m34_garden_mult_lv1_vpm4": "C9nVGU9EAlbWBE57ZEp3SkzFHwrw.Oz9",
    "mtic_c3_m34_garden_mult_lv1_vpm8": "IOJhIqdCjqFhETBYT_8jUkoj9HWGxvbP",
    "mtic_c3_m34_toyfac_1m": "Ar9gSG9CKuBGdYOBdW9wW1LjFseJT54E",
    "mtic_c3_m34_place_val": "jWRRSkWm9BnivNUJMm3dmcNXacsD4zOS",
    "mtic_c3_m34_toyfac_1k": "f81bDvRsxwnqRUwud.JjtsEctYAyGb9Y",
    "mtic_c3_m34_equal_lesn": "Ktw7bSEcV9WNX_upC3H_DPhGFR8QZlfK",
    "mtic_c3_m34_div_concept": "wBdoxQrORyMxvlkaobKiOUArG0mGavdI",
    "mtic_c3_m34_div_concept_vpm4": "t7yAry0wzb78OZEPjz4tjF1FZATiIHB3",
    "mtic_c3_m34_canoe_lv2": "qtBedf02z3KRzPI4nUB8_T_a34w57fG_",
    "mtic_c3_m34_canoe_lv2_vpm4": "_Z_Jv5Heo.M1CnYJVTrTvvimEGy25nhZ",
    "mtic_c3_m34_zahlen_fill_intro": ".tzbvFSoLpEt2dPX5_8PkLSfN8EvBrIH",
    "mtic_c3_m34_zahlen_fill_intro_vpm4": "9OTsLY7DlhOd6.B.7u4qa9kV5tA3Br9E",
    "mtic_c3_m34_zahlen_empty_intro": "iQCczZ4GoUkJ4oMzpebbQDpdzjXi2Lsp",
    "mtic_c3_m34_zahlen_empty_intro_vpm4": "uJ3HPyQrip2Hhp2BuzvD6TC5m3zhwBGF",
    "mtic_g78_m4_triominos_pt1": "N8xEiGQqqC9j1skSPIWdgwi6yKU3Rmf5",
    "mtic_g78_m4_triominos_pt2": "ASsKuTq24FQWXhY3U14wIJd.fs4zpzjt",
    "mtic_g78_m4_dominos": "mMROSqg6aHwryWIW732EwUl9WIajBj2Z",
    "area_construction": "0XEDmiD_FkVLNbs9Tr6Ffr9znEI1CKw0",
    "perimeter_construction": "m114IpaZNr8Ez63SG9J4W.FLYWVNd2Bh",
    "perimeter_area_lake": "ZYzclpSgkj_bVm5BUyL.TRWmpyWaKhhJ",
    "mtic_c4_fraction_puzzle_pt2": "wg2_ILzGuN_.hEWhI0dv9qzfgUetk2Rv",
    "mtic_c4_fraction_puzzle_pt4": "WHVMpWrBJ9DfAhzawy1zrXW4yO2MUwM0",
    "mtic_c4_fraction_puzzle_pt3": "N7eyTVmd8P7vZAmYpetIoty6hdo92mOx",
    "mtic_c4_fraction_puzzle_pt1": "M86eNh4KH4dOfTVVOQZYvkr1HQFFl1wA",
    "mtic_c4_fractions_dominos": "qVZExxmfmLnngM64Jladrc6D3odPis4Q",
    "mtic_c4_fractions_triominos_pt2": "8Lleny6SmM6enEh3KGiEV1iwye.4dtO6",
    "mtic_c4_fractions_triominos_pt1": "TCwp8mWtUG313HlgpSoUxFGieHSc.3n1",
    "mtic_c4_fractions_addition_twos": "v4qx3r99AwOSVw6kQ.N38MeEdG00HxXy",
    "mtic_c4_fractions_addition_threes": "awJYA4QZ.H0pJOn9FqKBnAyDMiiL.Qh0",
    "mtic_c4_fractions_determine_ensemble": "_a5X6.kMwKHCNHV99avUQIHDjvQ_uRaJ",
    "mtic_c4_fractions_determine_figure": "r.UTcEIIGE9KJNOl2oorYp7CQk647dud",
    "mtic_c4_fractions_reproduire_partie_1": "daguayRyQWqLIHZilUI5p0BJmQHM4tl6",
    "mtic_c4_fractions_verify_figure": "cwFZn_SVneokV10idEIBP4ImUGZMkO_L",
    "mtic_c4_fractions_reproduire_partie_2": "8wn5ayHqSrtXIafglHuRwqcICCQh7McY",
    "mtic_c4_fractions_drapeaux_partie_1": "QuY6iaK3SVRJAoFCYvjaSEZ8UExg8lFA",
    "mtic_c4_fractions_determiner_droite": "0yHp6L_M33mwM6VMpa.EHeTcuNnUGh0A",
    "mtic_c4_fractions_placer_sur_droite": "iKM5.5Clup5fS23m_k7kGhfHqWrVhqmS",
    "mtic_c4_fractions_comparaison": "c6hVzMF6DzU_sLX1V7DefaEy2k1EoPcB",
    "mtic_c4_fractions_equivalentes": "EVx0kcqbt8.D0EqBNhC64SmxntmrWExi",
    "mtic_c4_fractions_ordonner": "pZ9HxX3GinyhG4muHzAB2SQRa.BWuucX",
    "mtic_c4_fractions_subtraction_twos": "K_73zHF.31uFiu4ceYazsHHx8zniSA0B",
    "mtic_c4_fractions_intercaler": "akg6bUEs_eWQiqEvaLrGpL9SJono6Chj",
    "mtic_c4_fractions_subtraction_threes": "9Uc06xVuR8NeDLqYvgqT8xgsUluPnfUj",
    "mtic_c4_fractions_multiplication_partie_1": "wUbtzgyzcsOcm9ZsYvWuiRayg2tTZ0.8",
    "mtic_c4_fractions_multiplication_partie_2": "ZvhhyD_zq1ipVGh4Zh7Ymqm8c_10Pwts",
    "mtic_c4_fractions_dominos_pt2": "ozzJQLRhVc0sOg7co7Iikoj.cA5M4hna",
    "mtic_c4_fractions_pad": "hpw6pqzOVwS9RM3jPEvbOTVSpRMeqTBv",
    "mtic_c4_fractions_engrenages_partie_2": "LCkNdVXiQaQwW10ds0.LF76hqqVUhVZj",
    "mtic_c4_fractions_engrenages_partie_1": "u.Qo1B9Em6X1.fyYjytiq1U1VGwN9w2q",
    "mtic_c4_decimals_calc_casse": "V8nthOc6Verhh21U4vIk1fwU535Lt5PD",
    "mtic_c4_decimals_expl_conv_dec_part2": "hIrII3qXpc99WIekAodHikVOUDV9r_dq",
    "mtic_c4_decimals_expl_conv_dec_part4": "Y_UWm9XS_.VhT9loeXo1AM0lVNQbdSij",
    "mtic_c4_decimals_expl_frac_Ex": "uB2VSFm4bz2azXOHjzfXBIzb5FdPVRFd",
    "mtic_c4_decimals_droite_zoomee": "g2wWljd9PecPHDs5.X2xjCwcZtWrn2LN",
    "mtic_c4_decimals_compare_num": "r9COeY1SoEPka4_gIQrtcGrZM_cx0Rz9",
    "mtic_c4_decimals_interposing_num": "_LKWdL9YnB5uNl341PYLtG8LR7nsTLXK",
    "mtic_c4_decimals_order_num": "94SS4_bKT9pnN_qNMaqvFz8ffbbz7wDR",
    "mtic_c4_decimals_add_num": "WuuXiV7JchO4iFtrGQi9GUMerOTu.rDU",
    "mtic_c4_decimals_mult_num": "n60RxjtKNEiE9jLAs7kwwbJjfh2aChFR",
    "mtic_c4_decimals_sub_num": "mIeue2C3tlfwUbrkulwl0LhebyUZUQaO",
    "mtic_c4_decimals_est_num_line": "TgN89D6blPqjGpNdiJCPr8MTG67H9bOc",
    "mtic_c4_decimals_div_num": "u884FPRxeK2m1NIBnG0wxuhwUmuGEqIG",
    "mtic_c4_decimals_boite_noire_pt2": "TCcMegIA1_sz_hezpoMAiNKL0WJqfXF7",
    "mtic_c4_decimals_boite_noire_pt1": "MIYY75_Ggf0go8maT8tiZ1l2gDA9RaPa",
    "mtic_c4_decimals_boite_noire_pt3": "WNQ.4XVCqNL2QM06wR97Dn25aLrUi27P",
    "mtic_c4_decimals_dominos_p2": "wz.u5zEWRQJQMLcuYYI0AMjlKG9_pqqW",
    "mtic_c4_decimals_dominos_p3": "VfaQsBUV1HQoeb1seKPxoemrzSBDvzHa",
    "mtic_c4_decimals_convert_time": "ESIfe49iyv7jumBYFUGAZO6aeB2V3w4I",
    "mtic_c4_decimals_dominos_p1": "JcDG_08zZkKnR3_NLWFljgdSmaYBYJOA",
    "mtic_c4_decimals_dj": "QGA9X9HWgaqyD6p30FpVLrUyQ7J_7Je8",
    "mtic_c4_decimals_expl_add_sub_part2": "kDqaC2wS8sxqPq8NaHfXy6CU5CaN1M9M",
    "mtic_c4_decimals_etiquettes_pt2": "i0099QEEW1Uf2vCckmKzP27w84sY1JLB",
    "mtic_c4_decimals_etiquettes_pt1": "GQb3JN.XYW15xFzaLUg4igjWF44GVcvt",
    "mtic_c4_decimals_round_unit": "W5s9wcrQcjNPzyVN6nA9sJgynX25mk9e",
    "mtic_c4_decimals_machine_cafe_pt2": "0XWJvLzWK7M80.a05GjBkumvXbJ2soVD",
    "mtic_c4_decimals_round_time": "sMdoAs4dyNZFFyMrCg_2pSnM0OGBHGW7",
    "mtic_c4_decimals_pendule": "rGm1Bvp_RswLS1A8NBQ0O1nabNF8pTGw",
    "mtic_c4_decimals_meltdown": "wn3WByKdWHbNFs5X3SrN49B7V1vET.xZ",
    "mtic_c4_m5_menuisier": "5TyGwaQ75wcwT2nPa0t0Fpp.kpdvz.t7",
    "mtic_c4_m5_alice_bob_calcul": "Chsb2nsbeGD6CW7rxg3UuU.sXGkdttfy",
    "mtic_c4_m5_arbre": "LOzmNAj0Mqg.7LOa19v7uq.XS7qlDGmx",
    "mtic_c4_m5_athetisme_pt2": ".d6gJrvGaDuG866GC_l190GiASOL3ten",
    "mtic_c4_m5_pattern": "5ue75UmINCJVklkkuVYHuLKspV1zhvYJ",
    "mtic_c4_m5_trouve_bon_point": "5El9ZtU3cj4TR_l40g7qwvZFLkmkrZgs",
    "mtic_c4_m5_trouve_coordonnees": "bZIU.d2P68o9GJumH4NYk889Hhj71MVU",
    "mtic_c4_m5_complete_figure": "eLrgnx7zObvpKSgjGhc.xgJz1PcbZcX.",
    "mtic_c4_m5_repere_couleur": "QXjNJtPa8qivZWP6G4f9FGOLU7TLHX0T",
    "mtic_c4_m5_repere_polygone": "PdIWP0m1qY.lmmBAzaN9niSz9Dy3yMbE",
    "mtic_c4_m5_planche_galton": "QQLnyUlxegxl4Vcq3Y21i00kiylx7vO3",
    "mtic_c4_m5_sport_collectif": "kQWaBslp3CsI89PDIbB00gRBVz9Qe85j",
    "mtic_c4_m5_avezvous_jetons": "USTb1Gz9.b4lIi._s8jcJ7LdHOEVDjd8",
    "mtic_c4_m5_the_captains_rule": "VswgAFxE1aC2PVmVE4MUZPepaX_rlMcF",
    "mtic_c4_m6_orient_nyc": "sr8f9czQ8LWz.Mixb5RgjIrBQHr.5XMt",
    "mtic_c4_m5_syracuse_pt1": "pRNonyVGE9D_cxcMd106f_M4F9eBIxkn",
    "mtic_c4_m5_syracuse_intro": "o2wN4MfOoz.QHHaqBoyClaVhyx8v3V2x",
    "mtic_c4_m5_syracuse_pt2": "NqGRgEIhxC8lSWu4UJIpPlVMi0ebnbWP",
    "mtic_c4_m5_syracuse_pt3": "RjWpqTZrhAIahQKwAD7G49pN3MDfTWpl",
    "mtic_c4_m6_tomb_architechts_pt2": "BpD74ZpYwGWrk1GZ7PrTj1A9YtHsxrMH",
    "mtic_c4_m6_tomb_architechts_pt1": "hlnZ1ZndLsL.hyyf9xsn6iaOuRRvTZzX",
    "mtic_c4_m6_tomb_model_pt1": "wv1WEcHMoSTCJv74EaIDgTuKTt8JZKIZ",
    "mtic_c4_m6_tomb_model_pt2": "_6U5H0kM5BwLHEzI_ZQ85j2bVGwlt7hq",
    "mtic_c4_m6_tomb_build_ex": "H734ERum8fnAGC1FFueaSluEqpjSlfXw",
    "mtic_c4_m6_conv_len_b": "VgEe5SnoUK9elWfQLvlOUD_nyMNQ6GAJ",
    "mtic_c4_m6_conv_len_pt5": "1vgOQxSgsG7AlAO4QV_yPqbQdYxIa6WD",
    "mtic_c4_m6_conv_len_ex": "drwYCeADXMrkHrVaEfi_NBtT4SM8A0LY",
    "mtic_c4_m6_conv_len_pt3": "g.gqCjpi_wTglwUxbIDGuzw07DXWb776",
    "mtic_c4_m6_conv_area_ex": "jNtKhKjbxXe0dmuZk9dYU0kQ38Hi_RDD",
    "mtic_c4_m6_conv_vol_ex": "IFwqb3cnkiHkD0Mae_zwUJShlAyL3SoD",
    "mtic_c4_m6_decor_axial_ex": "4eRRP_iRUtCS8gty5iYTE4piAUWxln3o",
    "mtic_c4_m6_decor_radial_ex": "_fIPCwdsLMS56KJH4M4Fd65_SHGxZ9y7",
    "mtic_c4_m6_decor_transl_ex": "CEAZmN5fDuVjbVe7YU6XBQ5zK1RAWvb_",
    "mtic_c4_m6_cube": "FRNxvujadHcLOQ.7mF7vD59Mr3IVnwhB",
    "mtic_c4_m6_cube_squared": "rQFiPMqu6Hkv7o1mRHlV54IMsdvqYtfa",
    "mtic_c4_m6_pat_et_com": "euj6xP9Qwd5LFgPDKvRXLN_uqGepKHd7",
    "mtic_c4_m6_cube_squared_pt2": "2ZWsx..4jk3gtr80QLDTj.cQdJL3Q5Ej",
    "mtic_c4_m6_symm_find": "8QSQ3s1YumNQiQdWym4RULBYjhXmrge7",
    "mtic_c4_m6_transl_find": "tlfrxAzimUpm6LYyVsZVzNeJUMGvh39U",
    "mtic_c4_m6_construct_angle": "YkVhRvc_7oBJEcF2k4A9l4_c6Lr.qyN_",
    "mtic_c4_m6_suite_figure": "zwhtAT59dj9XdjShjW4Nc2LLsnaY.gHA",
    "mtic_c4_m6_conv_area_b": "oAIGHEp43_e_yNIn1lfPZZqjL3U3IP4C",
    "mtic_c4_m6_conv_vol_b": "LZ9AlsaZ2HmxuIVQRaf_9Mp24cZk_3Ls",
    "mtic_c4_m6_symm_place": "08.Tzq33ac2XbapvwmzlFAdvNI9tR3eP",
    "mtic_c4_m6_paint_cube_pt1": "X8rp9zbmFouOeivALHXNFUbTXQqD_Wjt",
    "mtic_c4_m6_paint_cube_pt2": "Qi4UnMkakb4jTaFwT0DTBcMBr2aaIFRX",
    "mtic_c4_m6_transl_place": "u.UdrzTQqYiawsZSCG8tFYpuhGpsfTqF",
    "mtic_c4_m6_conv_all": "yHMZGwP35VEy38sZ3vyX6hk0tkmtXt1k",
    "mtic_c4_m5_construct_diagram": "sQoNv86pYNplAd3pPUIRV0zG.lhUGgUM",
    "addition_soustraction_decompose": "J_YdwHVT4jUm5aBGJtBW4BFiJ1jZdqQJ",
    "soustraction_decompose_1": "SxyhDCwGzkTmFIiYHhVn6xKI.A27JGEP",
    "multiplication_addition_distributivite": "CZ6xySsg5UR3fdoaY1qLBorIgiu0HeKl",
    "factors_creating_result": "JIo7mRF9cR0r6QCcmCfyXqbNqbz4_.FW",
    "factors_create_product": "8pv.WBGNzHVHSYhVEpUnt.8G6RWIdkDn",
    "multiplication_decompose": "BSXDmZvkMbPOkVMy8U5FyCm8hS68IZXS",
    "mtic_c4_m2_calculator": "g26xALFRtslA9YjoLOnvUCFZk4KXZtHv",
    "lagent_codebar_3_0": "jdtodwKqcwTzzZFlJR7AzP24SE8fqw2x",
    "lagent_codebar_3_1_v2": "Aq.FgR8hX55TNtSfFq2VhguzWIaeZrMk",
    "lagent_codebar_3_2_v2": "OHtdA_At8vXjSd3hDwX40YmWbX1a2ZGE",
    "lagent_codebar_3_3_v2": "ADy3ymkDwG7v7QdbDPAIawPMz9sAJ.uz",
    "lagent_codebar_4_2_v2": "5C2vovD.69agHKyurLIm_hsObC5aVzU6",
    "lagent_codebar_4_3_v2": "ubJpHqEdS49fldoJtm7ghBboF6bwjojW",
    "lagent_codebar_4_4_v2": "ku.r2qt9rnF2Ow6ANGAgREJ8COyggTpp",
    "multiplication_division_calcul_relier_mult": "8IakBQ3sUO9uXIvs4pqnPiq684BPh4P7",
    "multiplication_division_calcul_relier_div": "b3fFgiCKh9vrUX_aw7tccpIjPEiz8X7l"
});
'use strict';

angular.module('mtic').constant('IAM_CONFIGURATION', {
    "microsoft": {
        "clientId": "ca56dac5-0fcb-4745-8cfd-2bef47397dc3",
        "instance": "https://login.microsoftonline.com/",
        "cacheLocation": "localStorage",
        "redirectUri": window.location.href,
        "postLogoutRedirectUri": window.location.href,
        "navigateToLoginRequestUrl": false
    }
});
'use strict';

// angular.module('mtic')
//   .constant('ERROR_CODES', {
//   "LOGIN" : {
//     "MISSING_PARAMETERS": "Please fill in both username and password",
//     "NOT_FOUND__USER_AUTHS": "Username is not found",
//     "BAD_PASSWORD": "Invalid Password"
//   },
//   "SIGNUP": {
//     "MISSING_PARAMETERS": "Please complete all fields to sign up",
//     "NOT_FOUND_ACCESS_CODES": "The access code you entered is not valid",
//     "UUID_ALREADY_EXISTS": "This User name already exists",
//     "NOT_FOUND_USER_ROLES": "Invalid class code or teacher id"
//   },
//   "UNKNOWN": "Something went wrong, please check your internet connection"
//   })

angular.module('mtic').constant('ERROR_CODES', {
  "LOGIN": {
    "MISSING_PARAMETERS": "11306",
    "NOT_FOUND__USER_AUTHS": "11307",
    "BAD_PASSWORD": "11308"
  },
  "SIGNUP": {
    "MISSING_PARAMETERS": "11309",
    "NOT_FOUND_ACCESS_CODES": "11310",
    "UUID_ALREADY_EXISTS": "11311",
    "NOT_FOUND_USER_ROLES": "11312"
  },
  "UNKNOWN": "11313"
});
'use strict';

angular.module('mtic').constant('DEV_VARIABLES', {
  GROUPS: {
    LUXEMBOURG: {
      TEACHERLESS_MODULES: [{ resource_type: 'mtic_c3_m_meta', group_id: 2018 }, { resource_type: 'c4_meta_module', group_id: 2019 }, { resource_type: 'mtic_gr78_m_meta', group_id: 1917 }, { resource_type: 'mtic_vp', group_id: 8748 }],
      AVAILABLE_MODULES: [{ resource_id: 317, module_id: 11, foreign_slug: 'lux_ef_c3' }, { resource_id: 385, module_id: 28, foreign_slug: 'lux_ef_c4' }, { resource_id: 99, module_id: 2, foreign_slug: 'lux_es_ci' }, { resource_id: 6246, module_id: 1234, foreign_slug: 'lux_es_mod' }, { resource_id: 6098, module_id: 1234, foreign_slug: 'lux_es_mod' }]
    }
  },
  RESOURCES: {
    HIDE_THESE: ['mtic_g78_m1_prop_table_b', 'mtic_g78_m1_beaker', 'mtic_g78_m3_graph_area'],
    LOCK_THESE: [
      //'mtic_gr78_m4',

      /* gr78_m4 */
      // 'mtic_g78_m4_conv_b',
      // 'mtic_g78_m4_conv_dec',
      // 'mtic_g78_m4_conv_frac',
      // 'mtic_g78_m4_div_b',
      // 'mtic_g78_m4_verify_figure',
      // 'mtic_g78_m4_reproduire_partie_1',
      // 'mtic_g78_m4_reproduire_partie_2',
      // 'mtic_g78_m4_slushie_pt2',
      // 'mtic_g78_m4_slushie_pt1',
      // 'mtic_g78_m4_dominos',
      // 'mtic_g78_m4_triominos_pt1',
      // 'mtic_g78_m4_triominos_pt2',
      // 'mtic_g78_m4_sub_b',
      // 'mtic_g78_m4_order',
      // 'mtic_g78_m4_div_pt2_a',
      // 'mtic_g78_m4_mult_a_pt2',
      // 'mtic_g78_m4_divisibility_b',
      // 'mtic_g78_m4_carrot',
      // 'mtic_g78_m4_determine_figure',
      // 'mtic_g78_m4_comp_b',
      // 'mtic_g78_m4_equiv_b',
      // 'mtic_g78_m4_mahjong',
      // 'mtic_g78_m4_add_b',
      // 'mtic_g78_m4_mult_b_pt1',
      // 'mtic_g78_m4_bedmas_a',
      // 'mtic_g78_m4_mult_b_pt2',
      // 'mtic_g78_m4_div_pt1_a',
      // 'mtic_g78_m4_mult_a_pt3',
      // 'mtic_g78_m4_attack_puz',
      // 'mtic_g78_m4_bedmas_b',
      // 'mtic_g78_m4_attack_time',
      // 'mtic_g78_m4_num_line_b',
      // 'mtic_g78_m4_diagnostic',
      // 'mtic_g78_m4_mult_a_pt1',
    ],
    MARK_COMPLETE: [],
    UNLOCK_THESE: [

      //gr78_m4
      // 'mtic_g78_m4_multiple',
      // 'mtic_g78_m4_divisibility_a_pt1',
      // 'mtic_g78_m4_divisibility_a_pt2',
      // 'mtic_g78_m4_divisors',
      // 'mtic_g78_m4_intro_frac',
      // 'mtic_g78_m4_num_line_a',
      // 'mtic_g78_m4_equiv_a',
      // 'mtic_g78_m4_simp',
      // 'mtic_g78_m4_comp_a',
      // 'mtic_g78_m4_add_same',
      // 'mtic_g78_m4_add_diff',
      // 'mtic_g78_m4_sub_a',
      // 'mtic_g78_m4_multi_tutorial',
      // 'mtic_g78_m4_conv_b',
      // 'mtic_g78_m4_conv_dec',
      // 'mtic_g78_m4_conv_frac',
      // 'mtic_g78_m4_div_b',
      // 'mtic_g78_m4_verify_figure',
      // 'mtic_g78_m4_reproduire_partie_1',
      // 'mtic_g78_m4_reproduire_partie_2',
      // 'mtic_g78_m4_slushie_pt2',
      // 'mtic_g78_m4_slushie_pt1',
      // 'mtic_g78_m4_dominos',
      // 'mtic_g78_m4_triominos_pt1',
      // 'mtic_g78_m4_triominos_pt2',
      // 'mtic_g78_m4_sub_b',
      // 'mtic_g78_m4_order',
      // 'mtic_g78_m4_div_pt2_a',
      // 'mtic_g78_m4_mult_a_pt2',
      // 'mtic_g78_m4_divisibility_b',
      // 'mtic_g78_m4_carrot',
      // 'mtic_g78_m4_determine_figure',
      // 'mtic_g78_m4_comp_b',
      // 'mtic_g78_m4_equiv_b',
      // 'mtic_g78_m4_mahjong',
      // 'mtic_g78_m4_add_b',
      // 'mtic_g78_m4_mult_b_pt1',
      // 'mtic_g78_m4_bedmas_a',
      // 'mtic_g78_m4_mult_b_pt2',
      // 'mtic_g78_m4_div_pt1_a',
      // 'mtic_g78_m4_mult_a_pt3',
      // 'mtic_g78_m4_attack_puz',
      // 'mtic_g78_m4_bedmas_b',
      // 'mtic_g78_m4_attack_time',
      // 'mtic_g78_m4_num_line_b',
      // 'mtic_g78_m4_diagnostic',
      // 'mtic_g78_m4_mult_a_pt1',

      //gr78-m3 items
      // "mtic_g78_m3_game_sub_pt1",
      //"mtic_g78_m3_diag",
      // "mtic_g78_m3_game_sub_pt2","mtic_g78_m3_graph_perim","mtic_g78_m3_inver_oper","mtic_g78_m3_inver_oper_pt2","mtic_g78_m3_alg_balance","mtic_g78_m3_graph_area","mtic_g78_m3_class_eq","mtic_g78_m3_sub_method","mtic_g78_m3_bracket_wo","mtic_g78_m3_bracket_wo_pt2","mtic_g78_m3_bracket_incl","mtic_g78_m3_impos_eq","mtic_g78_m3_impos_eq_pt2","mtic_g78_m3_represent_eq","mtic_g78_m3_geo_perim","mtic_g78_m3_geo_area","mtic_g78_m3_word_prob","mtic_g78_m3_word_prob_pt2","mtic_g78_m3_equal_area","mtic_g78_m3_alice_bob","mtic_g78_m3_open","mtic_g78_m3_receipt"
    ]
  },
  LOGGING_OVERRIDE: {
    RESOURCE: location.search.indexOf('debugItems') > -1,
    GENERAL: location.search.indexOf('debugLogs') > -1
  },
  BROWSER_SUPPORT: {
    OVERRIDE: 'debugBrowsers',
    IS_SUPPORTED: function IS_SUPPORTED() {
      if (location.search.indexOf(this.OVERRIDE) > -1) {
        return true;
      } else {
        var isSupported = bowser.name === 'Chrome' || bowser.ipad;
        isSupported = isSupported && !(bowser.mobile || bowser.tablet);
        return isSupported;
      }
    }
  }
});
'use strict';

angular.module('mtic').constant('DATA_HOST', {
  C3_TEACHER_CONFIGS: {
    'path': 'https://s3.eu-central-1.amazonaws.com/mtic-human-config/c3-teacher-configs/',
    'ext': '.json'
  }
});
'use strict';

angular.module('mtic').constant('BRANDING', {
  "MTIC": {
    'code': 'mtic',
    'clazz': 'mtic-branding'
  },
  "OCMT": {
    'code': 'ocmt',
    'clazz': 'ocmt-branding'
  }
});
'use strict';

angular.module('mtic').constant('ASSET_HOST', {
  "CONTAINER": {
    "openfl": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/openfl/index.html",
      "VERSION": "7Ga7bZ9dYkLbNpCcvAK_1vt9EyXk1fr1"
    },
    "openfl_c4": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/c4html5/index.html",
      "VERSION": "e1qG8.vCoVt8L6sh_ZGS7cfQolJTwDoD"
    },
    "html_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/items/packages"
    },
    "inbook_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/inbook/router/index.html",
      "VERSION": "RxmtIgogM4K7MgcB0thinZ1LVKYMV6Hc"
    },
    "c4swf": {
      "URL": "https://mtic-items.s3.amazonaws.com/containers/c4swf/v18/index.html",
      "VERSION": "cQmB5r5dbuyBzP3E_Hq6382E0g2yogB0"
    },
    "itematic_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/itematic/",
      // "URL": "http://localhost:3002/",
      "VERSION": "v1.1.18"
    }
  },
  "IMAGE": {
    "star": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fstar.png%2F1504458986485_93014%2Fstar.png?alt=media&token=3e72a373-3eb9-497d-842b-8b682d45d643",
    "star-empty": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fstar-empty.png%2F1504458955264_98267%2Fstar-empty.png?alt=media&token=9747daba-cd5b-4a3f-9a46-0b31c9a22070",
    "ribbon-a": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-a.png%2F1504458542000_48773%2Fribbon-a.png?alt=media&token=61b6fbb3-8d3f-4579-8903-3006a70bd532",
    "ribbon-b": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-b.png%2F1504458529694_98701%2Fribbon-b.png?alt=media&token=3c839792-d3c1-42a7-b08e-3b29c2fbe3c8",
    "ribbon-c": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-c.png%2F1504458457725_99417%2Fribbon-c.png?alt=media&token=ad1663f9-7ec4-417a-bd03-9fb54147665b",
    "replay-icon": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Freplay-icon.png%2F1504458610787_27303%2Freplay-icon.png?alt=media&token=b244ed55-5684-4806-9090-49ff9b339a28",
    "continue-icon": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fcontinue-icon.png%2F1504458623591_45219%2Fcontinue-icon.png?alt=media&token=0c65be65-e6d8-45f1-b1d5-c959460235f1"
  }
});
'use strict';

angular.module('mtic').constant('API_ROUTES', {
  GET: {
    CLASS_AGENDA: "/class/agenda",
    CLASS_CUSTOM_RESOURCES: '/class/custom_module/resource',
    CLASS_INFO: '/class/info',
    CLASS_MEMBERS: '/class/members',
    ARCHIVED_STUDENTS: '/archived/students',
    CLASS_MODULES: "/class/modules",
    CLASS_RESOURCE_STATES: "/class/resource/states",
    CLASS_SUMMARY_STATS: '/class/modules/summary',
    CLASSES_WITH_MODULES_BY_SCHOOL: '/teacher/school/class',
    COUNTRIES: '/countries',
    NOSCHOOL_CLASSES: "/noschool/classes",
    STUDENT_AGENDA: "/student/agenda",
    STUDENT_APP_EVENTS: "/student/app/events",
    STUDENT_BY_USERNAME_NOSCHOOL: "/noschool/classes/students",
    STUDENT_CLASS_MEMBERS: '/student/class/members',
    STUDENT_CLASSES: "/student/classes",
    STUDENT_CUSTOM_RESOURCES: '/student/custom_module/resource',
    STUDENT_MODULE_RESOURCE_STATE: "/student/module/resource/states",
    TEACHER_SCHOOL_MODULES: '/teacher/school/modules',
    TEACHER_STUDENT_MODULE_RESOURCE_STATE: "/teacher/student/module/resource/states",
    USER_GROUPS: "/user/groups",
    USER_INFO: "/user/info",
    USER_LOGIN: '/user/login',
    VERSION: "/version",
    GET_USER_RESOURCE_APP_STATE: "/user/resource/app/state",
    GET_USER_RESOURCE_LATEST_APP_STATE: "/user/resource/latest/app/state",
    GET_USER_RESOURCE_LAST_APP_STATE: "/user/resource/last/app/state", //SHOULD BE DEPRECATED
    GET_LEADERBOARD: "/leaderboard",
    GET_LEADERBOARD_TOP_PERFORMER: "/leaderboard/top/student",
    GET_SYNC_LEADERBOARD: "/sync/leaderboard/stats",
    GET_STUDENT_ASSESSMENT_PDF: "/student/assessment/diagnostic/results/pdf",
    GET_CLASS_ASSESSMENT_DATA: "/class/assessment/diagnostic/results",
    GET_PDF_AVAILABILITY: "/pdf/availability",
    GET_USER_NOTIFICATIONS: "/user/notifications",
    REFRESH_TOKEN: "/access/token",
    CLASS_COUNTRY: "/class/country"
  },
  POST: {
    ACCESS_CODES: "/access_codes",
    AUTH_EVENT: "/user/app/event",
    CLASS_AGENDA: "/class/agenda",
    EVENT: "/app/event",
    GENERAL_LOG: "/random",
    REDEEM_ACCESS_CODE: "/redeem/access_code",
    SCHOOL_MODULE_CLASS: '/teacher/school/class',
    STUDENT_GROUP: "/student/group",
    STUDENT_NO_SCHOOL_ALL: "/multigroup/student",
    STUDENT_NO_SCHOOL: "/group/student",
    STUDENT_RERSOURCE_STATE: "/student/resource/state",
    STUDENT_RERSOURCE_STATE_COPIED: "/copied/student/resource/state",
    STUDENT: "/student",
    TEACHER_THROUGH_GROUP: "/group/teacher",
    TEACHER: "/teacher",
    USER_LOGIN: "/user/login",
    VALID_IAM: "/validate/iam",
    USER_LOGIN_AS: "/user/login/as",
    ARCHIVE_STUDENT: "/student/archive",
    STATE_LOG_SESSION: "/state/log/session",
    IMPORT_AGENDA: "/share/agenda",
    NOTIFICATION_DISMISSED: '/dismiss/notification',
    NOTIFICATION_SEEN: '/markseen/notification',
    NOTIFICATION_ARCHIVE: '/archive/notification',
    POST_NOTIFICATION: '/user/notification',
    POST_RESOURCE_TIME: '/resource/state/timeupdate',
    UPDATE_PASSWORD: '/user/password/update',
    UPDATE_TEACHER_PASSWORD: '/teacher/password/update',
    UPDATE_USER_LANGUAGE: '/user/language/update'
  },
  PUT: {
    GROUP: "/group",
    CLASS_AGENDA: "/class/agenda",
    CLASS_STATE: "/student/fb/class/comment/state",
    LINK_IAM: "/user/auth",
    STUDENT_CLASSES_TRANSFER: "/student/classes/transfer",
    TRANSFER_STUDENT: "/class/student",
    UPDATE_CLASS_ARCHIVE_STATUS: "/class/archive"
  },
  DELETE: {
    ACCESS_CODES: "/access_codes",
    CLASS_AGENDA: "/class/agenda",
    LOGOUT: "/user/login"
  }
});
'use strict';

angular.module('mtic').directive('mtic', function (EventManager, $log, PlatformService) {
  return {
    template:'<mtic-app></mtic-app>',
    restrict: 'E',
    scope: {
      isLive: '='
    },
    link: function link(scope) {
      var eventManager = new EventManager('mtic', scope);
      var url = location.href;
      scope.isLive = url.indexOf('mathematic.lu') > -1 || url.indexOf('mathematic.org') > -1;

      if (PlatformService.isAndroid) {
        // Android soft-keyboard fix -> https://stackoverflow.com/a/42817175
        // This forces the viewport meta to explicitly set viewport width and height, whereas hardcoding in HTML
        // doesn't work because the device-width and device-height change when Android's soft keyboard is opened.
        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute("content", "height=" + window.outerHeight + ", width=" + window.outerWidth + ", initial-scale=1.0");
        // Need to force viewport size on orientation change
        window.addEventListener("orientationchange", function (event) {
          window.setTimeout(function () {
            var viewport = document.querySelector("meta[name=viewport]");
            viewport.setAttribute("content", "height=" + window.outerHeight + ", width=" + window.outerWidth + ", initial-scale=1.0");
          }, 300);
        }, true);
      }
    }
  };
});
'use strict';

/*global window*/
angular.module('mtic').config(function ($locationProvider, DEV_VARIABLES, $provide, $logProvider, tooltipsConfProvider) {

  $locationProvider.hashPrefix('');

  // disable logging
  if (!DEV_VARIABLES.LOGGING_OVERRIDE.GENERAL) {
    $logProvider.debugEnabled(/localhost/.test(window.location.hostname));
  }
  // turn off automatic tracking
  // $analyticsProvider.virtualPageviews(false);
  // tooltip config
  tooltipsConfProvider.configure({
    'smart': true,
    'size': 'large',
    'speed': 'slow',
    'class': 'tooltip-main-class'
  });
});